
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree135"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree135"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.8" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.8";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("cmoHh", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(' ');
        me.s1 = mash(' ');
        me.s2 = mash(' ');
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("euRi5", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("hDsEw", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("3J2Zm", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = '' + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("6Px8M", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + '\0';
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("lDm0S", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



let $9ecda7333d28e490$var$api_endpoint = "http://localhost:8070/api/";
// let web_socket_endpoint = "ws://localhost:9003"
let $9ecda7333d28e490$var$web_socket_endpoint = "https://backoffice.zebrain.se/wss";
let $9ecda7333d28e490$var$coach_host = "http://localhost:1235/";
let $9ecda7333d28e490$var$localSystem = true;
if (window.location.hostname === "meeting.zebrain.se") {
    $9ecda7333d28e490$var$api_endpoint = "https://api-dazzle.zebrain.se/api/";
    $9ecda7333d28e490$var$coach_host = "https://coach.zebrain.se/";
    $9ecda7333d28e490$var$localSystem = false;
}
const $9ecda7333d28e490$export$1630b5343357e8b5 = {
    API_TOKEN: "api_token",
    PERSON_TOKEN: "person_token",
    USERNAME_TOKEN: "username_token",
    API_ENDPOINT: $9ecda7333d28e490$var$api_endpoint,
    WEB_SOCKET_ENDPOINT: $9ecda7333d28e490$var$web_socket_endpoint,
    COACH_HOST: $9ecda7333d28e490$var$coach_host,
    AUTH0_CLIENT_ID: "Ec9P4CVtrm3cIVjUCNou3BMcXXJIPfjm",
    MEETING_TYPE: "meeting_type",
    MEETING_KEY: "meeting_key",
    MEETING_WHO: "meeting_who",
    MEETING_USER_ID: "meeting_user_id",
    MEETING_BACK: "meeting_back",
    LOCAL_SYSTEM: $9ecda7333d28e490$var$localSystem
};




var $acw62 = parcelRequire("acw62");
const $673ff3dfc4a496de$var$isString = (obj)=>typeof obj === 'string';
const $673ff3dfc4a496de$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $673ff3dfc4a496de$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $673ff3dfc4a496de$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
const $673ff3dfc4a496de$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, '.') : key;
const $673ff3dfc4a496de$var$canNotTraverseDeeper = (object)=>!object || $673ff3dfc4a496de$var$isString(object);
const $673ff3dfc4a496de$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$673ff3dfc4a496de$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
        const key = $673ff3dfc4a496de$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $673ff3dfc4a496de$var$cleanKey(stack[stackIndex])
    };
};
const $673ff3dfc4a496de$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $673ff3dfc4a496de$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $673ff3dfc4a496de$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $673ff3dfc4a496de$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
};
const $673ff3dfc4a496de$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($673ff3dfc4a496de$var$isString(target[prop]) || target[prop] instanceof String || $673ff3dfc4a496de$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $673ff3dfc4a496de$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $673ff3dfc4a496de$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $673ff3dfc4a496de$var$escape = (data)=>{
    if ($673ff3dfc4a496de$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
};
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
const $673ff3dfc4a496de$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $673ff3dfc4a496de$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $673ff3dfc4a496de$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $673ff3dfc4a496de$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger, options1 = {}){
        this.init(concreteLogger, options1);
    }
    init(concreteLogger, options1 = {}) {
        this.prefix = options1.prefix || 'i18next:';
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options1;
        this.debug = options1.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($673ff3dfc4a496de$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options1) {
        options1 = options1 || this.options;
        options1.prefix = options1.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options1);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data, options1 = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options1;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options1 = {}) {
        const keySeparator = options1.keySeparator !== undefined ? options1.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options1.ignoreJSONStructure !== undefined ? options1.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($673ff3dfc4a496de$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$673ff3dfc4a496de$var$isString(key)) return result;
        return $673ff3dfc4a496de$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options1 = {
        silent: false
    }) {
        const keySeparator = options1.keySeparator !== undefined ? options1.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options1.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options1 = {
        silent: false
    }) {
        for(const m in resources)if ($673ff3dfc4a496de$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options1.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options1 = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options1.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options1.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options1, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options1, translator) ?? value;
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
const $673ff3dfc4a496de$var$shouldHandleAsObject = (res)=>!$673ff3dfc4a496de$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services, options1 = {}){
        super();
        $673ff3dfc4a496de$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options1;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        return resolved?.res !== undefined;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
        const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $673ff3dfc4a496de$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $673ff3dfc4a496de$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$673ff3dfc4a496de$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $673ff3dfc4a496de$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($673ff3dfc4a496de$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($673ff3dfc4a496de$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options1 = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options1);
        return this.resourceStore.getResource(code, ns, key, options1);
    }
    getUsedParamsDetails(options1 = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options1.replace && !$673ff3dfc4a496de$var$isString(options1.replace);
        let data = useOptionsReplaceForData ? options1.replace : options1;
        if (useOptionsReplaceForData && typeof options1.count !== 'undefined') data.count = options1.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options1) {
        const prefix = 'defaultValue';
        for(const option in options1){
            if (Object.prototype.hasOwnProperty.call(options1, option) && prefix === option.substring(0, prefix.length) && undefined !== options1[option]) return true;
        }
        return false;
    }
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options1){
        this.options = options1;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($673ff3dfc4a496de$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($673ff3dfc4a496de$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($673ff3dfc4a496de$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($673ff3dfc4a496de$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $673ff3dfc4a496de$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils, options1 = {}){
        this.languageUtils = languageUtils;
        this.options = options1;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options1 = {}) {
        const cleanedCode = $673ff3dfc4a496de$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options1.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $673ff3dfc4a496de$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $673ff3dfc4a496de$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options1);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options1 = {}) {
        let rule = this.getRule(code, options1);
        if (!rule) rule = this.getRule('dev', options1);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options1 = {}) {
        return this.getSuffixes(code, options1).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options1 = {}) {
        let rule = this.getRule(code, options1);
        if (!rule) rule = this.getRule('dev', options1);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options1.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options1 = {}) {
        const rule = this.getRule(code, options1);
        if (rule) return `${this.options.prepend}${options1.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options1);
    }
}
const $673ff3dfc4a496de$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $673ff3dfc4a496de$var$isString(key)) {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $673ff3dfc4a496de$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $673ff3dfc4a496de$var$Interpolator {
    constructor(options1 = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('interpolator');
        this.options = options1;
        this.format = options1?.interpolation?.format || ((value)=>value);
        this.init(options1);
    }
    init(options1 = {}) {
        if (!options1.interpolation) options1.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options1.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $673ff3dfc4a496de$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $673ff3dfc4a496de$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $673ff3dfc4a496de$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options1) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options1,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options1,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options1?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options1?.interpolation?.skipOnVariables !== undefined ? options1.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$673ff3dfc4a496de$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $673ff3dfc4a496de$var$regexSafe(this.escape(val)) : $673ff3dfc4a496de$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options1);
                        value = $673ff3dfc4a496de$var$isString(temp) ? temp : '';
                    } else if (options1 && Object.prototype.hasOwnProperty.call(options1, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$673ff3dfc4a496de$var$isString(value) && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options1 = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options1
            };
            clonedOptions = clonedOptions.replace && !$673ff3dfc4a496de$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$673ff3dfc4a496de$var$isString(value)) return value;
            if (!$673ff3dfc4a496de$var$isString(value)) value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options1.lng, {
                    ...options1,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $673ff3dfc4a496de$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $673ff3dfc4a496de$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($673ff3dfc4a496de$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $673ff3dfc4a496de$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($673ff3dfc4a496de$var$getCleanedCode(l), o)(v);
class $673ff3dfc4a496de$var$Formatter {
    constructor(options1 = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('formatter');
        this.options = options1;
        this.init(options1);
    }
    init(services, options1 = {
        interpolation: {}
    }) {
        this.formatSeparator = options1.interpolation.formatSeparator || ',';
        const cf = options1.cacheInBuiltFormats ? $673ff3dfc4a496de$var$createCachedFormatter : $673ff3dfc4a496de$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options1 = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options1?.formatParams?.[options1.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options1.locale || options1.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options1,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $673ff3dfc4a496de$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services, options1 = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options1;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options1.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options1.maxRetries >= 0 ? options1.maxRetries : 5;
        this.retryTimeout = options1.retryTimeout >= 1 ? options1.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options1.backend, options1);
    }
    queueLoad(languages, namespaces, options1, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options1.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options1 = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($673ff3dfc4a496de$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($673ff3dfc4a496de$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options1, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options1 = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options1,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $673ff3dfc4a496de$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($673ff3dfc4a496de$var$isString(args[1])) ret.defaultValue = args[1];
            if ($673ff3dfc4a496de$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options1 = args[3] || args[2];
                Object.keys(options1).forEach((key)=>{
                    ret[key] = options1[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $673ff3dfc4a496de$var$transformOptions = (options1)=>{
    if ($673ff3dfc4a496de$var$isString(options1.ns)) options1.ns = [
        options1.ns
    ];
    if ($673ff3dfc4a496de$var$isString(options1.fallbackLng)) options1.fallbackLng = [
        options1.fallbackLng
    ];
    if ($673ff3dfc4a496de$var$isString(options1.fallbackNS)) options1.fallbackNS = [
        options1.fallbackNS
    ];
    if (options1.supportedLngs?.indexOf?.('cimode') < 0) options1.supportedLngs = options1.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options1.initImmediate === 'boolean') options1.initAsync = options1.initImmediate;
    return options1;
};
const $673ff3dfc4a496de$var$noop = ()=>{};
const $673ff3dfc4a496de$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(options1 = {}, callback){
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options1);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options1.isClone) {
            if (!this.options.initAsync) {
                this.init(options1, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options1, callback);
            }, 0);
        }
    }
    init(options1 = {}, callback) {
        this.isInitializing = true;
        if (typeof options1 === 'function') {
            callback = options1;
            options1 = {};
        }
        if (options1.defaultNS == null && options1.ns) {
            if ($673ff3dfc4a496de$var$isString(options1.ns)) options1.defaultNS = options1.ns;
            else if (options1.ns.indexOf('translation') < 0) options1.defaultNS = options1.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options1)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options1.keySeparator !== undefined) this.options.userDefinedKeySeparator = options1.keySeparator;
        if (options1.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options1.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.warn(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $673ff3dfc4a496de$var$noop) {
        let usedCallback = callback;
        const usedLng = $673ff3dfc4a496de$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $673ff3dfc4a496de$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($673ff3dfc4a496de$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${o.keyPrefix}${keySeparator}${k}`);
            else resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            return this.t(resultKey, o);
        };
        if ($673ff3dfc4a496de$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options1 = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options1.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options1.precheck) {
            const preResult = options1.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($673ff3dfc4a496de$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if ($673ff3dfc4a496de$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options1 = {}, callback) {
        return new $673ff3dfc4a496de$var$I18n(options1, callback);
    }
    cloneInstance(options1 = {}, callback = $673ff3dfc4a496de$var$noop) {
        const forkResourceStore = options1.forkResourceStore;
        if (forkResourceStore) delete options1.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options1,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options1.debug !== undefined || options1.prefix !== undefined) clone.logger = clone.logger.clone(options1);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $dca61ba26e2661d8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $dca61ba26e2661d8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($dca61ba26e2661d8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;


const $cfb6e0167e0b350d$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $cfb6e0167e0b350d$var$alreadyWarned = {};
const $cfb6e0167e0b350d$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg) && $cfb6e0167e0b350d$var$alreadyWarned[msg]) return;
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg)) $cfb6e0167e0b350d$var$alreadyWarned[msg] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $cfb6e0167e0b350d$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $cfb6e0167e0b350d$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($cfb6e0167e0b350d$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $cfb6e0167e0b350d$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $cfb6e0167e0b350d$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316
};
const $4f75eea5b29ffc65$export$2e2366488d12e20d = (options = {})=>{
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
};
const $4f75eea5b29ffc65$export$212bb2fc580a90a8 = ()=>$4f75eea5b29ffc65$var$defaultOptions;


let $1d04edb3ddd0d89e$var$i18nInstance;
const $1d04edb3ddd0d89e$export$a039134f2fc7e0 = (instance)=>{
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
};
const $1d04edb3ddd0d89e$export$64af334f494c2f47 = ()=>$1d04edb3ddd0d89e$var$i18nInstance;


const $acffcb171536f8e9$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $acffcb171536f8e9$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
};
const $acffcb171536f8e9$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $acw62.isValidElement));
const $acffcb171536f8e9$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $acffcb171536f8e9$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $acffcb171536f8e9$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $acw62.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $acffcb171536f8e9$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $acw62.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.props.ref ?? c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
};
const $acffcb171536f8e9$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $acw62.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, comp);
    }
    return (0, $acw62.createElement)(Componentized, {
        key: componentKey
    });
};
const $acffcb171536f8e9$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$acffcb171536f8e9$var$fixComponentProps(c, index, translation));
const $acffcb171536f8e9$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $acffcb171536f8e9$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $acffcb171536f8e9$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $acffcb171536f8e9$var$generateArrayComponents(components, translation);
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(components)) return $acffcb171536f8e9$var$generateObjectComponents(components, translation);
    (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $acffcb171536f8e9$var$isComponentsMap = (object)=>{
    if (!(0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const generatedComponents = $acffcb171536f8e9$var$generateComponents(components, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($acffcb171536f8e9$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $acffcb171536f8e9$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $0636c84fe4549f1f$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $0636c84fe4549f1f$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $e04d9533328ca578$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");


const $3765cebd031b52c0$var$usePrevious = (value, ignore)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $3765cebd031b52c0$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $3765cebd031b52c0$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $acw62.useCallback)($3765cebd031b52c0$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $3765cebd031b52c0$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react?.wait) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'DEPRECATED_OPTION', 'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    i18n.reportNamespaces.addUsedNamespaces?.(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $3765cebd031b52c0$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$3765cebd031b52c0$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $acw62.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $3765cebd031b52c0$var$usePrevious(joinedNS);
    const isMounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n?.on(bindI18n, boundReset);
        if (bindI18nStore) i18n?.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n && bindI18n) bindI18n?.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $acw62 = parcelRequire("acw62");


const $d9bd4545752f9667$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $868685a400877801$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $d97c91d803f78bcc$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $afd5c8e3ef499392$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>'';
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>'';
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>'';
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>'';
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>'';
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>'';


const $6458f422158f2f9a$var$langMap = {
    "settings": [
        "Settings",
        "Inst\xe4llningar"
    ],
    "starting-video": [
        "Starting video",
        "Startar video"
    ],
    "starting-camera": [
        "Starting camera",
        "Startar kamera"
    ],
    "starting-network": [
        "Starting network",
        "Startar n\xe4tverk"
    ],
    "booked-meetings": [
        "Booked meetings",
        "Bokade m\xf6ten"
    ],
    "previous-meetings": [
        "Previous meetings",
        "Tidigare m\xf6ten"
    ],
    "coming": [
        "Upcoming",
        "Kommande"
    ],
    "earlier": [
        "Earlier",
        "Tidigare"
    ],
    "previous": [
        "Previous",
        "F\xf6reg\xe5ende"
    ],
    "calendar": [
        "Calendar",
        "Kalender"
    ],
    "start": [
        "Start",
        "Start"
    ],
    "my-bookings": [
        "My bookings",
        "Mina bokningar"
    ],
    "meetings": [
        "Meetings",
        "M\xf6ten"
    ],
    "menu-support": [
        "Support",
        "Support"
    ],
    "menu-about-company": [
        "About Zebrain",
        "Om Zebrain"
    ],
    "logout": [
        "Log out",
        "Logga ut"
    ],
    "about-nav-title": [
        "About Zebrain",
        "Om Zebrain"
    ],
    "support-nav-title": [
        "Support",
        "Support"
    ],
    "support-description-placeholder": [
        "Describe your issue here...",
        "Beskriv ditt problem h\xe4r..."
    ],
    "support-email-info": [
        "You can also email us at",
        "Du kan ocks\xe5 mejla oss p\xe5"
    ],
    "set-availability": [
        "Set availability",
        "St\xe4ll in tillg\xe4nglighet"
    ],
    "set-hours-per-day": [
        "Set hours per day",
        "St\xe4ll in timmar per dag"
    ],
    "availability": [
        "Availability",
        "Tillg\xe4nglighet"
    ],
    "availability-timeperiod": [
        "Time period for availability",
        "Tidsperiod f\xf6r tillg\xe4nglighet"
    ],
    "availability-timeperiod-set": [
        "Set for how long your schedule lasts",
        "St\xe4ll in hur l\xe4nge ditt schema ska g\xe4lla"
    ],
    "number-of-weeks": [
        "Number of weeks",
        "Antal veckor"
    ],
    "standard-schedule": [
        "Standard schedule",
        "Ordinarie schema"
    ],
    "deviant-schedule": [
        "Deviant dates",
        "Avvikande datum"
    ],
    "schedule": [
        "Schedule",
        "Schema"
    ],
    "other-settings": [
        "Other settings",
        "\xd6vriga inst\xe4llningar"
    ],
    "sync-external-calendar": [
        "Sync external calendar",
        "Synka extern kalender"
    ],
    "add-extra-availability": [
        "Add extra availability",
        "L\xe4gg till extra tillg\xe4nglighet"
    ],
    "add": [
        "Add",
        "L\xe4gg till"
    ],
    "block-time-dates": [
        "Block time and dates",
        "Blockera tider och datum"
    ],
    "cancel": [
        "Cancel",
        "Avbryt"
    ],
    "save": [
        "Save",
        "Spara"
    ],
    "delete": [
        "Delete",
        "Ta bort"
    ],
    "hours": [
        "hours",
        "timmar"
    ],
    "minutes": [
        "minutes",
        "minuter"
    ],
    "extra-availability-text": [
        "You can choose multiple dates. Selected dates overrules the standard schedule.",
        "Du kan v\xe4lja flera datum samtidigt. Valda datum \xe5sidos\xe4tter standardschemat."
    ],
    "time-before-booking": [
        "Booking-to-Meeting Buffer",
        "Tid mellan ny bokning och m\xf6tets start"
    ],
    "time-before-booking-set": [
        "Select the minimum time gap between a new booking and the meeting start.",
        "Ange den minsta tidsmarginalen mellan en ny bokning och m\xf6tesstart."
    ],
    "time-head": [
        "Time ahead",
        "Tid i f\xf6rv\xe4g"
    ],
    "start-interval": [
        "Start interval",
        "Startintervall"
    ],
    "start-interval-set": [
        "Set start interval for meetings",
        "St\xe4ll in startintervall f\xf6r m\xf6ten"
    ],
    "time-interval": [
        "Time interval",
        "Tidsintervall"
    ],
    "max-bookings": [
        "Daily booking limit",
        "Max antal bokningar per dag"
    ],
    "max-bookings-set": [
        "Select the maximum number of bookings allowed per day",
        "St\xe4ll in det maximala antalet bokningar per dag"
    ],
    "max-per-day": [
        "Max per day",
        "Max per dag"
    ],
    "buffer-time": [
        "Meeting-to-Meeting buffer",
        "Bufferttid"
    ],
    "buffer-time-set": [
        "Select the minimum time gap between consecutive meetings",
        "St\xe4ll in den minsta pausen efter ett m\xf6te innan n\xe4sta kan b\xf6rja."
    ],
    "my-clients": [
        "My clients",
        "Mina klienter"
    ],
    "my-profile": [
        "My profile",
        "Min profil"
    ],
    "language": [
        "Language",
        "Spr\xe5k"
    ],
    "languages": [
        "Languages",
        "Spr\xe5k"
    ],
    "select-language": [
        "Select language",
        "V\xe4lj spr\xe5k"
    ],
    "select": [
        "Select",
        "V\xe4lj"
    ],
    "choose-coaching-language": [
        "Choose language to coach in",
        "V\xe4lj spr\xe5k att coacha p\xe5"
    ],
    "profile-intro": [
        "Short about your self as coach",
        "Kort om dig som coach"
    ],
    "profile-expertise": [
        "Expertise",
        "Expertis"
    ],
    "profile-experience": [
        "Experience",
        "Erfarenhet"
    ],
    "profile-philosophy": [
        "Philosophy",
        "Filosofi"
    ],
    "no-meetings-today": [
        "You have no meetings today.",
        "Du har inga m\xf6ten idag."
    ],
    "one-meeting-today": [
        "You have one meeting today.",
        "Du har ett m\xf6te idag."
    ],
    "you-have": [
        "You have ",
        "Du har"
    ],
    "meetings-today": [
        "meetings booked today",
        "m\xf6ten inbokade idag"
    ],
    "cs": [
        "Czech",
        "Tjeckiska"
    ],
    "no": [
        "Norwegian",
        "Norska"
    ],
    "nl": [
        "Ductch",
        "Holl\xe4ndska"
    ],
    "el": [
        "Greek",
        "Grekiska"
    ],
    "hu": [
        "Hungarian",
        "Ungerska"
    ],
    "pl": [
        "Polish",
        "Polska"
    ],
    "pt": [
        "Portuguese",
        "Portugisiska"
    ],
    "es": [
        "Spanish",
        "Spanska"
    ],
    "sv": [
        "Swedish",
        "Svenska"
    ],
    "fi": [
        "Finnish",
        "Finska"
    ],
    "en": [
        "English",
        "Engelska"
    ],
    "de": [
        "German",
        "Tyska"
    ],
    "fr": [
        "French",
        "Franska"
    ],
    "da": [
        "Danish",
        "Danska"
    ],
    "it": [
        "Italian",
        "Italienska"
    ],
    "change": [
        "Change",
        "\xc4ndra"
    ],
    "go-to-meeting": [
        "Go to meeting",
        "G\xe5 till m\xf6tet"
    ],
    "to-meeting": [
        "To meeting",
        "Till m\xf6te"
    ],
    "cancel-booking": [
        "Cancel",
        "Avboka"
    ],
    "today": [
        "Today",
        "Idag"
    ],
    "next-meeting": [
        "Next meeting",
        "N\xe4sta m\xf6te"
    ],
    "next": [
        "Next",
        "N\xe4sta"
    ],
    "hi": [
        "Hi",
        "Hej"
    ],
    "add-more-availability": [
        "Set availability",
        "St\xe4ll in tillg\xe4nglighet"
    ],
    "complete-profiles": [
        "Complete profiles",
        "F\xe4rdigst\xe4ll profiler"
    ],
    "go-to-profile": [
        "Go to My profile",
        "G\xe5 till Min profil"
    ],
    "go-to-availability": [
        "Go to Availability settings",
        "G\xe5 till Tillg\xe4nglighet"
    ],
    "original-booking": [
        "Original booking",
        "Ursprunglig bokning"
    ],
    "your-meeting-has": [
        "Your meeting has",
        "Ditt m\xf6te har"
    ],
    "client-is-notified": [
        "and your client is notified",
        "och din klient har meddelats"
    ],
    "coach-is-notified": [
        "and your coach is notified",
        "och din coach har meddelats"
    ],
    "write-message-to-client": [
        "Write a message to the client...",
        "Skriv ett meddelande till klienten..."
    ],
    "write-message-to-coach": [
        "Write a message to the coach...",
        "Skriv ett meddelande till coachen..."
    ],
    "been-changed": [
        "been changed",
        "\xe4ndrats"
    ],
    "been-booked": [
        "been booked",
        "bokats"
    ],
    "book-meeting": [
        "Book meeting",
        "Boka m\xf6te"
    ],
    "change-meeting": [
        "Change meeting",
        "\xc4ndra m\xf6te"
    ],
    "cancel-meeting": [
        "Cancel meeting",
        "Avboka m\xf6te"
    ],
    "available-times": [
        "Available times",
        "Lediga tider"
    ],
    "development-plan": [
        "Development plan",
        "Utvecklingsplan"
    ],
    "read": [
        "Read",
        "L\xe4s"
    ],
    "professional-details": [
        "Professional details",
        "Yrkesdetaljer"
    ],
    "level": [
        "Level",
        "Niv\xe5"
    ],
    "in-company-since": [
        "In company since",
        "I f\xf6retaget sedan"
    ],
    "current-role-since": [
        "Current role since",
        "Nuvarande roll sedan"
    ],
    "non-managerial": [
        "Non-managerial employee",
        "Anst\xe4lld utan ledande befattning"
    ],
    "manager_team": [
        "Manager with team and/or personnel responsibility",
        "Chef med team- och/eller personalansvar"
    ],
    "c_level": [
        "C-level executive",
        "Chef p\xe5 C-niv\xe5"
    ],
    "title": [
        "Title",
        "Titel"
    ],
    "coaching-areas-of-interest": [
        "Coaching areas of interest",
        "Coachomr\xe5den av intresse"
    ],
    "experience-of-being-coached": [
        "Experience of being coached",
        "Erfarenhet av att ha haft coaching"
    ],
    "executive_coaching": [
        "Executive coaching",
        "Chefscoaching"
    ],
    "team_coaching": [
        "Team coaching",
        "Teamcoaching"
    ],
    "leadership_coaching": [
        "Leadership coaching",
        "Ledarskapscoaching"
    ],
    "business_coaching": [
        "Business coaching",
        "Aff\xe4rscoaching"
    ],
    "agile_coaching": [
        "Agile coaching",
        "Agil coaching"
    ],
    "inclusive_corporate_culture": [
        "Inclusive corporate culture",
        "Inkluderande f\xf6retagskultur"
    ],
    "lifestyle_health": [
        "Lifestyle and health",
        "Livsstil och h\xe4lsa"
    ],
    "stress_management": [
        "Stress management",
        "Stresshantering"
    ],
    "life_coaching": [
        "Life coaching",
        "Livscoaching"
    ],
    "mental_training": [
        "Mental training",
        "Mental tr\xe4ning"
    ],
    "self_leadership": [
        "Self-leadership",
        "Sj\xe4lvledarskap"
    ],
    "rehabilitation": [
        "Rehabilitation",
        "Rehabilitering"
    ],
    "career_coaching": [
        "Career coaching",
        "Karri\xe4rcoaching"
    ],
    "transit_coaching": [
        "Transit coaching",
        "Transitcoaching"
    ],
    "mentorship": [
        "Mentorship",
        "Mentorskap"
    ],
    "self-assessment": [
        "Self-assessment",
        "Sj\xe4lvskattning"
    ],
    "feedback-score": [
        "Feedback",
        "Feedback"
    ],
    "perception-gap": [
        "Perception gap",
        "Gap"
    ],
    "read-more": [
        "Read more",
        "L\xe4s mer"
    ],
    "read-less": [
        "Read less",
        "L\xe4s mindre"
    ],
    "analysis": [
        "Analysis",
        "Analys"
    ],
    "write-text-here": [
        "Write text here...",
        "Skriv text h\xe4r..."
    ],
    "yes": [
        "Yes",
        "Ja"
    ],
    "synced-calendars": [
        "Synced calendars",
        "Synkade kalendrar"
    ],
    "send": [
        "Send",
        "Skicka"
    ],
    "summary": [
        "Summary",
        "Sammanst\xe4llning"
    ],
    "notes": [
        "Notes",
        "Anteckningar"
    ],
    "client": [
        "Client",
        "Klient"
    ],
    "chat-placeholder": [
        "Type your message here...",
        "Skriv ditt meddelande h\xe4r..."
    ],
    "support-modal-success-title": [
        "Thank you for reaching out to us! ",
        "Tack f\xf6r att du kontaktar oss! "
    ],
    "support-modal-success-description": [
        "We will get back to you as soon as possible.",
        "Vi \xe5terkommer s\xe5 snart som m\xf6jligt."
    ],
    "support-error-message": [
        "An error occurred, please try again later.",
        "Ett fel uppstod, f\xf6rs\xf6k igen senare."
    ],
    "goal": [
        "Goal",
        "M\xe5l"
    ],
    "description": [
        "Description",
        "Beskrivning"
    ],
    "details": [
        "Details",
        "Details"
    ],
    "starting-point": [
        "Assess your starting point",
        "Startl\xe4ge"
    ],
    "importance-level": [
        "Importance level",
        "Hur viktigt \xe4r m\xe5let"
    ],
    "success-metrics": [
        "Success metrics",
        "M\xe5tt f\xf6r framg\xe5ng"
    ],
    "target-date": [
        "Target date",
        "M\xe5ldatum"
    ],
    "goal-journey": [
        "Goal journey",
        "M\xe5lets resa"
    ],
    "set-your-goal": [
        "Set your goal",
        "S\xe4tt ditt m\xe5l"
    ],
    "set-your-goal-text": [
        "Define what success looks like for you.",
        "Definiera vad framg\xe5ng betyder f\xf6r dig"
    ],
    "stay-on-track": [
        "Check in",
        "H\xe5ll dig p\xe5 r\xe4tt sp\xe5r"
    ],
    "stay-on-track-text": [
        "Check in regularly to remove blockers, and gather feedback from your colleagues.",
        "Kontrollera ofta och ta bort hinder"
    ],
    "get-feedback-along-the-way": [
        "Follow up",
        "F\xe5 feedback l\xe4ngs v\xe4gen"
    ],
    "get-feedback-along-the-way-text": [
        "Reflect on your journey and send a new feedback request to see how your progress is perceived and what you can improve.",
        "Skapa medvetenhet om din process och justera din strategi vid behov"
    ],
    "decide-whats-next": [
        "Decide what's next",
        "Best\xe4m vad som \xe4r n\xe4sta steg"
    ],
    "decide-whats-next-text": [
        "Set a new goal, or start a new Focus Area",
        "S\xe4tt ett nytt m\xe5l eller starta ett nytt fokusomr\xe5de"
    ],
    "set-goal-description": [
        "Setting a clear goal gives you direction, keeps you focused, and aligns your efforts with what truly matters\u2014driving meaningful progress.",
        "Att s\xe4tta ett tydligt m\xe5l ger dig riktning, h\xe5ller dig fokuserad och anpassar dina anstr\xe4ngningar med det som verkligen betyder n\xe5got \u2013 att driva meningsfulla framsteg."
    ],
    "coaching-tools": [
        "Coaching tools",
        "Coachingverktyg"
    ],
    "focus-area": [
        "Focus area",
        "Fokusomr\xe5de"
    ],
    "book": [
        "Book",
        "Boka"
    ],
    "profile": [
        "Profile",
        "Profil"
    ],
    "personality-test": [
        "Personality test",
        "Personlighetstest"
    ],
    "stress-test": [
        "Stress test",
        "Stresstest"
    ],
    "sub-goals": [
        "Sub Goals",
        "Delm\xe5l"
    ],
    "due-date": [
        "Due date",
        "Slutdatum"
    ]
};
const $6458f422158f2f9a$var$english = {};
const $6458f422158f2f9a$var$swedish = {};
for(const k in $6458f422158f2f9a$var$langMap){
    $6458f422158f2f9a$var$english[k] = $6458f422158f2f9a$var$langMap[k][0];
    $6458f422158f2f9a$var$swedish[k] = $6458f422158f2f9a$var$langMap[k][1];
}
const $6458f422158f2f9a$var$resources = {
    en: {
        translation: $6458f422158f2f9a$var$english
    },
    sv: {
        translation: $6458f422158f2f9a$var$swedish
    }
};
const $6458f422158f2f9a$var$selectedLng = localStorage.getItem('language') === 'sv' ? 'sv' : 'en';
(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)).init({
    resources: $6458f422158f2f9a$var$resources,
    lng: $6458f422158f2f9a$var$selectedLng,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    },
    debug: false
});
var $6458f422158f2f9a$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);


var $cbe71848aa286a1b$export$4ec7f52694178c6 = /*#__PURE__*/ function(ExtraWindow) {
    ExtraWindow[ExtraWindow["None"] = 0] = "None";
    ExtraWindow[ExtraWindow["Chat"] = 1] = "Chat";
    ExtraWindow[ExtraWindow["BookMeeting"] = 2] = "BookMeeting";
    ExtraWindow[ExtraWindow["Client"] = 3] = "Client";
    ExtraWindow[ExtraWindow["Settings"] = 4] = "Settings";
    ExtraWindow[ExtraWindow["Background"] = 5] = "Background";
    ExtraWindow[ExtraWindow["CoachingTools"] = 6] = "CoachingTools";
    return ExtraWindow;
}({});
var $cbe71848aa286a1b$export$4fd720569787ab6f = /*#__PURE__*/ function(ERRORS) {
    ERRORS[ERRORS["WEBSOCKET_FAILED_OPEN"] = 0] = "WEBSOCKET_FAILED_OPEN";
    ERRORS[ERRORS["WEBSOCKET_NOT_OPEN"] = 1] = "WEBSOCKET_NOT_OPEN";
    ERRORS[ERRORS["WEBSOCKET_CLOSED"] = 2] = "WEBSOCKET_CLOSED";
    ERRORS[ERRORS["WEBSOCKET_EVENT_CLOSED"] = 3] = "WEBSOCKET_EVENT_CLOSED";
    ERRORS[ERRORS["WEBSOCKET_NOT_AVAILABLE"] = 4] = "WEBSOCKET_NOT_AVAILABLE";
    ERRORS[ERRORS["RTC_CONNECTION_STATE_FAILED"] = 5] = "RTC_CONNECTION_STATE_FAILED";
    ERRORS[ERRORS["RTC_NEGOTIATION_SLOW"] = 6] = "RTC_NEGOTIATION_SLOW";
    return ERRORS;
}({});


const $4242a576d6cd20f5$var$WIDTH_WIDE = 745;
const $4242a576d6cd20f5$var$FOOTER_HEIGHT = 90;
const $4242a576d6cd20f5$var$VIDEO_PADDING = 12;
function $4242a576d6cd20f5$var$makeElement(element, container, screen, mine) {
    return {
        container: container,
        element: element,
        width: element.videoWidth,
        height: element.videoHeight,
        ratio: element.videoWidth / element.videoHeight,
        screen: screen,
        mine: mine
    };
}
function $4242a576d6cd20f5$var$makeCanvasElement(element, container, width, height) {
    return {
        container: container,
        element: element,
        width: width,
        height: height,
        ratio: width / height,
        screen: false,
        mine: true
    };
}
function $4242a576d6cd20f5$export$e9e6961726f0a4a7(resources) {
    const videoElements = [];
    const screenElements = [];
    const smallElements = [];
    const showExtraWindow = resources.extraWindow != (0, $cbe71848aa286a1b$export$4ec7f52694178c6).None;
    let partnerScreens = 0;
    resources.partners.forEach((partner)=>{
        if (partner.videoElement && partner.videoContainer) videoElements.push($4242a576d6cd20f5$var$makeElement(partner.videoElement, partner.videoContainer, false, false));
        if (partner.screenElement && partner.screenContainer) {
            screenElements.push($4242a576d6cd20f5$var$makeElement(partner.screenElement, partner.screenContainer, true, false));
            partnerScreens++;
        }
    });
    if (resources.canvas && resources.videoContainer) {
        const width = resources.canvas.width;
        const height = resources.canvas.height;
        const canvasEl = $4242a576d6cd20f5$var$makeCanvasElement(resources.canvas.canvasOut, resources.videoContainer, width, height);
        if (resources.small && partnerScreens === 0) smallElements.push(canvasEl);
        else videoElements.push(canvasEl);
    } else if (resources.videoElement && resources.videoContainer) {
        if (resources.small && partnerScreens === 0) smallElements.push($4242a576d6cd20f5$var$makeElement(resources.videoElement, resources.videoContainer, false, true));
        else videoElements.push($4242a576d6cd20f5$var$makeElement(resources.videoElement, resources.videoContainer, false, true));
    }
    if (resources.screenElement && resources.screenContainer) videoElements.push($4242a576d6cd20f5$var$makeElement(resources.screenElement, resources.screenContainer, true, true));
    if (window.innerWidth > $4242a576d6cd20f5$var$WIDTH_WIDE) {
        $4242a576d6cd20f5$var$placeVideosWide(videoElements, showExtraWindow, partnerScreens);
        $4242a576d6cd20f5$var$placeVideosSmall(smallElements, showExtraWindow, partnerScreens);
    } else {
        $4242a576d6cd20f5$var$placeVideosNarrow(videoElements, partnerScreens);
        $4242a576d6cd20f5$var$placeVideosSmall(smallElements, showExtraWindow, partnerScreens);
    }
    if (partnerScreens > 0) $4242a576d6cd20f5$var$placeScreens(screenElements, partnerScreens);
}
function $4242a576d6cd20f5$var$calculateCols(videoElements, width, height) {
    let maxVideoRatio = 0;
    for (const videoElement of videoElements)if (videoElement.ratio > maxVideoRatio) maxVideoRatio = videoElement.ratio;
    let cols = 1;
    const ratio = width / height;
    if (videoElements.length > 2) {
        if (ratio < 0.5) cols = 1;
        else cols = 2;
    } else if (videoElements.length > 1) {
        if (ratio > maxVideoRatio) cols = videoElements.length;
    }
    return cols;
}
function $4242a576d6cd20f5$var$placeVideosWide(videoElements, showExtraWindow, partnerScreens) {
    let windowRight = 0;
    let windowLeft = 0;
    if (showExtraWindow) windowRight = 400;
    let width = window.innerWidth - windowRight;
    if (partnerScreens > 0) {
        if (width < 500) width = 200;
        else width = 400;
        windowLeft = window.innerWidth - width;
    }
    const height = window.innerHeight - $4242a576d6cd20f5$var$FOOTER_HEIGHT;
    const cols = $4242a576d6cd20f5$var$calculateCols(videoElements, width, height);
    const rows = Math.round(videoElements.length / cols);
    const maxWidth = width / cols;
    const maxHeight = height / rows;
    let left = 0;
    let top = 0;
    let row = 0;
    let col = 0;
    for (const videoElement of videoElements){
        let containerWidth = maxWidth;
        let containerHeight = containerWidth / videoElement.ratio;
        if (containerHeight > maxHeight) {
            containerHeight = maxHeight;
            containerWidth = containerHeight * videoElement.ratio;
        }
        let zIndex = 90;
        if (videoElement.screen && !videoElement.mine) {
            zIndex = 91;
            left = 0;
            top = 0;
            containerWidth = width;
            containerHeight = height;
        } else {
            left = col * maxWidth;
            top = row * maxHeight + $4242a576d6cd20f5$var$VIDEO_PADDING;
        }
        const videoWidth = containerWidth - 12;
        const videoHeight = containerHeight - 12;
        const containerLeft = left + windowLeft + (maxWidth - videoWidth) / 2;
        const containerStyle = 'position: fixed;z-index:' + zIndex + ';top:' + top + 'px;left:' + containerLeft + 'px;' + 'width:' + containerWidth + 'px; height:' + containerHeight + 'px;';
        const videoStyle = "position: absolute;top:0;left:0;width:" + videoWidth + 'px; height:' + videoHeight + 'px;';
        videoElement.container.setAttribute('style', containerStyle);
        videoElement.element.setAttribute('style', videoStyle);
        col++;
        if (col % cols === 0) {
            col = 0;
            row++;
        }
    }
}
function $4242a576d6cd20f5$var$placeVideosSmall(videoElements, showExtraWindow, partnerScreens) {
    const maxWidth = 200;
    const maxHeight = 200;
    for (const videoElement of videoElements){
        let containerWidth = maxWidth;
        let containerHeight = containerWidth / videoElement.ratio;
        if (containerHeight > maxHeight) {
            containerHeight = maxHeight;
            containerWidth = containerHeight * videoElement.ratio;
        }
        let zIndex = 95;
        let right = 12;
        if (showExtraWindow) {
            if (window.innerWidth > $4242a576d6cd20f5$var$WIDTH_WIDE) right = 412;
        }
        const videoWidth = containerWidth - 2;
        const videoHeight = containerHeight - 2;
        const containerStyle = 'position: fixed;z-index:' + zIndex + ';top:12px;right:' + right + 'px;' + 'width:' + containerWidth + 'px; height:' + containerHeight + 'px;';
        const videoStyle = "position: absolute;top:0;left:0;width:" + videoWidth + 'px; height:' + videoHeight + 'px;';
        videoElement.container.setAttribute('style', containerStyle);
        videoElement.element.setAttribute('style', videoStyle);
    }
}
function $4242a576d6cd20f5$var$placeVideosNarrow(videoElements, partnerScreens) {
    const width = window.innerWidth;
    const height = window.innerHeight - $4242a576d6cd20f5$var$FOOTER_HEIGHT;
    const cols = $4242a576d6cd20f5$var$calculateCols(videoElements, width, height);
    const rows = Math.round(videoElements.length / cols);
    const maxWidth = width / cols;
    const maxHeight = height / rows;
    let left = 0;
    let top = 0;
    let row = 0;
    let col = 0;
    for (const videoElement of videoElements){
        let containerWidth = maxWidth;
        let containerHeight = containerWidth / videoElement.ratio;
        if (containerHeight > maxHeight) {
            containerHeight = maxHeight;
            containerWidth = containerHeight * videoElement.ratio;
        }
        let zIndex = 90;
        left = col * maxWidth;
        top = row * maxHeight;
        const videoWidth = containerWidth - 2;
        const videoHeight = containerHeight - 2;
        const containerLeft = left;
        const containerStyle = 'position: absolute;z-index:' + zIndex + ';top:' + top + 'px;left:' + containerLeft + 'px;' + 'width:' + containerWidth + 'px; height:' + containerHeight + 'px;';
        const videoStyle = "position: absolute; top: 1px; left: 1px;width:" + videoWidth + 'px; height:' + videoHeight + 'px;';
        videoElement.container.setAttribute('style', containerStyle);
        videoElement.element.setAttribute('style', videoStyle);
        col++;
        if (col % cols === 0) {
            col = 0;
            row++;
        }
    }
}
function $4242a576d6cd20f5$var$placeScreens(videoElements, partnerScreens) {
    let windowLeft = 0;
    // if (chatOpen) {
    //   windowLeft = 375
    // }
    let width = window.innerWidth;
    if (window.innerWidth > $4242a576d6cd20f5$var$WIDTH_WIDE) width = window.innerWidth - windowLeft - 400;
    const height = window.innerHeight - $4242a576d6cd20f5$var$FOOTER_HEIGHT;
    const rows = videoElements.length;
    const maxWidth = width;
    const maxHeight = height / rows;
    let left = 0;
    let top = 0;
    let row = 0;
    for (const videoElement of videoElements){
        let containerWidth = maxWidth;
        let containerHeight = containerWidth / videoElement.ratio;
        if (containerHeight > maxHeight) {
            containerHeight = maxHeight;
            containerWidth = containerHeight * videoElement.ratio;
        }
        let zIndex = 93;
        left = 0;
        top = row * height;
        const videoWidth = containerWidth - 2;
        const videoHeight = containerHeight - 2;
        const containerLeft = left + windowLeft;
        const containerStyle = 'position: absolute;z-index:' + zIndex + ';top:' + top + 'px;left:' + containerLeft + 'px;' + 'width:' + containerWidth + 'px; height:' + containerHeight + 'px;';
        const videoStyle = "position: absolute; top: 1px; left: 1px;width:" + videoWidth + 'px; height:' + videoHeight + 'px;';
        videoElement.container.setAttribute('style', containerStyle);
        videoElement.element.setAttribute('style', videoStyle);
        row++;
    }
}





async function $372c9bf7abbf89f1$export$53fec17173c2db16(stream, peerConnection) {
    console.log('--- debugStream');
    let info = '';
    for (const track of stream.getTracks()){
        const reports = await peerConnection.getStats(track);
        info += $372c9bf7abbf89f1$var$debugReport(reports);
    }
    return info;
}
function $372c9bf7abbf89f1$export$f42fec71d97a1ce3(offer) {
    for (const line of offer.sdp.split('\r\n'))if (line.substr(0, 2) === 'm=') console.log(line);
}
function $372c9bf7abbf89f1$var$debugReport(reports) {
    let info = '';
    // let bytesReceived = 0
    reports.forEach((now)=>{
        if (now.type === 'track') {
            // console.log(now)
            if (now.kind === 'video') info += '\nvideo size: ' + now.frameWidth + ' x ' + now.frameHeight;
            else if (now.kind === 'audio') {
                if (now.audiolevel !== undefined) info += '\naudio level: ' + now.audioLevel;
                console.log('total audio energy: ' + now.totalAudioEnergy);
            } else console.log(now);
        } else if (now.type === 'remote-outbound-rtp') info += '\n' + now.kind + ' bytes sent ' + now.bytesSent;
        else if (now.type === 'media-source') {
            if (now.kind === 'audio') info += '\nAudio level: ' + now.audioLevel;
            else if (now.kind === 'video') info += '\nFrames per second: ' + now.framesPerSecond;
        // } else if (now.type === 'transport') {
        //   if (bytesReceived === 0) {
        //     bytesReceived = now.bytesReceived
        //     info += '\nBytes received: ' + bytesReceived
        //   }
        } else console.log('debugReport type: ' + now.type);
    });
    return info;
}
async function $372c9bf7abbf89f1$export$69d61de8f38a4d09(resources, showInfo) {
    let info = '';
    if (resources.partners.length === 0) info += 'Not connected yet';
    else {
        const partner = resources.partners[0];
        if (resources.localStream) info += await $372c9bf7abbf89f1$export$53fec17173c2db16(resources.localStream, partner.peerConnection);
        if (resources.screenStream) info += await $372c9bf7abbf89f1$export$53fec17173c2db16(resources.screenStream, partner.peerConnection);
    }
    showInfo(info, true);
}
async function $372c9bf7abbf89f1$export$fc3e29cdcc5fc446(partner) {
    let info = partner.userName + ': ' + partner.peerConnection.iceConnectionState + ' (gathering state: ' + partner.peerConnection.iceGatheringState + ')';
    if (partner.videoStream) info += await $372c9bf7abbf89f1$export$53fec17173c2db16(partner.videoStream, partner.peerConnection);
    return info;
}



var $fb78ff4872d948ee$exports = {};
$fb78ff4872d948ee$exports = import.meta.resolve("iejuV");


var $eb3224ba44adbd09$exports = {};
$eb3224ba44adbd09$exports = import.meta.resolve("aSDoh");


function $561686717f5feab0$export$f0c31ae1c576befa(peerConnection, resources) {
    for (const partner of resources.partners){
        if (partner.peerConnection === peerConnection) return partner;
    }
    return null;
}
function $561686717f5feab0$var$receivePeerCandidate(event, resources) {
    const partner = $561686717f5feab0$export$f0c31ae1c576befa(event.target, resources);
    if (partner && event.candidate) {
        const mess = {
            type: 'meeting',
            command: 'icecandidate',
            candidate: event.candidate,
            user_id_to: partner.userId
        };
        (0, $722e8aa081170f4b$export$b67beb45fba1b83d)(mess, resources);
    } else if (partner) (0, $722e8aa081170f4b$export$e6b638b7514428dd)('icecandidate is empty, can open remote stream', resources);
    else (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('Failed partnerFromPeer', resources);
}
function $561686717f5feab0$export$258ec4dbf7f41a75(parent) {
    const videoContainer = document.createElement('div');
    videoContainer.classList.add('video_element_container');
    parent.appendChild(videoContainer);
    return videoContainer;
}
function $561686717f5feab0$export$f4f3d816544d7e44(parent) {
    const videoElement = document.createElement('video');
    videoElement.height = 200;
    videoElement.width = 200;
    videoElement.autoplay = true;
    videoElement.setAttribute("playsinline", "playsinline");
    videoElement.classList.add('video_element');
    videoElement.controls = false;
    parent.appendChild(videoElement);
    return videoElement;
}
function $561686717f5feab0$export$d6f3987786a60e52(resources, parent, partner) {
    const el = document.createElement('div');
    el.classList.add('video_info_div');
    el.innerText = partner.userName;
    el.addEventListener('click', function() {
        // console.log(partner.videoTrack?.getSettings().width)
        (0, $372c9bf7abbf89f1$export$fc3e29cdcc5fc446)(partner).then((info)=>{
            resources.stateFunc('info', info);
            resources.stateFunc('showInfo', true);
        });
    });
    parent.appendChild(el);
}
function $561686717f5feab0$export$cd7f3873ff6a50a4(resources, parent, displayInfo) {
    const el = document.createElement('div');
    el.classList.add('video_info_div');
    const enlarge = document.createElement('img');
    enlarge.src = (0, (/*@__PURE__*/$parcel$interopDefault($fb78ff4872d948ee$exports)));
    enlarge.classList.add('video_toggle_size');
    enlarge.addEventListener('click', function() {
        resources.small = !resources.small;
        if (resources.small) this.src = (0, (/*@__PURE__*/$parcel$interopDefault($eb3224ba44adbd09$exports)));
        else this.src = (0, (/*@__PURE__*/$parcel$interopDefault($fb78ff4872d948ee$exports)));
        (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources);
    });
    el.appendChild(enlarge);
    const nameEl = document.createElement('div');
    nameEl.innerText = resources.userName;
    // nameEl.classList.add('cursor-pointer')
    // nameEl.addEventListener('click', function () {
    //   showLocalInfo(resources, displayInfo)
    // })
    el.appendChild(nameEl);
    parent.appendChild(el);
    return el;
}
function $561686717f5feab0$var$connectRemoteStream(partner, resources) {
    const now = new Date();
    if (partner.connectedRemoteStream > 0) {
        const sinceLastConnect = now.getTime() - partner.connectedRemoteStream;
        if (sinceLastConnect < 3000) {
            (0, $722e8aa081170f4b$export$e6b638b7514428dd)('connectRemoteStream ran ' + sinceLastConnect + ' ms ago, returning', resources);
            return;
        } else console.log('---- connectRemoteStream ran ' + sinceLastConnect + ' ms ago,');
    }
    partner.connectedRemoteStream = now.getTime();
    let remoteVideo = undefined;
    if (partner.offerType === 'video') {
        if (!partner.videoElement) {
            partner.videoContainer = $561686717f5feab0$export$258ec4dbf7f41a75(resources.videoContainerRef.current);
            $561686717f5feab0$export$d6f3987786a60e52(resources, partner.videoContainer, partner);
            remoteVideo = $561686717f5feab0$export$f4f3d816544d7e44(partner.videoContainer);
            partner.videoElement = remoteVideo;
            if (partner.videoStream) {
                remoteVideo.srcObject = partner.videoStream;
                partner.videoElement.onresize = (e)=>{
                    if (partner.videoElement) {
                        const w = partner.videoElement.videoWidth;
                        const h = partner.videoElement.videoHeight;
                        if (partner.videoWidth !== 0 && partner.videoWidth !== w && partner.videoHeight !== 0 && partner.videoHeight !== h) {
                            console.log('Trigger change from ' + partner.videoWidth + ' x ' + partner.videoHeight + ' to ' + w + ' x ' + h);
                            resources.stateFunc('arrangeVideos');
                        }
                        partner.videoWidth = w;
                        partner.videoHeight = h;
                    }
                };
            } else alert('No partner.videoStream');
        }
    } else if (partner.offerType === 'screen') {
        if (!partner.screenElement) {
            partner.screenContainer = $561686717f5feab0$export$258ec4dbf7f41a75(resources.videoContainerRef.current);
            remoteVideo = $561686717f5feab0$export$f4f3d816544d7e44(partner.screenContainer);
            partner.screenElement = remoteVideo;
            if (partner.screenStream) {
                remoteVideo.srcObject = partner.screenStream;
                resources.rtcStatus = 'connected';
            } else alert('No partner.screenStream');
        } else console.log('!!!partner.screenElement existed');
        if (!partner.videoElement) console.log('!!!No partner.videoElement');
    } else (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('Bad offer type: ' + partner.offerType, resources);
    if (remoteVideo) try {
        remoteVideo.onloadedmetadata = ()=>{
            resources.rtcStatus = 'connected';
            if (window.innerWidth > 500) resources.small = true;
            if (partner.offerType === 'video') {
                const infoText = partner.userName + ' is connected to meeting.';
                resources.stateFunc('info', infoText);
                resources.stateFunc('showInfo', true);
            }
            (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources);
            const mess = {
                type: 'meeting',
                command: 'connected'
            };
            (0, $722e8aa081170f4b$export$b67beb45fba1b83d)(mess, resources);
        };
    } catch (error) {
        console.error('Error opening video camera.', error);
        (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('Error opening video camera', resources);
    }
    else (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources);
}
function $561686717f5feab0$var$receivePeerTrack(event, resources) {
    console.log('receivePeerTrack ', event.track);
    if (event.track.kind !== 'video' && event.track.kind !== 'audio') return;
    const partner = $561686717f5feab0$export$f0c31ae1c576befa(event.target, resources);
    if (!partner) {
        (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('receivePeerTrack failed partnerFromPeer', resources);
        return;
    }
    if (!partner.videoStream) partner.videoStream = new MediaStream();
    if (event.track.kind === 'audio') {
        if (!partner.audioTrack) {
            partner.audioTrack = event.track;
            partner.videoStream.addTrack(event.track);
        }
    } else if (event.track.kind === 'video') {
        if (partner.offerType === 'video') {
            if (!partner.videoTrack) {
                partner.videoTrack = event.track;
                partner.videoStream.addTrack(event.track);
            }
        } else if (partner.offerType === 'screen') {
            if (!partner.screenTrack) {
                if (!partner.screenStream) {
                    partner.screenStream = new MediaStream();
                    partner.screenTrack = event.track;
                    partner.screenStream.addTrack(event.track);
                } else console.log('!!!partner.screenStream existed already!');
            } else console.log('!!!partner.screenTrack existed already: ', partner.screenTrack);
        }
    }
}
function $561686717f5feab0$var$peerConnectionStateChange(event, resources) {
    console.log('-------- connectionStateChange: ' + event.target.connectionState);
    if (event.target.connectionState === 'failed') {
        (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('peerConnectionStateChange failed rtc connection', resources);
        resources.errorFunc((0, $cbe71848aa286a1b$export$4fd720569787ab6f).RTC_CONNECTION_STATE_FAILED);
    }
}
function $561686717f5feab0$var$peerConnectionError(event, resources) {
    (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)(event.errorText, resources);
}
function $561686717f5feab0$var$peerIceCandidateError(event, resources) {
    (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)(event.errorText, resources);
}
function $561686717f5feab0$var$peerGatheringStateChange(event, resources, partner) {
    console.log('------ icegatheringstatechange: ' + event.target.iceGatheringState);
    if (event.target.iceGatheringState === 'complete') {
        resources.rtcHasConnected = true;
        $561686717f5feab0$var$connectRemoteStream(partner, resources);
    }
}
function $561686717f5feab0$var$peerNegotiationNeeded(event) {
    console.log('------ negotiation needed');
    console.log(event);
}
function $561686717f5feab0$export$23d2b4404c659c6(resources, userId) {
    for (const partner of resources.partners){
        if (partner.userId === userId) return partner;
    }
    return null;
}
function $561686717f5feab0$export$f1e72e62ae9018c2(resources, userId, userName) {
    const partner = $561686717f5feab0$export$28fd2328eae7b819(userId, userName, resources);
    $561686717f5feab0$export$d9df15f189ea13a5(partner, resources);
    $561686717f5feab0$var$sendOffer(resources, partner, 'video');
}
function $561686717f5feab0$var$sendOffer(resources, partner, kind) {
    partner.peerConnection.createOffer().then((offer)=>{
        partner.peerConnection.setLocalDescription(offer).then(()=>{
            const mess = {
                type: 'meeting',
                command: 'offer',
                user_id_to: partner.userId,
                user_name_from: resources.userName,
                kind: kind,
                offer: offer
            };
            (0, $722e8aa081170f4b$export$b67beb45fba1b83d)(mess, resources);
            console.log('send offer to: ' + partner.userId);
        }).catch((error)=>{
            (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('sendOffer cannot set localDescription', resources);
        });
    }).catch((error)=>{
        (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('sendOffer cannot createOffer', resources);
    });
}
function $561686717f5feab0$export$b354714506bde367(resources, userId, userName, offer, kind) {
    let partner = $561686717f5feab0$export$23d2b4404c659c6(resources, userId);
    if (!partner) {
        partner = $561686717f5feab0$export$28fd2328eae7b819(userId, userName, resources);
        if (kind === 'video') $561686717f5feab0$var$rtcNegotiationStarted(resources, partner);
    }
    partner.offerType = kind;
    console.log('Offer of kind ' + kind);
    $561686717f5feab0$export$d9df15f189ea13a5(partner, resources);
    const remoteDesc = new RTCSessionDescription(offer);
    partner.peerConnection.setRemoteDescription(remoteDesc).then(()=>{
        partner?.peerConnection.createAnswer().then((answer)=>{
            partner?.peerConnection.setLocalDescription(answer).then(()=>{
                const mess = {
                    type: 'meeting',
                    command: 'answer',
                    user_id_to: userId,
                    kind: kind,
                    answer: answer
                };
                (0, $722e8aa081170f4b$export$b67beb45fba1b83d)(mess, resources);
                if (partner && kind === 'screen') // Ideally we would call this from icegatheringstate === 'complete', but that is not fired when screen sharing
                $561686717f5feab0$var$connectRemoteStream(partner, resources);
            });
        });
    }).catch((err)=>{
        console.log(err);
        (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('handleOffer cannot set remoteDescription', resources);
    });
}
function $561686717f5feab0$var$rtcNegotiationStarted(resources, partner) {
    const infoText = partner.userName + ' is connecting to meeting.';
    resources.stateFunc('info', infoText);
    resources.stateFunc('showInfo', true);
    resources.rtcStatus = 'connecting';
    setTimeout(()=>{
        $561686717f5feab0$var$rtcNegotiationCheck(resources);
    }, 2000);
}
function $561686717f5feab0$var$rtcNegotiationCheck(resources) {
    if (resources.rtcStatus === 'connected') resources.stateFunc('showInfo', false);
    else {
        resources.errorFunc((0, $cbe71848aa286a1b$export$4fd720569787ab6f).RTC_NEGOTIATION_SLOW);
        (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('rtcNegotiationCheck did not get connect in time', resources);
    }
}
function $561686717f5feab0$export$aa715608ab043027(resources, userId, kind, answer) {
    const partner = $561686717f5feab0$export$23d2b4404c659c6(resources, userId);
    if (partner) {
        const remoteDesc = new RTCSessionDescription(answer);
        partner.peerConnection.setRemoteDescription(remoteDesc).then(()=>{
            console.log('--- handleAnswer');
            if (kind !== 'screen') $561686717f5feab0$var$rtcNegotiationStarted(resources, partner);
        });
    } else {
        alert('Could not find partner ' + userId);
        (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('handleAnswer could not find partner ' + userId, resources);
    }
}
function $561686717f5feab0$export$d30ffaff3f548b4c(resources, userId, candidate) {
    console.log('---- Got candidate', candidate);
    const partner = $561686717f5feab0$export$23d2b4404c659c6(resources, userId);
    if (partner) try {
        partner.peerConnection.addIceCandidate(candidate).then(()=>{
            console.log('added icecandidate');
        });
    } catch (e) {
        (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('handleCandidate failed addIceCandidate', resources);
    }
}
function $561686717f5feab0$export$28fd2328eae7b819(userId, userName, resources) {
    const turnServer = resources.skipTurn ? 'skip_turn.zebrain.se' : 'turn.zebrain.se';
    if (resources.skipTurn) console.log('------- skipTurn enabled, using turn server ' + turnServer);
    const turnUdp = 'turn:' + turnServer + ':443';
    const turnTcp = 'turn:' + turnServer + ':443?transport=tcp';
    const RTCconfiguration = {
        iceCandidatePoolSize: 2,
        iceServers: [
            {
                urls: turnUdp,
                username: 'hakan',
                credential: 'darkness'
            },
            {
                urls: turnTcp,
                username: 'hakan',
                credential: 'darkness'
            }
        ]
    };
    const peerConnection = new RTCPeerConnection(RTCconfiguration);
    peerConnection.addEventListener('icecandidate', function(event) {
        $561686717f5feab0$var$receivePeerCandidate(event, resources);
    });
    peerConnection.addEventListener('connectionstatechange', function(event) {
        $561686717f5feab0$var$peerConnectionStateChange(event, resources);
    });
    peerConnection.addEventListener('track', function(event) {
        $561686717f5feab0$var$receivePeerTrack(event, resources);
    });
    peerConnection.addEventListener('negotiationneeded', $561686717f5feab0$var$peerNegotiationNeeded);
    const partner = {
        peerConnection: peerConnection,
        videoStream: new MediaStream(),
        userId: userId,
        userName: userName,
        videoWidth: 0,
        videoHeight: 0,
        offerType: 'video',
        connectedRemoteStream: 0
    };
    resources.partners.push(partner);
    peerConnection.addEventListener('error', function(event) {
        $561686717f5feab0$var$peerConnectionError(event, resources);
    });
    peerConnection.addEventListener('icecandidateerror', function(event) {
        $561686717f5feab0$var$peerIceCandidateError(event, resources);
    });
    peerConnection.addEventListener('icegatheringstatechange', function(event) {
        $561686717f5feab0$var$peerGatheringStateChange(event, resources, partner);
    });
    return partner;
}
function $561686717f5feab0$export$d9df15f189ea13a5(partner, resources) {
    const existingTracks = [];
    partner.peerConnection.getSenders().forEach((sender)=>{
        if (sender.track) existingTracks.push(sender.track);
    });
    // It is possible that sender has background image. In that case there is a canvasStream
    const canvasStream = resources.canvas?.canvasOut.captureStream();
    resources.localStream?.getTracks().forEach((track)=>{
        if (existingTracks.indexOf(track) < 0) {
            if (resources.localStream) {
                if (canvasStream && track.kind === 'video') console.log('Not adding localStream - there is a canvasStream');
                else {
                    partner.peerConnection.addTrack(track, resources.localStream);
                    console.log('Add track to peer: ', track);
                }
                if (track.kind === 'audio' && track.muted) {
                    resources.stateFunc('info', 'Your microphone is muted.\nCheck volume level.');
                    resources.stateFunc('showInfo', true);
                }
            }
        } else console.log('Track existed: ', track);
    });
    if (canvasStream) canvasStream?.getTracks().forEach((track)=>{
        if (existingTracks.indexOf(track) < 0) partner.peerConnection.addTrack(track, canvasStream);
        else console.log('Canvas track existed: ', track);
    });
// if (resources.screenStream) {
//   const track: MediaStreamTrack = resources.screenStream.getVideoTracks()[0]
//   track.addEventListener('ended', function() {
//     stopShareScreen(resources)
//   })
//   partner.peerConnection.addTrack(track, resources.screenStream)
//   sendOffer(resources, partner, 'screen')
//   console.log('Added screen stream to peer')
// }
}
function $561686717f5feab0$var$addScreenTracksToPeer(resources) {
    if (resources.screenStream) {
        const track = resources.screenStream.getVideoTracks()[0];
        track.addEventListener('ended', function() {
            $561686717f5feab0$export$a2225f6f9177d1a0(resources);
        });
        for (const partner of resources.partners)if (resources.screenStream) partner.peerConnection.addTrack(track, resources.screenStream);
        for (const partner of resources.partners)$561686717f5feab0$var$sendOffer(resources, partner, 'screen');
        (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources);
    }
}
function $561686717f5feab0$export$c3d42395a2b4ee59(resources) {
    for (const partner of resources.partners)resources.localStream?.getTracks().forEach((track)=>{
        partner.peerConnection.getSenders().forEach((sender)=>{
            if (sender.track !== null && sender.track.kind === track.kind) {
                sender.replaceTrack(track).then(()=>{
                    console.log('Replacing track ' + track.kind);
                });
                return;
            }
        });
    });
}
function $561686717f5feab0$export$500335708f2f9ded(resources) {
    if (!resources.screenContainer) resources.screenContainer = $561686717f5feab0$export$258ec4dbf7f41a75(resources.videoContainerRef.current);
    if (!resources.screenElement) resources.screenElement = $561686717f5feab0$export$f4f3d816544d7e44(resources.screenContainer);
    navigator.mediaDevices.getDisplayMedia({
        video: true
    }).then((localStream)=>{
        resources.screenStream = localStream;
        try {
            if (resources.screenElement) {
                resources.screenElement.srcObject = resources.screenStream;
                resources.screenElement.onloadedmetadata = ()=>{
                    $561686717f5feab0$var$addScreenTracksToPeer(resources);
                    resources.stateFunc('shareScreen', true);
                };
            }
        } catch (error) {
            console.error('Error opening screen sharing.', error);
        // this.showInfo('Sharing error:' + error.toString)
        }
    }).catch((err)=>{
        console.error(err);
    // this.showInfo('Could not share screen. Ask Zebrain for help!')
    });
}
function $561686717f5feab0$export$a2225f6f9177d1a0(resources) {
    if (resources.screenStream) {
        const removedIds = [];
        resources.screenStream.getTracks().forEach((track)=>{
            removedIds.push(track.id);
            track.removeEventListener('ended', function() {
                $561686717f5feab0$export$a2225f6f9177d1a0(resources);
            });
            track.stop();
        });
        for (const partner of resources.partners){
            partner.offerType = 'video';
            partner.peerConnection.getSenders().forEach((sender)=>{
                if (sender.track !== null && removedIds.indexOf(sender.track.id) > -1) partner.peerConnection.removeTrack(sender);
            });
            const mess = {
                type: 'meeting',
                command: 'stopScreen',
                user_id_to: partner.userId
            };
            (0, $722e8aa081170f4b$export$b67beb45fba1b83d)(mess, resources);
        }
        resources.screenStream = undefined;
        resources.stateFunc('shareScreen', false);
    }
    if (resources.screenElement) {
        $561686717f5feab0$var$removeVideoElement(resources.videoContainerRef.current, resources.screenContainer, resources.screenElement);
        resources.screenElement = undefined;
    }
    (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources);
}
function $561686717f5feab0$export$6fd50a7d7b15aa88(resources, userId) {
    const partner = $561686717f5feab0$export$23d2b4404c659c6(resources, userId);
    if (!partner) return;
    if (partner.screenTrack) {
        partner.screenTrack.stop();
        partner.screenTrack = undefined;
        partner.screenStream = undefined;
    }
    if (partner.screenElement) {
        $561686717f5feab0$var$removeVideoElement(resources.videoContainerRef.current, partner.screenContainer, partner.screenElement);
        partner.screenElement = undefined;
    }
    (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources);
}
function $561686717f5feab0$export$d940fb3660370fda(resources, userId) {
    $561686717f5feab0$export$9c41f81a0736a568(userId, resources);
    (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources);
}
function $561686717f5feab0$var$removeVideoElement(parentElement, container, element) {
    if (container) {
        if (element) {
            container.removeChild(element);
            element.remove();
            element.srcObject = null;
        }
        if (parentElement.contains(container)) parentElement.removeChild(container);
        else console.error('container not in parent');
    }
}
function $561686717f5feab0$export$9c41f81a0736a568(userId, resources) {
    const partner = $561686717f5feab0$export$23d2b4404c659c6(resources, userId);
    if (!partner) return;
    resources.small = false;
    resources.rtcStatus = 'waiting';
    const infoText = partner.userName + ' left the meeting.';
    resources.stateFunc('info', infoText);
    resources.stateFunc('showInfo', true);
    if (partner.audioTrack) partner.audioTrack.stop();
    if (partner.videoTrack) partner.videoTrack.stop();
    if (partner.screenTrack) partner.screenTrack.stop();
    partner.peerConnection.getSenders().forEach((sender)=>{
        if (sender.track !== null) partner.peerConnection.removeTrack(sender);
    });
    if (partner.videoElement) {
        $561686717f5feab0$var$removeVideoElement(resources.videoContainerRef.current, partner.videoContainer, partner.videoElement);
        partner.videoElement = undefined;
    }
    if (partner.screenElement) {
        $561686717f5feab0$var$removeVideoElement(resources.videoContainerRef.current, partner.screenContainer, partner.screenElement);
        partner.screenElement = undefined;
    }
    partner.peerConnection.close();
    resources.partners = resources.partners.filter((obj)=>obj !== partner);
}
function $561686717f5feab0$var$stopStream(stream) {
    stream.getTracks().forEach((track)=>{
        if (track.readyState === 'live') {
            track.stop();
            console.log(track.kind + ' stopped');
        } else console.log(track.kind + ': ' + track.readyState);
    });
}
function $561686717f5feab0$export$be3892ac83272cb6(resources) {
    console.log('--- unmounting video. Resources: ' + resources.localStream);
    if (resources.localStream) $561686717f5feab0$var$stopStream(resources.localStream);
    if (resources.screenStream) $561686717f5feab0$var$stopStream(resources.screenStream);
    for (const partner of resources.partners){
        if (partner.videoStream) $561686717f5feab0$var$stopStream(partner.videoStream);
        if (partner.screenStream) $561686717f5feab0$var$stopStream(partner.screenStream);
        resources.videoContainer = undefined;
        resources.videoElement = undefined;
        if (partner.peerConnection) {
            partner.peerConnection.removeEventListener('icecandidate', function(event) {
                $561686717f5feab0$var$receivePeerCandidate(event, resources);
            });
            partner.peerConnection.removeEventListener('connectionstatechange', function(event) {
                $561686717f5feab0$var$peerConnectionStateChange(event, resources);
            });
            partner.peerConnection.removeEventListener('error', function(event) {
                $561686717f5feab0$var$peerConnectionError(event, resources);
            });
            partner.peerConnection.removeEventListener('track', function(event) {
                $561686717f5feab0$var$receivePeerTrack(event, resources);
            });
            partner.peerConnection.removeEventListener('icecandidateerror', function(event) {
                $561686717f5feab0$var$peerIceCandidateError(event, resources);
            });
            partner.peerConnection.removeEventListener('icegatheringstatechange', function(event) {
                $561686717f5feab0$var$peerGatheringStateChange(event, resources, partner);
            });
            partner.peerConnection.removeEventListener('negotiationneeded', $561686717f5feab0$var$peerNegotiationNeeded);
            partner.peerConnection.close();
        }
    }
}



function $722e8aa081170f4b$export$b67beb45fba1b83d(mess, resources) {
    if (resources.webSocket) {
        if (resources.webSocket.readyState !== WebSocket.OPEN) {
            resources.errorFunc((0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_NOT_OPEN);
            return;
        }
        resources.webSocket.send(JSON.stringify(mess));
    }
}
function $722e8aa081170f4b$export$e6b638b7514428dd(msg, resources) {
    const mess = {
        type: 'debug',
        command: msg
    };
    $722e8aa081170f4b$export$b67beb45fba1b83d(mess, resources);
}
function $722e8aa081170f4b$export$9d476a4ed49c5f1f(msg, resources) {
    const mess = {
        type: 'error',
        command: msg
    };
    $722e8aa081170f4b$export$b67beb45fba1b83d(mess, resources);
}
function $722e8aa081170f4b$var$messageListener(event, resources) {
    const message = JSON.parse(event.data);
    if (!message) return;
    // console.log(message)
    if (message.type === 'meeting') {
        if (message.command === 'init') {
            if (message.status === 'first') console.log("Du \xe4r f\xf6rst i m\xf6tet...");
            else if (message.status === 'connect') (0, $561686717f5feab0$export$f1e72e62ae9018c2)(resources, message.user_id_from, message.user_name_from);
            else console.log('Error - unknown status in message.user_id_from', message.user_id_from, message.status, message.type, message.command);
        } else if (message.command === 'offer') {
            console.log('Got offer');
            (0, $561686717f5feab0$export$b354714506bde367)(resources, message.user_id_from, message.user_name_from, message.offer, message.kind);
        } else if (message.command === 'answer') {
            console.log('Got answer');
            (0, $561686717f5feab0$export$aa715608ab043027)(resources, message.user_id_from, message.kind, message.answer);
        } else if (message.command === 'icecandidate') {
            console.log('Got icecandidate');
            (0, $561686717f5feab0$export$d30ffaff3f548b4c)(resources, message.user_id_from, message.candidate);
        } else if (message.command === 'stopScreen') (0, $561686717f5feab0$export$6fd50a7d7b15aa88)(resources, message.user_id_from);
        else if (message.command === 'close') (0, $561686717f5feab0$export$d940fb3660370fda)(resources, message.user_id_from);
        else if (message.command === 'hangup') {
            console.log('----- will hangup session');
            if (window.opener) {
                window.opener.console.log('From opened window');
                console.log('----- Closing window');
                window.opener.postMessage('video_window_close');
            } else // window.location.href = '/app/' + resources.who + '/overview'
            console.log('Received hangup from socket');
        } else console.log('Unknown command ' + message.command);
    } else console.log('Unknown message type: ' + message.type);
}
function $722e8aa081170f4b$export$4e6053747055af0e(resources, userId, userName) {
    console.log('--------- openSocket userId: ' + userId + ' userName ' + userName);
    resources.webSocket = new WebSocket((0, $9ecda7333d28e490$export$1630b5343357e8b5).WEB_SOCKET_ENDPOINT);
    if (resources.webSocket) {
        resources.webSocket.addEventListener('message', function(event) {
            $722e8aa081170f4b$var$messageListener(event, resources);
        });
        resources.webSocket.addEventListener('error', function(event) {
            if (event.target?.readyState === WebSocket.CLOSED) {
                if (resources.webSocketHasOpened) resources.errorFunc((0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_EVENT_CLOSED);
                else resources.errorFunc((0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_FAILED_OPEN);
            }
        });
        resources.webSocket.onopen = ()=>{
            resources.webSocketHasOpened = true;
            resources.webSocketPingInterval = setInterval(()=>{
                if (resources.webSocket) {
                    if (resources.webSocket?.readyState === WebSocket.OPEN) {
                        const mess = {
                            type: 'ping'
                        };
                        resources.webSocket.send(JSON.stringify(mess));
                    } else resources.errorFunc((0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_NOT_OPEN);
                } else resources.errorFunc((0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_NOT_AVAILABLE);
            }, 30000);
            const message = {
                type: 'session_init',
                user_id: userId,
                user_name: userName
            };
            $722e8aa081170f4b$export$b67beb45fba1b83d(message, resources);
        };
    }
}
async function $722e8aa081170f4b$export$948ce3773b347819(resources) {
    const isOpened = ()=>resources.webSocket?.readyState === WebSocket.OPEN;
    if (resources.webSocket?.readyState !== WebSocket.CONNECTING) return isOpened();
    else {
        const intrasleep = 100;
        const ttl = 10000 / intrasleep // time to loop
        ;
        let loop = 0;
        while(resources.webSocket?.readyState === WebSocket.CONNECTING && loop < ttl){
            await new Promise((resolve)=>setTimeout(resolve, intrasleep));
            loop++;
        }
        return isOpened();
    }
}
function $722e8aa081170f4b$export$a222caf1cf2d6f53(resources) {
    const mess = {
        type: 'meeting',
        command: 'init',
        key: resources.meetingKey,
        user_agent: window.navigator.userAgent
    };
    console.log('---- Sending meeting init');
    $722e8aa081170f4b$export$b67beb45fba1b83d(mess, resources);
}
function $722e8aa081170f4b$export$755db3b985fb9f16(resources) {
    if (resources.webSocket) {
        resources.webSocket.removeEventListener('message', function(event) {
            $722e8aa081170f4b$var$messageListener(event, resources);
        });
        resources.webSocket.close();
        clearInterval(resources.webSocketPingInterval);
    }
}


const $dd3ca96f76569213$export$8bb342e53ebb74df = [
    "M\xe5n",
    'Tis',
    'Ons',
    'Tor',
    'Fre',
    "L\xf6r",
    "S\xf6n"
];
const $dd3ca96f76569213$export$5e4515d610119e9a = [
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun'
];
const $dd3ca96f76569213$export$c56d8f67a12422b1 = [
    "M\xe5ndag",
    'Tisdag',
    'Onsdag',
    'Torsdag',
    'Fredag',
    "L\xf6rdag",
    "S\xf6ndag"
];
const $dd3ca96f76569213$export$6b73857a58d7b12e = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
const $dd3ca96f76569213$export$2bb3eb27682a776 = [
    'Januari',
    'Februari',
    'Mars',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'Augusti',
    'September',
    'Oktober',
    'November',
    'December'
];
const $dd3ca96f76569213$export$22c5e7c8a0c84d30 = [
    'January',
    'February',
    'Mars',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const $dd3ca96f76569213$export$b4b23bfab2f68498 = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Maj',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec'
];
const $dd3ca96f76569213$export$af84e65568f81785 = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];


function $f6959fbcc1e8f0a1$export$d8f1108603581fa1(dayNum, lang) {
    if (lang === 'en') return (0, $dd3ca96f76569213$export$5e4515d610119e9a)[dayNum];
    return (0, $dd3ca96f76569213$export$8bb342e53ebb74df)[dayNum];
}
function $f6959fbcc1e8f0a1$export$70ac11c42ad092f6(date, lang) {
    let day = date.getDay() - 1;
    if (day < 0) day = 6;
    return $f6959fbcc1e8f0a1$export$932c8267700e55ee(day, lang);
}
function $f6959fbcc1e8f0a1$export$932c8267700e55ee(dayNum, lang) {
    if (lang === 'en') return (0, $dd3ca96f76569213$export$6b73857a58d7b12e)[dayNum];
    return (0, $dd3ca96f76569213$export$c56d8f67a12422b1)[dayNum];
}
function $f6959fbcc1e8f0a1$export$852a3a662acbcadb(dateStr, lang) {
    const d = new Date(dateStr);
    return d.getDate() + ' ' + $f6959fbcc1e8f0a1$export$3734a8d11104faac(d.getMonth(), lang) + ', ' + d.getFullYear();
}
function $f6959fbcc1e8f0a1$export$3015f3f5495570dc(dateStr, lang) {
    const d = new Date(dateStr);
    return $f6959fbcc1e8f0a1$export$70ac11c42ad092f6(d, lang) + ' - ' + $f6959fbcc1e8f0a1$export$5f885a9374f8e024(d);
}
function $f6959fbcc1e8f0a1$export$3734a8d11104faac(monthNum, lang) {
    if (lang === 'en') return (0, $dd3ca96f76569213$export$22c5e7c8a0c84d30)[monthNum];
    return (0, $dd3ca96f76569213$export$2bb3eb27682a776)[monthNum];
}
function $f6959fbcc1e8f0a1$export$478c9c14b5784b92(monthNum, lang) {
    if (lang === 'en') return (0, $dd3ca96f76569213$export$af84e65568f81785)[monthNum];
    return (0, $dd3ca96f76569213$export$b4b23bfab2f68498)[monthNum];
}
function $f6959fbcc1e8f0a1$export$5f885a9374f8e024(d) {
    return d.getHours() + ':' + $f6959fbcc1e8f0a1$export$728c8e2d6789728(d.getMinutes());
}
function $f6959fbcc1e8f0a1$export$2287e3d29250119e(d, minutes) {
    let newDate = new Date(d);
    newDate.setMinutes(newDate.getMinutes() + minutes);
    return newDate;
}
function $f6959fbcc1e8f0a1$export$dd412b56f1e4d8aa(d, days) {
    let newDate = new Date(d);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}
function $f6959fbcc1e8f0a1$export$212a2e732fe26c47(start, l) {
    return new Date(start.getTime() + l * 60000);
}
function $f6959fbcc1e8f0a1$export$af90a3ef075406ce(dateStr) {
    const d = new Date(dateStr);
    return $f6959fbcc1e8f0a1$export$5f885a9374f8e024(d);
}
function $f6959fbcc1e8f0a1$export$60e57b324afdc8c4(dateStr, lang) {
    const d = new Date(dateStr);
    const now = new Date();
    const secondsDiff = (d.getTime() - now.getTime()) / 1000;
    const inTime = lang === 'sv' ? 'Om ' : 'In ';
    if (secondsDiff > 0 && secondsDiff < 86400) {
        const hours = Math.floor(secondsDiff / 3600);
        const minutes = Math.floor((secondsDiff - 3600 * hours) / 60);
        const seconds = Math.floor(secondsDiff - 3600 * hours - 60 * minutes);
        if (hours > 0) return inTime + hours + ' h ' + minutes + ' min';
        else return inTime + minutes + ' min ' + $f6959fbcc1e8f0a1$export$728c8e2d6789728(seconds) + ' s';
    } else return "-";
}
function $f6959fbcc1e8f0a1$export$83d04527fc498dec(d, lang) {
    const now = new Date();
    const midnight = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const utcDate = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
    const dayDiff = Math.floor((utcDate - midnight) / 86400000);
    let ret;
    if (now.getFullYear() !== d.getFullYear()) ret = '' + d.getFullYear() + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
    else if (dayDiff === 0) {
        if (lang === 'en') ret = 'Today';
        else ret = 'I dag';
    } else if (dayDiff === 1) {
        if (lang === 'en') ret = 'Tomorrow';
        else ret = 'I morgon';
    } else if (dayDiff === 2) {
        if (lang === 'en') ret = 'Day after tomorrow';
        else ret = "I \xf6vermorgon";
    } else if (dayDiff === -1) {
        if (lang === 'en') ret = 'Yesterday';
        else ret = "I g\xe5r";
    } else {
        let day = lang === 'en' ? (0, $dd3ca96f76569213$export$6b73857a58d7b12e) : (0, $dd3ca96f76569213$export$c56d8f67a12422b1);
        ret = day[$f6959fbcc1e8f0a1$export$a24aefd2b69080a9(d)] + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
    }
    ret += ' ' + d.getHours() + ':' + $f6959fbcc1e8f0a1$export$728c8e2d6789728(d.getMinutes());
    return ret;
}
function $f6959fbcc1e8f0a1$export$31bd54ef8fbd09b6(dateStr, lang) {
    const d = new Date(dateStr);
    return $f6959fbcc1e8f0a1$export$83d04527fc498dec(d, lang);
}
function $f6959fbcc1e8f0a1$export$b980974597db1132(dateStr, minutes) {
    const d = new Date(dateStr);
    const now = new Date();
    const minuteDiff = (d.getTime() - now.getTime()) / 60000;
    if (minuteDiff < minutes) return true;
    else return false;
}
function $f6959fbcc1e8f0a1$export$a8b2a21161763694(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}
function $f6959fbcc1e8f0a1$export$9a827e9be85de527(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return hours + ':' + $f6959fbcc1e8f0a1$export$728c8e2d6789728(minutes);
}
function $f6959fbcc1e8f0a1$export$728c8e2d6789728(digit) {
    if (digit < 10) return "0" + digit;
    return "" + digit;
}
function $f6959fbcc1e8f0a1$export$77b0033b88d4485c(thisWeekDate, orgDate) {
    // Convert week day so that Monday is 0
    const thisWeekDay = $f6959fbcc1e8f0a1$export$2061056d06d7cdf7(thisWeekDate);
    const orgWeekDay = $f6959fbcc1e8f0a1$export$2061056d06d7cdf7(orgDate);
    // If original day is Wednesday (2) and this day is Tuesday (1), add (2-1=1) day
    const addDays = orgWeekDay - thisWeekDay;
    return new Date(thisWeekDate.getFullYear(), thisWeekDate.getMonth(), thisWeekDate.getDate() + addDays, orgDate.getHours(), orgDate.getMinutes(), 0);
}
function $f6959fbcc1e8f0a1$export$2061056d06d7cdf7(d) {
    let dayOfWeek = d.getDay() - 1;
    if (dayOfWeek < 0) dayOfWeek = 6;
    return dayOfWeek;
}
function $f6959fbcc1e8f0a1$export$9390b7bc4e425fb2(d) {
    const date = new Date(d.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    const week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}
function $f6959fbcc1e8f0a1$export$ff9a5f6f7fb9966b(d, lang, long = false) {
    const m = d.getMonth();
    const month = lang === 'sv' ? (0, $dd3ca96f76569213$export$b4b23bfab2f68498)[m].toLowerCase() : (0, $dd3ca96f76569213$export$af84e65568f81785)[m];
    let result = d.getDate() + ' ' + month;
    if (long) result += ' ' + d.getFullYear();
    return result;
}
function $f6959fbcc1e8f0a1$export$1c7501cd03a59e59(d, showTime, lang) {
    let day = lang === 'en' ? (0, $dd3ca96f76569213$export$6b73857a58d7b12e) : (0, $dd3ca96f76569213$export$c56d8f67a12422b1);
    let ret = day[$f6959fbcc1e8f0a1$export$a24aefd2b69080a9(d)] + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
    if (showTime) ret += ' ' + $f6959fbcc1e8f0a1$export$728c8e2d6789728(d.getHours()) + ':' + $f6959fbcc1e8f0a1$export$728c8e2d6789728(d.getMinutes());
    return ret;
}
function $f6959fbcc1e8f0a1$export$3ae94a2503e890a1(dateStr, showTime, lang) {
    const d = new Date(dateStr);
    return $f6959fbcc1e8f0a1$export$1c7501cd03a59e59(d, showTime, lang);
}
function $f6959fbcc1e8f0a1$export$2ba31a6bf619dece(dateStr, lang) {
    const d = new Date(dateStr);
    return d.getDate() + '/' + (d.getMonth() + 1);
}
function $f6959fbcc1e8f0a1$export$a24aefd2b69080a9(date) {
    if (date) {
        const dow = date.getDay();
        if (dow === 0) return 6;
        else return dow - 1;
    }
    return 0 // Actually an error, but should not happen
    ;
}
function $f6959fbcc1e8f0a1$export$ce35f6b40b9b16f5(today) {
    if (!today) today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}
function $f6959fbcc1e8f0a1$export$adf69d68d71478c0(d) {
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}
function $f6959fbcc1e8f0a1$export$5a252a405018366(dateStr) {
    const today = new Date(dateStr);
    return $f6959fbcc1e8f0a1$export$adf69d68d71478c0(today);
}





/**
    * @license
    * Copyright 2023 Google LLC. All Rights Reserved.
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    * http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    * =============================================================================
    */ var $d2cc08cc2aa8032f$exports = {};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code.
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code for tfjs-core
// Set up Engine and ENV
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $b73fd602f21aa26c$export$76e53a66c52b6d4d = 1e-7;
const $b73fd602f21aa26c$export$49716d145771e6a2 = 1e-4;
class $b73fd602f21aa26c$export$e95767ffe2e60cec {
    constructor(backend, dataMover){
        this.backend = backend;
        this.dataMover = dataMover;
        this.data = new WeakMap();
        this.dataIdsCount = 0;
    }
    get(dataId) {
        if (!this.data.has(dataId)) this.dataMover.moveData(this.backend, dataId);
        return this.data.get(dataId);
    }
    set(dataId, value) {
        this.dataIdsCount++;
        this.data.set(dataId, value);
    }
    has(dataId) {
        return this.data.has(dataId);
    }
    delete(dataId) {
        this.dataIdsCount--;
        return this.data.delete(dataId);
    }
    numDataIds() {
        return this.dataIdsCount;
    }
}
class $b73fd602f21aa26c$export$543916c62202b50a {
    refCount(dataId) {
        return $b73fd602f21aa26c$var$notYetImplemented('refCount');
    }
    incRef(dataId) {
        return $b73fd602f21aa26c$var$notYetImplemented('incRef');
    }
    timerAvailable() {
        return true;
    }
    time(f) {
        return $b73fd602f21aa26c$var$notYetImplemented('time');
    }
    read(dataId) {
        return $b73fd602f21aa26c$var$notYetImplemented('read');
    }
    readSync(dataId) {
        return $b73fd602f21aa26c$var$notYetImplemented('readSync');
    }
    readToGPU(dataId, options) {
        return $b73fd602f21aa26c$var$notYetImplemented('readToGPU');
    }
    numDataIds() {
        return $b73fd602f21aa26c$var$notYetImplemented('numDataIds');
    }
    disposeData(dataId, force) {
        return $b73fd602f21aa26c$var$notYetImplemented('disposeData');
    }
    write(values, shape, dtype) {
        return $b73fd602f21aa26c$var$notYetImplemented('write');
    }
    move(dataId, values, shape, dtype, refCount) {
        return $b73fd602f21aa26c$var$notYetImplemented('move');
    }
    createTensorFromGPUData(values, shape, dtype) {
        return $b73fd602f21aa26c$var$notYetImplemented('createTensorFromGPUData');
    }
    memory() {
        return $b73fd602f21aa26c$var$notYetImplemented('memory');
    }
    /** Returns the highest precision for floats in bits (e.g. 16 or 32) */ floatPrecision() {
        return $b73fd602f21aa26c$var$notYetImplemented('floatPrecision');
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? $b73fd602f21aa26c$export$76e53a66c52b6d4d : $b73fd602f21aa26c$export$49716d145771e6a2;
    }
    dispose() {
        return $b73fd602f21aa26c$var$notYetImplemented('dispose');
    }
}
function $b73fd602f21aa26c$var$notYetImplemented(kernelName) {
    throw new Error(`'${kernelName}' not yet implemented or not found in the registry. ` + `This kernel may not be supported by the tfjs backend you have chosen`);
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $5f8d0ee7a8d35dfe$exports = {};

$parcel$export($5f8d0ee7a8d35dfe$exports, "shuffle", () => $5f8d0ee7a8d35dfe$export$448332262467e042);
$parcel$export($5f8d0ee7a8d35dfe$exports, "swap", () => $5f8d0ee7a8d35dfe$export$b0e76d9850c64156);
$parcel$export($5f8d0ee7a8d35dfe$exports, "shuffleCombo", () => $5f8d0ee7a8d35dfe$export$ae1498b5fd31a179);
$parcel$export($5f8d0ee7a8d35dfe$exports, "clamp", () => $5f8d0ee7a8d35dfe$export$7d15b64cf5a3a4c4);
$parcel$export($5f8d0ee7a8d35dfe$exports, "nearestLargerEven", () => $5f8d0ee7a8d35dfe$export$ece2fd7300c99d1f);
$parcel$export($5f8d0ee7a8d35dfe$exports, "sum", () => $5f8d0ee7a8d35dfe$export$8a63f25cc62965f1);
$parcel$export($5f8d0ee7a8d35dfe$exports, "randUniform", () => $5f8d0ee7a8d35dfe$export$1c2519d52242937);
$parcel$export($5f8d0ee7a8d35dfe$exports, "distSquared", () => $5f8d0ee7a8d35dfe$export$499eb56409f6cbc2);
$parcel$export($5f8d0ee7a8d35dfe$exports, "assert", () => $5f8d0ee7a8d35dfe$export$a7a9523472993e97);
$parcel$export($5f8d0ee7a8d35dfe$exports, "assertShapesMatch", () => $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782);
$parcel$export($5f8d0ee7a8d35dfe$exports, "arraysEqual", () => $5f8d0ee7a8d35dfe$export$234180f8206db11b);
$parcel$export($5f8d0ee7a8d35dfe$exports, "assertNonNull", () => $5f8d0ee7a8d35dfe$export$44a06cc2759dd036);
$parcel$export($5f8d0ee7a8d35dfe$exports, "sizeFromShape", () => $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f);
$parcel$export($5f8d0ee7a8d35dfe$exports, "isScalarShape", () => $5f8d0ee7a8d35dfe$export$d58b8d1ec2129064);
$parcel$export($5f8d0ee7a8d35dfe$exports, "arraysEqualWithNull", () => $5f8d0ee7a8d35dfe$export$9efb31c074e61de7);
$parcel$export($5f8d0ee7a8d35dfe$exports, "isInt", () => $5f8d0ee7a8d35dfe$export$357fc28f6427af8b);
$parcel$export($5f8d0ee7a8d35dfe$exports, "tanh", () => $5f8d0ee7a8d35dfe$export$7128670e45beef9a);
$parcel$export($5f8d0ee7a8d35dfe$exports, "sizeToSquarishShape", () => $5f8d0ee7a8d35dfe$export$55bdc5631791c247);
$parcel$export($5f8d0ee7a8d35dfe$exports, "createShuffledIndices", () => $5f8d0ee7a8d35dfe$export$49070d702e17365);
$parcel$export($5f8d0ee7a8d35dfe$exports, "rightPad", () => $5f8d0ee7a8d35dfe$export$390245bab32fb60f);
$parcel$export($5f8d0ee7a8d35dfe$exports, "repeatedTry", () => $5f8d0ee7a8d35dfe$export$aa345f93372ddb7b);
$parcel$export($5f8d0ee7a8d35dfe$exports, "inferFromImplicitShape", () => $5f8d0ee7a8d35dfe$export$e9459a51c182ffc2);
$parcel$export($5f8d0ee7a8d35dfe$exports, "parseAxisParam", () => $5f8d0ee7a8d35dfe$export$72b84eb9fe1f482);
$parcel$export($5f8d0ee7a8d35dfe$exports, "squeezeShape", () => $5f8d0ee7a8d35dfe$export$3106ace2a3b5396d);
$parcel$export($5f8d0ee7a8d35dfe$exports, "getTypedArrayFromDType", () => $5f8d0ee7a8d35dfe$export$3b783bdb77632623);
$parcel$export($5f8d0ee7a8d35dfe$exports, "getArrayFromDType", () => $5f8d0ee7a8d35dfe$export$24f13f6206df8f7c);
$parcel$export($5f8d0ee7a8d35dfe$exports, "checkConversionForErrors", () => $5f8d0ee7a8d35dfe$export$579cf7b8ff0a87a3);
$parcel$export($5f8d0ee7a8d35dfe$exports, "isValidDtype", () => $5f8d0ee7a8d35dfe$export$a6a3df2178ac9529);
$parcel$export($5f8d0ee7a8d35dfe$exports, "hasEncodingLoss", () => $5f8d0ee7a8d35dfe$export$9130d84b35fa7b98);
$parcel$export($5f8d0ee7a8d35dfe$exports, "bytesPerElement", () => $5f8d0ee7a8d35dfe$export$3f355ce86503b89f);
$parcel$export($5f8d0ee7a8d35dfe$exports, "bytesFromStringArray", () => $5f8d0ee7a8d35dfe$export$c474902e1102282d);
$parcel$export($5f8d0ee7a8d35dfe$exports, "isString", () => $5f8d0ee7a8d35dfe$export$844ec244b1367d54);
$parcel$export($5f8d0ee7a8d35dfe$exports, "isBoolean", () => $5f8d0ee7a8d35dfe$export$f9ce7b637dfbe238);
$parcel$export($5f8d0ee7a8d35dfe$exports, "isNumber", () => $5f8d0ee7a8d35dfe$export$7e4aa119212bc614);
$parcel$export($5f8d0ee7a8d35dfe$exports, "inferDtype", () => $5f8d0ee7a8d35dfe$export$2005775d905d2dc2);
$parcel$export($5f8d0ee7a8d35dfe$exports, "isFunction", () => $5f8d0ee7a8d35dfe$export$f6e2535fb5126e54);
$parcel$export($5f8d0ee7a8d35dfe$exports, "nearestDivisor", () => $5f8d0ee7a8d35dfe$export$c0ff3276320ddb5e);
$parcel$export($5f8d0ee7a8d35dfe$exports, "computeStrides", () => $5f8d0ee7a8d35dfe$export$6ad0292cf4d50f79);
$parcel$export($5f8d0ee7a8d35dfe$exports, "toNestedArray", () => $5f8d0ee7a8d35dfe$export$3983c25181aa68cc);
$parcel$export($5f8d0ee7a8d35dfe$exports, "convertBackendValuesAndArrayBuffer", () => $5f8d0ee7a8d35dfe$export$568d15cfc23dac5d);
$parcel$export($5f8d0ee7a8d35dfe$exports, "makeOnesTypedArray", () => $5f8d0ee7a8d35dfe$export$b915f681a907ae99);
$parcel$export($5f8d0ee7a8d35dfe$exports, "makeZerosTypedArray", () => $5f8d0ee7a8d35dfe$export$edbc8aedac4e036f);
$parcel$export($5f8d0ee7a8d35dfe$exports, "makeZerosNestedTypedArray", () => $5f8d0ee7a8d35dfe$export$eef638260c005c74);
$parcel$export($5f8d0ee7a8d35dfe$exports, "assertNonNegativeIntegerDimensions", () => $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5);
$parcel$export($5f8d0ee7a8d35dfe$exports, "locToIndex", () => $5f8d0ee7a8d35dfe$export$a14b009c502dc3b4);
$parcel$export($5f8d0ee7a8d35dfe$exports, "indexToLoc", () => $5f8d0ee7a8d35dfe$export$2d1ada4c755a8699);
$parcel$export($5f8d0ee7a8d35dfe$exports, "isPromise", () => $5f8d0ee7a8d35dfe$export$4369c812aac99591);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Shuffles the array in-place using Fisher-Yates algorithm.
 *
 * ```js
 * const a = [1, 2, 3, 4, 5];
 * tf.util.shuffle(a);
 * console.log(a);
 * ```
 *
 * @param array The array to shuffle in-place.
 *
 * @doc {heading: 'Util', namespace: 'util'}
 */ // tslint:disable-next-line:no-any
function $5f8d0ee7a8d35dfe$export$448332262467e042(array) {
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element with it
        $5f8d0ee7a8d35dfe$export$b0e76d9850c64156(array, counter, index);
    }
}
function $5f8d0ee7a8d35dfe$export$ae1498b5fd31a179(// tslint:disable-next-line:no-any
array, // tslint:disable-next-line:no-any
array2) {
    if (array.length !== array2.length) throw new Error(`Array sizes must match to be shuffled together ` + `First array length was ${array.length}` + `Second array length was ${array2.length}`);
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element of each array with it
        $5f8d0ee7a8d35dfe$export$b0e76d9850c64156(array, counter, index);
        $5f8d0ee7a8d35dfe$export$b0e76d9850c64156(array2, counter, index);
    }
}
function $5f8d0ee7a8d35dfe$export$7d15b64cf5a3a4c4(min, x, max) {
    return Math.max(min, Math.min(x, max));
}
function $5f8d0ee7a8d35dfe$export$ece2fd7300c99d1f(val) {
    return val % 2 === 0 ? val : val + 1;
}
function $5f8d0ee7a8d35dfe$export$b0e76d9850c64156(object, left, right) {
    const temp = object[left];
    object[left] = object[right];
    object[right] = temp;
}
function $5f8d0ee7a8d35dfe$export$8a63f25cc62965f1(arr) {
    let sum = 0;
    for(let i = 0; i < arr.length; i++)sum += arr[i];
    return sum;
}
function $5f8d0ee7a8d35dfe$export$1c2519d52242937(a, b) {
    const r = Math.random();
    return b * r + (1 - r) * a;
}
function $5f8d0ee7a8d35dfe$export$499eb56409f6cbc2(a, b) {
    let result = 0;
    for(let i = 0; i < a.length; i++){
        const diff = Number(a[i]) - Number(b[i]);
        result += diff * diff;
    }
    return result;
}
function $5f8d0ee7a8d35dfe$export$a7a9523472993e97(expr, msg) {
    if (!expr) throw new Error(typeof msg === 'string' ? msg : msg());
}
function $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782(shapeA, shapeB, errorMessagePrefix = '') {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$234180f8206db11b(shapeA, shapeB), ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
}
function $5f8d0ee7a8d35dfe$export$44a06cc2759dd036(a) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(a != null, ()=>`The input to the tensor constructor must be a non-null value.`);
}
function $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f(shape) {
    if (shape.length === 0) // Scalar.
    return 1;
    let size = shape[0];
    for(let i = 1; i < shape.length; i++)size *= shape[i];
    return size;
}
function $5f8d0ee7a8d35dfe$export$d58b8d1ec2129064(shape) {
    return shape.length === 0;
}
function $5f8d0ee7a8d35dfe$export$9efb31c074e61de7(n1, n2) {
    if (n1 === n2) return true;
    if (n1 == null || n2 == null) return false;
    if (n1.length !== n2.length) return false;
    for(let i = 0; i < n1.length; i++){
        if (n1[i] !== null && n2[i] !== null && n1[i] !== n2[i]) return false;
    }
    return true;
}
function $5f8d0ee7a8d35dfe$export$234180f8206db11b(n1, n2) {
    if (n1 === n2) return true;
    if (n1 == null || n2 == null) return false;
    if (n1.length !== n2.length) return false;
    for(let i = 0; i < n1.length; i++){
        if (n1[i] !== n2[i]) return false;
    }
    return true;
}
function $5f8d0ee7a8d35dfe$export$357fc28f6427af8b(a) {
    return a % 1 === 0;
}
function $5f8d0ee7a8d35dfe$export$7128670e45beef9a(x) {
    // tslint:disable-next-line:no-any
    if (Math.tanh != null) // tslint:disable-next-line:no-any
    return Math.tanh(x);
    if (x === Infinity) return 1;
    else if (x === -Infinity) return -1;
    else {
        const e2x = Math.exp(2 * x);
        return (e2x - 1) / (e2x + 1);
    }
}
function $5f8d0ee7a8d35dfe$export$55bdc5631791c247(size) {
    const width = Math.ceil(Math.sqrt(size));
    return [
        width,
        Math.ceil(size / width)
    ];
}
function $5f8d0ee7a8d35dfe$export$49070d702e17365(n) {
    const shuffledIndices = new Uint32Array(n);
    for(let i = 0; i < n; ++i)shuffledIndices[i] = i;
    $5f8d0ee7a8d35dfe$export$448332262467e042(shuffledIndices);
    return shuffledIndices;
}
function $5f8d0ee7a8d35dfe$export$390245bab32fb60f(a, size) {
    if (size <= a.length) return a;
    return a + ' '.repeat(size - a.length);
}
function $5f8d0ee7a8d35dfe$export$aa345f93372ddb7b(checkFn, delayFn = (counter)=>0, maxCounter, scheduleFn) {
    return new Promise((resolve, reject)=>{
        let tryCount = 0;
        const tryFn = ()=>{
            if (checkFn()) {
                resolve();
                return;
            }
            tryCount++;
            const nextBackoff = delayFn(tryCount);
            if (maxCounter != null && tryCount >= maxCounter) {
                reject();
                return;
            }
            if (scheduleFn != null) scheduleFn(tryFn, nextBackoff);
            else // google3 does not allow assigning another variable to setTimeout.
            // Don't refactor this so scheduleFn has a default value of setTimeout.
            setTimeout(tryFn, nextBackoff);
        };
        tryFn();
    });
}
function $5f8d0ee7a8d35dfe$export$e9459a51c182ffc2(shape, size) {
    let shapeProd = 1;
    let implicitIdx = -1;
    for(let i = 0; i < shape.length; ++i){
        if (shape[i] >= 0) shapeProd *= shape[i];
        else if (shape[i] === -1) {
            if (implicitIdx !== -1) throw Error(`Shapes can only have 1 implicit size. ` + `Found -1 at dim ${implicitIdx} and dim ${i}`);
            implicitIdx = i;
        } else if (shape[i] < 0) throw Error(`Shapes can not be < 0. Found ${shape[i]} at dim ${i}`);
    }
    if (implicitIdx === -1) {
        if (size > 0 && size !== shapeProd) throw Error(`Size(${size}) must match the product of shape ${shape}`);
        return shape;
    }
    if (shapeProd === 0) throw Error(`Cannot infer the missing size in [${shape}] when ` + `there are 0 elements`);
    if (size % shapeProd !== 0) throw Error(`The implicit shape can't be a fractional number. ` + `Got ${size} / ${shapeProd}`);
    const newShape = shape.slice();
    newShape[implicitIdx] = size / shapeProd;
    return newShape;
}
function $5f8d0ee7a8d35dfe$export$72b84eb9fe1f482(axis, shape) {
    const rank = shape.length;
    // Normalize input
    axis = axis == null ? shape.map((s, i)=>i) : [].concat(axis);
    // Check for valid range
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(axis.every((ax)=>ax >= -rank && ax < rank), ()=>`All values in axis param must be in range [-${rank}, ${rank}) but ` + `got axis ${axis}`);
    // Check for only integers
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(axis.every((ax)=>$5f8d0ee7a8d35dfe$export$357fc28f6427af8b(ax)), ()=>`All values in axis param must be integers but ` + `got axis ${axis}`);
    // Handle negative axis.
    return axis.map((a)=>a < 0 ? rank + a : a);
}
function $5f8d0ee7a8d35dfe$export$3106ace2a3b5396d(shape, axis) {
    const newShape = [];
    const keptDims = [];
    const isEmptyArray = axis != null && Array.isArray(axis) && axis.length === 0;
    const axes = axis == null || isEmptyArray ? null : $5f8d0ee7a8d35dfe$export$72b84eb9fe1f482(axis, shape).sort();
    let j = 0;
    for(let i = 0; i < shape.length; ++i){
        if (axes != null) {
            if (axes[j] === i && shape[i] !== 1) throw new Error(`Can't squeeze axis ${i} since its dim '${shape[i]}' is not 1`);
            if ((axes[j] == null || axes[j] > i) && shape[i] === 1) {
                newShape.push(shape[i]);
                keptDims.push(i);
            }
            if (axes[j] <= i) j++;
        }
        if (shape[i] !== 1) {
            newShape.push(shape[i]);
            keptDims.push(i);
        }
    }
    return {
        newShape: newShape,
        keptDims: keptDims
    };
}
function $5f8d0ee7a8d35dfe$export$3b783bdb77632623(dtype, size) {
    return $5f8d0ee7a8d35dfe$export$24f13f6206df8f7c(dtype, size);
}
function $5f8d0ee7a8d35dfe$export$24f13f6206df8f7c(dtype, size) {
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else if (dtype === 'string') values = new Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    return values;
}
function $5f8d0ee7a8d35dfe$export$579cf7b8ff0a87a3(vals, dtype) {
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) throw Error(`A tensor of type ${dtype} being uploaded contains ${num}.`);
    }
}
function $5f8d0ee7a8d35dfe$export$a6a3df2178ac9529(dtype) {
    return dtype === 'bool' || dtype === 'complex64' || dtype === 'float32' || dtype === 'int32' || dtype === 'string';
}
function $5f8d0ee7a8d35dfe$export$9130d84b35fa7b98(oldType, newType) {
    if (newType === 'complex64') return false;
    if (newType === 'float32' && oldType !== 'complex64') return false;
    if (newType === 'int32' && oldType !== 'float32' && oldType !== 'complex64') return false;
    if (newType === 'bool' && oldType === 'bool') return false;
    return true;
}
function $5f8d0ee7a8d35dfe$export$3f355ce86503b89f(dtype) {
    if (dtype === 'float32' || dtype === 'int32') return 4;
    else if (dtype === 'complex64') return 8;
    else if (dtype === 'bool') return 1;
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $5f8d0ee7a8d35dfe$export$c474902e1102282d(arr) {
    if (arr == null) return 0;
    let bytes = 0;
    arr.forEach((x)=>bytes += x.length);
    return bytes;
}
function $5f8d0ee7a8d35dfe$export$844ec244b1367d54(value) {
    return typeof value === 'string' || value instanceof String;
}
function $5f8d0ee7a8d35dfe$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $5f8d0ee7a8d35dfe$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $5f8d0ee7a8d35dfe$export$2005775d905d2dc2(values) {
    if (Array.isArray(values)) return $5f8d0ee7a8d35dfe$export$2005775d905d2dc2(values[0]);
    if (values instanceof Float32Array) return 'float32';
    else if (values instanceof Int32Array || values instanceof Uint8Array || values instanceof Uint8ClampedArray) return 'int32';
    else if ($5f8d0ee7a8d35dfe$export$7e4aa119212bc614(values)) return 'float32';
    else if ($5f8d0ee7a8d35dfe$export$844ec244b1367d54(values)) return 'string';
    else if ($5f8d0ee7a8d35dfe$export$f9ce7b637dfbe238(values)) return 'bool';
    return 'float32';
}
function $5f8d0ee7a8d35dfe$export$f6e2535fb5126e54(f) {
    return !!(f && f.constructor && f.call && f.apply);
}
function $5f8d0ee7a8d35dfe$export$c0ff3276320ddb5e(size, start) {
    for(let i = start; i < size; ++i){
        if (size % i === 0) return i;
    }
    return size;
}
function $5f8d0ee7a8d35dfe$export$6ad0292cf4d50f79(shape) {
    const rank = shape.length;
    if (rank < 2) return [];
    // Last dimension has implicit stride of 1, thus having D-1 (instead of D)
    // strides.
    const strides = new Array(rank - 1);
    strides[rank - 2] = shape[rank - 1];
    for(let i = rank - 3; i >= 0; --i)strides[i] = strides[i + 1] * shape[i + 1];
    return strides;
}
function $5f8d0ee7a8d35dfe$var$createNestedArray(offset, shape, a, isComplex = false) {
    const ret = new Array();
    if (shape.length === 1) {
        const d = shape[0] * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = a[offset + i];
    } else {
        const d = shape[0];
        const rest = shape.slice(1);
        const len = rest.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = $5f8d0ee7a8d35dfe$var$createNestedArray(offset + i * len, rest, a, isComplex);
    }
    return ret;
}
function $5f8d0ee7a8d35dfe$export$3983c25181aa68cc(shape, a, isComplex = false) {
    if (shape.length === 0) // Scalar type should return a single number.
    return a[0];
    const size = shape.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
    if (size === 0) // A tensor with shape zero should be turned into empty list.
    return [];
    if (size !== a.length) throw new Error(`[${shape}] does not match the input size ${a.length}${isComplex ? ' for a complex tensor' : ''}.`);
    return $5f8d0ee7a8d35dfe$var$createNestedArray(0, shape, a, isComplex);
}
function $5f8d0ee7a8d35dfe$export$568d15cfc23dac5d(data, dtype) {
    // If is type Uint8Array[], return it directly.
    if (Array.isArray(data)) return data;
    if (dtype === 'float32') return data instanceof Float32Array ? data : new Float32Array(data);
    else if (dtype === 'int32') return data instanceof Int32Array ? data : new Int32Array(data);
    else if (dtype === 'bool' || dtype === 'string') return Uint8Array.from(new Int32Array(data));
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $5f8d0ee7a8d35dfe$export$b915f681a907ae99(size, dtype) {
    const array = $5f8d0ee7a8d35dfe$export$edbc8aedac4e036f(size, dtype);
    for(let i = 0; i < array.length; i++)array[i] = 1;
    return array;
}
function $5f8d0ee7a8d35dfe$export$edbc8aedac4e036f(size, dtype) {
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(size);
    else if (dtype === 'int32') return new Int32Array(size);
    else if (dtype === 'bool') return new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
}
function $5f8d0ee7a8d35dfe$export$eef638260c005c74(shape, dtype) {
    const size = shape.reduce((prev, curr)=>prev * curr, 1);
    if (dtype == null || dtype === 'float32') return $5f8d0ee7a8d35dfe$export$3983c25181aa68cc(shape, new Float32Array(size));
    else if (dtype === 'int32') return $5f8d0ee7a8d35dfe$export$3983c25181aa68cc(shape, new Int32Array(size));
    else if (dtype === 'bool') return $5f8d0ee7a8d35dfe$export$3983c25181aa68cc(shape, new Uint8Array(size));
    else throw new Error(`Unknown data type ${dtype}`);
}
function $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5(shape) {
    shape.forEach((dimSize)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(Number.isInteger(dimSize) && dimSize >= 0, ()=>`Tensor must have a shape comprised of positive integers but got ` + `shape [${shape}].`);
    });
}
function $5f8d0ee7a8d35dfe$export$a14b009c502dc3b4(locs, rank, strides) {
    if (rank === 0) return 0;
    else if (rank === 1) return locs[0];
    let index = locs[locs.length - 1];
    for(let i = 0; i < locs.length - 1; ++i)index += strides[i] * locs[i];
    return index;
}
function $5f8d0ee7a8d35dfe$export$2d1ada4c755a8699(index, rank, strides) {
    if (rank === 0) return [];
    else if (rank === 1) return [
        index
    ];
    const locs = new Array(rank);
    for(let i = 0; i < locs.length - 1; ++i){
        locs[i] = Math.floor(index / strides[i]);
        index -= locs[i] * strides[i];
    }
    locs[locs.length - 1] = index;
    return locs;
}
function $5f8d0ee7a8d35dfe$export$4369c812aac99591(object) {
    //  We chose to not use 'obj instanceOf Promise' for two reasons:
    //  1. It only reliably works for es6 Promise, not other Promise
    //  implementations.
    //  2. It doesn't work with framework that uses zone.js. zone.js monkey
    //  patch the async calls, so it is possible the obj (patched) is
    //  comparing to a pre-patched Promise.
    return object && object.then && typeof object.then === 'function';
}


// Expects flags from URL in the format ?tfjsflags=FLAG1:1,FLAG2:true.
const $d3cf252ef4ef8e7f$var$TENSORFLOWJS_FLAGS_PREFIX = 'tfjsflags';
class $d3cf252ef4ef8e7f$export$7dc6752a22ab011a {
    // tslint:disable-next-line: no-any
    constructor(global){
        this.global = global;
        this.flags = {};
        this.flagRegistry = {};
        this.urlFlags = {};
        // Jasmine spies on this in 'environment_test.ts'
        this.getQueryParams = $d3cf252ef4ef8e7f$export$e2de15bbd9edf9c6;
        this.populateURLFlags();
    }
    setPlatform(platformName, platform) {
        if (this.platform != null) {
            if (!($d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Platform ${this.platformName} has already been set. ` + `Overwriting the platform with ${platformName}.`);
        }
        this.platformName = platformName;
        this.platform = platform;
    }
    registerFlag(flagName, evaluationFn, setHook) {
        this.flagRegistry[flagName] = {
            evaluationFn: evaluationFn,
            setHook: setHook
        };
        // Override the flag value from the URL. This has to happen here because
        // the environment is initialized before flags get registered.
        if (this.urlFlags[flagName] != null) {
            const flagValue = this.urlFlags[flagName];
            if (!($d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Setting feature override from URL ${flagName}: ${flagValue}.`);
            this.set(flagName, flagValue);
        }
    }
    async getAsync(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        this.flags[flagName] = await this.evaluateFlag(flagName);
        return this.flags[flagName];
    }
    get(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        const flagValue = this.evaluateFlag(flagName);
        if ((0, $5f8d0ee7a8d35dfe$export$4369c812aac99591)(flagValue)) throw new Error(`Flag ${flagName} cannot be synchronously evaluated. ` + `Please use getAsync() instead.`);
        this.flags[flagName] = flagValue;
        return this.flags[flagName];
    }
    getNumber(flagName) {
        return this.get(flagName);
    }
    getBool(flagName) {
        return this.get(flagName);
    }
    getString(flagName) {
        return this.get(flagName);
    }
    getFlags() {
        return this.flags;
    }
    // For backwards compatibility.
    get features() {
        return this.flags;
    }
    set(flagName, value) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot set flag ${flagName} as it has not been registered.`);
        this.flags[flagName] = value;
        if (this.flagRegistry[flagName].setHook != null) this.flagRegistry[flagName].setHook(value);
    }
    evaluateFlag(flagName) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot evaluate flag '${flagName}': no evaluation function found.`);
        return this.flagRegistry[flagName].evaluationFn();
    }
    setFlags(flags) {
        this.flags = Object.assign({}, flags);
    }
    reset() {
        this.flags = {};
        this.urlFlags = {};
        this.populateURLFlags();
    }
    populateURLFlags() {
        if (typeof this.global === 'undefined' || typeof this.global.location === 'undefined' || typeof this.global.location.search === 'undefined') return;
        const urlParams = this.getQueryParams(this.global.location.search);
        if ($d3cf252ef4ef8e7f$var$TENSORFLOWJS_FLAGS_PREFIX in urlParams) {
            const keyValues = urlParams[$d3cf252ef4ef8e7f$var$TENSORFLOWJS_FLAGS_PREFIX].split(',');
            keyValues.forEach((keyValue)=>{
                const [key, value] = keyValue.split(':');
                this.urlFlags[key] = $d3cf252ef4ef8e7f$var$parseValue(key, value);
            });
        }
    }
}
function $d3cf252ef4ef8e7f$export$e2de15bbd9edf9c6(queryString) {
    const params = {};
    queryString.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, (s, ...t)=>{
        $d3cf252ef4ef8e7f$var$decodeParam(params, t[0], t[1]);
        return t.join('=');
    });
    return params;
}
function $d3cf252ef4ef8e7f$var$decodeParam(params, name, value) {
    params[decodeURIComponent(name)] = decodeURIComponent(value || '');
}
function $d3cf252ef4ef8e7f$var$parseValue(flagName, value) {
    const lowerCaseValue = value.toLowerCase();
    if (lowerCaseValue === 'true' || lowerCaseValue === 'false') return lowerCaseValue === 'true';
    else if (`${+lowerCaseValue}` === lowerCaseValue) return +lowerCaseValue;
    else return value;
}
function $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3() {
    return $d3cf252ef4ef8e7f$export$83401e34d5e11bf4;
}
let $d3cf252ef4ef8e7f$export$83401e34d5e11bf4 = null;
function $d3cf252ef4ef8e7f$export$3ef32a49eeda04cc(environment) {
    $d3cf252ef4ef8e7f$export$83401e34d5e11bf4 = environment;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Note that the identifier globalNameSpace is scoped to this module, but will
// always resolve to the same global object regardless of how the module is
// resolved.
// tslint:disable-next-line:no-any
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


let $bf790b47f177f8e9$var$globalNameSpace;
function $bf790b47f177f8e9$export$5054b240ae6849b7() {
    if ($bf790b47f177f8e9$var$globalNameSpace == null) {
        // tslint:disable-next-line:no-any
        let ns;
        if (typeof window !== 'undefined') ns = window;
        else if (typeof $parcel$global !== 'undefined') ns = $parcel$global;
        else if (typeof $cfae44f0dfdf62c0$exports !== 'undefined') ns = $cfae44f0dfdf62c0$exports;
        else if (typeof self !== 'undefined') ns = self;
        else throw new Error('Could not find a global object');
        $bf790b47f177f8e9$var$globalNameSpace = ns;
    }
    return $bf790b47f177f8e9$var$globalNameSpace;
}
// tslint:disable-next-line:no-any
function $bf790b47f177f8e9$var$getGlobalMap() {
    const ns = $bf790b47f177f8e9$export$5054b240ae6849b7();
    if (ns._tfGlobals == null) ns._tfGlobals = new Map();
    return ns._tfGlobals;
}
function $bf790b47f177f8e9$export$a4e55266d2135a7f(key, init) {
    const globalMap = $bf790b47f177f8e9$var$getGlobalMap();
    if (globalMap.has(key)) return globalMap.get(key);
    else {
        const singleton = init();
        globalMap.set(key, singleton);
        return globalMap.get(key);
    }
}


var $c9f78399309a8a0d$exports = {};

$parcel$export($c9f78399309a8a0d$exports, "Abs", () => $c9f78399309a8a0d$export$b73c596ee8758a66);
$parcel$export($c9f78399309a8a0d$exports, "Acos", () => $c9f78399309a8a0d$export$3b952c9980dac550);
$parcel$export($c9f78399309a8a0d$exports, "Acosh", () => $c9f78399309a8a0d$export$987da490b7c2e7dd);
$parcel$export($c9f78399309a8a0d$exports, "Add", () => $c9f78399309a8a0d$export$d0265b2c425512d6);
$parcel$export($c9f78399309a8a0d$exports, "AddN", () => $c9f78399309a8a0d$export$eef235ad06d3226a);
$parcel$export($c9f78399309a8a0d$exports, "All", () => $c9f78399309a8a0d$export$5dceb1ab650a1776);
$parcel$export($c9f78399309a8a0d$exports, "Any", () => $c9f78399309a8a0d$export$b24b633b1364b94b);
$parcel$export($c9f78399309a8a0d$exports, "ArgMax", () => $c9f78399309a8a0d$export$17612294a1503e1c);
$parcel$export($c9f78399309a8a0d$exports, "ArgMin", () => $c9f78399309a8a0d$export$baabd09270cbbd94);
$parcel$export($c9f78399309a8a0d$exports, "Asin", () => $c9f78399309a8a0d$export$664c8ca7e7e5c126);
$parcel$export($c9f78399309a8a0d$exports, "Asinh", () => $c9f78399309a8a0d$export$847c88940cb7dcb5);
$parcel$export($c9f78399309a8a0d$exports, "Atan", () => $c9f78399309a8a0d$export$bac667d46ac043ae);
$parcel$export($c9f78399309a8a0d$exports, "Atanh", () => $c9f78399309a8a0d$export$98981a86fa2b1366);
$parcel$export($c9f78399309a8a0d$exports, "Atan2", () => $c9f78399309a8a0d$export$3bf4c619ce589f4b);
$parcel$export($c9f78399309a8a0d$exports, "AvgPool", () => $c9f78399309a8a0d$export$37f2cc7be1add88c);
$parcel$export($c9f78399309a8a0d$exports, "AvgPoolGrad", () => $c9f78399309a8a0d$export$9873fd6046cd6951);
$parcel$export($c9f78399309a8a0d$exports, "AvgPool3D", () => $c9f78399309a8a0d$export$390ecb697af103f6);
$parcel$export($c9f78399309a8a0d$exports, "AvgPool3DGrad", () => $c9f78399309a8a0d$export$7163112adf28c062);
$parcel$export($c9f78399309a8a0d$exports, "BatchMatMul", () => $c9f78399309a8a0d$export$9a3bf60b23f63c8);
$parcel$export($c9f78399309a8a0d$exports, "BatchToSpaceND", () => $c9f78399309a8a0d$export$e2743f47f61cca1f);
$parcel$export($c9f78399309a8a0d$exports, "Bincount", () => $c9f78399309a8a0d$export$45dfbbff595c32aa);
$parcel$export($c9f78399309a8a0d$exports, "BitwiseAnd", () => $c9f78399309a8a0d$export$a9e259e32a62221f);
$parcel$export($c9f78399309a8a0d$exports, "BroadcastTo", () => $c9f78399309a8a0d$export$ea5eeb875a7c4dd1);
$parcel$export($c9f78399309a8a0d$exports, "BroadcastArgs", () => $c9f78399309a8a0d$export$32877b1d6d497805);
$parcel$export($c9f78399309a8a0d$exports, "Cast", () => $c9f78399309a8a0d$export$107ecfb3d1ccbd77);
$parcel$export($c9f78399309a8a0d$exports, "Ceil", () => $c9f78399309a8a0d$export$d4a1bccfd52ebd3);
$parcel$export($c9f78399309a8a0d$exports, "ClipByValue", () => $c9f78399309a8a0d$export$611c0e357ac37f7d);
$parcel$export($c9f78399309a8a0d$exports, "Complex", () => $c9f78399309a8a0d$export$50ceb3fb9926e63e);
$parcel$export($c9f78399309a8a0d$exports, "ComplexAbs", () => $c9f78399309a8a0d$export$32902e58f1b48f4b);
$parcel$export($c9f78399309a8a0d$exports, "Concat", () => $c9f78399309a8a0d$export$936bbfc007425eea);
$parcel$export($c9f78399309a8a0d$exports, "Conv2D", () => $c9f78399309a8a0d$export$57742e605d475795);
$parcel$export($c9f78399309a8a0d$exports, "Conv2DBackpropFilter", () => $c9f78399309a8a0d$export$32a8943c0f1ca5a7);
$parcel$export($c9f78399309a8a0d$exports, "Conv2DBackpropInput", () => $c9f78399309a8a0d$export$e26961e8ed0eb404);
$parcel$export($c9f78399309a8a0d$exports, "Conv3D", () => $c9f78399309a8a0d$export$9d3874201dd21933);
$parcel$export($c9f78399309a8a0d$exports, "Conv3DBackpropFilterV2", () => $c9f78399309a8a0d$export$dd2885efe6043eee);
$parcel$export($c9f78399309a8a0d$exports, "Conv3DBackpropInputV2", () => $c9f78399309a8a0d$export$a54f552d6d7d521f);
$parcel$export($c9f78399309a8a0d$exports, "Cos", () => $c9f78399309a8a0d$export$ddfd0a983d257666);
$parcel$export($c9f78399309a8a0d$exports, "Cosh", () => $c9f78399309a8a0d$export$5e311a1c57b0d27c);
$parcel$export($c9f78399309a8a0d$exports, "Cumprod", () => $c9f78399309a8a0d$export$e581acc6014c47a);
$parcel$export($c9f78399309a8a0d$exports, "Cumsum", () => $c9f78399309a8a0d$export$706617d894ad63da);
$parcel$export($c9f78399309a8a0d$exports, "CropAndResize", () => $c9f78399309a8a0d$export$50bc9557793c2e04);
$parcel$export($c9f78399309a8a0d$exports, "DenseBincount", () => $c9f78399309a8a0d$export$5bab6834954299c5);
$parcel$export($c9f78399309a8a0d$exports, "DepthToSpace", () => $c9f78399309a8a0d$export$fb0ee52d0cd6f233);
$parcel$export($c9f78399309a8a0d$exports, "DepthwiseConv2dNative", () => $c9f78399309a8a0d$export$7c0fc590ff9e156f);
$parcel$export($c9f78399309a8a0d$exports, "DepthwiseConv2dNativeBackpropFilter", () => $c9f78399309a8a0d$export$c99f139e0d4d1833);
$parcel$export($c9f78399309a8a0d$exports, "DepthwiseConv2dNativeBackpropInput", () => $c9f78399309a8a0d$export$8649ca3b17033a24);
$parcel$export($c9f78399309a8a0d$exports, "Diag", () => $c9f78399309a8a0d$export$ca73a25315ddeb7f);
$parcel$export($c9f78399309a8a0d$exports, "Dilation2D", () => $c9f78399309a8a0d$export$dbbb7830c6497701);
$parcel$export($c9f78399309a8a0d$exports, "Dilation2DBackpropInput", () => $c9f78399309a8a0d$export$5dd675a6b0f37e17);
$parcel$export($c9f78399309a8a0d$exports, "Dilation2DBackpropFilter", () => $c9f78399309a8a0d$export$91add972be69d592);
$parcel$export($c9f78399309a8a0d$exports, "Draw", () => $c9f78399309a8a0d$export$dca20402ebea5ece);
$parcel$export($c9f78399309a8a0d$exports, "RealDiv", () => $c9f78399309a8a0d$export$b9880b86e1014bb8);
$parcel$export($c9f78399309a8a0d$exports, "Einsum", () => $c9f78399309a8a0d$export$2541d8be32f3c641);
$parcel$export($c9f78399309a8a0d$exports, "Elu", () => $c9f78399309a8a0d$export$64636e173424d83d);
$parcel$export($c9f78399309a8a0d$exports, "EluGrad", () => $c9f78399309a8a0d$export$9906be4699a73c53);
$parcel$export($c9f78399309a8a0d$exports, "Erf", () => $c9f78399309a8a0d$export$c2ee2551ce71f1d0);
$parcel$export($c9f78399309a8a0d$exports, "Equal", () => $c9f78399309a8a0d$export$8dcf9f58ce5cdfc);
$parcel$export($c9f78399309a8a0d$exports, "Exp", () => $c9f78399309a8a0d$export$f908be7a96fb3363);
$parcel$export($c9f78399309a8a0d$exports, "ExpandDims", () => $c9f78399309a8a0d$export$2391750b1d901146);
$parcel$export($c9f78399309a8a0d$exports, "Expm1", () => $c9f78399309a8a0d$export$261f26143a1ff3);
$parcel$export($c9f78399309a8a0d$exports, "FFT", () => $c9f78399309a8a0d$export$677347237c014ba);
$parcel$export($c9f78399309a8a0d$exports, "Fill", () => $c9f78399309a8a0d$export$ffffe40bfa0649a3);
$parcel$export($c9f78399309a8a0d$exports, "FlipLeftRight", () => $c9f78399309a8a0d$export$34e7296fc8558df5);
$parcel$export($c9f78399309a8a0d$exports, "Floor", () => $c9f78399309a8a0d$export$4880b0ae5643c62b);
$parcel$export($c9f78399309a8a0d$exports, "FloorDiv", () => $c9f78399309a8a0d$export$d79b5692ede26c2f);
$parcel$export($c9f78399309a8a0d$exports, "FusedBatchNorm", () => $c9f78399309a8a0d$export$3821a0416660aaa2);
$parcel$export($c9f78399309a8a0d$exports, "GatherV2", () => $c9f78399309a8a0d$export$ccd988942e5c0181);
$parcel$export($c9f78399309a8a0d$exports, "GatherNd", () => $c9f78399309a8a0d$export$4ef6e37a23721703);
$parcel$export($c9f78399309a8a0d$exports, "Greater", () => $c9f78399309a8a0d$export$d0a25eac5ee3f515);
$parcel$export($c9f78399309a8a0d$exports, "GreaterEqual", () => $c9f78399309a8a0d$export$3b7d21bc9aee0851);
$parcel$export($c9f78399309a8a0d$exports, "Identity", () => $c9f78399309a8a0d$export$544bf02140fa9a77);
$parcel$export($c9f78399309a8a0d$exports, "IFFT", () => $c9f78399309a8a0d$export$21c6f576ae8100e8);
$parcel$export($c9f78399309a8a0d$exports, "Imag", () => $c9f78399309a8a0d$export$303b4473993a24f);
$parcel$export($c9f78399309a8a0d$exports, "IsFinite", () => $c9f78399309a8a0d$export$b9fcc0946d7d485e);
$parcel$export($c9f78399309a8a0d$exports, "IsInf", () => $c9f78399309a8a0d$export$74b5a3bc735b152);
$parcel$export($c9f78399309a8a0d$exports, "IsNan", () => $c9f78399309a8a0d$export$9912dc4fc649dbec);
$parcel$export($c9f78399309a8a0d$exports, "LeakyRelu", () => $c9f78399309a8a0d$export$f0c7162bb7af1a2d);
$parcel$export($c9f78399309a8a0d$exports, "Less", () => $c9f78399309a8a0d$export$728c50f1c88ac779);
$parcel$export($c9f78399309a8a0d$exports, "LessEqual", () => $c9f78399309a8a0d$export$84afd0d8f7fb8c5d);
$parcel$export($c9f78399309a8a0d$exports, "LinSpace", () => $c9f78399309a8a0d$export$34f0ab8eba543ee6);
$parcel$export($c9f78399309a8a0d$exports, "Log", () => $c9f78399309a8a0d$export$ce30dbb46644d06c);
$parcel$export($c9f78399309a8a0d$exports, "Log1p", () => $c9f78399309a8a0d$export$70f05bf9ddcfca68);
$parcel$export($c9f78399309a8a0d$exports, "LogicalAnd", () => $c9f78399309a8a0d$export$8a27ff10dff4d6e5);
$parcel$export($c9f78399309a8a0d$exports, "LogicalNot", () => $c9f78399309a8a0d$export$4393bee5596c68c2);
$parcel$export($c9f78399309a8a0d$exports, "LogicalOr", () => $c9f78399309a8a0d$export$c49f9f5ffc6f678c);
$parcel$export($c9f78399309a8a0d$exports, "LogicalXor", () => $c9f78399309a8a0d$export$656629b293485eff);
$parcel$export($c9f78399309a8a0d$exports, "LogSoftmax", () => $c9f78399309a8a0d$export$85b5bcbd60848a10);
$parcel$export($c9f78399309a8a0d$exports, "LowerBound", () => $c9f78399309a8a0d$export$9ec35fe80d53e931);
$parcel$export($c9f78399309a8a0d$exports, "LRN", () => $c9f78399309a8a0d$export$eb2f713fc3e1ca9a);
$parcel$export($c9f78399309a8a0d$exports, "LRNGrad", () => $c9f78399309a8a0d$export$73ba43cd0ce95b10);
$parcel$export($c9f78399309a8a0d$exports, "MatrixBandPart", () => $c9f78399309a8a0d$export$b4571177c51d555b);
$parcel$export($c9f78399309a8a0d$exports, "Max", () => $c9f78399309a8a0d$export$d36c09e5d02927e7);
$parcel$export($c9f78399309a8a0d$exports, "Maximum", () => $c9f78399309a8a0d$export$d8d02ac92d161004);
$parcel$export($c9f78399309a8a0d$exports, "MaxPool", () => $c9f78399309a8a0d$export$39ea33024ddd5cf);
$parcel$export($c9f78399309a8a0d$exports, "MaxPoolGrad", () => $c9f78399309a8a0d$export$f0f010b1d1db8a46);
$parcel$export($c9f78399309a8a0d$exports, "MaxPool3D", () => $c9f78399309a8a0d$export$88fdc64af890fc53);
$parcel$export($c9f78399309a8a0d$exports, "MaxPool3DGrad", () => $c9f78399309a8a0d$export$52be2c00371a1350);
$parcel$export($c9f78399309a8a0d$exports, "MaxPoolWithArgmax", () => $c9f78399309a8a0d$export$deac4b7497b4047f);
$parcel$export($c9f78399309a8a0d$exports, "Mean", () => $c9f78399309a8a0d$export$1c2d59c4b681fbd8);
$parcel$export($c9f78399309a8a0d$exports, "Min", () => $c9f78399309a8a0d$export$dfed19fabc75a31d);
$parcel$export($c9f78399309a8a0d$exports, "Minimum", () => $c9f78399309a8a0d$export$23cb308301e89d6b);
$parcel$export($c9f78399309a8a0d$exports, "MirrorPad", () => $c9f78399309a8a0d$export$f4c0e95fd7fd31e5);
$parcel$export($c9f78399309a8a0d$exports, "Mod", () => $c9f78399309a8a0d$export$e4835a5e3f3674d5);
$parcel$export($c9f78399309a8a0d$exports, "Multinomial", () => $c9f78399309a8a0d$export$ee0a8cfb693e0e3f);
$parcel$export($c9f78399309a8a0d$exports, "Multiply", () => $c9f78399309a8a0d$export$f14f83b3b531d498);
$parcel$export($c9f78399309a8a0d$exports, "Neg", () => $c9f78399309a8a0d$export$c07c549000872073);
$parcel$export($c9f78399309a8a0d$exports, "NotEqual", () => $c9f78399309a8a0d$export$385ebe9945cae0c5);
$parcel$export($c9f78399309a8a0d$exports, "NonMaxSuppressionV3", () => $c9f78399309a8a0d$export$5e11788439c2f04);
$parcel$export($c9f78399309a8a0d$exports, "NonMaxSuppressionV4", () => $c9f78399309a8a0d$export$7df908154366fe7f);
$parcel$export($c9f78399309a8a0d$exports, "NonMaxSuppressionV5", () => $c9f78399309a8a0d$export$cb45d3fcefce2ef0);
$parcel$export($c9f78399309a8a0d$exports, "OnesLike", () => $c9f78399309a8a0d$export$a2962e735c809d91);
$parcel$export($c9f78399309a8a0d$exports, "OneHot", () => $c9f78399309a8a0d$export$18982b43ba8c02e9);
$parcel$export($c9f78399309a8a0d$exports, "Pack", () => $c9f78399309a8a0d$export$c26f40b29201e5b7);
$parcel$export($c9f78399309a8a0d$exports, "PadV2", () => $c9f78399309a8a0d$export$5d47ba206577f0f2);
$parcel$export($c9f78399309a8a0d$exports, "Pool", () => $c9f78399309a8a0d$export$14963ee5c8637e11);
$parcel$export($c9f78399309a8a0d$exports, "Pow", () => $c9f78399309a8a0d$export$ce28d653ec559ee);
$parcel$export($c9f78399309a8a0d$exports, "Prelu", () => $c9f78399309a8a0d$export$a42f35f308fc2fa3);
$parcel$export($c9f78399309a8a0d$exports, "Prod", () => $c9f78399309a8a0d$export$b8a16d526a791fb0);
$parcel$export($c9f78399309a8a0d$exports, "RaggedGather", () => $c9f78399309a8a0d$export$ffee9c5b4fce08a1);
$parcel$export($c9f78399309a8a0d$exports, "RaggedRange", () => $c9f78399309a8a0d$export$9d0615a9a6d213d2);
$parcel$export($c9f78399309a8a0d$exports, "RaggedTensorToTensor", () => $c9f78399309a8a0d$export$616d73a9ab7617c7);
$parcel$export($c9f78399309a8a0d$exports, "Range", () => $c9f78399309a8a0d$export$9a58ef0d7ad3278c);
$parcel$export($c9f78399309a8a0d$exports, "Real", () => $c9f78399309a8a0d$export$f41305719b94e675);
$parcel$export($c9f78399309a8a0d$exports, "Reciprocal", () => $c9f78399309a8a0d$export$c6e4a23ed5e0415b);
$parcel$export($c9f78399309a8a0d$exports, "Relu", () => $c9f78399309a8a0d$export$9a6ff968bf961432);
$parcel$export($c9f78399309a8a0d$exports, "Reshape", () => $c9f78399309a8a0d$export$755ddd847e5abe03);
$parcel$export($c9f78399309a8a0d$exports, "ResizeNearestNeighbor", () => $c9f78399309a8a0d$export$6c8d8ec26192bb18);
$parcel$export($c9f78399309a8a0d$exports, "ResizeNearestNeighborGrad", () => $c9f78399309a8a0d$export$b84ac31c55aa023b);
$parcel$export($c9f78399309a8a0d$exports, "ResizeBilinear", () => $c9f78399309a8a0d$export$24f2f15d869e0fd);
$parcel$export($c9f78399309a8a0d$exports, "ResizeBilinearGrad", () => $c9f78399309a8a0d$export$2d3cf759f1538c13);
$parcel$export($c9f78399309a8a0d$exports, "Relu6", () => $c9f78399309a8a0d$export$3be9e924f629054e);
$parcel$export($c9f78399309a8a0d$exports, "Reverse", () => $c9f78399309a8a0d$export$53c81f36b32e1bba);
$parcel$export($c9f78399309a8a0d$exports, "Round", () => $c9f78399309a8a0d$export$c5ed3eef16c0612f);
$parcel$export($c9f78399309a8a0d$exports, "Rsqrt", () => $c9f78399309a8a0d$export$7cc53aa09f5f3a2d);
$parcel$export($c9f78399309a8a0d$exports, "ScatterNd", () => $c9f78399309a8a0d$export$28eef6f0168af686);
$parcel$export($c9f78399309a8a0d$exports, "TensorScatterUpdate", () => $c9f78399309a8a0d$export$20050a140fd1de77);
$parcel$export($c9f78399309a8a0d$exports, "SearchSorted", () => $c9f78399309a8a0d$export$9a1405490b09867e);
$parcel$export($c9f78399309a8a0d$exports, "Select", () => $c9f78399309a8a0d$export$ef9b1a59e592288f);
$parcel$export($c9f78399309a8a0d$exports, "Selu", () => $c9f78399309a8a0d$export$6760d858e6f2594a);
$parcel$export($c9f78399309a8a0d$exports, "Slice", () => $c9f78399309a8a0d$export$b3f2e2de3a8baa1e);
$parcel$export($c9f78399309a8a0d$exports, "Sin", () => $c9f78399309a8a0d$export$75be1b631f7687);
$parcel$export($c9f78399309a8a0d$exports, "Sinh", () => $c9f78399309a8a0d$export$b8c187376329d79b);
$parcel$export($c9f78399309a8a0d$exports, "Sign", () => $c9f78399309a8a0d$export$1db683ad541682f6);
$parcel$export($c9f78399309a8a0d$exports, "Sigmoid", () => $c9f78399309a8a0d$export$fde18c826dda6b1b);
$parcel$export($c9f78399309a8a0d$exports, "Softplus", () => $c9f78399309a8a0d$export$c5af433747f1fd0a);
$parcel$export($c9f78399309a8a0d$exports, "Sqrt", () => $c9f78399309a8a0d$export$21ab404ab9d512a6);
$parcel$export($c9f78399309a8a0d$exports, "Sum", () => $c9f78399309a8a0d$export$534760f50726d5);
$parcel$export($c9f78399309a8a0d$exports, "SpaceToBatchND", () => $c9f78399309a8a0d$export$f63ac5409312707c);
$parcel$export($c9f78399309a8a0d$exports, "SplitV", () => $c9f78399309a8a0d$export$8dffabb4071f05aa);
$parcel$export($c9f78399309a8a0d$exports, "Softmax", () => $c9f78399309a8a0d$export$350a526055d3ca6e);
$parcel$export($c9f78399309a8a0d$exports, "SparseFillEmptyRows", () => $c9f78399309a8a0d$export$8f1933853a5c8cca);
$parcel$export($c9f78399309a8a0d$exports, "SparseReshape", () => $c9f78399309a8a0d$export$f08f0dca44fa542);
$parcel$export($c9f78399309a8a0d$exports, "SparseSegmentMean", () => $c9f78399309a8a0d$export$610b077aecc2447b);
$parcel$export($c9f78399309a8a0d$exports, "SparseSegmentSum", () => $c9f78399309a8a0d$export$68351c28d7116b56);
$parcel$export($c9f78399309a8a0d$exports, "SparseToDense", () => $c9f78399309a8a0d$export$2c426709a9332421);
$parcel$export($c9f78399309a8a0d$exports, "SquaredDifference", () => $c9f78399309a8a0d$export$2f922d20d66089c6);
$parcel$export($c9f78399309a8a0d$exports, "Square", () => $c9f78399309a8a0d$export$b09fb900337259de);
$parcel$export($c9f78399309a8a0d$exports, "StaticRegexReplace", () => $c9f78399309a8a0d$export$2fbaa77553edaeff);
$parcel$export($c9f78399309a8a0d$exports, "StridedSlice", () => $c9f78399309a8a0d$export$60c7f9ac271417a9);
$parcel$export($c9f78399309a8a0d$exports, "StringNGrams", () => $c9f78399309a8a0d$export$11a7f4af7d96ad41);
$parcel$export($c9f78399309a8a0d$exports, "StringSplit", () => $c9f78399309a8a0d$export$7e266f7223b9d396);
$parcel$export($c9f78399309a8a0d$exports, "StringToHashBucketFast", () => $c9f78399309a8a0d$export$a5639899909bc8ae);
$parcel$export($c9f78399309a8a0d$exports, "Sub", () => $c9f78399309a8a0d$export$d7a01e11500dfb6f);
$parcel$export($c9f78399309a8a0d$exports, "Tan", () => $c9f78399309a8a0d$export$115b2d5263ba5985);
$parcel$export($c9f78399309a8a0d$exports, "Tanh", () => $c9f78399309a8a0d$export$893b6e865e352c83);
$parcel$export($c9f78399309a8a0d$exports, "Tile", () => $c9f78399309a8a0d$export$235cb65c20ad2b7);
$parcel$export($c9f78399309a8a0d$exports, "TopK", () => $c9f78399309a8a0d$export$c593cd1ea0d02ebd);
$parcel$export($c9f78399309a8a0d$exports, "Transform", () => $c9f78399309a8a0d$export$563a914cafbdc389);
$parcel$export($c9f78399309a8a0d$exports, "Transpose", () => $c9f78399309a8a0d$export$7e714455f9a1f8f7);
$parcel$export($c9f78399309a8a0d$exports, "Unique", () => $c9f78399309a8a0d$export$8e3adf126971a183);
$parcel$export($c9f78399309a8a0d$exports, "Unpack", () => $c9f78399309a8a0d$export$441ad6bfc5db8ab4);
$parcel$export($c9f78399309a8a0d$exports, "UnsortedSegmentSum", () => $c9f78399309a8a0d$export$af810663cded5fe2);
$parcel$export($c9f78399309a8a0d$exports, "UpperBound", () => $c9f78399309a8a0d$export$7dc194c8da2f9058);
$parcel$export($c9f78399309a8a0d$exports, "ZerosLike", () => $c9f78399309a8a0d$export$430969a37eda1e88);
$parcel$export($c9f78399309a8a0d$exports, "Step", () => $c9f78399309a8a0d$export$fd55ce593607084a);
$parcel$export($c9f78399309a8a0d$exports, "FromPixels", () => $c9f78399309a8a0d$export$d0eb4e7054966c48);
$parcel$export($c9f78399309a8a0d$exports, "RotateWithOffset", () => $c9f78399309a8a0d$export$c5a44649815d1c3);
$parcel$export($c9f78399309a8a0d$exports, "_FusedMatMul", () => $c9f78399309a8a0d$export$8d1af0f7c2a4da9e);
$parcel$export($c9f78399309a8a0d$exports, "FusedConv2D", () => $c9f78399309a8a0d$export$86f8a8e3a8f2a8f2);
$parcel$export($c9f78399309a8a0d$exports, "FusedDepthwiseConv2D", () => $c9f78399309a8a0d$export$5a249e8f498c02c1);
const $c9f78399309a8a0d$export$b73c596ee8758a66 = 'Abs';
const $c9f78399309a8a0d$export$3b952c9980dac550 = 'Acos';
const $c9f78399309a8a0d$export$987da490b7c2e7dd = 'Acosh';
const $c9f78399309a8a0d$export$d0265b2c425512d6 = 'Add';
const $c9f78399309a8a0d$export$eef235ad06d3226a = 'AddN';
const $c9f78399309a8a0d$export$5dceb1ab650a1776 = 'All';
const $c9f78399309a8a0d$export$b24b633b1364b94b = 'Any';
const $c9f78399309a8a0d$export$17612294a1503e1c = 'ArgMax';
const $c9f78399309a8a0d$export$baabd09270cbbd94 = 'ArgMin';
const $c9f78399309a8a0d$export$664c8ca7e7e5c126 = 'Asin';
const $c9f78399309a8a0d$export$847c88940cb7dcb5 = 'Asinh';
const $c9f78399309a8a0d$export$bac667d46ac043ae = 'Atan';
const $c9f78399309a8a0d$export$98981a86fa2b1366 = 'Atanh';
const $c9f78399309a8a0d$export$3bf4c619ce589f4b = 'Atan2';
const $c9f78399309a8a0d$export$37f2cc7be1add88c = 'AvgPool';
const $c9f78399309a8a0d$export$9873fd6046cd6951 = 'AvgPoolGrad';
const $c9f78399309a8a0d$export$390ecb697af103f6 = 'AvgPool3D';
const $c9f78399309a8a0d$export$7163112adf28c062 = 'AvgPool3DGrad';
const $c9f78399309a8a0d$export$9a3bf60b23f63c8 = 'BatchMatMul';
const $c9f78399309a8a0d$export$e2743f47f61cca1f = 'BatchToSpaceND';
const $c9f78399309a8a0d$export$45dfbbff595c32aa = 'Bincount';
const $c9f78399309a8a0d$export$a9e259e32a62221f = 'BitwiseAnd';
const $c9f78399309a8a0d$export$ea5eeb875a7c4dd1 = 'BroadcastTo';
const $c9f78399309a8a0d$export$32877b1d6d497805 = 'BroadcastArgs';
const $c9f78399309a8a0d$export$107ecfb3d1ccbd77 = 'Cast';
const $c9f78399309a8a0d$export$d4a1bccfd52ebd3 = 'Ceil';
const $c9f78399309a8a0d$export$611c0e357ac37f7d = 'ClipByValue';
const $c9f78399309a8a0d$export$50ceb3fb9926e63e = 'Complex';
const $c9f78399309a8a0d$export$32902e58f1b48f4b = 'ComplexAbs';
const $c9f78399309a8a0d$export$936bbfc007425eea = 'Concat';
const $c9f78399309a8a0d$export$57742e605d475795 = 'Conv2D';
const $c9f78399309a8a0d$export$32a8943c0f1ca5a7 = 'Conv2DBackpropFilter';
const $c9f78399309a8a0d$export$e26961e8ed0eb404 = 'Conv2DBackpropInput';
const $c9f78399309a8a0d$export$9d3874201dd21933 = 'Conv3D';
const $c9f78399309a8a0d$export$dd2885efe6043eee = 'Conv3DBackpropFilterV2';
const $c9f78399309a8a0d$export$a54f552d6d7d521f = 'Conv3DBackpropInputV2';
const $c9f78399309a8a0d$export$ddfd0a983d257666 = 'Cos';
const $c9f78399309a8a0d$export$5e311a1c57b0d27c = 'Cosh';
const $c9f78399309a8a0d$export$e581acc6014c47a = 'Cumprod';
const $c9f78399309a8a0d$export$706617d894ad63da = 'Cumsum';
const $c9f78399309a8a0d$export$50bc9557793c2e04 = 'CropAndResize';
const $c9f78399309a8a0d$export$5bab6834954299c5 = 'DenseBincount';
const $c9f78399309a8a0d$export$fb0ee52d0cd6f233 = 'DepthToSpace';
const $c9f78399309a8a0d$export$7c0fc590ff9e156f = 'DepthwiseConv2dNative';
const $c9f78399309a8a0d$export$c99f139e0d4d1833 = 'DepthwiseConv2dNativeBackpropFilter';
const $c9f78399309a8a0d$export$8649ca3b17033a24 = 'DepthwiseConv2dNativeBackpropInput';
const $c9f78399309a8a0d$export$ca73a25315ddeb7f = 'Diag';
const $c9f78399309a8a0d$export$dbbb7830c6497701 = 'Dilation2D';
const $c9f78399309a8a0d$export$5dd675a6b0f37e17 = 'Dilation2DBackpropInput';
const $c9f78399309a8a0d$export$91add972be69d592 = 'Dilation2DBackpropFilter';
const $c9f78399309a8a0d$export$dca20402ebea5ece = 'Draw';
const $c9f78399309a8a0d$export$b9880b86e1014bb8 = 'RealDiv';
const $c9f78399309a8a0d$export$2541d8be32f3c641 = 'Einsum';
const $c9f78399309a8a0d$export$64636e173424d83d = 'Elu';
const $c9f78399309a8a0d$export$9906be4699a73c53 = 'EluGrad';
const $c9f78399309a8a0d$export$c2ee2551ce71f1d0 = 'Erf';
const $c9f78399309a8a0d$export$8dcf9f58ce5cdfc = 'Equal';
const $c9f78399309a8a0d$export$f908be7a96fb3363 = 'Exp';
const $c9f78399309a8a0d$export$2391750b1d901146 = 'ExpandDims';
const $c9f78399309a8a0d$export$261f26143a1ff3 = 'Expm1';
const $c9f78399309a8a0d$export$677347237c014ba = 'FFT';
const $c9f78399309a8a0d$export$ffffe40bfa0649a3 = 'Fill';
const $c9f78399309a8a0d$export$34e7296fc8558df5 = 'FlipLeftRight';
const $c9f78399309a8a0d$export$4880b0ae5643c62b = 'Floor';
const $c9f78399309a8a0d$export$d79b5692ede26c2f = 'FloorDiv';
const $c9f78399309a8a0d$export$3821a0416660aaa2 = 'FusedBatchNorm';
const $c9f78399309a8a0d$export$ccd988942e5c0181 = 'GatherV2';
const $c9f78399309a8a0d$export$4ef6e37a23721703 = 'GatherNd';
const $c9f78399309a8a0d$export$d0a25eac5ee3f515 = 'Greater';
const $c9f78399309a8a0d$export$3b7d21bc9aee0851 = 'GreaterEqual';
const $c9f78399309a8a0d$export$544bf02140fa9a77 = 'Identity';
const $c9f78399309a8a0d$export$21c6f576ae8100e8 = 'IFFT';
const $c9f78399309a8a0d$export$303b4473993a24f = 'Imag';
const $c9f78399309a8a0d$export$b9fcc0946d7d485e = 'IsFinite';
const $c9f78399309a8a0d$export$74b5a3bc735b152 = 'IsInf';
const $c9f78399309a8a0d$export$9912dc4fc649dbec = 'IsNan';
const $c9f78399309a8a0d$export$f0c7162bb7af1a2d = 'LeakyRelu';
const $c9f78399309a8a0d$export$728c50f1c88ac779 = 'Less';
const $c9f78399309a8a0d$export$84afd0d8f7fb8c5d = 'LessEqual';
const $c9f78399309a8a0d$export$34f0ab8eba543ee6 = 'LinSpace';
const $c9f78399309a8a0d$export$ce30dbb46644d06c = 'Log';
const $c9f78399309a8a0d$export$70f05bf9ddcfca68 = 'Log1p';
const $c9f78399309a8a0d$export$8a27ff10dff4d6e5 = 'LogicalAnd';
const $c9f78399309a8a0d$export$4393bee5596c68c2 = 'LogicalNot';
const $c9f78399309a8a0d$export$c49f9f5ffc6f678c = 'LogicalOr';
const $c9f78399309a8a0d$export$656629b293485eff = 'LogicalXor';
const $c9f78399309a8a0d$export$85b5bcbd60848a10 = 'LogSoftmax';
const $c9f78399309a8a0d$export$9ec35fe80d53e931 = 'LowerBound';
const $c9f78399309a8a0d$export$eb2f713fc3e1ca9a = 'LRN';
const $c9f78399309a8a0d$export$73ba43cd0ce95b10 = 'LRNGrad';
const $c9f78399309a8a0d$export$b4571177c51d555b = 'MatrixBandPart';
const $c9f78399309a8a0d$export$d36c09e5d02927e7 = 'Max';
const $c9f78399309a8a0d$export$d8d02ac92d161004 = 'Maximum';
const $c9f78399309a8a0d$export$39ea33024ddd5cf = 'MaxPool';
const $c9f78399309a8a0d$export$f0f010b1d1db8a46 = 'MaxPoolGrad';
const $c9f78399309a8a0d$export$88fdc64af890fc53 = 'MaxPool3D';
const $c9f78399309a8a0d$export$52be2c00371a1350 = 'MaxPool3DGrad';
const $c9f78399309a8a0d$export$deac4b7497b4047f = 'MaxPoolWithArgmax';
const $c9f78399309a8a0d$export$1c2d59c4b681fbd8 = 'Mean';
const $c9f78399309a8a0d$export$dfed19fabc75a31d = 'Min';
const $c9f78399309a8a0d$export$23cb308301e89d6b = 'Minimum';
const $c9f78399309a8a0d$export$f4c0e95fd7fd31e5 = 'MirrorPad';
const $c9f78399309a8a0d$export$e4835a5e3f3674d5 = 'Mod';
const $c9f78399309a8a0d$export$ee0a8cfb693e0e3f = 'Multinomial';
const $c9f78399309a8a0d$export$f14f83b3b531d498 = 'Multiply';
const $c9f78399309a8a0d$export$c07c549000872073 = 'Neg';
const $c9f78399309a8a0d$export$385ebe9945cae0c5 = 'NotEqual';
const $c9f78399309a8a0d$export$5e11788439c2f04 = 'NonMaxSuppressionV3';
const $c9f78399309a8a0d$export$7df908154366fe7f = 'NonMaxSuppressionV4';
const $c9f78399309a8a0d$export$cb45d3fcefce2ef0 = 'NonMaxSuppressionV5';
const $c9f78399309a8a0d$export$a2962e735c809d91 = 'OnesLike';
const $c9f78399309a8a0d$export$18982b43ba8c02e9 = 'OneHot';
const $c9f78399309a8a0d$export$c26f40b29201e5b7 = 'Pack';
const $c9f78399309a8a0d$export$5d47ba206577f0f2 = 'PadV2';
const $c9f78399309a8a0d$export$14963ee5c8637e11 = 'Pool';
const $c9f78399309a8a0d$export$ce28d653ec559ee = 'Pow';
const $c9f78399309a8a0d$export$a42f35f308fc2fa3 = 'Prelu';
const $c9f78399309a8a0d$export$b8a16d526a791fb0 = 'Prod';
const $c9f78399309a8a0d$export$ffee9c5b4fce08a1 = 'RaggedGather';
const $c9f78399309a8a0d$export$9d0615a9a6d213d2 = 'RaggedRange';
const $c9f78399309a8a0d$export$616d73a9ab7617c7 = 'RaggedTensorToTensor';
const $c9f78399309a8a0d$export$9a58ef0d7ad3278c = 'Range';
const $c9f78399309a8a0d$export$f41305719b94e675 = 'Real';
const $c9f78399309a8a0d$export$c6e4a23ed5e0415b = 'Reciprocal';
const $c9f78399309a8a0d$export$9a6ff968bf961432 = 'Relu';
const $c9f78399309a8a0d$export$755ddd847e5abe03 = 'Reshape';
const $c9f78399309a8a0d$export$6c8d8ec26192bb18 = 'ResizeNearestNeighbor';
const $c9f78399309a8a0d$export$b84ac31c55aa023b = 'ResizeNearestNeighborGrad';
const $c9f78399309a8a0d$export$24f2f15d869e0fd = 'ResizeBilinear';
const $c9f78399309a8a0d$export$2d3cf759f1538c13 = 'ResizeBilinearGrad';
const $c9f78399309a8a0d$export$3be9e924f629054e = 'Relu6';
const $c9f78399309a8a0d$export$53c81f36b32e1bba = 'Reverse';
const $c9f78399309a8a0d$export$c5ed3eef16c0612f = 'Round';
const $c9f78399309a8a0d$export$7cc53aa09f5f3a2d = 'Rsqrt';
const $c9f78399309a8a0d$export$28eef6f0168af686 = 'ScatterNd';
const $c9f78399309a8a0d$export$20050a140fd1de77 = 'TensorScatterUpdate';
const $c9f78399309a8a0d$export$9a1405490b09867e = 'SearchSorted';
const $c9f78399309a8a0d$export$ef9b1a59e592288f = 'Select';
const $c9f78399309a8a0d$export$6760d858e6f2594a = 'Selu';
const $c9f78399309a8a0d$export$b3f2e2de3a8baa1e = 'Slice';
const $c9f78399309a8a0d$export$75be1b631f7687 = 'Sin';
const $c9f78399309a8a0d$export$b8c187376329d79b = 'Sinh';
const $c9f78399309a8a0d$export$1db683ad541682f6 = 'Sign';
const $c9f78399309a8a0d$export$fde18c826dda6b1b = 'Sigmoid';
const $c9f78399309a8a0d$export$c5af433747f1fd0a = 'Softplus';
const $c9f78399309a8a0d$export$21ab404ab9d512a6 = 'Sqrt';
const $c9f78399309a8a0d$export$534760f50726d5 = 'Sum';
const $c9f78399309a8a0d$export$f63ac5409312707c = 'SpaceToBatchND';
const $c9f78399309a8a0d$export$8dffabb4071f05aa = 'SplitV';
const $c9f78399309a8a0d$export$350a526055d3ca6e = 'Softmax';
const $c9f78399309a8a0d$export$8f1933853a5c8cca = 'SparseFillEmptyRows';
const $c9f78399309a8a0d$export$f08f0dca44fa542 = 'SparseReshape';
const $c9f78399309a8a0d$export$610b077aecc2447b = 'SparseSegmentMean';
const $c9f78399309a8a0d$export$68351c28d7116b56 = 'SparseSegmentSum';
const $c9f78399309a8a0d$export$2c426709a9332421 = 'SparseToDense';
const $c9f78399309a8a0d$export$2f922d20d66089c6 = 'SquaredDifference';
const $c9f78399309a8a0d$export$b09fb900337259de = 'Square';
const $c9f78399309a8a0d$export$2fbaa77553edaeff = 'StaticRegexReplace';
const $c9f78399309a8a0d$export$60c7f9ac271417a9 = 'StridedSlice';
const $c9f78399309a8a0d$export$11a7f4af7d96ad41 = 'StringNGrams';
const $c9f78399309a8a0d$export$7e266f7223b9d396 = 'StringSplit';
const $c9f78399309a8a0d$export$a5639899909bc8ae = 'StringToHashBucketFast';
const $c9f78399309a8a0d$export$d7a01e11500dfb6f = 'Sub';
const $c9f78399309a8a0d$export$115b2d5263ba5985 = 'Tan';
const $c9f78399309a8a0d$export$893b6e865e352c83 = 'Tanh';
const $c9f78399309a8a0d$export$235cb65c20ad2b7 = 'Tile';
const $c9f78399309a8a0d$export$c593cd1ea0d02ebd = 'TopK';
const $c9f78399309a8a0d$export$563a914cafbdc389 = 'Transform';
const $c9f78399309a8a0d$export$7e714455f9a1f8f7 = 'Transpose';
const $c9f78399309a8a0d$export$8e3adf126971a183 = 'Unique';
const $c9f78399309a8a0d$export$441ad6bfc5db8ab4 = 'Unpack';
const $c9f78399309a8a0d$export$af810663cded5fe2 = 'UnsortedSegmentSum';
const $c9f78399309a8a0d$export$7dc194c8da2f9058 = 'UpperBound';
const $c9f78399309a8a0d$export$430969a37eda1e88 = 'ZerosLike';
const $c9f78399309a8a0d$export$fd55ce593607084a = 'Step';
const $c9f78399309a8a0d$export$d0eb4e7054966c48 = 'FromPixels';
const $c9f78399309a8a0d$export$c5a44649815d1c3 = 'RotateWithOffset';
const $c9f78399309a8a0d$export$8d1af0f7c2a4da9e = '_FusedMatMul';
const $c9f78399309a8a0d$export$86f8a8e3a8f2a8f2 = 'FusedConv2D';
const $c9f78399309a8a0d$export$5a249e8f498c02c1 = 'FusedDepthwiseConv2D';


var $a6ed5fb1cf7ee2a4$exports = {};

$parcel$export($a6ed5fb1cf7ee2a4$exports, "getKernel", () => $a6ed5fb1cf7ee2a4$export$1b85808c967cc434);
$parcel$export($a6ed5fb1cf7ee2a4$exports, "getGradient", () => $a6ed5fb1cf7ee2a4$export$e14995d3ec1747ee);
$parcel$export($a6ed5fb1cf7ee2a4$exports, "getKernelsForBackend", () => $a6ed5fb1cf7ee2a4$export$e4b8d76e176eaecc);
$parcel$export($a6ed5fb1cf7ee2a4$exports, "registerKernel", () => $a6ed5fb1cf7ee2a4$export$f3f7c443f3a606e6);
$parcel$export($a6ed5fb1cf7ee2a4$exports, "registerGradient", () => $a6ed5fb1cf7ee2a4$export$de9396b872fdfcc3);
$parcel$export($a6ed5fb1cf7ee2a4$exports, "unregisterKernel", () => $a6ed5fb1cf7ee2a4$export$1c3fb41896379a12);
$parcel$export($a6ed5fb1cf7ee2a4$exports, "unregisterGradient", () => $a6ed5fb1cf7ee2a4$export$41b3e24402efeb81);
$parcel$export($a6ed5fb1cf7ee2a4$exports, "copyRegisteredKernels", () => $a6ed5fb1cf7ee2a4$export$fb249e95c44186e6);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

var $8ee8f3c328242644$exports = {};

$parcel$export($8ee8f3c328242644$exports, "warn", () => $8ee8f3c328242644$export$c106dd0671a0fc2d);
$parcel$export($8ee8f3c328242644$exports, "log", () => $8ee8f3c328242644$export$bef1f36f5486a6a3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $8ee8f3c328242644$export$c106dd0671a0fc2d(...msg) {
    if (!((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_TEST') || (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('PROD'))) console.warn(...msg);
}
function $8ee8f3c328242644$export$bef1f36f5486a6a3(...msg) {
    if (!((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_TEST') || (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('PROD'))) console.log(...msg);
}


const $a6ed5fb1cf7ee2a4$var$kernelRegistry = (0, $bf790b47f177f8e9$export$a4e55266d2135a7f)('kernelRegistry', ()=>new Map());
const $a6ed5fb1cf7ee2a4$var$gradRegistry = (0, $bf790b47f177f8e9$export$a4e55266d2135a7f)('gradRegistry', ()=>new Map());
function $a6ed5fb1cf7ee2a4$export$1b85808c967cc434(kernelName, backendName) {
    const key = $a6ed5fb1cf7ee2a4$var$makeKey(kernelName, backendName);
    return $a6ed5fb1cf7ee2a4$var$kernelRegistry.get(key);
}
function $a6ed5fb1cf7ee2a4$export$e14995d3ec1747ee(kernelName) {
    return $a6ed5fb1cf7ee2a4$var$gradRegistry.get(kernelName);
}
function $a6ed5fb1cf7ee2a4$export$e4b8d76e176eaecc(backendName) {
    const it = $a6ed5fb1cf7ee2a4$var$kernelRegistry.entries();
    const result = [];
    while(true){
        const { done: done, value: value } = it.next();
        if (done) break;
        const [key, config] = value;
        const [backend] = key.split('_');
        if (backend === backendName) result.push(config);
    }
    return result;
}
function $a6ed5fb1cf7ee2a4$export$f3f7c443f3a606e6(config) {
    const { kernelName: kernelName, backendName: backendName } = config;
    const key = $a6ed5fb1cf7ee2a4$var$makeKey(kernelName, backendName);
    if ($a6ed5fb1cf7ee2a4$var$kernelRegistry.has(key)) $8ee8f3c328242644$export$c106dd0671a0fc2d(`The kernel '${kernelName}' for backend ` + `'${backendName}' is already registered`);
    $a6ed5fb1cf7ee2a4$var$kernelRegistry.set(key, config);
}
function $a6ed5fb1cf7ee2a4$export$de9396b872fdfcc3(config) {
    const { kernelName: kernelName } = config;
    if ($a6ed5fb1cf7ee2a4$var$gradRegistry.has(kernelName)) // TODO (yassogba) after 3.0 assess whether we need to keep this gated
    // to debug mode.
    {
        if ((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('DEBUG')) $8ee8f3c328242644$export$c106dd0671a0fc2d(`Overriding the gradient for '${kernelName}'`);
    }
    $a6ed5fb1cf7ee2a4$var$gradRegistry.set(kernelName, config);
}
function $a6ed5fb1cf7ee2a4$export$1c3fb41896379a12(kernelName, backendName) {
    const key = $a6ed5fb1cf7ee2a4$var$makeKey(kernelName, backendName);
    if (!$a6ed5fb1cf7ee2a4$var$kernelRegistry.has(key)) throw new Error(`The kernel '${kernelName}' for backend ` + `'${backendName}' is not registered`);
    $a6ed5fb1cf7ee2a4$var$kernelRegistry.delete(key);
}
function $a6ed5fb1cf7ee2a4$export$41b3e24402efeb81(kernelName) {
    if (!$a6ed5fb1cf7ee2a4$var$gradRegistry.has(kernelName)) throw new Error(`The gradient '${kernelName}' for backend is not registered`);
    $a6ed5fb1cf7ee2a4$var$gradRegistry.delete(kernelName);
}
function $a6ed5fb1cf7ee2a4$export$fb249e95c44186e6(registeredBackendName, newBackendName) {
    const kernels = $a6ed5fb1cf7ee2a4$export$e4b8d76e176eaecc(registeredBackendName);
    kernels.forEach((kernelConfig)=>{
        const newKernelConfig = Object.assign({}, kernelConfig, {
            backendName: newBackendName
        });
        $a6ed5fb1cf7ee2a4$export$f3f7c443f3a606e6(newKernelConfig);
    });
}
function $a6ed5fb1cf7ee2a4$var$makeKey(kernelName, backendName) {
    return `${backendName}_${kernelName}`;
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e10678764dab7ea0$exports = {};

$parcel$export($e10678764dab7ea0$exports, "createScalarValue", () => $e10678764dab7ea0$export$cd3f28d8002ec2a2);
$parcel$export($e10678764dab7ea0$exports, "encodeString", () => $e10678764dab7ea0$export$8146d2e653b87d6a);
$parcel$export($e10678764dab7ea0$exports, "toTypedArray", () => $e10678764dab7ea0$export$965adc581230795c);
$parcel$export($e10678764dab7ea0$exports, "flatten", () => $e10678764dab7ea0$export$bffa455ba8c619a6);
$parcel$export($e10678764dab7ea0$exports, "now", () => $e10678764dab7ea0$export$461939dd4422153);
$parcel$export($e10678764dab7ea0$exports, "fetch", () => $e10678764dab7ea0$export$e7aa7bc5c1b3cfb3);
$parcel$export($e10678764dab7ea0$exports, "decodeString", () => $e10678764dab7ea0$export$a0fb664af7d0cc44);
$parcel$export($e10678764dab7ea0$exports, "isTypedArray", () => $e10678764dab7ea0$export$b119cc7e1840e59c);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $4ecc12e21462e25f$export$632e6430b2d784cd(a) {
    return a instanceof Float32Array || a instanceof Int32Array || a instanceof Uint8Array || a instanceof Uint8ClampedArray;
}



var $9fb60678e6950826$exports = {};

$parcel$export($9fb60678e6950826$exports, "hexToLong", () => $9fb60678e6950826$export$20e49d17901a85a5);
$parcel$export($9fb60678e6950826$exports, "fingerPrint64", () => $9fb60678e6950826$export$919ee948dc019032);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for allowing cjs module to be included in bundle created by
// rollup.
var $db6a881889ec5536$exports = {};
$db6a881889ec5536$exports = $db6a881889ec5536$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $db6a881889ec5536$var$wasm = null;
try {
    $db6a881889ec5536$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $db6a881889ec5536$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $db6a881889ec5536$var$Long.prototype.__isLong__;
Object.defineProperty($db6a881889ec5536$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $db6a881889ec5536$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $db6a881889ec5536$var$Long.isLong = $db6a881889ec5536$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $db6a881889ec5536$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $db6a881889ec5536$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $db6a881889ec5536$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $db6a881889ec5536$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $db6a881889ec5536$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $db6a881889ec5536$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $db6a881889ec5536$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $db6a881889ec5536$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromInt = $db6a881889ec5536$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $db6a881889ec5536$var$UZERO : $db6a881889ec5536$var$ZERO;
    if (unsigned) {
        if (value < 0) return $db6a881889ec5536$var$UZERO;
        if (value >= $db6a881889ec5536$var$TWO_PWR_64_DBL) return $db6a881889ec5536$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$db6a881889ec5536$var$TWO_PWR_63_DBL) return $db6a881889ec5536$var$MIN_VALUE;
        if (value + 1 >= $db6a881889ec5536$var$TWO_PWR_63_DBL) return $db6a881889ec5536$var$MAX_VALUE;
    }
    if (value < 0) return $db6a881889ec5536$var$fromNumber(-value, unsigned).neg();
    return $db6a881889ec5536$var$fromBits(value % $db6a881889ec5536$var$TWO_PWR_32_DBL | 0, value / $db6a881889ec5536$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromNumber = $db6a881889ec5536$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromBits(lowBits, highBits, unsigned) {
    return new $db6a881889ec5536$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromBits = $db6a881889ec5536$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $db6a881889ec5536$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $db6a881889ec5536$var$ZERO;
    if (typeof unsigned === 'number') // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    var p;
    if ((p = str.indexOf('-')) > 0) throw Error('interior hyphen');
    else if (p === 0) return $db6a881889ec5536$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $db6a881889ec5536$var$fromNumber($db6a881889ec5536$var$pow_dbl(radix, 8));
    var result = $db6a881889ec5536$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $db6a881889ec5536$var$fromNumber($db6a881889ec5536$var$pow_dbl(radix, size));
            result = result.mul(power).add($db6a881889ec5536$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($db6a881889ec5536$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromString = $db6a881889ec5536$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $db6a881889ec5536$var$fromValue(val, unsigned) {
    if (typeof val === 'number') return $db6a881889ec5536$var$fromNumber(val, unsigned);
    if (typeof val === 'string') return $db6a881889ec5536$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $db6a881889ec5536$var$fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $db6a881889ec5536$var$Long.fromValue = $db6a881889ec5536$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_32_DBL = $db6a881889ec5536$var$TWO_PWR_16_DBL * $db6a881889ec5536$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_64_DBL = $db6a881889ec5536$var$TWO_PWR_32_DBL * $db6a881889ec5536$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_63_DBL = $db6a881889ec5536$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $db6a881889ec5536$var$TWO_PWR_24 = $db6a881889ec5536$var$fromInt($db6a881889ec5536$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$ZERO = $db6a881889ec5536$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.ZERO = $db6a881889ec5536$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$UZERO = $db6a881889ec5536$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.UZERO = $db6a881889ec5536$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$ONE = $db6a881889ec5536$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.ONE = $db6a881889ec5536$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$UONE = $db6a881889ec5536$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.UONE = $db6a881889ec5536$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$NEG_ONE = $db6a881889ec5536$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.NEG_ONE = $db6a881889ec5536$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$MAX_VALUE = $db6a881889ec5536$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.MAX_VALUE = $db6a881889ec5536$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$MAX_UNSIGNED_VALUE = $db6a881889ec5536$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.MAX_UNSIGNED_VALUE = $db6a881889ec5536$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $db6a881889ec5536$var$MIN_VALUE = $db6a881889ec5536$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $db6a881889ec5536$var$Long.MIN_VALUE = $db6a881889ec5536$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $db6a881889ec5536$var$LongPrototype = $db6a881889ec5536$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $db6a881889ec5536$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $db6a881889ec5536$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $db6a881889ec5536$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $db6a881889ec5536$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $db6a881889ec5536$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    if (this.isZero()) return '0';
    if (this.isNegative()) {
        if (this.eq($db6a881889ec5536$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $db6a881889ec5536$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return '-' + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $db6a881889ec5536$var$fromNumber($db6a881889ec5536$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = '';
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $db6a881889ec5536$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $db6a881889ec5536$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $db6a881889ec5536$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $db6a881889ec5536$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $db6a881889ec5536$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($db6a881889ec5536$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.eqz = $db6a881889ec5536$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.equals = function equals(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.eq = $db6a881889ec5536$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.neq = $db6a881889ec5536$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.ne = $db6a881889ec5536$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.lt = $db6a881889ec5536$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.lte = $db6a881889ec5536$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.le = $db6a881889ec5536$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.gt = $db6a881889ec5536$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.gte = $db6a881889ec5536$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $db6a881889ec5536$var$LongPrototype.ge = $db6a881889ec5536$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $db6a881889ec5536$var$LongPrototype.compare = function compare(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $db6a881889ec5536$var$LongPrototype.comp = $db6a881889ec5536$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $db6a881889ec5536$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($db6a881889ec5536$var$MIN_VALUE)) return $db6a881889ec5536$var$MIN_VALUE;
    return this.not().add($db6a881889ec5536$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $db6a881889ec5536$var$LongPrototype.neg = $db6a881889ec5536$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $db6a881889ec5536$var$LongPrototype.add = function add(addend) {
    if (!$db6a881889ec5536$var$isLong(addend)) addend = $db6a881889ec5536$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $db6a881889ec5536$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $db6a881889ec5536$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$db6a881889ec5536$var$isLong(subtrahend)) subtrahend = $db6a881889ec5536$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $db6a881889ec5536$var$LongPrototype.sub = $db6a881889ec5536$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $db6a881889ec5536$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $db6a881889ec5536$var$ZERO;
    if (!$db6a881889ec5536$var$isLong(multiplier)) multiplier = $db6a881889ec5536$var$fromValue(multiplier);
    // use wasm support if present
    if ($db6a881889ec5536$var$wasm) {
        var low = $db6a881889ec5536$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $db6a881889ec5536$var$fromBits(low, $db6a881889ec5536$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $db6a881889ec5536$var$ZERO;
    if (this.eq($db6a881889ec5536$var$MIN_VALUE)) return multiplier.isOdd() ? $db6a881889ec5536$var$MIN_VALUE : $db6a881889ec5536$var$ZERO;
    if (multiplier.eq($db6a881889ec5536$var$MIN_VALUE)) return this.isOdd() ? $db6a881889ec5536$var$MIN_VALUE : $db6a881889ec5536$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($db6a881889ec5536$var$TWO_PWR_24) && multiplier.lt($db6a881889ec5536$var$TWO_PWR_24)) return $db6a881889ec5536$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $db6a881889ec5536$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $db6a881889ec5536$var$LongPrototype.mul = $db6a881889ec5536$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $db6a881889ec5536$var$LongPrototype.divide = function divide(divisor) {
    if (!$db6a881889ec5536$var$isLong(divisor)) divisor = $db6a881889ec5536$var$fromValue(divisor);
    if (divisor.isZero()) throw Error('division by zero');
    // use wasm support if present
    if ($db6a881889ec5536$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $db6a881889ec5536$var$wasm.div_u : $db6a881889ec5536$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $db6a881889ec5536$var$fromBits(low, $db6a881889ec5536$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $db6a881889ec5536$var$UZERO : $db6a881889ec5536$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($db6a881889ec5536$var$MIN_VALUE)) {
            if (divisor.eq($db6a881889ec5536$var$ONE) || divisor.eq($db6a881889ec5536$var$NEG_ONE)) return $db6a881889ec5536$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($db6a881889ec5536$var$MIN_VALUE)) return $db6a881889ec5536$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($db6a881889ec5536$var$ZERO)) return divisor.isNegative() ? $db6a881889ec5536$var$ONE : $db6a881889ec5536$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($db6a881889ec5536$var$MIN_VALUE)) return this.unsigned ? $db6a881889ec5536$var$UZERO : $db6a881889ec5536$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $db6a881889ec5536$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $db6a881889ec5536$var$UZERO;
        if (divisor.gt(this.shru(1))) return $db6a881889ec5536$var$UONE;
        res = $db6a881889ec5536$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $db6a881889ec5536$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $db6a881889ec5536$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $db6a881889ec5536$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $db6a881889ec5536$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $db6a881889ec5536$var$LongPrototype.div = $db6a881889ec5536$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $db6a881889ec5536$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$db6a881889ec5536$var$isLong(divisor)) divisor = $db6a881889ec5536$var$fromValue(divisor);
    // use wasm support if present
    if ($db6a881889ec5536$var$wasm) {
        var low = (this.unsigned ? $db6a881889ec5536$var$wasm.rem_u : $db6a881889ec5536$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $db6a881889ec5536$var$fromBits(low, $db6a881889ec5536$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $db6a881889ec5536$var$LongPrototype.mod = $db6a881889ec5536$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $db6a881889ec5536$var$LongPrototype.rem = $db6a881889ec5536$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $db6a881889ec5536$var$LongPrototype.not = function not() {
    return $db6a881889ec5536$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $db6a881889ec5536$var$LongPrototype.and = function and(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    return $db6a881889ec5536$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $db6a881889ec5536$var$LongPrototype.or = function or(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    return $db6a881889ec5536$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $db6a881889ec5536$var$LongPrototype.xor = function xor(other) {
    if (!$db6a881889ec5536$var$isLong(other)) other = $db6a881889ec5536$var$fromValue(other);
    return $db6a881889ec5536$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($db6a881889ec5536$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $db6a881889ec5536$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $db6a881889ec5536$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shl = $db6a881889ec5536$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($db6a881889ec5536$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $db6a881889ec5536$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $db6a881889ec5536$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shr = $db6a881889ec5536$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($db6a881889ec5536$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $db6a881889ec5536$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $db6a881889ec5536$var$fromBits(high, 0, this.unsigned);
        else return $db6a881889ec5536$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shru = $db6a881889ec5536$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $db6a881889ec5536$var$LongPrototype.shr_u = $db6a881889ec5536$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $db6a881889ec5536$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $db6a881889ec5536$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $db6a881889ec5536$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $db6a881889ec5536$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $db6a881889ec5536$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $db6a881889ec5536$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $db6a881889ec5536$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $db6a881889ec5536$var$Long.fromBytesLE(bytes, unsigned) : $db6a881889ec5536$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $db6a881889ec5536$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $db6a881889ec5536$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $db6a881889ec5536$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};


// tslint:disable-next-line
const $9fb60678e6950826$var$Long = // tslint:disable-next-line
$db6a881889ec5536$exports.default || $db6a881889ec5536$exports;
function $9fb60678e6950826$export$20e49d17901a85a5(hex) {
    return $9fb60678e6950826$var$Long.fromString(hex, true, 16);
}
// Some primes between 2^63 and 2^64 for various uses.
// Hex 0xc3a5c85c97cb3127
const $9fb60678e6950826$var$k0 = $9fb60678e6950826$export$20e49d17901a85a5('c3a5c85c97cb3127');
// Hex 0xb492b66fbe98f273
const $9fb60678e6950826$var$k1 = $9fb60678e6950826$export$20e49d17901a85a5('b492b66fbe98f273');
// Hex 0x9ae16a3b2f90404f
const $9fb60678e6950826$var$k2 = $9fb60678e6950826$export$20e49d17901a85a5('9ae16a3b2f90404f');
function $9fb60678e6950826$var$shiftMix(val) {
    return val.xor(val.shru(47));
}
function $9fb60678e6950826$var$fetch(s, offset, numBytes) {
    const bytes = s.slice(offset, offset + numBytes);
    return $9fb60678e6950826$var$Long.fromBytes(Array.from(bytes), true, true);
}
function $9fb60678e6950826$var$fetch64(s, offset) {
    return $9fb60678e6950826$var$fetch(s, offset, 8);
}
function $9fb60678e6950826$var$fetch32(s, offset) {
    return $9fb60678e6950826$var$fetch(s, offset, 4);
}
function $9fb60678e6950826$var$rotate64(val, shift) {
    // Avoid shifting by 64: doing so yields an undefined result.
    return shift === 0 ? val : val.shru(shift).or(val.shl(64 - shift));
}
function $9fb60678e6950826$var$hashLen16(u, v, mul = $9fb60678e6950826$export$20e49d17901a85a5('9ddfea08eb382d69')) {
    // Murmur-inspired hashing.
    let a = u.xor(v).mul(mul);
    a = a.xor(a.shru(47));
    let b = v.xor(a).mul(mul);
    b = b.xor(b.shru(47));
    b = b.mul(mul);
    return b;
}
// Return a 16-byte hash for 48 bytes.  Quick and dirty.
// Callers do best to use "random-looking" values for a and b.
function $9fb60678e6950826$var$weakHashLen32WithSeeds(w, x, y, z, a, b) {
    a = a.add(w);
    b = $9fb60678e6950826$var$rotate64(b.add(a).add(z), 21);
    const c = a;
    a = a.add(x);
    a = a.add(y);
    b = b.add($9fb60678e6950826$var$rotate64(a, 44));
    return [
        a.add(z),
        b.add(c)
    ];
}
function $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset, a, b) {
    return $9fb60678e6950826$var$weakHashLen32WithSeeds($9fb60678e6950826$var$fetch64(s, offset), $9fb60678e6950826$var$fetch64(s, offset + 8), $9fb60678e6950826$var$fetch64(s, offset + 16), $9fb60678e6950826$var$fetch64(s, offset + 24), a, b);
}
function $9fb60678e6950826$var$hashLen0to16(s, len = s.length) {
    if (len >= 8) {
        const mul = $9fb60678e6950826$var$k2.add(len * 2);
        const a = $9fb60678e6950826$var$fetch64(s, 0).add($9fb60678e6950826$var$k2);
        const b = $9fb60678e6950826$var$fetch64(s, len - 8);
        const c = $9fb60678e6950826$var$rotate64(b, 37).mul(mul).add(a);
        const d = $9fb60678e6950826$var$rotate64(a, 25).add(b).mul(mul);
        return $9fb60678e6950826$var$hashLen16(c, d, mul);
    }
    if (len >= 4) {
        const mul = $9fb60678e6950826$var$k2.add(len * 2);
        const a = $9fb60678e6950826$var$fetch32(s, 0);
        return $9fb60678e6950826$var$hashLen16(a.shl(3).add(len), $9fb60678e6950826$var$fetch32(s, len - 4), mul);
    }
    if (len > 0) {
        const a = s[0];
        const b = s[len >> 1];
        const c = s[len - 1];
        const y = a + (b << 8);
        const z = len + (c << 2);
        return $9fb60678e6950826$var$shiftMix($9fb60678e6950826$var$k2.mul(y).xor($9fb60678e6950826$var$k0.mul(z))).mul($9fb60678e6950826$var$k2);
    }
    return $9fb60678e6950826$var$k2;
}
function $9fb60678e6950826$var$hashLen17to32(s, len = s.length) {
    const mul = $9fb60678e6950826$var$k2.add(len * 2);
    const a = $9fb60678e6950826$var$fetch64(s, 0).mul($9fb60678e6950826$var$k1);
    const b = $9fb60678e6950826$var$fetch64(s, 8);
    const c = $9fb60678e6950826$var$fetch64(s, len - 8).mul(mul);
    const d = $9fb60678e6950826$var$fetch64(s, len - 16).mul($9fb60678e6950826$var$k2);
    return $9fb60678e6950826$var$hashLen16($9fb60678e6950826$var$rotate64(a.add(b), 43).add($9fb60678e6950826$var$rotate64(c, 30)).add(d), a.add($9fb60678e6950826$var$rotate64(b.add($9fb60678e6950826$var$k2), 18)).add(c), mul);
}
function $9fb60678e6950826$var$hashLen33to64(s, len = s.length) {
    const mul = $9fb60678e6950826$var$k2.add(len * 2);
    const a = $9fb60678e6950826$var$fetch64(s, 0).mul($9fb60678e6950826$var$k2);
    const b = $9fb60678e6950826$var$fetch64(s, 8);
    const c = $9fb60678e6950826$var$fetch64(s, len - 8).mul(mul);
    const d = $9fb60678e6950826$var$fetch64(s, len - 16).mul($9fb60678e6950826$var$k2);
    const y = $9fb60678e6950826$var$rotate64(a.add(b), 43).add($9fb60678e6950826$var$rotate64(c, 30)).add(d);
    const z = $9fb60678e6950826$var$hashLen16(y, a.add($9fb60678e6950826$var$rotate64(b.add($9fb60678e6950826$var$k2), 18)).add(c), mul);
    const e = $9fb60678e6950826$var$fetch64(s, 16).mul(mul);
    const f = $9fb60678e6950826$var$fetch64(s, 24);
    const g = y.add($9fb60678e6950826$var$fetch64(s, len - 32)).mul(mul);
    const h = z.add($9fb60678e6950826$var$fetch64(s, len - 24)).mul(mul);
    return $9fb60678e6950826$var$hashLen16($9fb60678e6950826$var$rotate64(e.add(f), 43).add($9fb60678e6950826$var$rotate64(g, 30)).add(h), e.add($9fb60678e6950826$var$rotate64(f.add(a), 18)).add(g), mul);
}
function $9fb60678e6950826$export$919ee948dc019032(s, len = s.length) {
    const seed = $9fb60678e6950826$var$Long.fromNumber(81, true);
    if (len <= 32) {
        if (len <= 16) return $9fb60678e6950826$var$hashLen0to16(s, len);
        else return $9fb60678e6950826$var$hashLen17to32(s, len);
    } else if (len <= 64) return $9fb60678e6950826$var$hashLen33to64(s, len);
    // For strings over 64 bytes we loop.  Internal state consists of
    // 56 bytes: v, w, x, y, and z.
    let x = seed;
    let y = seed.mul($9fb60678e6950826$var$k1).add(113);
    let z = $9fb60678e6950826$var$shiftMix(y.mul($9fb60678e6950826$var$k2).add(113)).mul($9fb60678e6950826$var$k2);
    let v = [
        $9fb60678e6950826$var$Long.UZERO,
        $9fb60678e6950826$var$Long.UZERO
    ];
    let w = [
        $9fb60678e6950826$var$Long.UZERO,
        $9fb60678e6950826$var$Long.UZERO
    ];
    x = x.mul($9fb60678e6950826$var$k2).add($9fb60678e6950826$var$fetch64(s, 0));
    let offset = 0;
    // Set end so that after the loop we have 1 to 64 bytes left to process.
    const end = (len - 1 >> 6) * 64;
    const last64 = end + (len - 1 & 63) - 63;
    do {
        x = $9fb60678e6950826$var$rotate64(x.add(y).add(v[0]).add($9fb60678e6950826$var$fetch64(s, offset + 8)), 37).mul($9fb60678e6950826$var$k1);
        y = $9fb60678e6950826$var$rotate64(y.add(v[1]).add($9fb60678e6950826$var$fetch64(s, offset + 48)), 42).mul($9fb60678e6950826$var$k1);
        x = x.xor(w[1]);
        y = y.add(v[0]).add($9fb60678e6950826$var$fetch64(s, offset + 40));
        z = $9fb60678e6950826$var$rotate64(z.add(w[0]), 33).mul($9fb60678e6950826$var$k1);
        v = $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul($9fb60678e6950826$var$k1), x.add(w[0]));
        w = $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($9fb60678e6950826$var$fetch64(s, offset + 16)));
        [z, x] = [
            x,
            z
        ];
        offset += 64;
    }while (offset !== end);
    const mul = $9fb60678e6950826$var$k1.add(z.and(0xff).shl(1));
    // Point to the last 64 bytes of input.
    offset = last64;
    w[0] = w[0].add(len - 1 & 63);
    v[0] = v[0].add(w[0]);
    w[0] = w[0].add(v[0]);
    x = $9fb60678e6950826$var$rotate64(x.add(y).add(v[0]).add($9fb60678e6950826$var$fetch64(s, offset + 8)), 37).mul(mul);
    y = $9fb60678e6950826$var$rotate64(y.add(v[1]).add($9fb60678e6950826$var$fetch64(s, offset + 48)), 42).mul(mul);
    x = x.xor(w[1].mul(9));
    y = y.add(v[0].mul(9).add($9fb60678e6950826$var$fetch64(s, offset + 40)));
    z = $9fb60678e6950826$var$rotate64(z.add(w[0]), 33).mul(mul);
    v = $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul(mul), x.add(w[0]));
    w = $9fb60678e6950826$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($9fb60678e6950826$var$fetch64(s, offset + 16)));
    [z, x] = [
        x,
        z
    ];
    return $9fb60678e6950826$var$hashLen16($9fb60678e6950826$var$hashLen16(v[0], w[0], mul).add($9fb60678e6950826$var$shiftMix(y).mul($9fb60678e6950826$var$k0)).add(z), $9fb60678e6950826$var$hashLen16(v[1], w[1], mul).add(x), mul);
}


function $e10678764dab7ea0$export$cd3f28d8002ec2a2(value, dtype) {
    if (dtype === 'string') return $e10678764dab7ea0$export$8146d2e653b87d6a(value);
    return $e10678764dab7ea0$export$965adc581230795c([
        value
    ], dtype);
}
function $e10678764dab7ea0$var$noConversionNeeded(a, dtype) {
    return a instanceof Float32Array && dtype === 'float32' || a instanceof Int32Array && dtype === 'int32' || a instanceof Uint8Array && dtype === 'bool';
}
function $e10678764dab7ea0$export$965adc581230795c(a, dtype) {
    if (dtype === 'string') throw new Error('Cannot convert a string[] to a TypedArray');
    if (Array.isArray(a)) a = $e10678764dab7ea0$export$bffa455ba8c619a6(a);
    if ((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('DEBUG')) $5f8d0ee7a8d35dfe$export$579cf7b8ff0a87a3(a, dtype);
    if ($e10678764dab7ea0$var$noConversionNeeded(a, dtype)) return a;
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(a);
    else if (dtype === 'int32') return new Int32Array(a);
    else if (dtype === 'bool') {
        const bool = new Uint8Array(a.length);
        for(let i = 0; i < bool.length; ++i)if (Math.round(a[i]) !== 0) bool[i] = 1;
        return bool;
    } else throw new Error(`Unknown data type ${dtype}`);
}
function $e10678764dab7ea0$export$461939dd4422153() {
    return (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().platform.now();
}
function $e10678764dab7ea0$export$e7aa7bc5c1b3cfb3(path, requestInits) {
    return (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().platform.fetch(path, requestInits);
}
function $e10678764dab7ea0$export$8146d2e653b87d6a(s, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().platform.encode(s, encoding);
}
function $e10678764dab7ea0$export$a0fb664af7d0cc44(bytes, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().platform.decode(bytes, encoding);
}
function $e10678764dab7ea0$export$b119cc7e1840e59c(a) {
    // TODO(mattsoulanille): Remove this fallback in 5.0.0
    if ((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().platform.isTypedArray != null) return (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().platform.isTypedArray(a);
    else return (0, $4ecc12e21462e25f$export$632e6430b2d784cd)(a);
}
function $e10678764dab7ea0$export$bffa455ba8c619a6(arr, result = [], skipTypedArray = false) {
    if (result == null) result = [];
    if (typeof arr === 'boolean' || typeof arr === 'number' || typeof arr === 'string' || $5f8d0ee7a8d35dfe$export$4369c812aac99591(arr) || arr == null || $e10678764dab7ea0$export$b119cc7e1840e59c(arr) && skipTypedArray) result.push(arr);
    else if (Array.isArray(arr) || $e10678764dab7ea0$export$b119cc7e1840e59c(arr)) for(let i = 0; i < arr.length; ++i)$e10678764dab7ea0$export$bffa455ba8c619a6(arr[i], result, skipTypedArray);
    else {
        let maxIndex = -1;
        for (const key of Object.keys(arr))// 0 or positive integer.
        if (/^([1-9]+[0-9]*|0)$/.test(key)) maxIndex = Math.max(maxIndex, Number(key));
        for(let i = 0; i <= maxIndex; i++)// tslint:disable-next-line: no-unnecessary-type-assertion
        $e10678764dab7ea0$export$bffa455ba8c619a6(arr[i], result, skipTypedArray);
    }
    return result;
}
$parcel$exportWildcard($e10678764dab7ea0$exports, $5f8d0ee7a8d35dfe$exports);
$parcel$exportWildcard($e10678764dab7ea0$exports, $9fb60678e6950826$exports);


class $6857a2d26887063c$export$e2c29f18771995cb {
    constructor(backendTimer, logger){
        this.backendTimer = backendTimer;
        this.logger = logger;
        if (logger == null) this.logger = new $6857a2d26887063c$export$efa9a398d6368992();
    }
    profileKernel(kernelName, inputs, f) {
        let outputs;
        const holdResultWrapperFn = ()=>{
            outputs = f();
        };
        let timer;
        const start = $e10678764dab7ea0$export$461939dd4422153();
        if (this.backendTimer.timerAvailable()) timer = this.backendTimer.time(holdResultWrapperFn);
        else {
            holdResultWrapperFn();
            for (const output of outputs)output.dataSync();
            timer = Promise.resolve({
                kernelMs: $e10678764dab7ea0$export$461939dd4422153() - start
            });
        }
        if ((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('CHECK_COMPUTATION_FOR_ERRORS')) for(let i = 0; i < outputs.length; i++){
            const output = outputs[i];
            // Dangling promise here because we don't want to propagate up
            // asynchronicity.
            output.data().then((tensorVals)=>{
                $6857a2d26887063c$export$7f6e9a47e989eedc(tensorVals, output.dtype, kernelName);
            });
        }
        const kernelProfile = {
            kernelName: kernelName,
            outputs: outputs,
            inputs: inputs,
            timeMs: timer.then((timing)=>timing.kernelMs),
            extraInfo: timer.then((timing)=>timing.getExtraProfileInfo != null ? timing.getExtraProfileInfo() : '')
        };
        return kernelProfile;
    }
    logKernelProfile(kernelProfile) {
        const { kernelName: kernelName, outputs: outputs, timeMs: timeMs, inputs: inputs, extraInfo: extraInfo } = kernelProfile;
        outputs.forEach((result)=>{
            Promise.all([
                result.data(),
                timeMs,
                extraInfo
            ]).then((valueContainer)=>{
                this.logger.logKernelProfile(kernelName, result, valueContainer[0], valueContainer[1], inputs, valueContainer[2]);
            });
        });
    }
}
function $6857a2d26887063c$export$7f6e9a47e989eedc(vals, dtype, kernelName) {
    if (dtype !== 'float32') // Only floating point computations will generate NaN values
    return false;
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) {
            // Throwing custom exception so behavior is testable.
            console.warn(`Found ${num} in the result of '${kernelName}'`);
            return true;
        }
    }
    return false;
}
class $6857a2d26887063c$export$efa9a398d6368992 {
    logKernelProfile(name, result, vals, timeMs, inputs, extraInfo) {
        const time = typeof timeMs === 'number' ? $5f8d0ee7a8d35dfe$export$390245bab32fb60f(`${timeMs}ms`, 9) : timeMs['error'];
        const paddedName = $5f8d0ee7a8d35dfe$export$390245bab32fb60f(name, 25);
        const rank = result.rank;
        const size = result.size;
        const shape = $5f8d0ee7a8d35dfe$export$390245bab32fb60f(result.shape.toString(), 14);
        let inputShapesDescription = '';
        for(const name in inputs){
            const input = inputs[name];
            if (input != null) {
                // The input might be a non-tensor (e.g HTMLImageElement), in which case
                // we claim the output shape as input shape.
                const inputShape = input.shape || result.shape;
                const inputRank = inputShape.length;
                inputShapesDescription += `${name}: ${inputRank}D ${inputRank > 0 ? inputShape : ''} `;
            }
        }
        console.log(`%c${paddedName}\t%c${time}\t%c${rank}D ${shape}\t%c${size}\t%c${inputShapesDescription}\t%c${extraInfo}`, 'font-weight:bold', 'color:red', 'color:blue', 'color: orange', 'color: green', 'color: steelblue');
    }
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $63dff6d774c8eeaf$export$13eebbb952f0db02(tape, xs, y) {
    // Forward pass to compute all the nodes and Tensors that are transitively a
    // function of x.
    const tensorsFromX = {};
    const nodesFromX = {};
    for(let i = 0; i < xs.length; i++)tensorsFromX[xs[i].id] = true;
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        const nodeInputs = node.inputs;
        for(const inputName in nodeInputs){
            const input = nodeInputs[inputName];
            let anyInputFromX = false;
            for(let j = 0; j < xs.length; j++)if (tensorsFromX[input.id]) {
                node.outputs.forEach((output)=>tensorsFromX[output.id] = true);
                anyInputFromX = true;
                nodesFromX[node.id] = true;
                break;
            }
            if (anyInputFromX) break;
        }
    }
    // Backward pass to find all of the nodes and Tensors that lead to y.
    const tensorsLeadToY = {};
    tensorsLeadToY[y.id] = true;
    const nodesToY = {};
    for(let i = tape.length - 1; i >= 0; i--){
        const node = tape[i];
        const nodeInputs = node.inputs;
        // If any of the outputs lead to y, mark all of the inputs as leading to y.
        for(let j = 0; j < node.outputs.length; j++)if (tensorsLeadToY[node.outputs[j].id]) {
            for(const inputName in nodeInputs){
                tensorsLeadToY[nodeInputs[inputName].id] = true;
                nodesToY[node.id] = true;
            }
            break;
        }
    }
    // Return the paths that come from x and lead to y.
    const filteredTape = [];
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        if (nodesFromX[node.id] && nodesToY[node.id]) {
            // Prune the inputs from the node that aren't a function of x.
            const prunedInputs = {};
            for(const inputName in node.inputs){
                const nodeInput = node.inputs[inputName];
                if (tensorsFromX[nodeInput.id]) prunedInputs[inputName] = nodeInput;
            }
            // Copy the node and overwrite inputsAndArgs to the pruned version.
            const prunedNode = Object.assign({}, node);
            prunedNode.inputs = prunedInputs;
            prunedNode.outputs = node.outputs;
            filteredTape.push(prunedNode);
        }
    }
    return filteredTape;
}
function $63dff6d774c8eeaf$export$2992958ba0a8790d(tensorAccumulatedGradientMap, filteredTape, tidy, add) {
    // Walk the tape backward and keep a map of Tensor to its gradient.
    for(let i = filteredTape.length - 1; i >= 0; i--){
        const node = filteredTape[i];
        const dys = [];
        node.outputs.forEach((o)=>{
            const gradTensor = tensorAccumulatedGradientMap[o.id];
            if (gradTensor != null) dys.push(gradTensor);
            else // This particular output is not in the back-propagation subgraph, so it
            // does not affect the final output, thus we put null for its dy.
            dys.push(null);
        });
        if (node.gradient == null) throw new Error(`Cannot compute gradient: gradient function not found ` + `for ${node.kernelName}.`);
        // Backprop dy through this node and accumulate gradients over the inputs.
        const inputGradients = node.gradient(dys);
        for(const inputName in node.inputs){
            if (!(inputName in inputGradients)) throw new Error(`Cannot backprop through input ${inputName}. ` + `Available gradients found: ${Object.keys(inputGradients)}.`);
            // Call the gradient function.
            const dx = tidy(()=>inputGradients[inputName]());
            if (dx.dtype !== 'float32') throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `${inputName} must have 'float32' dtype, but has '${dx.dtype}'`);
            const x = node.inputs[inputName];
            if (!$5f8d0ee7a8d35dfe$export$234180f8206db11b(dx.shape, x.shape)) throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `'${inputName}' has shape '${dx.shape}', which does not match ` + `the shape of the input '${x.shape}'`);
            if (tensorAccumulatedGradientMap[x.id] == null) tensorAccumulatedGradientMap[x.id] = dx;
            else {
                const curGradient = tensorAccumulatedGradientMap[x.id];
                tensorAccumulatedGradientMap[x.id] = add(curGradient, dx);
                curGradient.dispose();
            }
        }
    }
}


/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for: https://github.com/bazelbuild/rules_nodejs/issues/1265
/// <reference types="@webgpu/types/dist" />

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
// Maximum number of values before we decide to show ellipsis.
const $db2bdc726e48c731$var$FORMAT_LIMIT_NUM_VALS = 20;
// Number of first and last values to show when displaying a, b,...,y, z.
const $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS = 3;
// Number of significant digits to show.
const $db2bdc726e48c731$var$FORMAT_NUM_SIG_DIGITS = 7;
function $db2bdc726e48c731$export$7febe2c78b16daa7(vals, shape, dtype, verbose) {
    const strides = (0, $5f8d0ee7a8d35dfe$export$6ad0292cf4d50f79)(shape);
    const padPerCol = $db2bdc726e48c731$var$computeMaxSizePerColumn(vals, shape, dtype, strides);
    const rank = shape.length;
    const valsLines = $db2bdc726e48c731$var$subTensorToString(vals, shape, dtype, strides, padPerCol);
    const lines = [
        'Tensor'
    ];
    if (verbose) {
        lines.push(`  dtype: ${dtype}`);
        lines.push(`  rank: ${rank}`);
        lines.push(`  shape: [${shape}]`);
        lines.push(`  values:`);
    }
    lines.push(valsLines.map((l)=>'    ' + l).join('\n'));
    return lines.join('\n');
}
function $db2bdc726e48c731$var$computeMaxSizePerColumn(vals, shape, dtype, strides) {
    const n = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(shape);
    const numCols = strides[strides.length - 1];
    const padPerCol = new Array(numCols).fill(0);
    const rank = shape.length;
    const valuesOrTuples = dtype === 'complex64' ? $db2bdc726e48c731$var$createComplexTuples(vals) : vals;
    if (rank > 1) for(let row = 0; row < n / numCols; row++){
        const offset = row * numCols;
        for(let j = 0; j < numCols; j++)padPerCol[j] = Math.max(padPerCol[j], $db2bdc726e48c731$var$valToString(valuesOrTuples[offset + j], 0, dtype).length);
    }
    return padPerCol;
}
function $db2bdc726e48c731$var$valToString(val, pad, dtype) {
    let valStr;
    if (Array.isArray(val)) valStr = `${parseFloat(val[0].toFixed($db2bdc726e48c731$var$FORMAT_NUM_SIG_DIGITS))} + ` + `${parseFloat(val[1].toFixed($db2bdc726e48c731$var$FORMAT_NUM_SIG_DIGITS))}j`;
    else if ((0, $5f8d0ee7a8d35dfe$export$844ec244b1367d54)(val)) valStr = `'${val}'`;
    else if (dtype === 'bool') valStr = $db2bdc726e48c731$var$boolNumToString(val);
    else valStr = parseFloat(val.toFixed($db2bdc726e48c731$var$FORMAT_NUM_SIG_DIGITS)).toString();
    return (0, $5f8d0ee7a8d35dfe$export$390245bab32fb60f)(valStr, pad);
}
function $db2bdc726e48c731$var$boolNumToString(v) {
    return v === 0 ? 'false' : 'true';
}
function $db2bdc726e48c731$var$subTensorToString(vals, shape, dtype, strides, padPerCol, isLast = true) {
    const storagePerElement = dtype === 'complex64' ? 2 : 1;
    const size = shape[0];
    const rank = shape.length;
    if (rank === 0) {
        if (dtype === 'complex64') {
            const complexTuple = $db2bdc726e48c731$var$createComplexTuples(vals);
            return [
                $db2bdc726e48c731$var$valToString(complexTuple[0], 0, dtype)
            ];
        }
        if (dtype === 'bool') return [
            $db2bdc726e48c731$var$boolNumToString(vals[0])
        ];
        return [
            vals[0].toString()
        ];
    }
    if (rank === 1) {
        if (size > $db2bdc726e48c731$var$FORMAT_LIMIT_NUM_VALS) {
            const firstValsSize = $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS * storagePerElement;
            let firstVals = Array.from(vals.slice(0, firstValsSize));
            let lastVals = Array.from(vals.slice((size - $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS) * storagePerElement, size * storagePerElement));
            if (dtype === 'complex64') {
                firstVals = $db2bdc726e48c731$var$createComplexTuples(firstVals);
                lastVals = $db2bdc726e48c731$var$createComplexTuples(lastVals);
            }
            return [
                '[' + firstVals.map((x, i)=>$db2bdc726e48c731$var$valToString(x, padPerCol[i], dtype)).join(', ') + ', ..., ' + lastVals.map((x, i)=>$db2bdc726e48c731$var$valToString(x, padPerCol[size - $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS + i], dtype)).join(', ') + ']'
            ];
        }
        const displayVals = dtype === 'complex64' ? $db2bdc726e48c731$var$createComplexTuples(vals) : Array.from(vals);
        return [
            '[' + displayVals.map((x, i)=>$db2bdc726e48c731$var$valToString(x, padPerCol[i], dtype)).join(', ') + ']'
        ];
    }
    // The array is rank 2 or more.
    const subshape = shape.slice(1);
    const substrides = strides.slice(1);
    const stride = strides[0] * storagePerElement;
    const lines = [];
    if (size > $db2bdc726e48c731$var$FORMAT_LIMIT_NUM_VALS) {
        for(let i = 0; i < $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$db2bdc726e48c731$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, false));
        }
        lines.push('...');
        for(let i = size - $db2bdc726e48c731$var$FORMAT_NUM_FIRST_LAST_VALS; i < size; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$db2bdc726e48c731$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
        }
    } else for(let i = 0; i < size; i++){
        const start = i * stride;
        const end = start + stride;
        lines.push(...$db2bdc726e48c731$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
    }
    const sep = rank === 2 ? ',' : '';
    lines[0] = '[' + (size > 0 ? lines[0] + sep : '');
    for(let i = 1; i < lines.length - 1; i++)lines[i] = ' ' + lines[i] + sep;
    let newLineSep = ',\n';
    for(let i = 2; i < rank; i++)newLineSep += '\n';
    lines[lines.length - 1] = ' ' + lines[lines.length - 1] + ']' + (isLast ? '' : newLineSep);
    return lines;
}
function $db2bdc726e48c731$var$createComplexTuples(vals) {
    const complexTuples = [];
    for(let i = 0; i < vals.length; i += 2)complexTuples.push([
        vals[i],
        vals[i + 1]
    ]);
    return complexTuples;
}



class $6c839404e55214b5$export$350df26cd52e08e1 {
    constructor(shape, dtype, values){
        this.dtype = dtype;
        this.shape = shape.slice();
        this.size = $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f(shape);
        if (values != null) {
            const n = values.length;
            $5f8d0ee7a8d35dfe$export$a7a9523472993e97(n === this.size, ()=>`Length of values '${n}' does not match the size ` + `inferred by the shape '${this.size}'.`);
        }
        if (dtype === 'complex64') throw new Error(`complex64 dtype TensorBuffers are not supported. Please create ` + `a TensorBuffer for the real and imaginary parts separately and ` + `call tf.complex(real, imag).`);
        this.values = values || $5f8d0ee7a8d35dfe$export$24f13f6206df8f7c(dtype, this.size);
        this.strides = (0, $5f8d0ee7a8d35dfe$export$6ad0292cf4d50f79)(shape);
    }
    /**
     * Sets a value in the buffer at a given location.
     *
     * @param value The value to set.
     * @param locs  The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ set(value, ...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(locs.length === this.rank, ()=>`The number of provided coordinates (${locs.length}) must ` + `match the rank (${this.rank})`);
        const index = this.locToIndex(locs);
        this.values[index] = value;
    }
    /**
     * Returns the value in the buffer at the provided location.
     *
     * @param locs The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ get(...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        let i = 0;
        for (const loc of locs){
            if (loc < 0 || loc >= this.shape[i]) {
                const msg = `Requested out of range element at ${locs}. ` + `  Buffer shape=${this.shape}`;
                throw new Error(msg);
            }
            i++;
        }
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return this.values[index];
    }
    locToIndex(locs) {
        if (this.rank === 0) return 0;
        else if (this.rank === 1) return locs[0];
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return index;
    }
    indexToLoc(index) {
        if (this.rank === 0) return [];
        else if (this.rank === 1) return [
            index
        ];
        const locs = new Array(this.shape.length);
        for(let i = 0; i < locs.length - 1; ++i){
            locs[i] = Math.floor(index / this.strides[i]);
            index -= locs[i] * this.strides[i];
        }
        locs[locs.length - 1] = index;
        return locs;
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Creates an immutable `tf.Tensor` object from the buffer.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ toTensor() {
        return $6c839404e55214b5$var$trackerFn().makeTensor(this.values, this.shape, this.dtype);
    }
}
// For tracking tensor creation and disposal.
let $6c839404e55214b5$var$trackerFn = null;
// Used by chaining methods to call into ops.
let $6c839404e55214b5$var$opHandler = null;
// Used to warn about deprecated methods.
let $6c839404e55214b5$var$deprecationWarningFn = null;
function $6c839404e55214b5$export$b1e34d2f0ffbbd85(fn) {
    $6c839404e55214b5$var$trackerFn = fn;
}
function $6c839404e55214b5$export$1efe8d8b4884ad31(handler) {
    $6c839404e55214b5$var$opHandler = handler;
}
function $6c839404e55214b5$export$ca605c1d8919649f(fn) {
    $6c839404e55214b5$var$deprecationWarningFn = fn;
}
class $6c839404e55214b5$export$7b6b8d90402f8814 {
    constructor(shape, dtype, dataId, id){
        /** Whether this tensor has been globally kept. */ this.kept = false;
        this.isDisposedInternal = false;
        this.shape = shape.slice();
        this.dtype = dtype || 'float32';
        this.size = $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f(shape);
        this.strides = (0, $5f8d0ee7a8d35dfe$export$6ad0292cf4d50f79)(shape);
        this.dataId = dataId;
        this.id = id;
        this.rankType = this.rank < 5 ? this.rank.toString() : 'higher';
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Returns a promise of `tf.TensorBuffer` that holds the underlying data.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async buffer() {
        const vals = await this.data();
        return $6c839404e55214b5$var$opHandler.buffer(this.shape, this.dtype, vals);
    }
    /**
     * Returns a `tf.TensorBuffer` that holds the underlying data.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ bufferSync() {
        return $6c839404e55214b5$var$opHandler.buffer(this.shape, this.dtype, this.dataSync());
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * asynchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async array() {
        const vals = await this.data();
        return (0, $5f8d0ee7a8d35dfe$export$3983c25181aa68cc)(this.shape, vals, this.dtype === 'complex64');
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * synchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ arraySync() {
        return (0, $5f8d0ee7a8d35dfe$export$3983c25181aa68cc)(this.shape, this.dataSync(), this.dtype === 'complex64');
    }
    /**
     * Asynchronously downloads the values from the `tf.Tensor`. Returns a
     * promise of `TypedArray` that resolves when the computation has finished.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async data() {
        this.throwIfDisposed();
        const data = $6c839404e55214b5$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') {
            const bytes = await data;
            try {
                return bytes.map((b)=>$e10678764dab7ea0$export$a0fb664af7d0cc44(b));
            } catch (_a) {
                throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
            }
        }
        return data;
    }
    /**
     * Copy the tensor's data to a new GPU resource. Comparing to the `dataSync()`
     * and `data()`, this method prevents data from being downloaded to CPU.
     *
     * For WebGL backend, the data will be stored on a densely packed texture.
     * This means that the texture will use the RGBA channels to store value.
     *
     * For WebGPU backend, the data will be stored on a buffer. There is no
     * parameter, so can not use a user-defined size to create the buffer.
     *
     * @param options:
     *     For WebGL,
     *         - customTexShape: Optional. If set, will use the user defined
     *     texture shape to create the texture.
     *
     * @returns For WebGL backend, a GPUData contains the new texture and
     *     its information.
     *     {
     *        tensorRef: The tensor that is associated with this texture,
     *        texture: WebGLTexture,
     *        texShape: [number, number] // [height, width]
     *     }
     *
     *     For WebGPU backend, a GPUData contains the new buffer.
     *     {
     *        tensorRef: The tensor that is associated with this buffer,
     *        buffer: GPUBuffer,
     *     }
     *
     *     Remember to dispose the GPUData after it is used by
     *     `res.tensorRef.dispose()`.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataToGPU(options) {
        this.throwIfDisposed();
        return $6c839404e55214b5$var$trackerFn().readToGPU(this.dataId, options);
    }
    /**
     * Synchronously downloads the values from the `tf.Tensor`. This blocks the
     * UI thread until the values are ready, which can cause performance issues.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataSync() {
        this.throwIfDisposed();
        const data = $6c839404e55214b5$var$trackerFn().readSync(this.dataId);
        if (this.dtype === 'string') try {
            return data.map((b)=>$e10678764dab7ea0$export$a0fb664af7d0cc44(b));
        } catch (_a) {
            throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
        }
        return data;
    }
    /** Returns the underlying bytes of the tensor's data. */ async bytes() {
        this.throwIfDisposed();
        const data = await $6c839404e55214b5$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') return data;
        else return new Uint8Array(data.buffer);
    }
    /**
     * Disposes `tf.Tensor` from memory.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dispose() {
        if (this.isDisposed) return;
        if (this.kerasMask) this.kerasMask.dispose();
        $6c839404e55214b5$var$trackerFn().disposeTensor(this);
        this.isDisposedInternal = true;
    }
    get isDisposed() {
        return this.isDisposedInternal;
    }
    throwIfDisposed() {
        if (this.isDisposed) throw new Error(`Tensor is disposed.`);
    }
    /**
     * Prints the `tf.Tensor`. See `tf.print` for details.
     *
     * @param verbose Whether to print verbose information about the tensor,
     *    including dtype and size.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ print(verbose = false) {
        return $6c839404e55214b5$var$opHandler.print(this, verbose);
    }
    /**
     * Returns a copy of the tensor. See `tf.clone` for details.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ clone() {
        this.throwIfDisposed();
        return $6c839404e55214b5$var$opHandler.clone(this);
    }
    /**
     * Returns a human-readable description of the tensor. Useful for logging.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ toString(verbose = false) {
        const vals = this.dataSync();
        return (0, $db2bdc726e48c731$export$7febe2c78b16daa7)(vals, this.shape, this.dtype, verbose);
    }
    cast(dtype) {
        this.throwIfDisposed();
        return $6c839404e55214b5$var$opHandler.cast(this, dtype);
    }
    variable(trainable = true, name, dtype) {
        this.throwIfDisposed();
        return $6c839404e55214b5$var$trackerFn().makeVariable(this, trainable, name, dtype);
    }
}
Object.defineProperty($6c839404e55214b5$export$7b6b8d90402f8814, Symbol.hasInstance, {
    value: (instance)=>{
        // Implementation note: we should use properties of the object that will be
        // defined before the constructor body has finished executing (methods).
        // This is because when this code is transpiled by babel, babel will call
        // classCallCheck before the constructor body is run.
        // See https://github.com/tensorflow/tfjs/issues/3384 for backstory.
        return !!instance && instance.data != null && instance.dataSync != null && instance.throwIfDisposed != null;
    }
});
function $6c839404e55214b5$export$3cbd87e9d6a9b7ac() {
    // Use getGlobal so that we can augment the Tensor class across package
    // boundaries because the node resolution alg may result in different modules
    // being returned for this file depending on the path they are loaded from.
    return (0, $bf790b47f177f8e9$export$a4e55266d2135a7f)('Tensor', ()=>{
        return $6c839404e55214b5$export$7b6b8d90402f8814;
    });
}
// Global side effect. Cache global reference to Tensor class
$6c839404e55214b5$export$3cbd87e9d6a9b7ac();
class $6c839404e55214b5$export$c867a5c9595a1350 extends $6c839404e55214b5$export$7b6b8d90402f8814 {
    constructor(initialValue, trainable, name, tensorId){
        super(initialValue.shape, initialValue.dtype, initialValue.dataId, tensorId);
        this.trainable = trainable;
        this.name = name;
    }
    /**
     * Assign a new `tf.Tensor` to this variable. The new `tf.Tensor` must have
     * the same shape and dtype as the old `tf.Tensor`.
     *
     * @param newValue New tensor to be assigned to this variable.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ assign(newValue) {
        if (newValue.dtype !== this.dtype) throw new Error(`dtype of the new value (${newValue.dtype}) and ` + `previous value (${this.dtype}) must match`);
        if (!$5f8d0ee7a8d35dfe$export$234180f8206db11b(newValue.shape, this.shape)) throw new Error(`shape of the new value (${newValue.shape}) and ` + `previous value (${this.shape}) must match`);
        $6c839404e55214b5$var$trackerFn().disposeTensor(this);
        this.dataId = newValue.dataId;
        $6c839404e55214b5$var$trackerFn().incRef(this, null);
    }
    dispose() {
        $6c839404e55214b5$var$trackerFn().disposeVariable(this);
        this.isDisposedInternal = true;
    }
}
Object.defineProperty($6c839404e55214b5$export$c867a5c9595a1350, Symbol.hasInstance, {
    value: (instance)=>{
        return instance instanceof $6c839404e55214b5$export$7b6b8d90402f8814 && instance.assign != null && instance.assign instanceof Function;
    }
});


var $28f820f91d9287a3$exports = {};

$parcel$export($28f820f91d9287a3$exports, "makeTypesMatch", () => $28f820f91d9287a3$export$8b0e24c749a224d7);
$parcel$export($28f820f91d9287a3$exports, "assertTypesMatch", () => $28f820f91d9287a3$export$8a66522456343d17);
$parcel$export($28f820f91d9287a3$exports, "isTensorInList", () => $28f820f91d9287a3$export$537d2ee9de90a490);
$parcel$export($28f820f91d9287a3$exports, "getTensorsInContainer", () => $28f820f91d9287a3$export$888c106d343989f5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $206e8e4148e423f6$export$c36edca8f8f0427a;
(function(Rank) {
    Rank["R0"] = "R0";
    Rank["R1"] = "R1";
    Rank["R2"] = "R2";
    Rank["R3"] = "R3";
    Rank["R4"] = "R4";
    Rank["R5"] = "R5";
    Rank["R6"] = "R6";
})($206e8e4148e423f6$export$c36edca8f8f0427a || ($206e8e4148e423f6$export$c36edca8f8f0427a = {}));
// Looks for upcasting types. Used, for example, in operations with mixed dtype
// inputs.
var $206e8e4148e423f6$var$UpcastInt32AndMap;
(function(UpcastInt32AndMap) {
    UpcastInt32AndMap["float32"] = "float32";
    UpcastInt32AndMap["int32"] = "int32";
    UpcastInt32AndMap["bool"] = "int32";
    UpcastInt32AndMap["complex64"] = "complex64";
})($206e8e4148e423f6$var$UpcastInt32AndMap || ($206e8e4148e423f6$var$UpcastInt32AndMap = {}));
var $206e8e4148e423f6$var$UpcastBoolAndMap;
(function(UpcastBoolAndMap) {
    UpcastBoolAndMap["float32"] = "float32";
    UpcastBoolAndMap["int32"] = "int32";
    UpcastBoolAndMap["bool"] = "bool";
    UpcastBoolAndMap["complex64"] = "complex64";
})($206e8e4148e423f6$var$UpcastBoolAndMap || ($206e8e4148e423f6$var$UpcastBoolAndMap = {}));
var $206e8e4148e423f6$var$UpcastFloat32AndMap;
(function(UpcastFloat32AndMap) {
    UpcastFloat32AndMap["float32"] = "float32";
    UpcastFloat32AndMap["int32"] = "float32";
    UpcastFloat32AndMap["bool"] = "float32";
    UpcastFloat32AndMap["complex64"] = "complex64";
})($206e8e4148e423f6$var$UpcastFloat32AndMap || ($206e8e4148e423f6$var$UpcastFloat32AndMap = {}));
var $206e8e4148e423f6$var$UpcastComplex64AndMap;
(function(UpcastComplex64AndMap) {
    UpcastComplex64AndMap["float32"] = "complex64";
    UpcastComplex64AndMap["int32"] = "complex64";
    UpcastComplex64AndMap["bool"] = "complex64";
    UpcastComplex64AndMap["complex64"] = "complex64";
})($206e8e4148e423f6$var$UpcastComplex64AndMap || ($206e8e4148e423f6$var$UpcastComplex64AndMap = {}));
const $206e8e4148e423f6$var$upcastTypeMap = {
    'float32': $206e8e4148e423f6$var$UpcastFloat32AndMap,
    'int32': $206e8e4148e423f6$var$UpcastInt32AndMap,
    'bool': $206e8e4148e423f6$var$UpcastBoolAndMap,
    'complex64': $206e8e4148e423f6$var$UpcastComplex64AndMap
};
function $206e8e4148e423f6$export$7bcca02d1a156bdf(typeA, typeB) {
    if (typeA === 'string' || typeB === 'string') {
        if (typeA === 'string' && typeB === 'string') return 'string';
        throw new Error(`Can not upcast ${typeA} with ${typeB}`);
    }
    return $206e8e4148e423f6$var$upcastTypeMap[typeA][typeB];
}
function $206e8e4148e423f6$export$3479b4fbed3c0d8d(type) {
    return $206e8e4148e423f6$export$7bcca02d1a156bdf(type, 'int32');
}
function $206e8e4148e423f6$export$12371c78da2a116a(values) {
    return values != null && typeof values === 'object' && 'texture' in values && values.texture instanceof WebGLTexture;
}
function $206e8e4148e423f6$export$db4071ca636ae03b(values) {
    return typeof GPUBuffer !== 'undefined' && values != null && typeof values === 'object' && 'buffer' in values && values.buffer instanceof GPUBuffer;
}



function $28f820f91d9287a3$export$8b0e24c749a224d7(a, b) {
    if (a.dtype === b.dtype) return [
        a,
        b
    ];
    const dtype = (0, $206e8e4148e423f6$export$7bcca02d1a156bdf)(a.dtype, b.dtype);
    return [
        a.cast(dtype),
        b.cast(dtype)
    ];
}
function $28f820f91d9287a3$export$8a66522456343d17(a, b) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(a.dtype === b.dtype, ()=>`The dtypes of the first(${a.dtype}) and` + ` second(${b.dtype}) input must match`);
}
function $28f820f91d9287a3$export$537d2ee9de90a490(tensor, tensorList) {
    return tensorList.some((x)=>x.id === tensor.id);
}
function $28f820f91d9287a3$export$888c106d343989f5(result) {
    const list = [];
    const seen = new Set();
    $28f820f91d9287a3$var$walkTensorContainer(result, list, seen);
    return list;
}
function $28f820f91d9287a3$var$walkTensorContainer(container, list, seen) {
    if (container == null) return;
    if (container instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814)) {
        list.push(container);
        return;
    }
    if (!$28f820f91d9287a3$var$isIterable(container)) return;
    // Iteration over keys works also for arrays.
    const iterable = container;
    for(const k in iterable){
        const val = iterable[k];
        if (!seen.has(val)) {
            seen.add(val);
            $28f820f91d9287a3$var$walkTensorContainer(val, list, seen);
        }
    }
}
// tslint:disable-next-line:no-any
function $28f820f91d9287a3$var$isIterable(obj) {
    return Array.isArray(obj) || typeof obj === 'object';
}



function $249f84ddb1ced836$var$isRegisteredKernelInvocation(kernelInvocation) {
    return kernelInvocation.kernelName != null;
}
class $249f84ddb1ced836$var$EngineState {
    constructor(){
        // Public since optimizers will use it.
        this.registeredVariables = {};
        this.nextTapeNodeId = 0;
        this.numBytes = 0;
        this.numTensors = 0;
        this.numStringTensors = 0;
        this.numDataBuffers = 0;
        // Number of nested tf.grad() statements when computing higher-order
        // gradients. E.g. `1` for first-order gradients and `2` for second-order
        // gradients. Used to track if the tape should be removed after a backprop.
        this.gradientDepth = 0;
        // Number of nested kernel calls. When kernel depth is greater than 1, we turn
        // off the tape.
        this.kernelDepth = 0;
        this.scopeStack = [];
        /**
         * Keeps track of the number of data moves during a kernel execution. We
         * maintain a stack since kernels can call other kernels, recursively.
         */ this.numDataMovesStack = [];
        this.nextScopeId = 0;
        this.tensorInfo = new WeakMap();
        this.profiling = false;
        this.activeProfile = {
            newBytes: 0,
            newTensors: 0,
            peakBytes: 0,
            kernels: [],
            result: null,
            get kernelNames () {
                return Array.from(new Set(this.kernels.map((k)=>k.name)));
            }
        };
    }
    dispose() {
        for(const variableName in this.registeredVariables)this.registeredVariables[variableName].dispose();
    }
}
class $249f84ddb1ced836$export$2c3b404bf3a77a1f {
    constructor(ENV){
        this.ENV = ENV;
        this.registry = {};
        this.registryFactory = {};
        this.pendingBackendInitId = 0;
        this.state = new $249f84ddb1ced836$var$EngineState();
    }
    async ready() {
        if (this.pendingBackendInit != null) return this.pendingBackendInit.then(()=>{});
        if (this.backendInstance != null) return;
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const success = await this.initializeBackend(backendName).success;
            if (success) {
                await this.setBackend(backendName);
                return;
            }
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    get backend() {
        if (this.pendingBackendInit != null) throw new Error(`Backend '${this.backendName}' has not yet been initialized. Make ` + `sure to await tf.ready() or await tf.setBackend() before calling ` + `other methods`);
        if (this.backendInstance == null) {
            const { name: name, asyncInit: asyncInit } = this.initializeBackendsAndReturnBest();
            if (asyncInit) throw new Error(`The highest priority backend '${name}' has not yet been ` + `initialized. Make sure to await tf.ready() or ` + `await tf.setBackend() before calling other methods`);
            this.setBackend(name);
        }
        return this.backendInstance;
    }
    backendNames() {
        return Object.keys(this.registryFactory);
    }
    findBackend(backendName) {
        if (!(backendName in this.registry)) {
            // If the backend hasn't been initialized but we have a registry entry for
            // it, initialize it and return it.
            if (backendName in this.registryFactory) {
                const { asyncInit: asyncInit } = this.initializeBackend(backendName);
                if (asyncInit) // Backend is not ready yet.
                return null;
            } else return null;
        }
        return this.registry[backendName];
    }
    findBackendFactory(backendName) {
        if (!(backendName in this.registryFactory)) return null;
        return this.registryFactory[backendName].factory;
    }
    registerBackend(backendName, factory, priority = 1) {
        if (backendName in this.registryFactory) {
            $8ee8f3c328242644$export$c106dd0671a0fc2d(`${backendName} backend was already registered. ` + `Reusing existing backend factory.`);
            return false;
        }
        this.registryFactory[backendName] = {
            factory: factory,
            priority: priority
        };
        return true;
    }
    async setBackend(backendName) {
        if (this.registryFactory[backendName] == null) throw new Error(`Backend name '${backendName}' not found in registry`);
        this.backendName = backendName;
        if (this.registry[backendName] == null) {
            this.backendInstance = null;
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            const result = asyncInit ? await success : success;
            if (!result) return false;
        }
        this.backendInstance = this.registry[backendName];
        this.setupRegisteredKernels();
        // Reset the profiler.
        this.profiler = new (0, $6857a2d26887063c$export$e2c29f18771995cb)(this.backendInstance);
        return true;
    }
    setupRegisteredKernels() {
        const kernels = (0, $a6ed5fb1cf7ee2a4$export$e4b8d76e176eaecc)(this.backendName);
        kernels.forEach((kernel)=>{
            if (kernel.setupFunc != null) kernel.setupFunc(this.backendInstance);
        });
    }
    disposeRegisteredKernels(backendName) {
        const kernels = (0, $a6ed5fb1cf7ee2a4$export$e4b8d76e176eaecc)(backendName);
        kernels.forEach((kernel)=>{
            if (kernel.disposeFunc != null) kernel.disposeFunc(this.registry[backendName]);
        });
    }
    /**
     * Initializes a backend by looking up the backend name in the factory
     * registry and calling the factory method. Returns a boolean representing
     * whether the initialization of the backend succeeded. Throws an error if
     * there is no backend in the factory registry.
     */ initializeBackend(backendName) {
        const registryFactoryEntry = this.registryFactory[backendName];
        if (registryFactoryEntry == null) throw new Error(`Cannot initialize backend ${backendName}, no registration found.`);
        try {
            const backend = registryFactoryEntry.factory();
            /* Test if the factory returns a promise.
            Done in a more liberal way than
            previous 'Promise.resolve(backend)===backend'
            as we needed to account for custom Promise
            implementations (e.g. Angular) */ if (backend && !(backend instanceof (0, $b73fd602f21aa26c$export$543916c62202b50a)) && typeof backend.then === 'function') {
                const promiseId = ++this.pendingBackendInitId;
                const success = backend.then((backendInstance)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.registry[backendName] = backendInstance;
                    this.pendingBackendInit = null;
                    return true;
                }).catch((err)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.pendingBackendInit = null;
                    $8ee8f3c328242644$export$c106dd0671a0fc2d(`Initialization of backend ${backendName} failed`);
                    $8ee8f3c328242644$export$c106dd0671a0fc2d(err.stack || err.message);
                    return false;
                });
                this.pendingBackendInit = success;
                return {
                    success: success,
                    asyncInit: true
                };
            } else {
                this.registry[backendName] = backend;
                return {
                    success: true,
                    asyncInit: false
                };
            }
        } catch (err) {
            $8ee8f3c328242644$export$c106dd0671a0fc2d(`Initialization of backend ${backendName} failed`);
            $8ee8f3c328242644$export$c106dd0671a0fc2d(err.stack || err.message);
            return {
                success: false,
                asyncInit: false
            };
        }
    }
    removeBackend(backendName) {
        if (!(backendName in this.registryFactory)) throw new Error(`${backendName} backend not found in registry`);
        if (this.backendName === backendName && this.pendingBackendInit != null) // There is a pending promise of the backend we want to remove. Make it
        // obsolete.
        this.pendingBackendInitId++;
        if (backendName in this.registry) {
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        delete this.registryFactory[backendName];
        // Unset the backend if it is active.
        if (this.backendName === backendName) {
            this.pendingBackendInit = null;
            this.backendName = null;
            this.backendInstance = null;
        }
    }
    getSortedBackends() {
        if (Object.keys(this.registryFactory).length === 0) throw new Error('No backend found in registry.');
        return Object.keys(this.registryFactory).sort((a, b)=>{
            // Highest priority comes first.
            return this.registryFactory[b].priority - this.registryFactory[a].priority;
        });
    }
    initializeBackendsAndReturnBest() {
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            if (asyncInit || success) return {
                name: backendName,
                asyncInit: asyncInit
            };
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    moveData(backend, dataId) {
        const info = this.state.tensorInfo.get(dataId);
        const srcBackend = info.backend;
        const values = this.readSync(dataId);
        const refCount = srcBackend.refCount(dataId);
        // Delete the tensor from the old backend and move it to the new
        // backend.
        srcBackend.disposeData(dataId, true);
        info.backend = backend;
        backend.move(dataId, values, info.shape, info.dtype, refCount);
        if (this.shouldCheckForMemLeaks()) // Track the number of moves during a kernel execution to correctly
        // detect memory leaks.
        this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++;
    }
    tidy(nameOrFn, fn) {
        let name = null;
        if (fn == null) {
            // Called with only 1 argument.
            if (typeof nameOrFn !== 'function') throw new Error('Please provide a function to tidy()');
            fn = nameOrFn;
        } else {
            // Called with 2 arguments.
            if (typeof nameOrFn !== 'string' && !(nameOrFn instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
            if (typeof fn !== 'function') throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
            name = nameOrFn;
        // TODO(nsthorat,smilkov): Do operation logging and performance
        // profiling.
        }
        let result;
        return this.scopedRun(()=>this.startScope(name), ()=>this.endScope(result), ()=>{
            result = fn();
            if (result instanceof Promise) console.error('Cannot return a Promise inside of tidy.');
            return result;
        });
    }
    scopedRun(start, end, f) {
        start();
        try {
            const res = f();
            end();
            return res;
        } catch (ex) {
            end();
            throw ex;
        }
    }
    nextTensorId() {
        return $249f84ddb1ced836$export$2c3b404bf3a77a1f.nextTensorId++;
    }
    nextVariableId() {
        return $249f84ddb1ced836$export$2c3b404bf3a77a1f.nextVariableId++;
    }
    /**
     * This method is called instead of the public-facing tensor.clone() when
     * saving a tensor for backwards pass. It makes sure to add the clone
     * operation to the tape regardless of being called inside a kernel
     * execution.
     */ clone(x) {
        const y = $249f84ddb1ced836$export$33b63313cc511a3b.runKernel((0, $c9f78399309a8a0d$export$544bf02140fa9a77), {
            x: x
        });
        const inputs = {
            x: x
        };
        const grad = (dy)=>({
                x: ()=>{
                    const dtype = 'float32';
                    const gradInputs = {
                        x: dy
                    };
                    const attrs = {
                        dtype: dtype
                    };
                    return $249f84ddb1ced836$export$33b63313cc511a3b.runKernel((0, $c9f78399309a8a0d$export$107ecfb3d1ccbd77), gradInputs, // tslint:disable-next-line: no-unnecessary-type-assertion
                    attrs);
                }
            });
        const saved = [];
        this.addTapeNode(this.state.activeScope.name, inputs, [
            y
        ], grad, saved, {});
        return y;
    }
    /**
     * Execute a kernel with the given name and return the output tensor.
     *
     * @param kernelName The name of the kernel to execute.
     * @param inputs A map of input names to tensors.
     * @param attrs A map of attribute names to their values. An attribute is a
     *     primitive (non-tensor) input to the kernel.
     * @param inputsToSave A list of tensors, inputs to save for the backprop
     *     computation.
     * @param outputsToSave A list of booleans, specifying which output to save
     *     for the backprop computation. These are booleans since the output
     * tensors are not visible to the user.
     */ runKernel(kernelName, inputs, attrs) {
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        const hasKernel = (0, $a6ed5fb1cf7ee2a4$export$1b85808c967cc434)(kernelName, this.backendName) != null;
        if (!hasKernel) throw new Error(`Kernel '${kernelName}' not registered for backend '${this.backendName}'`);
        return this.runKernelFunc({
            kernelName: kernelName,
            inputs: inputs,
            attrs: attrs
        });
    }
    shouldCheckForMemLeaks() {
        return this.ENV.getBool('IS_TEST');
    }
    checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos) {
        const numDataIdsAfter = this.backend.numDataIds();
        // Count the number of data ids associated with the result of the kernel.
        let numOutputDataIds = 0;
        outInfos.forEach((info)=>{
            // Complex numbers allocate 3 data ids, one for 'real', one for
            // 'imaginary', and one for the container that holds the former two.
            numOutputDataIds += info.dtype === 'complex64' ? 3 : 1;
        });
        // Account for the number of moves during kernel execution. A "data move"
        // can happen in the middle of a kernel execution, placing a new (key,value)
        // pair in the data storage. Since data moves have net zero effect (we
        // always remove the data from the old backend), we have to cancel them out
        // when detecting memory leaks.
        const numMoves = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1];
        const dataIdsLeaked = numDataIdsAfter - numDataIdsBefore - numOutputDataIds - numMoves;
        if (dataIdsLeaked > 0) throw new Error(`Backend '${this.backendName}' has an internal memory leak ` + `(${dataIdsLeaked} data ids) after running '${kernelName}'`);
    }
    /**
     * Internal helper method to execute a kernel Func
     *
     * Use `runKernel` to execute kernels from outside of engine.
     */ runKernelFunc(kernelParams) {
        let outputs;
        let saved = [];
        const isTapeOn = this.isTapeOn();
        const startingBytecount = this.state.numBytes;
        const startingNumTensors = this.state.numTensors;
        if (this.shouldCheckForMemLeaks()) this.state.numDataMovesStack.push(0);
        let kernelFunc;
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        let out;
        const kernelOrScopeName = $249f84ddb1ced836$var$isRegisteredKernelInvocation(kernelParams) ? kernelParams.kernelName : this.state.activeScope != null ? this.state.activeScope.name : '';
        // Create the kernelFunc from either a registered kernel OR passed in
        // forward/backward functions (used by custom grad). In this context a
        // kernelFunc wraps a kernel implementation with some bookkeeping.
        if ($249f84ddb1ced836$var$isRegisteredKernelInvocation(kernelParams)) {
            const { kernelName: kernelName, inputs: inputs, attrs: attrs } = kernelParams;
            if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
            // can be deferred until an op/ kernel is run).
            // The below getter has side effects that will try to initialize the
            // backend and set properties like this.backendName
            // tslint:disable-next-line: no-unused-expression
            this.backend;
            const kernel = (0, $a6ed5fb1cf7ee2a4$export$1b85808c967cc434)(kernelName, this.backendName);
            $5f8d0ee7a8d35dfe$export$a7a9523472993e97(kernel != null, ()=>`Cannot find registered kernel '${kernelName}' for backend '${this.backendName}'`);
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = kernel.kernelFunc({
                    inputs: inputs,
                    attrs: attrs,
                    backend: this.backend
                });
                const outInfos = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) this.checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos);
                const outTensors = outInfos.map((outInfo)=>{
                    // todo (yassogba) remove this option (Tensor) when node backend
                    // methods have been modularized and they all return tensorInfo.
                    // TensorInfos do not have a rank attribute.
                    if (outInfo.rank != null) return outInfo;
                    return this.makeTensorFromTensorInfo(outInfo);
                });
                // Save any required inputs and outputs.
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since there would be no backprop for these tensors
                // (which would otherwise dispose them).
                if (isTapeOn) {
                    const tensorsToSave = this.getTensorsForGradient(kernelName, inputs, outTensors);
                    saved = this.saveTensorsForBackwardMode(tensorsToSave);
                }
                return outTensors;
            };
        } else {
            const { forwardFunc: forwardFunc } = kernelParams;
            // Running a customGrad op.
            const saveFunc = (tensors)=>{
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since we would never run backprop, which disposes
                // the kept tensors.
                if (!isTapeOn) return;
                saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
            };
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = this.tidy(()=>forwardFunc(this.backend, saveFunc));
                const outs = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) // Scope name is used to print a more helpful error message if needed.
                this.checkKernelForMemLeak(kernelOrScopeName, numDataIdsBefore, outs);
                return outs;
            };
        }
        //
        // Run the kernelFunc. Optionally profiling it.
        //
        const { inputs: inputs, attrs: attrs } = kernelParams;
        const backwardsFunc = $249f84ddb1ced836$var$isRegisteredKernelInvocation(kernelParams) ? null : kernelParams.backwardsFunc;
        let kernelProfile;
        this.scopedRun(// Stop recording to a tape when running a kernel.
        ()=>this.state.kernelDepth++, ()=>this.state.kernelDepth--, ()=>{
            if (!this.ENV.getBool('DEBUG') && !this.state.profiling) outputs = kernelFunc();
            else {
                kernelProfile = this.profiler.profileKernel(kernelOrScopeName, inputs, ()=>kernelFunc());
                if (this.ENV.getBool('DEBUG')) this.profiler.logKernelProfile(kernelProfile);
                outputs = kernelProfile.outputs;
            }
        });
        if (isTapeOn) this.addTapeNode(kernelOrScopeName, inputs, outputs, backwardsFunc, saved, attrs);
        if (this.state.profiling) this.state.activeProfile.kernels.push({
            name: kernelOrScopeName,
            bytesAdded: this.state.numBytes - startingBytecount,
            totalBytesSnapshot: this.state.numBytes,
            tensorsAdded: this.state.numTensors - startingNumTensors,
            totalTensorsSnapshot: this.state.numTensors,
            inputShapes: Object.keys(inputs).map((key)=>inputs[key] != null ? inputs[key].shape : null),
            outputShapes: outputs.map((item)=>item.shape),
            kernelTimeMs: kernelProfile.timeMs,
            extraInfo: kernelProfile.extraInfo
        });
        return Array.isArray(out) ? outputs : outputs[0];
    }
    /**
     * Saves tensors used in forward mode for use in backward mode.
     *
     * @param tensors the list of tensors to save.
     */ saveTensorsForBackwardMode(tensors) {
        const saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
        return saved;
    }
    /**
     * Returns a list of tensors to save for a given gradient calculation.
     *
     * @param kernelName name of kernel to look up gradient for.
     * @param inputs a map of input tensors.
     * @param outputs an array of output tensors from forward mode of kernel.
     */ getTensorsForGradient(kernelName, inputs, outputs) {
        const gradConfig = (0, $a6ed5fb1cf7ee2a4$export$e14995d3ec1747ee)(kernelName);
        if (gradConfig != null) {
            const inputsToSave = gradConfig.inputsToSave || [];
            const outputsToSave = gradConfig.outputsToSave || [];
            // If saveAllInputs is true, all inputs will be saved. Otherwise, inputs
            // specified in inputsToSave will be saved.
            let inputTensorsToSave;
            if (gradConfig.saveAllInputs) {
                $5f8d0ee7a8d35dfe$export$a7a9523472993e97(Array.isArray(inputs), ()=>'saveAllInputs is true, expected inputs to be an array.');
                inputTensorsToSave = Object.keys(inputs).map((key)=>inputs[key]);
            } else inputTensorsToSave = inputsToSave.map((inputName)=>inputs[inputName]);
            const outputTensorsToSave = outputs.filter((_, i)=>outputsToSave[i]);
            return inputTensorsToSave.concat(outputTensorsToSave);
        }
        // We return an empty list rather than throw an error because the kernel we
        // are looking up may not actually be relevant to backproping through the
        // overall function
        //
        // See 'does not error if irrelevant (pruned) ops are missing grads' test
        // in gradients_test.ts for an example.
        return [];
    }
    /**
     * Internal method used by public APIs for tensor creation. Makes a new
     * tensor with the provided shape, dtype and values. It always
     * creates a new data id and writes the values to the underlying backend.
     */ makeTensor(values, shape, dtype, backend) {
        if (values == null) throw new Error('Values passed to engine.makeTensor() are null');
        dtype = dtype || 'float32';
        backend = backend || this.backend;
        let backendVals = values;
        if (dtype === 'string' && $5f8d0ee7a8d35dfe$export$844ec244b1367d54(values[0])) backendVals = values.map((d)=>$e10678764dab7ea0$export$8146d2e653b87d6a(d));
        const dataId = backend.write(backendVals, shape, dtype);
        const t = new (0, $6c839404e55214b5$export$7b6b8d90402f8814)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        // Count bytes for string tensors.
        if (dtype === 'string') {
            const info = this.state.tensorInfo.get(dataId);
            const newBytes = (0, $5f8d0ee7a8d35dfe$export$c474902e1102282d)(backendVals);
            this.state.numBytes += newBytes - info.bytes;
            info.bytes = newBytes;
        }
        return t;
    }
    /**
     * Internal method used by backends. Makes a new tensor
     * that is a wrapper around an existing data id. It doesn't create
     * a new data id, only increments the ref count used in memory tracking.
     * @deprecated
     */ makeTensorFromDataId(dataId, shape, dtype, backend) {
        dtype = dtype || 'float32';
        const tensorInfo = {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
        return this.makeTensorFromTensorInfo(tensorInfo, backend);
    }
    /**
     * Internal method used by backends. Makes a new tensor that is a wrapper
     * around an existing data id in TensorInfo. It doesn't create a new data id,
     * only increments the ref count used in memory tracking.
     */ makeTensorFromTensorInfo(tensorInfo, backend) {
        const { dataId: dataId, shape: shape, dtype: dtype } = tensorInfo;
        const t = new (0, $6c839404e55214b5$export$7b6b8d90402f8814)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        return t;
    }
    makeVariable(initialValue, trainable = true, name, dtype) {
        name = name || this.nextVariableId().toString();
        if (dtype != null && dtype !== initialValue.dtype) initialValue = initialValue.cast(dtype);
        const v = new (0, $6c839404e55214b5$export$c867a5c9595a1350)(initialValue, trainable, name, this.nextTensorId());
        if (this.state.registeredVariables[v.name] != null) throw new Error(`Variable with name ${v.name} was already registered`);
        this.state.registeredVariables[v.name] = v;
        this.incRef(v, this.backend);
        return v;
    }
    trackTensor(a, backend) {
        this.state.numTensors++;
        if (a.dtype === 'string') this.state.numStringTensors++;
        // Bytes for complex numbers are counted by their components. Bytes for
        // string tensors are counted when writing values.
        let bytes = 0;
        if (a.dtype !== 'complex64' && a.dtype !== 'string') bytes = a.size * $5f8d0ee7a8d35dfe$export$3f355ce86503b89f(a.dtype);
        this.state.numBytes += bytes;
        if (!this.state.tensorInfo.has(a.dataId)) {
            this.state.numDataBuffers++;
            this.state.tensorInfo.set(a.dataId, {
                backend: backend || this.backend,
                dtype: a.dtype,
                shape: a.shape,
                bytes: bytes
            });
        }
        if (!(a instanceof (0, $6c839404e55214b5$export$c867a5c9595a1350))) this.track(a);
    }
    // Track the tensor by dataId and increase the refCount for the dataId in the
    // backend.
    // TODO(pyu10055): This is currently used by makeVariable method, to increase
    // refCount on the backend for the dataId. It can potentially be replaced with
    // Identity op indead of calling backend directly.
    incRef(a, backend) {
        this.trackTensor(a, backend);
        this.backend.incRef(a.dataId);
    }
    removeDataId(dataId, backend) {
        if (this.state.tensorInfo.has(dataId) && this.state.tensorInfo.get(dataId).backend === backend) {
            this.state.tensorInfo.delete(dataId);
            this.state.numDataBuffers--;
        }
    }
    disposeTensor(a) {
        if (!this.state.tensorInfo.has(a.dataId)) return;
        const info = this.state.tensorInfo.get(a.dataId);
        this.state.numTensors--;
        if (a.dtype === 'string') {
            this.state.numStringTensors--;
            this.state.numBytes -= info.bytes;
        }
        // Don't count bytes for complex numbers as they are counted by their
        // components.
        if (a.dtype !== 'complex64' && a.dtype !== 'string') {
            const bytes = a.size * $5f8d0ee7a8d35dfe$export$3f355ce86503b89f(a.dtype);
            this.state.numBytes -= bytes;
        }
        // Remove the reference to dataId if backend dispose the data successfully
        if (info.backend.disposeData(a.dataId)) this.removeDataId(a.dataId, info.backend);
    // TODO(nsthorat): Construct an error and save the stack trace for
    // debugging when in debug mode. Creating a stack trace is too expensive
    // to do unconditionally.
    }
    disposeVariables() {
        for(const varName in this.state.registeredVariables){
            const v = this.state.registeredVariables[varName];
            this.disposeVariable(v);
        }
    }
    disposeVariable(v) {
        this.disposeTensor(v);
        if (this.state.registeredVariables[v.name] != null) delete this.state.registeredVariables[v.name];
    }
    memory() {
        const info = this.backend.memory();
        info.numTensors = this.state.numTensors;
        info.numDataBuffers = this.state.numDataBuffers;
        info.numBytes = this.state.numBytes;
        if (this.state.numStringTensors > 0) {
            info.unreliable = true;
            if (info.reasons == null) info.reasons = [];
            info.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)");
        }
        return info;
    }
    async profile(query) {
        this.state.profiling = true;
        const startBytes = this.state.numBytes;
        const startNumTensors = this.state.numTensors;
        this.state.activeProfile.kernels = [];
        this.state.activeProfile.result = await query();
        this.state.profiling = false;
        this.state.activeProfile.peakBytes = Math.max(...this.state.activeProfile.kernels.map((d)=>d.totalBytesSnapshot));
        this.state.activeProfile.newBytes = this.state.numBytes - startBytes;
        this.state.activeProfile.newTensors = this.state.numTensors - startNumTensors;
        for (const kernel of this.state.activeProfile.kernels){
            kernel.kernelTimeMs = await kernel.kernelTimeMs;
            kernel.extraInfo = await kernel.extraInfo;
        }
        return this.state.activeProfile;
    }
    isTapeOn() {
        return this.state.gradientDepth > 0 && this.state.kernelDepth === 0;
    }
    addTapeNode(kernelName, inputs, outputs, gradientsFunc, saved, attrs) {
        const tapeNode = {
            id: this.state.nextTapeNodeId++,
            kernelName: kernelName,
            inputs: inputs,
            outputs: outputs,
            saved: saved
        };
        const gradConfig = (0, $a6ed5fb1cf7ee2a4$export$e14995d3ec1747ee)(kernelName);
        if (gradConfig != null) gradientsFunc = gradConfig.gradFunc;
        if (gradientsFunc != null) tapeNode.gradient = (dys)=>{
            // TODO(smilkov): To optimize back-prop, pass dys that are not used in
            // the backprop graph to the user as null instead of zeros
            dys = dys.map((dy, i)=>{
                if (dy == null) {
                    const output = outputs[i];
                    const vals = $5f8d0ee7a8d35dfe$export$edbc8aedac4e036f(output.size, output.dtype);
                    return this.makeTensor(vals, output.shape, output.dtype);
                }
                return dy;
            });
            // Grad functions of ops with single outputs expect a dy, while ops
            // with multiple outputs expect dys (array of dy).
            return gradientsFunc(dys.length > 1 ? dys : dys[0], saved, attrs);
        };
        this.state.activeTape.push(tapeNode);
    }
    keep(result) {
        result.kept = true;
        return result;
    }
    startTape() {
        if (this.state.gradientDepth === 0) this.state.activeTape = [];
        this.state.gradientDepth++;
    }
    endTape() {
        this.state.gradientDepth--;
    }
    /**
     * Start a scope. Use this with endScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ startScope(name) {
        const scopeInfo = {
            track: [],
            name: 'unnamed scope',
            id: this.state.nextScopeId++
        };
        if (name) scopeInfo.name = name;
        this.state.scopeStack.push(scopeInfo);
        this.state.activeScope = scopeInfo;
    }
    /**
     * End a scope. Use this with startScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ endScope(result) {
        const tensorsToTrackInParent = (0, $28f820f91d9287a3$export$888c106d343989f5)(result);
        const tensorsToTrackInParentSet = new Set(tensorsToTrackInParent.map((t)=>t.id));
        // Dispose the arrays tracked in this scope.
        for(let i = 0; i < this.state.activeScope.track.length; i++){
            const tensor = this.state.activeScope.track[i];
            if (!tensor.kept && !tensorsToTrackInParentSet.has(tensor.id)) tensor.dispose();
        }
        const oldScope = this.state.scopeStack.pop();
        this.state.activeScope = this.state.scopeStack.length === 0 ? null : this.state.scopeStack[this.state.scopeStack.length - 1];
        // Track the current result in the parent scope.
        tensorsToTrackInParent.forEach((tensor)=>{
            // Only track the tensor if was allocated in the inner scope and is not
            // globally kept.
            if (!tensor.kept && tensor.scopeId === oldScope.id) this.track(tensor);
        });
    }
    /**
     * Returns gradients of `f` with respect to each of the `xs`. The gradients
     * returned are of the same length as `xs`, but some might be null if `f`
     * was not a function of that `x`. It also takes optional dy to multiply the
     * gradient, which defaults to `1`.
     */ gradients(f, xs, dy, allowNoGradients = false) {
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(xs.length > 0, ()=>'gradients() received an empty list of xs.');
        if (dy != null && dy.dtype !== 'float32') throw new Error(`dy must have 'float32' dtype, but has '${dy.dtype}'`);
        const y = this.scopedRun(()=>this.startTape(), ()=>this.endTape(), ()=>this.tidy('forward', f));
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(y instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814), ()=>'The result y returned by f() must be a tensor.');
        // Filter out the nodes that don't connect x => y.
        const filteredTape = (0, $63dff6d774c8eeaf$export$13eebbb952f0db02)(this.state.activeTape, xs, y);
        if (!allowNoGradients && filteredTape.length === 0 && xs.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
        return this.tidy('backward', ()=>{
            const accumulatedGradientMap = {};
            accumulatedGradientMap[y.id] = dy == null ? $249f84ddb1ced836$var$ones(y.shape) : dy;
            // Backprop gradients through the filtered nodes.
            (0, $63dff6d774c8eeaf$export$2992958ba0a8790d)(accumulatedGradientMap, filteredTape, // Pass the tidy function to avoid circular dep with `tape.ts`.
            (f)=>this.tidy(f), // Pass an add function to avoide a circular dep with `tape.ts`.
            $249f84ddb1ced836$export$e16d8520af44a096);
            const grads = xs.map((x)=>accumulatedGradientMap[x.id]);
            if (this.state.gradientDepth === 0) {
                // This means that we are not computing higher-order gradients
                // and can clean up the tape.
                this.state.activeTape.forEach((node)=>{
                    for (const tensor of node.saved)tensor.dispose();
                });
                this.state.activeTape = null;
            }
            return {
                value: y,
                grads: grads
            };
        });
    }
    customGrad(f) {
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$f6e2535fb5126e54(f), ()=>'The f passed in customGrad(f) must be a function.');
        return (...inputs)=>{
            $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inputs.every((t)=>t instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814)), ()=>"The args passed in customGrad(f)(x1, x2,...) must all be tensors");
            let res;
            const inputMap = {};
            inputs.forEach((input, i)=>{
                inputMap[i] = input;
            });
            const forwardFunc = (_, save)=>{
                res = f(...[
                    ...inputs,
                    save
                ]);
                $5f8d0ee7a8d35dfe$export$a7a9523472993e97(res.value instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814), ()=>"The function f passed in customGrad(f) must return an object where `obj.value` is a tensor");
                $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$f6e2535fb5126e54(res.gradFunc), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function.");
                return res.value;
            };
            const backwardsFunc = (dy, saved)=>{
                const gradRes = res.gradFunc(dy, saved);
                const grads = Array.isArray(gradRes) ? gradRes : [
                    gradRes
                ];
                $5f8d0ee7a8d35dfe$export$a7a9523472993e97(grads.length === inputs.length, ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...).");
                $5f8d0ee7a8d35dfe$export$a7a9523472993e97(grads.every((t)=>t instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814)), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors.");
                const gradMap = {};
                grads.forEach((grad, i)=>{
                    gradMap[i] = ()=>grad;
                });
                return gradMap;
            };
            return this.runKernelFunc({
                forwardFunc: forwardFunc,
                backwardsFunc: backwardsFunc,
                inputs: inputMap
            });
        };
    }
    readSync(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readSync(dataId);
    }
    read(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.read(dataId);
    }
    readToGPU(dataId, options) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readToGPU(dataId, options);
    }
    async time(query) {
        const start = (0, $e10678764dab7ea0$export$461939dd4422153)();
        const timingInfo = await this.backend.time(query);
        timingInfo.wallMs = (0, $e10678764dab7ea0$export$461939dd4422153)() - start;
        return timingInfo;
    }
    /**
     * Tracks a Tensor in the current scope to be automatically cleaned up
     * when the current scope ends, and returns the value.
     *
     * @param result The Tensor to track in the current scope.
     */ track(result) {
        if (this.state.activeScope != null) {
            result.scopeId = this.state.activeScope.id;
            this.state.activeScope.track.push(result);
        }
        return result;
    }
    get registeredVariables() {
        return this.state.registeredVariables;
    }
    /**
     * Resets the engine state. Removes all backends but does not remove
     * registered backend factories.
     */ reset() {
        // Make any pending promise obsolete.
        this.pendingBackendInitId++;
        this.state.dispose();
        this.ENV.reset();
        this.state = new $249f84ddb1ced836$var$EngineState();
        for(const backendName in this.registry){
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        this.backendName = null;
        this.backendInstance = null;
        this.pendingBackendInit = null;
    }
}
$249f84ddb1ced836$export$2c3b404bf3a77a1f.nextTensorId = 0;
$249f84ddb1ced836$export$2c3b404bf3a77a1f.nextVariableId = 0;
function $249f84ddb1ced836$var$ones(shape) {
    const values = (0, $5f8d0ee7a8d35dfe$export$b915f681a907ae99)((0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(shape), 'float32');
    return $249f84ddb1ced836$export$33b63313cc511a3b.makeTensor(values, shape, 'float32');
}
function $249f84ddb1ced836$export$ca8737f6c8c212b8() {
    const ns = (0, $bf790b47f177f8e9$export$5054b240ae6849b7)();
    if (ns._tfengine == null) {
        const environment = new (0, $d3cf252ef4ef8e7f$export$7dc6752a22ab011a)(ns);
        ns._tfengine = new $249f84ddb1ced836$export$2c3b404bf3a77a1f(environment);
    }
    (0, $d3cf252ef4ef8e7f$export$3ef32a49eeda04cc)(ns._tfengine.ENV);
    // Tell the current tensor interface that the global engine is responsible
    // for tracking.
    (0, $6c839404e55214b5$export$b1e34d2f0ffbbd85)(()=>ns._tfengine);
    return ns._tfengine;
}
const $249f84ddb1ced836$export$33b63313cc511a3b = $249f84ddb1ced836$export$ca8737f6c8c212b8();
function $249f84ddb1ced836$export$e16d8520af44a096(a, b) {
    // We duplicate Add here to avoid a circular dependency with add.ts.
    const inputs = {
        a: a,
        b: b
    };
    return $249f84ddb1ced836$export$33b63313cc511a3b.runKernel((0, $c9f78399309a8a0d$export$d0265b2c425512d6), inputs);
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $36a682e0812b3b99$exports = {};

$parcel$export($36a682e0812b3b99$exports, "mockIsMobile", () => $36a682e0812b3b99$export$f55f7bd5cb259cb2);
$parcel$export($36a682e0812b3b99$exports, "isMobile", () => $36a682e0812b3b99$export$d0a8044dce8ff2fc);
$parcel$export($36a682e0812b3b99$exports, "isBrowser", () => $36a682e0812b3b99$export$4e09c449d6c407f7);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line:no-any
function $36a682e0812b3b99$var$_isNavigatorDefined() {
    return typeof navigator !== 'undefined' && navigator != null;
}
let $36a682e0812b3b99$var$isMobileMockValue;
function $36a682e0812b3b99$export$f55f7bd5cb259cb2(value) {
    $36a682e0812b3b99$var$isMobileMockValue = value;
}
function $36a682e0812b3b99$export$d0a8044dce8ff2fc(nav) {
    if ($36a682e0812b3b99$var$isMobileMockValue !== undefined) return $36a682e0812b3b99$var$isMobileMockValue;
    if (nav || $36a682e0812b3b99$var$_isNavigatorDefined()) {
        if (!nav) nav = navigator;
        if (nav.product === 'ReactNative') return true;
        const a = nav.userAgent || nav.vendor || // tslint:disable-next-line:no-any
        (typeof window !== 'undefined' ? window.opera : '');
        // Use `navigator.userAgentData.mobile` as fallback.
        if (!a) {
            // tslint:disable-next-line:no-any
            const navAny = nav;
            return navAny.userAgentData && navAny.userAgentData.mobile;
        }
        // tslint:disable-next-line:max-line-length
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || // tslint:disable-next-line:max-line-length
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
    }
    return false;
}
function $36a682e0812b3b99$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' && window.document != null || //@ts-ignore
    typeof WorkerGlobalScope !== 'undefined';
}



const $99ce6f6ee5cbe792$var$ENV = (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)();
/**
 * This file contains environment-related flag registrations.
 */ /** Whether to enable debug mode. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('DEBUG', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
});
/** Whether we are in a browser (as versus, say, node.js) environment. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_BROWSER', ()=>$36a682e0812b3b99$export$4e09c449d6c407f7());
/** Whether we are in a browser (as versus, say, node.js) environment. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_NODE', ()=>false);
/** Whether this browser is Chrome. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_CHROME', ()=>typeof navigator !== 'undefined' && navigator != null && navigator.userAgent != null && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
/** Whether this browser is Safari. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_SAFARI', ()=>typeof navigator !== 'undefined' && navigator != null && navigator.userAgent != null && /Safari/.test(navigator.userAgent) && /Apple/.test(navigator.vendor));
/**
 * True when the environment is "production" where we disable safety checks
 * to gain performance.
 */ $99ce6f6ee5cbe792$var$ENV.registerFlag('PROD', ()=>false);
/**
 * Whether to do sanity checks when inferring a shape from user-provided
 * values, used when creating a new tensor.
 */ $99ce6f6ee5cbe792$var$ENV.registerFlag('TENSORLIKE_CHECK_SHAPE_CONSISTENCY', ()=>$99ce6f6ee5cbe792$var$ENV.getBool('DEBUG'));
/** Whether deprecation warnings are enabled. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('DEPRECATION_WARNINGS_ENABLED', ()=>true);
/** True if running unit tests. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('IS_TEST', ()=>false);
/** Whether to check computation result for errors. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('CHECK_COMPUTATION_FOR_ERRORS', ()=>$99ce6f6ee5cbe792$var$ENV.getBool('DEBUG'));
/** Whether the backend needs to wrap input to imageBitmap. */ $99ce6f6ee5cbe792$var$ENV.registerFlag('WRAP_TO_IMAGEBITMAP', ()=>false);
/** Whether to enable canvas2d willReadFrequently for GPU backends */ $99ce6f6ee5cbe792$var$ENV.registerFlag('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU', ()=>false);
/** Whether to use setTimeoutCustom */ $99ce6f6ee5cbe792$var$ENV.registerFlag('USE_SETTIMEOUTCUSTOM', ()=>false);


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





function $010a899b69412c72$export$467a8ad638b9ad20(val, dtype) {
    let firstElem = val;
    if ((0, $e10678764dab7ea0$export$b119cc7e1840e59c)(val)) return dtype === 'string' ? [] : [
        val.length
    ];
    if ((0, $206e8e4148e423f6$export$12371c78da2a116a)(val)) {
        const usedChannels = val.channels || 'RGBA';
        return [
            val.height,
            val.width * usedChannels.length
        ];
    } else if ((0, $206e8e4148e423f6$export$db4071ca636ae03b)(val)) return [
        val.buffer.size / (dtype == null ? 4 : (0, $5f8d0ee7a8d35dfe$export$3f355ce86503b89f)(dtype))
    ];
    if (!Array.isArray(val)) return []; // Scalar.
    const shape = [];
    while(Array.isArray(firstElem) || (0, $e10678764dab7ea0$export$b119cc7e1840e59c)(firstElem) && dtype !== 'string'){
        shape.push(firstElem.length);
        firstElem = firstElem[0];
    }
    if (Array.isArray(val) && (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('TENSORLIKE_CHECK_SHAPE_CONSISTENCY')) $010a899b69412c72$var$deepAssertShapeConsistency(val, shape, []);
    return shape;
}
function $010a899b69412c72$var$deepAssertShapeConsistency(val, shape, indices) {
    indices = indices || [];
    if (!Array.isArray(val) && !(0, $e10678764dab7ea0$export$b119cc7e1840e59c)(val)) {
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(shape.length === 0, ()=>`Element arr[${indices.join('][')}] is a primitive, ` + `but should be an array/TypedArray of ${shape[0]} elements`);
        return;
    }
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(shape.length > 0, ()=>`Element arr[${indices.join('][')}] should be a primitive, ` + `but is an array of ${val.length} elements`);
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(val.length === shape[0], ()=>`Element arr[${indices.join('][')}] should have ${shape[0]} ` + `elements, but has ${val.length} elements`);
    const subShape = shape.slice(1);
    for(let i = 0; i < val.length; ++i)$010a899b69412c72$var$deepAssertShapeConsistency(val[i], subShape, indices.concat(i));
}
function $010a899b69412c72$var$assertDtype(expectedDtype, actualDType, argName, functionName) {
    if (expectedDtype === 'string_or_numeric') return;
    if (expectedDtype == null) throw new Error(`Expected dtype cannot be null.`);
    if (expectedDtype !== 'numeric' && expectedDtype !== actualDType || expectedDtype === 'numeric' && actualDType === 'string') throw new Error(`Argument '${argName}' passed to '${functionName}' must ` + `be ${expectedDtype} tensor, but got ${actualDType} tensor`);
}
function $010a899b69412c72$export$ede379c4c939d71a(x, argName, functionName, parseAsDtype = 'numeric') {
    if (x instanceof (0, $6c839404e55214b5$export$3cbd87e9d6a9b7ac)()) {
        $010a899b69412c72$var$assertDtype(parseAsDtype, x.dtype, argName, functionName);
        return x;
    }
    let inferredDtype = (0, $5f8d0ee7a8d35dfe$export$2005775d905d2dc2)(x);
    // If the user expects a bool/int/float, use that info to update the
    // inferredDtype when it is not a string.
    if (inferredDtype !== 'string' && [
        'bool',
        'int32',
        'float32'
    ].indexOf(parseAsDtype) >= 0) inferredDtype = parseAsDtype;
    $010a899b69412c72$var$assertDtype(parseAsDtype, inferredDtype, argName, functionName);
    if (x == null || !(0, $e10678764dab7ea0$export$b119cc7e1840e59c)(x) && !Array.isArray(x) && typeof x !== 'number' && typeof x !== 'boolean' && typeof x !== 'string') {
        const type = x == null ? 'null' : x.constructor.name;
        throw new Error(`Argument '${argName}' passed to '${functionName}' must be a ` + `Tensor or TensorLike, but got '${type}'`);
    }
    const inferredShape = $010a899b69412c72$export$467a8ad638b9ad20(x, inferredDtype);
    if (!(0, $e10678764dab7ea0$export$b119cc7e1840e59c)(x) && !Array.isArray(x)) x = [
        x
    ];
    const skipTypedArray = true;
    const values = inferredDtype !== 'string' ? (0, $e10678764dab7ea0$export$965adc581230795c)(x, inferredDtype) : (0, $e10678764dab7ea0$export$bffa455ba8c619a6)(x, [], skipTypedArray);
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).makeTensor(values, inferredShape, inferredDtype);
}
function $010a899b69412c72$export$758e66616b4d410b(arg, argName, functionName, parseAsDtype = 'numeric') {
    if (!Array.isArray(arg)) throw new Error(`Argument ${argName} passed to ${functionName} must be a ` + '`Tensor[]` or `TensorLike[]`');
    const tensors = arg;
    return tensors.map((t, i)=>$010a899b69412c72$export$ede379c4c939d71a(t, `${argName}[${i}]`, functionName, parseAsDtype));
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

const $e25ad0fc1c7fe06f$export$93114f1494faf9bb = '__op';
function $e25ad0fc1c7fe06f$export$f59964a629598e2(f) {
    const keys = Object.keys(f);
    if (keys.length !== 1) throw new Error(`Please provide an object with a single key ` + `(operation name) mapping to a function. Got an object with ` + `${keys.length} keys.`);
    let opName = keys[0];
    const fn = f[opName];
    // Strip the underscore from the end of the function name.
    if (opName.endsWith('_')) opName = opName.substring(0, opName.length - 1);
    // add an __op suffix to distinguish ops from kernels in tf.profile
    opName = opName + $e25ad0fc1c7fe06f$export$93114f1494faf9bb;
    // tslint:disable-next-line:no-any
    const f2 = (...args)=>{
        (0, $249f84ddb1ced836$export$33b63313cc511a3b).startScope(opName);
        try {
            const result = fn(...args);
            if ((0, $5f8d0ee7a8d35dfe$export$4369c812aac99591)(result)) console.error('Cannot return a Promise inside of tidy.');
            (0, $249f84ddb1ced836$export$33b63313cc511a3b).endScope(result);
            return result;
        } catch (ex) {
            (0, $249f84ddb1ced836$export$33b63313cc511a3b).endScope(null);
            throw ex;
        }
    };
    Object.defineProperty(f2, 'name', {
        value: opName,
        configurable: true
    });
    // tslint:disable-next-line:no-any
    return f2;
}


/**
 * Converts two real numbers to a complex number.
 *
 * Given a tensor `real` representing the real part of a complex number, and a
 * tensor `imag` representing the imaginary part of a complex number, this
 * operation returns complex numbers elementwise of the form [r0, i0, r1, i1],
 * where r represents the real part and i represents the imag part.
 *
 * The input tensors real and imag must have the same shape.
 *
 * ```js
 * const real = tf.tensor1d([2.25, 3.25]);
 * const imag = tf.tensor1d([4.75, 5.75]);
 * const complex = tf.complex(real, imag);
 *
 * complex.print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $175eb29e145dcf53$var$complex_(real, imag) {
    const $real = (0, $010a899b69412c72$export$ede379c4c939d71a)(real, 'real', 'complex');
    const $imag = (0, $010a899b69412c72$export$ede379c4c939d71a)(imag, 'imag', 'complex');
    $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782($real.shape, $imag.shape, `real and imag shapes, ${$real.shape} and ${$imag.shape}, ` + `must match in call to tf.complex().`);
    const inputs = {
        real: $real,
        imag: $imag
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$50ceb3fb9926e63e), inputs);
}
const $175eb29e145dcf53$export$83a0e34f1302825b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    complex_: $175eb29e145dcf53$var$complex_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $a024938a45229223$export$f41686c891d7ebce(values, shape, inferredShape, dtype) {
    if (dtype == null) dtype = (0, $5f8d0ee7a8d35dfe$export$2005775d905d2dc2)(values);
    else if (dtype === 'complex64') throw new Error(`Cannot construct a complex64 tensor directly. ` + `Please use tf.complex(real, imag).`);
    if ((0, $206e8e4148e423f6$export$db4071ca636ae03b)(values) || (0, $206e8e4148e423f6$export$12371c78da2a116a)(values)) {
        if (dtype !== 'float32' && dtype !== 'int32') throw new Error(`Creating tensor from GPU data only supports ` + `'float32'|'int32' dtype, while the dtype is ${dtype}.`);
        return (0, $249f84ddb1ced836$export$33b63313cc511a3b).backend.createTensorFromGPUData(values, shape || inferredShape, dtype);
    }
    if (!(0, $e10678764dab7ea0$export$b119cc7e1840e59c)(values) && !Array.isArray(values) && typeof values !== 'number' && typeof values !== 'boolean' && typeof values !== 'string') throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
    // Verify that the shape matches the inferred shape.
    if (shape != null) {
        (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
        const providedSize = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(shape);
        const inferredSize = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(inferredShape);
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(providedSize === inferredSize, ()=>`Based on the provided shape, [${shape}], the tensor should have ` + `${providedSize} values but has ${inferredSize}`);
        for(let i = 0; i < inferredShape.length; ++i){
            const inferred = inferredShape[i];
            const flatDimsDontMatch = i === inferredShape.length - 1 ? inferred !== (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(shape.slice(i)) : true;
            (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(inferredShape[i] === shape[i] || !flatDimsDontMatch, ()=>`Error creating a new Tensor. Inferred shape ` + `(${inferredShape}) does not match the provided ` + `shape (${shape}). `);
        }
    }
    if (!(0, $e10678764dab7ea0$export$b119cc7e1840e59c)(values) && !Array.isArray(values)) values = [
        values
    ];
    shape = shape || inferredShape;
    values = dtype !== 'string' ? (0, $e10678764dab7ea0$export$965adc581230795c)(values, dtype) : (0, $e10678764dab7ea0$export$bffa455ba8c619a6)(values, [], true);
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).makeTensor(values, shape, dtype);
}


function $a82c6773538d9e64$export$65df3ad1ad888abb(values, shape, dtype) {
    const inferredShape = (0, $010a899b69412c72$export$467a8ad638b9ad20)(values, dtype);
    return (0, $a024938a45229223$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /* Type definitions for exporting and importing of models. */ /**
 * A map from Tensor dtype to number of bytes per element of the Tensor.
 */ const $198abd4496908653$export$8103dee73e5eaa46 = {
    'float32': 4,
    'float16': 2,
    'int32': 4,
    'uint16': 2,
    'uint8': 1,
    'bool': 1,
    'complex64': 8
};



class $ccfe888395cdb33c$export$fd7a5551e5344016 {
    /**
     * Concatenate a number of ArrayBuffers into one.
     *
     * @param buffers An array of ArrayBuffers to concatenate, or a single
     *     ArrayBuffer.
     * @returns Result of concatenating `buffers` in order.
     */ static join(buffers) {
        return new $ccfe888395cdb33c$export$fd7a5551e5344016(buffers).slice();
    }
    constructor(buffers){
        this.shards = [];
        this.previousShardIndex = 0;
        if (buffers == null) return;
        // Normalize the `buffers` input to be `ArrayBuffer[]`.
        if (!(buffers instanceof Array)) buffers = [
            buffers
        ];
        buffers = buffers.map((bufferOrTypedArray)=>{
            if ($e10678764dab7ea0$export$b119cc7e1840e59c(bufferOrTypedArray)) return bufferOrTypedArray.buffer;
            return bufferOrTypedArray;
        });
        // Skip setting up shards if there are no buffers.
        if (buffers.length === 0) return;
        this.bufferUniformSize = buffers[0].byteLength;
        let start = 0;
        for(let i = 0; i < buffers.length; i++){
            const buffer = buffers[i];
            // Check that all buffers except the last one have the same length.
            if (i !== buffers.length - 1 && buffer.byteLength !== this.bufferUniformSize) // Unset the buffer uniform size, since the buffer sizes are not
            // uniform.
            this.bufferUniformSize = undefined;
            // Create the shards, including their start and end points.
            const end = start + buffer.byteLength;
            this.shards.push({
                buffer: buffer,
                start: start,
                end: end
            });
            start = end;
        }
        // Set the byteLength
        if (this.shards.length === 0) this.byteLength = 0;
        this.byteLength = this.shards[this.shards.length - 1].end;
    }
    slice(start = 0, end = this.byteLength) {
        // If there are no shards, then the CompositeArrayBuffer was initialized
        // with no data.
        if (this.shards.length === 0) return new ArrayBuffer(0);
        // NaN is treated as zero for slicing. This matches ArrayBuffer's behavior.
        start = isNaN(Number(start)) ? 0 : start;
        end = isNaN(Number(end)) ? 0 : end;
        // Fix the bounds to within the array.
        start = Math.max(0, start);
        end = Math.min(this.byteLength, end);
        if (end <= start) return new ArrayBuffer(0);
        const startShardIndex = this.findShardForByte(start);
        if (startShardIndex === -1) // This should not happen since the start and end indices are always
        // within 0 and the composite array's length.
        throw new Error(`Could not find start shard for byte ${start}`);
        const size = end - start;
        const outputBuffer = new ArrayBuffer(size);
        const outputArray = new Uint8Array(outputBuffer);
        let sliced = 0;
        for(let i = startShardIndex; i < this.shards.length; i++){
            const shard = this.shards[i];
            const globalStart = start + sliced;
            const localStart = globalStart - shard.start;
            const outputStart = sliced;
            const globalEnd = Math.min(end, shard.end);
            const localEnd = globalEnd - shard.start;
            const outputSlice = new Uint8Array(shard.buffer, localStart, localEnd - localStart);
            outputArray.set(outputSlice, outputStart);
            sliced += outputSlice.length;
            if (end < shard.end) break;
        }
        return outputBuffer;
    }
    /**
     * Get the index of the shard that contains the byte at `byteIndex`.
     */ findShardForByte(byteIndex) {
        if (this.shards.length === 0 || byteIndex < 0 || byteIndex >= this.byteLength) return -1;
        // If the buffers have a uniform size, compute the shard directly.
        if (this.bufferUniformSize != null) {
            this.previousShardIndex = Math.floor(byteIndex / this.bufferUniformSize);
            return this.previousShardIndex;
        }
        // If the buffers don't have a uniform size, we need to search for the
        // shard. That means we need a function to check where the byteIndex lies
        // relative to a given shard.
        function check(shard) {
            if (byteIndex < shard.start) return -1;
            if (byteIndex >= shard.end) return 1;
            return 0;
        }
        // For efficiency, try the previous shard first.
        if (check(this.shards[this.previousShardIndex]) === 0) return this.previousShardIndex;
        // Otherwise, use a generic search function.
        // This should almost never end up being used in practice since the weight
        // entries should always be in order.
        const index = $ccfe888395cdb33c$export$d76128d007d19019(this.shards, check);
        if (index === -1) return -1;
        this.previousShardIndex = index;
        return this.previousShardIndex;
    }
}
function $ccfe888395cdb33c$export$d76128d007d19019(sortedArray, compare) {
    // Binary search
    let min = 0;
    let max = sortedArray.length;
    while(min <= max){
        const middle = Math.floor((max - min) / 2) + min;
        const side = compare(sortedArray[middle]);
        if (side === 0) return middle;
        else if (side < 0) max = middle;
        else min = middle + 1;
    }
    return -1;
}


var $8c449c89295c3cc4$exports = {};

$parcel$export($8c449c89295c3cc4$exports, "enableProdMode", () => $8c449c89295c3cc4$export$1e73b1267274f27e);
$parcel$export($8c449c89295c3cc4$exports, "enableDebugMode", () => $8c449c89295c3cc4$export$ef8a131e8a882a3a);
$parcel$export($8c449c89295c3cc4$exports, "disableDeprecationWarnings", () => $8c449c89295c3cc4$export$cb100329fdb11914);
$parcel$export($8c449c89295c3cc4$exports, "deprecationWarn", () => $8c449c89295c3cc4$export$e46eea6a629d2da5);
$parcel$export($8c449c89295c3cc4$exports, "disposeVariables", () => $8c449c89295c3cc4$export$f22ce7a2fa538c48);
$parcel$export($8c449c89295c3cc4$exports, "engine", () => $8c449c89295c3cc4$export$d3c662a6136faebb);
$parcel$export($8c449c89295c3cc4$exports, "memory", () => $8c449c89295c3cc4$export$827b61424e8f52d2);
$parcel$export($8c449c89295c3cc4$exports, "profile", () => $8c449c89295c3cc4$export$4882ae973e0491e);
$parcel$export($8c449c89295c3cc4$exports, "tidy", () => $8c449c89295c3cc4$export$b841c6a213a653eb);
$parcel$export($8c449c89295c3cc4$exports, "dispose", () => $8c449c89295c3cc4$export$fcfbbcec2cb820d5);
$parcel$export($8c449c89295c3cc4$exports, "keep", () => $8c449c89295c3cc4$export$fae3166c418e0471);
$parcel$export($8c449c89295c3cc4$exports, "time", () => $8c449c89295c3cc4$export$2da9be4cfdb689b1);
$parcel$export($8c449c89295c3cc4$exports, "setBackend", () => $8c449c89295c3cc4$export$7953970fabc9c2);
$parcel$export($8c449c89295c3cc4$exports, "ready", () => $8c449c89295c3cc4$export$28ee1007e174a2a6);
$parcel$export($8c449c89295c3cc4$exports, "getBackend", () => $8c449c89295c3cc4$export$b098501f764cdf30);
$parcel$export($8c449c89295c3cc4$exports, "removeBackend", () => $8c449c89295c3cc4$export$c299110fbe92c80c);
$parcel$export($8c449c89295c3cc4$exports, "findBackend", () => $8c449c89295c3cc4$export$f94fbc07ea8e852e);
$parcel$export($8c449c89295c3cc4$exports, "findBackendFactory", () => $8c449c89295c3cc4$export$e4a6d214466a2c7b);
$parcel$export($8c449c89295c3cc4$exports, "registerBackend", () => $8c449c89295c3cc4$export$1ac8c3a90eff05d);
$parcel$export($8c449c89295c3cc4$exports, "backend", () => $8c449c89295c3cc4$export$32a253b6f8b50fb4);
$parcel$export($8c449c89295c3cc4$exports, "setPlatform", () => $8c449c89295c3cc4$export$5f05d56a0f2349cc);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $8c449c89295c3cc4$export$1e73b1267274f27e() {
    (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().set('PROD', true);
}
function $8c449c89295c3cc4$export$ef8a131e8a882a3a() {
    (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().set('DEBUG', true);
}
function $8c449c89295c3cc4$export$cb100329fdb11914() {
    (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().set('DEPRECATION_WARNINGS_ENABLED', false);
    console.warn(`TensorFlow.js deprecation warnings have been disabled.`);
}
function $8c449c89295c3cc4$export$e46eea6a629d2da5(msg) {
    if ((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('DEPRECATION_WARNINGS_ENABLED')) console.warn(msg + ' You can disable deprecation warnings with ' + 'tf.disableDeprecationWarnings().');
}
(0, $6c839404e55214b5$export$ca605c1d8919649f)($8c449c89295c3cc4$export$e46eea6a629d2da5);
function $8c449c89295c3cc4$export$f22ce7a2fa538c48() {
    (0, $249f84ddb1ced836$export$33b63313cc511a3b).disposeVariables();
}
function $8c449c89295c3cc4$export$d3c662a6136faebb() {
    return 0, $249f84ddb1ced836$export$33b63313cc511a3b;
}
function $8c449c89295c3cc4$export$827b61424e8f52d2() {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).memory();
}
function $8c449c89295c3cc4$export$4882ae973e0491e(f) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).profile(f);
}
function $8c449c89295c3cc4$export$b841c6a213a653eb(nameOrFn, fn) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).tidy(nameOrFn, fn);
}
function $8c449c89295c3cc4$export$fcfbbcec2cb820d5(container) {
    const tensors = (0, $28f820f91d9287a3$export$888c106d343989f5)(container);
    tensors.forEach((tensor)=>tensor.dispose());
}
function $8c449c89295c3cc4$export$fae3166c418e0471(result) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).keep(result);
}
function $8c449c89295c3cc4$export$2da9be4cfdb689b1(f) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).time(f);
}
function $8c449c89295c3cc4$export$7953970fabc9c2(backendName) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).setBackend(backendName);
}
function $8c449c89295c3cc4$export$28ee1007e174a2a6() {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).ready();
}
function $8c449c89295c3cc4$export$b098501f764cdf30() {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).backendName;
}
function $8c449c89295c3cc4$export$c299110fbe92c80c(name) {
    (0, $249f84ddb1ced836$export$33b63313cc511a3b).removeBackend(name);
}
function $8c449c89295c3cc4$export$f94fbc07ea8e852e(name) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).findBackend(name);
}
function $8c449c89295c3cc4$export$e4a6d214466a2c7b(name) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).findBackendFactory(name);
}
function $8c449c89295c3cc4$export$1ac8c3a90eff05d(name, factory, priority = 1) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).registerBackend(name, factory, priority);
}
function $8c449c89295c3cc4$export$32a253b6f8b50fb4() {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).backend;
}
function $8c449c89295c3cc4$export$5f05d56a0f2349cc(platformName, platform) {
    (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().setPlatform(platformName, platform);
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $3674b353dc6c3d42$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
/** Number of bytes reserved for the length of the string. (32bit integer). */ const $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH = 4;
async function $3674b353dc6c3d42$export$6c50c12dbd6168b(tensors, group) {
    // TODO(adarob, cais): Support quantization.
    const specs = [];
    const dataPromises = [];
    const names = Array.isArray(tensors) ? tensors.map((tensor)=>tensor.name) : Object.keys(tensors);
    for(let i = 0; i < names.length; ++i){
        const name = names[i];
        const t = Array.isArray(tensors) ? tensors[i].tensor : tensors[name];
        if (t.dtype !== 'float32' && t.dtype !== 'int32' && t.dtype !== 'bool' && t.dtype !== 'string' && t.dtype !== 'complex64') throw new Error(`Unsupported dtype in weight '${name}': ${t.dtype}`);
        const spec = {
            name: name,
            shape: t.shape,
            dtype: t.dtype
        };
        if (t.dtype === 'string') {
            const utf8bytes = new Promise(async (resolve)=>{
                const vals = await t.bytes();
                const totalNumBytes = vals.reduce((p, c)=>p + c.length, 0) + $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH * vals.length;
                const bytes = new Uint8Array(totalNumBytes);
                let offset = 0;
                for(let i = 0; i < vals.length; i++){
                    const val = vals[i];
                    const bytesOfLength = new Uint8Array(new Uint32Array([
                        val.length
                    ]).buffer);
                    bytes.set(bytesOfLength, offset);
                    offset += $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH;
                    bytes.set(val, offset);
                    offset += val.length;
                }
                resolve(bytes);
            });
            dataPromises.push(utf8bytes);
        } else dataPromises.push(t.data());
        if (group != null) spec.group = group;
        specs.push(spec);
    }
    const tensorValues = await Promise.all(dataPromises);
    return {
        data: $3674b353dc6c3d42$export$b9f790e5e2031778(tensorValues),
        specs: specs
    };
}
function $3674b353dc6c3d42$export$7a14c2428d4f4a2e(weightData, specs) {
    // TODO(adarob, cais): Support quantization.
    const compositeBuffer = new (0, $ccfe888395cdb33c$export$fd7a5551e5344016)(weightData);
    const out = {};
    let offset = 0;
    for (const spec of specs){
        const byteLength = $3674b353dc6c3d42$var$getWeightBytelength(spec, (start, end)=>{
            return compositeBuffer.slice(offset + start, offset + end);
        });
        out[spec.name] = $3674b353dc6c3d42$var$decodeWeight(spec, compositeBuffer.slice(offset, offset + byteLength));
        offset += byteLength;
    }
    return out;
}
function $3674b353dc6c3d42$var$getWeightBytelength(spec, slice) {
    const size = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(spec.shape);
    let bytesPerValue;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        bytesPerValue = (0, $198abd4496908653$export$8103dee73e5eaa46)[quantization.dtype];
    } else if (spec.dtype === 'string') {
        // Can not statically determine string length.
        let byteLength = 0;
        for(let i = 0; i < size; i++)byteLength += $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH + new Uint32Array(slice(byteLength, byteLength + $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH))[0];
        return byteLength;
    } else bytesPerValue = (0, $198abd4496908653$export$8103dee73e5eaa46)[spec.dtype];
    return size * bytesPerValue;
}
async function $3674b353dc6c3d42$var$getWeightBytelengthAsync(spec, slice) {
    const size = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(spec.shape);
    let bytesPerValue;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        bytesPerValue = (0, $198abd4496908653$export$8103dee73e5eaa46)[quantization.dtype];
    } else if (spec.dtype === 'string') {
        // Can not statically determine string length.
        let byteLength = 0;
        for(let i = 0; i < size; i++)byteLength += $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH + new Uint32Array(await slice(byteLength, byteLength + $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH))[0];
        return byteLength;
    } else bytesPerValue = (0, $198abd4496908653$export$8103dee73e5eaa46)[spec.dtype];
    return size * bytesPerValue;
}
function $3674b353dc6c3d42$var$decodeWeight(spec, byteBuffer) {
    const name = spec.name;
    const dtype = spec.dtype;
    const shape = spec.shape;
    const size = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(shape);
    let values;
    let offset = 0;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
            if (!('min' in quantization && 'scale' in quantization)) throw new Error(`Weight ${spec.name} with quantization ${quantization.dtype} ` + `doesn't have corresponding metadata min and scale.`);
        } else if (quantization.dtype === 'float16') {
            if (dtype !== 'float32') throw new Error(`Weight ${spec.name} is quantized with ${quantization.dtype} ` + `which only supports weights of type float32 not ${dtype}.`);
        } else throw new Error(`Weight ${spec.name} has unknown ` + `quantization dtype ${quantization.dtype}. ` + `Supported quantization dtypes are: ` + `'uint8', 'uint16', and 'float16'.`);
        const quantizationSizeFactor = (0, $198abd4496908653$export$8103dee73e5eaa46)[quantization.dtype];
        const quantizedArray = quantization.dtype === 'uint8' ? new Uint8Array(byteBuffer) : new Uint16Array(byteBuffer);
        if (dtype === 'float32') {
            if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
                values = new Float32Array(quantizedArray.length);
                for(let i = 0; i < quantizedArray.length; i++){
                    const v = quantizedArray[i];
                    values[i] = v * quantization.scale + quantization.min;
                }
            } else if (quantization.dtype === 'float16') {
                // TODO: This is inefficient. Make getFloat16Decoder efficient.
                const float16Decode = $3674b353dc6c3d42$export$6f94974d2b5810f7();
                values = float16Decode(quantizedArray);
            } else throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type float32.`);
        } else if (dtype === 'int32') {
            if (quantization.dtype !== 'uint8' && quantization.dtype !== 'uint16') throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type int32.`);
            values = new Int32Array(quantizedArray.length);
            for(let i = 0; i < quantizedArray.length; i++){
                const v = quantizedArray[i];
                values[i] = Math.round(v * quantization.scale + quantization.min);
            }
        } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
        offset += size * quantizationSizeFactor;
    } else if (dtype === 'string') {
        const size = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(spec.shape);
        values = [];
        for(let i = 0; i < size; i++){
            const byteLength = new Uint32Array(byteBuffer.slice(offset, offset + $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH))[0];
            offset += $3674b353dc6c3d42$var$NUM_BYTES_STRING_LENGTH;
            const bytes = new Uint8Array(byteBuffer.slice(offset, offset + byteLength));
            values.push(bytes);
            offset += byteLength;
        }
    } else {
        const dtypeFactor = (0, $198abd4496908653$export$8103dee73e5eaa46)[dtype];
        if (dtype === 'float32') values = new Float32Array(byteBuffer);
        else if (dtype === 'int32') values = new Int32Array(byteBuffer);
        else if (dtype === 'bool') values = new Uint8Array(byteBuffer);
        else if (dtype === 'complex64') {
            values = new Float32Array(byteBuffer);
            const real = new Float32Array(values.length / 2);
            const image = new Float32Array(values.length / 2);
            for(let i = 0; i < real.length; i++){
                real[i] = values[i * 2];
                image[i] = values[i * 2 + 1];
            }
            const realTensor = (0, $a82c6773538d9e64$export$65df3ad1ad888abb)(real, shape, 'float32');
            const imageTensor = (0, $a82c6773538d9e64$export$65df3ad1ad888abb)(image, shape, 'float32');
            const complexTensor = (0, $175eb29e145dcf53$export$83a0e34f1302825b)(realTensor, imageTensor);
            realTensor.dispose();
            imageTensor.dispose();
            return complexTensor;
        } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
        offset += size * dtypeFactor;
    }
    return (0, $a82c6773538d9e64$export$65df3ad1ad888abb)(values, shape, dtype);
}
async function $3674b353dc6c3d42$var$readToLength(reader, initialData, length) {
    let data = new Uint8Array(initialData);
    while(data.byteLength < length){
        const { done: done, value: value } = await reader.read();
        if (done && value == null) {
            const missing = length - data.byteLength;
            throw new Error(`Reader is done but ${missing} bytes are still expected`);
        }
        // TODO: Don't create a new array every loop.
        const newData = new Uint8Array(data.length + value.byteLength);
        newData.set(data, 0);
        newData.set(new Uint8Array(value), data.length);
        data = newData;
    }
    return data.buffer;
}
async function $3674b353dc6c3d42$export$6c19531ae9ba1204(weightStream, specs) {
    const tensors = {};
    const reader = weightStream.getReader();
    let data = new ArrayBuffer(0);
    for (const spec of specs){
        const byteLength = await $3674b353dc6c3d42$var$getWeightBytelengthAsync(spec, async (start, end)=>{
            data = await $3674b353dc6c3d42$var$readToLength(reader, data, end);
            return data.slice(start, end);
        });
        data = await $3674b353dc6c3d42$var$readToLength(reader, data, byteLength);
        // Slice the tensor out
        const tensorData = data.slice(0, byteLength);
        data = data.slice(byteLength);
        const weightTensor = $3674b353dc6c3d42$var$decodeWeight(spec, tensorData);
        tensors[spec.name] = weightTensor;
        // TODO(mattsoulanille): Better way to call uploadToGPU.
        // TODO(mattsoulanille): Make this work for webgl too.
        if ((0, $8c449c89295c3cc4$export$b098501f764cdf30)() === 'webgpu') {
            const b = (0, $8c449c89295c3cc4$export$32a253b6f8b50fb4)();
            if ('uploadToGPU' in b && (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(weightTensor.shape) >= (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().get('WEBGPU_CPU_HANDOFF_SIZE_THRESHOLD')) b.uploadToGPU(weightTensor.dataId);
        }
    }
    return tensors;
}
function $3674b353dc6c3d42$export$b9f790e5e2031778(xs) {
    // TODO(adarob, cais): Support quantization.
    if (xs === null) throw new Error(`Invalid input value: ${JSON.stringify(xs)}`);
    let totalByteLength = 0;
    // `normalizedXs` is here for this reason: a `TypedArray`'s `buffer'
    // can have a different byte length from that of the `TypedArray` itself,
    // for example, when the `TypedArray` is created from an offset in an
    // `ArrayBuffer`. `normliazedXs` holds `TypedArray`s whose `buffer`s match
    // the `TypedArray` in byte length. If an element of `xs` does not show
    // this property, a new `TypedArray` that satisfy this property will be
    // constructed and pushed into `normalizedXs`.
    const normalizedXs = [];
    xs.forEach((x)=>{
        totalByteLength += x.byteLength;
        // tslint:disable:no-any
        normalizedXs.push(x.byteLength === x.buffer.byteLength ? x : new x.constructor(x));
        if (!(x instanceof Float32Array || x instanceof Int32Array || x instanceof Uint8Array)) throw new Error(`Unsupported TypedArray subtype: ${x.constructor.name}`);
    // tslint:enable:no-any
    });
    const y = new Uint8Array(totalByteLength);
    let offset = 0;
    normalizedXs.forEach((x)=>{
        y.set(new Uint8Array(x.buffer), offset);
        offset += x.byteLength;
    });
    return y.buffer;
}
// Use Buffer on Node.js instead of Blob/atob/btoa
const $3674b353dc6c3d42$var$useNodeBuffer = typeof $3674b353dc6c3d42$require$Buffer !== 'undefined' && (typeof Blob === 'undefined' || typeof atob === 'undefined' || typeof btoa === 'undefined');
function $3674b353dc6c3d42$export$42600be9c932993b(str) {
    if ($3674b353dc6c3d42$var$useNodeBuffer) return $3674b353dc6c3d42$require$Buffer.byteLength(str, 'utf8');
    return new Blob([
        str
    ]).size;
}
function $3674b353dc6c3d42$export$28e753ea3e93cabf(buffer) {
    if ($3674b353dc6c3d42$var$useNodeBuffer) return $3674b353dc6c3d42$require$Buffer.from(buffer).toString('base64');
    const buf = new Uint8Array(buffer);
    let s = '';
    for(let i = 0, l = buf.length; i < l; i++)s += String.fromCharCode(buf[i]);
    return btoa(s);
}
function $3674b353dc6c3d42$export$aa941b9d243f1be4(str) {
    if ($3674b353dc6c3d42$var$useNodeBuffer) {
        const buf = $3674b353dc6c3d42$require$Buffer.from(str, 'base64');
        return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
    }
    const s = atob(str);
    const buffer = new Uint8Array(s.length);
    for(let i = 0; i < s.length; ++i)buffer.set([
        s.charCodeAt(i)
    ], i);
    return buffer.buffer;
}
function $3674b353dc6c3d42$export$9a3e9c78eb778da8(buffers) {
    return (0, $ccfe888395cdb33c$export$fd7a5551e5344016).join(buffers);
}
function $3674b353dc6c3d42$export$9bf319d8f74f51d1(path) {
    const SEPARATOR = '/';
    path = path.trim();
    while(path.endsWith(SEPARATOR))path = path.slice(0, path.length - 1);
    const items = path.split(SEPARATOR);
    return items[items.length - 1];
}
function $3674b353dc6c3d42$export$a725daa2cfaa7bd5(artifacts, manifest) {
    const result = {
        modelTopology: artifacts.modelTopology,
        format: artifacts.format,
        generatedBy: artifacts.generatedBy,
        convertedBy: artifacts.convertedBy,
        weightsManifest: manifest
    };
    if (artifacts.signature != null) result.signature = artifacts.signature;
    if (artifacts.userDefinedMetadata != null) result.userDefinedMetadata = artifacts.userDefinedMetadata;
    if (artifacts.modelInitializer != null) result.modelInitializer = artifacts.modelInitializer;
    if (artifacts.initializerSignature != null) result.initializerSignature = artifacts.initializerSignature;
    if (artifacts.trainingConfig != null) result.trainingConfig = artifacts.trainingConfig;
    return result;
}
function $3674b353dc6c3d42$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData) {
    const modelArtifacts = {
        modelTopology: modelJSON.modelTopology,
        format: modelJSON.format,
        generatedBy: modelJSON.generatedBy,
        convertedBy: modelJSON.convertedBy
    };
    if (modelJSON.trainingConfig != null) modelArtifacts.trainingConfig = modelJSON.trainingConfig;
    if (modelJSON.weightsManifest != null) {
        if (!weightSpecs) throw new Error('modelJSON has weightsManifest but weightSpecs is null');
        if (!weightData) throw new Error('modelJSON has weightsManifest but weightData is null');
        modelArtifacts.weightSpecs = weightSpecs;
        modelArtifacts.weightData = weightData;
    }
    if (modelJSON.signature != null) modelArtifacts.signature = modelJSON.signature;
    if (modelJSON.userDefinedMetadata != null) modelArtifacts.userDefinedMetadata = modelJSON.userDefinedMetadata;
    if (modelJSON.modelInitializer != null) modelArtifacts.modelInitializer = modelJSON.modelInitializer;
    if (modelJSON.initializerSignature != null) modelArtifacts.initializerSignature = modelJSON.initializerSignature;
    return modelArtifacts;
}
async function $3674b353dc6c3d42$export$b867c14eedd5b8a2(modelJSON, loadWeights) {
    let weightSpecs;
    let weightData;
    if (modelJSON.weightsManifest != null) [weightSpecs, weightData] = await loadWeights(modelJSON.weightsManifest);
    return $3674b353dc6c3d42$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData);
}
function $3674b353dc6c3d42$export$ece8b449d7d29272(modelArtifacts) {
    if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error('Expected JSON model topology, received ArrayBuffer.');
    return {
        dateSaved: new Date(),
        modelTopologyType: 'JSON',
        modelTopologyBytes: modelArtifacts.modelTopology == null ? 0 : $3674b353dc6c3d42$export$42600be9c932993b(JSON.stringify(modelArtifacts.modelTopology)),
        weightSpecsBytes: modelArtifacts.weightSpecs == null ? 0 : $3674b353dc6c3d42$export$42600be9c932993b(JSON.stringify(modelArtifacts.weightSpecs)),
        weightDataBytes: modelArtifacts.weightData == null ? 0 : new (0, $ccfe888395cdb33c$export$fd7a5551e5344016)(modelArtifacts.weightData).byteLength
    };
}
function $3674b353dc6c3d42$export$9f3fe06e8e8def44(weightsManifest) {
    const weightSpecs = [];
    for (const entry of weightsManifest)weightSpecs.push(...entry.weights);
    return weightSpecs;
}
/**
 * Computes mantisa table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 2048 mantissa lookup values.
 */ function $3674b353dc6c3d42$var$computeFloat16MantisaTable() {
    const convertMantissa = (i)=>{
        let m = i << 13;
        let e = 0;
        while((m & 0x00800000) === 0){
            e -= 0x00800000;
            m <<= 1;
        }
        m &= -8388609;
        e += 0x38800000;
        return m | e;
    };
    const mantisaTable = new Uint32Array(2048);
    mantisaTable[0] = 0;
    for(let i = 1; i < 1024; i++)mantisaTable[i] = convertMantissa(i);
    for(let i = 1024; i < 2048; i++)mantisaTable[i] = 0x38000000 + (i - 1024 << 13);
    return mantisaTable;
}
/**
 * Computes exponent table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 64 exponent lookup values.
 */ function $3674b353dc6c3d42$var$computeFloat16ExponentTable() {
    const exponentTable = new Uint32Array(64);
    exponentTable[0] = 0;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 31; i++)exponentTable[i] = i << 23;
    for(let i = 33; i < 63; i++)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    return exponentTable;
}
/**
 * Computes offset table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 6d offset values.
 */ function $3674b353dc6c3d42$var$computeFloat16OffsetTable() {
    const offsetTable = new Uint32Array(64);
    for(let i = 0; i < 64; i++)offsetTable[i] = 1024;
    offsetTable[0] = offsetTable[32] = 0;
    return offsetTable;
}
function $3674b353dc6c3d42$export$6f94974d2b5810f7() {
    // Algorithm is based off of
    // http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
    // Cache lookup tables
    const mantisaTable = $3674b353dc6c3d42$var$computeFloat16MantisaTable();
    const exponentTable = $3674b353dc6c3d42$var$computeFloat16ExponentTable();
    const offsetTable = $3674b353dc6c3d42$var$computeFloat16OffsetTable();
    return (quantizedArray)=>{
        const buffer = new ArrayBuffer(4 * quantizedArray.length);
        const bufferUint32View = new Uint32Array(buffer);
        for(let index = 0; index < quantizedArray.length; index++){
            const float16Bits = quantizedArray[index];
            const float32Bits = mantisaTable[offsetTable[float16Bits >> 10] + (float16Bits & 0x3ff)] + exponentTable[float16Bits >> 10];
            bufferUint32View[index] = float32Bits;
        }
        return new Float32Array(buffer);
    };
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $72f51ea9c3e59639$export$512275d398c0bdcd {
    constructor(){
        this.saveRouters = [];
        this.loadRouters = [];
    }
    static getInstance() {
        if ($72f51ea9c3e59639$export$512275d398c0bdcd.instance == null) $72f51ea9c3e59639$export$512275d398c0bdcd.instance = new $72f51ea9c3e59639$export$512275d398c0bdcd();
        return $72f51ea9c3e59639$export$512275d398c0bdcd.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerSaveRouter(saveRouter) {
        $72f51ea9c3e59639$export$512275d398c0bdcd.getInstance().saveRouters.push(saveRouter);
    }
    /**
     * Register a load-handler router.
     *
     * @param loadRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `load` method defined or `null`.
     */ static registerLoadRouter(loadRouter) {
        $72f51ea9c3e59639$export$512275d398c0bdcd.getInstance().loadRouters.push(loadRouter);
    }
    /**
     * Look up IOHandler for saving, given a URL-like string.
     *
     * @param url
     * @returns If only one match is found, an instance of IOHandler with the
     * `save` method defined. If no match is found, `null`.
     * @throws Error, if more than one match is found.
     */ static getSaveHandlers(url) {
        return $72f51ea9c3e59639$export$512275d398c0bdcd.getHandlers(url, 'save');
    }
    /**
     * Look up IOHandler for loading, given a URL-like string.
     *
     * @param url
     * @param loadOptions Optional, custom load options.
     * @returns All valid handlers for `url`, given the currently registered
     *   handler routers.
     */ static getLoadHandlers(url, loadOptions) {
        return $72f51ea9c3e59639$export$512275d398c0bdcd.getHandlers(url, 'load', loadOptions);
    }
    static getHandlers(url, handlerType, loadOptions) {
        const validHandlers = [];
        const routers = handlerType === 'load' ? $72f51ea9c3e59639$export$512275d398c0bdcd.getInstance().loadRouters : $72f51ea9c3e59639$export$512275d398c0bdcd.getInstance().saveRouters;
        routers.forEach((router)=>{
            const handler = router(url, loadOptions);
            if (handler !== null) validHandlers.push(handler);
        });
        return validHandlers;
    }
}
const $72f51ea9c3e59639$export$94da4683f36f634e = (loudRouter)=>$72f51ea9c3e59639$export$512275d398c0bdcd.registerSaveRouter(loudRouter);
const $72f51ea9c3e59639$export$8bf64df3d1fb9866 = (loudRouter)=>$72f51ea9c3e59639$export$512275d398c0bdcd.registerLoadRouter(loudRouter);
const $72f51ea9c3e59639$export$88af18fd9ddb62ff = (url)=>$72f51ea9c3e59639$export$512275d398c0bdcd.getSaveHandlers(url);
const $72f51ea9c3e59639$export$90c6c4d24103fa9a = (url, loadOptions)=>$72f51ea9c3e59639$export$512275d398c0bdcd.getLoadHandlers(url, loadOptions);



const $8dcbd320ae526cfe$var$DATABASE_NAME = 'tensorflowjs';
const $8dcbd320ae526cfe$var$DATABASE_VERSION = 1;
// Model data and ModelArtifactsInfo (metadata) are stored in two separate
// stores for efficient access of the list of stored models and their metadata.
// 1. The object store for model data: topology, weights and weight manifests.
const $8dcbd320ae526cfe$var$MODEL_STORE_NAME = 'models_store';
// 2. The object store for ModelArtifactsInfo, including meta-information such
//    as the type of topology (JSON vs binary), byte size of the topology, byte
//    size of the weights, etc.
const $8dcbd320ae526cfe$var$INFO_STORE_NAME = 'model_info_store';
async function $8dcbd320ae526cfe$export$24b6df48b2529372() {
    const idbFactory = $8dcbd320ae526cfe$var$getIndexedDBFactory();
    return new Promise((resolve, reject)=>{
        const deleteRequest = idbFactory.deleteDatabase($8dcbd320ae526cfe$var$DATABASE_NAME);
        deleteRequest.onsuccess = ()=>resolve();
        deleteRequest.onerror = (error)=>reject(error);
    });
}
function $8dcbd320ae526cfe$var$getIndexedDBFactory() {
    if (!(0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) // TODO(cais): Add more info about what IOHandler subtypes are available.
    //   Maybe point to a doc page on the web and/or automatically determine
    //   the available IOHandlers and print them in the error message.
    throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
    // tslint:disable-next-line:no-any
    const theWindow = typeof window === 'undefined' ? self : window;
    const factory = theWindow.indexedDB || theWindow.mozIndexedDB || theWindow.webkitIndexedDB || theWindow.msIndexedDB || theWindow.shimIndexedDB;
    if (factory == null) throw new Error('The current browser does not appear to support IndexedDB.');
    return factory;
}
function $8dcbd320ae526cfe$var$setUpDatabase(openRequest) {
    const db = openRequest.result;
    db.createObjectStore($8dcbd320ae526cfe$var$MODEL_STORE_NAME, {
        keyPath: 'modelPath'
    });
    db.createObjectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME, {
        keyPath: 'modelPath'
    });
}
/**
 * IOHandler subclass: Browser IndexedDB.
 *
 * See the doc string of `browserIndexedDB` for more details.
 */ class $8dcbd320ae526cfe$export$2c670ce804876090 {
    constructor(modelPath){
        this.indexedDB = $8dcbd320ae526cfe$var$getIndexedDBFactory();
        if (modelPath == null || !modelPath) throw new Error('For IndexedDB, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
    }
    async save(modelArtifacts) {
        // TODO(cais): Support saving GraphDef models.
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        return this.databaseAction(this.modelPath, modelArtifacts);
    }
    async load() {
        return this.databaseAction(this.modelPath);
    }
    /**
     * Perform database action to put model artifacts into or read model artifacts
     * from IndexedDB object store.
     *
     * Whether the action is put or get depends on whether `modelArtifacts` is
     * specified. If it is specified, the action will be put; otherwise the action
     * will be get.
     *
     * @param modelPath A unique string path for the model.
     * @param modelArtifacts If specified, it will be the model artifacts to be
     *   stored in IndexedDB.
     * @returns A `Promise` of `SaveResult`, if the action is put, or a `Promise`
     *   of `ModelArtifacts`, if the action is get.
     */ databaseAction(modelPath, modelArtifacts) {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($8dcbd320ae526cfe$var$DATABASE_NAME, $8dcbd320ae526cfe$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$8dcbd320ae526cfe$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                if (modelArtifacts == null) {
                    // Read model out from object store.
                    const modelTx = db.transaction($8dcbd320ae526cfe$var$MODEL_STORE_NAME, 'readonly');
                    const modelStore = modelTx.objectStore($8dcbd320ae526cfe$var$MODEL_STORE_NAME);
                    const getRequest = modelStore.get(this.modelPath);
                    getRequest.onsuccess = ()=>{
                        if (getRequest.result == null) {
                            db.close();
                            return reject(new Error(`Cannot find model with path '${this.modelPath}' ` + `in IndexedDB.`));
                        } else resolve(getRequest.result.modelArtifacts);
                    };
                    getRequest.onerror = (error)=>{
                        db.close();
                        return reject(getRequest.error);
                    };
                    modelTx.oncomplete = ()=>db.close();
                } else {
                    // Put model into object store.
                    // Concatenate all the model weights into a single ArrayBuffer. Large
                    // models (~1GB) have problems saving if they are not concatenated.
                    // TODO(mattSoulanille): Save large models to multiple indexeddb
                    // records.
                    modelArtifacts.weightData = (0, $ccfe888395cdb33c$export$fd7a5551e5344016).join(modelArtifacts.weightData);
                    const modelArtifactsInfo = (0, $3674b353dc6c3d42$export$ece8b449d7d29272)(modelArtifacts);
                    // First, put ModelArtifactsInfo into info store.
                    const infoTx = db.transaction($8dcbd320ae526cfe$var$INFO_STORE_NAME, 'readwrite');
                    let infoStore = infoTx.objectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME);
                    let putInfoRequest;
                    try {
                        putInfoRequest = infoStore.put({
                            modelPath: this.modelPath,
                            modelArtifactsInfo: modelArtifactsInfo
                        });
                    } catch (error) {
                        return reject(error);
                    }
                    let modelTx;
                    putInfoRequest.onsuccess = ()=>{
                        // Second, put model data into model store.
                        modelTx = db.transaction($8dcbd320ae526cfe$var$MODEL_STORE_NAME, 'readwrite');
                        const modelStore = modelTx.objectStore($8dcbd320ae526cfe$var$MODEL_STORE_NAME);
                        let putModelRequest;
                        try {
                            putModelRequest = modelStore.put({
                                modelPath: this.modelPath,
                                modelArtifacts: modelArtifacts,
                                modelArtifactsInfo: modelArtifactsInfo
                            });
                        } catch (error) {
                            // Sometimes, the serialized value is too large to store.
                            return reject(error);
                        }
                        putModelRequest.onsuccess = ()=>resolve({
                                modelArtifactsInfo: modelArtifactsInfo
                            });
                        putModelRequest.onerror = (error)=>{
                            // If the put-model request fails, roll back the info entry as
                            // well.
                            infoStore = infoTx.objectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME);
                            const deleteInfoRequest = infoStore.delete(this.modelPath);
                            deleteInfoRequest.onsuccess = ()=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                            deleteInfoRequest.onerror = (error)=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                        };
                    };
                    putInfoRequest.onerror = (error)=>{
                        db.close();
                        return reject(putInfoRequest.error);
                    };
                    infoTx.oncomplete = ()=>{
                        if (modelTx == null) db.close();
                        else modelTx.oncomplete = ()=>db.close();
                    };
                }
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}
$8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME = 'indexeddb://';
const $8dcbd320ae526cfe$export$7375c81acb8edf6e = (url)=>{
    if (!(0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME)) return $8dcbd320ae526cfe$export$a4d8901e5a950049(url.slice($8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME.length));
        else return null;
    }
};
(0, $72f51ea9c3e59639$export$512275d398c0bdcd).registerSaveRouter($8dcbd320ae526cfe$export$7375c81acb8edf6e);
(0, $72f51ea9c3e59639$export$512275d398c0bdcd).registerLoadRouter($8dcbd320ae526cfe$export$7375c81acb8edf6e);
function $8dcbd320ae526cfe$export$a4d8901e5a950049(modelPath) {
    return new $8dcbd320ae526cfe$export$2c670ce804876090(modelPath);
}
function $8dcbd320ae526cfe$var$maybeStripScheme(key) {
    return key.startsWith($8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME) ? key.slice($8dcbd320ae526cfe$export$2c670ce804876090.URL_SCHEME.length) : key;
}
class $8dcbd320ae526cfe$export$4b0775e2ff88802 {
    constructor(){
        this.indexedDB = $8dcbd320ae526cfe$var$getIndexedDBFactory();
    }
    async listModels() {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($8dcbd320ae526cfe$var$DATABASE_NAME, $8dcbd320ae526cfe$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$8dcbd320ae526cfe$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const tx = db.transaction($8dcbd320ae526cfe$var$INFO_STORE_NAME, 'readonly');
                const store = tx.objectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME);
                // tslint:disable:max-line-length
                // Need to cast `store` as `any` here because TypeScript's DOM
                // library does not have the `getAll()` method even though the
                // method is supported in the latest version of most mainstream
                // browsers:
                // https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/getAll
                // tslint:enable:max-line-length
                // tslint:disable-next-line:no-any
                const getAllInfoRequest = store.getAll();
                getAllInfoRequest.onsuccess = ()=>{
                    const out = {};
                    for (const item of getAllInfoRequest.result)out[item.modelPath] = item.modelArtifactsInfo;
                    resolve(out);
                };
                getAllInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getAllInfoRequest.error);
                };
                tx.oncomplete = ()=>db.close();
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
    async removeModel(path) {
        path = $8dcbd320ae526cfe$var$maybeStripScheme(path);
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($8dcbd320ae526cfe$var$DATABASE_NAME, $8dcbd320ae526cfe$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$8dcbd320ae526cfe$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const infoTx = db.transaction($8dcbd320ae526cfe$var$INFO_STORE_NAME, 'readwrite');
                const infoStore = infoTx.objectStore($8dcbd320ae526cfe$var$INFO_STORE_NAME);
                const getInfoRequest = infoStore.get(path);
                let modelTx;
                getInfoRequest.onsuccess = ()=>{
                    if (getInfoRequest.result == null) {
                        db.close();
                        return reject(new Error(`Cannot find model with path '${path}' ` + `in IndexedDB.`));
                    } else {
                        // First, delete the entry in the info store.
                        const deleteInfoRequest = infoStore.delete(path);
                        const deleteModelData = ()=>{
                            // Second, delete the entry in the model store.
                            modelTx = db.transaction($8dcbd320ae526cfe$var$MODEL_STORE_NAME, 'readwrite');
                            const modelStore = modelTx.objectStore($8dcbd320ae526cfe$var$MODEL_STORE_NAME);
                            const deleteModelRequest = modelStore.delete(path);
                            deleteModelRequest.onsuccess = ()=>resolve(getInfoRequest.result.modelArtifactsInfo);
                            deleteModelRequest.onerror = (error)=>reject(getInfoRequest.error);
                        };
                        // Proceed with deleting model data regardless of whether deletion
                        // of info data succeeds or not.
                        deleteInfoRequest.onsuccess = deleteModelData;
                        deleteInfoRequest.onerror = (error)=>{
                            deleteModelData();
                            db.close();
                            return reject(getInfoRequest.error);
                        };
                    }
                };
                getInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getInfoRequest.error);
                };
                infoTx.oncomplete = ()=>{
                    if (modelTx == null) db.close();
                    else modelTx.oncomplete = ()=>db.close();
                };
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





const $c74728762db9681f$var$PATH_SEPARATOR = '/';
const $c74728762db9681f$var$PATH_PREFIX = 'tensorflowjs_models';
const $c74728762db9681f$var$INFO_SUFFIX = 'info';
const $c74728762db9681f$var$MODEL_TOPOLOGY_SUFFIX = 'model_topology';
const $c74728762db9681f$var$WEIGHT_SPECS_SUFFIX = 'weight_specs';
const $c74728762db9681f$var$WEIGHT_DATA_SUFFIX = 'weight_data';
const $c74728762db9681f$var$MODEL_METADATA_SUFFIX = 'model_metadata';
function $c74728762db9681f$export$af2a48c9611db360() {
    if (!(0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') throw new Error("purgeLocalStorageModels() cannot proceed because local storage is unavailable in the current environment.");
    const LS = window.localStorage;
    const purgedModelPaths = [];
    for(let i = 0; i < LS.length; ++i){
        const key = LS.key(i);
        const prefix = $c74728762db9681f$var$PATH_PREFIX + $c74728762db9681f$var$PATH_SEPARATOR;
        if (key.startsWith(prefix) && key.length > prefix.length) {
            LS.removeItem(key);
            const modelName = $c74728762db9681f$var$getModelPathFromKey(key);
            if (purgedModelPaths.indexOf(modelName) === -1) purgedModelPaths.push(modelName);
        }
    }
    return purgedModelPaths;
}
function $c74728762db9681f$var$getModelKeys(path) {
    return {
        info: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$INFO_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR),
        topology: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$MODEL_TOPOLOGY_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR),
        weightSpecs: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$WEIGHT_SPECS_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR),
        weightData: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$WEIGHT_DATA_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR),
        modelMetadata: [
            $c74728762db9681f$var$PATH_PREFIX,
            path,
            $c74728762db9681f$var$MODEL_METADATA_SUFFIX
        ].join($c74728762db9681f$var$PATH_SEPARATOR)
    };
}
function $c74728762db9681f$var$removeItems(keys) {
    for (const key of Object.values(keys))window.localStorage.removeItem(key);
}
/**
 * Get model path from a local-storage key.
 *
 * E.g., 'tensorflowjs_models/my/model/1/info' --> 'my/model/1'
 *
 * @param key
 */ function $c74728762db9681f$var$getModelPathFromKey(key) {
    const items = key.split($c74728762db9681f$var$PATH_SEPARATOR);
    if (items.length < 3) throw new Error(`Invalid key format: ${key}`);
    return items.slice(1, items.length - 1).join($c74728762db9681f$var$PATH_SEPARATOR);
}
function $c74728762db9681f$var$maybeStripScheme(key) {
    return key.startsWith($c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME) ? key.slice($c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME.length) : key;
}
/**
 * IOHandler subclass: Browser Local Storage.
 *
 * See the doc string to `browserLocalStorage` for more details.
 */ class $c74728762db9681f$export$8984a84f7aef20de {
    constructor(modelPath){
        if (!(0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') // TODO(cais): Add more info about what IOHandler subtypes are
        // available.
        //   Maybe point to a doc page on the web and/or automatically determine
        //   the available IOHandlers and print them in the error message.
        throw new Error('The current environment does not support local storage.');
        this.LS = window.localStorage;
        if (modelPath == null || !modelPath) throw new Error('For local storage, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
        this.keys = $c74728762db9681f$var$getModelKeys(this.modelPath);
    }
    /**
     * Save model artifacts to browser local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @param modelArtifacts The model artifacts to be stored.
     * @returns An instance of SaveResult.
     */ async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        else {
            const topology = JSON.stringify(modelArtifacts.modelTopology);
            const weightSpecs = JSON.stringify(modelArtifacts.weightSpecs);
            const modelArtifactsInfo = (0, $3674b353dc6c3d42$export$ece8b449d7d29272)(modelArtifacts);
            // TODO(mattsoulanille): Support saving models over 2GB that exceed
            // Chrome's ArrayBuffer size limit.
            const weightBuffer = (0, $ccfe888395cdb33c$export$fd7a5551e5344016).join(modelArtifacts.weightData);
            try {
                this.LS.setItem(this.keys.info, JSON.stringify(modelArtifactsInfo));
                this.LS.setItem(this.keys.topology, topology);
                this.LS.setItem(this.keys.weightSpecs, weightSpecs);
                this.LS.setItem(this.keys.weightData, (0, $3674b353dc6c3d42$export$28e753ea3e93cabf)(weightBuffer));
                // Note that JSON.stringify doesn't write out keys that have undefined
                // values, so for some keys, we set undefined instead of a null-ish
                // value.
                const metadata = {
                    format: modelArtifacts.format,
                    generatedBy: modelArtifacts.generatedBy,
                    convertedBy: modelArtifacts.convertedBy,
                    signature: modelArtifacts.signature != null ? modelArtifacts.signature : undefined,
                    userDefinedMetadata: modelArtifacts.userDefinedMetadata != null ? modelArtifacts.userDefinedMetadata : undefined,
                    modelInitializer: modelArtifacts.modelInitializer != null ? modelArtifacts.modelInitializer : undefined,
                    initializerSignature: modelArtifacts.initializerSignature != null ? modelArtifacts.initializerSignature : undefined,
                    trainingConfig: modelArtifacts.trainingConfig != null ? modelArtifacts.trainingConfig : undefined
                };
                this.LS.setItem(this.keys.modelMetadata, JSON.stringify(metadata));
                return {
                    modelArtifactsInfo: modelArtifactsInfo
                };
            } catch (err) {
                // If saving failed, clean up all items saved so far.
                $c74728762db9681f$var$removeItems(this.keys);
                throw new Error(`Failed to save model '${this.modelPath}' to local storage: ` + `size quota being exceeded is a possible cause of this failure: ` + `modelTopologyBytes=${modelArtifactsInfo.modelTopologyBytes}, ` + `weightSpecsBytes=${modelArtifactsInfo.weightSpecsBytes}, ` + `weightDataBytes=${modelArtifactsInfo.weightDataBytes}.`);
            }
        }
    }
    /**
     * Load a model from local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @returns The loaded model (if loading succeeds).
     */ async load() {
        const info = JSON.parse(this.LS.getItem(this.keys.info));
        if (info == null) throw new Error(`In local storage, there is no model with name '${this.modelPath}'`);
        if (info.modelTopologyType !== 'JSON') throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
        const out = {};
        // Load topology.
        const topology = JSON.parse(this.LS.getItem(this.keys.topology));
        if (topology == null) throw new Error(`In local storage, the topology of model '${this.modelPath}' ` + `is missing.`);
        out.modelTopology = topology;
        // Load weight specs.
        const weightSpecs = JSON.parse(this.LS.getItem(this.keys.weightSpecs));
        if (weightSpecs == null) throw new Error(`In local storage, the weight specs of model '${this.modelPath}' ` + `are missing.`);
        out.weightSpecs = weightSpecs;
        // Load meta-data fields.
        const metadataString = this.LS.getItem(this.keys.modelMetadata);
        if (metadataString != null) {
            const metadata = JSON.parse(metadataString);
            out.format = metadata.format;
            out.generatedBy = metadata.generatedBy;
            out.convertedBy = metadata.convertedBy;
            if (metadata.signature != null) out.signature = metadata.signature;
            if (metadata.userDefinedMetadata != null) out.userDefinedMetadata = metadata.userDefinedMetadata;
            if (metadata.modelInitializer != null) out.modelInitializer = metadata.modelInitializer;
            if (metadata.initializerSignature != null) out.initializerSignature = metadata.initializerSignature;
            if (metadata.trainingConfig != null) out.trainingConfig = metadata.trainingConfig;
        }
        // Load weight data.
        const weightDataBase64 = this.LS.getItem(this.keys.weightData);
        if (weightDataBase64 == null) throw new Error(`In local storage, the binary weight values of model ` + `'${this.modelPath}' are missing.`);
        out.weightData = (0, $3674b353dc6c3d42$export$aa941b9d243f1be4)(weightDataBase64);
        return out;
    }
}
$c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME = 'localstorage://';
const $c74728762db9681f$export$64ff64fd6b1180ae = (url)=>{
    if (!(0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME)) return $c74728762db9681f$export$96d8dd89e6c22307(url.slice($c74728762db9681f$export$8984a84f7aef20de.URL_SCHEME.length));
        else return null;
    }
};
(0, $72f51ea9c3e59639$export$512275d398c0bdcd).registerSaveRouter($c74728762db9681f$export$64ff64fd6b1180ae);
(0, $72f51ea9c3e59639$export$512275d398c0bdcd).registerLoadRouter($c74728762db9681f$export$64ff64fd6b1180ae);
function $c74728762db9681f$export$96d8dd89e6c22307(modelPath) {
    return new $c74728762db9681f$export$8984a84f7aef20de(modelPath);
}
class $c74728762db9681f$export$bb7e7fb445a616f4 {
    constructor(){
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER'), ()=>'Current environment is not a web browser');
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(typeof window === 'undefined' || typeof window.localStorage !== 'undefined', ()=>'Current browser does not appear to support localStorage');
        this.LS = window.localStorage;
    }
    async listModels() {
        const out = {};
        const prefix = $c74728762db9681f$var$PATH_PREFIX + $c74728762db9681f$var$PATH_SEPARATOR;
        const suffix = $c74728762db9681f$var$PATH_SEPARATOR + $c74728762db9681f$var$INFO_SUFFIX;
        for(let i = 0; i < this.LS.length; ++i){
            const key = this.LS.key(i);
            if (key.startsWith(prefix) && key.endsWith(suffix)) {
                const modelPath = $c74728762db9681f$var$getModelPathFromKey(key);
                out[modelPath] = JSON.parse(this.LS.getItem(key));
            }
        }
        return out;
    }
    async removeModel(path) {
        path = $c74728762db9681f$var$maybeStripScheme(path);
        const keys = $c74728762db9681f$var$getModelKeys(path);
        if (this.LS.getItem(keys.info) == null) throw new Error(`Cannot find model at path '${path}'`);
        const info = JSON.parse(this.LS.getItem(keys.info));
        $c74728762db9681f$var$removeItems(keys);
        return info;
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Classes and functions for model management across multiple storage mediums.
 *
 * Supported client actions:
 * - Listing models on all registered storage mediums.
 * - Remove model by URL from any registered storage mediums, by using URL
 *   string.
 * - Moving or copying model from one path to another in the same medium or from
 *   one medium to another, by using URL strings.
 */ 

const $15605ea4e29ff52d$var$URL_SCHEME_SUFFIX = '://';
class $15605ea4e29ff52d$export$ccf7f72dec8f0028 {
    constructor(){
        this.managers = {};
    }
    static getInstance() {
        if ($15605ea4e29ff52d$export$ccf7f72dec8f0028.instance == null) $15605ea4e29ff52d$export$ccf7f72dec8f0028.instance = new $15605ea4e29ff52d$export$ccf7f72dec8f0028();
        return $15605ea4e29ff52d$export$ccf7f72dec8f0028.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerManager(scheme, manager) {
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(scheme != null, ()=>'scheme must not be undefined or null.');
        if (scheme.endsWith($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX)) scheme = scheme.slice(0, scheme.indexOf($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX));
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(scheme.length > 0, ()=>'scheme must not be an empty string.');
        const registry = $15605ea4e29ff52d$export$ccf7f72dec8f0028.getInstance();
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(registry.managers[scheme] == null, ()=>`A model store manager is already registered for scheme '${scheme}'.`);
        registry.managers[scheme] = manager;
    }
    static getManager(scheme) {
        const manager = $15605ea4e29ff52d$export$ccf7f72dec8f0028.getInstance().managers[scheme];
        if (manager == null) throw new Error(`Cannot find model manager for scheme '${scheme}'`);
        return manager;
    }
    static getSchemes() {
        return Object.keys($15605ea4e29ff52d$export$ccf7f72dec8f0028.getInstance().managers);
    }
}
/**
 * Helper method for parsing a URL string into a scheme and a path.
 *
 * @param url E.g., 'localstorage://my-model'
 * @returns A dictionary with two fields: scheme and path.
 *   Scheme: e.g., 'localstorage' in the example above.
 *   Path: e.g., 'my-model' in the example above.
 */ function $15605ea4e29ff52d$var$parseURL(url) {
    if (url.indexOf($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX) === -1) throw new Error(`The url string provided does not contain a scheme. ` + `Supported schemes are: ` + `${$15605ea4e29ff52d$export$ccf7f72dec8f0028.getSchemes().join(',')}`);
    return {
        scheme: url.split($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX)[0],
        path: url.split($15605ea4e29ff52d$var$URL_SCHEME_SUFFIX)[1]
    };
}
async function $15605ea4e29ff52d$var$cloneModelInternal(sourceURL, destURL, deleteSource = false) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(sourceURL !== destURL, ()=>`Old path and new path are the same: '${sourceURL}'`);
    const loadHandlers = (0, $72f51ea9c3e59639$export$512275d398c0bdcd).getLoadHandlers(sourceURL);
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(loadHandlers.length > 0, ()=>`Copying failed because no load handler is found for source URL ${sourceURL}.`);
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(loadHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `load handlers for source URL ${sourceURL}.`);
    const loadHandler = loadHandlers[0];
    const saveHandlers = (0, $72f51ea9c3e59639$export$512275d398c0bdcd).getSaveHandlers(destURL);
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(saveHandlers.length > 0, ()=>`Copying failed because no save handler is found for destination ` + `URL ${destURL}.`);
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(saveHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `save handlers for destination URL ${destURL}.`);
    const saveHandler = saveHandlers[0];
    const sourceScheme = $15605ea4e29ff52d$var$parseURL(sourceURL).scheme;
    const sourcePath = $15605ea4e29ff52d$var$parseURL(sourceURL).path;
    const sameMedium = sourceScheme === $15605ea4e29ff52d$var$parseURL(sourceURL).scheme;
    const modelArtifacts = await loadHandler.load();
    // If moving within the same storage medium, remove the old model as soon as
    // the loading is done. Without doing this, it is possible that the combined
    // size of the two models will cause the cloning to fail.
    if (deleteSource && sameMedium) await $15605ea4e29ff52d$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    const saveResult = await saveHandler.save(modelArtifacts);
    // If moving between mediums, the deletion is done after the save succeeds.
    // This guards against the case in which saving to the destination medium
    // fails.
    if (deleteSource && !sameMedium) await $15605ea4e29ff52d$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    return saveResult.modelArtifactsInfo;
}
/**
 * List all models stored in registered storage mediums.
 *
 * For a web browser environment, the registered mediums are Local Storage and
 * IndexedDB.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @returns A `Promise` of a dictionary mapping URLs of existing models to
 * their model artifacts info. URLs include medium-specific schemes, e.g.,
 *   'indexeddb://my/model/1'. Model artifacts info include type of the
 * model's topology, byte sizes of the topology, weights, etc.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $15605ea4e29ff52d$export$8d63af86d795ece4() {
    const schemes = $15605ea4e29ff52d$export$ccf7f72dec8f0028.getSchemes();
    const out = {};
    for (const scheme of schemes){
        const schemeOut = await $15605ea4e29ff52d$export$ccf7f72dec8f0028.getManager(scheme).listModels();
        for(const path in schemeOut){
            const url = scheme + $15605ea4e29ff52d$var$URL_SCHEME_SUFFIX + path;
            out[url] = schemeOut[path];
        }
    }
    return out;
}
/**
 * Remove a model specified by URL from a registered storage medium.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @param url A URL to a stored model, with a scheme prefix, e.g.,
 *   'localstorage://my-model-1', 'indexeddb://my/model/2'.
 * @returns ModelArtifactsInfo of the deleted model (if and only if deletion
 *   is successful).
 * @throws Error if deletion fails, e.g., if no model exists at `path`.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $15605ea4e29ff52d$export$e71037184d1ad0fd(url) {
    const schemeAndPath = $15605ea4e29ff52d$var$parseURL(url);
    const manager = $15605ea4e29ff52d$export$ccf7f72dec8f0028.getManager(schemeAndPath.scheme);
    return manager.removeModel(schemeAndPath.path);
}
/**
 * Copy a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Copying within a storage medium, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Copying between two storage mediums, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Copy the model, from Local Storage to IndexedDB.
 * await tf.io.copyModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove both models.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of copying.
 * @param destURL Destination URL of copying.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if copying fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $15605ea4e29ff52d$export$b5971478866000ed(sourceURL, destURL) {
    const deleteSource = false;
    return $15605ea4e29ff52d$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}
/**
 * Move a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Moving within a storage medium, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Moving between two storage mediums, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Move the model, from Local Storage to IndexedDB.
 * await tf.io.moveModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove the moved model.
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of moving.
 * @param destURL Destination URL of moving.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if moving fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $15605ea4e29ff52d$export$598f168272f4fec2(sourceURL, destURL) {
    const deleteSource = true;
    return $15605ea4e29ff52d$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}



class $14d84372e9b9718d$export$c812b315576f1552 {
    constructor(){
        // For setTimeoutCustom
        this.messageName = 'setTimeoutCustom';
        this.functionRefs = [];
        this.handledMessageCount = 0;
        this.hasEventListener = false;
    }
    fetch(path, init) {
        return fetch(path, init);
    }
    now() {
        return performance.now();
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Browser's encoder only supports utf-8, but got ${encoding}`);
        if (this.textEncoder == null) this.textEncoder = new TextEncoder();
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        return new TextDecoder(encoding).decode(bytes);
    }
    // If the setTimeout nesting level is greater than 5 and timeout is less
    // than 4ms, timeout will be clamped to 4ms, which hurts the perf.
    // Interleaving window.postMessage and setTimeout will trick the browser and
    // avoid the clamp.
    setTimeoutCustom(functionRef, delay) {
        if (typeof window === 'undefined' || !(0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('USE_SETTIMEOUTCUSTOM')) {
            setTimeout(functionRef, delay);
            return;
        }
        this.functionRefs.push(functionRef);
        setTimeout(()=>{
            window.postMessage({
                name: this.messageName,
                index: this.functionRefs.length - 1
            }, '*');
        }, delay);
        if (!this.hasEventListener) {
            this.hasEventListener = true;
            window.addEventListener('message', (event)=>{
                if (event.source === window && event.data.name === this.messageName) {
                    event.stopPropagation();
                    const functionRef = this.functionRefs[event.data.index];
                    functionRef();
                    this.handledMessageCount++;
                    if (this.handledMessageCount === this.functionRefs.length) {
                        this.functionRefs = [];
                        this.handledMessageCount = 0;
                    }
                }
            }, true);
        }
    }
    isTypedArray(a) {
        return (0, $4ecc12e21462e25f$export$632e6430b2d784cd)(a);
    }
}
if ((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().get('IS_BROWSER')) {
    (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().setPlatform('browser', new $14d84372e9b9718d$export$c812b315576f1552());
    // Register LocalStorage IOHandler
    try {
        (0, $15605ea4e29ff52d$export$ccf7f72dec8f0028).registerManager((0, $c74728762db9681f$export$8984a84f7aef20de).URL_SCHEME, new (0, $c74728762db9681f$export$bb7e7fb445a616f4)());
    } catch (err) {}
    // Register IndexedDB IOHandler
    try {
        (0, $15605ea4e29ff52d$export$ccf7f72dec8f0028).registerManager((0, $8dcbd320ae526cfe$export$2c670ce804876090).URL_SCHEME, new (0, $8dcbd320ae526cfe$export$4b0775e2ff88802)());
    } catch (err) {}
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $f7d9d89bc67d90a6$export$fc0623918121e18f = {
    // tslint:disable-next-line:no-require-imports
    importFetch: ()=>(parcelRequire("kjyEk"))
};
let $f7d9d89bc67d90a6$var$systemFetch;
function $f7d9d89bc67d90a6$export$ab67f817cc7ff6dc() {
    $f7d9d89bc67d90a6$var$systemFetch = null;
}
function $f7d9d89bc67d90a6$export$fec6b32271d1a551(fetchFn) {
    $f7d9d89bc67d90a6$var$systemFetch = fetchFn;
}
function $f7d9d89bc67d90a6$export$f53da9ce5ba19de0() {
    return $f7d9d89bc67d90a6$var$systemFetch;
}

class $f7d9d89bc67d90a6$export$7befb6c3de272049 {
    constructor(){
        // tslint:disable-next-line:no-require-imports
        this.util = (parcelRequire("kjyEk"));
        // According to the spec, the built-in encoder can do only UTF-8 encoding.
        // https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder/TextEncoder
        this.textEncoder = new this.util.TextEncoder();
    }
    fetch(path, requestInits) {
        if ((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().global.fetch != null) return (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().global.fetch(path, requestInits);
        if ($f7d9d89bc67d90a6$var$systemFetch == null) $f7d9d89bc67d90a6$var$systemFetch = $f7d9d89bc67d90a6$export$fc0623918121e18f.importFetch();
        return $f7d9d89bc67d90a6$var$systemFetch(path, requestInits);
    }
    now() {
        const time = $cfae44f0dfdf62c0$exports.hrtime();
        return time[0] * 1000 + time[1] / 1000000;
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Node built-in encoder only supports utf-8, but got ${encoding}`);
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        if (bytes.length === 0) return '';
        return new this.util.TextDecoder(encoding).decode(bytes);
    }
    isTypedArray(a) {
        return this.util.types.isFloat32Array(a) || this.util.types.isInt32Array(a) || this.util.types.isUint8Array(a) || this.util.types.isUint8ClampedArray(a);
    }
}
if ((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().get('IS_NODE') && !(0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().get('IS_BROWSER')) (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().setPlatform('node', new $f7d9d89bc67d90a6$export$7befb6c3de272049());


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $d99273e33e31a4d2$export$ab1029bcae9ddb4a(shape, dtype = 'float32', values) {
    dtype = dtype || 'float32';
    $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5(shape);
    return new (0, $6c839404e55214b5$export$350df26cd52e08e1)(shape, dtype, values);
}


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Casts a `tf.Tensor` to a new dtype.
 *
 * ```js
 * const x = tf.tensor1d([1.5, 2.5, 3]);
 * tf.cast(x, 'int32').print();
 * ```
 * @param x The input tensor to be casted.
 * @param dtype The dtype to cast the input tensor to.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $d61a75572b5954a3$var$cast_(x, dtype) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'cast');
    // Sanity checks.
    if (!$5f8d0ee7a8d35dfe$export$a6a3df2178ac9529(dtype)) throw new Error(`Failed to cast to unknown dtype ${dtype}`);
    if (dtype === 'string' && $x.dtype !== 'string' || dtype !== 'string' && $x.dtype === 'string') throw new Error('Only strings can be casted to strings');
    const inputs = {
        x: $x
    };
    const attrs = {
        dtype: dtype
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$107ecfb3d1ccbd77), inputs, attrs);
}
const $d61a75572b5954a3$export$f2db7d5238e1d23f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    cast_: $d61a75572b5954a3$var$cast_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a new tensor with the same values and shape as the specified
 * tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 *
 * x.clone().print();
 * ```
 *
 * @param x The tensor to clone.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $44a9d8b42e3e34af$var$clone_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'clone', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    // Note this op is called tf.identity in python. Hence the kernel name used
    // here.
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$544bf02140fa9a77), inputs);
}
const $44a9d8b42e3e34af$export$9cd59f9826255e47 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    clone_: $44a9d8b42e3e34af$var$clone_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Prints information about the `tf.Tensor` including its data.
 *
 * ```js
 * const verbose = true;
 * tf.tensor2d([1, 2, 3, 4], [2, 2]).print(verbose);
 * ```
 * @param x The tensor to be printed.
 * @param verbose Whether to print verbose information about the ` Tensor`,
 * including dtype and size.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $8a5834107ae482be$export$c2d084dc44961371(x, verbose = false) {
    console.log(x.toString(verbose));
}



(0, $249f84ddb1ced836$export$ca8737f6c8c212b8)();
const $6aa8f84e3c4f0382$var$opHandler = {
    buffer: $d99273e33e31a4d2$export$ab1029bcae9ddb4a,
    cast: $d61a75572b5954a3$export$f2db7d5238e1d23f,
    clone: $44a9d8b42e3e34af$export$9cd59f9826255e47,
    print: $8a5834107ae482be$export$c2d084dc44961371
};
(0, $6c839404e55214b5$export$1efe8d8b4884ad31)($6aa8f84e3c4f0382$var$opHandler);


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Adds two `tf.Tensor`s element-wise, A + B. Supports broadcasting.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 *
 * ```js
 * // Broadcast add a with b.
 * const a = tf.scalar(5);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 * @param a The first `tf.Tensor` to add.
 * @param b The second `tf.Tensor` to add. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $c90bd95bc0e58efa$var$add_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'add');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'add');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$d0265b2c425512d6), inputs);
}
const $c90bd95bc0e58efa$export$e16d8520af44a096 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    add_: $c90bd95bc0e58efa$var$add_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 * The result is rounded with floor function.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.floorDiv(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.floorDiv(b).print();  // or tf.floorDiv(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $47c5bf11930fb3f9$var$floorDiv_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'floorDiv');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'floorDiv');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$d79b5692ede26c2f), inputs);
}
const $47c5bf11930fb3f9$export$112397bc52715a8 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    floorDiv_: $47c5bf11930fb3f9$var$floorDiv_
});



/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $15928a4fee5ff81f$var$div_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'div');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'div');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    if ($a.dtype === 'int32' && $b.dtype === 'int32') return (0, $47c5bf11930fb3f9$export$112397bc52715a8)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$b9880b86e1014bb8), inputs, attrs);
}
const $15928a4fee5ff81f$export$159d9494db57879b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    div_: $15928a4fee5ff81f$var$div_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Multiplies two `tf.Tensor`s element-wise, A * B. Supports broadcasting.
 *
 * We also expose `tf.mulStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([2, 3, 4, 5]);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 *
 * ```js
 * // Broadcast mul a with b.
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.scalar(5);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 * @param a The first tensor to multiply.
 * @param b The second tensor to multiply. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $e8cd0739d0f73f4b$var$mul_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'mul');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'mul');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$f14f83b3b531d498), inputs);
}
const $e8cd0739d0f73f4b$export$6e3a27864ab166fe = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    mul_: $e8cd0739d0f73f4b$var$mul_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes square root of the input `tf.Tensor` element-wise: `y = sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.sqrt().print();  // or tf.sqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d8742a69331de610$var$sqrt_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'sqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$21ab404ab9d512a6), inputs);
}
const $d8742a69331de610$export$eba8049fb5020b81 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sqrt_: $d8742a69331de610$var$sqrt_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * Computes square of `x` element-wise: `x ^ 2`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.sqrt(2), -1]);
 *
 * x.square().print();  // or tf.square(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $03801900ae8a72ab$var$square_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'square');
    const attrs = {};
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel('Square', {
        x: $x
    }, attrs);
}
const $03801900ae8a72ab$export$dd4f28cef696bc7d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    square_: $03801900ae8a72ab$var$square_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with all elements set to 0 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.zerosLike(x).print();
 * ```
 *
 * @param x The tensor of required shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $64c118098861f580$var$zerosLike_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'zerosLike');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$430969a37eda1e88), inputs);
}
const $64c118098861f580$export$cb1f824e7733584d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    zerosLike_: $64c118098861f580$var$zerosLike_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Provided `f(x)`, returns another function `g(x, dy?)`, which gives the
 * gradient of `f(x)` with respect to `x`.
 *
 * If `dy` is provided, the gradient of `f(x).mul(dy).sum()` with respect to
 * `x` is computed instead. `f(x)` must take a single tensor `x` and return a
 * single tensor `y`. If `f()` takes multiple inputs, use `tf.grads` instead.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.grad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * g(x).print();
 * ```
 *
 * ```js
 * // f(x) = x ^ 3
 * const f = x => x.pow(tf.scalar(3, 'int32'));
 * // f'(x) = 3x ^ 2
 * const g = tf.grad(f);
 * // f''(x) = 6x
 * const gg = tf.grad(g);
 *
 * const x = tf.tensor1d([2, 3]);
 * gg(x).print();
 * ```
 *
 * @param f The function f(x), to compute gradient for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$c24429b22bb73814(f) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$f6e2535fb5126e54(f), ()=>'The f passed in grad(f) must be a function');
    return (x, dy)=>{
        // x can be of any dtype, thus null as the last argument.
        const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'tf.grad', 'string_or_numeric');
        const $dy = dy != null ? (0, $010a899b69412c72$export$ede379c4c939d71a)(dy, 'dy', 'tf.grad') : null;
        return (0, $249f84ddb1ced836$export$33b63313cc511a3b).tidy(()=>{
            const { value: value, grads: grads } = (0, $249f84ddb1ced836$export$33b63313cc511a3b).gradients(()=>f($x), [
                $x
            ], $dy);
            if ($dy != null) $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782(value.shape, $dy.shape, "The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)");
            $694041655139423f$var$checkGrads(grads);
            return grads[0];
        });
    };
}
/**
 * Provided `f(x1, x2,...)`, returns another function `g([x1, x2,...], dy?)`,
 * which gives an array of gradients of `f()` with respect to each input
 * [`x1`,`x2`,...].
 *
 * If `dy` is passed when calling `g()`, the gradient of
 * `f(x1,...).mul(dy).sum()` with respect to each input is computed instead.
 * The provided `f` must take one or more tensors and return a single tensor
 * `y`. If `f()` takes a single input, we recommend using `tf.grad` instead.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df / da = b, df / db = a
 * const g = tf.grads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const [da, db] = g([a, b]);
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @param f The function `f(x1, x2,...)` to compute gradients for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$3f3749f5340c73f2(f) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$f6e2535fb5126e54(f), ()=>'The f passed in grads(f) must be a function');
    return (args, dy)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(Array.isArray(args), ()=>"The args passed in grads(f)(args) must be an array of `Tensor`s or `TensorLike`s");
        // args can be of any dtype, thus null as the last argument.
        const $args = (0, $010a899b69412c72$export$758e66616b4d410b)(args, 'args', 'tf.grads', 'string_or_numeric');
        const $dy = dy != null ? (0, $010a899b69412c72$export$ede379c4c939d71a)(dy, 'dy', 'tf.grads') : null;
        return (0, $249f84ddb1ced836$export$33b63313cc511a3b).tidy(()=>{
            const { value: value, grads: grads } = (0, $249f84ddb1ced836$export$33b63313cc511a3b).gradients(()=>f(...$args), $args, $dy);
            if ($dy != null) $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782(value.shape, $dy.shape, "The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
            $694041655139423f$var$checkGrads(grads);
            return grads;
        });
    };
}
/**
 * Like `tf.grad`, but also returns the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grad: The gradient of `f(x)` w.r.t. `x` (result of `tf.grad`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.valueAndGrad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * const {value, grad} = g(x);
 *
 * console.log('value');
 * value.print();
 * console.log('grad');
 * grad.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$9fbe39d4dcb3921e(f) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$f6e2535fb5126e54(f), ()=>'The f passed in valueAndGrad(f) must be a function');
    return (x, dy)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814), ()=>'The x passed in valueAndGrad(f)(x) must be a tensor');
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dy == null || dy instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814), ()=>'The dy passed in valueAndGrad(f)(x, dy) must be a tensor');
        const { grads: grads, value: value } = (0, $249f84ddb1ced836$export$33b63313cc511a3b).gradients(()=>f(x), [
            x
        ], dy);
        $694041655139423f$var$checkGrads(grads);
        return {
            grad: grads[0],
            value: value
        };
    };
}
/**
 * Like `tf.grads`, but returns also the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grads: The gradients of `f()` w.r.t. each input (result of `tf.grads`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df/da = b, df/db = a
 * const g = tf.valueAndGrads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const {value, grads} = g([a, b]);
 *
 * const [da, db] = grads;
 *
 * console.log('value');
 * value.print();
 *
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$c03281a254ef3cf0(f) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$f6e2535fb5126e54(f), ()=>'The f passed in valueAndGrads(f) must be a function');
    return (args, dy)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(Array.isArray(args) && args.every((arg)=>arg instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814)), ()=>"The args passed in valueAndGrads(f)(args) must be array of tensors");
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dy == null || dy instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814), ()=>'The dy passed in valueAndGrads(f)(args, dy) must be a tensor');
        const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).gradients(()=>f(...args), args, dy);
        if (dy != null) $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782(res.value.shape, dy.shape, "The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
        $694041655139423f$var$checkGrads(res.grads);
        return res;
    };
}
/**
 * Computes and returns the gradient of f(x) with respect to the list of
 * trainable variables provided by `varList`. If no list is provided, it
 * defaults to all trainable variables.
 *
 * ```js
 * const a = tf.variable(tf.tensor1d([3, 4]));
 * const b = tf.variable(tf.tensor1d([5, 6]));
 * const x = tf.tensor1d([1, 2]);
 *
 * // f(a, b) = a * x ^ 2 + b * x
 * const f = () => a.mul(x.square()).add(b.mul(x)).sum();
 * // df/da = x ^ 2, df/db = x
 * const {value, grads} = tf.variableGrads(f);
 *
 * Object.keys(grads).forEach(varName => grads[varName].print());
 * ```
 *
 * @param f The function to execute. f() should return a scalar.
 * @param varList The list of variables to compute the gradients with respect
 *     to. Defaults to all trainable variables.
 * @returns An object with the following keys and values:
 *   - `value`: The value of the function `f`.
 *   - `grads`: A map from the names of the variables to the gradients.
 *     If the `varList` argument is provided explicitly and contains a subset of
 *     non-trainable variables, this map in the return value will contain keys
 *     that map the names of the non-trainable variables to `null`.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$c756d9ed08b9677f(f, varList) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$f6e2535fb5126e54(f), ()=>'The f passed in variableGrads(f) must be a function');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(varList == null || Array.isArray(varList) && varList.every((v)=>v instanceof (0, $6c839404e55214b5$export$c867a5c9595a1350)), ()=>"The varList passed in variableGrads(f, varList) must be an array of variables");
    const specifiedVarList = varList != null;
    if (!specifiedVarList) {
        // Get all of the trainable variables.
        varList = [];
        for(const varName in (0, $249f84ddb1ced836$export$33b63313cc511a3b).registeredVariables)varList.push((0, $249f84ddb1ced836$export$33b63313cc511a3b).registeredVariables[varName]);
    }
    const specifiedNonTrainable = specifiedVarList ? varList.filter((variable)=>!variable.trainable) : null;
    // Prune non-trainable variables.
    const originalVarCount = varList.length;
    varList = varList.filter((variable)=>variable.trainable);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(varList.length > 0, ()=>`variableGrads() expects at least one of the input variables to ` + `be trainable, but none of the ${originalVarCount} variables is ` + `trainable.`);
    const allowNoGradients = true;
    const { value: value, grads: grads } = (0, $249f84ddb1ced836$export$33b63313cc511a3b).gradients(f, varList, null, allowNoGradients);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(grads.some((g)=>g != null), ()=>"Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize().");
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(value.rank === 0, ()=>`The f passed in variableGrads(f) must return a scalar, but it ` + `returned a rank-${value.rank} tensor`);
    const namedGrads = {};
    varList.forEach((v, i)=>{
        if (grads[i] != null) namedGrads[v.name] = grads[i];
    });
    if (specifiedNonTrainable != null) // If varList is explicitly provided and contains non-trainable values,
    // add them to the returned gradients with `null` values.
    specifiedNonTrainable.forEach((v)=>namedGrads[v.name] = null);
    return {
        value: value,
        grads: namedGrads
    };
}
/**
 * Overrides the gradient computation of a function `f`.
 *
 * Takes a function
 * `f(...inputs, save) => {value: Tensor, gradFunc: (dy, saved) => Tensor[]}`
 * and returns another function `g(...inputs)` which takes the same inputs as
 * `f`. When called, `g` returns `f().value`. In backward mode, custom gradients
 * with respect to each input of `f` are computed using `f().gradFunc`.
 *
 * The `save` function passed to `f` should be used for saving tensors needed
 * in the gradient. And the `saved` passed to the `gradFunc` is a
 * `NamedTensorMap`, which contains those saved tensors.
 *
 * ```js
 * const customOp = tf.customGrad((x, save) => {
 *   // Save x to make sure it's available later for the gradient.
 *   save([x]);
 *   // Override gradient of our custom x ^ 2 op to be dy * abs(x);
 *   return {
 *     value: x.square(),
 *     // Note `saved.x` which points to the `x` we saved earlier.
 *     gradFunc: (dy, saved) => [dy.mul(saved[0].abs())]
 *   };
 * });
 *
 * const x = tf.tensor1d([-1, -2, 3]);
 * const dx = tf.grad(x => customOp(x));
 *
 * console.log(`f(x):`);
 * customOp(x).print();
 * console.log(`f'(x):`);
 * dx(x).print();
 * ```
 *
 * @param f The function to evaluate in forward mode, which should return
 *     `{value: Tensor, gradFunc: (dy, saved) => Tensor[]}`, where `gradFunc`
 *     returns the custom gradients of `f` with respect to its inputs.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $694041655139423f$export$5519f0eeb00c44e5(f) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).customGrad(f);
}
function $694041655139423f$var$checkGrads(grads) {
    const numNullGradients = grads.filter((g)=>g == null).length;
    if (numNullGradients > 0) throw new Error(`Cannot compute gradient of y=f(x) with respect to x. Make sure that
    the f you passed encloses all operations that lead from x to y.`);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $2937f01f2600aea0$export$7de3fcd3cdba2a46(value, dtype) {
    if (((0, $e10678764dab7ea0$export$b119cc7e1840e59c)(value) && dtype !== 'string' || Array.isArray(value)) && dtype !== 'complex64') throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
    if (dtype === 'string' && (0, $e10678764dab7ea0$export$b119cc7e1840e59c)(value) && !(value instanceof Uint8Array)) throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
    const shape = [];
    const inferredShape = [];
    return (0, $a024938a45229223$export$f41686c891d7ebce)(value, shape, inferredShape, dtype);
}


var $42b0cce2828065a4$exports = {};

$parcel$export($42b0cce2828065a4$exports, "Serializable", () => $42b0cce2828065a4$export$64782a6a7800f48c);
$parcel$export($42b0cce2828065a4$exports, "SerializationMap", () => $42b0cce2828065a4$export$3a868b20f0f2f6c0);
$parcel$export($42b0cce2828065a4$exports, "registerClass", () => $42b0cce2828065a4$export$a3f7d716dc76cb2e);
$parcel$export($42b0cce2828065a4$exports, "getRegisteredName", () => $42b0cce2828065a4$export$33f51542dd5bdf78);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * Maps to mapping between the custom object and its name.
 *
 * After registering a custom class, these two maps will add key-value pairs
 * for the class object and the registered name.
 *
 * Therefore we can get the relative registered name by calling
 * getRegisteredName() function.
 *
 * For example:
 * GLOBAL_CUSTOM_OBJECT: {key=registeredName: value=corresponding
 * CustomObjectClass}
 *
 * GLOBAL_CUSTOM_NAMES: {key=CustomObjectClass: value=corresponding
 * registeredName}
 *
 */ const $42b0cce2828065a4$var$GLOBAL_CUSTOM_OBJECT = new Map();
const $42b0cce2828065a4$var$GLOBAL_CUSTOM_NAMES = new Map();
class $42b0cce2828065a4$export$64782a6a7800f48c {
    /**
     * Return the class name for this class to use in serialization contexts.
     *
     * Generally speaking this will be the same thing that constructor.name
     * would have returned.  However, the class name needs to be robust
     * against minification for serialization/deserialization to work properly.
     *
     * There's also places such as initializers.VarianceScaling, where
     * implementation details between different languages led to different
     * class hierarchies and a non-leaf node is used for serialization purposes.
     */ getClassName() {
        return this.constructor.className;
    }
    /**
     * Creates an instance of T from a ConfigDict.
     *
     * This works for most descendants of serializable.  A few need to
     * provide special handling.
     * @param cls A Constructor for the class to instantiate.
     * @param config The Configuration for the object.
     */ /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
class $42b0cce2828065a4$export$3a868b20f0f2f6c0 {
    constructor(){
        this.classNameMap = {};
    }
    /**
     * Returns the singleton instance of the map.
     */ static getMap() {
        if ($42b0cce2828065a4$export$3a868b20f0f2f6c0.instance == null) $42b0cce2828065a4$export$3a868b20f0f2f6c0.instance = new $42b0cce2828065a4$export$3a868b20f0f2f6c0();
        return $42b0cce2828065a4$export$3a868b20f0f2f6c0.instance;
    }
    /**
     * Registers the class as serializable.
     */ static register(cls) {
        $42b0cce2828065a4$export$3a868b20f0f2f6c0.getMap().classNameMap[cls.className] = [
            cls,
            cls.fromConfig
        ];
    }
}
function $42b0cce2828065a4$export$a3f7d716dc76cb2e(cls, pkg, name) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(cls.className != null, ()=>`Class being registered does not have the static className ` + `property defined.`);
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(typeof cls.className === 'string', ()=>`className is required to be a string, but got type ` + typeof cls.className);
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(cls.className.length > 0, ()=>`Class being registered has an empty-string as its className, ` + `which is disallowed.`);
    if (typeof pkg === 'undefined') pkg = 'Custom';
    if (typeof name === 'undefined') name = cls.className;
    const className = name;
    const registerName = pkg + '>' + className;
    $42b0cce2828065a4$export$3a868b20f0f2f6c0.register(cls);
    $42b0cce2828065a4$var$GLOBAL_CUSTOM_OBJECT.set(registerName, cls);
    $42b0cce2828065a4$var$GLOBAL_CUSTOM_NAMES.set(cls, registerName);
    return cls;
}
function $42b0cce2828065a4$export$33f51542dd5bdf78(cls) {
    if ($42b0cce2828065a4$var$GLOBAL_CUSTOM_NAMES.has(cls)) return $42b0cce2828065a4$var$GLOBAL_CUSTOM_NAMES.get(cls);
    else return cls.className;
}


class $f39e0de69b839287$export$69ae9293516e70f0 extends (0, $42b0cce2828065a4$export$64782a6a7800f48c) {
    /**
     * Executes `f()` and minimizes the scalar output of `f()` by computing
     * gradients of y with respect to the list of trainable variables provided by
     * `varList`. If no list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to minimize.
     * @param returnCost Whether to return the scalar cost value produced by
     * executing `f()`.
     * @param varList An optional list of variables to update. If specified, only
     * the trainable variables in varList will be updated by minimize. Defaults to
     * all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ minimize(f, returnCost = false, varList) {
        const { value: value, grads: grads } = this.computeGradients(f, varList);
        if (varList != null) {
            const gradArray = varList.map((v)=>({
                    name: v.name,
                    tensor: grads[v.name]
                }));
            this.applyGradients(gradArray);
        } else this.applyGradients(grads);
        // Dispose gradients.
        (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(grads);
        if (returnCost) return value;
        else {
            value.dispose();
            return null;
        }
    }
    /**
     * The number of iterations that this optimizer instance has been invoked for.
     */ get iterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return this.iterations_;
    }
    incrementIterations() {
        this.iterations_ = this.iterations + 1;
    }
    /**
     * Executes f() and computes the gradient of the scalar output of f() with
     * respect to the list of trainable variables provided by `varList`. If no
     * list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to use for computing
     * gradients with respect to variables.
     * @param varList An optional list of variables to compute gradients with
     * respect to. If specified, only the trainable variables in varList will have
     * gradients computed with respect to. Defaults to all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ computeGradients(f, varList) {
        return (0, $694041655139423f$export$c756d9ed08b9677f)(f, varList);
    }
    /**
     * Dispose the variables (if any) owned by this optimizer instance.
     */ dispose() {
        if (this.iterations_ != null) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.iterations_);
    }
    async saveIterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return {
            name: 'iter',
            // TODO(cais): Use 'int64' type when available.
            tensor: (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(this.iterations_, 'int32')
        };
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for this optimizer yet.');
    }
    async setWeights(weightValues) {
        throw new Error(`setWeights() is not implemented for this optimizer class ` + `${this.getClassName()}`);
    }
    /**
     * Extract the first element of the weight values and set it
     * as the iterations counter variable of this instance of optimizer.
     *
     * @param weightValues
     * @returns Weight values with the first element consumed and excluded.
     */ async extractIterations(weightValues) {
        this.iterations_ = (await weightValues[0].tensor.data())[0];
        return weightValues.slice(1);
    }
}
Object.defineProperty($f39e0de69b839287$export$69ae9293516e70f0, Symbol.hasInstance, {
    value: (instance)=>{
        return instance.minimize != null && instance.computeGradients != null && instance.applyGradients != null;
    }
});


class $081c1e1a002596a7$export$d80a766c536c9aaf extends (0, $f39e0de69b839287$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adadelta';
    }
    constructor(learningRate, rho, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.rho = rho;
        this.epsilon = epsilon;
        this.accumulatedGrads = [];
        this.accumulatedUpdates = [];
        if (epsilon == null) this.epsilon = (0, $249f84ddb1ced836$export$33b63313cc511a3b).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $249f84ddb1ced836$export$33b63313cc511a3b).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedGrads[i] == null) this.accumulatedGrads[i] = {
                originalName: `${name}/accum_grad`,
                variable: (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>(0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable))
            };
            if (this.accumulatedUpdates[i] == null) this.accumulatedUpdates[i] = {
                originalName: `${name}/accum_var`,
                variable: (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>(0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            const accumulatedUpdate = this.accumulatedUpdates[i].variable;
            (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
                const newAccumulatedGrad = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(accumulatedGrad, this.rho), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $03801900ae8a72ab$export$dd4f28cef696bc7d)(gradient), 1 - this.rho));
                const updates = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $d8742a69331de610$export$eba8049fb5020b81)((0, $c90bd95bc0e58efa$export$e16d8520af44a096)(accumulatedUpdate, this.epsilon)), (0, $d8742a69331de610$export$eba8049fb5020b81)((0, $c90bd95bc0e58efa$export$e16d8520af44a096)(accumulatedGrad, this.epsilon))), gradient);
                const newAccumulatedUpdate = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(accumulatedUpdate, this.rho), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $03801900ae8a72ab$export$dd4f28cef696bc7d)(updates), 1 - this.rho));
                accumulatedGrad.assign(newAccumulatedGrad);
                accumulatedUpdate.assign(newAccumulatedUpdate);
                const newValue = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(updates, -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedUpdates != null) {
            (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedGrads.map((v)=>v.variable));
            (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedUpdates.map((v)=>v.variable));
        }
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedGrads,
            ...this.accumulatedUpdates
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedGrads = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedUpdates = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'rho': this.rho,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['rho'], config['epsilon']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` filled with a scalar value.
 *
 * ```js
 * tf.fill([2, 2], 4).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param value The scalar value to fill the tensor with.
 * @param dtype The type of an element in the resulting tensor. Defaults to
 *     'float32' if the given param value is a number, otherwise 'string'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $c5b09a3759406f8a$export$9563e054e6f787fb(shape, value, dtype) {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    dtype = dtype || (0, $5f8d0ee7a8d35dfe$export$2005775d905d2dc2)(value);
    const attrs = {
        shape: shape,
        value: value,
        dtype: dtype
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$ffffe40bfa0649a3), {}, attrs);
}






class $52dc4bd6634a3583$export$fa35e48f6f1caa57 extends (0, $f39e0de69b839287$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adagrad';
    }
    constructor(learningRate, initialAccumulatorValue = 0.1){
        super();
        this.learningRate = learningRate;
        this.initialAccumulatorValue = initialAccumulatorValue;
        this.accumulatedGrads = [];
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $249f84ddb1ced836$export$33b63313cc511a3b).registeredVariables[name];
            if (this.accumulatedGrads[i] == null) {
                const trainable = false;
                this.accumulatedGrads[i] = {
                    originalName: `${name}/accumulator`,
                    variable: (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>(0, $c5b09a3759406f8a$export$9563e054e6f787fb)(value.shape, this.initialAccumulatorValue).variable(trainable))
                };
            }
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
                const newAccumulatedGrad = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(accumulatedGrad, (0, $03801900ae8a72ab$export$dd4f28cef696bc7d)(gradient));
                accumulatedGrad.assign(newAccumulatedGrad);
                const newValue = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $15928a4fee5ff81f$export$159d9494db57879b)(gradient, (0, $d8742a69331de610$export$eba8049fb5020b81)((0, $c90bd95bc0e58efa$export$e16d8520af44a096)(newAccumulatedGrad, (0, $249f84ddb1ced836$export$33b63313cc511a3b).backend.epsilon()))), -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedGrads != null) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedGrads.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulatedGrads.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulatedGrads = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'initialAccumulatorValue': this.initialAccumulatorValue
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['initialAccumulatorValue']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the power of one `tf.Tensor` to another. Supports broadcasting.
 *
 * Given a `tf.Tensor` x and a `tf.Tensor` y, this operation computes x^y for
 * corresponding elements in x and y. The result's dtype will be the upcasted
 * type of the `base` and `exp` dtypes.
 *
 * ```js
 * const a = tf.tensor([[2, 3], [4, 5]])
 * const b = tf.tensor([[1, 2], [3, 0]]).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 *
 * ```js
 * const a = tf.tensor([[1, 2], [3, 4]])
 * const b = tf.tensor(2).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 * We also expose `powStrict` which has the same signature as this op and
 * asserts that `base` and `exp` are the same shape (does not broadcast).
 *
 * @param base The base `tf.Tensor` to pow element-wise.
 * @param exp The exponent `tf.Tensor` to pow element-wise.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $76ec324d3dfd83d3$var$pow_(base, exp) {
    let $base = (0, $010a899b69412c72$export$ede379c4c939d71a)(base, 'base', 'pow');
    let $exp = (0, $010a899b69412c72$export$ede379c4c939d71a)(exp, 'exp', 'pow');
    [$base, $exp] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($base, $exp);
    const inputs = {
        a: $base,
        b: $exp
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$ce28d653ec559ee), inputs);
}
const $76ec324d3dfd83d3$export$9c297f60e22e3389 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    pow_: $76ec324d3dfd83d3$var$pow_
});





/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Subtracts two `tf.Tensor`s element-wise, A - B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 *
 * ```js
 * // Broadcast subtract a with b.
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.scalar(5);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 * @param a The first `tf.Tensor` to subtract from.
 * @param b The second `tf.Tensor` to be subtracted. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $555d660851b98db3$var$sub_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'sub');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'sub');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$d7a01e11500dfb6f), inputs);
}
const $555d660851b98db3$export$f93b5905241a7cca = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sub_: $555d660851b98db3$var$sub_
});




class $8e5923bf3349c4f0$export$de1938eb5fee8ee2 extends (0, $f39e0de69b839287$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adam';
    }
    constructor(learningRate, beta1, beta2, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.accumulatedFirstMoment = [];
        this.accumulatedSecondMoment = [];
        (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            // accB* will be updated by batch.
            this.accBeta1 = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(beta1).variable();
            this.accBeta2 = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(beta2).variable();
        });
        if (epsilon == null) this.epsilon = (0, $249f84ddb1ced836$export$33b63313cc511a3b).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            const oneMinusAccBeta1 = (0, $555d660851b98db3$export$f93b5905241a7cca)(1, this.accBeta1);
            const oneMinusAccBeta2 = (0, $555d660851b98db3$export$f93b5905241a7cca)(1, this.accBeta2);
            varNames.forEach((name, i)=>{
                const value = (0, $249f84ddb1ced836$export$33b63313cc511a3b).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>(0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable))
                };
                if (this.accumulatedSecondMoment[i] == null) this.accumulatedSecondMoment[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>(0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable))
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const secondMoment = this.accumulatedSecondMoment[i].variable;
                const newFirstMoment = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(firstMoment, this.beta1), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(gradient, 1 - this.beta1));
                const newSecondMoment = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(secondMoment, this.beta2), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $03801900ae8a72ab$export$dd4f28cef696bc7d)(gradient), 1 - this.beta2));
                const biasCorrectedFirstMoment = (0, $15928a4fee5ff81f$export$159d9494db57879b)(newFirstMoment, oneMinusAccBeta1);
                const biasCorrectedSecondMoment = (0, $15928a4fee5ff81f$export$159d9494db57879b)(newSecondMoment, oneMinusAccBeta2);
                firstMoment.assign(newFirstMoment);
                secondMoment.assign(newSecondMoment);
                const newValue = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $15928a4fee5ff81f$export$159d9494db57879b)(biasCorrectedFirstMoment, (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $d8742a69331de610$export$eba8049fb5020b81)(biasCorrectedSecondMoment), this.epsilon)), -this.learningRate), value);
                value.assign(newValue);
            });
            this.accBeta1.assign((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(this.accBeta1, this.beta1));
            this.accBeta2.assign((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(this.accBeta2, this.beta2));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.accBeta2.dispose();
        if (this.accumulatedFirstMoment != null) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedSecondMoment != null) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedSecondMoment.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedFirstMoment,
            ...this.accumulatedSecondMoment
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            this.accBeta1.assign((0, $76ec324d3dfd83d3$export$9c297f60e22e3389)(this.beta1, this.iterations_ + 1));
            this.accBeta2.assign((0, $76ec324d3dfd83d3$export$9c297f60e22e3389)(this.beta2, this.iterations_ + 1));
        });
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedFirstMoment = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedSecondMoment = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes absolute value element-wise: `abs(x)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.abs().print();  // or tf.abs(x)
 * ```
 * @param x The input `tf.Tensor`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $551d87f9cd40f29c$var$abs_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'abs');
    if ($x.dtype === 'complex64') {
        const inputs = {
            x: $x
        };
        return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$32902e58f1b48f4b), inputs);
    } else {
        const inputs = {
            x: $x
        };
        return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$b73c596ee8758a66), inputs);
    }
}
const $551d87f9cd40f29c$export$2335f513bbd82c6d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    abs_: $551d87f9cd40f29c$var$abs_
});




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



var $642a122b4608acc0$exports = {};

$parcel$export($642a122b4608acc0$exports, "getBroadcastDims", () => $642a122b4608acc0$export$fc823784344690e0);
$parcel$export($642a122b4608acc0$exports, "getReductionAxes", () => $642a122b4608acc0$export$9f11ec258a9b2804);
$parcel$export($642a122b4608acc0$exports, "assertAndGetBroadcastShape", () => $642a122b4608acc0$export$a3e2a38a57ec8318);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Returns the dimensions in the input shape that are broadcasted to
 * produce the provided output shape.
 *
 * The returned dimensions are 0-indexed and sorted. An example:
 * inShape = [4, 1, 3]
 * outShape = [5, 4, 3, 3]
 * result = [1]. Dimension 1 (2nd dimension of input) gets broadcasted 1 => 3.
 */ function $642a122b4608acc0$export$fc823784344690e0(inShape, outShape) {
    const inRank = inShape.length;
    const dims = [];
    for(let i = 0; i < inRank; i++){
        const dim = inRank - 1 - i;
        const a = inShape[dim] || 1;
        const b = outShape[outShape.length - 1 - i] || 1;
        if (b > 1 && a === 1) dims.unshift(dim);
    }
    return dims;
}
function $642a122b4608acc0$export$9f11ec258a9b2804(inShape, outShape) {
    const result = [];
    for(let i = 0; i < outShape.length; i++){
        const inDim = inShape[inShape.length - i - 1];
        const outAxis = outShape.length - i - 1;
        const outDim = outShape[outAxis];
        if (inDim == null || inDim === 1 && outDim > 1) result.unshift(outAxis);
    }
    return result;
}
function $642a122b4608acc0$export$a3e2a38a57ec8318(shapeA, shapeB) {
    const l = Math.max(shapeA.length, shapeB.length);
    const result = new Array(l);
    for(let i = 0; i < l; i++){
        let a = shapeA[shapeA.length - i - 1];
        if (a == null) a = 1;
        let b = shapeB[shapeB.length - i - 1];
        if (b == null) b = 1;
        if (a === 1) result[l - i - 1] = b;
        else if (b === 1) result[l - i - 1] = a;
        else if (a !== b) {
            const errMsg = `Operands could not be broadcast together with shapes ` + `${shapeA} and ${shapeB}.`;
            throw Error(errMsg);
        } else result[l - i - 1] = a;
    }
    return result;
}




/**
 * Returns the max of a and b (`a > b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `tf.maximumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * ```js
 * // Broadcast maximum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $bb7061cc1559a0cf$var$maximum_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'maximum');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'maximum');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($a, 'int32');
        $b = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($b, 'int32');
    }
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$d8d02ac92d161004), inputs);
}
const $bb7061cc1559a0cf$export$b25e0be55f42c9a = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    maximum_: $bb7061cc1559a0cf$var$maximum_
});







class $6e2717eed7ef3d6f$export$69957d0bff775eb6 extends (0, $f39e0de69b839287$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adamax';
    }
    constructor(learningRate, beta1, beta2, epsilon = null, decay = 0.0){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.decay = decay;
        this.accumulatedFirstMoment = [];
        this.accumulatedWeightedInfNorm = [];
        (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            this.iteration = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(0).variable();
            this.accBeta1 = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(beta1).variable();
        });
        if (epsilon == null) this.epsilon = (0, $249f84ddb1ced836$export$33b63313cc511a3b).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            const oneMinusAccBeta1 = (0, $555d660851b98db3$export$f93b5905241a7cca)(1, this.accBeta1);
            const lr = (0, $15928a4fee5ff81f$export$159d9494db57879b)(-this.learningRate, (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(this.iteration, this.decay), 1));
            variableNames.forEach((name, i)=>{
                const value = (0, $249f84ddb1ced836$export$33b63313cc511a3b).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable)
                };
                if (this.accumulatedWeightedInfNorm[i] == null) this.accumulatedWeightedInfNorm[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable)
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const weightedInfNorm = this.accumulatedWeightedInfNorm[i].variable;
                const newFirstMoment = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(firstMoment, this.beta1), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(gradient, 1 - this.beta1));
                const ut0 = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(weightedInfNorm, this.beta2);
                const ut1 = (0, $551d87f9cd40f29c$export$2335f513bbd82c6d)(gradient);
                const newWeightedInfNorm = (0, $bb7061cc1559a0cf$export$b25e0be55f42c9a)(ut0, ut1);
                firstMoment.assign(newFirstMoment);
                weightedInfNorm.assign(newWeightedInfNorm);
                const newValue = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $15928a4fee5ff81f$export$159d9494db57879b)(lr, oneMinusAccBeta1), (0, $15928a4fee5ff81f$export$159d9494db57879b)(newFirstMoment, (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(newWeightedInfNorm, this.epsilon))), value);
                value.assign(newValue);
            });
            this.iteration.assign((0, $c90bd95bc0e58efa$export$e16d8520af44a096)(this.iteration, 1));
            this.accBeta1.assign((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(this.accBeta1, this.beta1));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.iteration.dispose();
        if (this.accumulatedFirstMoment != null) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedWeightedInfNorm != null) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedWeightedInfNorm.map((v)=>v.variable));
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for Adamax yet.');
    }
    async setWeights(weightValues) {
        throw new Error('setWeights() is not implemented for Adamax yet.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon,
            'decay': this.decay
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon'], config['decay']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





class $cffcb030baa5b575$export$97318dd520e1bd4f extends (0, $f39e0de69b839287$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'SGD';
    }
    constructor(learningRate){
        super();
        this.learningRate = learningRate;
        this.setLearningRate(learningRate);
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        varNames.forEach((name, i)=>{
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const value = (0, $249f84ddb1ced836$export$33b63313cc511a3b).registeredVariables[name];
            (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
                const newValue = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(this.c, gradient), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    /**
     * Sets the learning rate of the optimizer.
     */ setLearningRate(learningRate) {
        this.learningRate = learningRate;
        if (this.c != null) this.c.dispose();
        this.c = (0, $8c449c89295c3cc4$export$fae3166c418e0471)((0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(-learningRate));
    }
    dispose() {
        this.c.dispose();
    }
    async getWeights() {
        return [
            await this.saveIterations()
        ];
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        if (weightValues.length !== 0) throw new Error('SGD optimizer does not have settable weights.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate']);
    }
}


class $598fe5979c627cee$export$1db7ecf1f8312c6 extends (0, $cffcb030baa5b575$export$97318dd520e1bd4f) {
    /** @nocollapse */ // Name matters for Python compatibility.
    static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Momentum';
    }
    constructor(learningRate, momentum, useNesterov = false){
        super(learningRate);
        this.learningRate = learningRate;
        this.momentum = momentum;
        this.useNesterov = useNesterov;
        this.accumulations = [];
        this.m = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(this.momentum);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $249f84ddb1ced836$export$33b63313cc511a3b).registeredVariables[name];
            if (this.accumulations[i] == null) {
                const trainable = false;
                this.accumulations[i] = {
                    originalName: `${name}/momentum`,
                    variable: (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>(0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable))
                };
            }
            const accumulation = this.accumulations[i].variable;
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
                let newValue;
                const newAccumulation = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(this.m, accumulation), gradient);
                if (this.useNesterov) newValue = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(this.c, (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(gradient, (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(newAccumulation, this.m))), value);
                else newValue = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(this.c, newAccumulation), value);
                accumulation.assign(newAccumulation);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        this.m.dispose();
        if (this.accumulations != null) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulations.map((v)=>v.variable));
    }
    /**
     * Sets the momentum of the optimizer.
     *
     * @param momentum
     */ setMomentum(momentum) {
        this.momentum = momentum;
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulations.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulations = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'momentum': this.momentum,
            'useNesterov': this.useNesterov
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['momentum'], config['useNesterov']);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 









class $5677a40ccf9c31ca$export$6e668138ce08e3bf extends (0, $f39e0de69b839287$export$69ae9293516e70f0) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'RMSProp';
    }
    constructor(learningRate, decay = 0.9, momentum = 0.0, epsilon = null, centered = false){
        super();
        this.learningRate = learningRate;
        this.decay = decay;
        this.momentum = momentum;
        this.epsilon = epsilon;
        this.accumulatedMeanSquares = [];
        this.accumulatedMoments = [];
        this.accumulatedMeanGrads = [];
        this.centered = centered;
        if (epsilon == null) this.epsilon = (0, $249f84ddb1ced836$export$33b63313cc511a3b).backend.epsilon();
        if (learningRate == null) throw new Error(`learningRate for RMSPropOptimizer must be defined.`);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $249f84ddb1ced836$export$33b63313cc511a3b).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedMeanSquares[i] == null) this.accumulatedMeanSquares[i] = {
                originalName: `${name}/rms`,
                variable: (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>(0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable))
            };
            if (this.accumulatedMoments[i] == null) this.accumulatedMoments[i] = {
                originalName: `${name}/momentum`,
                variable: (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>(0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable))
            };
            if (this.accumulatedMeanGrads[i] == null && this.centered) this.accumulatedMeanGrads[i] = {
                originalName: `${name}/mg`,
                variable: (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>(0, $64c118098861f580$export$cb1f824e7733584d)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedMeanSquare = this.accumulatedMeanSquares[i].variable;
            const accumulatedMoments = this.accumulatedMoments[i].variable;
            (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
                const newAccumulatedMeanSquare = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(accumulatedMeanSquare, this.decay), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $03801900ae8a72ab$export$dd4f28cef696bc7d)(gradient), 1 - this.decay));
                if (this.centered) {
                    const accumulatedMeanGrad = this.accumulatedMeanGrads[i].variable;
                    // Centered gradient
                    const newAccumulatedMeanGrad = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(accumulatedMeanGrad, this.decay), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(gradient, 1 - this.decay));
                    const gradContribution = (0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(gradient, this.learningRate), (0, $d8742a69331de610$export$eba8049fb5020b81)((0, $555d660851b98db3$export$f93b5905241a7cca)(newAccumulatedMeanSquare, (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $03801900ae8a72ab$export$dd4f28cef696bc7d)(newAccumulatedMeanGrad), this.epsilon))));
                    const newAccumulatedMoments = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(accumulatedMoments, this.momentum), gradContribution);
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMeanGrad.assign(newAccumulatedMeanGrad);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $555d660851b98db3$export$f93b5905241a7cca)(value, newAccumulatedMoments);
                    value.assign(newValue);
                } else {
                    // Plain gradient
                    const newAccumulatedMeanSquare = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(accumulatedMeanSquare, this.decay), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $03801900ae8a72ab$export$dd4f28cef696bc7d)(gradient), 1 - this.decay));
                    const newAccumulatedMoments = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(accumulatedMoments, this.momentum), (0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(gradient, this.learningRate), (0, $d8742a69331de610$export$eba8049fb5020b81)((0, $c90bd95bc0e58efa$export$e16d8520af44a096)(newAccumulatedMeanSquare, this.epsilon))));
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $555d660851b98db3$export$f93b5905241a7cca)(value, newAccumulatedMoments);
                    value.assign(newValue);
                }
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedMeanSquares != null) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedMeanSquares.map((v)=>v.variable));
        if (this.accumulatedMeanGrads != null && this.centered) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedMeanGrads.map((v)=>v.variable));
        if (this.accumulatedMoments != null) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.accumulatedMoments.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedMeanSquares,
            ...this.accumulatedMoments
        ];
        if (this.centered) variables.push(...this.accumulatedMeanGrads);
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = this.centered ? weightValues.length / 3 : weightValues.length / 2;
        const trainable = false;
        this.accumulatedMeanSquares = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedMoments = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        if (this.centered) this.accumulatedMeanGrads = weightValues.slice(variableCount * 2, variableCount * 3).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'decay': this.decay,
            'momentum': this.momentum,
            'epsilon': this.epsilon,
            'centered': this.centered
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['decay'], config['momentum'], config['epsilon'], config['centered']);
    }
}




const $4303074357071843$var$OPTIMIZERS = [
    (0, $081c1e1a002596a7$export$d80a766c536c9aaf),
    (0, $52dc4bd6634a3583$export$fa35e48f6f1caa57),
    (0, $8e5923bf3349c4f0$export$de1938eb5fee8ee2),
    (0, $6e2717eed7ef3d6f$export$69957d0bff775eb6),
    (0, $598fe5979c627cee$export$1db7ecf1f8312c6),
    (0, $5677a40ccf9c31ca$export$6e668138ce08e3bf),
    (0, $cffcb030baa5b575$export$97318dd520e1bd4f)
];
function $4303074357071843$export$9a85654c75805c9a() {
    for (const optimizer of $4303074357071843$var$OPTIMIZERS)(0, $42b0cce2828065a4$export$a3f7d716dc76cb2e)(optimizer);
}


var $4b62b17ea43e8f87$exports = {};

$parcel$export($4b62b17ea43e8f87$exports, "AdadeltaOptimizer", () => $081c1e1a002596a7$export$d80a766c536c9aaf);
$parcel$export($4b62b17ea43e8f87$exports, "AdagradOptimizer", () => $52dc4bd6634a3583$export$fa35e48f6f1caa57);
$parcel$export($4b62b17ea43e8f87$exports, "AdamOptimizer", () => $8e5923bf3349c4f0$export$de1938eb5fee8ee2);
$parcel$export($4b62b17ea43e8f87$exports, "AdamaxOptimizer", () => $6e2717eed7ef3d6f$export$69957d0bff775eb6);
$parcel$export($4b62b17ea43e8f87$exports, "MomentumOptimizer", () => $598fe5979c627cee$export$1db7ecf1f8312c6);
$parcel$export($4b62b17ea43e8f87$exports, "Optimizer", () => $f39e0de69b839287$export$69ae9293516e70f0);
$parcel$export($4b62b17ea43e8f87$exports, "OptimizerConstructors", () => $898835df87cf1c26$export$1babc3d7b10c0cf6);
$parcel$export($4b62b17ea43e8f87$exports, "RMSPropOptimizer", () => $5677a40ccf9c31ca$export$6e668138ce08e3bf);
$parcel$export($4b62b17ea43e8f87$exports, "SGDOptimizer", () => $cffcb030baa5b575$export$97318dd520e1bd4f);
$parcel$export($4b62b17ea43e8f87$exports, "Tensor", () => $6c839404e55214b5$export$7b6b8d90402f8814);
$parcel$export($4b62b17ea43e8f87$exports, "TensorBuffer", () => $6c839404e55214b5$export$350df26cd52e08e1);
$parcel$export($4b62b17ea43e8f87$exports, "Variable", () => $6c839404e55214b5$export$c867a5c9595a1350);
$parcel$export($4b62b17ea43e8f87$exports, "Rank", () => $206e8e4148e423f6$export$c36edca8f8f0427a);
$parcel$export($4b62b17ea43e8f87$exports, "sumOutType", () => $206e8e4148e423f6$export$3479b4fbed3c0d8d);
$parcel$export($4b62b17ea43e8f87$exports, "upcastType", () => $206e8e4148e423f6$export$7bcca02d1a156bdf);
$parcel$export($4b62b17ea43e8f87$exports, "Reduction", () => $d33626f0529b69e1$export$cc9fa7113d70efba);
$parcel$export($4b62b17ea43e8f87$exports, "customGrad", () => $694041655139423f$export$5519f0eeb00c44e5);
$parcel$export($4b62b17ea43e8f87$exports, "grad", () => $694041655139423f$export$c24429b22bb73814);
$parcel$export($4b62b17ea43e8f87$exports, "grads", () => $694041655139423f$export$3f3749f5340c73f2);
$parcel$export($4b62b17ea43e8f87$exports, "valueAndGrad", () => $694041655139423f$export$9fbe39d4dcb3921e);
$parcel$export($4b62b17ea43e8f87$exports, "valueAndGrads", () => $694041655139423f$export$c03281a254ef3cf0);
$parcel$export($4b62b17ea43e8f87$exports, "variableGrads", () => $694041655139423f$export$c756d9ed08b9677f);
$parcel$export($4b62b17ea43e8f87$exports, "Environment", () => $d3cf252ef4ef8e7f$export$7dc6752a22ab011a);
$parcel$export($4b62b17ea43e8f87$exports, "env", () => $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3);
$parcel$export($4b62b17ea43e8f87$exports, "ENV", () => $d3cf252ef4ef8e7f$export$83401e34d5e11bf4);
$parcel$export($4b62b17ea43e8f87$exports, "version_core", () => $f3f7c17932263fce$export$83d89fbfd8236492);
$parcel$export($4b62b17ea43e8f87$exports, "nextFrame", () => $71bfb8d913b21bbc$export$68d2d147c928d1dd);
$parcel$export($4b62b17ea43e8f87$exports, "browser", () => $90849bbe88a0108e$exports);
$parcel$export($4b62b17ea43e8f87$exports, "io", () => $707ce2a17ca1210d$exports);
$parcel$export($4b62b17ea43e8f87$exports, "math", () => $6e29fb748b30ea69$exports);
$parcel$export($4b62b17ea43e8f87$exports, "serialization", () => $42b0cce2828065a4$exports);
$parcel$export($4b62b17ea43e8f87$exports, "test_util", () => $4b634705d248be81$exports);
$parcel$export($4b62b17ea43e8f87$exports, "util", () => $e10678764dab7ea0$exports);
$parcel$export($4b62b17ea43e8f87$exports, "backend_util", () => $5a956a12516ed8ee$exports);
$parcel$export($4b62b17ea43e8f87$exports, "broadcast_util", () => $642a122b4608acc0$exports);
$parcel$export($4b62b17ea43e8f87$exports, "tensor_util", () => $28f820f91d9287a3$exports);
$parcel$export($4b62b17ea43e8f87$exports, "slice_util", () => $857e39e1331d3036$exports);
$parcel$export($4b62b17ea43e8f87$exports, "gather_util", () => $36339f0b093f9859$exports);
$parcel$export($4b62b17ea43e8f87$exports, "scatter_util", () => $57b46503159dbf6f$exports);
$parcel$export($4b62b17ea43e8f87$exports, "device_util", () => $36a682e0812b3b99$exports);
$parcel$export($4b62b17ea43e8f87$exports, "kernel_impls", () => $fb3bc18262ab6c94$exports);
$parcel$export($4b62b17ea43e8f87$exports, "KernelBackend", () => $b73fd602f21aa26c$export$543916c62202b50a);
$parcel$export($4b62b17ea43e8f87$exports, "DataStorage", () => $b73fd602f21aa26c$export$e95767ffe2e60cec);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // base.ts is tfjs-core without auto registration of things like flags,
// gradients, chained ops or the opHandler. See base_side_effects.ts for parts
// tfjs core that are required side effects.
/**
 * @fileoverview
 * @suppress {partialAlias} Optimization disabled due to passing the module
 * object into a function below:
 *
 *   import * as ops from './ops/ops';
 *   setOpHandler(ops);
 */ // Serialization.
var $707ce2a17ca1210d$exports = {};

$parcel$export($707ce2a17ca1210d$exports, "copyModel", () => $15605ea4e29ff52d$export$b5971478866000ed);
$parcel$export($707ce2a17ca1210d$exports, "listModels", () => $15605ea4e29ff52d$export$8d63af86d795ece4);
$parcel$export($707ce2a17ca1210d$exports, "moveModel", () => $15605ea4e29ff52d$export$598f168272f4fec2);
$parcel$export($707ce2a17ca1210d$exports, "removeModel", () => $15605ea4e29ff52d$export$e71037184d1ad0fd);
$parcel$export($707ce2a17ca1210d$exports, "browserFiles", () => $080b36d35603200b$export$6729643cf069471c);
$parcel$export($707ce2a17ca1210d$exports, "browserHTTPRequest", () => $df8714d527b2cee6$export$624ff5bc4e3a9d72);
$parcel$export($707ce2a17ca1210d$exports, "CompositeArrayBuffer", () => $ccfe888395cdb33c$export$fd7a5551e5344016);
$parcel$export($707ce2a17ca1210d$exports, "concatenateArrayBuffers", () => $3674b353dc6c3d42$export$9a3e9c78eb778da8);
$parcel$export($707ce2a17ca1210d$exports, "decodeWeights", () => $3674b353dc6c3d42$export$7a14c2428d4f4a2e);
$parcel$export($707ce2a17ca1210d$exports, "decodeWeightsStream", () => $3674b353dc6c3d42$export$6c19531ae9ba1204);
$parcel$export($707ce2a17ca1210d$exports, "encodeWeights", () => $3674b353dc6c3d42$export$6c50c12dbd6168b);
$parcel$export($707ce2a17ca1210d$exports, "fromMemory", () => $c8ddf02cd96cceaf$export$89ba941c7951a2e8);
$parcel$export($707ce2a17ca1210d$exports, "fromMemorySync", () => $c8ddf02cd96cceaf$export$c22472cb1d774f45);
$parcel$export($707ce2a17ca1210d$exports, "getLoadHandlers", () => $72f51ea9c3e59639$export$90c6c4d24103fa9a);
$parcel$export($707ce2a17ca1210d$exports, "getModelArtifactsForJSON", () => $3674b353dc6c3d42$export$b867c14eedd5b8a2);
$parcel$export($707ce2a17ca1210d$exports, "getModelArtifactsForJSONSync", () => $3674b353dc6c3d42$export$ebf48c0f134e5c8);
$parcel$export($707ce2a17ca1210d$exports, "getModelArtifactsInfoForJSON", () => $3674b353dc6c3d42$export$ece8b449d7d29272);
$parcel$export($707ce2a17ca1210d$exports, "getSaveHandlers", () => $72f51ea9c3e59639$export$88af18fd9ddb62ff);
$parcel$export($707ce2a17ca1210d$exports, "getWeightSpecs", () => $3674b353dc6c3d42$export$9f3fe06e8e8def44);
$parcel$export($707ce2a17ca1210d$exports, "http", () => $df8714d527b2cee6$export$7d6f1c8842f9f527);
$parcel$export($707ce2a17ca1210d$exports, "isHTTPScheme", () => $df8714d527b2cee6$export$18a721ae4733601b);
$parcel$export($707ce2a17ca1210d$exports, "loadWeights", () => $060ee13579f28267$export$55f7d42d35356096);
$parcel$export($707ce2a17ca1210d$exports, "registerLoadRouter", () => $72f51ea9c3e59639$export$8bf64df3d1fb9866);
$parcel$export($707ce2a17ca1210d$exports, "registerSaveRouter", () => $72f51ea9c3e59639$export$94da4683f36f634e);
$parcel$export($707ce2a17ca1210d$exports, "weightsLoaderFactory", () => $060ee13579f28267$export$635f986c4ab6ebe2);
$parcel$export($707ce2a17ca1210d$exports, "withSaveHandler", () => $c8ddf02cd96cceaf$export$fa4a26428614aae7);
$parcel$export($707ce2a17ca1210d$exports, "withSaveHandlerSync", () => $c8ddf02cd96cceaf$export$53913891eb9f0585);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Importing local_storage and indexed_db is necessary for the routers to be
// registered.


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandlers related to files, such as browser-triggered file downloads,
 * user-selected files in browser.
 */ 




const $080b36d35603200b$var$DEFAULT_FILE_NAME_PREFIX = 'model';
const $080b36d35603200b$var$DEFAULT_JSON_EXTENSION_NAME = '.json';
const $080b36d35603200b$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME = '.weights.bin';
function $080b36d35603200b$var$defer(f) {
    return new Promise((resolve)=>setTimeout(resolve)).then(f);
}
class $080b36d35603200b$export$cc3c076530f2848f {
    constructor(fileNamePrefix){
        if (!(0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) // TODO(cais): Provide info on what IOHandlers are available under the
        //   current environment.
        throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
        if (fileNamePrefix.startsWith($080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME)) fileNamePrefix = fileNamePrefix.slice($080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME.length);
        if (fileNamePrefix == null || fileNamePrefix.length === 0) fileNamePrefix = $080b36d35603200b$var$DEFAULT_FILE_NAME_PREFIX;
        this.modelJsonFileName = fileNamePrefix + $080b36d35603200b$var$DEFAULT_JSON_EXTENSION_NAME;
        this.weightDataFileName = fileNamePrefix + $080b36d35603200b$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME;
    }
    async save(modelArtifacts) {
        if (typeof document === 'undefined') throw new Error("Browser downloads are not supported in this environment since `document` is not present");
        // TODO(mattsoulanille): Support saving models over 2GB that exceed
        // Chrome's ArrayBuffer size limit.
        const weightBuffer = (0, $ccfe888395cdb33c$export$fd7a5551e5344016).join(modelArtifacts.weightData);
        const weightsURL = window.URL.createObjectURL(new Blob([
            weightBuffer
        ], {
            type: 'application/octet-stream'
        }));
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
        else {
            const weightsManifest = [
                {
                    paths: [
                        './' + this.weightDataFileName
                    ],
                    weights: modelArtifacts.weightSpecs
                }
            ];
            const modelJSON = (0, $3674b353dc6c3d42$export$a725daa2cfaa7bd5)(modelArtifacts, weightsManifest);
            const modelJsonURL = window.URL.createObjectURL(new Blob([
                JSON.stringify(modelJSON)
            ], {
                type: 'application/json'
            }));
            // If anchor elements are not provided, create them without attaching them
            // to parents, so that the downloaded file names can be controlled.
            const jsonAnchor = this.modelJsonAnchor == null ? document.createElement('a') : this.modelJsonAnchor;
            jsonAnchor.download = this.modelJsonFileName;
            jsonAnchor.href = modelJsonURL;
            // Trigger downloads by evoking a click event on the download anchors.
            // When multiple downloads are started synchronously, Firefox will only
            // save the last one.
            await $080b36d35603200b$var$defer(()=>jsonAnchor.dispatchEvent(new MouseEvent('click')));
            if (modelArtifacts.weightData != null) {
                const weightDataAnchor = this.weightDataAnchor == null ? document.createElement('a') : this.weightDataAnchor;
                weightDataAnchor.download = this.weightDataFileName;
                weightDataAnchor.href = weightsURL;
                await $080b36d35603200b$var$defer(()=>weightDataAnchor.dispatchEvent(new MouseEvent('click')));
            }
            return {
                modelArtifactsInfo: (0, $3674b353dc6c3d42$export$ece8b449d7d29272)(modelArtifacts)
            };
        }
    }
}
$080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME = 'downloads://';
class $080b36d35603200b$var$BrowserFiles {
    constructor(files){
        if (files == null || files.length < 1) throw new Error(`When calling browserFiles, at least 1 file is required, ` + `but received ${files}`);
        this.jsonFile = files[0];
        this.weightsFiles = files.slice(1);
    }
    async load() {
        return new Promise((resolve, reject)=>{
            const jsonReader = new FileReader();
            jsonReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const modelJSON = JSON.parse(event.target.result);
                const modelTopology = modelJSON.modelTopology;
                if (modelTopology == null) {
                    reject(new Error(`modelTopology field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                const weightsManifest = modelJSON.weightsManifest;
                if (weightsManifest == null) {
                    reject(new Error(`weightManifest field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                if (this.weightsFiles.length === 0) {
                    resolve({
                        modelTopology: modelTopology
                    });
                    return;
                }
                const modelArtifactsPromise = (0, $3674b353dc6c3d42$export$b867c14eedd5b8a2)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
                resolve(modelArtifactsPromise);
            };
            jsonReader.onerror = (error)=>reject(`Failed to read model topology and weights manifest JSON ` + `from file '${this.jsonFile.name}'. BrowserFiles supports loading ` + `Keras-style tf.Model artifacts only.`);
            jsonReader.readAsText(this.jsonFile);
        });
    }
    loadWeights(weightsManifest) {
        const weightSpecs = [];
        const paths = [];
        for (const entry of weightsManifest){
            weightSpecs.push(...entry.weights);
            paths.push(...entry.paths);
        }
        const pathToFile = this.checkManifestAndWeightFiles(weightsManifest);
        const promises = paths.map((path)=>this.loadWeightsFile(path, pathToFile[path]));
        return Promise.all(promises).then((buffers)=>[
                weightSpecs,
                buffers
            ]);
    }
    loadWeightsFile(path, file) {
        return new Promise((resolve, reject)=>{
            const weightFileReader = new FileReader();
            weightFileReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const weightData = event.target.result;
                resolve(weightData);
            };
            weightFileReader.onerror = (error)=>reject(`Failed to weights data from file of path '${path}'.`);
            weightFileReader.readAsArrayBuffer(file);
        });
    }
    /**
     * Check the compatibility between weights manifest and weight files.
     */ checkManifestAndWeightFiles(manifest) {
        const basenames = [];
        const fileNames = this.weightsFiles.map((file)=>(0, $3674b353dc6c3d42$export$9bf319d8f74f51d1)(file.name));
        const pathToFile = {};
        for (const group of manifest)group.paths.forEach((path)=>{
            const pathBasename = (0, $3674b353dc6c3d42$export$9bf319d8f74f51d1)(path);
            if (basenames.indexOf(pathBasename) !== -1) throw new Error(`Duplicate file basename found in weights manifest: ` + `'${pathBasename}'`);
            basenames.push(pathBasename);
            if (fileNames.indexOf(pathBasename) === -1) throw new Error(`Weight file with basename '${pathBasename}' is not provided.`);
            else pathToFile[path] = this.weightsFiles[fileNames.indexOf(pathBasename)];
        });
        if (basenames.length !== this.weightsFiles.length) throw new Error(`Mismatch in the number of files in weights manifest ` + `(${basenames.length}) and the number of weight files provided ` + `(${this.weightsFiles.length}).`);
        return pathToFile;
    }
}
const $080b36d35603200b$export$6149c5f14395749b = (url)=>{
    if (!(0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME)) return $080b36d35603200b$export$8fbc9551c735f788(url.slice($080b36d35603200b$export$cc3c076530f2848f.URL_SCHEME.length));
        else return null;
    }
};
(0, $72f51ea9c3e59639$export$512275d398c0bdcd).registerSaveRouter($080b36d35603200b$export$6149c5f14395749b);
function $080b36d35603200b$export$8fbc9551c735f788(fileNamePrefix = 'model') {
    return new $080b36d35603200b$export$cc3c076530f2848f(fileNamePrefix);
}
function $080b36d35603200b$export$6729643cf069471c(files) {
    return new $080b36d35603200b$var$BrowserFiles(files);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandler implementations based on HTTP requests in the web browser.
 *
 * Uses [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
 */ 




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $97375e54bf64bee5$export$b88cae388b9e062e(promises, onProgress, startFraction, endFraction) {
    checkPromises(promises);
    startFraction = startFraction == null ? 0 : startFraction;
    endFraction = endFraction == null ? 1 : endFraction;
    checkFraction(startFraction, endFraction);
    let resolvedPromise = 0;
    const registerMonitor = (promise)=>{
        promise.then((value)=>{
            const fraction = startFraction + ++resolvedPromise / promises.length * (endFraction - startFraction);
            // pass fraction as parameter to callback function.
            onProgress(fraction);
            return value;
        });
        return promise;
    };
    function checkPromises(promises) {
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(promises != null && Array.isArray(promises) && promises.length > 0, ()=>'promises must be a none empty array');
    }
    function checkFraction(startFraction, endFraction) {
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(startFraction >= 0 && startFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got startFraction ${startFraction}`);
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(endFraction >= 0 && endFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got endFraction ${endFraction}`);
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(endFraction >= startFraction, ()=>`startFraction must be no more than endFraction, but ` + `got startFraction ${startFraction} and endFraction ` + `${endFraction}`);
    }
    return Promise.all(promises.map(registerMonitor));
}



async function $060ee13579f28267$export$6873c1a1d3325bf7(fetchURLs, loadOptions) {
    if (loadOptions == null) loadOptions = {};
    const fetchFunc = loadOptions.fetchFunc == null ? (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().platform.fetch : loadOptions.fetchFunc;
    // Create the requests for all of the weights in parallel.
    const requests = fetchURLs.map((fetchURL)=>fetchFunc(fetchURL, loadOptions.requestInit, {
            isBinary: true
        }));
    const fetchStartFraction = 0;
    const fetchEndFraction = 0.5;
    const responses = loadOptions.onProgress == null ? await Promise.all(requests) : await (0, $97375e54bf64bee5$export$b88cae388b9e062e)(requests, loadOptions.onProgress, fetchStartFraction, fetchEndFraction);
    const bufferPromises = responses.map((response)=>response.arrayBuffer());
    const bufferStartFraction = 0.5;
    const bufferEndFraction = 1;
    const buffers = loadOptions.onProgress == null ? await Promise.all(bufferPromises) : await (0, $97375e54bf64bee5$export$b88cae388b9e062e)(bufferPromises, loadOptions.onProgress, bufferStartFraction, bufferEndFraction);
    return buffers;
}
function $060ee13579f28267$export$4fc61cabab0a1e7e(fetchURLs, loadOptions) {
    var _a;
    const fetchFunc = loadOptions.fetchFunc == null ? (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().platform.fetch : loadOptions.fetchFunc;
    let fetchIndex = 0;
    let chunkReader;
    (_a = loadOptions.onProgress) === null || _a === void 0 || _a.call(loadOptions, 0);
    return new ReadableStream({
        pull: async (controller)=>{
            var _a;
            while(fetchIndex < fetchURLs.length){
                if (!chunkReader) {
                    const body = (await fetchFunc(fetchURLs[fetchIndex], loadOptions.requestInit, {
                        isBinary: true
                    })).body;
                    chunkReader = body.getReader();
                }
                const { done: done, value: value } = await chunkReader.read();
                if (done) {
                    fetchIndex++;
                    chunkReader = undefined;
                    (_a = loadOptions.onProgress) === null || _a === void 0 || _a.call(loadOptions, fetchIndex / fetchURLs.length);
                    continue;
                }
                controller.enqueue(value);
                return;
            }
            controller.close();
        }
    });
}
async function $060ee13579f28267$export$55f7d42d35356096(manifest, filePathPrefix = '', weightNames, requestInit) {
    // TODO(nsthorat): Groups are currently fetched atomically. If you need a
    // single weight from a group, the whole group will be fetched. At a future
    // date, we should support fetching only the individual shards within a
    // group that are needed to reconstruct the requested weight.
    // TODO(cais): Use `decodeWeights` for implementation.
    const fetchWeights = (fetchUrls)=>$060ee13579f28267$export$6873c1a1d3325bf7(fetchUrls, {
            requestInit: requestInit
        });
    const loadWeights1 = $060ee13579f28267$export$635f986c4ab6ebe2(fetchWeights);
    return loadWeights1(manifest, filePathPrefix, weightNames);
}
function $060ee13579f28267$export$635f986c4ab6ebe2(fetchWeightsFunction) {
    return async (manifest, filePathPrefix = '', weightNames)=>{
        // Collect all the groups, weights, and their relative offsets to be
        // fetched.
        const groupIndicesToFetchMap = manifest.map(()=>false);
        const groupWeightsToFetch = {};
        const weightsFound = weightNames != null ? weightNames.map(()=>false) : [];
        const allManifestWeightNames = [];
        manifest.forEach((manifestGroupConfig, groupIndex)=>{
            let groupOffset = 0;
            manifestGroupConfig.weights.forEach((weightsEntry)=>{
                const rawDtype = 'quantization' in weightsEntry ? weightsEntry.quantization.dtype : weightsEntry.dtype;
                const weightsBytes = (0, $198abd4496908653$export$8103dee73e5eaa46)[rawDtype] * $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f(weightsEntry.shape);
                const enqueueWeightsForFetchingFn = ()=>{
                    groupIndicesToFetchMap[groupIndex] = true;
                    if (groupWeightsToFetch[groupIndex] == null) groupWeightsToFetch[groupIndex] = [];
                    groupWeightsToFetch[groupIndex].push({
                        manifestEntry: weightsEntry,
                        groupOffset: groupOffset,
                        sizeBytes: weightsBytes
                    });
                };
                if (weightNames != null) weightNames.forEach((weightName, weightIndex)=>{
                    if (weightName === weightsEntry.name) {
                        enqueueWeightsForFetchingFn();
                        weightsFound[weightIndex] = true;
                    }
                });
                else enqueueWeightsForFetchingFn();
                allManifestWeightNames.push(weightsEntry.name);
                groupOffset += weightsBytes;
            });
        });
        if (!weightsFound.every((found)=>found)) {
            const weightsNotFound = weightNames.filter((_, i)=>!weightsFound[i]);
            throw new Error(`Could not find weights in manifest with names: ` + `${weightsNotFound.join(', ')}. \n` + `Manifest JSON has weights with names: ` + `${allManifestWeightNames.join(', ')}.`);
        }
        // Convert the one-hot boolean groupId => shouldFetch map to a list of group
        // IDs.
        const groupIndicesToFetch = groupIndicesToFetchMap.reduce((accumulator, shouldFetch, i)=>{
            if (shouldFetch) accumulator.push(i);
            return accumulator;
        }, []);
        const fetchUrls = [];
        groupIndicesToFetch.forEach((i)=>{
            manifest[i].paths.forEach((filepath)=>{
                const fetchUrl = filePathPrefix + (!filePathPrefix.endsWith('/') ? '/' : '') + filepath;
                fetchUrls.push(fetchUrl);
            });
        });
        const buffers = await fetchWeightsFunction(fetchUrls);
        const weightsTensorMap = {};
        let bufferIndexOffset = 0;
        groupIndicesToFetch.forEach((i)=>{
            const numBuffers = manifest[i].paths.length;
            const weightsBuffer = new (0, $ccfe888395cdb33c$export$fd7a5551e5344016)(buffers.slice(bufferIndexOffset, bufferIndexOffset + numBuffers));
            const weightsEntries = groupWeightsToFetch[i];
            weightsEntries.forEach((weightsEntry)=>{
                const byteBuffer = weightsBuffer.slice(weightsEntry.groupOffset, weightsEntry.groupOffset + weightsEntry.sizeBytes);
                const nameToTensorMap = (0, $3674b353dc6c3d42$export$7a14c2428d4f4a2e)(byteBuffer, [
                    weightsEntry.manifestEntry
                ]);
                for(const name in nameToTensorMap)weightsTensorMap[name] = nameToTensorMap[name];
            });
            bufferIndexOffset += numBuffers;
        });
        return weightsTensorMap;
    };
}


const $df8714d527b2cee6$var$OCTET_STREAM_MIME_TYPE = 'application/octet-stream';
const $df8714d527b2cee6$var$JSON_TYPE = 'application/json';
class $df8714d527b2cee6$export$3df08bb5d0f8b499 {
    constructor(path, loadOptions){
        this.DEFAULT_METHOD = 'POST';
        if (loadOptions == null) loadOptions = {};
        this.weightPathPrefix = loadOptions.weightPathPrefix;
        this.weightUrlConverter = loadOptions.weightUrlConverter;
        if (loadOptions.fetchFunc != null) {
            (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(typeof loadOptions.fetchFunc === 'function', ()=>"Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)");
            this.fetch = loadOptions.fetchFunc;
        } else this.fetch = (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().platform.fetch;
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(path != null && path.length > 0, ()=>"URL path for http must not be null, undefined or empty.");
        if (Array.isArray(path)) (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(path.length === 2, ()=>'URL paths for http must have a length of 2, ' + `(actual length is ${path.length}).`);
        this.path = path;
        if (loadOptions.requestInit != null && loadOptions.requestInit.body != null) throw new Error('requestInit is expected to have no pre-existing body, but has one.');
        this.requestInit = loadOptions.requestInit || {};
        this.loadOptions = loadOptions;
    }
    async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
        const init = Object.assign({
            method: this.DEFAULT_METHOD
        }, this.requestInit);
        init.body = new FormData();
        const weightsManifest = [
            {
                paths: [
                    './model.weights.bin'
                ],
                weights: modelArtifacts.weightSpecs
            }
        ];
        const modelTopologyAndWeightManifest = (0, $3674b353dc6c3d42$export$a725daa2cfaa7bd5)(modelArtifacts, weightsManifest);
        init.body.append('model.json', new Blob([
            JSON.stringify(modelTopologyAndWeightManifest)
        ], {
            type: $df8714d527b2cee6$var$JSON_TYPE
        }), 'model.json');
        if (modelArtifacts.weightData != null) {
            // TODO(mattsoulanille): Support saving models over 2GB that exceed
            // Chrome's ArrayBuffer size limit.
            const weightBuffer = (0, $ccfe888395cdb33c$export$fd7a5551e5344016).join(modelArtifacts.weightData);
            init.body.append('model.weights.bin', new Blob([
                weightBuffer
            ], {
                type: $df8714d527b2cee6$var$OCTET_STREAM_MIME_TYPE
            }), 'model.weights.bin');
        }
        const response = await this.fetch(this.path, init);
        if (response.ok) return {
            modelArtifactsInfo: (0, $3674b353dc6c3d42$export$ece8b449d7d29272)(modelArtifacts),
            responses: [
                response
            ]
        };
        else throw new Error(`BrowserHTTPRequest.save() failed due to HTTP response status ` + `${response.status}.`);
    }
    async loadModelJSON() {
        const modelConfigRequest = await this.fetch(this.path, this.requestInit);
        if (!modelConfigRequest.ok) throw new Error(`Request to ${this.path} failed with status code ` + `${modelConfigRequest.status}. Please verify this URL points to ` + `the model JSON of the model to load.`);
        let modelJSON;
        try {
            modelJSON = await modelConfigRequest.json();
        } catch (e) {
            let message = `Failed to parse model JSON of response from ${this.path}.`;
            // TODO(nsthorat): Remove this after some time when we're comfortable that
            // .pb files are mostly gone.
            if (this.path.endsWith('.pb')) message += " Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository.";
            else message += " Please make sure the server is serving valid JSON for this request.";
            throw new Error(message);
        }
        // We do not allow both modelTopology and weightsManifest to be missing.
        const modelTopology = modelJSON.modelTopology;
        const weightsManifest = modelJSON.weightsManifest;
        if (modelTopology == null && weightsManifest == null) throw new Error(`The JSON from HTTP path ${this.path} contains neither model ` + `topology or manifest for weights.`);
        return modelJSON;
    }
    /**
     * Load model artifacts via HTTP request(s).
     *
     * See the documentation to `tf.io.http` for details on the saved
     * artifacts.
     *
     * @returns The loaded model artifacts (if loading succeeds).
     */ async load() {
        if (this.loadOptions.streamWeights) return this.loadStream();
        const modelJSON = await this.loadModelJSON();
        return (0, $3674b353dc6c3d42$export$b867c14eedd5b8a2)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
    }
    async loadStream() {
        const modelJSON = await this.loadModelJSON();
        const fetchURLs = await this.getWeightUrls(modelJSON.weightsManifest);
        const weightSpecs = (0, $3674b353dc6c3d42$export$9f3fe06e8e8def44)(modelJSON.weightsManifest);
        const stream = ()=>(0, $060ee13579f28267$export$4fc61cabab0a1e7e)(fetchURLs, this.loadOptions);
        return Object.assign(Object.assign({}, modelJSON), {
            weightSpecs: weightSpecs,
            getWeightStream: stream
        });
    }
    async getWeightUrls(weightsManifest) {
        const weightPath = Array.isArray(this.path) ? this.path[1] : this.path;
        const [prefix, suffix] = $df8714d527b2cee6$export$7a5253c0f62e0150(weightPath);
        const pathPrefix = this.weightPathPrefix || prefix;
        const fetchURLs = [];
        const urlPromises = [];
        for (const weightsGroup of weightsManifest){
            for (const path of weightsGroup.paths)if (this.weightUrlConverter != null) urlPromises.push(this.weightUrlConverter(path));
            else fetchURLs.push(pathPrefix + path + suffix);
        }
        if (this.weightUrlConverter) fetchURLs.push(...await Promise.all(urlPromises));
        return fetchURLs;
    }
    async loadWeights(weightsManifest) {
        const fetchURLs = await this.getWeightUrls(weightsManifest);
        const weightSpecs = (0, $3674b353dc6c3d42$export$9f3fe06e8e8def44)(weightsManifest);
        const buffers = await (0, $060ee13579f28267$export$6873c1a1d3325bf7)(fetchURLs, this.loadOptions);
        return [
            weightSpecs,
            buffers
        ];
    }
}
$df8714d527b2cee6$export$3df08bb5d0f8b499.URL_SCHEME_REGEX = /^https?:\/\//;
function $df8714d527b2cee6$export$7a5253c0f62e0150(url) {
    const lastSlash = url.lastIndexOf('/');
    const lastSearchParam = url.lastIndexOf('?');
    const prefix = url.substring(0, lastSlash);
    const suffix = lastSearchParam > lastSlash ? url.substring(lastSearchParam) : '';
    return [
        prefix + '/',
        suffix
    ];
}
function $df8714d527b2cee6$export$18a721ae4733601b(url) {
    return url.match($df8714d527b2cee6$export$3df08bb5d0f8b499.URL_SCHEME_REGEX) != null;
}
const $df8714d527b2cee6$export$696b487c8ad531d2 = (url, loadOptions)=>{
    if (typeof fetch === 'undefined' && (loadOptions == null || loadOptions.fetchFunc == null)) // `http` uses `fetch` or `node-fetch`, if one wants to use it in
    // an environment that is not the browser or node they have to setup a
    // global fetch polyfill.
    return null;
    else {
        let isHTTP = true;
        if (Array.isArray(url)) isHTTP = url.every((urlItem)=>$df8714d527b2cee6$export$18a721ae4733601b(urlItem));
        else isHTTP = $df8714d527b2cee6$export$18a721ae4733601b(url);
        if (isHTTP) return $df8714d527b2cee6$export$7d6f1c8842f9f527(url, loadOptions);
    }
    return null;
};
(0, $72f51ea9c3e59639$export$512275d398c0bdcd).registerSaveRouter($df8714d527b2cee6$export$696b487c8ad531d2);
(0, $72f51ea9c3e59639$export$512275d398c0bdcd).registerLoadRouter($df8714d527b2cee6$export$696b487c8ad531d2);
function $df8714d527b2cee6$export$7d6f1c8842f9f527(path, loadOptions) {
    return new $df8714d527b2cee6$export$3df08bb5d0f8b499(path, loadOptions);
}
function $df8714d527b2cee6$export$624ff5bc4e3a9d72(path, loadOptions) {
    return $df8714d527b2cee6$export$7d6f1c8842f9f527(path, loadOptions);
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $c8ddf02cd96cceaf$var$PassthroughLoader {
    constructor(modelArtifacts){
        this.modelArtifacts = modelArtifacts;
    }
    load() {
        return this.modelArtifacts;
    }
}
class $c8ddf02cd96cceaf$var$PassthroughSaver {
    constructor(saveHandler){
        this.saveHandler = saveHandler;
    }
    save(modelArtifacts) {
        return this.saveHandler(modelArtifacts);
    }
}
class $c8ddf02cd96cceaf$var$PassthroughAsync {
    constructor(handler){
        if (handler.load) this.load = ()=>Promise.resolve(handler.load());
        if (handler.save) this.save = (modelArtifacts)=>Promise.resolve(handler.save(modelArtifacts));
    }
}
function $c8ddf02cd96cceaf$export$89ba941c7951a2e8(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    const args = arguments;
    return new $c8ddf02cd96cceaf$var$PassthroughAsync($c8ddf02cd96cceaf$export$c22472cb1d774f45(...args));
}
function $c8ddf02cd96cceaf$export$c22472cb1d774f45(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    if (arguments.length === 1) {
        const isModelArtifacts = modelArtifacts.modelTopology != null || modelArtifacts.weightSpecs != null;
        if (isModelArtifacts) return new $c8ddf02cd96cceaf$var$PassthroughLoader(modelArtifacts);
        else {
            // Legacy support: with only modelTopology.
            // TODO(cais): Remove this deprecated API.
            console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
            return new $c8ddf02cd96cceaf$var$PassthroughLoader({
                modelTopology: modelArtifacts
            });
        }
    } else {
        // Legacy support.
        // TODO(cais): Remove this deprecated API.
        console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
        return new $c8ddf02cd96cceaf$var$PassthroughLoader({
            modelTopology: modelArtifacts,
            weightSpecs: weightSpecs,
            weightData: weightData,
            trainingConfig: trainingConfig
        });
    }
}
function $c8ddf02cd96cceaf$export$fa4a26428614aae7(saveHandler) {
    return new $c8ddf02cd96cceaf$var$PassthroughSaver(saveHandler);
}
function $c8ddf02cd96cceaf$export$53913891eb9f0585(saveHandler) {
    return new $c8ddf02cd96cceaf$var$PassthroughSaver(saveHandler);
}








var $6e29fb748b30ea69$exports = {};

$parcel$export($6e29fb748b30ea69$exports, "confusionMatrix", () => $3938e3541a82a004$export$e83fd4c6c32bfa2e);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Exports under the tf.math.* namespace.
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the dot product of two matrices, A * B. These must be matrices.
 *
 * ```js
 * const a = tf.tensor2d([1, 2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.matMul(b).print();  // or tf.matMul(a, b)
 * ```
 * @param a First matrix in dot product operation.
 * @param b Second matrix in dot product operation.
 * @param transposeA If true, `a` is transposed before multiplication.
 * @param transposeB If true, `b` is transposed before multiplication.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $7f1f3e54d78420da$var$matMul_(a, b, transposeA = false, transposeB = false) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'matMul');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'matMul');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$9a3bf60b23f63c8), inputs, attrs);
}
const $7f1f3e54d78420da$export$6706882a873e9a8f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    matMul_: $7f1f3e54d78420da$var$matMul_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a one-hot `tf.Tensor`. The locations represented by `indices` take
 * value `onValue` (defaults to 1), while all other locations take value
 * `offValue` (defaults to 0). If `indices` is rank `R`, the output has rank
 * `R+1` with the last axis of size `depth`.
 * `indices` used to encode prediction class must start from 0. For example,
 *  if you have 3 classes of data, class 1 should be encoded as 0, class 2
 *  should be 1, and class 3 should be 2.
 *
 * ```js
 * tf.oneHot(tf.tensor1d([0, 1], 'int32'), 3).print();
 * ```
 *
 * @param indices `tf.Tensor` of indices with dtype `int32`. Indices must
 * start from 0.
 * @param depth The depth of the one hot dimension.
 * @param onValue A number used to fill in the output when the index matches
 * the location.
 * @param offValue A number used to fill in the output when the index does
 *     not match the location.
 * @param dtype The dtype of the output tensor, default to 'int32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $d263ffd91bb8ab3a$var$oneHot_(indices, depth, onValue = 1, offValue = 0, dtype = 'int32') {
    if (depth < 2) throw new Error(`Error in oneHot: depth must be >=2, but it is ${depth}`);
    const $indices = (0, $010a899b69412c72$export$ede379c4c939d71a)(indices, 'indices', 'oneHot', 'int32');
    const inputs = {
        indices: $indices
    };
    const attrs = {
        dtype: dtype,
        depth: depth,
        onValue: onValue,
        offValue: offValue
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$18982b43ba8c02e9), inputs, attrs);
}
const $d263ffd91bb8ab3a$export$341b5490a776d041 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    oneHot_: $d263ffd91bb8ab3a$var$oneHot_
});



var $7bef7bb1507e4cb8$exports = {};

$parcel$export($7bef7bb1507e4cb8$exports, "transpose", () => $7bef7bb1507e4cb8$export$9cb09a71b7d66923);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the imaginary part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the imaginary part of each element in input considered as a complex number.
 * If input is real, a tensor of all zeros is returned.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.imag(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $0e1dcb58360d86cd$var$imag_(input) {
    const $input = (0, $010a899b69412c72$export$ede379c4c939d71a)(input, 'input', 'imag');
    const inputs = {
        input: $input
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$303b4473993a24f), inputs);
}
const $0e1dcb58360d86cd$export$d78fab5778ab392b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    imag_: $0e1dcb58360d86cd$var$imag_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes `-1 * x` element-wise.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, -2, 0], [2, 2]);
 *
 * x.neg().print();  // or tf.neg(x)
 * ```
 *
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0ca018ac52410371$var$neg_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'neg');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c07c549000872073), inputs);
}
const $0ca018ac52410371$export$d9493ff0dfa0fdd5 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    neg_: $0ca018ac52410371$var$neg_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the real part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the real part of each element in input considered as a complex number.
 *
 * If the input is real, it simply makes a clone.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.real(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $8189f77a6a673bd0$var$real_(input) {
    const $input = (0, $010a899b69412c72$export$ede379c4c939d71a)(input, 'input', 'real');
    const inputs = {
        input: $input
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$f41305719b94e675), inputs);
}
const $8189f77a6a673bd0$export$9fc57fb453bdbd67 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    real_: $8189f77a6a673bd0$var$real_
});


/**
 * Transposes the `tf.Tensor`. Permutes the dimensions according to `perm`.
 *
 * The returned `tf.Tensor`'s dimension `i` will correspond to the input
 * dimension `perm[i]`. If `perm` is not given, it is set to `[n-1...0]`,
 * where `n` is the rank of the input `tf.Tensor`. Hence by default, this
 * operation performs a regular matrix transpose on 2-D input `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4, 5, 6], [2, 3]);
 *
 * a.transpose().print();  // or tf.transpose(a)
 * ```
 *
 * @param x The tensor to transpose.
 * @param perm The permutation of the dimensions of a.
 * @param conjugate Will conjugate complex input if true.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $7bef7bb1507e4cb8$var$transpose_(x, perm, conjugate) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'transpose');
    if (perm == null) perm = $x.shape.map((s, i)=>i).reverse();
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === perm.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of perm ${perm}.`);
    perm.forEach((axis)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(axis >= 0 && axis < $x.rank, ()=>`All entries in 'perm' must be between 0 and ${$x.rank - 1}` + ` but got ${perm}`);
    });
    if ($x.rank <= 1) return $x.clone();
    const inputs = {
        x: $x
    };
    const attrs = {
        perm: perm
    };
    if ($x.dtype === 'complex64') return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
        let $real = (0, $8189f77a6a673bd0$export$9fc57fb453bdbd67)($x);
        let $imag = (0, $0e1dcb58360d86cd$export$d78fab5778ab392b)($x);
        $real = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$7e714455f9a1f8f7), {
            x: $real
        }, attrs);
        $imag = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$7e714455f9a1f8f7), {
            x: $imag
        }, attrs);
        if (conjugate) $imag = (0, $0ca018ac52410371$export$d9493ff0dfa0fdd5)($imag);
        return (0, $175eb29e145dcf53$export$83a0e34f1302825b)($real, $imag);
    });
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$7e714455f9a1f8f7), inputs, attrs);
}
const $7bef7bb1507e4cb8$export$9cb09a71b7d66923 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    transpose_: $7bef7bb1507e4cb8$var$transpose_
});


function $3938e3541a82a004$export$fdc6eac044b0dee2(labels, predictions, numClasses) {
    const $labels = (0, $010a899b69412c72$export$ede379c4c939d71a)(labels, 'labels', 'confusionMatrix');
    const $predictions = (0, $010a899b69412c72$export$ede379c4c939d71a)(predictions, 'predictions', 'confusionMatrix');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(numClasses == null || numClasses > 0 && Number.isInteger(numClasses), ()=>`If provided, numClasses must be a positive integer, ` + `but got ${numClasses}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($labels.rank === 1, ()=>`Expected the rank of labels to be 1, but got ${$labels.rank}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($predictions.rank === 1, ()=>`Expected the rank of predictions to be 1, ` + `but got ${$predictions.rank}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($labels.shape[0] === $predictions.shape[0], ()=>`Mismatch in the number of examples: ` + `${$labels.shape[0]} vs. ${$predictions.shape[0]}. ` + `Labels and predictions should have the same number of elements.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(numClasses > 0 && Number.isInteger(numClasses), ()=>`numClasses is required to be a positive integer, but got ` + `${numClasses}`);
    // TODO(cais): In the future, if oneHot supports tensors inputs for
    //   `numClasses`, `confusionMatrix` can make `numClasses` optional.
    const oneHotLabels = (0, $d263ffd91bb8ab3a$export$341b5490a776d041)((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($labels, 'int32'), numClasses);
    const oneHotPredictions = (0, $d263ffd91bb8ab3a$export$341b5490a776d041)((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($predictions, 'int32'), numClasses);
    const oneHotLabelsT = (0, $7bef7bb1507e4cb8$export$9cb09a71b7d66923)(oneHotLabels);
    const product = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(oneHotLabelsT, oneHotPredictions);
    return (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(product, 'int32');
}
const $3938e3541a82a004$export$e83fd4c6c32bfa2e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    confusionMatrix_: $3938e3541a82a004$export$fdc6eac044b0dee2
});





var $90849bbe88a0108e$exports = {};

$parcel$export($90849bbe88a0108e$exports, "fromPixelsAsync", () => $90849bbe88a0108e$export$6b17f27238fa6bff);
$parcel$export($90849bbe88a0108e$exports, "toPixels", () => $90849bbe88a0108e$export$89b6cc959998e12e);
$parcel$export($90849bbe88a0108e$exports, "draw", () => $90849bbe88a0108e$export$e529deb2bfd496dc);
$parcel$export($90849bbe88a0108e$exports, "fromPixels", () => $90849bbe88a0108e$export$5a3bc84b10e77d32);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 







/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $4da6fbe2266e5502$export$aa36a9de53c6d912(values, shape, dtype) {
    (0, $5f8d0ee7a8d35dfe$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 3) throw new Error('tensor3d() requires shape to have three numbers');
    const inferredShape = (0, $010a899b69412c72$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 3 && inferredShape.length !== 1) throw new Error('tensor3d() requires values to be number[][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
    return (0, $a024938a45229223$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


let $90849bbe88a0108e$var$fromPixels2DContext;
let $90849bbe88a0108e$var$hasToPixelsWarned = false;
/**
 * Creates a `tf.Tensor` from an image.
 *
 * ```js
 * const image = new ImageData(1, 1);
 * image.data[0] = 100;
 * image.data[1] = 150;
 * image.data[2] = 200;
 * image.data[3] = 255;
 *
 * tf.browser.fromPixels(image).print();
 * ```
 *
 * @param pixels The input image to construct the tensor from. The
 * supported image types are all 4-channel. You can also pass in an image
 * object with following attributes:
 * `{data: Uint8Array; width: number; height: number}`
 * @param numChannels The number of channels of the output tensor. A
 * numChannels value less than 4 allows you to ignore channels. Defaults to
 * 3 (ignores alpha channel of input image).
 *
 * @returns A Tensor3D with the shape `[height, width, numChannels]`.
 *
 * Note: fromPixels can be lossy in some cases, same image may result in
 * slightly different tensor values, if rendered by different rendering
 * engines. This means that results from different browsers, or even same
 * browser with CPU and GPU rendering engines can be different. See discussion
 * in details:
 * https://github.com/tensorflow/tfjs/issues/5482
 *
 * @doc {heading: 'Browser', namespace: 'browser', ignoreCI: true}
 */ function $90849bbe88a0108e$var$fromPixels_(pixels, numChannels = 3) {
    // Sanity checks.
    if (numChannels > 4) throw new Error('Cannot construct Tensor with more than 4 channels from pixels.');
    if (pixels == null) throw new Error('pixels passed to tf.browser.fromPixels() can not be null');
    let isPixelData = false;
    let isImageData = false;
    let isVideo = false;
    let isImage = false;
    let isCanvasLike = false;
    let isImageBitmap = false;
    if (pixels.data instanceof Uint8Array) isPixelData = true;
    else if (typeof ImageData !== 'undefined' && pixels instanceof ImageData) isImageData = true;
    else if (typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement) isVideo = true;
    else if (typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement) isImage = true;
    else if (pixels.getContext != null) isCanvasLike = true;
    else if (typeof ImageBitmap !== 'undefined' && pixels instanceof ImageBitmap) isImageBitmap = true;
    else throw new Error('pixels passed to tf.browser.fromPixels() must be either an ' + `HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData ` + `in browser, or OffscreenCanvas, ImageData in webworker` + ` or {data: Uint32Array, width: number, height: number}, ` + `but was ${pixels.constructor.name}`);
    // If the current backend has 'FromPixels' registered, it has a more
    // efficient way of handling pixel uploads, so we call that.
    const kernel = (0, $a6ed5fb1cf7ee2a4$export$1b85808c967cc434)((0, $c9f78399309a8a0d$export$d0eb4e7054966c48), (0, $249f84ddb1ced836$export$33b63313cc511a3b).backendName);
    if (kernel != null) {
        const inputs = {
            pixels: pixels
        };
        const attrs = {
            numChannels: numChannels
        };
        return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$d0eb4e7054966c48), inputs, attrs);
    }
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    let vals;
    if (isCanvasLike) vals = // tslint:disable-next-line:no-any
    pixels.getContext('2d').getImageData(0, 0, width, height).data;
    else if (isImageData || isPixelData) vals = pixels.data;
    else if (isImage || isVideo || isImageBitmap) {
        if ($90849bbe88a0108e$var$fromPixels2DContext == null) {
            if (typeof document === 'undefined') {
                if (typeof OffscreenCanvas !== 'undefined' && typeof OffscreenCanvasRenderingContext2D !== 'undefined') // @ts-ignore
                $90849bbe88a0108e$var$fromPixels2DContext = new OffscreenCanvas(1, 1).getContext('2d');
                else throw new Error("Cannot parse input in current context. Reason: OffscreenCanvas Context2D rendering is not supported.");
            } else $90849bbe88a0108e$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                willReadFrequently: true
            });
        }
        $90849bbe88a0108e$var$fromPixels2DContext.canvas.width = width;
        $90849bbe88a0108e$var$fromPixels2DContext.canvas.height = height;
        $90849bbe88a0108e$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
        vals = $90849bbe88a0108e$var$fromPixels2DContext.getImageData(0, 0, width, height).data;
    }
    let values;
    if (numChannels === 4) values = new Int32Array(vals);
    else {
        const numPixels = width * height;
        values = new Int32Array(numPixels * numChannels);
        for(let i = 0; i < numPixels; i++)for(let channel = 0; channel < numChannels; ++channel)values[i * numChannels + channel] = vals[i * 4 + channel];
    }
    const outShape = [
        height,
        width,
        numChannels
    ];
    return (0, $4da6fbe2266e5502$export$aa36a9de53c6d912)(values, outShape, 'int32');
}
// Helper functions for |fromPixelsAsync| to check whether the input can
// be wrapped into imageBitmap.
function $90849bbe88a0108e$var$isPixelData(pixels) {
    return pixels != null && pixels.data instanceof Uint8Array;
}
function $90849bbe88a0108e$var$isImageBitmapFullySupported() {
    return typeof window !== 'undefined' && typeof ImageBitmap !== 'undefined' && window.hasOwnProperty('createImageBitmap');
}
function $90849bbe88a0108e$var$isNonEmptyPixels(pixels) {
    return pixels != null && pixels.width !== 0 && pixels.height !== 0;
}
function $90849bbe88a0108e$var$canWrapPixelsToImageBitmap(pixels) {
    return $90849bbe88a0108e$var$isImageBitmapFullySupported() && !(pixels instanceof ImageBitmap) && $90849bbe88a0108e$var$isNonEmptyPixels(pixels) && !$90849bbe88a0108e$var$isPixelData(pixels);
}
async function $90849bbe88a0108e$export$6b17f27238fa6bff(pixels, numChannels = 3) {
    let inputs = null;
    // Check whether the backend needs to wrap |pixels| to imageBitmap and
    // whether |pixels| can be wrapped to imageBitmap.
    if ((0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('WRAP_TO_IMAGEBITMAP') && $90849bbe88a0108e$var$canWrapPixelsToImageBitmap(pixels)) {
        // Force the imageBitmap creation to not do any premultiply alpha
        // ops.
        let imageBitmap;
        try {
            // wrap in try-catch block, because createImageBitmap may not work
            // properly in some browsers, e.g.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1335594
            // tslint:disable-next-line: no-any
            imageBitmap = await createImageBitmap(pixels, {
                premultiplyAlpha: 'none'
            });
        } catch (e) {
            imageBitmap = null;
        }
        // createImageBitmap will clip the source size.
        // In some cases, the input will have larger size than its content.
        // E.g. new Image(10, 10) but with 1 x 1 content. Using
        // createImageBitmap will clip the size from 10 x 10 to 1 x 1, which
        // is not correct. We should avoid wrapping such resouce to
        // imageBitmap.
        if (imageBitmap != null && imageBitmap.width === pixels.width && imageBitmap.height === pixels.height) inputs = imageBitmap;
        else inputs = pixels;
    } else inputs = pixels;
    return $90849bbe88a0108e$var$fromPixels_(inputs, numChannels);
}
function $90849bbe88a0108e$var$validateImgTensor(img) {
    if (img.rank !== 2 && img.rank !== 3) throw new Error(`toPixels only supports rank 2 or 3 tensors, got rank ${img.rank}.`);
    const depth = img.rank === 2 ? 1 : img.shape[2];
    if (depth > 4 || depth === 2) throw new Error(`toPixels only supports depth of size ` + `1, 3 or 4 but got ${depth}`);
    if (img.dtype !== 'float32' && img.dtype !== 'int32') throw new Error(`Unsupported type for toPixels: ${img.dtype}.` + ` Please use float32 or int32 tensors.`);
}
function $90849bbe88a0108e$var$validateImageOptions(imageOptions) {
    const alpha = (imageOptions === null || imageOptions === void 0 ? void 0 : imageOptions.alpha) || 1;
    if (alpha > 1 || alpha < 0) throw new Error(`Alpha value ${alpha} is suppoed to be in range [0 - 1].`);
}
async function $90849bbe88a0108e$export$89b6cc959998e12e(img, canvas) {
    let $img = (0, $010a899b69412c72$export$ede379c4c939d71a)(img, 'img', 'toPixels');
    if (!(img instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814))) {
        // Assume int32 if user passed a native array.
        const originalImgTensor = $img;
        $img = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(originalImgTensor, 'int32');
        originalImgTensor.dispose();
    }
    $90849bbe88a0108e$var$validateImgTensor($img);
    const [height, width] = $img.shape.slice(0, 2);
    const depth = $img.rank === 2 ? 1 : $img.shape[2];
    const data = await $img.data();
    const multiplier = $img.dtype === 'float32' ? 255 : 1;
    const bytes = new Uint8ClampedArray(width * height * 4);
    for(let i = 0; i < height * width; ++i){
        const rgba = [
            0,
            0,
            0,
            255
        ];
        for(let d = 0; d < depth; d++){
            const value = data[i * depth + d];
            if ($img.dtype === 'float32') {
                if (value < 0 || value > 1) throw new Error(`Tensor values for a float32 Tensor must be in the ` + `range [0 - 1] but encountered ${value}.`);
            } else if ($img.dtype === 'int32') {
                if (value < 0 || value > 255) throw new Error(`Tensor values for a int32 Tensor must be in the ` + `range [0 - 255] but encountered ${value}.`);
            }
            if (depth === 1) {
                rgba[0] = value * multiplier;
                rgba[1] = value * multiplier;
                rgba[2] = value * multiplier;
            } else rgba[d] = value * multiplier;
        }
        const j = i * 4;
        bytes[j + 0] = Math.round(rgba[0]);
        bytes[j + 1] = Math.round(rgba[1]);
        bytes[j + 2] = Math.round(rgba[2]);
        bytes[j + 3] = Math.round(rgba[3]);
    }
    if (canvas != null) {
        if (!$90849bbe88a0108e$var$hasToPixelsWarned) {
            const kernel = (0, $a6ed5fb1cf7ee2a4$export$1b85808c967cc434)((0, $c9f78399309a8a0d$export$dca20402ebea5ece), (0, $249f84ddb1ced836$export$33b63313cc511a3b).backendName);
            if (kernel != null) {
                console.warn("tf.browser.toPixels is not efficient to draw tensor on canvas. Please try tf.browser.draw instead.");
                $90849bbe88a0108e$var$hasToPixelsWarned = true;
            }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        const imageData = new ImageData(bytes, width, height);
        ctx.putImageData(imageData, 0, 0);
    }
    if ($img !== img) $img.dispose();
    return bytes;
}
function $90849bbe88a0108e$export$e529deb2bfd496dc(image, canvas, options) {
    let $img = (0, $010a899b69412c72$export$ede379c4c939d71a)(image, 'img', 'draw');
    if (!(image instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814))) {
        // Assume int32 if user passed a native array.
        const originalImgTensor = $img;
        $img = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(originalImgTensor, 'int32');
        originalImgTensor.dispose();
    }
    $90849bbe88a0108e$var$validateImgTensor($img);
    $90849bbe88a0108e$var$validateImageOptions(options === null || options === void 0 ? void 0 : options.imageOptions);
    const inputs = {
        image: $img
    };
    const attrs = {
        canvas: canvas,
        options: options
    };
    (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$dca20402ebea5ece), inputs, attrs);
}
const $90849bbe88a0108e$export$5a3bc84b10e77d32 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    fromPixels_: $90849bbe88a0108e$var$fromPixels_
});


var $36339f0b093f9859$exports = {};

$parcel$export($36339f0b093f9859$exports, "prepareAndValidate", () => $36339f0b093f9859$export$6bb34ea9be10068f);

function $36339f0b093f9859$export$6bb34ea9be10068f(tensor, indices) {
    const tensorRank = tensor.shape.length;
    const indicesRank = indices.shape.length;
    if (tensorRank < 1) throw new Error('tf.gatherND() expects the input to be rank 1 or higher,' + ` but the rank was ${tensorRank}.`);
    if (indicesRank < 1) throw new Error('tf.gatherND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indicesRank}.`);
    if (indices.dtype !== 'int32') throw new Error('tf.gatherND() expects the indices to be int32 type,' + ` but the dtype was ${indices.dtype}.`);
    if (indices.shape[indicesRank - 1] > tensorRank) throw new Error('index innermost dimension length must be <= tensor rank; saw: ' + `${indices.shape[indicesRank - 1]} vs. ${tensorRank}`);
    if ((0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(tensor.shape) === 0) throw new Error('Requested more than 0 entries, but input is empty.' + ` Input shape: ${tensor.shape}.`);
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    // The result shape is
    //   indices.shape[:-1] + params.shape[indices.shape[-1]:]
    let nResult = 1;
    for(let i = 0; i < indicesShape.length - 1; ++i)nResult *= indicesShape[i];
    const inputShape = tensor.shape;
    const resultShape = indicesShape.slice();
    resultShape.pop();
    let sliceSize = 1;
    for(let i = sliceRank; i < tensorRank; ++i){
        sliceSize *= inputShape[i];
        resultShape.push(inputShape[i]);
    }
    const strides = [
        ...(0, $5f8d0ee7a8d35dfe$export$6ad0292cf4d50f79)(tensor.shape).map((stride)=>stride / sliceSize),
        1
    ].slice(0, sliceRank);
    return [
        resultShape,
        nResult,
        sliceSize,
        strides
    ];
}


var $57b46503159dbf6f$exports = {};

$parcel$export($57b46503159dbf6f$exports, "validateUpdateShape", () => $57b46503159dbf6f$export$9d843bc97e7022ed);
$parcel$export($57b46503159dbf6f$exports, "validateInput", () => $57b46503159dbf6f$export$4d09d4ac8ba225dd);
$parcel$export($57b46503159dbf6f$exports, "calculateShapes", () => $57b46503159dbf6f$export$4dc1a8917bf18661);

function $57b46503159dbf6f$export$9d843bc97e7022ed(shape, indices, updates) {
    const sliceDim = indices.rank > 1 ? indices.shape[indices.rank - 1] : 1;
    const batchDim = indices.rank > 1 ? indices.rank - 1 : 1;
    const shapeError = 'Must have updates.shape = indices.shape[:batchDim] + ' + `shape[sliceDim:], got updates.shape: ${updates.shape}` + `, indices.shape: ${indices.shape}, shape: ${shape}` + `, sliceDim: ${sliceDim}, and batchDim: ${batchDim}.`;
    if (updates.rank < batchDim) throw new Error(shapeError + ` update.rank < ${batchDim}. `);
    if (shape.length < sliceDim + (updates.rank - batchDim)) throw new Error(shapeError + ` Output shape length < ${sliceDim + (updates.rank - batchDim)}`);
    if (updates.rank !== batchDim + shape.length - sliceDim) throw new Error(shapeError + ` update.rank != ${batchDim + shape.length - sliceDim}`);
    for(let d = 0; d < batchDim; ++d){
        if (updates.shape[d] !== indices.shape[d]) throw new Error(shapeError + ` updates.shape[${d}] (${updates.shape[d]}) != indices.shape[${d}] (${indices.shape[d]}).`);
    }
    for(let d = 0; d < updates.rank - batchDim; ++d){
        if (updates.shape[d + batchDim] !== shape[d + sliceDim]) throw new Error(shapeError + ` updates.shape[${d + batchDim}] (${updates.shape[d + batchDim]}) != shape[${d + batchDim}] (${shape[d + batchDim]})`);
    }
}
function $57b46503159dbf6f$export$4d09d4ac8ba225dd(updates, indices, shape) {
    if (indices.rank < 1) throw new Error('tf.scatterND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indices.rank}.`);
    if (updates.rank < 1) throw new Error('tf.scatterND() expects the updates to be rank 1 or higher,' + ` but the rank was ${updates.rank}.`);
    if (indices.dtype !== 'int32') throw new Error(`The dtype of 'indices' should be int32, but got dtype: ${indices.dtype}`);
    if (shape.length < 1) throw new Error(`Output rank must be greater or equal to 1, but got shape: ${shape}`);
    if (shape.length === 0) {
        if (indices.size === 0) throw new Error(`Indices specified for empty output. indices shape: ${indices.shape}`);
        if (updates.size === 0) throw new Error(`Updates specified for empty output. updates shape: ${updates.shape}`);
    }
    $57b46503159dbf6f$export$9d843bc97e7022ed(shape, indices, updates);
}
function $57b46503159dbf6f$export$4dc1a8917bf18661(updates, indices, shape) {
    // Calculate the number of dimensions in indices
    const indicesRank = indices.shape.length;
    const sliceRank = indicesRank > 1 ? indices.shape[indicesRank - 1] : 1;
    // Calculate the number of elements that make up each slice of our updated
    // tensor. This allows us to work with flattened tensors and copy over whole
    // slices at a time.
    const totalNd = shape.length;
    let sliceSize = 1;
    for(let i = sliceRank; i < totalNd; ++i)sliceSize *= shape[i];
    const safeSliceDim = sliceRank < 1 ? 1 : sliceRank;
    const numUpdates = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(indices.shape) / safeSliceDim;
    const strides = [
        ...(0, $5f8d0ee7a8d35dfe$export$6ad0292cf4d50f79)(shape.slice(0, sliceRank)),
        1
    ];
    const outputSize = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(shape);
    return {
        sliceRank: sliceRank,
        numUpdates: numUpdates,
        sliceSize: sliceSize,
        strides: strides,
        outputSize: outputSize
    };
}


var $857e39e1331d3036$exports = {};

$parcel$export($857e39e1331d3036$exports, "assertParamsValid", () => $857e39e1331d3036$export$1da6c8ba17e84239);
$parcel$export($857e39e1331d3036$exports, "maskToAxes", () => $857e39e1331d3036$export$ce8be3e704107015);
$parcel$export($857e39e1331d3036$exports, "computeOutShape", () => $857e39e1331d3036$export$22fa6b3b1305508e);
$parcel$export($857e39e1331d3036$exports, "stridesWithElidedDims", () => $857e39e1331d3036$export$7f5fa1173bdb6e15);
$parcel$export($857e39e1331d3036$exports, "getNormalizedAxes", () => $857e39e1331d3036$export$895fe9252fb79d1);
$parcel$export($857e39e1331d3036$exports, "startIndicesWithElidedDims", () => $857e39e1331d3036$export$a9f0de12634a4ce3);
$parcel$export($857e39e1331d3036$exports, "stopIndicesWithElidedDims", () => $857e39e1331d3036$export$19a416bd7e87244f);
$parcel$export($857e39e1331d3036$exports, "startForAxis", () => $857e39e1331d3036$export$643aca61b9318da8);
$parcel$export($857e39e1331d3036$exports, "stopForAxis", () => $857e39e1331d3036$export$612a961a199ffe65);
$parcel$export($857e39e1331d3036$exports, "stridesForAxis", () => $857e39e1331d3036$export$9e3fd91f45c1f07f);
$parcel$export($857e39e1331d3036$exports, "isSliceContinous", () => $857e39e1331d3036$export$9dc11bd6855e72c6);
$parcel$export($857e39e1331d3036$exports, "computeFlatOffset", () => $857e39e1331d3036$export$b01553f5da8f819c);
$parcel$export($857e39e1331d3036$exports, "parseSliceParams", () => $857e39e1331d3036$export$8448a0604fef5d62);
$parcel$export($857e39e1331d3036$exports, "sliceInfo", () => $857e39e1331d3036$export$54d224865abb6767);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $857e39e1331d3036$var$NEW_AXIS = -2;
const $857e39e1331d3036$var$SHRINK_AXIS = -1;
function $857e39e1331d3036$export$1da6c8ba17e84239(input, begin, size) {
    const inputRank = input.shape.length;
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inputRank === begin.length, ()=>`Error in slice${inputRank}D: Length of begin ${begin} must ` + `match the rank of the array (${inputRank}).`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inputRank === size.length, ()=>`Error in slice${inputRank}D: Length of size ${size} must ` + `match the rank of the array (${inputRank}).`);
    for(let i = 0; i < inputRank; ++i)$5f8d0ee7a8d35dfe$export$a7a9523472993e97(begin[i] + size[i] <= input.shape[i], ()=>`Error in slice${inputRank}D: begin[${i}] + size[${i}] ` + `(${begin[i] + size[i]}) would overflow input.shape[${i}] (${input.shape[i]})`);
}
function $857e39e1331d3036$export$ce8be3e704107015(mask) {
    const axes = [];
    let axis = 0;
    while(mask > 0){
        if (mask & 1) axes.push(axis);
        mask /= 2;
        axis++;
    }
    return axes;
}
function $857e39e1331d3036$export$22fa6b3b1305508e(begin, end, strides) {
    const size = [];
    for(let axis = 0; axis < begin.length; axis++)size[axis] = Math.ceil((end[axis] - begin[axis]) / strides[axis]);
    return size;
}
function $857e39e1331d3036$export$7f5fa1173bdb6e15(strides, ellipsisInsertionIndex, numElidedAxes, inputShape) {
    const newStrides = [
        ...strides
    ];
    for(let i = newStrides.length; i < inputShape.length; i++)newStrides.push(1);
    for(let i = 0; i < numElidedAxes; i++)if (i === 0) newStrides[ellipsisInsertionIndex] = 1;
    else {
        newStrides.splice(ellipsisInsertionIndex, 0 /* num elements to delete */ , 1 /* element to add */ );
        newStrides.pop();
    }
    return newStrides;
}
function $857e39e1331d3036$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, normalizedAxis) {
    if (normalizedAxis <= ellipsisInsertionIndex) return normalizedAxis;
    return normalizedAxis - (numElidedAxes - 1);
}
function $857e39e1331d3036$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex) {
    const elidedAxes = [];
    for(let i = 0; i < numElidedAxes; i++)elidedAxes.push(ellipsisInsertionIndex + i);
    return elidedAxes;
}
function $857e39e1331d3036$export$895fe9252fb79d1(inputShape, ellipsisAxes, numInterpolatedAxes, begin, end, strides, beginMask, endMask, ellipsisMask) {
    const inputRank = inputShape.length;
    let normalizedBegin = new Array(inputRank), normalizedEnd = new Array(inputRank), normalizedStrides = new Array(inputRank);
    if (ellipsisAxes.length && numInterpolatedAxes > 0) {
        const fullIndex = ellipsisAxes[0];
        // The ellipsis applies to the masked index as well as any dimensions
        // that are interpolated.
        const numElidedAxes = numInterpolatedAxes + 1;
        normalizedBegin = $857e39e1331d3036$export$a9f0de12634a4ce3(beginMask, fullIndex, numElidedAxes, begin, inputShape);
        normalizedEnd = $857e39e1331d3036$export$19a416bd7e87244f(endMask, fullIndex, numElidedAxes, end, inputShape);
        normalizedStrides = $857e39e1331d3036$export$7f5fa1173bdb6e15(strides, fullIndex, numElidedAxes, inputShape);
    } else for(let axis = 0; axis < inputRank; axis++){
        normalizedBegin[axis] = $857e39e1331d3036$export$643aca61b9318da8(beginMask, begin, strides, inputShape, axis, ellipsisMask);
        normalizedEnd[axis] = $857e39e1331d3036$export$612a961a199ffe65(endMask, end, strides, inputShape, axis, ellipsisMask);
        normalizedStrides[axis] = $857e39e1331d3036$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask);
    }
    return {
        begin: normalizedBegin,
        end: normalizedEnd,
        strides: normalizedStrides
    };
}
function $857e39e1331d3036$export$a9f0de12634a4ce3(beginMask, ellipsisInsertionIndex, numElidedAxes, originalBegin, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $857e39e1331d3036$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = 0;
    else {
        const originalAxis = $857e39e1331d3036$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalBegin[originalAxis];
        if (beginMask & 1 << originalAxis) originalValue = 0;
        newIndices[axis] = originalValue;
    }
    return newIndices;
}
function $857e39e1331d3036$export$19a416bd7e87244f(endMask, ellipsisInsertionIndex, numElidedAxes, originalEnd, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $857e39e1331d3036$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = Number.MAX_SAFE_INTEGER;
    else {
        const originalAxis = $857e39e1331d3036$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalEnd[originalAxis];
        if (endMask & 1 << originalAxis) originalValue = Number.MAX_SAFE_INTEGER;
        newIndices[axis] = originalValue;
    }
    for(let i = 0; i < newIndices.length; i++){
        // Handle negative indices
        const axisSize = inputShape[i];
        if (newIndices[i] < 0) newIndices[i] += axisSize;
        newIndices[i] = $5f8d0ee7a8d35dfe$export$7d15b64cf5a3a4c4(0, newIndices[i], inputShape[i]);
    }
    return newIndices;
}
function $857e39e1331d3036$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask) {
    let stride = strides[axis];
    if (ellipsisMask & 1 << axis || stride == null) stride = 1;
    return stride;
}
function $857e39e1331d3036$export$643aca61b9318da8(beginMask, startIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let start = startIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or the begin index is not set
    // for the axis.
    if (beginMask & 1 << axis || ellipsisMask & 1 << axis || start == null) {
        if (stride > 0) // Forward iteration - use the first element. These values will get
        // clamped below (Note: We could have set them to 0 and axis_size-1, but
        // use lowest() and max() to maintain symmetry with StopForAxis())
        start = Number.MIN_SAFE_INTEGER;
        else // Backward iteration - use the last element.
        start = Number.MAX_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (start < 0) start += axisSize;
    // Clamping
    start = $5f8d0ee7a8d35dfe$export$7d15b64cf5a3a4c4(0, start, axisSize - 1);
    return start;
}
function $857e39e1331d3036$export$612a961a199ffe65(endMask, stopIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let stop = stopIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or if the stop index is not
    // set for this axis.
    if (endMask & 1 << axis || ellipsisMask & 1 << axis || stop == null) {
        if (stride > 0) // Forward iteration - use the last element. These values will get
        // clamped below
        stop = Number.MAX_SAFE_INTEGER;
        else // Backward iteration - use the first element.
        stop = Number.MIN_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (stop < 0) stop += axisSize;
    // Clamping
    // Because the end index points one past the last element, we need slightly
    // different clamping ranges depending on the direction.
    if (stride > 0) // Forward iteration
    stop = $5f8d0ee7a8d35dfe$export$7d15b64cf5a3a4c4(0, stop, axisSize);
    else // Backward iteration
    stop = $5f8d0ee7a8d35dfe$export$7d15b64cf5a3a4c4(-1, stop, axisSize - 1);
    return stop;
}
function $857e39e1331d3036$export$9dc11bd6855e72c6(shape, begin, size) {
    // Index of the first axis that has size > 1.
    let firstNonOneAxis = size.length;
    for(let i = 0; i < size.length; i++)if (size[i] > 1) {
        firstNonOneAxis = i;
        break;
    }
    for(let i = firstNonOneAxis + 1; i < size.length; i++){
        if (begin[i] > 0 || size[i] !== shape[i]) return false;
    }
    return true;
}
function $857e39e1331d3036$export$b01553f5da8f819c(begin, strides) {
    let flatOffset = begin.length > 0 ? begin[begin.length - 1] : 1;
    for(let i = 0; i < begin.length - 1; i++)flatOffset += begin[i] * strides[i];
    return flatOffset;
}
function $857e39e1331d3036$export$8448a0604fef5d62(x, begin, size) {
    // The following logic allows for more ergonomic calls.
    let begin_;
    const xRank = x.shape.length;
    if (typeof begin === 'number') begin_ = [
        begin,
        ...new Array(xRank - 1).fill(0)
    ];
    else if (begin.length < xRank) begin_ = begin.concat(new Array(xRank - begin.length).fill(0));
    else begin_ = begin.slice();
    begin_.forEach((d)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(d !== -1, ()=>'slice() does not support negative begin indexing.');
    });
    let size_;
    if (size == null) size_ = new Array(xRank).fill(-1);
    else if (typeof size === 'number') size_ = [
        size,
        ...new Array(xRank - 1).fill(-1)
    ];
    else if (size.length < xRank) size_ = size.concat(new Array(xRank - size.length).fill(-1));
    else size_ = size;
    size_ = size_.map((d, i)=>{
        if (d >= 0) return d;
        else {
            $5f8d0ee7a8d35dfe$export$a7a9523472993e97(d === -1, ()=>`Negative size values should be exactly -1 but got ` + `${d} for the slice() size at index ${i}.`);
            return x.shape[i] - begin_[i];
        }
    });
    return [
        begin_,
        size_
    ];
}
function $857e39e1331d3036$export$54d224865abb6767(xShape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
    let stridesNonNull;
    if (strides == null) {
        stridesNonNull = new Array(begin.length);
        stridesNonNull.fill(1);
    } else stridesNonNull = strides;
    // Only one non-zero bit is allowed in ellipsisMask, which means ellipsisMask
    // is a power of 2. Use bit compares to ensure ellipsisMask is 0 or a power
    // of 2. When i is a power of 2, i & (i - 1) is always 0.
    // Also ref:
    // https://stackoverflow.com/questions/600293/how-to-check-if-a-number-is-a-power-of-2
    if (ellipsisMask != null && (ellipsisMask & ellipsisMask - 1) !== 0) throw new Error('Multiple ellipses in slice is not allowed.');
    // Step 1: Account for ellipsis and new axis.
    // Check for ellipsis and count how many non-newaxis there are after.
    let ellipsisSeen = false;
    const sparseSpec = {
        dims: stridesNonNull.length,
        numAddAxisAfterEllipsis: 0,
        begin: begin.slice(),
        end: end.slice(),
        strides: stridesNonNull.slice(),
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    for(let i = 0; i < sparseSpec.dims; i++){
        if (ellipsisSeen && (1 << i & newAxisMask) !== 0) sparseSpec.numAddAxisAfterEllipsis++;
        if (1 << i & ellipsisMask) ellipsisSeen = true;
    }
    // If no ellipsis insert one at the end.
    if (!ellipsisSeen) {
        sparseSpec.ellipsisMask |= 1 << sparseSpec.dims;
        sparseSpec.dims++; // this effects loop iteration below
    }
    // Step 2: Make a sparse spec into a full index spec.
    //
    // The sparse spec deos not correspond to the number of dimensions.
    // Make a dense spec that cooresponds to the number of dimensions.
    //
    // For example suppose foo[...,3:] on foo.shape = [2, 2, 3] then we need to
    // produce the missing beginMask for the first two dimensions i.e. from
    // beginMaskSpec = 0, endMaskSpec = 2, we achieve beginMask = 6 (110),
    // endMask = 7 (111).
    const denseSpec = {
        dims: xShape.length,
        beginMask: 0,
        endMask: 0,
        beginValid: false,
        endValid: false
    };
    $857e39e1331d3036$var$buildDenseSpec(sparseSpec, denseSpec);
    // Step 3: Make implicit ranges (non-zero beginMasks and endMasks) explicit
    // and bounds check.
    let isIdentity = true;
    let sliceDim0 = true;
    let isSimpleSlice = true;
    const processingShape = [];
    const finalShape = [];
    for(let i = 0; i < xShape.length; ++i){
        if (denseSpec.strides[i] === 0) throw Error(`strides[${i}] must be non-zero`);
        const shrinkI = !!(denseSpec.shrinkAxisMask & 1 << i);
        const dimI = xShape[i];
        if (dimI === -1) {
            processingShape.push(shrinkI ? 1 : -1);
            continue;
        }
        const masks = [
            denseSpec.beginMask & 1 << i,
            denseSpec.endMask & 1 << i
        ];
        const validRange = [
            denseSpec.strides[i] > 0 ? 0 : -1,
            denseSpec.strides[i] > 0 ? dimI : dimI - 1
        ];
        if (shrinkI && denseSpec.strides[i] <= 0) throw Error('only stride 1 allowed on non-range indexing.');
        isSimpleSlice = isSimpleSlice && denseSpec.strides[i] === 1;
        const beginAndEndMasked = !!(denseSpec.beginMask & 1 << i && denseSpec.endMask & 1 << i);
        if (denseSpec.beginValid && denseSpec.endValid) {
            if (shrinkI) {
                // If we are shrinking, the end index is now possibly incorrect. In
                // particular foo[-1] produces sparseBegin = -1, sparseEnd = 0.
                // and canonical puts these to n-1 and 0, which implies a degenerate
                // interval. Fortunately, it is now safe to re-create end as begin + 1.
                const xFwd = denseSpec.begin[i] < 0 ? dimI + denseSpec.begin[i] : denseSpec.begin[i];
                denseSpec.begin[i] = xFwd;
                denseSpec.end[i] = denseSpec.begin[i] + 1;
                if (xFwd < 0 || xFwd >= dimI) throw Error(`slice index ${denseSpec.begin[i]} of dimension ${i} out of bounds.`);
            } else {
                denseSpec.begin[i] = $857e39e1331d3036$var$canonical(denseSpec.begin[i], 0, denseSpec.strides[i], dimI, masks, validRange);
                denseSpec.end[i] = $857e39e1331d3036$var$canonical(denseSpec.end[i], 1, denseSpec.strides[i], dimI, masks, validRange);
            }
            // Update optimization values
            const takeAllInDimension = denseSpec.strides[i] === 1 && denseSpec.begin[i] === 0 && denseSpec.end[i] === dimI;
            isIdentity = isIdentity && takeAllInDimension;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || takeAllInDimension);
        } else {
            isIdentity = isIdentity && denseSpec.strides[i] === 1 && beginAndEndMasked;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || beginAndEndMasked);
        }
        // Compute the processing shape (the intermediate Eigen will produce)
        let intervalLength;
        let knownInterval = false;
        if (denseSpec.beginValid && denseSpec.endValid) {
            intervalLength = denseSpec.end[i] - denseSpec.begin[i];
            knownInterval = true;
        } else if (shrinkI) {
            // The dimension is still known as 1 for the processingShape, but will be
            // discarded for the final shape.
            intervalLength = 1;
            knownInterval = true;
        } else if (beginAndEndMasked) // Even if we don't have values for begin or end, we do know that this
        // dimension covers the whole interval. If we have shape information for
        // this dimension, that tells us the interval length.
        {
            if (dimI >= 0) {
                if (denseSpec.strides[i] < 0) intervalLength = -dimI;
                else intervalLength = dimI;
                knownInterval = true;
            }
        }
        if (knownInterval) {
            let sizeI;
            // Hold zero if the interval is degenerate, otherwise account for
            // remainder
            if (intervalLength === 0 || intervalLength < 0 !== denseSpec.strides[i] < 0) sizeI = 0;
            else sizeI = Math.trunc(intervalLength / denseSpec.strides[i]) + (intervalLength % denseSpec.strides[i] !== 0 ? 1 : 0);
            processingShape.push(sizeI);
        } else processingShape.push(-1);
    }
    // Step 4: Compute the final shape
    //
    // newAxis will increase dimension by 1 (with a one-size dimension)
    // slices like foo[3, ...] will reduce dimension by 1.
    // This cannot be done earlier, because it depends on Step 3.
    for(let denseDim = 0; denseDim < denseSpec.finalShapeGatherIndices.length; ++denseDim){
        const gatherIndex = denseSpec.finalShapeGatherIndices[denseDim];
        if (gatherIndex >= 0) finalShape.push(processingShape[gatherIndex]);
        else if (gatherIndex === $857e39e1331d3036$var$NEW_AXIS) finalShape.push(1);
    }
    const finalShapeSparse = finalShape.filter((dim, i)=>denseSpec.finalShapeGatherIndices[i] !== $857e39e1331d3036$var$NEW_AXIS);
    return {
        finalShapeSparse: finalShapeSparse,
        finalShape: finalShape,
        isIdentity: isIdentity,
        sliceDim0: sliceDim0,
        isSimpleSlice: isSimpleSlice,
        begin: denseSpec.begin,
        end: denseSpec.end,
        strides: denseSpec.strides
    };
}
function $857e39e1331d3036$var$buildDenseSpec(sparse, dense) {
    dense.beginMask = 0;
    dense.endMask = 0;
    dense.shrinkAxisMask = 0;
    let fullIndex = 0;
    dense.beginValid = sparse.begin != null;
    dense.endValid = sparse.end != null;
    dense.begin = new Array(dense.dims);
    dense.end = new Array(dense.dims);
    dense.strides = new Array(dense.dims);
    dense.finalShapeGatherIndices = [];
    dense.finalShapeGatherIndicesSparse = [];
    dense.inputShapeGatherIndicesSparse = new Array(dense.dims);
    for(let i = 0; i < sparse.dims; i++){
        if (1 << i & sparse.ellipsisMask) {
            // Only the bit that has ellipsis will fall in this condition.
            // Expand the ellipsis into the appropriate indices
            // Note: this only works because we guaranteed one ellipsis.
            const nextIndex = Math.min(dense.dims - (sparse.dims - i) + 1 + sparse.numAddAxisAfterEllipsis, dense.dims);
            for(; fullIndex < nextIndex; fullIndex++){
                // newAxis aren't real axis so you have to skip.
                dense.begin[fullIndex] = 0;
                dense.end[fullIndex] = 0;
                dense.strides[fullIndex] = 1;
                dense.beginMask |= 1 << fullIndex;
                dense.endMask |= 1 << fullIndex;
                dense.finalShapeGatherIndices.push(fullIndex);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            }
        } else if (1 << i & sparse.newAxisMask) {
            // Only the bit that has newAxis will fall in this condition.
            dense.finalShapeGatherIndices.push($857e39e1331d3036$var$NEW_AXIS);
            dense.finalShapeGatherIndicesSparse.push(-1);
        } else {
            if (fullIndex === dense.begin.length) throw Error(`Index out of range using input dim ${fullIndex}; input ` + `has only ${dense.dims} dims, ${dense.begin.length}.`);
            // Gather slicing spec into appropriate index.
            if (sparse.begin != null) dense.begin[fullIndex] = sparse.begin[i];
            if (sparse.end != null) dense.end[fullIndex] = sparse.end[i];
            dense.strides[fullIndex] = sparse.strides[i];
            if (sparse.beginMask & 1 << i) dense.beginMask |= 1 << fullIndex;
            if (sparse.endMask & 1 << i) dense.endMask |= 1 << fullIndex;
            // If shrink, record where to get the dimensionality from (i.e. newAxis)
            // creates a fake 1 size dimension. Also remember shrink axis (now in
            // dense form) so we can ignore dense.end below.
            if (sparse.shrinkAxisMask & 1 << i) {
                dense.finalShapeGatherIndices.push($857e39e1331d3036$var$SHRINK_AXIS);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.shrinkAxisMask |= 1 << fullIndex;
            } else {
                dense.finalShapeGatherIndices.push(fullIndex);
                // Remember that where in the sparse shape the dense dim comes from.
                dense.finalShapeGatherIndicesSparse.push(i);
            }
            dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            fullIndex++;
        }
    }
}
function $857e39e1331d3036$var$canonical(x, c, strideI, dimI, masks, validRange) {
    if (masks[c]) return strideI > 0 ? validRange[c] : validRange[c + 1 & 1];
    else {
        const xFwd = x < 0 ? dimI + x : x; // make negative indices positive
        return xFwd < validRange[0] ? validRange[0] : xFwd > validRange[1] ? validRange[1] : xFwd;
    }
}




var $4b634705d248be81$exports = {};

$parcel$export($4b634705d248be81$exports, "TEST_EPSILON_FLOAT16", () => $4b634705d248be81$export$a86b4427e7a62065);
$parcel$export($4b634705d248be81$exports, "expectArraysClose", () => $4b634705d248be81$export$33c766a1062be5b2);
$parcel$export($4b634705d248be81$exports, "testEpsilon", () => $4b634705d248be81$export$e73bb4a504595b05);
$parcel$export($4b634705d248be81$exports, "expectPromiseToFail", () => $4b634705d248be81$export$f1ce55133f3520c4);
$parcel$export($4b634705d248be81$exports, "expectArraysEqual", () => $4b634705d248be81$export$347f1ed9dcafca0d);
$parcel$export($4b634705d248be81$exports, "expectNumbersClose", () => $4b634705d248be81$export$a09d1668dd6f88b6);
$parcel$export($4b634705d248be81$exports, "expectValuesInRange", () => $4b634705d248be81$export$1af4797b1eac800b);
$parcel$export($4b634705d248be81$exports, "expectArrayBuffersEqual", () => $4b634705d248be81$export$28801b43871bdbc0);
$parcel$export($4b634705d248be81$exports, "encodeStrings", () => $4b634705d248be81$export$a3027a992fa03b9e);
$parcel$export($4b634705d248be81$exports, "createVideoElement", () => $4b634705d248be81$export$f4f3d816544d7e44);
$parcel$export($4b634705d248be81$exports, "play", () => $4b634705d248be81$export$899fbdb5fa08b653);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $4b634705d248be81$var$TEST_EPSILON_FLOAT32 = 1e-3;
const $4b634705d248be81$export$a86b4427e7a62065 = 1e-1;
function $4b634705d248be81$export$33c766a1062be5b2(actual, expected, epsilon) {
    if (epsilon == null) epsilon = $4b634705d248be81$export$e73bb4a504595b05();
    return $4b634705d248be81$var$expectArraysPredicate(actual, expected, (a, b)=>$4b634705d248be81$var$areClose(a, b, epsilon));
}
function $4b634705d248be81$export$e73bb4a504595b05() {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).backend.floatPrecision() === 32 ? $4b634705d248be81$var$TEST_EPSILON_FLOAT32 : $4b634705d248be81$export$a86b4427e7a62065;
}
function $4b634705d248be81$var$expectArraysPredicate(actual, expected, predicate) {
    let checkClassType = true;
    if ((0, $e10678764dab7ea0$export$b119cc7e1840e59c)(actual) || (0, $e10678764dab7ea0$export$b119cc7e1840e59c)(expected)) checkClassType = false;
    if ((0, $e10678764dab7ea0$export$b119cc7e1840e59c)(actual) && (0, $e10678764dab7ea0$export$b119cc7e1840e59c)(expected)) checkClassType = true;
    if (checkClassType) {
        const aType = actual.constructor.name;
        const bType = expected.constructor.name;
        if (aType !== bType) throw new Error(`Arrays are of different type. Actual: ${aType}. ` + `Expected: ${bType}`);
    }
    if (Array.isArray(actual) && Array.isArray(expected)) {
        const actualShape = (0, $010a899b69412c72$export$467a8ad638b9ad20)(actual);
        const expectedShape = (0, $010a899b69412c72$export$467a8ad638b9ad20)(expected);
        if (!(0, $5f8d0ee7a8d35dfe$export$234180f8206db11b)(actualShape, expectedShape)) throw new Error(`Arrays have different shapes. ` + `Actual: [${actualShape}]. Expected: [${expectedShape}]`);
    }
    const actualFlat = (0, $e10678764dab7ea0$export$b119cc7e1840e59c)(actual) ? actual : (0, $e10678764dab7ea0$export$bffa455ba8c619a6)(actual);
    const expectedFlat = (0, $e10678764dab7ea0$export$b119cc7e1840e59c)(expected) ? expected : (0, $e10678764dab7ea0$export$bffa455ba8c619a6)(expected);
    if (actualFlat.length !== expectedFlat.length) throw new Error(`Arrays have different lengths actual: ${actualFlat.length} vs ` + `expected: ${expectedFlat.length}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    for(let i = 0; i < expectedFlat.length; ++i){
        const a = actualFlat[i];
        const e = expectedFlat[i];
        if (!predicate(a, e)) throw new Error(`Arrays differ: actual[${i}] = ${a}, expected[${i}] = ${e}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    }
    if (typeof expect !== 'undefined') expect().nothing();
}
function $4b634705d248be81$export$f1ce55133f3520c4(fn, done) {
    fn().then(()=>done.fail(), ()=>done());
    if (typeof expect !== 'undefined') expect().nothing();
}
function $4b634705d248be81$export$347f1ed9dcafca0d(actual, expected) {
    const exp = typeof expected === 'string' || typeof expected === 'number' || typeof expected === 'boolean' ? [
        expected
    ] : expected;
    if ((0, $5f8d0ee7a8d35dfe$export$844ec244b1367d54)(actual) || (0, $5f8d0ee7a8d35dfe$export$844ec244b1367d54)(actual[0]) || (0, $5f8d0ee7a8d35dfe$export$844ec244b1367d54)(expected) || (0, $5f8d0ee7a8d35dfe$export$844ec244b1367d54)(expected[0])) // tslint:disable-next-line: triple-equals
    return $4b634705d248be81$var$expectArraysPredicate(actual, exp, (a, b)=>a == b);
    return $4b634705d248be81$var$expectArraysPredicate(actual, expected, (a, b)=>$4b634705d248be81$var$areClose(a, b, 0));
}
function $4b634705d248be81$export$a09d1668dd6f88b6(a, e, epsilon) {
    if (epsilon == null) epsilon = $4b634705d248be81$export$e73bb4a504595b05();
    if (!$4b634705d248be81$var$areClose(a, e, epsilon)) throw new Error(`Numbers differ: actual === ${a}, expected === ${e}`);
    if (typeof expect !== 'undefined') expect().nothing();
}
function $4b634705d248be81$var$areClose(a, e, epsilon) {
    if (!isFinite(a) && !isFinite(e)) return true;
    if (isNaN(a) || isNaN(e) || Math.abs(a - e) > epsilon) return false;
    return true;
}
function $4b634705d248be81$export$1af4797b1eac800b(actual, low, high) {
    for(let i = 0; i < actual.length; i++){
        if (actual[i] < low || actual[i] > high) throw new Error(`Value out of range:${actual[i]} low: ${low}, high: ${high}`);
    }
}
function $4b634705d248be81$export$28801b43871bdbc0(actual, expected) {
    // Safari does not like comparing ArrayBuffers directly. Wrapping in
    // a Float32Array solves this issue.
    const actualArray = new Float32Array(actual);
    const expectedArray = new Float32Array(expected);
    if (actualArray.length !== expectedArray.length) throw new Error('Expected ArrayBuffer to be of length ' + `${expectedArray.length}, but it was ${actualArray.length}`);
    for(let i = 0; i < expectedArray.length; i++){
        if (actualArray[i] !== expectedArray[i]) throw new Error(`Expected ArrayBuffer value at ${i} to be ` + `${expectedArray[i]} but got ${actualArray[i]} instead`);
    }
}
function $4b634705d248be81$export$a3027a992fa03b9e(a) {
    for(let i = 0; i < a.length; i++){
        const val = a[i];
        if (Array.isArray(val)) $4b634705d248be81$export$a3027a992fa03b9e(val);
        else a[i] = (0, $e10678764dab7ea0$export$8146d2e653b87d6a)(val);
    }
    return a;
}
function $4b634705d248be81$export$f4f3d816544d7e44(source) {
    const video = document.createElement('video');
    if ('playsInline' in video) // tslint:disable-next-line:no-any
    video.playsInline = true;
    video.muted = true;
    video.loop = true;
    video.style.position = 'fixed';
    video.style.left = '0px';
    video.style.top = '0px';
    video.preload = 'auto';
    video.appendChild(source);
    return new Promise((resolve)=>{
        video.addEventListener('loadeddata', (_)=>resolve(video));
        video.load();
    });
}
async function $4b634705d248be81$export$899fbdb5fa08b653(video) {
    await video.play();
    if ('requestVideoFrameCallback' in video) await new Promise((resolve)=>{
        // tslint:disable-next-line:no-any
        video.requestVideoFrameCallback(resolve);
    });
}



/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $f3f7c17932263fce$export$83d89fbfd8236492 = '4.22.0';








/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






class $898835df87cf1c26$export$1babc3d7b10c0cf6 {
    /**
     * Constructs a `tf.SGDOptimizer` that uses stochastic gradient descent.
     *
     * ```js
     * // Fit a quadratic function by learning the coefficients a, b, c.
     * const xs = tf.tensor1d([0, 1, 2, 3]);
     * const ys = tf.tensor1d([1.1, 5.9, 16.8, 33.9]);
     *
     * const a = tf.scalar(Math.random()).variable();
     * const b = tf.scalar(Math.random()).variable();
     * const c = tf.scalar(Math.random()).variable();
     *
     * // y = a * x^2 + b * x + c.
     * const f = x => a.mul(x.square()).add(b.mul(x)).add(c);
     * const loss = (pred, label) => pred.sub(label).square().mean();
     *
     * const learningRate = 0.01;
     * const optimizer = tf.train.sgd(learningRate);
     *
     * // Train the model.
     * for (let i = 0; i < 10; i++) {
     *   optimizer.minimize(() => loss(f(xs), ys));
     * }
     *
     * // Make predictions.
     * console.log(
     *     `a: ${a.dataSync()}, b: ${b.dataSync()}, c: ${c.dataSync()}`);
     * const preds = f(xs).dataSync();
     * preds.forEach((pred, i) => {
     *   console.log(`x: ${i}, pred: ${pred}`);
     * });
     * ```
     *
     * @param learningRate The learning rate to use for the SGD algorithm.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static sgd(learningRate) {
        return new (0, $cffcb030baa5b575$export$97318dd520e1bd4f)(learningRate);
    }
    /**
     * Constructs a `tf.MomentumOptimizer` that uses momentum gradient
     * descent.
     *
     * See
     * [http://proceedings.mlr.press/v28/sutskever13.pdf](
     * http://proceedings.mlr.press/v28/sutskever13.pdf)
     *
     * @param learningRate The learning rate to use for the Momentum gradient
     * descent algorithm.
     * @param momentum The momentum to use for the momentum gradient descent
     * algorithm.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static momentum(learningRate, momentum, useNesterov = false) {
        return new (0, $598fe5979c627cee$export$1db7ecf1f8312c6)(learningRate, momentum, useNesterov);
    }
    /**
     * Constructs a `tf.RMSPropOptimizer` that uses RMSProp gradient
     * descent. This implementation uses plain momentum and is not centered
     * version of RMSProp.
     *
     * See
     * [http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf](
     * http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf)
     *
     * @param learningRate The learning rate to use for the RMSProp gradient
     * descent algorithm.
     * @param decay The discounting factor for the history/coming gradient.
     * @param momentum The momentum to use for the RMSProp gradient descent
     * algorithm.
     * @param epsilon Small value to avoid zero denominator.
     * @param centered If true, gradients are normalized by the estimated
     * variance of the gradient.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static rmsprop(learningRate, decay = .9, momentum = 0.0, epsilon = null, centered = false) {
        return new (0, $5677a40ccf9c31ca$export$6e668138ce08e3bf)(learningRate, decay, momentum, epsilon, centered);
    }
    /**
     * Constructs a `tf.AdamOptimizer` that uses the Adam algorithm.
     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
     *
     * @param learningRate The learning rate to use for the Adam gradient
     * descent algorithm.
     * @param beta1 The exponential decay rate for the 1st moment estimates.
     * @param beta2 The exponential decay rate for the 2nd moment estimates.
     * @param epsilon A small constant for numerical stability.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adam(learningRate = 0.001, beta1 = 0.9, beta2 = 0.999, epsilon = null) {
        return new (0, $8e5923bf3349c4f0$export$de1938eb5fee8ee2)(learningRate, beta1, beta2, epsilon);
    }
    /**
     * Constructs a `tf.AdadeltaOptimizer` that uses the Adadelta algorithm.
     * See [https://arxiv.org/abs/1212.5701](https://arxiv.org/abs/1212.5701)
     *
     * @param learningRate The learning rate to use for the Adadelta gradient
     * descent algorithm.
     * @param rho The learning rate decay over each update.
     * @param epsilon A constant epsilon used to better condition the grad
     * update.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adadelta(learningRate = .001, rho = .95, epsilon = null) {
        return new (0, $081c1e1a002596a7$export$d80a766c536c9aaf)(learningRate, rho, epsilon);
    }
    /**
     * Constructs a `tf.AdamaxOptimizer` that uses the Adamax algorithm.
     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
     *
     * @param learningRate The learning rate to use for the Adamax gradient
     * descent algorithm.
     * @param beta1 The exponential decay rate for the 1st moment estimates.
     * @param beta2 The exponential decay rate for the 2nd moment estimates.
     * @param epsilon A small constant for numerical stability.
     * @param decay The learning rate decay over each update.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adamax(learningRate = 0.002, beta1 = 0.9, beta2 = 0.999, epsilon = null, decay = 0.0) {
        return new (0, $6e2717eed7ef3d6f$export$69957d0bff775eb6)(learningRate, beta1, beta2, epsilon, decay);
    }
    /**
     * Constructs a `tf.AdagradOptimizer` that uses the Adagrad algorithm.
     * See
     * [http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf](
     * http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf)
     * or
     * [http://ruder.io/optimizing-gradient-descent/index.html#adagrad](
     * http://ruder.io/optimizing-gradient-descent/index.html#adagrad)
     *
     * @param learningRate The learning rate to use for the Adagrad gradient
     * descent algorithm.
     * @param initialAccumulatorValue Starting value for the accumulators, must be
     * positive.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adagrad(learningRate, initialAccumulatorValue = 0.1) {
        return new (0, $52dc4bd6634a3583$export$fa35e48f6f1caa57)(learningRate, initialAccumulatorValue);
    }
}






var $7912647d6e7a4ee9$exports = {};

$parcel$export($7912647d6e7a4ee9$exports, "spectral", () => $7912647d6e7a4ee9$export$e0ccf6166915bd59);
$parcel$export($7912647d6e7a4ee9$exports, "signal", () => $7912647d6e7a4ee9$export$e2ef10f86a8d60e8);
$parcel$export($7912647d6e7a4ee9$exports, "image", () => $7912647d6e7a4ee9$export$5c452ff88e35e47d);
$parcel$export($7912647d6e7a4ee9$exports, "linalg", () => $7912647d6e7a4ee9$export$dbc5be37a4415193);
$parcel$export($7912647d6e7a4ee9$exports, "losses", () => $7912647d6e7a4ee9$export$24b113a95118cbdc);
$parcel$export($7912647d6e7a4ee9$exports, "sparse", () => $7912647d6e7a4ee9$export$b6b7e189aa5d134c);
$parcel$export($7912647d6e7a4ee9$exports, "string", () => $7912647d6e7a4ee9$export$22b082955e083ec3);
$parcel$export($7912647d6e7a4ee9$exports, "abs", () => $551d87f9cd40f29c$export$2335f513bbd82c6d);
$parcel$export($7912647d6e7a4ee9$exports, "acos", () => $f7d85568d01690da$export$fd6306be3fde5b04);
$parcel$export($7912647d6e7a4ee9$exports, "acosh", () => $8be0326fb8f6cca9$export$b26caf0f29211d08);
$parcel$export($7912647d6e7a4ee9$exports, "add", () => $c90bd95bc0e58efa$export$e16d8520af44a096);
$parcel$export($7912647d6e7a4ee9$exports, "addN", () => $053c348cc86e4948$export$37b75d0026f96b8d);
$parcel$export($7912647d6e7a4ee9$exports, "all", () => $821a8a0c94e26af7$export$84bf76cd7afc7469);
$parcel$export($7912647d6e7a4ee9$exports, "any", () => $256104da10806f8b$export$4154a199d7d90455);
$parcel$export($7912647d6e7a4ee9$exports, "argMax", () => $dfa64f3fd949567e$export$7980a683c1b852b4);
$parcel$export($7912647d6e7a4ee9$exports, "argMin", () => $cf4c1fc826cdf2d0$export$ec99a91cddfb29a2);
$parcel$export($7912647d6e7a4ee9$exports, "asin", () => $68bd33264cc50f31$export$41726bdb1fc63f);
$parcel$export($7912647d6e7a4ee9$exports, "asinh", () => $6abc48723e475246$export$839d8a01b6af4fc0);
$parcel$export($7912647d6e7a4ee9$exports, "atan", () => $09c3f64090287437$export$628dc4eed22b0fbd);
$parcel$export($7912647d6e7a4ee9$exports, "atan2", () => $609ffdbffef81474$export$b8b770ee6a0d9760);
$parcel$export($7912647d6e7a4ee9$exports, "atanh", () => $401c33b19c5b0094$export$21ea955025ceb08b);
$parcel$export($7912647d6e7a4ee9$exports, "avgPool", () => $de218d76756da0e0$export$d5c65a2abd3d97dc);
$parcel$export($7912647d6e7a4ee9$exports, "avgPool3d", () => $ee986deb13dc5b5f$export$ee1b0efb53eb29c3);
$parcel$export($7912647d6e7a4ee9$exports, "basicLSTMCell", () => $ab33a6501fc905fb$export$5f13ab10a3272278);
$parcel$export($7912647d6e7a4ee9$exports, "batchToSpaceND", () => $2337f2e1e82e1c80$export$ea37d960c1808536);
$parcel$export($7912647d6e7a4ee9$exports, "batchNorm", () => $44e73c16120369ac$export$8ea8088e6d0cdd02);
$parcel$export($7912647d6e7a4ee9$exports, "batchNorm2d", () => $f1c219fe7a1e385d$export$4104d1fc5afa918a);
$parcel$export($7912647d6e7a4ee9$exports, "batchNorm3d", () => $2bc34dd5a70650fd$export$76211212fb57f1fa);
$parcel$export($7912647d6e7a4ee9$exports, "batchNorm4d", () => $23c80da7bb92eb50$export$4573a348ef14e569);
$parcel$export($7912647d6e7a4ee9$exports, "bincount", () => $af732e8d9c378509$export$7e474bab088ed182);
$parcel$export($7912647d6e7a4ee9$exports, "bitwiseAnd", () => $9ba11836a7a0e3b8$export$84529b0ad3b42cd1);
$parcel$export($7912647d6e7a4ee9$exports, "broadcastArgs", () => $e9c057b2b5ab831a$export$d226d344aedce941);
$parcel$export($7912647d6e7a4ee9$exports, "broadcastTo", () => $7737f62f876bfd57$export$ec9086aff2624eab);
$parcel$export($7912647d6e7a4ee9$exports, "buffer", () => $d99273e33e31a4d2$export$ab1029bcae9ddb4a);
$parcel$export($7912647d6e7a4ee9$exports, "cast", () => $d61a75572b5954a3$export$f2db7d5238e1d23f);
$parcel$export($7912647d6e7a4ee9$exports, "ceil", () => $e4b6dd76ad5b047e$export$803ce6b71a0a94b2);
$parcel$export($7912647d6e7a4ee9$exports, "clipByValue", () => $9557879f1a67b9dc$export$fa97baf70ad024c0);
$parcel$export($7912647d6e7a4ee9$exports, "clone", () => $44a9d8b42e3e34af$export$9cd59f9826255e47);
$parcel$export($7912647d6e7a4ee9$exports, "complex", () => $175eb29e145dcf53$export$83a0e34f1302825b);
$parcel$export($7912647d6e7a4ee9$exports, "concat", () => $dc14b6735dbc478f$export$ee1b3e54f0441b22);
$parcel$export($7912647d6e7a4ee9$exports, "concat1d", () => $3917d674c96d0dbb$export$1e0bfb2ad280a475);
$parcel$export($7912647d6e7a4ee9$exports, "concat2d", () => $5b4cc8a7f2cde29e$export$ba044983349051fd);
$parcel$export($7912647d6e7a4ee9$exports, "concat3d", () => $f8403086914455d5$export$23e0f187dd67babf);
$parcel$export($7912647d6e7a4ee9$exports, "concat4d", () => $70cd662e381f1d83$export$731e01cced6c0a23);
$parcel$export($7912647d6e7a4ee9$exports, "conv1d", () => $a54a489200625adb$export$d8aa844fa36b350e);
$parcel$export($7912647d6e7a4ee9$exports, "conv2d", () => $43815144b11940c7$export$188f9215482e3db8);
$parcel$export($7912647d6e7a4ee9$exports, "conv2dTranspose", () => $3f61560f269899e2$export$d5e924cbc07fb966);
$parcel$export($7912647d6e7a4ee9$exports, "conv3d", () => $ec8b6241dd6bfd55$export$c476b02bcf7b2def);
$parcel$export($7912647d6e7a4ee9$exports, "conv3dTranspose", () => $5d0b12361a33af6c$export$5eac62031b3f449f);
$parcel$export($7912647d6e7a4ee9$exports, "cos", () => $2a105ca58e08bbc3$export$50d414a77b60d802);
$parcel$export($7912647d6e7a4ee9$exports, "cosh", () => $8a7f403fda14de62$export$2e2fd1ad24e4d350);
$parcel$export($7912647d6e7a4ee9$exports, "cumprod", () => $835f27a7a6e6bb41$export$dc7513e907e94b8d);
$parcel$export($7912647d6e7a4ee9$exports, "cumsum", () => $558f12105d46bb41$export$71990b1e1c4912fe);
$parcel$export($7912647d6e7a4ee9$exports, "denseBincount", () => $6158ac691c62a7b2$export$436934e6cf1946f1);
$parcel$export($7912647d6e7a4ee9$exports, "depthToSpace", () => $fd0a6e62c5011c86$export$3b50daec0f185f12);
$parcel$export($7912647d6e7a4ee9$exports, "depthwiseConv2d", () => $0d28c12ba7a09138$export$48a8ad9494a8fad8);
$parcel$export($7912647d6e7a4ee9$exports, "diag", () => $396e859bb9bd07d1$export$c042e7c2f59bc046);
$parcel$export($7912647d6e7a4ee9$exports, "dilation2d", () => $f75f08fee6d6d2ca$export$d9b8f675671875b9);
$parcel$export($7912647d6e7a4ee9$exports, "div", () => $15928a4fee5ff81f$export$159d9494db57879b);
$parcel$export($7912647d6e7a4ee9$exports, "divNoNan", () => $27c0bba8a735dbc2$export$9c5df3eb9e56f19e);
$parcel$export($7912647d6e7a4ee9$exports, "dot", () => $475e1bc880e1fa62$export$94132a0e348806d4);
$parcel$export($7912647d6e7a4ee9$exports, "einsum", () => $0fe351921eebd33a$export$27265e7daac5c403);
$parcel$export($7912647d6e7a4ee9$exports, "elu", () => $5c36ca87265596d3$export$796b583dd79d8524);
$parcel$export($7912647d6e7a4ee9$exports, "ensureShape", () => $60ee51dd648d18e0$export$6699c34d603c5978);
$parcel$export($7912647d6e7a4ee9$exports, "equal", () => $5b85025852d3ccbe$export$411ce8e5a71e3069);
$parcel$export($7912647d6e7a4ee9$exports, "erf", () => $27da37b0d1c5f650$export$d3896f355fc09423);
$parcel$export($7912647d6e7a4ee9$exports, "euclideanNorm", () => $383d98731541f461$export$38d83b337e7c2edd);
$parcel$export($7912647d6e7a4ee9$exports, "exp", () => $20ea4fdf69fd4a26$export$b310ec824aaee37f);
$parcel$export($7912647d6e7a4ee9$exports, "expandDims", () => $db5bfab98435c6cf$export$d660d8ed21f46635);
$parcel$export($7912647d6e7a4ee9$exports, "expm1", () => $966280c1f426de32$export$b6c0a80d46d3391d);
$parcel$export($7912647d6e7a4ee9$exports, "eye", () => $6bf880f08dec68a4$export$4e18cf730a59887e);
$parcel$export($7912647d6e7a4ee9$exports, "fill", () => $c5b09a3759406f8a$export$9563e054e6f787fb);
$parcel$export($7912647d6e7a4ee9$exports, "floor", () => $3a38c7b29dbfd7e8$export$a3fe094919f356fd);
$parcel$export($7912647d6e7a4ee9$exports, "floorDiv", () => $47c5bf11930fb3f9$export$112397bc52715a8);
$parcel$export($7912647d6e7a4ee9$exports, "gather", () => $27ff7ccdc5033e17$export$9e05546f00427e8);
$parcel$export($7912647d6e7a4ee9$exports, "greater", () => $8a3e558d5bb76a4c$export$9dca161faaf6308b);
$parcel$export($7912647d6e7a4ee9$exports, "greaterEqual", () => $f4c954f893cb9ce6$export$c2fd4164cadc1fa2);
$parcel$export($7912647d6e7a4ee9$exports, "imag", () => $0e1dcb58360d86cd$export$d78fab5778ab392b);
$parcel$export($7912647d6e7a4ee9$exports, "isFinite", () => $a521efe7e5aac3f8$export$65f0b13f2f82375a);
$parcel$export($7912647d6e7a4ee9$exports, "isInf", () => $77bae48f55795afc$export$e5d3415c656f7096);
$parcel$export($7912647d6e7a4ee9$exports, "isNaN", () => $42028cbc7490170f$export$c9f5652083b8129d);
$parcel$export($7912647d6e7a4ee9$exports, "leakyRelu", () => $2e1cdcc1e07e834e$export$23a860e40a2c6b61);
$parcel$export($7912647d6e7a4ee9$exports, "less", () => $e7c220a817a7d6b0$export$bb1a638da8ad190f);
$parcel$export($7912647d6e7a4ee9$exports, "lessEqual", () => $5a854c2455432f6a$export$c24ad19a692bb92);
$parcel$export($7912647d6e7a4ee9$exports, "linspace", () => $6d3d63bd566c765a$export$71255ea3f595147c);
$parcel$export($7912647d6e7a4ee9$exports, "localResponseNormalization", () => $ea92d98dece5e886$export$b6127073705f6321);
$parcel$export($7912647d6e7a4ee9$exports, "log", () => $99bf7e02d49647cf$export$bef1f36f5486a6a3);
$parcel$export($7912647d6e7a4ee9$exports, "log1p", () => $442dfe97b70d73dc$export$144dcf16adfb9698);
$parcel$export($7912647d6e7a4ee9$exports, "logSigmoid", () => $54e8d955c4d71e65$export$9e0b8feed033df47);
$parcel$export($7912647d6e7a4ee9$exports, "logSoftmax", () => $20a7e47c51889579$export$676379a046a2e437);
$parcel$export($7912647d6e7a4ee9$exports, "logSumExp", () => $6b6676f787cc0273$export$e20aca1e89397787);
$parcel$export($7912647d6e7a4ee9$exports, "logicalAnd", () => $ebf6cebe68ef2a79$export$db5dd0ef9d505f);
$parcel$export($7912647d6e7a4ee9$exports, "logicalNot", () => $5aea02d79d421e58$export$c836ff7b605b1617);
$parcel$export($7912647d6e7a4ee9$exports, "logicalOr", () => $d63a04143271ccd2$export$e2a73975983cadd8);
$parcel$export($7912647d6e7a4ee9$exports, "logicalXor", () => $d9ff197708e7fc0d$export$20f90b62b30dbaef);
$parcel$export($7912647d6e7a4ee9$exports, "lowerBound", () => $e431e62c480471c9$export$450bb71ab40039dc);
$parcel$export($7912647d6e7a4ee9$exports, "matMul", () => $7f1f3e54d78420da$export$6706882a873e9a8f);
$parcel$export($7912647d6e7a4ee9$exports, "max", () => $00fa62f8df8ea40d$export$8960430cfd85939f);
$parcel$export($7912647d6e7a4ee9$exports, "maxPool", () => $bfa923df51c4e9fb$export$e4aadcf115842782);
$parcel$export($7912647d6e7a4ee9$exports, "maxPool3d", () => $c213f1d37ed322ef$export$822a6e53be1125f9);
$parcel$export($7912647d6e7a4ee9$exports, "maxPoolWithArgmax", () => $7178df567939d474$export$3d8b1b819d23351e);
$parcel$export($7912647d6e7a4ee9$exports, "maximum", () => $bb7061cc1559a0cf$export$b25e0be55f42c9a);
$parcel$export($7912647d6e7a4ee9$exports, "mean", () => $475473fd3a900b08$export$1ce691f85baaa52);
$parcel$export($7912647d6e7a4ee9$exports, "meshgrid", () => $a44d90bdd666156a$export$2fab8e71e5fefc1a);
$parcel$export($7912647d6e7a4ee9$exports, "min", () => $b5449d8a4698bd43$export$96ec731ed4dcb222);
$parcel$export($7912647d6e7a4ee9$exports, "minimum", () => $509eb1d608c78c8e$export$916782c1f0ddb132);
$parcel$export($7912647d6e7a4ee9$exports, "mirrorPad", () => $a6b3cd7f35f32ec3$export$c0b11600e90b86ae);
$parcel$export($7912647d6e7a4ee9$exports, "mod", () => $e74659ea6de4ec41$export$842a2cf37af977e1);
$parcel$export($7912647d6e7a4ee9$exports, "moments", () => $e804b403d2801180$export$19ef085469537740);
$parcel$export($7912647d6e7a4ee9$exports, "mul", () => $e8cd0739d0f73f4b$export$6e3a27864ab166fe);
$parcel$export($7912647d6e7a4ee9$exports, "multiRNNCell", () => $917954a7b3cdf6bb$export$cc05b5217b9b924f);
$parcel$export($7912647d6e7a4ee9$exports, "multinomial", () => $80a721450e7ef1a8$export$f4d580f3101a1c7e);
$parcel$export($7912647d6e7a4ee9$exports, "neg", () => $0ca018ac52410371$export$d9493ff0dfa0fdd5);
$parcel$export($7912647d6e7a4ee9$exports, "notEqual", () => $683debd13acf606f$export$53a6892c50694894);
$parcel$export($7912647d6e7a4ee9$exports, "oneHot", () => $d263ffd91bb8ab3a$export$341b5490a776d041);
$parcel$export($7912647d6e7a4ee9$exports, "ones", () => $b838e56973f13fe0$export$21041dee6b8001b0);
$parcel$export($7912647d6e7a4ee9$exports, "onesLike", () => $4741961218c2e183$export$fb6afd6214fee9e9);
$parcel$export($7912647d6e7a4ee9$exports, "outerProduct", () => $613695c2f6bda44d$export$8481b38c75c91cc7);
$parcel$export($7912647d6e7a4ee9$exports, "pad", () => $b90bbaefd48f2353$export$5d04458e2a6c373e);
$parcel$export($7912647d6e7a4ee9$exports, "pad1d", () => $9815392d4669cf13$export$be67ff622a7fd5);
$parcel$export($7912647d6e7a4ee9$exports, "pad2d", () => $f6d43711f5079033$export$38e9137d79715c2d);
$parcel$export($7912647d6e7a4ee9$exports, "pad3d", () => $f49389cdab278f98$export$880821ebecb16ceb);
$parcel$export($7912647d6e7a4ee9$exports, "pad4d", () => $bdbccbe431e53b87$export$4aef6fb43f1346f4);
$parcel$export($7912647d6e7a4ee9$exports, "pool", () => $72715b6f4ed888f7$export$7a0e2789ec54f0db);
$parcel$export($7912647d6e7a4ee9$exports, "pow", () => $76ec324d3dfd83d3$export$9c297f60e22e3389);
$parcel$export($7912647d6e7a4ee9$exports, "prelu", () => $751df8e2647ea232$export$5882f235222e6729);
$parcel$export($7912647d6e7a4ee9$exports, "print", () => $8a5834107ae482be$export$c2d084dc44961371);
$parcel$export($7912647d6e7a4ee9$exports, "prod", () => $8b2dec4eec8fb3b3$export$5e143010dea16c85);
$parcel$export($7912647d6e7a4ee9$exports, "raggedGather", () => $2c04d370930bbd05$export$e7118f605df251dd);
$parcel$export($7912647d6e7a4ee9$exports, "raggedRange", () => $012ad56de118f1c5$export$a173be400c6762b5);
$parcel$export($7912647d6e7a4ee9$exports, "raggedTensorToTensor", () => $d005955acffcb7e3$export$621e390307cbbaa1);
$parcel$export($7912647d6e7a4ee9$exports, "rand", () => $8aa32f484b90fe36$export$bb0a9c36cf454ea0);
$parcel$export($7912647d6e7a4ee9$exports, "randomGamma", () => $0a41cda08b4fd1d5$export$63a8048b65295cb7);
$parcel$export($7912647d6e7a4ee9$exports, "randomNormal", () => $c68f21db59d988e8$export$a0ac5549a8bec918);
$parcel$export($7912647d6e7a4ee9$exports, "randomStandardNormal", () => $f3bddf0c4680dee4$export$5a8aa20f8ebaee69);
$parcel$export($7912647d6e7a4ee9$exports, "randomUniform", () => $dee4b5fc7aecfad3$export$bd6fd37822e292fa);
$parcel$export($7912647d6e7a4ee9$exports, "randomUniformInt", () => $a5930481412268a3$export$134fe7f07fd7b492);
$parcel$export($7912647d6e7a4ee9$exports, "range", () => $5d4db871afef7031$export$d02631cccf789723);
$parcel$export($7912647d6e7a4ee9$exports, "real", () => $8189f77a6a673bd0$export$9fc57fb453bdbd67);
$parcel$export($7912647d6e7a4ee9$exports, "reciprocal", () => $24e709942a18bc8e$export$163bc8c839a1ac04);
$parcel$export($7912647d6e7a4ee9$exports, "relu", () => $633a7fface57265e$export$16d1e4612cc0139f);
$parcel$export($7912647d6e7a4ee9$exports, "relu6", () => $b4b08408f5ab9172$export$4a62bcb95e9c44c4);
$parcel$export($7912647d6e7a4ee9$exports, "reshape", () => $33ee657bc32918d5$export$9eaad88cf88cee2b);
$parcel$export($7912647d6e7a4ee9$exports, "reverse", () => $47cd593c7f6553f1$export$66c1ae025e96b4bc);
$parcel$export($7912647d6e7a4ee9$exports, "reverse1d", () => $1ff9af9aa5e82ce6$export$ec29ded9cbde7103);
$parcel$export($7912647d6e7a4ee9$exports, "reverse2d", () => $64cac5866b1d4ce7$export$12170f5f8cb48014);
$parcel$export($7912647d6e7a4ee9$exports, "reverse3d", () => $8d8b45c71f7c374d$export$1ecb65b2ca41f0e);
$parcel$export($7912647d6e7a4ee9$exports, "reverse4d", () => $87e902ddeaa5429c$export$76a1df46e0e42da4);
$parcel$export($7912647d6e7a4ee9$exports, "round", () => $743db37ae6b6e648$export$2077e0241d6afd3c);
$parcel$export($7912647d6e7a4ee9$exports, "rsqrt", () => $3efe1f83a3e5837d$export$1cc01d192953037e);
$parcel$export($7912647d6e7a4ee9$exports, "scalar", () => $2937f01f2600aea0$export$7de3fcd3cdba2a46);
$parcel$export($7912647d6e7a4ee9$exports, "selu", () => $8142a96555db4d0b$export$a5f8240d9e99b438);
$parcel$export($7912647d6e7a4ee9$exports, "separableConv2d", () => $62f5def725189d23$export$2586c92899c2d0fb);
$parcel$export($7912647d6e7a4ee9$exports, "setdiff1dAsync", () => $976f4ad32ff317f5$export$cd50e5d116ec1774);
$parcel$export($7912647d6e7a4ee9$exports, "sigmoid", () => $e3381678584872cc$export$3b295495ca3cad7c);
$parcel$export($7912647d6e7a4ee9$exports, "sign", () => $29a1d3c837b8ed64$export$c5552dfdbc7cec71);
$parcel$export($7912647d6e7a4ee9$exports, "sin", () => $34df037cb95cd0bc$export$5de3937cb4b592ed);
$parcel$export($7912647d6e7a4ee9$exports, "sinh", () => $b5a171d6413337da$export$545004b505d7c555);
$parcel$export($7912647d6e7a4ee9$exports, "slice", () => $535db06fef6716ec$export$58adb3bec8346d0f);
$parcel$export($7912647d6e7a4ee9$exports, "slice1d", () => $401c05c68cc4ac4b$export$95433662b275eb82);
$parcel$export($7912647d6e7a4ee9$exports, "slice2d", () => $c31e278a3cb12d98$export$e5c6a6611cb43a9d);
$parcel$export($7912647d6e7a4ee9$exports, "slice3d", () => $17befd7bb6856a0b$export$dec56af20749d733);
$parcel$export($7912647d6e7a4ee9$exports, "slice4d", () => $607f40e3463324cc$export$9833e35e879da26c);
$parcel$export($7912647d6e7a4ee9$exports, "softmax", () => $9bdcd3abf3c06921$export$e008137e76238601);
$parcel$export($7912647d6e7a4ee9$exports, "softplus", () => $3926ca7a31ecf655$export$76aa560a8c2b0055);
$parcel$export($7912647d6e7a4ee9$exports, "spaceToBatchND", () => $acc81226aaa46db7$export$effb9d7cae92012f);
$parcel$export($7912647d6e7a4ee9$exports, "fft", () => $1486b5b57f2c7550$export$a535ef183b6128fa);
$parcel$export($7912647d6e7a4ee9$exports, "ifft", () => $26eacb6258cb10d5$export$776649b0bf8ce1fd);
$parcel$export($7912647d6e7a4ee9$exports, "irfft", () => $cb2ae7445ffa5769$export$f47f4e5bcd3d6a66);
$parcel$export($7912647d6e7a4ee9$exports, "rfft", () => $8db28b200f22d7be$export$72aff1768917e9e5);
$parcel$export($7912647d6e7a4ee9$exports, "split", () => $6bb70aae893ea3fa$export$65980d18b75784e2);
$parcel$export($7912647d6e7a4ee9$exports, "sqrt", () => $d8742a69331de610$export$eba8049fb5020b81);
$parcel$export($7912647d6e7a4ee9$exports, "square", () => $03801900ae8a72ab$export$dd4f28cef696bc7d);
$parcel$export($7912647d6e7a4ee9$exports, "squaredDifference", () => $7adf3ff43b38d937$export$b178697fb6d0b37f);
$parcel$export($7912647d6e7a4ee9$exports, "squeeze", () => $f41010297af56801$export$889c931173b77c2f);
$parcel$export($7912647d6e7a4ee9$exports, "stack", () => $6437527469582bc5$export$a57ab32f40f83ea9);
$parcel$export($7912647d6e7a4ee9$exports, "step", () => $ff8982de7da7934b$export$35d34bc0ed591a92);
$parcel$export($7912647d6e7a4ee9$exports, "stridedSlice", () => $9c771bc0944a917c$export$4ae57224f3b0605c);
$parcel$export($7912647d6e7a4ee9$exports, "sub", () => $555d660851b98db3$export$f93b5905241a7cca);
$parcel$export($7912647d6e7a4ee9$exports, "sum", () => $7215cb99724b7643$export$8a63f25cc62965f1);
$parcel$export($7912647d6e7a4ee9$exports, "tan", () => $f63c00f5c65721ae$export$fcdd3b0b3246a325);
$parcel$export($7912647d6e7a4ee9$exports, "tanh", () => $a88dd77d13a4ba8f$export$7128670e45beef9a);
$parcel$export($7912647d6e7a4ee9$exports, "tensor", () => $a82c6773538d9e64$export$65df3ad1ad888abb);
$parcel$export($7912647d6e7a4ee9$exports, "tensor1d", () => $f68b57eba454beb7$export$8133e3bf3cd8f464);
$parcel$export($7912647d6e7a4ee9$exports, "tensor2d", () => $bea433ea0b14d5fb$export$b5469a65e8732256);
$parcel$export($7912647d6e7a4ee9$exports, "tensor3d", () => $4da6fbe2266e5502$export$aa36a9de53c6d912);
$parcel$export($7912647d6e7a4ee9$exports, "tensor4d", () => $4d00bcbc9bb89eab$export$b43603ce4e7542a7);
$parcel$export($7912647d6e7a4ee9$exports, "tensor5d", () => $b252ca7efcfee5b9$export$ab0278981fc9e727);
$parcel$export($7912647d6e7a4ee9$exports, "tensor6d", () => $c197f4d49e2608e8$export$7b9f27dd2306a502);
$parcel$export($7912647d6e7a4ee9$exports, "tensorScatterUpdate", () => $332a8f98d69e0a66$export$d3ac02769385eb36);
$parcel$export($7912647d6e7a4ee9$exports, "tile", () => $461b04d030518b80$export$3c17558da18e4d75);
$parcel$export($7912647d6e7a4ee9$exports, "topk", () => $95d6c1822e5bc026$export$4e6b28a600f8b4df);
$parcel$export($7912647d6e7a4ee9$exports, "truncatedNormal", () => $9ef055855a9c1b37$export$8ad5625727f3fa1d);
$parcel$export($7912647d6e7a4ee9$exports, "unique", () => $7c1158843694185a$export$7a5d5c156e7dc406);
$parcel$export($7912647d6e7a4ee9$exports, "unsortedSegmentSum", () => $9b1e231b583c89e6$export$ba7c4d144d85a309);
$parcel$export($7912647d6e7a4ee9$exports, "unstack", () => $c1775cdc84f05f72$export$3c05285afa115eec);
$parcel$export($7912647d6e7a4ee9$exports, "upperBound", () => $d4c7a0e45e12e674$export$1e7f253df265a2ba);
$parcel$export($7912647d6e7a4ee9$exports, "variable", () => $a7bfc0fb62924a2a$export$3a9d57cefcd2c285);
$parcel$export($7912647d6e7a4ee9$exports, "where", () => $f5215ba964de19ce$export$9c59b80dda569a6e);
$parcel$export($7912647d6e7a4ee9$exports, "whereAsync", () => $3fb1846d1fd1e918$export$b95962138b7a377d);
$parcel$export($7912647d6e7a4ee9$exports, "zeros", () => $cc4388674ebc96d5$export$4445a00dafa2633b);
$parcel$export($7912647d6e7a4ee9$exports, "zerosLike", () => $64c118098861f580$export$cb1f824e7733584d);
$parcel$export($7912647d6e7a4ee9$exports, "op", () => $e25ad0fc1c7fe06f$export$f59964a629598e2);
$parcel$export($7912647d6e7a4ee9$exports, "OP_SCOPE_SUFFIX", () => $e25ad0fc1c7fe06f$export$93114f1494faf9bb);
$parcel$export($7912647d6e7a4ee9$exports, "fused", () => $e4d1a64069662ad4$exports);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Modularized ops.

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes acos of the input `tf.Tensor` element-wise: `acos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.acos().print();  // or tf.acos(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $f7d85568d01690da$var$acos_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'acos');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$3b952c9980dac550), inputs);
}
const $f7d85568d01690da$export$fd6306be3fde5b04 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    acos_: $f7d85568d01690da$var$acos_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the inverse hyperbolic cos of the input `tf.Tensor` element-wise:
 * `acosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([10, 1, 3, 5.7]);
 *
 * x.acosh().print();  // or tf.acosh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $8be0326fb8f6cca9$var$acosh_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'acosh');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$987da490b7c2e7dd), inputs);
}
const $8be0326fb8f6cca9$export$b26caf0f29211d08 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    acosh_: $8be0326fb8f6cca9$var$acosh_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Adds a list of `tf.Tensor`s element-wise, each with the same shape and dtype.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 *
 * tf.addN([a, b, c]).print();
 * ```
 * @param tensors A list of tensors with the same shape and dtype.
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $053c348cc86e4948$var$addN_(tensors) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(Array.isArray(tensors), ()=>'The argument passed to tf.addN() must be a list of tensors');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(tensors.length >= 1, ()=>`Must pass at least one tensor to tf.addN(), but got ` + `${tensors.length}`);
    const $tensors = tensors.map((t, i)=>(0, $010a899b69412c72$export$ede379c4c939d71a)(t, `tensors${i}`, 'addN'));
    const firstTensor = $tensors[0];
    $tensors.forEach((t)=>{
        if (t.dtype !== firstTensor.dtype) throw new Error('All tensors passed to tf.addN() must have the same dtype');
    });
    $tensors.forEach((t)=>{
        if (!$5f8d0ee7a8d35dfe$export$234180f8206db11b(t.shape, firstTensor.shape)) throw new Error('All tensors passed to tf.addN() must have the same shape');
    });
    const inputs = $tensors;
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$eef235ad06d3226a), inputs);
}
const $053c348cc86e4948$export$37b75d0026f96b8d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    addN_: $053c348cc86e4948$var$addN_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the logical and of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.all().print();  // or tf.all(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.all(axis).print();  // or tf.all(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $821a8a0c94e26af7$var$all_(x, axis = null, keepDims = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'all', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$5dceb1ab650a1776), inputs, attrs);
}
const $821a8a0c94e26af7$export$84bf76cd7afc7469 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    all_: $821a8a0c94e26af7$var$all_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the logical or of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.any().print();  // or tf.any(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.any(axis).print();  // or tf.any(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $256104da10806f8b$var$any_(x, axis = null, keepDims = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'any', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$b24b633b1364b94b), inputs, attrs);
}
const $256104da10806f8b$export$4154a199d7d90455 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    any_: $256104da10806f8b$var$any_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the indices of the maximum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMax().print();  // or tf.argMax(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMax(axis).print();  // or tf.argMax(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $dfa64f3fd949567e$var$argMax_(x, axis = 0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'argMax');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$17612294a1503e1c), inputs, attrs);
}
const $dfa64f3fd949567e$export$7980a683c1b852b4 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    argMax_: $dfa64f3fd949567e$var$argMax_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the indices of the minimum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMin().print();  // or tf.argMin(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMin(axis).print();  // or tf.argMin(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $cf4c1fc826cdf2d0$var$argMin_(x, axis = 0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'argMin');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$baabd09270cbbd94), inputs, attrs);
}
const $cf4c1fc826cdf2d0$export$ec99a91cddfb29a2 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    argMin_: $cf4c1fc826cdf2d0$var$argMin_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes asin of the input `tf.Tensor` element-wise: `asin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asin().print();  // or tf.asin(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $68bd33264cc50f31$var$asin_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'asin');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$664c8ca7e7e5c126), inputs);
}
const $68bd33264cc50f31$export$41726bdb1fc63f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    asin_: $68bd33264cc50f31$var$asin_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes inverse hyperbolic sin of the input `tf.Tensor` element-wise:
 * `asinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asinh().print();  // or tf.asinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6abc48723e475246$var$asinh_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'asinh');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$847c88940cb7dcb5), inputs);
}
const $6abc48723e475246$export$839d8a01b6af4fc0 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    asinh_: $6abc48723e475246$var$asinh_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes atan of the input `tf.Tensor` element-wise: `atan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.atan().print();  // or tf.atan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $09c3f64090287437$var$atan_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'atan');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$bac667d46ac043ae), inputs);
}
const $09c3f64090287437$export$628dc4eed22b0fbd = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    atan_: $09c3f64090287437$var$atan_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes arctangent of `tf.Tensor`s a / b element-wise: `atan2(a, b)`.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1.0, 1.0, -1.0, .7]);
 * const b = tf.tensor1d([2.0, 13.0, 3.5, .21]);
 *
 * tf.atan2(a, b).print()
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $609ffdbffef81474$var$atan2_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'atan2');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'atan2');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$3bf4c619ce589f4b), inputs);
}
const $609ffdbffef81474$export$b8b770ee6a0d9760 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    atan2_: $609ffdbffef81474$var$atan2_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes inverse hyperbolic tan of the input `tf.Tensor` element-wise:
 * `atanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.atanh().print();  // or tf.atanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $401c33b19c5b0094$var$atanh_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'atanh');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$98981a86fa2b1366), inputs);
}
const $401c33b19c5b0094$export$21ea955025ceb08b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    atanh_: $401c33b19c5b0094$var$atanh_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




var $b3e4d1c19b78487c$exports = {};

$parcel$export($b3e4d1c19b78487c$exports, "computeDilation2DInfo", () => $b3e4d1c19b78487c$export$24e8a5cb688b9852);
$parcel$export($b3e4d1c19b78487c$exports, "convertConv2DDataFormat", () => $b3e4d1c19b78487c$export$1641c6bb3eb9a5b4);
$parcel$export($b3e4d1c19b78487c$exports, "computeConv2DInfo", () => $b3e4d1c19b78487c$export$fdd37387e0a3c672);
$parcel$export($b3e4d1c19b78487c$exports, "computePool2DInfo", () => $b3e4d1c19b78487c$export$67e321f77840205c);
$parcel$export($b3e4d1c19b78487c$exports, "computePool3DInfo", () => $b3e4d1c19b78487c$export$1382473b2833755b);
$parcel$export($b3e4d1c19b78487c$exports, "computeConv3DInfo", () => $b3e4d1c19b78487c$export$e4819ceef3994d7b);
$parcel$export($b3e4d1c19b78487c$exports, "computeDefaultPad", () => $b3e4d1c19b78487c$export$670354fdcb16da70);
$parcel$export($b3e4d1c19b78487c$exports, "tupleValuesAreOne", () => $b3e4d1c19b78487c$export$f16174446c2d5b2a);
$parcel$export($b3e4d1c19b78487c$exports, "eitherStridesOrDilationsAreOne", () => $b3e4d1c19b78487c$export$1e13dbff91e2f5ca);
$parcel$export($b3e4d1c19b78487c$exports, "stridesOrDilationsArePositive", () => $b3e4d1c19b78487c$export$6f24ba18d950c7e3);
$parcel$export($b3e4d1c19b78487c$exports, "checkPadOnDimRoundingMode", () => $b3e4d1c19b78487c$export$1b3400c26a44af8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $b3e4d1c19b78487c$export$24e8a5cb688b9852(inputShape, filterShape, strides, pad, dataFormat = 'NHWC', dilations) {
    // `computerConv2DInfo` require filterShape to be in the dimension of:
    // `[filterHeight, filterWidth, depth, outDepth]`, dilation2d doesn't have
    // outDepth, it should have the same depth as the input.
    // Input shape: [batch, height, width, inChannels]
    const inputChannels = inputShape[3];
    const $filterShape = [
        ...filterShape,
        inputChannels
    ];
    const $dataFormat = $b3e4d1c19b78487c$export$1641c6bb3eb9a5b4(dataFormat);
    return $b3e4d1c19b78487c$export$fdd37387e0a3c672(inputShape, $filterShape, strides, dilations, pad, null, null, $dataFormat);
}
function $b3e4d1c19b78487c$export$67e321f77840205c(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'channelsLast') {
    const [filterHeight, filterWidth] = $b3e4d1c19b78487c$var$parseTupleParam(filterSize);
    let filterShape;
    if (dataFormat === 'channelsLast') filterShape = [
        filterHeight,
        filterWidth,
        inShape[3],
        inShape[3]
    ];
    else if (dataFormat === 'channelsFirst') filterShape = [
        filterHeight,
        filterWidth,
        inShape[1],
        inShape[1]
    ];
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $b3e4d1c19b78487c$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, false, dataFormat);
}
function $b3e4d1c19b78487c$export$1382473b2833755b(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'NDHWC') {
    const [filterDepth, filterHeight, filterWidth] = $b3e4d1c19b78487c$var$parse3TupleParam(filterSize);
    let filterShape;
    let $dataFormat;
    if (dataFormat === 'NDHWC') {
        $dataFormat = 'channelsLast';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[4],
            inShape[4]
        ];
    } else if (dataFormat === 'NCDHW') {
        $dataFormat = 'channelsFirst';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[1],
            inShape[1]
        ];
    } else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $b3e4d1c19b78487c$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, false, $dataFormat, roundingMode);
}
function $b3e4d1c19b78487c$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, depthwise = false, dataFormat = 'channelsLast') {
    let [batchSize, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideHeight, strideWidth] = $b3e4d1c19b78487c$var$parseTupleParam(strides);
    const [dilationHeight, dilationWidth] = $b3e4d1c19b78487c$var$parseTupleParam(dilations);
    const effectiveFilterHeight = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outHeight: outHeight, outWidth: outWidth } = $b3e4d1c19b78487c$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, effectiveFilterHeight, effectiveFilterWidth, roundingMode, dataFormat);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $b3e4d1c19b78487c$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, depthwise = false, dataFormat = 'channelsLast', roundingMode) {
    let [batchSize, inDepth, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inDepth, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inDepth, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterDepth, filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideDepth, strideHeight, strideWidth] = $b3e4d1c19b78487c$var$parse3TupleParam(strides);
    const [dilationDepth, dilationHeight, dilationWidth] = $b3e4d1c19b78487c$var$parse3TupleParam(dilations);
    const effectiveFilterDepth = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterDepth, dilationDepth);
    const effectiveFilterHeight = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outDepth: outDepth, outHeight: outHeight, outWidth: outWidth } = $b3e4d1c19b78487c$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, effectiveFilterDepth, effectiveFilterHeight, effectiveFilterWidth, roundingMode);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outDepth,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outDepth,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inDepth: inDepth,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideDepth: strideDepth,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterDepth: filterDepth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterDepth: effectiveFilterDepth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationDepth: dilationDepth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $b3e4d1c19b78487c$var$computeOutputShape2D(inShape, fieldSize, stride, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $b3e4d1c19b78487c$export$670354fdcb16da70(inShape, fieldSize, stride);
    const inputRows = inShape[0];
    const inputCols = inShape[1];
    const outputRows = $b3e4d1c19b78487c$var$round((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    const outputCols = $b3e4d1c19b78487c$var$round((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    return [
        outputRows,
        outputCols
    ];
}
function $b3e4d1c19b78487c$var$computeOutputShape4D(inShape, filterShape, outChannels, strides, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $b3e4d1c19b78487c$export$670354fdcb16da70(inShape, filterShape[0], strides[0]);
    const outShape = [
        0,
        0,
        0,
        outChannels
    ];
    for(let index = 0; index < 3; index++)if (inShape[index] + 2 * zeroPad >= filterShape[index]) outShape[index] = $b3e4d1c19b78487c$var$round((inShape[index] - filterShape[index] + 2 * zeroPad) / strides[index] + 1, roundingMode);
    return outShape;
}
function $b3e4d1c19b78487c$export$670354fdcb16da70(inputShape, fieldSize, stride, dilation = 1) {
    const effectiveFieldSize = $b3e4d1c19b78487c$var$getEffectiveFilterSize(fieldSize, dilation);
    return Math.floor((inputShape[0] * (stride - 1) - stride + effectiveFieldSize) / 2);
}
function $b3e4d1c19b78487c$var$parseTupleParam(param) {
    if (typeof param === 'number') return [
        param,
        param,
        param
    ];
    if (param.length === 2) return [
        param[0],
        param[1],
        1
    ];
    return param;
}
function $b3e4d1c19b78487c$var$parse3TupleParam(param) {
    return typeof param === 'number' ? [
        param,
        param,
        param
    ] : param;
}
/* See https://www.tensorflow.org/api_docs/python/tf/nn/atrous_conv2d
 * Atrous convolution is equivalent to standard convolution with upsampled
 * filters with effective_filter_height =
 * filter_height + (filter_height - 1) * (dilation - 1)
 * and effective_filter_width =
 * filter_width + (filter_width - 1) * (dilation - 1),
 * produced by inserting dilation - 1 zeros along consecutive elements across
 * the filters' spatial dimensions.
 * When there is a dilation, this converts a filter dimension to the
 * effective filter dimension, so it can be used in a standard convolution.
 */ function $b3e4d1c19b78487c$var$getEffectiveFilterSize(filterSize, dilation) {
    if (dilation <= 1) return filterSize;
    return filterSize + (filterSize - 1) * (dilation - 1);
}
function $b3e4d1c19b78487c$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, filterHeight, filterWidth, roundingMode, dataFormat) {
    let padInfo;
    let outHeight;
    let outWidth;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            type: padType
        };
        const outShape = $b3e4d1c19b78487c$var$computeOutputShape2D([
            inHeight,
            inWidth
        ], filterHeight, strideHeight, pad, roundingMode);
        outHeight = outShape[0];
        outWidth = outShape[1];
    } else if (pad === 'same') {
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongHeight = Math.max(0, (outHeight - 1) * strideHeight + filterHeight - inHeight);
        const padAlongWidth = Math.max(0, (outWidth - 1) * strideWidth + filterWidth - inWidth);
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: 'SAME'
        };
    } else if (pad === 'valid') {
        padInfo = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            type: 'VALID'
        };
        outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
        outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
    } else if (typeof pad === 'object') {
        const top = dataFormat === 'channelsLast' ? pad[1][0] : pad[2][0];
        const bottom = dataFormat === 'channelsLast' ? pad[1][1] : pad[2][1];
        const left = dataFormat === 'channelsLast' ? pad[2][0] : pad[3][0];
        const right = dataFormat === 'channelsLast' ? pad[2][1] : pad[3][1];
        const padType = top === 0 && bottom === 0 && left === 0 && right === 0 ? 'VALID' : 'EXPLICIT';
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: padType
        };
        outHeight = $b3e4d1c19b78487c$var$round((inHeight - filterHeight + top + bottom) / strideHeight + 1, roundingMode);
        outWidth = $b3e4d1c19b78487c$var$round((inWidth - filterWidth + left + right) / strideWidth + 1, roundingMode);
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
function $b3e4d1c19b78487c$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, filterDepth, filterHeight, filterWidth, roundingMode) {
    let padInfo;
    let outDepth;
    let outHeight;
    let outWidth;
    if (pad === 'valid') pad = 0;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            front: pad,
            back: pad,
            type: padType
        };
        const outShape = $b3e4d1c19b78487c$var$computeOutputShape4D([
            inDepth,
            inHeight,
            inWidth,
            1
        ], [
            filterDepth,
            filterHeight,
            filterWidth
        ], 1, [
            strideDepth,
            strideHeight,
            strideWidth
        ], pad, roundingMode);
        outDepth = outShape[0];
        outHeight = outShape[1];
        outWidth = outShape[2];
    } else if (pad === 'same') {
        outDepth = Math.ceil(inDepth / strideDepth);
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongDepth = (outDepth - 1) * strideDepth + filterDepth - inDepth;
        const padAlongHeight = (outHeight - 1) * strideHeight + filterHeight - inHeight;
        const padAlongWidth = (outWidth - 1) * strideWidth + filterWidth - inWidth;
        const front = Math.floor(padAlongDepth / 2);
        const back = padAlongDepth - front;
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            front: front,
            back: back,
            type: 'SAME'
        };
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
/**
 * Rounds a value depending on the rounding mode
 * @param value
 * @param roundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $b3e4d1c19b78487c$var$round(value, roundingMode) {
    if (!roundingMode) return Math.trunc(value);
    switch(roundingMode){
        case 'round':
            // used for Caffe Conv
            return Math.round(value);
        case 'ceil':
            // used for Caffe Pool
            return Math.ceil(value);
        case 'floor':
            return Math.floor(value);
        default:
            throw new Error(`Unknown roundingMode ${roundingMode}`);
    }
}
function $b3e4d1c19b78487c$export$f16174446c2d5b2a(param) {
    const [dimA, dimB, dimC] = $b3e4d1c19b78487c$var$parseTupleParam(param);
    return dimA === 1 && dimB === 1 && dimC === 1;
}
function $b3e4d1c19b78487c$export$1e13dbff91e2f5ca(strides, dilations) {
    return $b3e4d1c19b78487c$export$f16174446c2d5b2a(strides) || $b3e4d1c19b78487c$export$f16174446c2d5b2a(dilations);
}
function $b3e4d1c19b78487c$export$6f24ba18d950c7e3(values) {
    return $b3e4d1c19b78487c$var$parseTupleParam(values).every((value)=>value > 0);
}
function $b3e4d1c19b78487c$export$1641c6bb3eb9a5b4(dataFormat) {
    if (dataFormat === 'NHWC') return 'channelsLast';
    else if (dataFormat === 'NCHW') return 'channelsFirst';
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
}
function $b3e4d1c19b78487c$export$1b3400c26a44af8(opDesc, pad, dimRoundingMode) {
    if (dimRoundingMode != null) {
        if (typeof pad === 'string') throw Error(`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'number') $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$357fc28f6427af8b(pad), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'object') pad.forEach((p)=>{
            p.forEach((v)=>{
                $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$357fc28f6427af8b(v), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${v}.`);
            });
        });
        else throw Error(`Error in ${opDesc}: Unknown padding parameter: ${pad}`);
    }
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reshapes a `tf.Tensor` to a given shape.
 *
 * Given an input tensor, returns a new tensor with the same values as the
 * input tensor with shape `shape`.
 *
 * If one component of shape is the special value -1, the size of that
 * dimension is computed so that the total size remains constant. In
 * particular, a shape of [-1] flattens into 1-D. At most one component of
 * shape can be -1.
 *
 * If shape is 1-D or higher, then the operation returns a tensor with shape
 * shape filled with the values of tensor. In this case, the number of
 * elements implied by shape must be the same as the number of elements in
 * tensor.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.reshape([2, 2]).print();
 * ```
 *
 * @param x The input tensor to be reshaped.
 * @param shape An array of integers defining the output tensor shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $33ee657bc32918d5$var$reshape_(x, shape) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'reshape', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        shape: shape
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$755ddd847e5abe03), inputs, attrs);
}
const $33ee657bc32918d5$export$9eaad88cf88cee2b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    reshape_: $33ee657bc32918d5$var$reshape_
});


/**
 * Computes the 2D average pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *         https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $de218d76756da0e0$var$avgPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'avgPool', 'float32');
    const dilations = 1;
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in avgPool: x must be rank 4 but got rank ${x4D.rank}.`);
    $b3e4d1c19b78487c$export$1b3400c26a44af8('avgPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$37f2cc7be1add88c), inputs, attrs);
    res = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(res, $x.dtype);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $de218d76756da0e0$export$d5c65a2abd3d97dc = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    avgPool_: $de218d76756da0e0$var$avgPool_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 







/**
 * Computes the 3D average pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.avgPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $ee986deb13dc5b5f$var$avgPool3d_(x, filterSize, strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'avgPool3d', 'float32');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x5D.rank === 5, ()=>`Error in avgPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dataFormat === 'NDHWC', ()=>`Error in avgPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(typeof strides === 'number' && strides > 0 || Array.isArray(strides) && strides[0] > 0 && strides[1] > 0 && strides[2] > 0, ()=>`Error in avgPool3d: Stride must be > 0, but got '${strides}'`);
    (0, $b3e4d1c19b78487c$export$1b3400c26a44af8)('avgPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$390ecb697af103f6), inputs, attrs);
    res = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(res, x5D.dtype);
    if (reshapedTo5D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $ee986deb13dc5b5f$export$ee1b0efb53eb29c3 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    avgPool3d_: $ee986deb13dc5b5f$var$avgPool3d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Concatenates a list of `tf.Tensor`s along a given axis.
 *
 * The tensors ranks and types must match, and their sizes must match in all
 * dimensions except `axis`.
 *
 * Also available are stricter rank-specific methods that assert that
 * `tensors` are of the given rank:
 *   - `tf.concat1d`
 *   - `tf.concat2d`
 *   - `tf.concat3d`
 *   - `tf.concat4d`
 *
 * Except `tf.concat1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * a.concat(b).print();  // or a.concat(b)
 * ```
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.concat([a, b, c]).print();
 * ```
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [10, 20]]);
 * const b = tf.tensor2d([[3, 4], [30, 40]]);
 * const axis = 1;
 * tf.concat([a, b], axis).print();
 * ```
 * @param tensors A list of tensors to concatenate.
 * @param axis The axis to concatenate along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $dc14b6735dbc478f$var$concat_(tensors, axis = 0) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(tensors.length >= 1, ()=>'Pass at least one tensor to concat');
    const $tensors = (0, $010a899b69412c72$export$758e66616b4d410b)(tensors, 'tensors', 'concat', 'string_or_numeric');
    if ($tensors[0].dtype === 'complex64') $tensors.forEach((tensor)=>{
        if (tensor.dtype !== 'complex64') throw new Error(`Cannot concatenate complex64 tensors with a tensor
          with dtype ${tensor.dtype}. `);
    });
    if ($tensors.length === 1) return (0, $44a9d8b42e3e34af$export$9cd59f9826255e47)($tensors[0]);
    const inputs = $tensors;
    const attr = {
        axis: axis
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$936bbfc007425eea), inputs, attr);
}
const $dc14b6735dbc478f$export$ee1b3e54f0441b22 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    concat_: $dc14b6735dbc478f$var$concat_
});





/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes sigmoid element-wise, `1 / (1 + exp(-x))`
 *
 * ```js
 * const x = tf.tensor1d([0, -1, 2, -3]);
 *
 * x.sigmoid().print();  // or tf.sigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $e3381678584872cc$var$sigmoid_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'sigmoid', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$fde18c826dda6b1b), inputs);
}
const $e3381678584872cc$export$3b295495ca3cad7c = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sigmoid_: $e3381678584872cc$var$sigmoid_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a slice from a `tf.Tensor` starting at coordinates `begin`
 * and is of size `size`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `x` is of the given rank:
 *   - `tf.slice1d`
 *   - `tf.slice2d`
 *   - `tf.slice3d`
 *   - `tf.slice4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.slice([1], [2]).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * x.slice([1, 0], [1, 2]).print();
 * ```
 * @param x The input `tf.Tensor` to slice from.
 * @param begin The coordinates to start the slice from. The length can be
 *     less than the rank of x - the rest of the axes will have implicit 0 as
 *     start. Can also be a single number, in which case it specifies the
 *     first axis.
 * @param size The size of the slice. The length can be less than the rank of
 *     x - the rest of the axes will have implicit -1. A value of -1 requests
 *     the rest of the dimensions in the axis. Can also be a single number,
 *     in which case it specifies the size of the first axis.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $535db06fef6716ec$var$slice_(x, begin, size) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'slice', 'string_or_numeric');
    if ($x.rank === 0) throw new Error('Slicing scalar is not possible');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        size: size
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$b3f2e2de3a8baa1e), inputs, attrs);
}
const $535db06fef6716ec$export$58adb3bec8346d0f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    slice_: $535db06fef6716ec$var$slice_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes hyperbolic tangent of the input `tf.Tensor` element-wise: `tanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, 70]);
 *
 * x.tanh().print();  // or tf.tanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $a88dd77d13a4ba8f$var$tanh_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'tanh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$893b6e865e352c83), inputs);
}
const $a88dd77d13a4ba8f$export$7128670e45beef9a = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    tanh_: $a88dd77d13a4ba8f$var$tanh_
});


/**
 * Computes the next state and output of a BasicLSTMCell.
 *
 * Returns `[newC, newH]`.
 *
 * Derived from tf.contrib.rnn.BasicLSTMCell.
 *
 * @param forgetBias Forget bias for the cell.
 * @param lstmKernel The weights for the cell.
 * @param lstmBias The bias for the cell.
 * @param data The input to the cell.
 * @param c Previous cell state.
 * @param h Previous cell output.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $ab33a6501fc905fb$var$basicLSTMCell_(forgetBias, lstmKernel, lstmBias, data, c, h) {
    const $forgetBias = (0, $010a899b69412c72$export$ede379c4c939d71a)(forgetBias, 'forgetBias', 'basicLSTMCell');
    const $lstmKernel = (0, $010a899b69412c72$export$ede379c4c939d71a)(lstmKernel, 'lstmKernel', 'basicLSTMCell');
    const $lstmBias = (0, $010a899b69412c72$export$ede379c4c939d71a)(lstmBias, 'lstmBias', 'basicLSTMCell');
    const $data = (0, $010a899b69412c72$export$ede379c4c939d71a)(data, 'data', 'basicLSTMCell');
    const $c = (0, $010a899b69412c72$export$ede379c4c939d71a)(c, 'c', 'basicLSTMCell');
    const $h = (0, $010a899b69412c72$export$ede379c4c939d71a)(h, 'h', 'basicLSTMCell');
    const combined = (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)([
        $data,
        $h
    ], 1);
    const weighted = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(combined, $lstmKernel);
    const res = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(weighted, $lstmBias);
    // i = input_gate, j = new_input, f = forget_gate, o = output_gate
    const batchSize = res.shape[0];
    const sliceCols = res.shape[1] / 4;
    const sliceSize = [
        batchSize,
        sliceCols
    ];
    const i = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(res, [
        0,
        0
    ], sliceSize);
    const j = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(res, [
        0,
        sliceCols
    ], sliceSize);
    const f = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(res, [
        0,
        sliceCols * 2
    ], sliceSize);
    const o = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(res, [
        0,
        sliceCols * 3
    ], sliceSize);
    const newC = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $e3381678584872cc$export$3b295495ca3cad7c)(i), (0, $a88dd77d13a4ba8f$export$7128670e45beef9a)(j)), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($c, (0, $e3381678584872cc$export$3b295495ca3cad7c)((0, $c90bd95bc0e58efa$export$e16d8520af44a096)($forgetBias, f))));
    const newH = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $a88dd77d13a4ba8f$export$7128670e45beef9a)(newC), (0, $e3381678584872cc$export$3b295495ca3cad7c)(o));
    return [
        newC,
        newH
    ];
}
const $ab33a6501fc905fb$export$5f13ab10a3272278 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    basicLSTMCell_: $ab33a6501fc905fb$var$basicLSTMCell_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * This operation reshapes the "batch" dimension 0 into `M + 1` dimensions of
 * shape `blockShape + [batch]`, interleaves these blocks back into the grid
 * defined by the spatial dimensions `[1, ..., M]`, to obtain a result with
 * the same rank as the input. The spatial dimensions of this intermediate
 * result are then optionally cropped according to `crops` to produce the
 * output. This is the reverse of `tf.spaceToBatchND`. See below for a precise
 * description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [4, 1, 1, 1]);
 * const blockShape = [2, 2];
 * const crops = [[0, 0], [0, 0]];
 *
 * x.batchToSpaceND(blockShape, crops).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param crops A 2-D array.  Must have shape `[M, 2]`, all values must be >= 0.
 * `crops[i] = [cropStart, cropEnd]` specifies the amount to crop from input
 * dimension `i + 1`, which corresponds to spatial dimension `i`. It is required
 * that `cropStart[i] + cropEnd[i] <= blockShape[i] * inputShape[i + 1]`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Reshape `x` to `reshaped` of shape: `[blockShape[0], ...,
 * blockShape[M-1], batch / prod(blockShape), x.shape[1], ...,
 * x.shape[N-1]]`
 *
 * 2. Permute dimensions of `reshaped` to produce `permuted` of shape `[batch /
 * prod(blockShape),x.shape[1], blockShape[0], ..., x.shape[M],
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 3. Reshape `permuted` to produce `reshapedPermuted` of shape `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0], ..., x.shape[M] *
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 4. Crop the start and end of dimensions `[1, ..., M]` of `reshapedPermuted`
 * according to `crops` to produce the output of shape: `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0] - crops[0,0] - crops[0,1],
 * ..., x.shape[M] * blockShape[M-1] - crops[M-1,0] -
 * crops[M-1,1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $2337f2e1e82e1c80$var$batchToSpaceND_(x, blockShape, crops) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'batchToSpaceND');
    const prod = blockShape.reduce((a, b)=>a * b);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank >= 1 + blockShape.length, ()=>`input rank is ${$x.rank} but should be > than blockShape.length ${blockShape.length}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(crops.length === blockShape.length, ()=>`crops.length is ${crops.length} but should be equal to blockShape.length  ${blockShape.length}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.shape[0] % prod === 0, ()=>`input tensor batch is ${$x.shape[0]} but is not divisible by the product of ` + `the elements of blockShape ${blockShape.join(' * ')} === ${prod}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        crops: crops
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$e2743f47f61cca1f), inputs, attrs);
}
const $2337f2e1e82e1c80$export$ea37d960c1808536 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    batchToSpaceND_: $2337f2e1e82e1c80$var$batchToSpaceND_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




function $13583fec5b92f414$export$b76c765a8a7b5836(x) {
    let x4D;
    if (x.rank === 0 || x.rank === 1) x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(x, [
        1,
        1,
        1,
        x.size
    ]);
    else if (x.rank === 2) x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(x, [
        1,
        1,
        x.shape[0],
        x.shape[1]
    ]);
    else if (x.rank === 3) x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    else x4D = x;
    return x4D;
}




/**
 * Batch normalization.
 *
 * As described in
 * [http://arxiv.org/abs/1502.03167](http://arxiv.org/abs/1502.03167).
 *
 * Mean, variance, scale, and offset can be of two shapes:
 *   - The same shape as the input.
 *   - In the common case, the depth dimension is the last dimension of x, so
 *     the values would be a `tf.Tensor1D` of shape [depth].
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that parameters passed are of given rank
 *   - `tf.batchNorm2d`
 *   - `tf.batchNorm3d`
 *   - `tf.batchNorm4d`
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $44e73c16120369ac$var$batchNorm_(x, mean, variance, offset, scale, varianceEpsilon) {
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'batchNorm');
    const $mean = (0, $010a899b69412c72$export$ede379c4c939d71a)(mean, 'mean', 'batchNorm');
    const $variance = (0, $010a899b69412c72$export$ede379c4c939d71a)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $010a899b69412c72$export$ede379c4c939d71a)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $010a899b69412c72$export$ede379c4c939d71a)(offset, 'offset', 'batchNorm');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($mean.rank === $variance.rank, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($offset == null || $mean.rank === $offset.rank, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($scale == null || $mean.rank === $scale.rank, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    const x4D = (0, $13583fec5b92f414$export$b76c765a8a7b5836)($x);
    const inputs = {
        x: x4D,
        scale: $scale,
        offset: $offset,
        mean: $mean,
        variance: $variance
    };
    const attrs = {
        varianceEpsilon: varianceEpsilon
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$3821a0416660aaa2), inputs, attrs);
    return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, $x.shape);
}
const $44e73c16120369ac$export$8ea8088e6d0cdd02 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    batchNorm_: $44e73c16120369ac$var$batchNorm_
});






/**
 * Batch normalization, strictly for 2D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $f1c219fe7a1e385d$var$batchNorm2d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'batchNorm');
    const $mean = (0, $010a899b69412c72$export$ede379c4c939d71a)(mean, 'mean', 'batchNorm');
    const $variance = (0, $010a899b69412c72$export$ede379c4c939d71a)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $010a899b69412c72$export$ede379c4c939d71a)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $010a899b69412c72$export$ede379c4c939d71a)(offset, 'offset', 'batchNorm');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 2, ()=>`Error in batchNorm2D: x must be rank 2 but got rank ` + `${$x.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($mean.rank === 2 || $mean.rank === 1, ()=>`Error in batchNorm2D: mean must be rank 2 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($variance.rank === 2 || $variance.rank === 1, ()=>`Error in batchNorm2D: variance must be rank 2 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $5f8d0ee7a8d35dfe$export$a7a9523472993e97($scale.rank === 2 || $scale.rank === 1, ()=>`Error in batchNorm2D: scale must be rank 2 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $5f8d0ee7a8d35dfe$export$a7a9523472993e97($offset.rank === 2 || $offset.rank === 1, ()=>`Error in batchNorm2D: offset must be rank 2 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $44e73c16120369ac$export$8ea8088e6d0cdd02)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $f1c219fe7a1e385d$export$4104d1fc5afa918a = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    batchNorm2d_: $f1c219fe7a1e385d$var$batchNorm2d_
});






/**
 * Batch normalization, strictly for 3D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $2bc34dd5a70650fd$var$batchNorm3d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'batchNorm');
    const $mean = (0, $010a899b69412c72$export$ede379c4c939d71a)(mean, 'mean', 'batchNorm');
    const $variance = (0, $010a899b69412c72$export$ede379c4c939d71a)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $010a899b69412c72$export$ede379c4c939d71a)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $010a899b69412c72$export$ede379c4c939d71a)(offset, 'offset', 'batchNorm');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 3, ()=>`Error in batchNorm3D: x must be rank 3 but got rank ` + `${$x.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($mean.rank === 3 || $mean.rank === 1, ()=>`Error in batchNorm3D: mean must be rank 3 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($variance.rank === 3 || $variance.rank === 1, ()=>`Error in batchNorm3D: variance must be rank 3 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $5f8d0ee7a8d35dfe$export$a7a9523472993e97($scale.rank === 3 || $scale.rank === 1, ()=>`Error in batchNorm3D: scale must be rank 3 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $5f8d0ee7a8d35dfe$export$a7a9523472993e97($offset.rank === 3 || $offset.rank === 1, ()=>`Error in batchNorm3D: offset must be rank 3 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $44e73c16120369ac$export$8ea8088e6d0cdd02)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $2bc34dd5a70650fd$export$76211212fb57f1fa = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    batchNorm3d_: $2bc34dd5a70650fd$var$batchNorm3d_
});






/**
 * Batch normalization, strictly for 4D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $23c80da7bb92eb50$var$batchNorm4d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'batchNorm');
    const $mean = (0, $010a899b69412c72$export$ede379c4c939d71a)(mean, 'mean', 'batchNorm');
    const $variance = (0, $010a899b69412c72$export$ede379c4c939d71a)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $010a899b69412c72$export$ede379c4c939d71a)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $010a899b69412c72$export$ede379c4c939d71a)(offset, 'offset', 'batchNorm');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 4, ()=>`Error in batchNorm4D: x must be rank 4 but got rank ` + `${$x.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($mean.rank === 4 || $mean.rank === 1, ()=>`Error in batchNorm4D: mean must be rank 4 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($variance.rank === 4 || $variance.rank === 1, ()=>`Error in batchNorm4D: variance must be rank 4 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $5f8d0ee7a8d35dfe$export$a7a9523472993e97($scale.rank === 4 || $scale.rank === 1, ()=>`Error in batchNorm4D: scale must be rank 4 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $5f8d0ee7a8d35dfe$export$a7a9523472993e97($offset.rank === 4 || $offset.rank === 1, ()=>`Error in batchNorm4D: offset must be rank 4 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $44e73c16120369ac$export$8ea8088e6d0cdd02)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $23c80da7bb92eb50$export$4573a348ef14e569 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    batchNorm4d_: $23c80da7bb92eb50$var$batchNorm4d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $af732e8d9c378509$var$bincount_(x, weights, size) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'bincount');
    const $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'bincount');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.dtype === 'int32', ()=>`Error in bincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($weights.size === $x.size || $weights.size === 0, ()=>`Error in bincount: weights must have the same size as input or` + `0-length, but got input shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$45dfbbff595c32aa), inputs, attrs);
}
const $af732e8d9c378509$export$7e474bab088ed182 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    bincount_: $af732e8d9c378509$var$bincount_
});


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Bitwise `AND` operation for input tensors.
 *
 * Given two input tensors, returns a new tensor
 * with the `AND` calculated values.
 *
 * The method supports int32 values
 *
 *
 * ```js
 * const x = tf.tensor1d([0, 5, 3, 14], 'int32');
 * const y = tf.tensor1d([5, 0, 7, 11], 'int32');
 * tf.bitwiseAnd(x, y).print();
 * ```
 *
 * @param x The input tensor to be calculated.
 * @param y The input tensor to be calculated.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $9ba11836a7a0e3b8$var$bitwiseAnd_(x, y) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'bitwiseAnd');
    const $y = (0, $010a899b69412c72$export$ede379c4c939d71a)(y, 'y', 'bitwiseAnd');
    if (!(0, $5f8d0ee7a8d35dfe$export$234180f8206db11b)($x.shape, $y.shape)) throw new Error(`BitwiseAnd: Tensors must have the same shape. x: ${$x.shape}, y: ${$y.shape}`);
    if ($x.dtype !== 'int32' || $y.dtype !== 'int32') throw new Error(`BitwiseAnd: Only supports 'int32' values in tensor, found type of x: ${$x.dtype} and type of y: ${$y.dtype}`);
    const inputs = {
        a: $x,
        b: $y
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$a9e259e32a62221f), inputs);
}
const $9ba11836a7a0e3b8$export$84529b0ad3b42cd1 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    bitwiseAnd_: $9ba11836a7a0e3b8$var$bitwiseAnd_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Return the shape of s0 op s1 with broadcast.
 *
 * compute r0, the broadcasted shape as a tensor.
 * s0, s1 and r0 are all integer vectors.
 *
 * This function returns the shape of the result of an operation between
 * two tensors of size s0 and s1 performed with broadcast.
 *
 * @param s0 A tensor representing a shape
 * @param s1 A tensor representing a shape
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $e9c057b2b5ab831a$var$broadcastArgs_(s0, s1) {
    const shape1Input = (0, $010a899b69412c72$export$ede379c4c939d71a)(s0, 's0', 'broadcastArgs', 'int32');
    const shape2Input = (0, $010a899b69412c72$export$ede379c4c939d71a)(s1, 's1', 'broadcastArgs', 'int32');
    if (shape1Input.rank !== 1) throw new Error('broadcastArgs(): first input must be a vector (rank=1). ' + `Has rank ${shape1Input.rank}`);
    if (shape2Input.rank !== 1) throw new Error('broadcastArgs(): second input must be a vector (rank=1). ' + `Has rank ${shape2Input.rank}`);
    const inputs = {
        s0: shape1Input,
        s1: shape2Input
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$32877b1d6d497805), inputs);
}
const $e9c057b2b5ab831a$export$d226d344aedce941 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    broadcastArgs_: $e9c057b2b5ab831a$var$broadcastArgs_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Broadcast an array to a compatible shape NumPy-style.
 *
 * The tensor's shape is compared to the broadcast shape from end to beginning.
 * Ones are prepended to the tensor's shape until it has the same length as
 * the broadcast shape. If input.shape[i]==shape[i], the (i+1)-th axis is
 * already broadcast-compatible. If input.shape[i]==1 and shape[i]==N, then
 * the input tensor is tiled N times along that axis (using tf.tile).
 *
 * @param input The tensor that is to be broadcasted.
 * @param shape The input is to be broadcast to this shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $7737f62f876bfd57$var$broadcastTo_(x, shape) {
    let input = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'broadcastTo', 'x');
    const xShape = input.shape;
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    if (shape.length < input.rank) throw new Error(`broadcastTo(): shape.length=${shape.length} < input.rank=${input.rank}.`);
    if (shape.length > input.rank) {
        const newShape = input.shape.slice();
        while(newShape.length < shape.length)newShape.unshift(1);
        input = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(input, newShape);
    }
    const inputShape = input.shape;
    const reps = Array.from(shape);
    for(let i = shape.length - 1; i >= 0; i--){
        if (inputShape[i] === shape[i]) reps[i] = 1;
        else if (input.shape[i] !== 1) throw new Error(`broadcastTo(): [${xShape}] cannot be broadcast to [${shape}].`);
    }
    const axes = reps.map((n, i)=>n > 1 ? i : -1).filter((i)=>i >= 0);
    if (axes.length === 0) return (0, $44a9d8b42e3e34af$export$9cd59f9826255e47)(input);
    // TODO call broadcastTo kernel directly once backends implement broadcstTo
    const inputs = {
        x: input
    };
    const attrs = {
        reps: reps
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$235cb65c20ad2b7), inputs, attrs);
}
const $7737f62f876bfd57$export$ec9086aff2624eab = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    broadcastTo_: $7737f62f876bfd57$var$broadcastTo_
});




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes ceiling of input `tf.Tensor` element-wise: `ceil(x)`
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.ceil().print();  // or tf.ceil(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $e4b6dd76ad5b047e$var$ceil_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'ceil', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$d4a1bccfd52ebd3), inputs);
}
const $e4b6dd76ad5b047e$export$803ce6b71a0a94b2 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    ceil_: $e4b6dd76ad5b047e$var$ceil_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Clips values element-wise. `max(min(x, clipValueMax), clipValueMin)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.clipByValue(-2, 3).print();  // or tf.clipByValue(x, -2, 3)
 * ```
 * @param x The input tensor.
 * @param clipValueMin Lower bound of range to be clipped to.
 * @param clipValueMax Upper bound of range to be clipped to.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $9557879f1a67b9dc$var$clipByValue_(x, clipValueMin, clipValueMax) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'clipByValue');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(clipValueMin <= clipValueMax, ()=>`Error in clip: min (${clipValueMin}) must be ` + `less than or equal to max (${clipValueMax}).`);
    if (clipValueMin === clipValueMax) return (0, $c5b09a3759406f8a$export$9563e054e6f787fb)($x.shape, clipValueMin, $x.dtype);
    const inputs = {
        x: $x
    };
    const attrs = {
        clipValueMin: clipValueMin,
        clipValueMax: clipValueMax
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$611c0e357ac37f7d), inputs, attrs);
}
const $9557879f1a67b9dc$export$fa97baf70ad024c0 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    clipByValue_: $9557879f1a67b9dc$var$clipByValue_
});







/**
 * Concatenates a list of`tf.Tensor1D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(3) = |r1, g1, b1|
 * B: shape(2) = |r2, g2|
 * C = tf.concat1d([A, B]) == |r1, g1, b1, r2, g2|
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @return The concatenated array.
 */ function $3917d674c96d0dbb$var$concat1d_(tensors) {
    return (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)(tensors, 0 /* axis */ );
}
const $3917d674c96d0dbb$export$1e0bfb2ad280a475 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    concat1d_: $3917d674c96d0dbb$var$concat1d_
});




/**
 * Concatenates a list of`tf.Tensor2D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *
 * B: shape(2, 3) = | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * C = tf.concat2d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *                  | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * if axis = 1:
 * C = shape(2, 6) = | r1, g1, b1, r3, g3, b3 |
 *                   | r2, g2, b2, r4, g4, b4 |
 *
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concatenate along.
 * @return The concatenated array.
 */ function $5b4cc8a7f2cde29e$var$concat2d_(tensors, axis) {
    return (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)(tensors, axis);
}
const $5b4cc8a7f2cde29e$export$ba044983349051fd = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    concat2d_: $5b4cc8a7f2cde29e$var$concat2d_
});




/**
 * Concatenates a list of `tf.Tensor3D`s along an axis.
 * See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *
 * B: shape(2, 1, 3) = | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * C = tf.concat3d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *                     | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * if axis = 1:
 * C: shape(2, 2, 3) = | r1, g1, b1, r3, g3, b3 |
 *                     | r2, g2, b2, r4, g4, b4 |
 *
 * if axis = 2:
 * C = shape(2, 1, 6) = | r1, g1, b1, r3, g3, b3 |
 *                      | r2, g2, b2, r4, g4, b4 |
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $f8403086914455d5$var$concat3d_(tensors, axis) {
    return (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)(tensors, axis);
}
const $f8403086914455d5$export$23e0f187dd67babf = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    concat3d_: $f8403086914455d5$var$concat3d_
});




/**
 * Concatenates a list of `tf.Tensor4D`s along an axis.
 * See `concat` for details.
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $70cd662e381f1d83$var$concat4d_(tensors, axis) {
    return (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)(tensors, axis);
}
const $70cd662e381f1d83$export$731e01cced6c0a23 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    concat4d_: $70cd662e381f1d83$var$concat4d_
});




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Computes a 2D convolution over the input x.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $43815144b11940c7$var$conv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $010a899b69412c72$export$ede379c4c939d71a)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in conv2d: input must be rank 4, but got rank ${x4D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($filter.rank === 4, ()=>`Error in conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $b3e4d1c19b78487c$export$1b3400c26a44af8('conv2d', pad, dimRoundingMode);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inDepth === $filter.shape[2], ()=>`Error in conv2d: depth of input (${inDepth}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$6f24ba18d950c7e3(dilations), ()=>'Error in conv2D: Dilated rates should be larger than 0.');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$6f24ba18d950c7e3(strides), ()=>'Error in conv2D: Strides should be larger than 0.');
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$57742e605d475795), inputs, attrs);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $43815144b11940c7$export$188f9215482e3db8 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    conv2d_: $43815144b11940c7$var$conv2d_
});





/**
 * Computes a 1D convolution over the input x.
 *
 * @param x The input tensor, of rank 3 or rank 2, of shape
 *     `[batch, width, inChannels]`. If rank 2, batch of 1 is assumed.
 * @param filter The filter, rank 3, of shape
 *     `[filterWidth, inDepth, outDepth]`.
 * @param stride The number of entries by which the filter is moved right at
 *     each step.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from "NWC", "NCW". Defaults to "NWC",
 *     the data is stored in the order of [batch, in_width, in_channels]. Only
 *     "NWC" is currently supported.
 * @param dilation The dilation rate in which we sample input values in
 *     atrous convolution. Defaults to `1`. If it is greater than 1, then
 *     stride must be `1`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $a54a489200625adb$var$conv1d_(x, filter, stride, pad, dataFormat = 'NWC', dilation = 1, dimRoundingMode) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'conv1d');
    const $filter = (0, $010a899b69412c72$export$ede379c4c939d71a)(filter, 'filter', 'conv1d');
    let x3D = $x;
    let reshapedTo3D = false;
    if ($x.rank === 2) {
        reshapedTo3D = true;
        x3D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x3D.rank === 3, ()=>`Error in conv1d: input must be rank 3, but got rank ${x3D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($filter.rank === 3, ()=>`Error in conv1d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $b3e4d1c19b78487c$export$1b3400c26a44af8('conv1d', pad, dimRoundingMode);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x3D.shape[2] === $filter.shape[1], ()=>`Error in conv1d: depth of input (${x3D.shape[2]}) must match ` + `input depth for filter ${$filter.shape[1]}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$1e13dbff91e2f5ca(stride, dilation), ()=>'Error in conv1D: Either stride or dilation must be 1. ' + `Got stride ${stride} and dilation '${dilation}'`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$6f24ba18d950c7e3(dilation), ()=>'Error in conv1D: Dilated rates should be larger than 0.');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$6f24ba18d950c7e3(stride), ()=>'Error in conv1D: Stride should be larger than 0.');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dataFormat === 'NWC', ()=>`Error in conv1d: got dataFormat of ${dataFormat} but only NWC is currently supported.`);
    const filter4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($filter, [
        1,
        $filter.shape[0],
        $filter.shape[1],
        $filter.shape[2]
    ]);
    const input4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(x3D, [
        x3D.shape[0],
        1,
        x3D.shape[1],
        x3D.shape[2]
    ]);
    const strides = [
        1,
        stride
    ];
    const dilations = [
        1,
        dilation
    ];
    const conv2dDataFormat = 'NHWC';
    const res = (0, $43815144b11940c7$export$188f9215482e3db8)(input4D, filter4D, strides, pad, conv2dDataFormat, dilations, dimRoundingMode);
    if (reshapedTo3D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[2],
        res.shape[3]
    ]);
    return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[0],
        res.shape[2],
        res.shape[3]
    ]);
}
const $a54a489200625adb$export$d8aa844fa36b350e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    conv1d_: $a54a489200625adb$var$conv1d_
});




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the derivative of the input of a 2D convolution.
 *
 * @param xShape The shape of the input: [batch, height, width, inDepth].
 * If length of 3, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 4 or rank 3 of shape
 *   `[batch, outHeight, outWidth, outDepth]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $4897cf7297aaab1d$var$conv2DBackpropInput_(xShape, dy, filter, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape4D = xShape;
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
        xShape4D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2]
        ];
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(xShape4D.length === 4, ()=>`Error in conv2dDerInput: inShape must be length 4, but got length ` + `${xShape4D.length}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dy4D.rank === 4, ()=>`Error in conv2dDerInput: dy must be rank 4, but got ` + `rank ${dy4D.rank}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(filter.rank === 4, ()=>`Error in conv2dDerInput: filter must be rank 4, but got ` + `rank ${filter.rank}`);
    const inDepth = dataFormat === 'NHWC' ? xShape4D[3] : xShape4D[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inDepth === filter.shape[2], ()=>`Error in conv2dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[2]}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(outDepth === filter.shape[3], ()=>`Error in conv2dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[3]}.`);
    $b3e4d1c19b78487c$export$1b3400c26a44af8('conv2dDerInput', pad, dimRoundingMode);
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        inputShape: xShape4D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$e26961e8ed0eb404), inputs, attrs);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $4897cf7297aaab1d$export$633310eed0c26e72 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    conv2DBackpropInput_: $4897cf7297aaab1d$var$conv2DBackpropInput_
});



/**
 * Computes the transposed 2D convolution of an image, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 4 or rank 3, of shape
 *   `[batch, height, width, inDepth]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 4 or rank 3:
 *     `[batch, height, width, outDepth]`. If rank 3, batch of 1 is assumed.
 * @param strides The strides of the original convolution:
 *     `[strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $3f61560f269899e2$var$conv2dTranspose_(x, filter, outputShape, strides, pad, dimRoundingMode) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'conv2dTranspose');
    const $filter = (0, $010a899b69412c72$export$ede379c4c939d71a)(filter, 'filter', 'conv2dTranspose');
    return (0, $4897cf7297aaab1d$export$633310eed0c26e72)(outputShape, $x, $filter, strides, pad, 'NHWC', dimRoundingMode);
}
const $3f61560f269899e2$export$d5e924cbc07fb966 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    conv2dTranspose_: $3f61560f269899e2$var$conv2dTranspose_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Computes a 3D convolution over the input x.
 *
 * @param x The input tensor, of rank 5 or rank 4, of shape
 *     `[batch, depth, height, width, channels]`. If rank 4,
 * batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inChannels, outChannels]`.
 *      inChannels must match between input and filter.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationDepth, dilationHeight,
 *     dilationWidth]` in which we sample input values across the height
 *     and width dimensions in atrous convolution. Defaults to `[1, 1, 1]`.
 *     If `dilations` is a single number, then
 *     `dilationDepth == dilationHeight == dilationWidth`. If it is greater
 *     than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $ec8b6241dd6bfd55$var$conv3d_(x, filter, strides, pad, dataFormat = 'NDHWC', dilations = [
    1,
    1,
    1
]) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'conv3d');
    const $filter = (0, $010a899b69412c72$export$ede379c4c939d71a)(filter, 'filter', 'conv3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x5D.rank === 5, ()=>`Error in conv3d: input must be rank 5, but got rank ${x5D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($filter.rank === 5, ()=>`Error in conv3d: filter must be rank 5, but got rank ` + `${$filter.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x5D.shape[4] === $filter.shape[3], ()=>`Error in conv3d: depth of input (${x5D.shape[4]}) must match ` + `input depth for filter ${$filter.shape[3]}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97((0, $b3e4d1c19b78487c$export$1e13dbff91e2f5ca)(strides, dilations), ()=>'Error in conv3D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dataFormat === 'NDHWC', ()=>`Error in conv3d: got dataFormat of ${dataFormat} but only NDHWC is currently supported.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97((0, $b3e4d1c19b78487c$export$6f24ba18d950c7e3)(dilations), ()=>'Error in conv3D: Dilated rates should be larger than 0.');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97((0, $b3e4d1c19b78487c$export$6f24ba18d950c7e3)(strides), ()=>'Error in conv3D: Strides should be larger than 0.');
    const inputs = {
        x: x5D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$9d3874201dd21933), inputs, attrs);
    if (reshapedTo5D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $ec8b6241dd6bfd55$export$c476b02bcf7b2def = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    conv3d_: $ec8b6241dd6bfd55$var$conv3d_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the derivative of the input of a 3D convolution.
 *
 * @param xShape The shape of the input: [batch, depth, height, width,
 * in_channels]. If length of 4, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 5 or rank 4 of shape
 *   `[batch, outDepth, outHeight, outWidth, in_channels]`.
 * If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 */ function $06e57b3d65a6c21e$var$conv3DBackpropInput_(xShape, dy, filter, strides, pad) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape5D = xShape;
    let dy5D = dy;
    let reshapedTo5D = false;
    if (dy.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2],
            dy.shape[3]
        ]);
        xShape5D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2],
            xShape[3]
        ];
    }
    const inDepth = xShape5D[4];
    const outDepth = dy5D.shape[4];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(xShape5D.length === 5, ()=>`Error in conv3dDerInput: inShape must be length 5, but got length ` + `${xShape5D.length}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dy5D.rank === 5, ()=>`Error in conv3dDerInput: dy must be rank 5, but got ` + `rank ${dy5D.rank}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(filter.rank === 5, ()=>`Error in conv3dDerInput: filter must be rank 5, but got ` + `rank ${filter.rank}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inDepth === filter.shape[3], ()=>`Error in conv3dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[3]}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(outDepth === filter.shape[4], ()=>`Error in conv3dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[4]}.`);
    const inputs = {
        dy: dy5D,
        filter: filter
    };
    const attrs = {
        pad: pad,
        strides: strides,
        inputShape: xShape5D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$a54f552d6d7d521f), inputs, attrs);
    if (reshapedTo5D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $06e57b3d65a6c21e$export$deb6d1ca1fa2977b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    conv3DBackpropInput_: $06e57b3d65a6c21e$var$conv3DBackpropInput_
});



/**
 * Computes the transposed 3D convolution of a volume, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 5 or rank 4, of shape
 *   `[batch, depth, height, width, inDepth]`. If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[depth, filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 5 or rank 4:
 *     `[batch, depth, height, width, outDepth]`. If rank 3, batch of 1 is
 *    assumed.
 * @param strides The strides of the original convolution:
 *     `[strideDepth, strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $5d0b12361a33af6c$var$conv3dTranspose_(x, filter, outputShape, strides, pad) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'conv3dTranspose');
    const $filter = (0, $010a899b69412c72$export$ede379c4c939d71a)(filter, 'filter', 'conv3dTranspose');
    return (0, $06e57b3d65a6c21e$export$deb6d1ca1fa2977b)(outputShape, $x, $filter, strides, pad);
}
const $5d0b12361a33af6c$export$5eac62031b3f449f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    conv3dTranspose_: $5d0b12361a33af6c$var$conv3dTranspose_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes cos of the input `tf.Tensor` element-wise: `cos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.cos().print();  // or tf.cos(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $2a105ca58e08bbc3$var$cos_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'cos', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$ddfd0a983d257666), inputs);
}
const $2a105ca58e08bbc3$export$50d414a77b60d802 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    cos_: $2a105ca58e08bbc3$var$cos_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes hyperbolic cos of the input `tf.Tensor` element-wise: `cosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.cosh().print();  // or tf.cosh(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $8a7f403fda14de62$var$cosh_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'cosh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$5e311a1c57b0d27c), inputs);
}
const $8a7f403fda14de62$export$2e2fd1ad24e4d350 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    cosh_: $8a7f403fda14de62$var$cosh_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the cumulative product of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumprod().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumprod().print();
 * ```
 *
 * @param x The input tensor to cumulatively multiply.
 * @param axis The axis along which to multiply. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative product. Optional.
 *     Defaults to false. If set to true then the product of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to multiply in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $835f27a7a6e6bb41$var$cumprod_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'cumprod');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$e581acc6014c47a), inputs, attrs);
}
const $835f27a7a6e6bb41$export$dc7513e907e94b8d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    cumprod_: $835f27a7a6e6bb41$var$cumprod_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the cumulative sum of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumsum().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumsum().print();
 * ```
 *
 * @param x The input tensor to be summed.
 * @param axis The axis along which to sum. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative sum. Optional.
 *     Defaults to false. If set to true then the sum of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to sum in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $558f12105d46bb41$var$cumsum_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'cumsum');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$706617d894ad63da), inputs, attrs);
}
const $558f12105d46bb41$export$71990b1e1c4912fe = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    cumsum_: $558f12105d46bb41$var$cumsum_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1 or rank 2.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 * @param binaryOutput Optional. Whether the kernel should count the appearance
 *     or number of occurrences. Defaults to False.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $6158ac691c62a7b2$var$denseBincount_(x, weights, size, binaryOutput = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'denseBincount');
    const $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'denseBincount');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.dtype === 'int32', ()=>`Error in denseBincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank <= 2, ()=>`Error in denseBincount: input must be at most rank 2, but got ` + `rank ${$x.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($weights.size === $x.size || $weights.size === 0, ()=>`Error in denseBincount: weights must have the same shape as x or ` + `0-length, but got x shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size,
        binaryOutput: binaryOutput
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$5bab6834954299c5), inputs, attrs);
}
const $6158ac691c62a7b2$export$436934e6cf1946f1 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    denseBincount_: $6158ac691c62a7b2$var$denseBincount_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Rearranges data from depth into blocks of spatial data. More specifically,
 * this op outputs a copy of the input tensor where values from the `depth`
 * dimension are moved in spatial blocks to the `height` and `width` dimensions.
 * The attr `blockSize` indicates the input block size and how the data is
 * moved.
 *
 *  - Chunks of data of size `blockSize * blockSize` from depth are rearranged
 * into non-overlapping blocks of size `blockSize x blockSize`
 *
 *  - The width the output tensor is `inputWidth * blockSize`, whereas the
 * height is `inputHeight * blockSize`
 *
 *  - The Y, X coordinates within each block of the output image are determined
 * by the high order component of the input channel index
 *
 *  - The depth of the input tensor must be divisible by `blockSize *
 * blockSize`
 *
 * The `dataFormat` attr specifies the layout of the input and output tensors
 * with the following options: "NHWC": [ `batch, height, width, channels` ]
 * "NCHW": [ `batch, channels, height, width` ]
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 1, 1, 4]);
 * const blockSize = 2;
 * const dataFormat = "NHWC";
 *
 * tf.depthToSpace(x, blockSize, dataFormat).print();
 * ```
 *
 * @param x The input tensor of rank 4
 * @param blockSIze  An `int` that is `>= 2`. The size of the spatial block
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to "NHWC"
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $fd0a6e62c5011c86$var$depthToSpace_(x, blockSize, dataFormat = 'NHWC') {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'depthToSpace', 'float32');
    const inputHeight = dataFormat === 'NHWC' ? $x.shape[1] : $x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? $x.shape[2] : $x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? $x.shape[3] : $x.shape[1];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(blockSize > 1, ()=>`blockSize should be > 1 for depthToSpace, but was: ${blockSize}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inputHeight * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputHeight} and ${blockSize}  for depthToSpace with input shape
    ${$x.shape}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inputWidth * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputWidth} and ${blockSize} for depthToSpace with input shape
        ${$x.shape}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inputDepth % (blockSize * blockSize) === 0, ()=>`Dimension size must be evenly divisible by ${blockSize * blockSize} but is ${inputDepth} for depthToSpace with input shape ${$x.shape}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockSize: blockSize,
        dataFormat: dataFormat
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$fb0ee52d0cd6f233), inputs, attrs);
}
const $fd0a6e62c5011c86$export$3b50daec0f185f12 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    depthToSpace_: $fd0a6e62c5011c86$var$depthToSpace_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Depthwise 2D convolution.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $0d28c12ba7a09138$var$depthwiseConv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $010a899b69412c72$export$ede379c4c939d71a)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($filter.rank === 4, ()=>`Error in depthwiseConv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    const inChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inChannels === $filter.shape[2], ()=>`Error in depthwiseConv2d: number of input channels ` + `(${inChannels}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    $b3e4d1c19b78487c$export$1b3400c26a44af8('depthwiseConv2d', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$7c0fc590ff9e156f), inputs, attrs);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $0d28c12ba7a09138$export$48a8ad9494a8fad8 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    depthwiseConv2d_: $0d28c12ba7a09138$var$depthwiseConv2d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns a diagonal tensor with given diagonal values.
 *
 * Given a diagonal, this operation returns a tensor with the diagonal and
 * everything else padded with zeros.
 *
 * Assume the input has dimensions `[D1,..., Dk]`, then the output is a tensor
 * of rank 2k with dimensions `[D1,..., Dk, D1,..., Dk]`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * tf.diag(x).print()
 * ```
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [4, 2])
 *
 * tf.diag(x).print()
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $396e859bb9bd07d1$var$diag_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'diag');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$ca73a25315ddeb7f), inputs);
}
const $396e859bb9bd07d1$export$c042e7c2f59bc046 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    diag_: $396e859bb9bd07d1$var$diag_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the grayscale dilation over the input `x`.
 *
 * @param x The input tensor, rank 3 or rank 4 of shape
 *     `[batch, height, width, depth]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter tensor, rank 3, of shape
 *     `[filterHeight, filterWidth, depth]`.
 * @param strides The strides of the sliding window for each dimension of the
 *     input tensor: `[strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat Specify the data format of the input and output data.
 *      Defaults to 'NHWC'. Only 'NHWC' is currently supported. With the
 *      default format "NHWC", the data is stored in the order of: [batch,
 *      height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     for atrous morphological dilation. Defaults to `[1, 1]`. If `dilations`
 *     is a single number, then `dilationHeight == dilationWidth`. If it is
 *     greater than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $f75f08fee6d6d2ca$var$dilation2d_(x, filter, strides, pad, dilations = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'dilation2d');
    const $filter = (0, $010a899b69412c72$export$ede379c4c939d71a)(filter, 'filter', 'dilation2d');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 3 || $x.rank === 4, ()=>`Error in dilation2d: input must be rank 3 or 4, but got rank ` + `${$x.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($filter.rank === 3, ()=>`Error in dilation2d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dataFormat === 'NHWC', ()=>`Error in dilation2d: Only NHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
        reshapedTo4D = true;
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.shape[3] === $filter.shape[2], ()=>`Error in dilation2d:  input and filter must have the same depth: ${x4D.shape[3]} vs ${$filter.shape[2]}`);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$dbbb7830c6497701), inputs, attrs);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $f75f08fee6d6d2ca$export$d9b8f675671875b9 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    dilation2d_: $f75f08fee6d6d2ca$var$dilation2d_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a == b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.equal(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $5b85025852d3ccbe$var$equal_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'equal', 'string_or_numeric');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'equal', 'string_or_numeric');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$8dcf9f58ce5cdfc), inputs);
}
const $5b85025852d3ccbe$export$411ce8e5a71e3069 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    equal_: $5b85025852d3ccbe$var$equal_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the elements, either `a` or `b` depending on the `condition`.
 *
 * If the condition is true, select from `a`, otherwise select from `b`.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const a = tf.tensor1d([1 , 2, 3]);
 * const b = tf.tensor1d([-1, -2, -3]);
 *
 * a.where(cond, b).print();
 * ```
 *
 * @param condition The input condition. Must be of dtype bool.
 * @param a If `condition` is rank 1, `a` may have a higher rank but
 *     its first dimension must match the size of `condition`.
 * @param b A tensor with the same dtype as `a` and with shape that is
 *     compatible with `a`.
 * @return A tensor with same dtype as `a` and `b`, and shape that is
 *     broadcastable from `a` and `b`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $f5215ba964de19ce$var$where_(condition, a, b) {
    const $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'where');
    const $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'where');
    const $condition = (0, $010a899b69412c72$export$ede379c4c939d71a)(condition, 'condition', 'where', 'bool');
    // TODO: move this logic to forward function when the broadcastTo op is
    // implemented in WASM.
    // Find the broadcastable shape for $condition, $a, and $b.
    const broadcastShape = (0, $642a122b4608acc0$export$a3e2a38a57ec8318)((0, $642a122b4608acc0$export$a3e2a38a57ec8318)($condition.shape, $a.shape), $b.shape);
    const $broadcastedCondition = (0, $7737f62f876bfd57$export$ec9086aff2624eab)($condition, broadcastShape);
    const $broadcastedA = (0, $7737f62f876bfd57$export$ec9086aff2624eab)($a, broadcastShape);
    const $broadcastedB = (0, $7737f62f876bfd57$export$ec9086aff2624eab)($b, broadcastShape);
    const inputs = {
        condition: $broadcastedCondition,
        t: $broadcastedA,
        e: $broadcastedB
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$ef9b1a59e592288f), inputs);
}
const $f5215ba964de19ce$export$9c59b80dda569a6e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    where_: $f5215ba964de19ce$var$where_
});



/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting. Return 0
 * if denominator is 0.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 * const c = tf.tensor1d([0, 0, 0, 0]);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 * const c = tf.scalar(0);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $27c0bba8a735dbc2$var$divNoNan_(a, b) {
    // TODO: Make this into its own kernel.
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'div');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'div');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    const divResult = (0, $15928a4fee5ff81f$export$159d9494db57879b)($a, $b);
    const zeros = (0, $64c118098861f580$export$cb1f824e7733584d)(divResult);
    const bEqualsZero = (0, $5b85025852d3ccbe$export$411ce8e5a71e3069)($b, zeros);
    return (0, $f5215ba964de19ce$export$9c59b80dda569a6e)(bEqualsZero, zeros, divResult);
}
const $27c0bba8a735dbc2$export$9c5df3eb9e56f19e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    divNoNan_: $27c0bba8a735dbc2$var$divNoNan_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the dot product of two matrices and/or vectors, `t1` and `t2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor2d([[1, 2], [3, 4]]);
 * const c = tf.tensor2d([[1, 2, 3], [4, 5, 6]]);
 *
 * a.dot(b).print();  // or tf.dot(a, b)
 * b.dot(a).print();
 * b.dot(c).print();
 * ```
 * @param t1 The first tensor in the dot operation.
 * @param t2 The second tensor in the dot operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $475e1bc880e1fa62$var$dot_(t1, t2) {
    const $t1 = (0, $010a899b69412c72$export$ede379c4c939d71a)(t1, 't1', 'dot');
    const $t2 = (0, $010a899b69412c72$export$ede379c4c939d71a)(t2, 't2', 'dot');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(($t1.rank === 1 || $t1.rank === 2) && ($t2.rank === 1 || $t2.rank === 2), ()=>`Error in dot: inputs must all be rank 1 or 2, but got ranks ` + `${$t1.rank} and ${$t2.rank}.`);
    const t1Inner = $t1.rank === 1 ? $t1.size : $t1.shape[1];
    const t2Inner = $t2.rank === 1 ? $t2.size : $t2.shape[0];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(t1Inner === t2Inner, ()=>`Error in dot: inner dimensions of inputs must match, but got ` + `${t1Inner} and ${t2Inner}.`);
    if ($t1.rank === 1 && $t2.rank === 1) {
        const t12D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(t12D, t22D);
        return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(t1t2, []);
    } else if ($t1.rank === 1 && $t2.rank === 2) {
        const t12D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(t12D, t22D);
        return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(t1t2, [
            t1t2.size
        ]);
    } else if ($t1.rank === 2 && $t2.rank === 1) {
        const t22D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)($t1, t22D);
        return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(t1t2, [
            t1t2.size
        ]);
    } else {
        const t22D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)($t1, t22D);
        return t1t2;
    }
}
const $475e1bc880e1fa62$export$94132a0e348806d4 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    dot_: $475e1bc880e1fa62$var$dot_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $0fe351921eebd33a$export$f6fde01e521435e1(equation, ...tensors) {
    const $tensors = tensors.map((t, i)=>(0, $010a899b69412c72$export$ede379c4c939d71a)(t, `tensors${i}`, 'einsum'));
    const attrs = {
        equation: equation
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$2541d8be32f3c641), $tensors, attrs);
}
const $0fe351921eebd33a$export$27265e7daac5c403 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    einsum_: $0fe351921eebd33a$export$f6fde01e521435e1
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes exponential linear element-wise: `x > 0 ? x : (e ^ x) - 1`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 1, -3, 2]);
 *
 * x.elu().print();  // or tf.elu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5c36ca87265596d3$var$elu_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'elu', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$64636e173424d83d), inputs);
}
const $5c36ca87265596d3$export$796b583dd79d8524 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    elu_: $5c36ca87265596d3$var$elu_
});


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * Checks the input tensor mathes the given shape.
 *
 * Given an input tensor, returns a new tensor with the same values as the
 * input tensor with shape `shape`.
 *
 * The method supports the null value in tensor. It will still check the shapes,
 * and null is a placeholder.
 *
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const y = tf.tensor1d([1, null, 3, 4]);
 * const z = tf.tensor2d([1, 2, 3, 4], [2,2]);
 * tf.ensureShape(x, [4]).print();
 * tf.ensureShape(y, [4]).print();
 * tf.ensureShape(z, [null, 2]).print();
 * ```
 *
 * @param x The input tensor to be ensured.
 * @param shape A TensorShape representing the shape of this tensor, an array
 *     or null.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $60ee51dd648d18e0$var$ensureShape_(x, shape) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'ensureShape', 'string_or_numeric');
    if (!(0, $5f8d0ee7a8d35dfe$export$9efb31c074e61de7)($x.shape, shape)) throw new Error(`EnsureShape: Shape of tensor ${$x.shape} is not compatible with expected shape ${shape}`);
    return x;
}
const $60ee51dd648d18e0$export$6699c34d603c5978 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    ensureShape_: $60ee51dd648d18e0$var$ensureShape_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes Gauss error function of the input `tf.Tensor` element-wise:
 * `erf(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.erf().print(); // or tf.erf(x);
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $27da37b0d1c5f650$var$erf_(x) {
    let $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'erf');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.dtype === 'int32' || $x.dtype === 'float32', ()=>'Input dtype must be `int32` or `float32`.');
    if ($x.dtype === 'int32') $x = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($x, 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c2ee2551ce71f1d0), inputs);
}
const $27da37b0d1c5f650$export$d3896f355fc09423 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    erf_: $27da37b0d1c5f650$var$erf_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $554f394697e806e8$exports = {};

$parcel$export($554f394697e806e8$exports, "norm", () => $554f394697e806e8$export$1991ecd29cc92c6b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


var $f36081d4d230c419$exports = {};

$parcel$export($f36081d4d230c419$exports, "axesAreInnerMostDims", () => $f36081d4d230c419$export$fcf762ecdaba1fc1);
$parcel$export($f36081d4d230c419$exports, "combineLocations", () => $f36081d4d230c419$export$6cfee5a53150f612);
$parcel$export($f36081d4d230c419$exports, "computeOutAndReduceShapes", () => $f36081d4d230c419$export$68ecd7df33283881);
$parcel$export($f36081d4d230c419$exports, "expandShapeToKeepDim", () => $f36081d4d230c419$export$e35db9afe008d7e3);
$parcel$export($f36081d4d230c419$exports, "assertAxesAreInnerMostDims", () => $f36081d4d230c419$export$f83b6b93f3b44c9c);
$parcel$export($f36081d4d230c419$exports, "getAxesPermutation", () => $f36081d4d230c419$export$d2a6288eef79b310);
$parcel$export($f36081d4d230c419$exports, "getUndoAxesPermutation", () => $f36081d4d230c419$export$2975b40e45f30ba8);
$parcel$export($f36081d4d230c419$exports, "getInnerMostAxes", () => $f36081d4d230c419$export$b62922ed36931ab6);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $f36081d4d230c419$export$fcf762ecdaba1fc1(axes, rank) {
    for(let i = 0; i < axes.length; ++i){
        if (axes[axes.length - i - 1] !== rank - 1 - i) return false;
    }
    return true;
}
function $f36081d4d230c419$export$6cfee5a53150f612(outputLoc, reduceLoc, axes) {
    const rank = outputLoc.length + reduceLoc.length;
    const loc = [];
    let outIdx = 0;
    let reduceIdx = 0;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) loc.push(outputLoc[outIdx++]);
    else loc.push(reduceLoc[reduceIdx++]);
    return loc;
}
function $f36081d4d230c419$export$68ecd7df33283881(aShape, axes) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) outShape.push(aShape[dim]);
    const reduceShape = axes.map((dim)=>aShape[dim]);
    return [
        outShape,
        reduceShape
    ];
}
function $f36081d4d230c419$export$e35db9afe008d7e3(shape, axes) {
    const reduceSubShape = axes.map((x)=>1);
    return $f36081d4d230c419$export$6cfee5a53150f612(shape, reduceSubShape, axes);
}
function $f36081d4d230c419$export$f83b6b93f3b44c9c(msg, axes, rank) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($f36081d4d230c419$export$fcf762ecdaba1fc1(axes, rank), ()=>`${msg} supports only inner-most axes for now. ` + `Got axes ${axes} and rank-${rank} input.`);
}
function $f36081d4d230c419$export$d2a6288eef79b310(axes, rank) {
    if ($f36081d4d230c419$export$fcf762ecdaba1fc1(axes, rank)) return null;
    const result = [];
    for(let i = 0; i < rank; ++i)if (axes.indexOf(i) === -1) result.push(i);
    axes.forEach((axis)=>result.push(axis));
    return result;
}
function $f36081d4d230c419$export$2975b40e45f30ba8(axes) {
    return axes.map((axis, i)=>[
            i,
            axis
        ]).sort((a, b)=>a[1] - b[1]).map((x)=>x[0]);
}
function $f36081d4d230c419$export$b62922ed36931ab6(numAxes, rank) {
    const res = [];
    for(let i = rank - numAxes; i < rank; ++i)res.push(i);
    return res;
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the maximum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.max().print();  // or tf.max(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.max(axis).print();  // or tf.max(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $00fa62f8df8ea40d$var$max_(x, axis = null, keepDims = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'max');
    const inputs = {
        x: $x
    };
    const attrs = {
        reductionIndices: axis,
        keepDims: keepDims
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$d36c09e5d02927e7), inputs, attrs);
}
const $00fa62f8df8ea40d$export$8960430cfd85939f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    max_: $00fa62f8df8ea40d$var$max_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the minimum value from the input.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axes`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axes` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.min().print();  // or tf.min(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.min(axis).print();  // or tf.min(x, axis)
 * ```
 *
 * @param x The input Tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $b5449d8a4698bd43$var$min_(x, axis = null, keepDims = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'min');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$dfed19fabc75a31d), inputs, attrs);
}
const $b5449d8a4698bd43$export$96ec731ed4dcb222 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    min_: $b5449d8a4698bd43$var$min_
});








/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the sum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If axes has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.sum().print();  // or tf.sum(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.sum(axis).print();  // or tf.sum(x, axis)
 * ```
 *
 * @param x The input tensor to compute the sum over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $7215cb99724b7643$var$sum_(x, axis = null, keepDims = false) {
    let $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'sum');
    if ($x.dtype === 'bool') $x = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$534760f50726d5), inputs, attrs);
}
const $7215cb99724b7643$export$8a63f25cc62965f1 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sum_: $7215cb99724b7643$var$sum_
});


/**
 * Computes the norm of scalar, vectors, and matrices.
 * This function can compute several different vector norms (the 1-norm, the
 * Euclidean or 2-norm, the inf-norm, and in general the p-norm for p > 0)
 * and matrix norms (Frobenius, 1-norm, and inf-norm).
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.norm().print();  // or tf.norm(x)
 * ```
 *
 * @param x The input array.
 * @param ord Optional. Order of the norm. Supported norm types are
 * following:
 *
 *  | ord        | norm for matrices         | norm for vectors
 *  |------------|---------------------------|---------------------
 *  |'euclidean' |Frobenius norm             |2-norm
 *  |'fro'       |Frobenius norm	           |
 *  |Infinity    |max(sum(abs(x), axis=1))   |max(abs(x))
 *  |-Infinity   |min(sum(abs(x), axis=1))   |min(abs(x))
 *  |1           |max(sum(abs(x), axis=0))   |sum(abs(x))
 *  |2           |                           |sum(abs(x)^2)^(1/2)
 *
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. norm(x, ord) is equivalent
 * to norm(x.reshape([-1]), ord). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $554f394697e806e8$var$norm_(x, ord = 'euclidean', axis = null, keepDims = false) {
    x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'norm');
    const norm = $554f394697e806e8$var$normImpl(x, ord, axis);
    let keepDimsShape = norm.shape;
    if (keepDims) {
        const axes = (0, $5f8d0ee7a8d35dfe$export$72b84eb9fe1f482)(axis, x.shape);
        keepDimsShape = $f36081d4d230c419$export$e35db9afe008d7e3(norm.shape, axes);
    }
    return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(norm, keepDimsShape);
}
function $554f394697e806e8$var$normImpl(x, p, axis = null) {
    if (x.rank === 0) return (0, $551d87f9cd40f29c$export$2335f513bbd82c6d)(x);
    // consider vector when no axis is specified
    if (x.rank !== 1 && axis === null) return $554f394697e806e8$var$normImpl((0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(x, [
        -1
    ]), p, axis);
    // vector
    if (x.rank === 1 || typeof axis === 'number' || Array.isArray(axis) && axis.length === 1) {
        if (p === 1) return (0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $551d87f9cd40f29c$export$2335f513bbd82c6d)(x), axis);
        if (p === Infinity) return (0, $00fa62f8df8ea40d$export$8960430cfd85939f)((0, $551d87f9cd40f29c$export$2335f513bbd82c6d)(x), axis);
        if (p === -Infinity) return (0, $b5449d8a4698bd43$export$96ec731ed4dcb222)((0, $551d87f9cd40f29c$export$2335f513bbd82c6d)(x), axis);
        if (p === 'euclidean' || p === 2) // norm(x, 2) = sum(abs(xi) ^ 2) ^ 1/2
        return (0, $d8742a69331de610$export$eba8049fb5020b81)((0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $76ec324d3dfd83d3$export$9c297f60e22e3389)((0, $551d87f9cd40f29c$export$2335f513bbd82c6d)(x), (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(2, 'int32')), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    // matrix (assumption axis[0] < axis[1])
    if (Array.isArray(axis) && axis.length === 2) {
        if (p === 1) return (0, $00fa62f8df8ea40d$export$8960430cfd85939f)((0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $551d87f9cd40f29c$export$2335f513bbd82c6d)(x), axis[0]), axis[1] - 1);
        if (p === Infinity) return (0, $00fa62f8df8ea40d$export$8960430cfd85939f)((0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $551d87f9cd40f29c$export$2335f513bbd82c6d)(x), axis[1]), axis[0]);
        if (p === -Infinity) return (0, $b5449d8a4698bd43$export$96ec731ed4dcb222)((0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $551d87f9cd40f29c$export$2335f513bbd82c6d)(x), axis[1]), axis[0]);
        if (p === 'fro' || p === 'euclidean') // norm(x) = sqrt(sum(pow(x, 2)))
        return (0, $d8742a69331de610$export$eba8049fb5020b81)((0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $03801900ae8a72ab$export$dd4f28cef696bc7d)(x), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    throw new Error(`Error in norm: invalid axis: ${axis}`);
}
const $554f394697e806e8$export$1991ecd29cc92c6b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    norm_: $554f394697e806e8$var$norm_
});



/**
 * Computes the Euclidean norm of scalar, vectors, and matrices.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.euclideanNorm().print();  // or tf.euclideanNorm(x)
 * ```
 *
 * @param x The input array.
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. euclideanNorm(x) is equivalent
 * to euclideanNorm(x.reshape([-1])). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $383d98731541f461$var$euclideanNorm_(x, axis = null, keepDims = false) {
    return (0, $554f394697e806e8$export$1991ecd29cc92c6b)(x, 'euclidean', axis, keepDims);
}
const $383d98731541f461$export$38d83b337e7c2edd = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    euclideanNorm_: $383d98731541f461$var$euclideanNorm_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes exponential of the input `tf.Tensor` element-wise. `e ^ x`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.exp().print();  // or tf.exp(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $20ea4fdf69fd4a26$var$exp_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'exp');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$f908be7a96fb3363), inputs);
}
const $20ea4fdf69fd4a26$export$b310ec824aaee37f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    exp_: $20ea4fdf69fd4a26$var$exp_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Returns a `tf.Tensor` that has expanded rank, by inserting a dimension
 * into the tensor's shape.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const axis = 1;
 * x.expandDims(axis).print();
 * ```
 *
 * @param x The input tensor whose dimensions are to be expanded.
 * @param axis The dimension index at which to insert shape of `1`. Defaults
 *     to 0 (the first dimension).
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $db5bfab98435c6cf$var$expandDims_(x, axis = 0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'expandDims', 'string_or_numeric');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(axis <= $x.rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = {
        input: $x
    };
    const attrs = {
        dim: axis
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$2391750b1d901146), inputs, attrs);
}
const $db5bfab98435c6cf$export$d660d8ed21f46635 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    expandDims_: $db5bfab98435c6cf$var$expandDims_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes exponential of the input `tf.Tensor` minus one element-wise.
 * `e ^ x - 1`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.expm1().print();  // or tf.expm1(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $966280c1f426de32$var$expm1_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'expm1');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$261f26143a1ff3), inputs);
}
const $966280c1f426de32$export$b6c0a80d46d3391d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    expm1_: $966280c1f426de32$var$expm1_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Construct a tensor by repeating it the number of times given by reps.
 *
 * This operation creates a new tensor by replicating `input` `reps`
 * times. The output tensor's `i`th dimension has `input.shape[i] *
 * reps[i]` elements, and the values of `input` are replicated
 * `reps[i]` times along the `i`th dimension. For example, tiling
 * `[a, b, c, d]` by `[2]` produces `[a, b, c, d, a, b, c, d]`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 *
 * a.tile([2]).print();    // or tf.tile(a, [2])
 * ```
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.tile([1, 2]).print();  // or tf.tile(a, [1,2])
 * ```
 * @param x The tensor to tile.
 * @param reps Determines the number of replications per dimension.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $461b04d030518b80$var$tile_(x, reps) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'tile', 'string_or_numeric');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === reps.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of reps ${reps}.`);
    const inputs = {
        x: $x
    };
    const attrs = {
        reps: reps
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$235cb65c20ad2b7), inputs, attrs);
}
const $461b04d030518b80$export$3c17558da18e4d75 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    tile_: $461b04d030518b80$var$tile_
});


/**
 * Create an identity matrix.
 *
 * @param numRows Number of rows.
 * @param numColumns Number of columns. Defaults to `numRows`.
 * @param batchShape If provided, will add the batch shape to the beginning
 *   of the shape of the returned `tf.Tensor` by repeating the identity
 *   matrix.
 * @param dtype Data type.
 * @returns Identity matrix of the specified size and data type, possibly
 *   with batch repetition if `batchShape` is specified.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $6bf880f08dec68a4$var$eye_(numRows, numColumns, batchShape, dtype = 'float32') {
    if (numColumns == null) numColumns = numRows;
    const buff = (0, $d99273e33e31a4d2$export$ab1029bcae9ddb4a)([
        numRows,
        numColumns
    ], dtype);
    const n = numRows <= numColumns ? numRows : numColumns;
    for(let i = 0; i < n; ++i)buff.set(1, i, i);
    const out = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(buff.toTensor(), [
        numRows,
        numColumns
    ]);
    if (batchShape == null) return out;
    else {
        if (batchShape.length === 1) return (0, $461b04d030518b80$export$3c17558da18e4d75)((0, $db5bfab98435c6cf$export$d660d8ed21f46635)(out, 0), [
            batchShape[0],
            1,
            1
        ]);
        else if (batchShape.length === 2) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $461b04d030518b80$export$3c17558da18e4d75)((0, $db5bfab98435c6cf$export$d660d8ed21f46635)((0, $db5bfab98435c6cf$export$d660d8ed21f46635)(out, 0), 0), [
            batchShape[0],
            batchShape[1],
            1,
            1
        ]);
        else if (batchShape.length === 3) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $461b04d030518b80$export$3c17558da18e4d75)((0, $db5bfab98435c6cf$export$d660d8ed21f46635)((0, $db5bfab98435c6cf$export$d660d8ed21f46635)((0, $db5bfab98435c6cf$export$d660d8ed21f46635)(out, 0), 0), 0), [
            batchShape[0],
            batchShape[1],
            batchShape[2],
            1,
            1
        ]);
        else throw new Error(`eye() currently supports only 1D and 2D ` + // tslint:disable-next-line:no-any
        `batchShapes, but received ${batchShape.length}D.`);
    }
}
const $6bf880f08dec68a4$export$4e18cf730a59887e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    eye_: $6bf880f08dec68a4$var$eye_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes floor of input `tf.Tensor` element-wise: `floor(x)`.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.floor().print();  // or tf.floor(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $3a38c7b29dbfd7e8$var$floor_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'floor', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$4880b0ae5643c62b), inputs);
}
const $3a38c7b29dbfd7e8$export$a3fe094919f356fd = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    floor_: $3a38c7b29dbfd7e8$var$floor_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Gather slices from tensor `x`'s axis `axis` according to `indices`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const indices = tf.tensor1d([1, 3, 3], 'int32');
 *
 * x.gather(indices).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const indices = tf.tensor1d([1, 1, 0], 'int32');
 *
 * x.gather(indices).print();
 * ```
 * @param x The input tensor whose slices are to be gathered.
 * @param indices The indices of the values to extract.
 * @param axis The axis over which to select values. Defaults to 0.
 * @param batchDims Optional. The number of batch dimensions. It must be less
 *     than or equal to rank(indices). Defaults to 0.
 *     The output tensor will have shape of
 *     `x.shape[:axis] + indices.shape[batchDims:] + x.shape[axis + 1:]`
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $27ff7ccdc5033e17$var$gather_(x, indices, axis = 0, batchDims = 0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'gather');
    const $indices = (0, $010a899b69412c72$export$ede379c4c939d71a)(indices, 'indices', 'gather', 'int32');
    const inputs = {
        x: $x,
        indices: $indices
    };
    const attrs = {
        axis: axis,
        batchDims: batchDims
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$ccd988942e5c0181), inputs, attrs);
}
const $27ff7ccdc5033e17$export$9e05546f00427e8 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    gather_: $27ff7ccdc5033e17$var$gather_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a > b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greater(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $8a3e558d5bb76a4c$var$greater_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'greater', 'string_or_numeric');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'greater', 'string_or_numeric');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$d0a25eac5ee3f515), inputs);
}
const $8a3e558d5bb76a4c$export$9dca161faaf6308b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    greater_: $8a3e558d5bb76a4c$var$greater_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a >= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greaterEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $f4c954f893cb9ce6$var$greaterEqual_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'greaterEqual', 'string_or_numeric');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'greaterEqual', 'string_or_numeric');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$3b7d21bc9aee0851), inputs);
}
const $f4c954f893cb9ce6$export$c2fd4164cadc1fa2 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    greaterEqual_: $f4c954f893cb9ce6$var$greaterEqual_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns which elements of x are finite.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isFinite().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $a521efe7e5aac3f8$var$isFinite_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'isFinite');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$b9fcc0946d7d485e), inputs);
}
const $a521efe7e5aac3f8$export$65f0b13f2f82375a = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    isFinite_: $a521efe7e5aac3f8$var$isFinite_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns which elements of x are Infinity or -Infinity.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isInf().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $77bae48f55795afc$var$isInf_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'isInf');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$74b5a3bc735b152), inputs);
}
const $77bae48f55795afc$export$e5d3415c656f7096 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    isInf_: $77bae48f55795afc$var$isInf_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns which elements of x are NaN.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isNaN().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $42028cbc7490170f$var$isNaN_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'isNaN');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$9912dc4fc649dbec), inputs);
}
const $42028cbc7490170f$export$c9f5652083b8129d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    isNaN_: $42028cbc7490170f$var$isNaN_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes leaky rectified linear element-wise.
 *
 * See
 * [http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf](
 *     http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf)
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.leakyRelu(0.1).print();  // or tf.leakyRelu(x, 0.1)
 * ```
 * @param x The input tensor.
 * @param alpha The scaling factor for negative values, defaults to 0.2.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $2e1cdcc1e07e834e$var$leakyRelu_(x, alpha = 0.2) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'leakyRelu');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$f0c7162bb7af1a2d), inputs, attrs);
}
const $2e1cdcc1e07e834e$export$23a860e40a2c6b61 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    leakyRelu_: $2e1cdcc1e07e834e$var$leakyRelu_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a < b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.less(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $e7c220a817a7d6b0$var$less_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'less', 'string_or_numeric');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'less', 'string_or_numeric');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$728c50f1c88ac779), inputs);
}
const $e7c220a817a7d6b0$export$bb1a638da8ad190f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    less_: $e7c220a817a7d6b0$var$less_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a <= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.lessEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $5a854c2455432f6a$var$lessEqual_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'lessEqual', 'string_or_numeric');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'lessEqual', 'string_or_numeric');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$84afd0d8f7fb8c5d), inputs);
}
const $5a854c2455432f6a$export$c24ad19a692bb92 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    lessEqual_: $5a854c2455432f6a$var$lessEqual_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $6d3d63bd566c765a$export$71255ea3f595147c(start, stop, num) {
    if (num <= 0) throw new Error('The number of values should be positive.');
    const attrs = {
        start: start,
        stop: stop,
        num: num
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$34f0ab8eba543ee6), {}, attrs);
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Normalizes the activation of a local neighborhood across or within
 * channels.
 *
 * @param x The input tensor. The 4-D input tensor is treated as a 3-D array
 *     of 1D vectors (along the last dimension), and each vector is
 *     normalized independently.
 * @param depthRadius The number of adjacent channels in the 1D normalization
 *     window.
 * @param bias A constant bias term for the basis.
 * @param alpha A scale factor, usually positive.
 * @param beta An exponent.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $ea92d98dece5e886$var$localResponseNormalization_(x, depthRadius = 5, bias = 1, alpha = 1, beta = 0.5) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'localResponseNormalization');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 4 || $x.rank === 3, ()=>`Error in localResponseNormalization: x must be rank 3 or 4 but got
               rank ${$x.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$357fc28f6427af8b(depthRadius), ()=>`Error in localResponseNormalization: depthRadius must be an ` + `integer but got depthRadius ${depthRadius}.`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    const inputs = {
        x: x4D
    };
    const attrs = {
        depthRadius: depthRadius,
        bias: bias,
        alpha: alpha,
        beta: beta
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$eb2f713fc3e1ca9a), inputs, attrs);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    else return res;
}
const $ea92d98dece5e886$export$b6127073705f6321 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    localResponseNormalization_: $ea92d98dece5e886$var$localResponseNormalization_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes natural logarithm of the input `tf.Tensor` element-wise: `ln(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E]);
 *
 * x.log().print();  // or tf.log(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $99bf7e02d49647cf$var$log_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'log', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$ce30dbb46644d06c), inputs);
}
const $99bf7e02d49647cf$export$bef1f36f5486a6a3 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    log_: $99bf7e02d49647cf$var$log_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes natural logarithm of the input `tf.Tensor` plus one
 * element-wise: `ln(1 + x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E - 1]);
 *
 * x.log1p().print();  // or tf.log1p(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $442dfe97b70d73dc$var$log1p_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'log1p');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$70f05bf9ddcfca68), inputs);
}
const $442dfe97b70d73dc$export$144dcf16adfb9698 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    log1p_: $442dfe97b70d73dc$var$log1p_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes softplus of the input `tf.Tensor` element-wise: `log(exp(x) + 1)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.softplus().print();  // or tf.softplus(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $3926ca7a31ecf655$var$softplus_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'softplus');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c5af433747f1fd0a), inputs);
}
const $3926ca7a31ecf655$export$76aa560a8c2b0055 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    softplus_: $3926ca7a31ecf655$var$softplus_
});


/**
 * Computes log sigmoid of the input `tf.Tensor` element-wise:
 * `logSigmoid(x)`. For numerical stability, we use `-tf.softplus(-x)`.
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.logSigmoid().print();  // or tf.logSigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $54e8d955c4d71e65$var$logSigmoid_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'logSigmoid');
    // Use a custom gradient to maintain previous implementation.
    // There is no LogSigmoid kernel in TF so we can't use engine.runKernel
    // directly
    const customOp = (0, $694041655139423f$export$5519f0eeb00c44e5)((x)=>{
        // TODO(yassogba) we can remove the chained softplus call here only
        // after backends have modualrized softplus at which point we can call
        // engine runKernel(..., Sotfplus, ...) directly.
        const value = (0, $0ca018ac52410371$export$d9493ff0dfa0fdd5)((0, $3926ca7a31ecf655$export$76aa560a8c2b0055)((0, $0ca018ac52410371$export$d9493ff0dfa0fdd5)(x)));
        const gradFunc = (dy)=>{
            const derX = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(dy, (0, $e3381678584872cc$export$3b295495ca3cad7c)((0, $0ca018ac52410371$export$d9493ff0dfa0fdd5)(x)));
            return derX;
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($x);
}
const $54e8d955c4d71e65$export$9e0b8feed033df47 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    logSigmoid_: $54e8d955c4d71e65$var$logSigmoid_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 









/**
 * Computes the log softmax.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param axis The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $20a7e47c51889579$var$logSoftmax_(logits, axis = -1) {
    const $logits = (0, $010a899b69412c72$export$ede379c4c939d71a)(logits, 'logits', 'logSoftmax');
    if (axis === -1) axis = $logits.rank - 1;
    if (axis !== $logits.rank - 1) throw Error('Log Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and axis was ${axis}`);
    // const forward: ForwardFunc<Tensor> = (backend, save) => {
    //   const keepDims = true;
    //   const xMax = max(logits, axis, true);
    //   const shifted = sub(logits, xMax);
    //   const value =
    //       sub(cast(shifted, 'float32'), log(sum(exp(shifted), axis,
    //       keepDims)));
    //   save([value]);
    //   return value;
    // };
    // Use a custom gradient for numerical stability.
    const customOp = (0, $694041655139423f$export$5519f0eeb00c44e5)((logits, save)=>{
        const keepDims = true;
        const xMax = (0, $00fa62f8df8ea40d$export$8960430cfd85939f)(logits, axis, true);
        const shifted = (0, $555d660851b98db3$export$f93b5905241a7cca)(logits, xMax);
        const value = (0, $555d660851b98db3$export$f93b5905241a7cca)((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(shifted, 'float32'), (0, $99bf7e02d49647cf$export$bef1f36f5486a6a3)((0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $20ea4fdf69fd4a26$export$b310ec824aaee37f)(shifted), axis, keepDims)));
        save([
            value
        ]);
        const gradFunc = (dy, saved)=>{
            const [value] = saved;
            const keepDims = true;
            const softmax = (0, $20ea4fdf69fd4a26$export$b310ec824aaee37f)(value);
            return (0, $555d660851b98db3$export$f93b5905241a7cca)(dy, (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $7215cb99724b7643$export$8a63f25cc62965f1)(dy, axis, keepDims), softmax));
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($logits);
// TODO Use Engine.runKernel when CPU/WebGL/WASM backends implement this.
// const inputs: LogSoftmaxInputs = {logits: $logits};
// const attrs: LogSoftmaxAttrs = {axis};
// return ENGINE.runKernel(
//            LogSoftmax, inputs as unknown as NamedTensorMap,
//            attrs as unknown as NamedAttrMap);
}
const $20a7e47c51889579$export$676379a046a2e437 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    logSoftmax_: $20a7e47c51889579$var$logSoftmax_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 










/**
 * Computes the log(sum(exp(elements across the reduction dimensions))).
 *
 * Reduces the input along the dimensions given in `axis`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.logSumExp().print();  // or tf.logSumExp(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.logSumExp(axis).print();  // or tf.logSumExp(a, axis)
 * ```
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. If null (the default),
 *     reduces all dimensions.
 * @param keepDims If true, retains reduced dimensions with length
 *     of 1. Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $6b6676f787cc0273$var$logSumExp_(x, axis = null, keepDims = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'logSumExp');
    const axes = (0, $5f8d0ee7a8d35dfe$export$72b84eb9fe1f482)(axis, $x.shape);
    const xMax = (0, $00fa62f8df8ea40d$export$8960430cfd85939f)($x, axes, true);
    const a = (0, $555d660851b98db3$export$f93b5905241a7cca)($x, xMax);
    const b = (0, $20ea4fdf69fd4a26$export$b310ec824aaee37f)(a);
    const c = (0, $7215cb99724b7643$export$8a63f25cc62965f1)(b, axes);
    const d = (0, $99bf7e02d49647cf$export$bef1f36f5486a6a3)(c);
    const res = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(xMax, d.shape), d);
    if (keepDims) {
        const newShape = (0, $f36081d4d230c419$export$e35db9afe008d7e3)(res.shape, axes);
        return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, newShape);
    }
    return res;
}
const $6b6676f787cc0273$export$e20aca1e89397787 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    logSumExp_: $6b6676f787cc0273$var$logSumExp_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Returns the truth value of `a AND b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalAnd(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $ebf6cebe68ef2a79$var$logicalAnd_(a, b) {
    const $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'logicalAnd', 'bool');
    const $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'logicalAnd', 'bool');
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$8a27ff10dff4d6e5), inputs);
}
const $ebf6cebe68ef2a79$export$db5dd0ef9d505f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    logicalAnd_: $ebf6cebe68ef2a79$var$logicalAnd_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns the truth value of `NOT x` element-wise.
 *
 * ```js
 * const a = tf.tensor1d([false, true], 'bool');
 *
 * a.logicalNot().print();
 * ```
 *
 * @param x The input tensor. Must be of dtype 'bool'.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $5aea02d79d421e58$var$logicalNot_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'logicalNot', 'bool');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$4393bee5596c68c2), inputs);
}
const $5aea02d79d421e58$export$c836ff7b605b1617 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    logicalNot_: $5aea02d79d421e58$var$logicalNot_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Returns the truth value of `a OR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalOr(b).print();
 * ```
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $d63a04143271ccd2$var$logicalOr_(a, b) {
    const $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'logicalOr', 'bool');
    const $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'logicalOr', 'bool');
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c49f9f5ffc6f678c), inputs);
}
const $d63a04143271ccd2$export$e2a73975983cadd8 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    logicalOr_: $d63a04143271ccd2$var$logicalOr_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of `a XOR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalXor(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $d9ff197708e7fc0d$var$logicalXor_(a, b) {
    const $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'logicalXor', 'bool');
    const $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'logicalXor', 'bool');
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    // x ^ y = (x | y) & ~(x & y)
    return (0, $ebf6cebe68ef2a79$export$db5dd0ef9d505f)((0, $d63a04143271ccd2$export$e2a73975983cadd8)(a, b), (0, $5aea02d79d421e58$export$c836ff7b605b1617)((0, $ebf6cebe68ef2a79$export$db5dd0ef9d505f)(a, b)));
}
const $d9ff197708e7fc0d$export$20f90b62b30dbaef = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    logicalXor_: $d9ff197708e7fc0d$var$logicalXor_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $4f8d2a80bf60195c$exports = {};

$parcel$export($4f8d2a80bf60195c$exports, "searchSorted", () => $4f8d2a80bf60195c$export$56fad8d65b0adbdd);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





const $4f8d2a80bf60195c$var$INT32_MAX = 2147483648;
/**
 * Searches for where a value would go in a sorted sequence.
 *
 * This is not a method for checking containment (like javascript in).
 *
 * The typical use case for this operation is "binning", "bucketing", or
 * "discretizing". The values are assigned to bucket-indices based on the edges
 * listed in 'sortedSequence'. This operation returns the bucket-index for each
 * value.
 *
 * The side argument controls which index is returned if a value lands exactly
 * on an edge.
 *
 * The axis is not settable for this operation. It always operates on the
 * innermost dimension (axis=-1). The operation will accept any number of outer
 * dimensions.
 *
 * Note: This operation assumes that 'sortedSequence' is sorted along the
 * innermost axis, maybe using 'sort(..., axis=-1)'. If the sequence is not
 * sorted no error is raised and the content of the returned tensor is not well
 * defined.
 *
 * ```js
 * const edges = tf.tensor1d([-1, 3.3, 9.1, 10.0]);
 * let values = tf.tensor1d([0.0, 4.1, 12.0]);
 * const result1 = tf.searchSorted(edges, values, 'left');
 * result1.print(); // [1, 2, 4]
 *
 * const seq = tf.tensor1d([0, 3, 9, 10, 10]);
 * values = tf.tensor1d([0, 4, 10]);
 * const result2 = tf.searchSorted(seq, values, 'left');
 * result2.print(); // [0, 2, 3]
 * const result3 = tf.searchSorted(seq, values, 'right');
 * result3.print(); // [1, 2, 5]
 *
 * const sortedSequence = tf.tensor2d([[0., 3., 8., 9., 10.],
 *                                     [1., 2., 3., 4., 5.]]);
 * values = tf.tensor2d([[9.8, 2.1, 4.3],
 *                       [0.1, 6.6, 4.5, ]]);
 * const result4 = tf.searchSorted(sortedSequence, values, 'left');
 * result4.print(); // [[4, 1, 2], [0, 5, 4]]
 * ```
 * @param sortedSequence: N-D. Sorted sequence.
 * @param values: N-D. Search values.
 * @param side: 'left'|'right'. Defaults to 'left'. 'left' corresponds to lower
 *     bound and 'right' to upper bound.
 * @return An N-D int32 tensor the size of values containing the result of
 *     applying either lower bound or upper bound (depending on side) to each
 *     value. The result is not a global index to the entire Tensor, but the
 *     index in the last dimension.
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $4f8d2a80bf60195c$var$searchSorted_(sortedSequence, values, side = 'left') {
    const $sortedSequence = (0, $010a899b69412c72$export$ede379c4c939d71a)(sortedSequence, 'sortedSequence', 'searchSorted');
    const $values = (0, $010a899b69412c72$export$ede379c4c939d71a)(values, 'values', 'searchSorted');
    const sequenceSize = $sortedSequence.shape[$sortedSequence.shape.length - 1];
    const valuesSize = $values.shape[$values.shape.length - 1];
    const $sortedSequence2D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($sortedSequence, [
        -1,
        sequenceSize
    ]);
    const $values2D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($values, [
        -1,
        valuesSize
    ]);
    if ($sortedSequence2D.rank < 2) throw new Error(`Sorted input argument must be at least 2-dimensional`);
    if ($sortedSequence2D.shape[0] !== $values2D.shape[0]) throw new Error(`Leading dimension of 'sortedSequence' and 'values' must match.`);
    if ((0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)($values2D.shape) >= $4f8d2a80bf60195c$var$INT32_MAX) throw new Error(`values tensor size must less than ${$4f8d2a80bf60195c$var$INT32_MAX}`);
    if ($sortedSequence2D.shape[1] >= $4f8d2a80bf60195c$var$INT32_MAX) throw new Error(`trailing dim_size must less than ${$4f8d2a80bf60195c$var$INT32_MAX} for int32 output type, was ${$sortedSequence2D.shape[1]}`);
    const inputs = {
        sortedSequence: $sortedSequence2D,
        values: $values2D
    };
    const attrs = {
        side: side
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$9a1405490b09867e), inputs, attrs);
}
const $4f8d2a80bf60195c$export$56fad8d65b0adbdd = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    searchSorted_: $4f8d2a80bf60195c$var$searchSorted_
});


function $e431e62c480471c9$export$450bb71ab40039dc(sortedSequence, values) {
    return (0, $4f8d2a80bf60195c$export$56fad8d65b0adbdd)(sortedSequence, values, 'left');
}




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Computes the 2D max pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $bfa923df51c4e9fb$var$maxPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'maxPool');
    const dilations = 1;
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x4D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $b3e4d1c19b78487c$export$1b3400c26a44af8('maxPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$39ea33024ddd5cf), inputs, attrs);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $bfa923df51c4e9fb$export$e4aadcf115842782 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    maxPool_: $bfa923df51c4e9fb$var$maxPool_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Computes the 3D max pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.maxPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $c213f1d37ed322ef$var$maxPool3d_(x, filterSize = [
    1,
    1,
    1
], strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'maxPool3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x5D.rank === 5, ()=>`Error in maxPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dataFormat === 'NDHWC', ()=>`Error in maxPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    (0, $b3e4d1c19b78487c$export$1b3400c26a44af8)('maxPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$88fdc64af890fc53), inputs, attrs);
    if (reshapedTo5D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $c213f1d37ed322ef$export$822a6e53be1125f9 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    maxPool3d_: $c213f1d37ed322ef$var$maxPool3d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the 2D max pooling of an image with Argmax index.
 * The indices in argmax are flattened, so that a maximum value at position `[b,
 * y, x, c]` becomes flattened index: `(y * width + x) * channels + c` if
 * include_batch_in_index is False; `((b * height + y) * width + x) * channels
 * +c` if include_batch_in_index is True.
 *
 * The indices returned are always in `[0, height) x [0, width)` before
 * flattening.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param includeBatchIndex Defaults to False. Whether to include batch
 *    dimension in flattened index of argmax.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $7178df567939d474$var$maxPoolWithArgmax_(x, filterSize, strides, pad, includeBatchInIndex = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'maxPoolWithArgmax');
    const inputs = {
        x: $x
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        includeBatchInIndex: includeBatchInIndex
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$deac4b7497b4047f), inputs, attrs);
    return {
        result: result[0],
        indexes: result[1]
    };
}
const $7178df567939d474$export$3d8b1b819d23351e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    maxPoolWithArgmax_: $7178df567939d474$var$maxPoolWithArgmax_
});



/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the mean of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces `x` along the dimensions given in `axis`. Unless `keepDims` is
 * true, the rank of the `tf.Tensor` is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and a `tf.Tensor` with
 * a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.mean().print();  // or tf.mean(a)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.mean(axis).print();  // or tf.mean(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $475473fd3a900b08$var$mean_(x, axis = null, keepDims = false) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'mean');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$1c2d59c4b681fbd8), inputs, attrs);
}
const $475473fd3a900b08$export$1ce691f85baaa52 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    mean_: $475473fd3a900b08$var$mean_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $cc4388674ebc96d5$export$4445a00dafa2633b(shape, dtype = 'float32') {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    if (dtype === 'complex64') {
        const real = $cc4388674ebc96d5$export$4445a00dafa2633b(shape, 'float32');
        const imag = $cc4388674ebc96d5$export$4445a00dafa2633b(shape, 'float32');
        return (0, $175eb29e145dcf53$export$83a0e34f1302825b)(real, imag);
    }
    const values = (0, $5f8d0ee7a8d35dfe$export$edbc8aedac4e036f)((0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(shape), dtype);
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).makeTensor(values, shape, dtype);
}


function $b838e56973f13fe0$export$21041dee6b8001b0(shape, dtype = 'float32') {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    if (dtype === 'complex64') {
        const real = $b838e56973f13fe0$export$21041dee6b8001b0(shape, 'float32');
        const imag = (0, $cc4388674ebc96d5$export$4445a00dafa2633b)(shape, 'float32');
        return (0, $175eb29e145dcf53$export$83a0e34f1302825b)(real, imag);
    }
    const values = (0, $5f8d0ee7a8d35dfe$export$b915f681a907ae99)((0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(shape), dtype);
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).makeTensor(values, shape, dtype);
}






function $a44d90bdd666156a$export$2fab8e71e5fefc1a(x, y, { indexing: indexing = 'xy' } = {}) {
    if (indexing !== 'xy' && indexing !== 'ij') throw new TypeError(`${indexing} is not a valid third argument to meshgrid`);
    if (x === undefined) return [];
    let $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'meshgrid', x instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? x.dtype : 'float32');
    if (y === undefined) return [
        $x
    ];
    let $y = (0, $010a899b69412c72$export$ede379c4c939d71a)(y, 'y', 'meshgrid', y instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? y.dtype : 'float32');
    const w = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)($x.shape);
    const h = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)($y.shape);
    if (indexing === 'xy') {
        $x = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            -1
        ]);
        $y = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($y, [
            -1,
            1
        ]);
        return [
            (0, $7f1f3e54d78420da$export$6706882a873e9a8f)((0, $b838e56973f13fe0$export$21041dee6b8001b0)([
                h,
                1
            ], $x.dtype), $x),
            (0, $7f1f3e54d78420da$export$6706882a873e9a8f)($y, (0, $b838e56973f13fe0$export$21041dee6b8001b0)([
                1,
                w
            ], $y.dtype))
        ];
    }
    $x = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
        -1,
        1
    ]);
    $y = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($y, [
        1,
        -1
    ]);
    return [
        (0, $7f1f3e54d78420da$export$6706882a873e9a8f)($x, (0, $b838e56973f13fe0$export$21041dee6b8001b0)([
            1,
            h
        ], $x.dtype)),
        (0, $7f1f3e54d78420da$export$6706882a873e9a8f)((0, $b838e56973f13fe0$export$21041dee6b8001b0)([
            w,
            1
        ], $y.dtype), $y)
    ];
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Returns the min of a and b (`a < b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `minimumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * ```js
 * // Broadcast minimum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $509eb1d608c78c8e$var$minimum_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'minimum');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'minimum');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($a, 'int32');
        $b = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($b, 'int32');
    }
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$23cb308301e89d6b), inputs);
}
const $509eb1d608c78c8e$export$916782c1f0ddb132 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    minimum_: $509eb1d608c78c8e$var$minimum_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Pads a `tf.Tensor` using mirror padding.
 *
 * This operation implements the `REFLECT` and `SYMMETRIC` modes of pad.
 *
 * ```js
 * const x = tf.range(0, 9).reshape([1, 1, 3, 3]);
 * x.mirrorPad([[0, 0], [0, 0], [2, 2], [2, 2]], 'reflect').print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * In "reflect" mode, the padded regions do not include the borders,
 * while in "symmetric" mode the padded regions do include the borders.
 * For example, if the input is `[1, 2, 3]` and paddings is `[0, 2]`,
 * then the output is `[1, 2, 3, 2, 1]` in "reflect" mode, and
 * `[1, 2, 3, 3, 2]` in "symmetric" mode.
 * If `mode` is "reflect" then both `paddings[D, 0]` and `paddings[D, 1]`
 * must be no greater than `x.shape[D] - 1`. If mode is "symmetric"
 * then both `paddings[D, 0]` and `paddings[D, 1]` must be no greater than
 * `x.shape[D]`
 * @param mode String to specify padding mode. Can be `'reflect' | 'symmetric'`
 */ /** @doc {heading: 'Tensors', subheading: 'Transformations'} */ function $a6b3cd7f35f32ec3$var$mirrorPad_(x, paddings, mode) {
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(mode === 'reflect' || mode === 'symmetric', ()=>`Invalid mode. Mode must be either reflect or symmetric. ` + `Got ${mode}.`);
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'mirrorPad');
    if ($x.rank === 0) throw new Error("mirrorPad(scalar) is not defined. Pass non-scalar to mirrorPad");
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(paddings.length === $x.rank, ()=>`Padding doesn't match input. Must be ${$x.rank}. ` + `Got ${paddings.length}.`);
    const shapeOffset = mode === 'reflect' ? 1 : 0;
    for(let i = 0; i < $x.rank; i++){
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(paddings[i].length === 2, ()=>`Invalid number of paddings. Must be length of 2 each.`);
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(paddings[i][0] >= 0 && paddings[i][0] <= $x.shape[i] - shapeOffset && paddings[i][1] >= 0 && paddings[i][1] <= $x.shape[i] - shapeOffset, ()=>`Padding in dimension ${i} cannot be greater than or equal ` + `to ${$x.shape[i] - shapeOffset} or less than 0 for input of ` + `shape ${$x.shape}`);
    }
    const attrs = {
        paddings: paddings,
        mode: mode
    };
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$f4c0e95fd7fd31e5), inputs, attrs);
}
const $a6b3cd7f35f32ec3$export$c0b11600e90b86ae = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    mirrorPad_: $a6b3cd7f35f32ec3$var$mirrorPad_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Returns the mod of a and b element-wise.
 * `floor(x / y) * y + mod(x, y) = x`
 * Supports broadcasting.
 *
 * We also expose `tf.modStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * ```js
 * // Broadcast a mod b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $e74659ea6de4ec41$var$mod_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'mod');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'mod');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$e4835a5e3f3674d5), inputs);
}
const $e74659ea6de4ec41$export$842a2cf37af977e1 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    mod_: $e74659ea6de4ec41$var$mod_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 








/**
 * Calculates the mean and variance of `x`. The mean and variance are
 * calculated by aggregating the contents of `x` across `axes`. If `x` is
 * 1-D and `axes = [0]` this is just the mean and variance of a vector.
 *
 * @param x The input tensor.
 * @param axis The dimension(s) along with to compute mean and
 *     variance. By default it reduces all dimensions.
 * @param keepDims If true, the moments have the same dimensionality as the
 *     input.
 * @return An object with two keys: `mean` and `variance`.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $e804b403d2801180$var$moments_(x, axis = null, keepDims = false) {
    x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'moments');
    const axes = (0, $5f8d0ee7a8d35dfe$export$72b84eb9fe1f482)(axis, x.shape);
    const xMean = (0, $475473fd3a900b08$export$1ce691f85baaa52)(x, axes, keepDims);
    let keepDimsShape = xMean.shape;
    if (!keepDims) keepDimsShape = (0, $f36081d4d230c419$export$e35db9afe008d7e3)(xMean.shape, axes);
    const devSquared = (0, $03801900ae8a72ab$export$dd4f28cef696bc7d)((0, $555d660851b98db3$export$f93b5905241a7cca)((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(x, 'float32'), (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(xMean, keepDimsShape)));
    const variance = (0, $475473fd3a900b08$export$1ce691f85baaa52)(devSquared, axes, keepDims);
    return {
        mean: xMean,
        variance: variance
    };
}
const $e804b403d2801180$export$19ef085469537740 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    moments_: $e804b403d2801180$var$moments_
});





/**
 * Computes the next states and outputs of a stack of LSTMCells.
 *
 * Each cell output is used as input to the next cell.
 *
 * Returns `[cellState, cellOutput]`.
 *
 * Derived from tf.contrib.rn.MultiRNNCell.
 *
 * @param lstmCells Array of LSTMCell functions.
 * @param data The input to the cell.
 * @param c Array of previous cell states.
 * @param h Array of previous cell outputs.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $917954a7b3cdf6bb$var$multiRNNCell_(lstmCells, data, c, h) {
    const $data = (0, $010a899b69412c72$export$ede379c4c939d71a)(data, 'data', 'multiRNNCell');
    const $c = (0, $010a899b69412c72$export$758e66616b4d410b)(c, 'c', 'multiRNNCell');
    const $h = (0, $010a899b69412c72$export$758e66616b4d410b)(h, 'h', 'multiRNNCell');
    let input = $data;
    const newStates = [];
    for(let i = 0; i < lstmCells.length; i++){
        const output = lstmCells[i](input, $c[i], $h[i]);
        newStates.push(output[0]);
        newStates.push(output[1]);
        input = output[1];
    }
    const newC = [];
    const newH = [];
    for(let i = 0; i < newStates.length; i += 2){
        newC.push(newStates[i]);
        newH.push(newStates[i + 1]);
    }
    return [
        newC,
        newH
    ];
}
const $917954a7b3cdf6bb$export$cc05b5217b9b924f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    multiRNNCell_: $917954a7b3cdf6bb$var$multiRNNCell_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Creates a `tf.Tensor` with values drawn from a multinomial distribution.
 *
 * ```js
 * const probs = tf.tensor([.75, .25]);
 * tf.multinomial(probs, 3).print();
 * ```
 *
 * @param logits 1D array with unnormalized log-probabilities, or
 *     2D array of shape `[batchSize, numOutcomes]`. See the `normalized`
 *     parameter.
 * @param numSamples Number of samples to draw for each row slice.
 * @param seed The seed number.
 * @param normalized Whether the provided `logits` are normalized true
 *     probabilities (sum to 1). Defaults to false.
 * @return 1D array of shape `[numSamples]`, or 2D array of shape
 *     `[batchSize, numSamples]`, depending on the rank of the input.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $80a721450e7ef1a8$var$multinomial_(logits, numSamples, seed, normalized = false) {
    const $logits = (0, $010a899b69412c72$export$ede379c4c939d71a)(logits, 'logits', 'multinomial');
    const numOutcomes = $logits.size;
    const origRank = $logits.rank;
    if (numOutcomes < 2) throw new Error(`Error in multinomial: you need at least 2 outcomes, but got ` + `${numOutcomes}.`);
    if (origRank > 2) throw new Error(`Rank of probabilities must be 1 or 2, but is ${origRank}`);
    // TODO(lina128): Investigate correct seed behavior. The code seems not allow
    // setting see to 0.
    seed = seed || Math.random();
    // The kernel only accepts (and returns) rank 2 tensors.
    const logits2D = origRank === 1 ? (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($logits, [
        1,
        -1
    ]) : $logits;
    const inputs = {
        logits: logits2D
    };
    const attrs = {
        numSamples: numSamples,
        seed: seed,
        normalized: normalized
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$ee0a8cfb693e0e3f), inputs, attrs);
    // tslint:disable-next-line:no-unnecessary-type-assertion
    return origRank === 1 ? (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.size
    ]) : res;
}
const $80a721450e7ef1a8$export$f4d580f3101a1c7e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    multinomial_: $80a721450e7ef1a8$var$multinomial_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns the truth value of (a != b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([0, 2, 3]);
 *
 * a.notEqual(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $683debd13acf606f$var$notEqual_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'notEqual', 'string_or_numeric');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'notEqual', 'string_or_numeric');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$385ebe9945cae0c5), inputs);
}
const $683debd13acf606f$export$53a6892c50694894 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    notEqual_: $683debd13acf606f$var$notEqual_
});




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with all elements set to 1 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.onesLike(x).print();
 * ```
 * @param x A tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $4741961218c2e183$var$onesLike_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'onesLike');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$a2962e735c809d91), inputs);
}
const $4741961218c2e183$export$fb6afd6214fee9e9 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    onesLike_: $4741961218c2e183$var$onesLike_
});







/**
 * Computes the outer product of two vectors, `v1` and `v2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([3, 4, 5]);
 *
 * tf.outerProduct(a, b).print();
 * ```
 * @param v1 The first vector in the outer product operation.
 * @param v2 The second vector in the outer product operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $613695c2f6bda44d$var$outerProduct_(v1, v2) {
    const $v1 = (0, $010a899b69412c72$export$ede379c4c939d71a)(v1, 'v1', 'outerProduct');
    const $v2 = (0, $010a899b69412c72$export$ede379c4c939d71a)(v2, 'v2', 'outerProduct');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($v1.rank === 1 && $v2.rank === 1, ()=>`Error in outerProduct: inputs must be rank 1, but got ranks ` + `${$v1.rank} and ${$v2.rank}.`);
    const v12D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($v1, [
        -1,
        1
    ]);
    const v22D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($v2, [
        1,
        -1
    ]);
    return (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(v12D, v22D);
}
const $613695c2f6bda44d$export$8481b38c75c91cc7 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    outerProduct_: $613695c2f6bda44d$var$outerProduct_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Pads a `tf.Tensor` with a given value and paddings.
 *
 * This operation implements `CONSTANT` mode. For `REFLECT` and `SYMMETRIC`,
 * refer to `tf.mirrorPad`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `paddings` is of given length.
 *   - `tf.pad1d`
 *   - `tf.pad2d`
 *   - `tf.pad3d`
 *   - `tf.pad4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.pad([[1, 2]]).print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * @param constantValue The pad value to use. Defaults to 0.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $b90bbaefd48f2353$var$pad_(x, paddings, constantValue = 0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'pad');
    if ($x.rank === 0) throw new Error('pad(scalar) is not defined. Pass non-scalar to pad');
    const attrs = {
        paddings: paddings,
        constantValue: constantValue
    };
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$5d47ba206577f0f2), inputs, attrs);
}
const $b90bbaefd48f2353$export$5d04458e2a6c373e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    pad_: $b90bbaefd48f2353$var$pad_
});





/**
 * Pads a `tf.Tensor1D` with a given value and paddings. See `pad` for details.
 */ function $9815392d4669cf13$var$pad1d_(x, paddings, constantValue = 0) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(paddings.length === 2, ()=>'Invalid number of paddings. Must be length of 2.');
    return (0, $b90bbaefd48f2353$export$5d04458e2a6c373e)(x, [
        paddings
    ], constantValue);
}
const $9815392d4669cf13$export$be67ff622a7fd5 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    pad1d_: $9815392d4669cf13$var$pad1d_
});





/**
 * Pads a `tf.Tensor2D` with a given value and paddings. See `pad` for details.
 */ function $f6d43711f5079033$var$pad2d_(x, paddings, constantValue = 0) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(paddings.length === 2 && paddings[0].length === 2 && paddings[1].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $b90bbaefd48f2353$export$5d04458e2a6c373e)(x, paddings, constantValue);
}
const $f6d43711f5079033$export$38e9137d79715c2d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    pad2d_: $f6d43711f5079033$var$pad2d_
});





/**
 * Pads a `tf.Tensor3D` with a given value and paddings. See `pad` for details.
 */ function $f49389cdab278f98$var$pad3d_(x, paddings, constantValue = 0) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(paddings.length === 3 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $b90bbaefd48f2353$export$5d04458e2a6c373e)(x, paddings, constantValue);
}
const $f49389cdab278f98$export$880821ebecb16ceb = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    pad3d_: $f49389cdab278f98$var$pad3d_
});





/**
 * Pads a `tf.Tensor4D` with a given value and paddings. See `pad` for details.
 */ function $bdbccbe431e53b87$var$pad4d_(x, paddings, constantValue = 0) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(paddings.length === 4 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2 && paddings[3].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $b90bbaefd48f2353$export$5d04458e2a6c373e)(x, paddings, constantValue);
}
const $bdbccbe431e53b87$export$4aef6fb43f1346f4 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    pad4d_: $bdbccbe431e53b87$var$pad4d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 







/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * This operation divides "spatial" dimensions `[1, ..., M]` of the input into
 * a grid of blocks of shape `blockShape`, and interleaves these blocks with
 * the "batch" dimension (0) such that in the output, the spatial
 * dimensions `[1, ..., M]` correspond to the position within the grid,
 * and the batch dimension combines both the position within a spatial block
 * and the original batch position. Prior to division into blocks,
 * the spatial dimensions of the input are optionally zero padded
 * according to `paddings`. See below for a precise description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 2, 2, 1]);
 * const blockShape = [2, 2];
 * const paddings = [[0, 0], [0, 0]];
 *
 * x.spaceToBatchND(blockShape, paddings).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param paddings A 2-D array. Must have shape `[M, 2]`, all values must be >=
 *     0. `paddings[i] = [padStart, padEnd]` specifies the amount to zero-pad
 * from input dimension `i + 1`, which corresponds to spatial dimension `i`. It
 * is required that
 * `(inputShape[i + 1] + padStart + padEnd) % blockShape[i] === 0`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Zero-pad the start and end of dimensions `[1, ..., M]` of the input
 * according to `paddings` to produce `padded` of shape paddedShape.
 *
 * 2. Reshape `padded` to `reshapedPadded` of shape:
 * `[batch] + [paddedShape[1] / blockShape[0], blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1], blockShape[M-1]] + remainingShape`
 *
 * 3. Permute dimensions of `reshapedPadded` to produce `permutedReshapedPadded`
 * of shape: `blockShape + [batch] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * 4. Reshape `permutedReshapedPadded` to flatten `blockShape` into the
 * batch dimension, producing an output tensor of shape:
 * `[batch * prod(blockShape)] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $acc81226aaa46db7$var$spaceToBatchND_(x, blockShape, paddings) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'spaceToBatchND');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank >= 1 + blockShape.length, ()=>`input rank ${$x.rank} should be > than [blockShape] ${blockShape.length}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(paddings.length === blockShape.length, ()=>`paddings.shape[0] ${paddings.length} must be equal to [blockShape] ${blockShape.length}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.shape.reduce((a, b, i)=>{
        if (i > 0 && i <= blockShape.length) return a && (b + paddings[i - 1][0] + paddings[i - 1][1]) % blockShape[i - 1] === 0;
        return a;
    }, true), ()=>`input spatial dimensions ${$x.shape.slice(1)} with paddings ${paddings.toString()} must be divisible by blockShapes ${blockShape.toString()}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        paddings: paddings
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$f63ac5409312707c), inputs, attrs);
}
const $acc81226aaa46db7$export$effb9d7cae92012f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    spaceToBatchND_: $acc81226aaa46db7$var$spaceToBatchND_
});


/**
 * Performs an N-D pooling operation
 *
 * @param input The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param windowShape The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param poolingType The type of pooling, either 'max' or 'avg'.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
 *         https://www.tensorflow.org/api_guides/python/nn#Convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilationRate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $72715b6f4ed888f7$var$pool_(input, windowShape, poolingType, pad, dilations, strides, dimRoundingMode) {
    if (dilations == null) dilations = [
        1,
        1
    ];
    if (strides == null) strides = 1;
    if (pad === 0) pad = 'valid';
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(input, 'x', 'maxPool');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in pool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $b3e4d1c19b78487c$export$67e321f77840205c(x4D.shape, windowShape, strides, dilations, pad);
    const dilation = [
        convInfo.dilationHeight,
        convInfo.dilationWidth
    ];
    // The following implementation does batchToSpace(pool(spaceToBatch(x)))
    // whenever dilation > 1 since the TF kernels do not support dilation > 1.
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L1037
    let basePadding;
    if (pad === 'same') basePadding = $72715b6f4ed888f7$var$withSpaceToBatchBasePaddings([
        convInfo.filterHeight,
        convInfo.filterWidth
    ], dilation);
    else basePadding = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    const isDilationOne = dilation[0] === 1 && dilation[1] === 1;
    const [adjustedPadding, adjustedCrops] = $72715b6f4ed888f7$var$requiredSpaceToBatchPaddings([
        convInfo.inHeight,
        convInfo.inWidth
    ], dilation, basePadding);
    const convertedPad = isDilationOne ? pad : 'valid';
    const convertedX = isDilationOne ? x4D : (0, $acc81226aaa46db7$export$effb9d7cae92012f)(x4D, dilation, adjustedPadding);
    const forwardOp = poolingType === 'avg' ? ()=>(0, $de218d76756da0e0$export$d5c65a2abd3d97dc)(convertedX, windowShape, strides, convertedPad, dimRoundingMode) : ()=>(0, $bfa923df51c4e9fb$export$e4aadcf115842782)(convertedX, windowShape, strides, convertedPad, dimRoundingMode);
    const y = forwardOp();
    const res = isDilationOne ? y : (0, $2337f2e1e82e1c80$export$ea37d960c1808536)(y, dilation, adjustedCrops);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
// Helper function to compute crops and paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/array_ops.py#L2184
function $72715b6f4ed888f7$var$requiredSpaceToBatchPaddings(inputShape, blockShape, basePadding) {
    const padStart = basePadding.map((b)=>b[0]);
    const origPadEnd = basePadding.map((b)=>b[1]);
    const fullInputShape = inputShape.concat(padStart, origPadEnd);
    const padEndExtra = blockShape.map((b, i)=>(b - fullInputShape[i] % b) % b);
    const padEnd = origPadEnd.map((s, i)=>s + padEndExtra[i]);
    const paddings = blockShape.map((_, i)=>[
            padStart[i],
            padEnd[i]
        ]);
    const crops = blockShape.map((_, i)=>[
            0,
            padEndExtra[i]
        ]);
    return [
        paddings,
        crops
    ];
}
// Helper function to compute base paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L524
function $72715b6f4ed888f7$var$withSpaceToBatchBasePaddings(filterShape, dilation) {
    // Spatial dimensions of the filters and the upsampled filters in which we
    // introduce (rate - 1) zeros between consecutive filter values.
    const dilatedFilterShape = filterShape.map((s, i)=>{
        return s + (s - 1) * (dilation[i] - 1);
    });
    const padExtraShape = dilatedFilterShape.map((s)=>s - 1);
    // When padding is odd, we pad more at end, following the same
    // convention as conv2d.
    const padExtraStart = padExtraShape.map((s)=>Math.floor(s / 2));
    const padExtraEnd = padExtraShape.map((s, i)=>s - padExtraStart[i]);
    return padExtraShape.map((_, i)=>{
        return [
            padExtraStart[i],
            padExtraEnd[i]
        ];
    });
}
const $72715b6f4ed888f7$export$7a0e2789ec54f0db = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    pool_: $72715b6f4ed888f7$var$pool_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes leaky rectified linear element-wise with parametric alphas.
 *
 * `x < 0 ? alpha * x : f(x) = x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 * const alpha = tf.scalar(0.1);
 *
 * x.prelu(alpha).print();  // or tf.prelu(x, alpha)
 * ```
 * @param x The input tensor.
 * @param alpha Scaling factor for negative values.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $751df8e2647ea232$var$prelu_(x, alpha) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'prelu');
    const $alpha = (0, $010a899b69412c72$export$ede379c4c939d71a)(alpha, 'alpha', 'prelu');
    const inputs = {
        x: $x,
        alpha: $alpha
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$a42f35f308fc2fa3), inputs);
}
const $751df8e2647ea232$export$5882f235222e6729 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    prelu_: $751df8e2647ea232$var$prelu_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the product of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.prod().print();  // or tf.prod(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.prod(axis).print();  // or tf.prod(x, axis)
 * ```
 *
 * @param x The input tensor to compute the product over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $8b2dec4eec8fb3b3$var$prod_(x, axis = null, keepDims = false) {
    let $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'prod');
    if ($x.dtype === 'bool') // bool is not an allowed type for the underlying kernel.
    $x = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$b8a16d526a791fb0), inputs, attrs);
}
const $8b2dec4eec8fb3b3$export$5e143010dea16c85 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    prod_: $8b2dec4eec8fb3b3$var$prod_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $2c04d370930bbd05$var$raggedGather_(paramsNestedSplits, paramsDenseValues, indices, outputRaggedRank) {
    const $paramsNestedSplits = paramsNestedSplits.map((t, i)=>(0, $010a899b69412c72$export$ede379c4c939d71a)(t, `tensors${i}`, 'raggedGather', 'int32'));
    const $paramsDenseValues = (0, $010a899b69412c72$export$ede379c4c939d71a)(paramsDenseValues, 'paramsDenseValues', 'raggedGather');
    const $indices = (0, $010a899b69412c72$export$ede379c4c939d71a)(indices, 'indices', 'raggedGather', 'int32');
    const inputs = {
        paramsNestedSplits: $paramsNestedSplits,
        paramsDenseValues: $paramsDenseValues,
        indices: $indices
    };
    const attrs = {
        outputRaggedRank: outputRaggedRank
    };
    const result = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$ffee9c5b4fce08a1), inputs, attrs);
    return {
        outputNestedSplits: result.slice(0, result.length - 1),
        outputDenseValues: result[result.length - 1]
    };
}
const $2c04d370930bbd05$export$e7118f605df251dd = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    raggedGather_: $2c04d370930bbd05$var$raggedGather_
});


/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns a RaggedTensor result composed from rtDenseValues and rtNestedSplits,
 * such that result[i] = [starts[i], starts[i] + deltas[i], ..., limits[i]]).
 *
 * @param starts: A Tensor. Must be one of the following types:
 *     'float32', 'int32'. The starts of each range.
 * @param limits: A Tensor. Must have the same type as starts. The limits of
 *     each range.
 * @param deltas: A Tensor. Must have the same type as starts. The deltas of
 *     each range.
 * @return A map with the following properties:
 *     - rtNestedSplits: A Tensor of type 'int32'.
 *     - rtDenseValues: A Tensor. Has the same type as starts.
 */ function $012ad56de118f1c5$var$raggedRange_(starts, limits, deltas) {
    const $starts = (0, $010a899b69412c72$export$ede379c4c939d71a)(starts, 'starts', 'raggedRange');
    const $limits = (0, $010a899b69412c72$export$ede379c4c939d71a)(limits, 'limits', 'raggedRange', $starts.dtype);
    const $deltas = (0, $010a899b69412c72$export$ede379c4c939d71a)(deltas, 'deltas', 'raggedRange', $starts.dtype);
    const inputs = {
        starts: $starts,
        limits: $limits,
        deltas: $deltas
    };
    const result = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$9d0615a9a6d213d2), inputs);
    return {
        rtNestedSplits: result[0],
        rtDenseValues: result[1]
    };
}
const $012ad56de118f1c5$export$a173be400c6762b5 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    raggedRange_: $012ad56de118f1c5$var$raggedRange_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Create a dense tensor from a ragged tensor, possibly altering its shape.
 *
 * The raggedTensorToTensor op creates a dense tensor from am array of row
 * partition tensors, a value vector, and default values. If the shape is
 * unspecified, the minimal shape required to contain all the elements in the
 * ragged tensor (the natural shape) will be used. If some dimensions are left
 * unspecified, then the size of the natural shape is used in that dimension.
 *
 * The defaultValue will be broadcast to the output shape. After that, the
 * values from the ragged tensor overwrite the default values. Note that the
 * defaultValue must have less dimensions than the value.
 *
 * The row partition tensors are in the order of the dimensions. At present, the
 * types can be: "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *   "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *   "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then it
 * is preceded by "FIRST_DIM_SIZE".
 * ```
 * @param shape: A Tensor. Must be one of the following types: 'int32'. The
 *     desired shape of the output tensor. If left unspecified (empty), the
 *     minimal shape required to contain all the elements in the ragged tensor
 *     (the natural shape) will be used. If some dimensions are left
 *     unspecified, then the size of the natural shape is used in that
 *     dimension.
 *
 *     Note that dense dimensions cannot be modified by the shape argument.
 *     Trying to change the size of a dense dimension will cause the op to fail.
 *     Examples: natural shape: [4, 5, 6] shape: -1 output shape: [4, 5, 6]
 *
 *     natural shape: [4, 5, 6] shape: [3, -1, 2] output shape: [3, 5, 2]
 *
 *     natural shape: [4, 5, 6] shape: [3, 7, 2] output shape: [3, 7, 2]
 * @param values: A Tensor. A 1D tensor representing the values of the ragged
 *     tensor.
 * @param defaultValue: A Tensor. Must have the same type as values. The
 *     defaultValue when the shape is larger than the ragged tensor. The
 *     defaultValue is broadcast until it is the shape of the output tensor,
 *     and then overwritten by values in the ragged tensor. The default value
 *     must be compatible with this broadcast operation, and must have fewer
 *     dimensions than the value tensor.
 * @param rowPartitionTensors: A list of at least 1 Tensor objects with the same
 *     type in: 'int32'.
 * @param rowPartitionTypes: A list of strings. The types of the row partition
 *     tensors. At present, these can be:
 *     "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *     "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *     "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then
 *         it is preceded by "FIRST_DIM_SIZE". The tensors are in the order of
 *         the dimensions.
 * @return A Tensor. Has the same type as values.
 * @doc {heading: 'Operations', subheading: 'Ragged'}
 */ function $d005955acffcb7e3$var$raggedTensorToTensor_(shape, values, defaultValue, rowPartitionTensors, rowPartitionTypes) {
    const $shape = (0, $010a899b69412c72$export$ede379c4c939d71a)(shape, 'shape', 'raggedTensorToTensor', 'int32');
    const $values = (0, $010a899b69412c72$export$ede379c4c939d71a)(values, 'values', 'raggedTensorToTensor');
    const $defaultValue = (0, $010a899b69412c72$export$ede379c4c939d71a)(defaultValue, 'defaultValue', 'raggedTensorToTensor', $values.dtype);
    const $rowPartitionTensors = rowPartitionTensors.map((t, i)=>(0, $010a899b69412c72$export$ede379c4c939d71a)(t, `tensors${i}`, 'raggedTensorToTensor', 'int32'));
    const inputs = {
        shape: $shape,
        values: $values,
        defaultValue: $defaultValue,
        rowPartitionTensors: $rowPartitionTensors
    };
    const attrs = {
        rowPartitionTypes: rowPartitionTypes
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$616d73a9ab7617c7), inputs, attrs);
}
const $d005955acffcb7e3$export$621e390307cbbaa1 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    raggedTensorToTensor_: $d005955acffcb7e3$var$raggedTensorToTensor_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with values sampled from a random number generator
 * function defined by the user.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param randFunction A random number generator function which is called
 * for each element in the output tensor.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $8aa32f484b90fe36$var$rand_(shape, randFunction, dtype) {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    const size = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(shape);
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    for(let i = 0; i < size; i++)values[i] = randFunction();
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).makeTensor(values, shape, dtype);
}
const $8aa32f484b90fe36$export$bb0a9c36cf454ea0 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    rand_: $8aa32f484b90fe36$var$rand_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $2725bdcb11510985$exports = {};
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $cmoHh = parcelRequire("cmoHh");

var $euRi5 = parcelRequire("euRi5");

var $hDsEw = parcelRequire("hDsEw");

var $3J2Zm = parcelRequire("3J2Zm");

var $6Px8M = parcelRequire("6Px8M");

var $lDm0S = parcelRequire("lDm0S");
var $d7e73366feb50558$exports = {};

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = 'random', startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == 'object') {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == 'string' ? obj : obj + '\0';
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if ($d7e73366feb50558$exports) {
        $d7e73366feb50558$exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("kjyEk"));
        } catch (ex) {}
    } else if (typeof define == 'function' && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math['seed' + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== 'undefined' ? self : $d7e73366feb50558$exports, [], Math // math: package containing random, pow, and seedrandom
);


$d7e73366feb50558$exports.alea = $cmoHh;
$d7e73366feb50558$exports.xor128 = $euRi5;
$d7e73366feb50558$exports.xorwow = $hDsEw;
$d7e73366feb50558$exports.xorshift7 = $3J2Zm;
$d7e73366feb50558$exports.xor4096 = $6Px8M;
$d7e73366feb50558$exports.tychei = $lDm0S;
$2725bdcb11510985$exports = $d7e73366feb50558$exports;



class $5b7125fa6f9f7784$export$d23b64058df0188a {
    constructor(mean, stdDeviation, dtype, truncated, seed){
        this.mean = mean;
        this.stdDev = stdDeviation;
        this.dtype = dtype;
        this.nextVal = NaN;
        this.truncated = truncated;
        if (this.truncated) {
            this.upper = this.mean + this.stdDev * 2;
            this.lower = this.mean - this.stdDev * 2;
        }
        const seedValue = seed ? seed : Math.random();
        this.random = $2725bdcb11510985$exports.alea(seedValue.toString());
    }
    /** Returns next sample from a Gaussian distribution. */ nextValue() {
        if (!isNaN(this.nextVal)) {
            const value = this.nextVal;
            this.nextVal = NaN;
            return value;
        }
        let resultX, resultY;
        let isValid = false;
        while(!isValid){
            let v1, v2, s;
            do {
                v1 = 2 * this.random() - 1;
                v2 = 2 * this.random() - 1;
                s = v1 * v1 + v2 * v2;
            }while (s >= 1 || s === 0);
            const mul = Math.sqrt(-2 * Math.log(s) / s);
            resultX = this.mean + this.stdDev * v1 * mul;
            resultY = this.mean + this.stdDev * v2 * mul;
            if (!this.truncated || this.isValidTruncated(resultX)) isValid = true;
        }
        if (!this.truncated || this.isValidTruncated(resultY)) this.nextVal = this.convertValue(resultY);
        return this.convertValue(resultX);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype == null || this.dtype === 'float32') return value;
        return Math.round(value);
    }
    /** Returns true if less than 2-standard-deviations from the mean. */ isValidTruncated(value) {
        return value <= this.upper && value >= this.lower;
    }
}
class $5b7125fa6f9f7784$export$bffe1ad508acdb18 {
    constructor(alpha, beta, dtype, seed){
        this.alpha = alpha;
        this.beta = 1 / beta; // convert rate to scale parameter
        this.dtype = dtype;
        const seedValue = seed ? seed : Math.random();
        this.randu = $2725bdcb11510985$exports.alea(seedValue.toString());
        this.randn = new $5b7125fa6f9f7784$export$d23b64058df0188a(0, 1, dtype, false, this.randu());
        if (alpha < 1) this.d = alpha + 2 / 3;
        else this.d = alpha - 1 / 3;
        this.c = 1 / Math.sqrt(9 * this.d);
    }
    /** Returns next sample from a gamma distribution. */ nextValue() {
        let x2, v0, v1, x, u, v;
        while(true){
            do {
                x = this.randn.nextValue();
                v = 1 + this.c * x;
            }while (v <= 0);
            v *= v * v;
            x2 = x * x;
            v0 = 1 - 0.331 * x2 * x2;
            v1 = 0.5 * x2 + this.d * (1 - v + Math.log(v));
            u = this.randu();
            if (u < v0 || Math.log(u) < v1) break;
        }
        v = 1 / this.beta * this.d * v;
        if (this.alpha < 1) v *= Math.pow(this.randu(), 1 / this.alpha);
        return this.convertValue(v);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype === 'float32') return value;
        return Math.round(value);
    }
}
class $5b7125fa6f9f7784$export$1e4a6d1367ace404 {
    constructor(min = 0, max = 1, dtype, seed){
        /** Handles proper rounding for non floating point numbers. */ this.canReturnFloat = ()=>this.dtype == null || this.dtype === 'float32';
        this.min = min;
        this.range = max - min;
        this.dtype = dtype;
        if (seed == null) seed = Math.random();
        if (typeof seed === 'number') seed = seed.toString();
        if (!this.canReturnFloat() && this.range <= 1) throw new Error(`The difference between ${min} - ${max} <= 1 and dtype is not float`);
        this.random = $2725bdcb11510985$exports.alea(seed);
    }
    convertValue(value) {
        if (this.canReturnFloat()) return value;
        return Math.round(value);
    }
    nextValue() {
        return this.convertValue(this.min + this.range * this.random());
    }
}
function $5b7125fa6f9f7784$export$5f38b2eb2df54d68(values) {
    // https://en.wikipedia.org/wiki/Jarque%E2%80%93Bera_test
    const n = values.length;
    const s = $5b7125fa6f9f7784$var$skewness(values);
    const k = $5b7125fa6f9f7784$var$kurtosis(values);
    const jb = n / 6 * (Math.pow(s, 2) + 0.25 * Math.pow(k - 3, 2));
    // JB test requires 2-degress of freedom from Chi-Square @ 0.95:
    // http://www.itl.nist.gov/div898/handbook/eda/section3/eda3674.htm
    const CHI_SQUARE_2DEG = 5.991;
    if (jb > CHI_SQUARE_2DEG) throw new Error(`Invalid p-value for JB: ${jb}`);
}
function $5b7125fa6f9f7784$export$3286e17febe230d(actual, expectedMean, expectedStdDev, epsilon) {
    if (epsilon == null) epsilon = (0, $4b634705d248be81$export$e73bb4a504595b05)();
    const actualMean = $5b7125fa6f9f7784$var$mean(actual);
    (0, $4b634705d248be81$export$a09d1668dd6f88b6)(actualMean, expectedMean, epsilon);
    (0, $4b634705d248be81$export$a09d1668dd6f88b6)($5b7125fa6f9f7784$var$standardDeviation(actual, actualMean), expectedStdDev, epsilon);
}
function $5b7125fa6f9f7784$var$mean(values) {
    let sum = 0;
    for(let i = 0; i < values.length; i++)sum += values[i];
    return sum / values.length;
}
function $5b7125fa6f9f7784$var$standardDeviation(values, mean) {
    let squareDiffSum = 0;
    for(let i = 0; i < values.length; i++){
        const diff = values[i] - mean;
        squareDiffSum += diff * diff;
    }
    return Math.sqrt(squareDiffSum / values.length);
}
function $5b7125fa6f9f7784$var$kurtosis(values) {
    // https://en.wikipedia.org/wiki/Kurtosis
    const valuesMean = $5b7125fa6f9f7784$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum4 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum4 += Math.pow(v, 4);
    }
    return 1 / n * sum4 / Math.pow(1 / n * sum2, 2);
}
function $5b7125fa6f9f7784$var$skewness(values) {
    // https://en.wikipedia.org/wiki/Skewness
    const valuesMean = $5b7125fa6f9f7784$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum3 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum3 += Math.pow(v, 3);
    }
    return 1 / n * sum3 / Math.pow(1 / (n - 1) * sum2, 1.5);
}


/**
 * Creates a `tf.Tensor` with values sampled from a gamma distribution.
 *
 * ```js
 * tf.randomGamma([2, 2], 1).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param alpha The shape parameter of the gamma distribution.
 * @param beta The inverse scale parameter of the gamma distribution. Defaults
 *     to 1.
 * @param dtype The data type of the output. Defaults to float32.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $0a41cda08b4fd1d5$var$randomGamma_(shape, alpha, beta = 1, dtype = 'float32', seed) {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    if (beta == null) beta = 1;
    if (dtype == null) dtype = 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new Error(`Unsupported data type ${dtype}`);
    const rgamma = new (0, $5b7125fa6f9f7784$export$bffe1ad508acdb18)(alpha, beta, dtype, seed);
    const res = (0, $d99273e33e31a4d2$export$ab1029bcae9ddb4a)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = rgamma.nextValue();
    return res.toTensor();
}
const $0a41cda08b4fd1d5$export$63a8048b65295cb7 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    randomGamma_: $0a41cda08b4fd1d5$var$randomGamma_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * ```js
 * tf.randomNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $c68f21db59d988e8$var$randomNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    const randGauss = new (0, $5b7125fa6f9f7784$export$d23b64058df0188a)(mean, stdDev, dtype, false, seed);
    const res = (0, $d99273e33e31a4d2$export$ab1029bcae9ddb4a)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $c68f21db59d988e8$export$a0ac5549a8bec918 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    randomNormal_: $c68f21db59d988e8$var$randomNormal_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * The generated values will have mean 0 and standard deviation 1.
 *
 * ```js
 * tf.randomStandardNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $f3bddf0c4680dee4$var$randomStandardNormal_(shape, dtype, seed) {
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    return (0, $c68f21db59d988e8$export$a0ac5549a8bec918)(shape, 0, 1, dtype, seed);
}
const $f3bddf0c4680dee4$export$5a8aa20f8ebaee69 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    randomStandardNormal_: $f3bddf0c4680dee4$var$randomStandardNormal_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with values sampled from a uniform distribution.
 *
 * The generated values follow a uniform distribution in the range [minval,
 * maxval). The lower bound minval is included in the range, while the upper
 * bound maxval is excluded.
 *
 * ```js
 * tf.randomUniform([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param minval The lower bound on the range of random values to generate.
 *   Defaults to 0.
 * @param maxval The upper bound on the range of random values to generate.
 *   Defaults to 1.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 * @param seed An optional int. Defaults to 0. If seed is set to be non-zero,
 *   the random number generator is seeded by the given seed. Otherwise, it is
 *   seeded by a random seed.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $dee4b5fc7aecfad3$var$randomUniform_(shape, minval = 0, maxval = 1, dtype = 'float32', seed) {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    const res = (0, $d99273e33e31a4d2$export$ab1029bcae9ddb4a)(shape, dtype);
    const random = new (0, $5b7125fa6f9f7784$export$1e4a6d1367ace404)(minval, maxval, null, seed);
    for(let i = 0; i < res.values.length; i++)res.values[i] = random.nextValue();
    return res.toTensor();
}
const $dee4b5fc7aecfad3$export$bd6fd37822e292fa = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    randomUniform_: $dee4b5fc7aecfad3$var$randomUniform_
});


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Creates a `tf.Tensor` with integers sampled from a uniform distribution.
 *
 * The generated values are uniform integers in the range [minval, maxval). The
 * lower bound minval is included in the range, while the upper bound maxval is
 * excluded.
 *
 * ```js
 * tf.randomUniformInt([2, 2], 0, 10).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param minval Inclusive lower bound on the generated integers.
 * @param maxval Exclusive upper bound on the generated integers.
 * @param seed An optional int. Defaults to 0. If seed is set to be non-zero,
 *   the random number generator is seeded by the given seed. Otherwise, it is
 *   seeded by a random seed.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $a5930481412268a3$var$randomUniformInt_(shape, minval, maxval, seed) {
    // TODO(mattsoulanille): Handle optional seed2 input.
    return (0, $dee4b5fc7aecfad3$export$bd6fd37822e292fa)(shape, minval, maxval, 'int32', seed);
}
const $a5930481412268a3$export$134fe7f07fd7b492 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    randomUniformInt_: $a5930481412268a3$var$randomUniformInt_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $5d4db871afef7031$export$d02631cccf789723(start, stop, step = 1, dtype = 'float32') {
    if (step === 0) throw new Error('Cannot have a step of zero');
    const attrs = {
        start: start,
        stop: stop,
        step: step,
        dtype: dtype
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$9a58ef0d7ad3278c), {} /* inputs */ , attrs);
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes reciprocal of x element-wise: `1 / x`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, 2]);
 *
 * x.reciprocal().print();  // or tf.reciprocal(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $24e709942a18bc8e$var$reciprocal_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'reciprocal');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c6e4a23ed5e0415b), inputs);
}
const $24e709942a18bc8e$export$163bc8c839a1ac04 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    reciprocal_: $24e709942a18bc8e$var$reciprocal_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes rectified linear element-wise: `max(x, 0)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.relu().print();  // or tf.relu(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $633a7fface57265e$var$relu_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'relu');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$9a6ff968bf961432), inputs);
}
const $633a7fface57265e$export$16d1e4612cc0139f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    relu_: $633a7fface57265e$var$relu_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes rectified linear 6 element-wise: `min(max(x, 0), 6)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 8]);
 *
 * x.relu6().print();  // or tf.relu6(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $b4b08408f5ab9172$var$relu6_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'relu6');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$3be9e924f629054e), inputs);
}
const $b4b08408f5ab9172$export$4a62bcb95e9c44c4 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    relu6_: $b4b08408f5ab9172$var$relu6_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor` along a specified axis.
 *
 * Also available are stricter rank-specific methods that assert that `x` is
 * of the given rank:
 *   - `tf.reverse1d`
 *   - `tf.reverse2d`
 *   - `tf.reverse3d`
 *   - `tf.reverse4d`
 *
 * Except `tf.reverse1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.reverse().print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.reverse(axis).print();
 * ```
 * @param x The input tensor to be reversed.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $47cd593c7f6553f1$var$reverse_(x, axis) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'reverse');
    const inputs = {
        x: $x
    };
    const attrs = {
        dims: axis
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$53c81f36b32e1bba), inputs, attrs);
}
const $47cd593c7f6553f1$export$66c1ae025e96b4bc = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    reverse_: $47cd593c7f6553f1$var$reverse_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor1D`.
 *
 * @param x The input tensor.
 */ function $1ff9af9aa5e82ce6$var$reverse1d_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'reverse');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 1, ()=>`Error in reverse1D: x must be rank 1 but got rank ${$x.rank}.`);
    return (0, $47cd593c7f6553f1$export$66c1ae025e96b4bc)($x, 0);
}
const $1ff9af9aa5e82ce6$export$ec29ded9cbde7103 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    reverse1d_: $1ff9af9aa5e82ce6$var$reverse1d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor2D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $64cac5866b1d4ce7$var$reverse2d_(x, axis) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'reverse');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 2, ()=>`Error in reverse2D: x must be rank 2 but got rank ${$x.rank}.`);
    return (0, $47cd593c7f6553f1$export$66c1ae025e96b4bc)($x, axis);
}
const $64cac5866b1d4ce7$export$12170f5f8cb48014 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    reverse2d_: $64cac5866b1d4ce7$var$reverse2d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor3D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $8d8b45c71f7c374d$var$reverse3d_(x, axis) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'reverse');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 3, ()=>`Error in reverse3D: x must be rank 3 but got rank ${$x.rank}.`);
    return (0, $47cd593c7f6553f1$export$66c1ae025e96b4bc)($x, axis);
}
const $8d8b45c71f7c374d$export$1ecb65b2ca41f0e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    reverse3d_: $8d8b45c71f7c374d$var$reverse3d_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Reverses a `tf.Tensor4D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $87e902ddeaa5429c$var$reverse4d_(x, axis) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'reverse');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 4, ()=>`Error in reverse4D: x must be rank 4 but got rank ${$x.rank}.`);
    return (0, $47cd593c7f6553f1$export$66c1ae025e96b4bc)($x, axis);
}
const $87e902ddeaa5429c$export$76a1df46e0e42da4 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    reverse4d_: $87e902ddeaa5429c$var$reverse4d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes round of input `tf.Tensor` element-wise: `round(x)`.
 * It implements banker's rounding.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.round().print();  // or tf.round(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $743db37ae6b6e648$var$round_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'round');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c5ed3eef16c0612f), inputs);
}
const $743db37ae6b6e648$export$2077e0241d6afd3c = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    round_: $743db37ae6b6e648$var$round_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes reciprocal of square root of the input `tf.Tensor` element-wise:
 * `y = 1 / sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.rsqrt().print();  // or tf.rsqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $3efe1f83a3e5837d$var$rsqrt_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'rsqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$7cc53aa09f5f3a2d), inputs);
}
const $3efe1f83a3e5837d$export$1cc01d192953037e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    rsqrt_: $3efe1f83a3e5837d$var$rsqrt_
});



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes scaled exponential linear element-wise.
 *
 * `x < 0 ? scale * alpha * (exp(x) - 1) : scale * x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.selu().print();  // or tf.selu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $8142a96555db4d0b$var$selu_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'selu');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$6760d858e6f2594a), inputs);
}
const $8142a96555db4d0b$export$a5f8240d9e99b438 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    selu_: $8142a96555db4d0b$var$selu_
});








/**
 * 2-D convolution with separable filters.
 *
 * Performs a depthwise convolution that acts separately on channels followed
 * by a pointwise convolution that mixes channels. Note that this is
 * separability between dimensions [1, 2] and 3, not spatial separability
 * between dimensions 1 and 2.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param depthwiseFilter The depthwise filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`. This is
 *     the filter used in the first step.
 * @param pointwiseFilter The pointwise filter tensor, rank 4, of shape
 *     `[1, 1, inChannels * channelMultiplier, outChannels]`. This is
 *     the filter used in the second step.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $62f5def725189d23$var$separableConv2d_(x, depthwiseFilter, pointwiseFilter, strides, pad, dilation = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'separableConv2d');
    const $depthwiseFilter = (0, $010a899b69412c72$export$ede379c4c939d71a)(depthwiseFilter, 'depthwiseFilter', 'separableConv2d');
    const $pointwiseFilter = (0, $010a899b69412c72$export$ede379c4c939d71a)(pointwiseFilter, 'pointwiseFilter', 'separableConv2d');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    if (dataFormat === 'NCHW') throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in separableConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($depthwiseFilter.rank === 4, ()=>`Error in separableConv2d: depthwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($pointwiseFilter.rank === 4, ()=>`Error in separableConv2d: pointwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($pointwiseFilter.shape[0] === 1, ()=>`Error in separableConv2d: the first dimension of pointwise filter ` + ` must be 1, but got ${$pointwiseFilter.shape[0]}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($pointwiseFilter.shape[1] === 1, ()=>`Error in separableConv2d: the second dimension of pointwise ` + `filter must be 1, but got ${$pointwiseFilter.shape[1]}.`);
    const inChannels = $depthwiseFilter.shape[2];
    const channelMultiplier = $depthwiseFilter.shape[3];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($pointwiseFilter.shape[2] === inChannels * channelMultiplier, ()=>`Error in separableConv2d: the third dimension of pointwise filter ` + `must be ${inChannels * channelMultiplier}, ` + `but got ${$pointwiseFilter.shape[2]}.`);
    const depthwise = (0, $0d28c12ba7a09138$export$48a8ad9494a8fad8)(x4D, $depthwiseFilter, strides, pad, dataFormat, dilation);
    const pointwiseStride = 1;
    const res = (0, $43815144b11940c7$export$188f9215482e3db8)(depthwise, $pointwiseFilter, pointwiseStride, 'valid', dataFormat);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $62f5def725189d23$export$2586c92899c2d0fb = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    separableConv2d_: $62f5def725189d23$var$separableConv2d_
});


/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * Computes the difference between two lists of numbers.
 *
 * Given a Tensor `x` and a Tensor `y`, this operation returns a Tensor `out`
 * that represents all values that are in `x` but not in `y`. The returned
 * Tensor `out` is sorted in the same order that the numbers appear in `x`
 * (duplicates are preserved). This operation also returns a Tensor indices that
 * represents the position of each out element in `x`. In other words:
 *
 * `out[i] = x[idx[i]] for i in [0, 1, ..., out.length - 1]`
 *
 * ```js
 * const x = [1, 2, 3, 4, 5, 6];
 * const y = [1, 3, 5];
 *
 * const [out, indices] = await tf.setdiff1dAsync(x, y);
 * out.print(); // [2, 4, 6]
 * indices.print(); // [1, 3, 5]
 * ```
 *
 * @param x 1-D Tensor. Values to keep.
 * @param y 1-D Tensor. Must have the same type as x. Values to exclude in the
 *     output.
 * @returns Promise of Tensor tuple [out, indices].
 *  out: Tensor with the same type as x.
 *  indices: A Tensor of type int32.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ async function $976f4ad32ff317f5$var$setdiff1dAsync_(x, y) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'setdiff1d');
    const $y = (0, $010a899b69412c72$export$ede379c4c939d71a)(y, 'y', 'setdiff1d');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.dtype === $y.dtype, ()=>`x and y should have the same dtype, but got x (${$x.dtype}) and y (${$y.dtype}).`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 1, ()=>`x should be 1D tensor, but got x (${$x.shape}).`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($y.rank === 1, ()=>`y should be 1D tensor, but got y (${$y.shape}).`);
    const xVals = await $x.data();
    const yVals = await $y.data();
    const ySet = new Set(yVals);
    let outputSize = 0;
    for(let i = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) outputSize++;
    const buffer = new (0, $6c839404e55214b5$export$350df26cd52e08e1)([
        outputSize
    ], $x.dtype);
    const indices = new (0, $6c839404e55214b5$export$350df26cd52e08e1)([
        outputSize
    ], 'int32');
    for(let i = 0, p = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) {
        buffer.values[p] = xVals[i];
        indices.values[p] = i;
        p++;
    }
    return [
        buffer.toTensor(),
        indices.toTensor()
    ];
}
const $976f4ad32ff317f5$export$cd50e5d116ec1774 = $976f4ad32ff317f5$var$setdiff1dAsync_;



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Returns an element-wise indication of the sign of a number.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3, NaN, 0]);
 *
 * x.sign().print();  // or tf.sign(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $29a1d3c837b8ed64$var$sign_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'sign');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$1db683ad541682f6), inputs);
}
const $29a1d3c837b8ed64$export$c5552dfdbc7cec71 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sign_: $29a1d3c837b8ed64$var$sign_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes sin of the input Tensor element-wise: `sin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.sin().print();  // or tf.sin(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $34df037cb95cd0bc$var$sin_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'sin', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$75be1b631f7687), inputs);
}
const $34df037cb95cd0bc$export$5de3937cb4b592ed = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sin_: $34df037cb95cd0bc$var$sin_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes hyperbolic sin of the input `tf.Tensor` element-wise: `sinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.sinh().print();  // or tf.sinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $b5a171d6413337da$var$sinh_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'sinh');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$b8c187376329d79b), inputs);
}
const $b5a171d6413337da$export$545004b505d7c555 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sinh_: $b5a171d6413337da$var$sinh_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a 1D slice from 1D array starting at coordinates `begin` and is
 * of length `size`. See `slice` for details.
 */ function $401c05c68cc4ac4b$var$slice1d_(x, begin, size) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'slice1d');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 1, ()=>`slice1d expects a rank-1 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $535db06fef6716ec$export$58adb3bec8346d0f)($x, [
        begin
    ], [
        size
    ]);
}
const $401c05c68cc4ac4b$export$95433662b275eb82 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    slice1d_: $401c05c68cc4ac4b$var$slice1d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a 2D slice from a 2D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $c31e278a3cb12d98$var$slice2d_(x, begin, size) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'slice2d');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 2, ()=>`slice2d expects a rank-2 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $535db06fef6716ec$export$58adb3bec8346d0f)($x, begin, size);
}
const $c31e278a3cb12d98$export$e5c6a6611cb43a9d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    slice2d_: $c31e278a3cb12d98$var$slice2d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a 3D slice from a 3D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $17befd7bb6856a0b$var$slice3d_(x, begin, size) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'slice3d');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 3, ()=>`slice3d expects a rank-3 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $535db06fef6716ec$export$58adb3bec8346d0f)($x, begin, size);
}
const $17befd7bb6856a0b$export$dec56af20749d733 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    slice3d_: $17befd7bb6856a0b$var$slice3d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a 4D slice from a 4D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $607f40e3463324cc$var$slice4d_(x, begin, size) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'slice4d');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.rank === 4, ()=>`slice4d expects a rank-4 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $535db06fef6716ec$export$58adb3bec8346d0f)($x, begin, size);
}
const $607f40e3463324cc$export$9833e35e879da26c = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    slice4d_: $607f40e3463324cc$var$slice4d_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the softmax normalized vector given the logits.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $9bdcd3abf3c06921$var$softmax_(logits, dim = -1) {
    const $logits = (0, $010a899b69412c72$export$ede379c4c939d71a)(logits, 'logits', 'softmax', 'float32');
    if (dim === -1) dim = $logits.rank - 1;
    if (dim !== $logits.rank - 1) throw Error('Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and dim was ${dim}`);
    const inputs = {
        logits: $logits
    };
    const attrs = {
        dim: dim
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$350a526055d3ca6e), inputs, attrs);
}
const $9bdcd3abf3c06921$export$e008137e76238601 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    softmax_: $9bdcd3abf3c06921$var$softmax_
});




/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the inner-most
 * dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.fft().print();  // tf.spectral.fft(x).print();
 * ```
 * @param input The complex input to compute an fft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $1486b5b57f2c7550$var$fft_(input) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.fft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$677347237c014ba), inputs);
}
const $1486b5b57f2c7550$export$a535ef183b6128fa = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    fft_: $1486b5b57f2c7550$var$fft_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Inverse fast Fourier transform.
 *
 * Computes the inverse 1-dimensional discrete Fourier transform over the
 * inner-most dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.ifft().print();  // tf.spectral.ifft(x).print();
 * ```
 * @param input The complex input to compute an ifft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $26eacb6258cb10d5$var$ifft_(input) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.ifft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$21c6f576ae8100e8), inputs);
}
const $26eacb6258cb10d5$export$776649b0bf8ce1fd = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    ifft_: $26eacb6258cb10d5$var$ifft_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 










/**
 * Inversed real value input fast Fourier transform.
 *
 * Computes the 1-dimensional inversed discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([0, 0, 0]);
 * const x = tf.complex(real, imag);
 *
 * x.irfft().print();
 * ```
 * @param input The real value input to compute an irfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $cb2ae7445ffa5769$var$irfft_(input) {
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let ret;
    if (innerDimensionSize <= 2) {
        const complexInput = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(input, [
            batch,
            innerDimensionSize
        ]);
        ret = (0, $26eacb6258cb10d5$export$776649b0bf8ce1fd)(complexInput);
    } else {
        // The length of unique components of the DFT of a real-valued signal
        // is 2 * (input_len - 1)
        const outputShape = [
            batch,
            2 * (innerDimensionSize - 1)
        ];
        const realInput = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $8189f77a6a673bd0$export$9fc57fb453bdbd67)(input), [
            batch,
            innerDimensionSize
        ]);
        const imagInput = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $0e1dcb58360d86cd$export$d78fab5778ab392b)(input), [
            batch,
            innerDimensionSize
        ]);
        const realConjugate = (0, $47cd593c7f6553f1$export$66c1ae025e96b4bc)((0, $535db06fef6716ec$export$58adb3bec8346d0f)(realInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1);
        const imagConjugate = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $47cd593c7f6553f1$export$66c1ae025e96b4bc)((0, $535db06fef6716ec$export$58adb3bec8346d0f)(imagInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1), (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(-1));
        const r = (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)([
            realInput,
            realConjugate
        ], 1);
        const i = (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)([
            imagInput,
            imagConjugate
        ], 1);
        const complexInput = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $175eb29e145dcf53$export$83a0e34f1302825b)(r, i), [
            outputShape[0],
            outputShape[1]
        ]);
        ret = (0, $26eacb6258cb10d5$export$776649b0bf8ce1fd)(complexInput);
    }
    ret = (0, $8189f77a6a673bd0$export$9fc57fb453bdbd67)(ret);
    // reshape the result if the input is 3D tensor.
    if (input.rank === 3 && input.shape[0] !== 0) {
        const temp = ret;
        const batch = input.shape[0];
        ret = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(ret, [
            batch,
            ret.shape[0] / batch,
            ret.shape[1]
        ]);
        temp.dispose();
    }
    return ret;
}
const $cb2ae7445ffa5769$export$f47f4e5bcd3d6a66 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    irfft_: $cb2ae7445ffa5769$var$irfft_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 







/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Splits a `tf.Tensor` into sub tensors.
 *
 * If `numOrSizeSplits` is a number, splits `x` along dimension `axis`
 * into `numOrSizeSplits` smaller tensors.
 * Requires that `numOrSizeSplits` evenly divides `x.shape[axis]`.
 *
 * If `numOrSizeSplits` is a number array, splits `x` into
 * `numOrSizeSplits.length` pieces. The shape of the `i`-th piece has the
 * same size as `x` except along dimension `axis` where the size is
 * `numOrSizeSplits[i]`.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [2, 4]);
 * const [a, b] = tf.split(x, 2, 1);
 * a.print();
 * b.print();
 *
 * const [c, d, e] = tf.split(x, [1, 2, 1], 1);
 * c.print();
 * d.print();
 * e.print();
 * ```
 *
 * @param x The input tensor to split.
 * @param numOrSizeSplits Either an integer indicating the number of
 * splits along the axis or an array of integers containing the sizes of
 * each output tensor along the axis. If a number then it must evenly divide
 * `x.shape[axis]`; otherwise the sum of sizes must match `x.shape[axis]`.
 * Can contain one -1 indicating that dimension is to be inferred.
 * @param axis The dimension along which to split. Defaults to 0 (the first
 * dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $6bb70aae893ea3fa$var$split_(x, numOrSizeSplits, axis = 0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'split');
    const inputs = {
        x: $x
    };
    const attr = {
        numOrSizeSplits: numOrSizeSplits,
        axis: axis
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$8dffabb4071f05aa), inputs, attr);
}
const $6bb70aae893ea3fa$export$65980d18b75784e2 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    split_: $6bb70aae893ea3fa$var$split_
});





/**
 * Real value input fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 *
 * real.rfft().print();
 * ```
 * @param input The real value input to compute an rfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $8db28b200f22d7be$var$rfft_(input, fftLength) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(input.dtype === 'float32', ()=>`The dtype for rfft() must be real value but got ${input.dtype}`);
    let innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let adjustedInput;
    if (fftLength != null && fftLength < innerDimensionSize) {
        // Need to crop
        const begin = input.shape.map((v)=>0);
        const size = input.shape.map((v)=>v);
        size[input.shape.length - 1] = fftLength;
        adjustedInput = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(input, begin, size);
        innerDimensionSize = fftLength;
    } else if (fftLength != null && fftLength > innerDimensionSize) {
        // Need to pad with zeros
        const zerosShape = input.shape.map((v)=>v);
        zerosShape[input.shape.length - 1] = fftLength - innerDimensionSize;
        adjustedInput = (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)([
            input,
            (0, $cc4388674ebc96d5$export$4445a00dafa2633b)(zerosShape)
        ], input.shape.length - 1);
        innerDimensionSize = fftLength;
    } else adjustedInput = input;
    // Complement the input with zero imaginary numbers.
    const zerosInput = (0, $64c118098861f580$export$cb1f824e7733584d)(adjustedInput);
    const complexInput = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $175eb29e145dcf53$export$83a0e34f1302825b)(adjustedInput, zerosInput), [
        batch,
        innerDimensionSize
    ]);
    const ret = (0, $1486b5b57f2c7550$export$a535ef183b6128fa)(complexInput);
    // Exclude complex conjugations. These conjugations are put symmetrically.
    const half = Math.floor(innerDimensionSize / 2) + 1;
    const realValues = (0, $8189f77a6a673bd0$export$9fc57fb453bdbd67)(ret);
    const imagValues = (0, $0e1dcb58360d86cd$export$d78fab5778ab392b)(ret);
    const realComplexConjugate = (0, $6bb70aae893ea3fa$export$65980d18b75784e2)(realValues, [
        half,
        innerDimensionSize - half
    ], realValues.shape.length - 1);
    const imagComplexConjugate = (0, $6bb70aae893ea3fa$export$65980d18b75784e2)(imagValues, [
        half,
        innerDimensionSize - half
    ], imagValues.shape.length - 1);
    const outputShape = adjustedInput.shape.slice();
    outputShape[adjustedInput.shape.length - 1] = half;
    return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $175eb29e145dcf53$export$83a0e34f1302825b)(realComplexConjugate[0], imagComplexConjugate[0]), outputShape);
}
const $8db28b200f22d7be$export$72aff1768917e9e5 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    rfft_: $8db28b200f22d7be$var$rfft_
});





/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Returns (a - b) * (a - b) element-wise.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * ```js
 * // Broadcast squared difference  a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $7adf3ff43b38d937$var$squaredDifference_(a, b) {
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'squaredDifference');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'squaredDifference');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    (0, $642a122b4608acc0$export$a3e2a38a57ec8318)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$2f922d20d66089c6), inputs, attrs);
}
const $7adf3ff43b38d937$export$b178697fb6d0b37f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    squaredDifference_: $7adf3ff43b38d937$var$squaredDifference_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Removes dimensions of size 1 from the shape of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4], [1, 1, 4]);
 * x.squeeze().print();
 * ```
 *
 * @param x The input tensor to be squeezed.
 * @param axis An optional list of numbers. If specified, only
 *     squeezes the dimensions listed. The dimension index starts at 0. It
 * is an error to squeeze a dimension that is not 1.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $f41010297af56801$var$squeeze_(x, axis) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'squeeze', 'string_or_numeric');
    return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, (0, $5f8d0ee7a8d35dfe$export$3106ace2a3b5396d)($x.shape, axis).newShape);
}
const $f41010297af56801$export$889c931173b77c2f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    squeeze_: $f41010297af56801$var$squeeze_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Stacks a list of rank-`R` `tf.Tensor`s into one rank-`(R+1)` `tf.Tensor`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.stack([a, b, c]).print();
 * ```
 *
 * @param tensors A list of tensor objects with the same shape and dtype.
 * @param axis The axis to stack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $6437527469582bc5$var$stack_(tensors, axis = 0) {
    const $tensors = (0, $010a899b69412c72$export$758e66616b4d410b)(tensors, 'tensors', 'stack', 'string_or_numeric');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($tensors.length >= 1, ()=>'Pass at least one tensor to tf.stack');
    if ($tensors.length > 0) $5f8d0ee7a8d35dfe$export$a7a9523472993e97(axis <= $tensors[0].rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = $tensors;
    const attrs = {
        axis: axis
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c26f40b29201e5b7), inputs, attrs);
}
const $6437527469582bc5$export$a57ab32f40f83ea9 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    stack_: $6437527469582bc5$var$stack_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes step of the input `tf.Tensor` element-wise: `x > 0 ? 1 : alpha`
 *
 * ```js
 * const x = tf.tensor1d([0, 2, -1, -3]);
 *
 * x.step(.5).print();  // or tf.step(x, .5)
 * ```
 * @param x The input tensor.
 * @param alpha The gradient when input is negative. Defaults to 0.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $ff8982de7da7934b$var$step_(x, alpha = 0.0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'step');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$fd55ce593607084a), inputs, attrs);
}
const $ff8982de7da7934b$export$35d34bc0ed591a92 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    step_: $ff8982de7da7934b$var$step_
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Extracts a strided slice of a tensor.
 *
 * Roughly speaking, this op extracts a slice of size (end-begin)/stride from
 * the given input tensor (x). Starting at the location specified by begin the
 * slice continues by adding stride to the index until all dimensions are not
 * less than end. Note that a stride can be negative, which causes a reverse
 * slice.
 *
 * ```js
 * const t = tf.tensor3d([1, 1, 1 ,2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6],
 *    [3, 2, 3]);
 * t.stridedSlice([1, 0, 0], [2, 1, 3], [1, 1, 1]).print()  // [[[3, 3, 3]]]
 * t.stridedSlice([1, 0, 0], [2, 2, 3], [1, 1, 1]).print()  // [[[3, 3, 3],
 *                                                     // [4, 4, 4]]]
 * t.stridedSlice([1, -1, 0], [2, -3, 3], [1, -1, 1]).print() // [[[4, 4, 4],
 *                                                     // [3, 3, 3]]]
 * ```
 *
 * @param x The tensor to stride slice.
 * @param begin The coordinates to start the slice from.
 * @param end: The coordinates to end the slice at.
 * @param strides: The size of the slice.
 * @param beginMask: If the ith bit of beginMask is set, begin[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param endMask: If the ith bit of endMask is set, end[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param shrinkAxisMask: a bitmask where bit i implies that
 * the ith specification should shrink the dimensionality. begin and end must
 * imply a slice of size 1 in the dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $9c771bc0944a917c$var$stridedSlice_(x, begin, end, strides, beginMask = 0, endMask = 0, ellipsisMask = 0, newAxisMask = 0, shrinkAxisMask = 0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'stridedSlice', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        end: end,
        strides: strides,
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$60c7f9ac271417a9), inputs, attrs);
}
const $9c771bc0944a917c$export$4ae57224f3b0605c = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    stridedSlice_: $9c771bc0944a917c$var$stridedSlice_
});




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes tan of the input `tf.Tensor` element-wise, `tan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.tan().print();  // or tf.tan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $f63c00f5c65721ae$var$tan_(x) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'tan', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$115b2d5263ba5985), inputs);
}
const $f63c00f5c65721ae$export$fcdd3b0b3246a325 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    tan_: $f63c00f5c65721ae$var$tan_
});




/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $f68b57eba454beb7$export$8133e3bf3cd8f464(values, dtype) {
    (0, $5f8d0ee7a8d35dfe$export$44a06cc2759dd036)(values);
    const inferredShape = (0, $010a899b69412c72$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 1) throw new Error('tensor1d() requires values to be a flat/TypedArray');
    const shape = null;
    return (0, $a024938a45229223$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $bea433ea0b14d5fb$export$b5469a65e8732256(values, shape, dtype) {
    (0, $5f8d0ee7a8d35dfe$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 2) throw new Error('tensor2d() requires shape to have two numbers');
    const inferredShape = (0, $010a899b69412c72$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 2 && inferredShape.length !== 1) throw new Error('tensor2d() requires values to be number[][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
    return (0, $a024938a45229223$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $4d00bcbc9bb89eab$export$b43603ce4e7542a7(values, shape, dtype) {
    (0, $5f8d0ee7a8d35dfe$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 4) throw new Error('tensor4d() requires shape to have four numbers');
    const inferredShape = (0, $010a899b69412c72$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 4 && inferredShape.length !== 1) throw new Error('tensor4d() requires values to be number[][][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");
    return (0, $a024938a45229223$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $b252ca7efcfee5b9$export$ab0278981fc9e727(values, shape, dtype) {
    (0, $5f8d0ee7a8d35dfe$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 5) throw new Error('tensor5d() requires shape to have five numbers');
    const inferredShape = (0, $010a899b69412c72$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 5 && inferredShape.length !== 1) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");
    return (0, $a024938a45229223$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


function $c197f4d49e2608e8$export$7b9f27dd2306a502(values, shape, dtype) {
    (0, $5f8d0ee7a8d35dfe$export$44a06cc2759dd036)(values);
    if (shape != null && shape.length !== 6) throw new Error('tensor6d() requires shape to have six numbers');
    const inferredShape = (0, $010a899b69412c72$export$467a8ad638b9ad20)(values, dtype);
    if (inferredShape.length !== 6 && inferredShape.length !== 1) throw new Error("tensor6d() requires values to be number[][][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");
    shape = shape || inferredShape;
    return (0, $a024938a45229223$export$f41686c891d7ebce)(values, shape, inferredShape, dtype);
}


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices to the passed in tensor according to
 * indices. This operator is the similar to scatterNd op, except that the
 * udpates are scattered on an existing tensor (as opposed to a zero-tensor).
 *
 * If indices contains duplicates, then we pick the last update for the index.
 *
 * If an out of bound index is found on CPU, an error is returned.
 *
 * Warning: There are some GPU specific semantics for this operation.
 *  - If an out of bound index is found, the index is ignored.
 *  - The order in which updates are applied is nondeterministic, so the output
 * will be nondeterministic if indices contains duplicates.
 * ```js
 * const shape = [8];
 * const tensor = tf.ones(shape);
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 *
 * tf.tensorScatterUpdate(tensor, indices, updates).print();
 *    //[1, 11, 1, 10, 9, 1, 1, 12]
 * ```
 *
 * @param tensor A Tensor. Tensor to copy/update.
 * @param indices The tensor contains the indices into the output tensor, must
 *     have at least 2 axes: (num_updates, index_depth).
 * @param updates The tensor contains the value for the indices.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $332a8f98d69e0a66$var$tensorScatterUpdate_(tensor, indices, updates) {
    const $tensor = (0, $010a899b69412c72$export$ede379c4c939d71a)(tensor, 'tensor', 'tensorScatterupdate');
    const $indices = (0, $010a899b69412c72$export$ede379c4c939d71a)(indices, 'indices', 'tensorScatterupdate', 'int32');
    const $updates = (0, $010a899b69412c72$export$ede379c4c939d71a)(updates, 'updates', 'tensorScatterupdate');
    $57b46503159dbf6f$export$4d09d4ac8ba225dd($updates, $indices, $tensor.shape);
    if ($tensor.dtype !== $updates.dtype) throw new Error(`tensor and updates must have the same dtype, instead they are ${$tensor.dtype} and ${$updates.dtype}.`);
    const inputs = {
        tensor: $tensor,
        indices: $indices,
        updates: $updates
    };
    const attrs = {};
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$20050a140fd1de77), inputs, attrs);
}
const $332a8f98d69e0a66$export$d3ac02769385eb36 = (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    tensorScatterUpdate_: $332a8f98d69e0a66$var$tensorScatterUpdate_
});



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Finds the values and indices of the `k` largest entries along the last
 * dimension.
 *
 * If the input is a vector (rank=1), finds the k largest entries in the vector
 * and outputs their values and indices as vectors. Thus values[j] is the j-th
 * largest entry in input, and its index is indices[j].
 * For higher rank inputs, computes the top k entries along the last dimension.
 *
 * If two elements are equal, the lower-index element appears first.
 *
 * ```js
 * const a = tf.tensor2d([[1, 5], [4, 3]]);
 * const {values, indices} = tf.topk(a);
 * values.print();
 * indices.print();
 * ```
 * @param x 1-D or higher `tf.Tensor` with last dimension being at least `k`.
 * @param k Number of top elements to look for along the last dimension.
 * @param sorted If true, the resulting `k` elements will be sorted by the
 *     values in descending order.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $95d6c1822e5bc026$var$topk_(x, k = 1, sorted = true) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'topk');
    if ($x.rank === 0) throw new Error('topk() expects the input to be of rank 1 or higher');
    const lastDim = $x.shape[$x.shape.length - 1];
    if (k < 0) throw new Error(`'k' passed to topk() must be >= 0 but got ${k}`);
    if (k > lastDim) throw new Error(`'k' passed to topk() must be <= the last dimension (${lastDim}) ` + `but got ${k}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        k: k,
        sorted: sorted
    };
    const [values, indices] = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c593cd1ea0d02ebd), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $95d6c1822e5bc026$export$4e6b28a600f8b4df = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    topk_: $95d6c1822e5bc026$var$topk_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates a `tf.Tensor` with values sampled from a truncated normal
 * distribution.
 *
 * ```js
 * tf.truncatedNormal([2, 2]).print();
 * ```
 *
 * The generated values follow a normal distribution with specified mean and
 * standard deviation, except that values whose magnitude is more than 2
 * standard deviations from the mean are dropped and re-picked.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output tensor.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $9ef055855a9c1b37$var$truncatedNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type $ { dtype }`);
    const randGauss = new (0, $5b7125fa6f9f7784$export$d23b64058df0188a)(mean, stdDev, dtype, true, seed);
    const res = (0, $d99273e33e31a4d2$export$ab1029bcae9ddb4a)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $9ef055855a9c1b37$export$8ad5625727f3fa1d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    truncatedNormal_: $9ef055855a9c1b37$var$truncatedNormal_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Finds unique elements along an axis of a tensor.
 *
 * It returns a tensor `values` containing all of the unique elements along the
 * `axis` of the given tensor `x` in the same order that they occur along the
 * `axis` in `x`; `x` does not need to be sorted. It also returns a tensor
 * `indices` the same size as the number of the elements in `x` along the `axis`
 * dimension. It contains the index in the unique output `values`.
 *
 * ```js
 * // A 1-D tensor
 * const a = tf.tensor1d([1, 1, 2, 4, 4, 4, 7, 8, 8]);
 * const {values, indices} = tf.unique(a);
 * values.print();   // [1, 2, 4, 7, 8,]
 * indices.print();  // [0, 0, 1, 2, 2, 2, 3, 4, 4]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=0
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 0)
 * values.print();   // [[1, 0, 0],
 *                   //  [2, 0, 0]]
 * indices.print();  // [0, 0, 1]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=1
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 1)
 * values.print();   // [[1, 0],
 *                   //  [1, 0],
 *                   //  [2, 0]]
 * indices.print();  // [0, 1, 1]
 * ```
 * @param x A tensor (int32, string, bool).
 * @param axis The axis of the tensor to find the unique elements.
 * @returns [uniqueElements, indices] (see above for details)
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $7c1158843694185a$var$unique_(x, axis = 0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'unique', 'string_or_numeric');
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)($x.rank > 0, ()=>'The input tensor must be at least 1D');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    const [values, indices] = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$8e3adf126971a183), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $7c1158843694185a$export$7a5d5c156e7dc406 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    unique_: $7c1158843694185a$var$unique_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Computes the sum along segments of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const segmentIds = tf.tensor1d([1, 2, 0, 1], 'int32');
 * const numSegments = 3;
 *
 * x.unsortedSegmentSum(segmentIds, numSegments).print()
 * //or tf.unsortedSegmentSum(x, segmentIds, numSegments)
 * ```
 * @param x The `tf.Tensor` that will be summed along its segments.
 * @param segmentIds A `tf.Tensor1D` whose rank is equal to the rank of `x`'s
 * dimension along the `axis`.  Maps each element of `x` to a segment.
 * @param numSegments The number of distinct `segmentIds`.
 *
 * @doc {heading: 'Operations', subheading: 'Segment'}
 */ function $9b1e231b583c89e6$var$unsortedSegmentSum_(x, segmentIds, numSegments) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'unsortedSegmentSum');
    const $segmentIds = (0, $010a899b69412c72$export$ede379c4c939d71a)(segmentIds, 'segmentIds', 'unsortedSegmentSum', 'int32');
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)((0, $5f8d0ee7a8d35dfe$export$357fc28f6427af8b)(numSegments), ()=>'numSegments must be of dtype int');
    const inputs = {
        x: $x,
        segmentIds: $segmentIds
    };
    const attrs = {
        numSegments: numSegments
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$af810663cded5fe2), inputs, attrs);
}
const $9b1e231b583c89e6$export$ba7c4d144d85a309 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    unsortedSegmentSum_: $9b1e231b583c89e6$var$unsortedSegmentSum_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Unstacks a `tf.Tensor` of rank-`R` into a list of rank-`(R-1)` `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * tf.unstack(a).forEach(tensor => tensor.print());
 * ```
 *
 * @param x A tensor object.
 * @param axis The axis to unstack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $c1775cdc84f05f72$var$unstack_(x, axis = 0) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'unstack', 'string_or_numeric');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(axis >= -$x.shape.length && axis < $x.shape.length, ()=>`Axis = ${axis} is not in [-${$x.shape.length}, ${$x.shape.length})`);
    const inputs = {
        value: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$441ad6bfc5db8ab4), inputs, attrs);
}
const $c1775cdc84f05f72$export$3c05285afa115eec = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    unstack_: $c1775cdc84f05f72$var$unstack_
});


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $d4c7a0e45e12e674$export$1e7f253df265a2ba(sortedSequence, values) {
    return (0, $4f8d2a80bf60195c$export$56fad8d65b0adbdd)(sortedSequence, values, 'right');
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $a7bfc0fb62924a2a$export$3a9d57cefcd2c285(initialValue, trainable = true, name, dtype) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).makeVariable(initialValue, trainable, name, dtype);
}



/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /** An implementation of the Where kernel shared between cpu and webgl */ 
function $f233c777c497de5b$export$3a1005f93c3f4453(condShape, condVals) {
    const indices = [];
    for(let i = 0; i < condVals.length; i++)if (condVals[i]) indices.push(i);
    const inBuffer = (0, $d99273e33e31a4d2$export$ab1029bcae9ddb4a)(condShape, 'int32');
    const out = (0, $d99273e33e31a4d2$export$ab1029bcae9ddb4a)([
        indices.length,
        condShape.length
    ], 'int32');
    for(let i = 0; i < indices.length; i++){
        const loc = inBuffer.indexToLoc(indices[i]);
        const offset = i * condShape.length;
        out.values.set(loc, offset);
    }
    return out.toTensor();
}



/**
 * Returns the coordinates of true elements of condition.
 *
 * The coordinates are returned in a 2-D tensor where the first dimension (rows)
 * represents the number of true elements, and the second dimension (columns)
 * represents the coordinates of the true elements. Keep in mind, the shape of
 * the output tensor can vary depending on how many true values there are in
 * input. Indices are output in row-major order. The resulting tensor has the
 * shape `[numTrueElems, condition.rank]`.
 *
 * This is analogous to calling the python `tf.where(cond)` without an x or y.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const result = await tf.whereAsync(cond);
 * result.print();
 * ```
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ async function $3fb1846d1fd1e918$var$whereAsync_(condition) {
    const $condition = (0, $010a899b69412c72$export$ede379c4c939d71a)(condition, 'condition', 'whereAsync', 'bool');
    const vals = await $condition.data();
    const res = (0, $f233c777c497de5b$export$3a1005f93c3f4453)($condition.shape, vals);
    if (condition !== $condition) $condition.dispose();
    return res;
}
const $3fb1846d1fd1e918$export$b95962138b7a377d = $3fb1846d1fd1e918$var$whereAsync_;




var $34d7e4c14c617766$exports = {};

$parcel$export($34d7e4c14c617766$exports, "booleanMaskAsync", () => $34d7e4c14c617766$export$358a56c181f796b3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Apply boolean mask to tensor.
 *
 * ```js
 * const tensor = tf.tensor2d([1, 2, 3, 4, 5, 6], [3, 2]);
 * const mask = tf.tensor1d([1, 0, 1], 'bool');
 * const result = await tf.booleanMaskAsync(tensor, mask);
 * result.print();
 * ```
 *
 * @param tensor N-D tensor.
 * @param mask K-D boolean tensor, K <= N and K must be known statically.
 * @param axis A 0-D int Tensor representing the axis in tensor to mask from.
 *     By default, axis is 0 which will mask from the first dimension.
 *     Otherwise K + axis <= N.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ async function $34d7e4c14c617766$var$booleanMaskAsync_(tensor, mask, axis) {
    const $tensor = (0, $010a899b69412c72$export$ede379c4c939d71a)(tensor, 'tensor', 'boolMask');
    const $mask = (0, $010a899b69412c72$export$ede379c4c939d71a)(mask, 'mask', 'boolMask', 'bool');
    const axisFrom = axis == null ? 0 : axis;
    const maskDim = $mask.rank;
    const tensorShape = $tensor.shape;
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(maskDim > 0, ()=>'mask cannot be scalar');
    $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782(tensorShape.slice(axisFrom, axisFrom + maskDim), $mask.shape, `mask's shape must match the first K dimensions of tensor's shape,`);
    let leadingSize = 1;
    for(let i = axisFrom; i < axisFrom + maskDim; i++)leadingSize *= tensorShape[i];
    const targetTensorShape = tensorShape.slice(0, axisFrom).concat([
        leadingSize
    ], tensorShape.slice(axisFrom + maskDim));
    const reshapedTensor = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($tensor, targetTensorShape);
    const reshapedMask = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($mask, [
        -1
    ]);
    const positivePositions = await (0, $3fb1846d1fd1e918$export$b95962138b7a377d)(reshapedMask);
    const indices = (0, $f41010297af56801$export$889c931173b77c2f)(positivePositions, [
        1
    ]);
    const res = (0, $27ff7ccdc5033e17$export$9e05546f00427e8)(reshapedTensor, indices, axisFrom);
    // Ensure no memory leak.
    if (tensor !== $tensor) $tensor.dispose();
    if (mask !== $mask) $mask.dispose();
    indices.dispose();
    reshapedTensor.dispose();
    reshapedMask.dispose();
    positivePositions.dispose();
    return res;
}
const $34d7e4c14c617766$export$358a56c181f796b3 = $34d7e4c14c617766$var$booleanMaskAsync_;




var $c2af547bb790802f$exports = {};

$parcel$export($c2af547bb790802f$exports, "movingAverage", () => $c2af547bb790802f$export$e0ccbd22a5b3aab6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 









/**
 * Compute the moving average of a variable.
 *
 * Without zeroDebias, the moving average operation is defined by:
 *   `v += delta`
 * where
 *   `delta = (1 - decay) * (x - v)`
 *
 * With zeroDebias (default), the `delta` term is scaled to debias the
 * effect of the (assumed) zero-initialization of `v`.
 *   `delta /= (1 - decay ^ step)`
 *
 * For more details on the zero-debiasing algorithm, see:
 *   https://arxiv.org/abs/1412.6980
 *
 * Note that this function is completely stateless and does not keep track of
 * step count. The step count needs to be maintained by the caller and passed
 * in as `step`.
 *
 * @param v The current moving average value.
 * @param x New input value, must have the same shape and dtype as `v`.
 * @param decay The decay factor. Typical values are 0.95 and 0.99.
 * @param step Step count.
 * @param zeroDebias: Whether zeroDebias is to be performed (default: `true`).
 * @returns The new moving average value.
 *
 * @doc {heading: 'Operations', subheading: 'Moving Average'}
 */ function $c2af547bb790802f$var$movingAverage_(v, x, decay, step, zeroDebias = true) {
    const $v = (0, $010a899b69412c72$export$ede379c4c939d71a)(v, 'v', 'movingAverage');
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'movingAverage');
    const $decay = (0, $010a899b69412c72$export$ede379c4c939d71a)(decay, 'decay', 'movingAverage');
    (0, $28f820f91d9287a3$export$8a66522456343d17)($v, $x);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($5f8d0ee7a8d35dfe$export$234180f8206db11b($v.shape, $x.shape), ()=>'Shape mismatch in v and x');
    const one = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(1);
    const oneMinusDecay = (0, $555d660851b98db3$export$f93b5905241a7cca)(one, $decay);
    let update = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $555d660851b98db3$export$f93b5905241a7cca)($x, $v), oneMinusDecay);
    if (zeroDebias) {
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(step != null, ()=>'When using zeroDebias: true, step is required.');
        const $step = (0, $010a899b69412c72$export$ede379c4c939d71a)(step, 'step', 'movingAverage');
        update = (0, $15928a4fee5ff81f$export$159d9494db57879b)(update, (0, $555d660851b98db3$export$f93b5905241a7cca)(one, (0, $76ec324d3dfd83d3$export$9c297f60e22e3389)($decay, $step)));
    }
    return (0, $c90bd95bc0e58efa$export$e16d8520af44a096)($v, update);
}
const $c2af547bb790802f$export$e0ccbd22a5b3aab6 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    movingAverage_: $c2af547bb790802f$var$movingAverage_
});


var $34a8afa76c8632d3$exports = {};

$parcel$export($34a8afa76c8632d3$exports, "scatterND", () => $34a8afa76c8632d3$export$5349ba4fee4e4c76);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices within a zero tensor of the given shape tensor according to
 * indices. This operator is the inverse of the `tf.gatherND` operator which
 * extracts values or slices from a given tensor.
 *
 * ```js
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 * const shape = [8];
 * tf.scatterND(indices, updates, shape).print() //[0, 11, 0, 10, 9, 0, 0, 12]
 * ```
 *
 * @param indices The tensor contains the indices into the output tensor.
 * @param updates The tensor contains the value for the indices.
 * @param shape: The shape of the output tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $34a8afa76c8632d3$var$scatterND_(indices, updates, shape) {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(shape);
    const $indices = (0, $010a899b69412c72$export$ede379c4c939d71a)(indices, 'indices', 'scatterND', 'int32');
    const $updates = (0, $010a899b69412c72$export$ede379c4c939d71a)(updates, 'updates', 'scatterND');
    $57b46503159dbf6f$export$4d09d4ac8ba225dd($updates, $indices, shape);
    const inputs = {
        indices: $indices,
        updates: $updates
    };
    const attrs = {
        shape: shape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$28eef6f0168af686), inputs, attrs);
}
const $34a8afa76c8632d3$export$5349ba4fee4e4c76 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    scatterND_: $34a8afa76c8632d3$var$scatterND_
});



var $f22637d8b9b4b458$exports = {};

$parcel$export($f22637d8b9b4b458$exports, "sparseToDense", () => $f22637d8b9b4b458$export$1be4b823dd1a3080);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Validate sparseToDense inputs.
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape number[]. Shape of the dense output tensor.
 * @param validateIndices boolean. indice validation is not supported, error
 * will be thrown if it is set.
 */ function $8efbdd38ab89bffe$export$4d09d4ac8ba225dd(sparseIndices, sparseValues, outputShape, defaultValues) {
    if (sparseIndices.dtype !== 'int32') throw new Error('tf.sparseToDense() expects the indices to be int32 type,' + ` but the dtype was ${sparseIndices.dtype}.`);
    if (sparseIndices.rank > 2) throw new Error('sparseIndices should be a scalar, vector, or matrix,' + ` but got shape ${sparseIndices.shape}.`);
    const numElems = sparseIndices.rank > 0 ? sparseIndices.shape[0] : 1;
    const numDims = sparseIndices.rank > 1 ? sparseIndices.shape[1] : 1;
    if (outputShape.length !== numDims) throw new Error('outputShape has incorrect number of elements:,' + ` ${outputShape.length}, should be: ${numDims}.`);
    const numValues = sparseValues.size;
    if (!(sparseValues.rank === 0 || sparseValues.rank === 1 && numValues === numElems)) throw new Error('sparseValues has incorrect shape ' + `${sparseValues.shape}, should be [] or [${numElems}]`);
    if (sparseValues.dtype !== defaultValues.dtype) throw new Error('sparseValues.dtype must match defaultValues.dtype');
}





/**
 * Converts a sparse representation into a dense tensor.
 *
 * Builds an array dense with shape outputShape such that:
 *
 * // If sparseIndices is scalar
 * dense[i] = (i == sparseIndices ? sparseValues : defaultValue)
 *
 * // If sparseIndices is a vector, then for each i
 * dense[sparseIndices[i]] = sparseValues[i]
 *
 * // If sparseIndices is an n by d matrix, then for each i in [0, n)
 * dense[sparseIndices[i][0], ..., sparseIndices[i][d-1]] = sparseValues[i]
 * All other values in dense are set to defaultValue. If sparseValues is a
 * scalar, all sparse indices are set to this single value.
 *
 * If indices are repeated the final value is summed over all values for those
 * indices.
 *
 * ```js
 * const indices = tf.tensor1d([4, 5, 6, 1, 2, 3], 'int32');
 * const values = tf.tensor1d([10, 11, 12, 13, 14, 15], 'float32');
 * const shape = [8];
 * tf.sparseToDense(indices, values, shape).print();
 * ```
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape Shape of the dense output tensor. The type is inferred.
 * @param defaultValue Scalar. Value to set for indices not specified in
 * sparseIndices. Defaults to zero.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $f22637d8b9b4b458$var$sparseToDense_(sparseIndices, sparseValues, outputShape, defaultValue = 0) {
    (0, $5f8d0ee7a8d35dfe$export$3d8b7619bac22cf5)(outputShape);
    const $sparseIndices = (0, $010a899b69412c72$export$ede379c4c939d71a)(sparseIndices, 'sparseIndices', 'sparseToDense', 'int32');
    const $sparseValues = (0, $010a899b69412c72$export$ede379c4c939d71a)(sparseValues, 'sparseValues', 'sparseToDense', 'string_or_numeric');
    const $defaultValue = (0, $010a899b69412c72$export$ede379c4c939d71a)(defaultValue, 'defaultValue', 'sparseToDense', $sparseValues.dtype);
    $8efbdd38ab89bffe$export$4d09d4ac8ba225dd($sparseIndices, $sparseValues, outputShape, $defaultValue);
    const inputs = {
        sparseIndices: $sparseIndices,
        sparseValues: $sparseValues,
        defaultValue: $defaultValue
    };
    const attrs = {
        outputShape: outputShape
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$2c426709a9332421), inputs, attrs);
}
const $f22637d8b9b4b458$export$1be4b823dd1a3080 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sparseToDense_: $f22637d8b9b4b458$var$sparseToDense_
});


var $420a1e3ced22d90d$exports = {};

$parcel$export($420a1e3ced22d90d$exports, "gatherND", () => $420a1e3ced22d90d$export$15ec1b40f43d319f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Gather slices from input tensor into a Tensor with shape specified by
 * `indices`.
 *
 * `indices` is a K-dimensional integer tensor, best thought of as a
 * (K-1)-dimensional tensor of indices into input, where each element defines a
 * slice of input:
 * output[\\(i_0, ..., i_{K-2}\\)] = input[indices[\\(i_0, ..., i_{K-2}\\)]]
 *
 * Whereas in `tf.gather`, `indices` defines slices into the first dimension of
 * input, in `tf.gatherND`, `indices` defines slices into the first N dimensions
 * of input, where N = indices.shape[-1].
 *
 * The last dimension of indices can be at most the rank of input:
 * indices.shape[-1] <= input.rank
 *
 * The last dimension of `indices` corresponds to elements
 * (if indices.shape[-1] == input.rank) or slices
 * (if indices.shape[-1] < input.rank) along dimension indices.shape[-1] of
 * input.
 * The output tensor has shape
 * indices.shape[:-1] + input.shape[indices.shape[-1]:]
 *
 * Note that on CPU, if an out of bound index is found, an error is returned. On
 * GPU, if an out of bound index is found, a 0 is stored in the corresponding
 * output value.
 *
 * ```js
 * const indices = tf.tensor2d([0, 1, 1, 0], [2,2], 'int32');
 * const input = tf.tensor2d([9, 10, 11, 12], [2, 2]);
 * tf.gatherND(input, indices).print() // [10, 11]
 * ```
 *
 * @param x The tensor from which to gather values.
 * @param indices Index tensor, must be of type int32.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $420a1e3ced22d90d$var$gatherND_(x, indices) {
    const $indices = (0, $010a899b69412c72$export$ede379c4c939d71a)(indices, 'indices', 'gatherND', 'int32');
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'gatherND', 'string_or_numeric');
    const inputs = {
        params: $x,
        indices: $indices
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$4ef6e37a23721703), inputs);
}
const $420a1e3ced22d90d$export$15ec1b40f43d319f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    gatherND_: $420a1e3ced22d90d$var$gatherND_
});


var $3e23b5eb4f133b27$exports = {};

$parcel$export($3e23b5eb4f133b27$exports, "dropout", () => $3e23b5eb4f133b27$export$fe05aa12367b4e47);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $189f4fc2b10a031f$export$5cc59b1f6d856c8e(x, noiseShape) {
    if (noiseShape == null) return x.shape.slice();
    if ($5f8d0ee7a8d35dfe$export$234180f8206db11b(x.shape, noiseShape)) return noiseShape;
    if (x.shape.length === noiseShape.length) {
        const newDimension = [];
        for(let i = 0; i < x.shape.length; i++)if (noiseShape[i] == null && x.shape[i] != null) newDimension.push(x.shape[i]);
        else newDimension.push(noiseShape[i]);
        return newDimension;
    }
    return noiseShape;
}






/**
 * Computes dropout.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 2, 1]);
 * const rate = 0.75;
 * const output = tf.dropout(x, rate);
 * output.print();
 * ```
 *
 * @param x A floating point Tensor or TensorLike.
 * @param rate A float in the range [0, 1). The probability that each element
 *   of x is discarded.
 * @param noiseShape An array of numbers of type int32, representing the
 * shape for randomly generated keep/drop flags. If the noiseShape has null
 * value, it will be automatically replaced with the x's relative dimension
 * size. Optional.
 * @param seed Used to create random seeds. Optional.
 * @returns A Tensor of the same shape of x.
 *
 * @doc {heading: 'Operations', subheading: 'Dropout'}
 */ function $3e23b5eb4f133b27$var$dropout_(x, rate, noiseShape, seed) {
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'dropout');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($x.dtype === 'float32', ()=>`x has to be a floating point tensor since it's going to be ` + `scaled, but got a ${$x.dtype} tensor instead.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(rate >= 0 && rate < 1, ()=>`rate must be a float in the range [0, 1), but got ${rate}.`);
    if (rate === 0) return x instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? $x.clone() : $x;
    const $noiseShape = (0, $189f4fc2b10a031f$export$5cc59b1f6d856c8e)($x, noiseShape);
    const keepProb = 1 - rate;
    const multiplier = (0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $3a38c7b29dbfd7e8$export$a3fe094919f356fd)((0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $dee4b5fc7aecfad3$export$bd6fd37822e292fa)($noiseShape, 0, 1, 'float32', seed), keepProb)), keepProb);
    return (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($x, multiplier);
}
const $3e23b5eb4f133b27$export$fe05aa12367b4e47 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    dropout_: $3e23b5eb4f133b27$var$dropout_
});


var $de4d87485d0c1285$exports = {};

$parcel$export($de4d87485d0c1285$exports, "enclosingPowerOfTwo", () => $de4d87485d0c1285$export$6fc2fe3b19043bf3);
$parcel$export($de4d87485d0c1285$exports, "cosineWindow", () => $de4d87485d0c1285$export$e875398ce092ee45);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $de4d87485d0c1285$export$6fc2fe3b19043bf3(value) {
    // Return 2**N for integer N such that 2**N >= value.
    return Math.floor(Math.pow(2, Math.ceil(Math.log(value) / Math.log(2.0))));
}
function $de4d87485d0c1285$export$e875398ce092ee45(windowLength, a, b) {
    const even = 1 - windowLength % 2;
    const newValues = new Float32Array(windowLength);
    for(let i = 0; i < windowLength; ++i){
        const cosArg = 2.0 * Math.PI * i / (windowLength + even - 1);
        newValues[i] = a - b * Math.cos(cosArg);
    }
    return (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)(newValues, 'float32');
}


var $019203b68c50a423$exports = {};

$parcel$export($019203b68c50a423$exports, "inTopKAsync", () => $019203b68c50a423$export$395be9a27e7de9f0);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * Returns whether the targets are in the top K predictions.
 *
 * ```js
 * const predictions = tf.tensor2d([[20, 10, 40, 30], [30, 50, -20, 10]]);
 * const targets = tf.tensor1d([2, 0]);
 * const precision = await tf.inTopKAsync(predictions, targets);
 * precision.print();
 * ```
 * @param predictions 2-D or higher `tf.Tensor` with last dimension being
 *     at least `k`.
 * @param targets 1-D or higher `tf.Tensor`.
 * @param k Optional Number of top elements to look at for computing precision,
 *     default to 1.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ async function $019203b68c50a423$var$inTopKAsync_(predictions, targets, k = 1) {
    const $predictions = (0, $010a899b69412c72$export$ede379c4c939d71a)(predictions, 'predictions', 'inTopK');
    const $targets = (0, $010a899b69412c72$export$ede379c4c939d71a)(targets, 'targets', 'inTopK');
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)($predictions.rank > 1, ()=>'inTopK() expects the predictions to be of rank 2 or higher, ' + `but got ${$predictions.rank}`);
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)($predictions.rank - 1 === $targets.rank, ()=>`predictions rank should be 1 larger than ` + `targets rank, but got predictions rank ` + `${$predictions.rank} and targets rank ${$targets.rank}`);
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($predictions.shape.slice(0, $predictions.shape.length - 1), $targets.shape, `predictions's shape should be align with the targets' shape, ` + 'except the last dimension.');
    const lastDim = $predictions.shape[$predictions.shape.length - 1];
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(k > 0 && k <= lastDim, ()=>`'k' passed to inTopK() must be > 0 && <= the predictions last ` + `dimension (${lastDim}), but got ${k}`);
    const predictionsVals = await $predictions.data();
    const targetsVals = await $targets.data();
    // Reshape predictionsVals into a 2d tensor [batch, lastDim]
    // and look up topK along lastDim.
    const [batch, size] = [
        predictionsVals.length / lastDim,
        lastDim
    ];
    const precision = (0, $5f8d0ee7a8d35dfe$export$3b783bdb77632623)('bool', batch);
    for(let b = 0; b < batch; b++){
        const offset = b * size;
        const vals = predictionsVals.subarray(offset, offset + size);
        const valAndInd = [];
        for(let i = 0; i < vals.length; i++)valAndInd.push({
            value: vals[i],
            index: i
        });
        valAndInd.sort((a, b)=>b.value - a.value);
        precision[b] = 0;
        for(let i = 0; i < k; i++)if (valAndInd[i].index === targetsVals[b]) {
            precision[b] = 1;
            break;
        }
    }
    if (predictions !== $predictions) $predictions.dispose();
    if (targets !== $targets) $targets.dispose();
    // Output precision has the same shape as targets.
    return (0, $a82c6773538d9e64$export$65df3ad1ad888abb)(precision, $targets.shape, 'bool');
}
const $019203b68c50a423$export$395be9a27e7de9f0 = $019203b68c50a423$var$inTopKAsync_;



var $e4d1a64069662ad4$exports = {};

$parcel$export($e4d1a64069662ad4$exports, "conv2d", () => $4df4bb602b8b2d4d$export$188f9215482e3db8);
$parcel$export($e4d1a64069662ad4$exports, "depthwiseConv2d", () => $98bcd9d17e6878df$export$48a8ad9494a8fad8);
$parcel$export($e4d1a64069662ad4$exports, "matMul", () => $108d671c8c951392$export$6706882a873e9a8f);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 








/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the derivative of the filter of a 2D convolution.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     [batch, height, width, inChannels]. If rank 3, batch of 1 is assumed.
 * @param dy The dy image, of rank 4 or rank 3, of shape
 *     [batch, height, width, outDepth]. If rank 3, batch of 1 is assumed.
 * @param filterShape The shape of the filter, length 4,
 *     [filterHeight, filterWidth, inDepth, outDepth].
 * @param strides The strides of the convolution: [strideHeight,
 * strideWidth].
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $38f8fd3cc4e72bb6$var$conv2DBackpropFilter_(x, dy, filterShape, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in conv2dDerFilter: input must be rank 4, but got shape ` + `${x4D.shape}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dy4D.rank === 4, ()=>`Error in conv2dDerFilter: dy must be rank 4, but got shape ` + `${dy4D.shape}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(filterShape.length === 4, ()=>`Error in conv2dDerFilter: filterShape must be length 4, but got ` + `${filterShape}.`);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(inDepth === filterShape[2], ()=>`Error in conv2dDerFilter: depth of input ${inDepth}) must ` + `match input depth in filter (${filterShape[2]}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(outDepth === filterShape[3], ()=>`Error in conv2dDerFilter: depth of dy (${outDepth}) must ` + `match output depth for filter (${filterShape[3]}).`);
    $b3e4d1c19b78487c$export$1b3400c26a44af8('conv2dDerFilter', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$32a8943c0f1ca5a7), inputs, attrs);
}
const $38f8fd3cc4e72bb6$export$652a30c9379f3de7 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    conv2DBackpropFilter_: $38f8fd3cc4e72bb6$var$conv2DBackpropFilter_
});




var $86c60a0aff9fcea2$exports = {};

$parcel$export($86c60a0aff9fcea2$exports, "getFusedDyActivation", () => $86c60a0aff9fcea2$export$a1905aed55f51aef);
$parcel$export($86c60a0aff9fcea2$exports, "getFusedBiasGradient", () => $86c60a0aff9fcea2$export$1a797e236ae09d1f);
$parcel$export($86c60a0aff9fcea2$exports, "applyActivation", () => $86c60a0aff9fcea2$export$a0f250a2ba84196);
$parcel$export($86c60a0aff9fcea2$exports, "shouldFuse", () => $86c60a0aff9fcea2$export$4904add493b957ab);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 










function $86c60a0aff9fcea2$export$a1905aed55f51aef(dy, y, activation) {
    if (activation == null || activation === 'linear') return dy;
    if (activation === 'relu') return (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(dy, (0, $ff8982de7da7934b$export$35d34bc0ed591a92)(y));
    throw new Error(`Cannot compute gradient for fused activation ${activation}.`);
}
function $86c60a0aff9fcea2$export$1a797e236ae09d1f(bias, dyActivation) {
    let res = dyActivation;
    const reduceAxes = $642a122b4608acc0$export$9f11ec258a9b2804(bias.shape, dyActivation.shape);
    if (reduceAxes.length > 0) res = (0, $7215cb99724b7643$export$8a63f25cc62965f1)(res, reduceAxes);
    return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, bias.shape);
}
function $86c60a0aff9fcea2$export$a0f250a2ba84196(x, activation, preluActivationWeights, leakyreluAlpha) {
    if (activation === 'linear') return x;
    else if (activation === 'relu') return (0, $633a7fface57265e$export$16d1e4612cc0139f)(x);
    else if (activation === 'elu') return (0, $5c36ca87265596d3$export$796b583dd79d8524)(x);
    else if (activation === 'relu6') return (0, $b4b08408f5ab9172$export$4a62bcb95e9c44c4)(x);
    else if (activation === 'prelu') return (0, $751df8e2647ea232$export$5882f235222e6729)(x, preluActivationWeights);
    else if (activation === 'leakyrelu') return (0, $2e1cdcc1e07e834e$export$23a860e40a2c6b61)(x, leakyreluAlpha);
    else if (activation === 'sigmoid') return (0, $e3381678584872cc$export$3b295495ca3cad7c)(x);
    throw new Error(`Unknown fused activation ${activation}.`);
}
const $86c60a0aff9fcea2$export$4904add493b957ab = (gradientDepth, activation)=>{
    const gradientMode = gradientDepth > 0;
    return !gradientMode || activation === 'linear';
};




/**
 * Computes a 2D convolution over the input x, optionally fused with adding a
 * bias and applying an activation.
 *
 * ```js
 * const inputDepth = 2;
 * const inShape = [2, 2, 2, inputDepth];
 * const outputDepth = 2;
 * const fSize = 1;
 * const pad = 0;
 * const strides = 1;
 *
 * const x = tf.tensor4d( [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
 * 16], inShape);
 * const w = tf.tensor4d([-1, 1, -2, 0.5], [fSize, fSize, inputDepth,
 * outputDepth]);
 *
 * tf.fused.conv2d({ x, filter: w, strides, pad, dataFormat: 'NHWC',
 * dilations: [1, 1], bias: tf.scalar(5), activation: 'relu' }).print();
 * ```
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid` output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`) to be
 *     applied
 *      after biasAdd.
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $4df4bb602b8b2d4d$var$fusedConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    activation = activation || 'linear';
    if ((0, $86c60a0aff9fcea2$export$4904add493b957ab)((0, $249f84ddb1ced836$export$33b63313cc511a3b).state.gradientDepth, activation) === false) {
        // TODO: Transpose bias and preluActivationWeights properly for NCHW
        // format before computation.
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dataFormat === 'NHWC', ()=>`Error in fused conv2d: got dataFormat of ${dataFormat} but ` + `only NHWC is currently supported for the case of gradient depth ` + `is 0 and the activation is not linear.`);
        let result = (0, $43815144b11940c7$export$188f9215482e3db8)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(result, bias);
        return (0, $86c60a0aff9fcea2$export$a0f250a2ba84196)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $010a899b69412c72$export$ede379c4c939d71a)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in fused conv2d: input must be rank 4, but got rank ` + `${x4D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($filter.rank === 4, ()=>`Error in fused conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $b3e4d1c19b78487c$export$1b3400c26a44af8('fused conv2d', pad, dimRoundingMode);
    const inputChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($filter.shape[2] === inputChannels, ()=>`Error in conv2d: depth of input (${inputChannels}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $b3e4d1c19b78487c$export$fdd37387e0a3c672(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode);
    let $bias;
    if (bias != null) {
        $bias = (0, $010a899b69412c72$export$ede379c4c939d71a)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($bias, $x);
        // According to TensorFlow, the bias is supposed be a 1-D tensor or a
        // scalar.
        //
        // 3-D or 4-D bias is not disabled for NHWC format, because they are
        // currently being used in some cases. For examplem in our code base,
        // https://github.com/tensorflow/tfjs/blob/b53bd47e880367ae57493f0ea628abaf08db2d5d/tfjs-core/src/ops/fused/fused_conv2d_test.ts#L1972.
        if (dataFormat === 'NHWC') $642a122b4608acc0$export$a3e2a38a57ec8318(convInfo.outShape, $bias.shape);
        else {
            $5f8d0ee7a8d35dfe$export$a7a9523472993e97($bias.shape.length <= 1, ()=>`Error in fused conv2d: only supports scalar or 1-D Tensor ` + `bias for NCHW format but got the bias of ` + `rank-${$bias.shape.length}.`);
            $5f8d0ee7a8d35dfe$export$a7a9523472993e97($bias.shape.length === 0 || $bias.shape[0] === convInfo.outChannels || $bias.shape[0] === 1, ()=>`Error in fused conv2d: bias shape (${$bias.shape}) is not ` + `compatible with the number of output channels ` + `(${convInfo.outChannels})`);
        }
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) {
        // PReLU's activation weights could be a scalar, a 1-D tensor or a 3-D
        // tensor.
        const alphaShape = preluActivationWeights.shape;
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(alphaShape.length <= 1 || alphaShape.length === 3, ()=>`Error in fused conv2d: only supports scalar, 1-D Tensor or ` + `3-D Tensor PReLU activation weights but got a tensor of ` + `rank-${alphaShape.length}.`);
        if (alphaShape.length === 1) // Whether the data format is NCHW or NHWC, the 1-D PReLU activation
        // weights tensor should be aligned with the output channels of conv2d
        // result.
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(alphaShape[0] === 1 || alphaShape[0] === convInfo.outChannels, ()=>`Error in fused conv2d: PReLU activation weights ` + `(${alphaShape}) is not compatible with the number of output ` + `channels (${convInfo.outChannels}).`);
        else if (alphaShape.length === 3) // Whether the data format is NCHW or NHWC, the PReLU activation weights
        // tensor should has the compatible shape with the result of conv2d.
        try {
            $642a122b4608acc0$export$a3e2a38a57ec8318(alphaShape, convInfo.outShape);
        } catch (e) {
            const errMsg = `Error in fused conv2d: PReLU activation weights (${alphaShape}) ` + `is not compatible with the output shape of the conv2d ` + `(${convInfo.outShape}).`;
            throw Error(errMsg);
        }
        $preluActivationWeights = (0, $010a899b69412c72$export$ede379c4c939d71a)(preluActivationWeights, 'prelu weights', 'fused conv2d');
    }
    const grad = (dy, saved)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(dataFormat === 'NHWC', ()=>`Error in gradient of fused conv2D: got dataFormat of ${dataFormat} but only NHWC is currently supported.`);
        const [$filter, x4D, y, $bias] = saved;
        const dyActivation = (0, $86c60a0aff9fcea2$export$a1905aed55f51aef)(dy, y, activation);
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$f16174446c2d5b2a(dilations), ()=>'Error in gradient of fused conv2D: ' + `dilation rates greater than 1 ` + `are not yet supported in gradients. Got dilations '${dilations}'`);
        const xDer = (0, $4897cf7297aaab1d$export$633310eed0c26e72)(x4D.shape, dyActivation, $filter, strides, pad);
        const filterDer = (0, $38f8fd3cc4e72bb6$export$652a30c9379f3de7)(x4D, dyActivation, $filter.shape, strides, pad);
        const der = [
            xDer,
            filterDer
        ];
        if ($bias != null) {
            const biasDer = (0, $86c60a0aff9fcea2$export$1a797e236ae09d1f)($bias, dyActivation);
            der.push(biasDer);
        }
        return der;
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $694041655139423f$export$5519f0eeb00c44e5)((x4D, filter, save)=>{
            let res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$86f8a8e3a8f2a8f2), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $694041655139423f$export$5519f0eeb00c44e5)((x4D, filter, bias, save)=>{
            let res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$86f8a8e3a8f2a8f2), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $4df4bb602b8b2d4d$export$188f9215482e3db8 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    fusedConv2d_: $4df4bb602b8b2d4d$var$fusedConv2d_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 









/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $ddcf36ad6325e4f6$var$depthwiseConv2dNativeBackpropFilter_(x, dy, filterShape, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c99f139e0d4d1833), inputs, attrs);
}
const $ddcf36ad6325e4f6$export$cc0ae65e9edc7e1a = (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    depthwiseConv2dNativeBackpropFilter_: $ddcf36ad6325e4f6$var$depthwiseConv2dNativeBackpropFilter_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



function $12cb10ef30bd47e6$var$depthwiseConv2dNativeBackpropInput_(xShape, dy, filter, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
    }
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        inputShape: xShape
    };
    const res = // tslint:disable-next-line: no-unnecessary-type-assertion
    (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$8649ca3b17033a24), inputs, attrs);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $12cb10ef30bd47e6$export$37e2ab95a4a4c24b = (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    depthwiseConv2dNativeBackpropInput_: $12cb10ef30bd47e6$var$depthwiseConv2dNativeBackpropInput_
});





/**
 * Computes depthwise 2D convolution, optionally fused with adding a
 * bias and applying an activation.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`).
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $98bcd9d17e6878df$var$fusedDepthwiseConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    if ((0, $86c60a0aff9fcea2$export$4904add493b957ab)((0, $249f84ddb1ced836$export$33b63313cc511a3b).state.gradientDepth, activation) === false) {
        let result = (0, $0d28c12ba7a09138$export$48a8ad9494a8fad8)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(result, bias);
        return (0, $86c60a0aff9fcea2$export$a0f250a2ba84196)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $010a899b69412c72$export$ede379c4c939d71a)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $010a899b69412c72$export$ede379c4c939d71a)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.rank === 4, ()=>`Error in fused depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($filter.rank === 4, ()=>`Error in fused depthwiseConv2d: filter must be rank 4, ` + `but got rank ${$filter.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(x4D.shape[3] === $filter.shape[2], ()=>`Error in fused depthwiseConv2d: number of input channels ` + `(${x4D.shape[3]}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    if (dilations == null) dilations = [
        1,
        1
    ];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$1e13dbff91e2f5ca(strides, dilations), ()=>'Error in fused depthwiseConv2d: Either strides or dilations must ' + `be 1. Got strides ${strides} and dilations '${dilations}'`);
    $b3e4d1c19b78487c$export$1b3400c26a44af8('fused depthwiseConv2d', pad, dimRoundingMode);
    const convInfo = $b3e4d1c19b78487c$export$fdd37387e0a3c672(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode, true);
    let $bias;
    if (bias != null) {
        $bias = (0, $010a899b69412c72$export$ede379c4c939d71a)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($bias, $x);
        $642a122b4608acc0$export$a3e2a38a57ec8318(convInfo.outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $010a899b69412c72$export$ede379c4c939d71a)(preluActivationWeights, 'prelu weights', 'fused depthwiseConv2d');
    const grad = (dy, saved)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97($b3e4d1c19b78487c$export$f16174446c2d5b2a(dilations), ()=>'Error in gradient of fused depthwiseConv2d: dilation rates ' + `greater than 1 are not yet supported. Got dilations ` + `'${dilations}'`);
        const [$filter, x4D, y, bias] = saved;
        const dyActivation = (0, $86c60a0aff9fcea2$export$a1905aed55f51aef)(dy, y, activation);
        const xDer = (0, $12cb10ef30bd47e6$export$37e2ab95a4a4c24b)(x4D.shape, dyActivation, $filter, strides, pad, dilations, dimRoundingMode);
        const filterDer = (0, $ddcf36ad6325e4f6$export$cc0ae65e9edc7e1a)(x4D, dyActivation, $filter.shape, strides, pad, dilations, dimRoundingMode);
        if (bias != null) {
            const biasDer = (0, $86c60a0aff9fcea2$export$1a797e236ae09d1f)($bias, dyActivation);
            return [
                xDer,
                filterDer,
                biasDer
            ];
        }
        return [
            xDer,
            filterDer
        ];
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $694041655139423f$export$5519f0eeb00c44e5)((x4D, filter, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$5a249e8f498c02c1), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $694041655139423f$export$5519f0eeb00c44e5)((x4D, filter, bias, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$5a249e8f498c02c1), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $98bcd9d17e6878df$export$48a8ad9494a8fad8 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    fusedDepthwiseConv2d_: $98bcd9d17e6878df$var$fusedDepthwiseConv2d_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 











/**
 * Computes the dot product of two matrices with optional activation and bias.
 *
 * ```js
 * const a = tf.tensor2d([-1, -2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const bias = tf.tensor2d([1, 2], [1, 2]);
 *
 * tf.fused.matMul({a, b, bias, activation: 'relu'}).print();
 * ```
 *
 * @param obj An object with the following properties:
 * - `a` First matrix in dot product operation.
 * - `b` Second matrix in dot product operation.
 * - `transposeA` If true, `a` is transposed before multiplication.
 * - `transposeB` If true, `b` is transposed before multiplication.
 * - `bias` Matrix to be added to the result.
 * - `activation` Name of activation kernel (defaults to `linear`).
 * - `preluActivationWeights` Tensor of prelu weights.
 * - `leakyreluAlpha` Alpha of leakyrelu.
 */ function $108d671c8c951392$var$fusedMatMul_({ a: a, b: b, transposeA: transposeA = false, transposeB: transposeB = false, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha = 0.2 }) {
    if ((0, $86c60a0aff9fcea2$export$4904add493b957ab)((0, $249f84ddb1ced836$export$33b63313cc511a3b).state.gradientDepth, activation) === false) {
        let result = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(a, b, transposeA, transposeB);
        if (bias != null) result = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(result, bias);
        return (0, $86c60a0aff9fcea2$export$a0f250a2ba84196)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    let $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'fused matMul');
    let $b = (0, $010a899b69412c72$export$ede379c4c939d71a)(b, 'b', 'fused matMul');
    [$a, $b] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($a, $b);
    const innerShapeA = transposeA ? $a.shape[$a.rank - 2] : $a.shape[$a.rank - 1];
    const innerShapeB = transposeB ? $b.shape[$b.rank - 1] : $b.shape[$b.rank - 2];
    const outerShapeA = transposeA ? $a.shape[$a.rank - 1] : $a.shape[$a.rank - 2];
    const outerShapeB = transposeB ? $b.shape[$b.rank - 2] : $b.shape[$b.rank - 1];
    const outerDimsA = $a.shape.slice(0, -2);
    const outerDimsB = $b.shape.slice(0, -2);
    const batchDimA = $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f(outerDimsA);
    const batchDimB = $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f(outerDimsB);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(innerShapeA === innerShapeB, ()=>`Error in fused matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${$a.shape} and ` + `${$b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const outShapeOuterDims = $642a122b4608acc0$export$a3e2a38a57ec8318($a.shape.slice(0, -2), $b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    const a3D = transposeA ? (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($a, [
        batchDimA,
        innerShapeA,
        outerShapeA
    ]) : (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($a, [
        batchDimA,
        outerShapeA,
        innerShapeA
    ]);
    const b3D = transposeB ? (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($b, [
        batchDimB,
        outerShapeB,
        innerShapeB
    ]) : (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($b, [
        batchDimB,
        innerShapeB,
        outerShapeB
    ]);
    let $bias;
    if (bias != null) {
        $bias = (0, $010a899b69412c72$export$ede379c4c939d71a)(bias, 'bias', 'fused matMul');
        [$bias] = (0, $28f820f91d9287a3$export$8b0e24c749a224d7)($bias, $a);
        $642a122b4608acc0$export$a3e2a38a57ec8318(outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $010a899b69412c72$export$ede379c4c939d71a)(preluActivationWeights, 'prelu weights', 'fused matMul');
    const grad = (dy, saved)=>{
        const [a3D, b3D, y, $bias] = saved;
        // we reshape dy because the result of the forward is not
        // necessarily going to be a 3d tensor due to a reshape done at the end of
        // the customOp.
        const dyActivation = (0, $86c60a0aff9fcea2$export$a1905aed55f51aef)((0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(dy, y.shape), y, activation);
        let aDer;
        let bDer;
        if (!transposeA && !transposeB) {
            aDer = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(dyActivation, b3D, false, true);
            bDer = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(a3D, dyActivation, true, false);
        } else if (!transposeA && transposeB) {
            aDer = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(dyActivation, b3D, false, false);
            bDer = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(dyActivation, a3D, true, false);
        } else if (transposeA && !transposeB) {
            aDer = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(b3D, dyActivation, false, true);
            bDer = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(a3D, dyActivation, false, false);
        } else {
            aDer = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(b3D, dyActivation, true, true);
            bDer = (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(dyActivation, a3D, true, true);
        }
        if (bias != null) {
            const biasDer = (0, $86c60a0aff9fcea2$export$1a797e236ae09d1f)($bias, dyActivation);
            return [
                aDer,
                bDer,
                biasDer
            ];
        } else return [
            aDer,
            bDer
        ];
    };
    const inputs = {
        a: a3D,
        b: b3D,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $694041655139423f$export$5519f0eeb00c44e5)((a3D, b3D, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$8d1af0f7c2a4da9e), inputs, attrs);
            save([
                a3D,
                b3D,
                res
            ]);
            return {
                value: (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, outShape),
                gradFunc: grad
            };
        });
        return customOp(a3D, b3D);
    } else {
        const customOpWithBias = (0, $694041655139423f$export$5519f0eeb00c44e5)((a3D, b3D, $bias, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$8d1af0f7c2a4da9e), inputs, attrs);
            save([
                a3D,
                b3D,
                res,
                $bias
            ]);
            return {
                value: (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, outShape),
                gradFunc: grad
            };
        });
        return customOpWithBias(a3D, b3D, $bias);
    }
}
const $108d671c8c951392$export$6706882a873e9a8f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    fusedMatMul_: $108d671c8c951392$var$fusedMatMul_
});




/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Generate a hamming window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hammingWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $02925f9669efedc1$var$hammingWindow_(windowLength) {
    return (0, $de4d87485d0c1285$export$e875398ce092ee45)(windowLength, 0.54, 0.46);
}
const $02925f9669efedc1$export$941eafcc99b559fa = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    hammingWindow_: $02925f9669efedc1$var$hammingWindow_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * Generate a Hann window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hannWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $bdc802a5a22bb768$var$hannWindow_(windowLength) {
    return (0, $de4d87485d0c1285$export$e875398ce092ee45)(windowLength, 0.5, 0.5);
}
const $bdc802a5a22bb768$export$f498cfeee84e5e59 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    hannWindow_: $bdc802a5a22bb768$var$hannWindow_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Expands input into frames of frameLength.
 * Slides a window size with frameStep.
 *
 * ```js
 * tf.signal.frame([1, 2, 3], 2, 1).print();
 * ```
 * @param signal The input tensor to be expanded
 * @param frameLength Length of each frame
 * @param frameStep The frame hop size in samples.
 * @param padEnd Whether to pad the end of signal with padValue.
 * @param padValue A number to use where the input signal does
 *     not exist when padEnd is True.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $fd98a793f0920716$var$frame_(signal, frameLength, frameStep, padEnd = false, padValue = 0) {
    let start = 0;
    const output = [];
    while(start + frameLength <= signal.size){
        output.push((0, $535db06fef6716ec$export$58adb3bec8346d0f)(signal, start, frameLength));
        start += frameStep;
    }
    if (padEnd) while(start < signal.size){
        const padLen = start + frameLength - signal.size;
        const pad = (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)([
            (0, $535db06fef6716ec$export$58adb3bec8346d0f)(signal, start, frameLength - padLen),
            (0, $c5b09a3759406f8a$export$9563e054e6f787fb)([
                padLen
            ], padValue)
        ]);
        output.push(pad);
        start += frameStep;
    }
    if (output.length === 0) return (0, $bea433ea0b14d5fb$export$b5469a65e8732256)([], [
        0,
        frameLength
    ]);
    return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)(output), [
        output.length,
        frameLength
    ]);
}
const $fd98a793f0920716$export$2cef06c20297c17d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    frame_: $fd98a793f0920716$var$frame_
});


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the Short-time Fourier Transform of signals
 * See: https://en.wikipedia.org/wiki/Short-time_Fourier_transform
 *
 * ```js
 * const input = tf.tensor1d([1, 1, 1, 1, 1])
 * tf.signal.stft(input, 3, 1).print();
 * ```
 * @param signal 1-dimensional real value tensor.
 * @param frameLength The window length of samples.
 * @param frameStep The number of samples to step.
 * @param fftLength The size of the FFT to apply.
 * @param windowFn A callable that takes a window length and returns 1-d tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $cdf98b3fb379599a$var$stft_(signal, frameLength, frameStep, fftLength, windowFn = (0, $bdc802a5a22bb768$export$f498cfeee84e5e59)) {
    if (fftLength == null) fftLength = (0, $de4d87485d0c1285$export$6fc2fe3b19043bf3)(frameLength);
    const framedSignal = (0, $fd98a793f0920716$export$2cef06c20297c17d)(signal, frameLength, frameStep);
    const windowedSignal = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(framedSignal, windowFn(frameLength));
    return (0, $8db28b200f22d7be$export$72aff1768917e9e5)(windowedSignal, fftLength);
}
const $cdf98b3fb379599a$export$eb1cf9b274257b4a = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    stft_: $cdf98b3fb379599a$var$stft_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Extracts crops from the input image tensor and resizes them using bilinear
 * sampling or nearest neighbor sampling (possibly with aspect ratio change)
 * to a common output size specified by cropSize.
 *
 * @param image 4d tensor of shape `[batch,imageHeight,imageWidth, depth]`,
 *     where imageHeight and imageWidth must be positive, specifying the
 *     batch of images from which to take crops
 * @param boxes 2d float32 tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the normalized
 *     coordinates of the box in the `boxInd[i]`th image in the batch
 * @param boxInd 1d int32 tensor of shape `[numBoxes]` with values in range
 *     `[0, batch)` that specifies the image that the `i`-th box refers to.
 * @param cropSize 1d int32 tensor of 2 elements `[cropHeigh, cropWidth]`
 *     specifying the size to which all crops are resized to.
 * @param method Optional string from `'bilinear' | 'nearest'`,
 *     defaults to bilinear, which specifies the sampling method for resizing
 * @param extrapolationValue A threshold for deciding when to remove boxes based
 *     on score. Defaults to 0.
 * @return A 4D tensor of the shape `[numBoxes,cropHeight,cropWidth,depth]`
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $e635a0b2cf6a009d$var$cropAndResize_(image, boxes, boxInd, cropSize, method = 'bilinear', extrapolationValue = 0) {
    const $image = (0, $010a899b69412c72$export$ede379c4c939d71a)(image, 'image', 'cropAndResize');
    const $boxes = (0, $010a899b69412c72$export$ede379c4c939d71a)(boxes, 'boxes', 'cropAndResize', 'float32');
    const $boxInd = (0, $010a899b69412c72$export$ede379c4c939d71a)(boxInd, 'boxInd', 'cropAndResize', 'int32');
    const numBoxes = $boxes.shape[0];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($image.rank === 4, ()=>'Error in cropAndResize: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($boxes.rank === 2 && $boxes.shape[1] === 4, ()=>`Error in cropAndResize: boxes must be have size [${numBoxes},4] ` + `but had shape ${$boxes.shape}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($boxInd.rank === 1 && $boxInd.shape[0] === numBoxes, ()=>`Error in cropAndResize: boxInd must be have size [${numBoxes}] ` + `but had shape ${$boxes.shape}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(cropSize.length === 2, ()=>`Error in cropAndResize: cropSize must be of length 2, but got ` + `length ${cropSize.length}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(cropSize[0] >= 1 && cropSize[1] >= 1, ()=>`cropSize must be atleast [1,1], but was ${cropSize}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(method === 'bilinear' || method === 'nearest', ()=>`method must be bilinear or nearest, but was ${method}`);
    const inputs = {
        image: $image,
        boxes: $boxes,
        boxInd: $boxInd
    };
    const attrs = {
        method: method,
        extrapolationValue: extrapolationValue,
        cropSize: cropSize
    };
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$50bc9557793c2e04), inputs, attrs);
    return res;
}
const $e635a0b2cf6a009d$export$6f0f0090e1f6cd3c = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    cropAndResize_: $e635a0b2cf6a009d$var$cropAndResize_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Flips the image left to right. Currently available in the CPU, WebGL, and
 * WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 */ /** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */ function $e439596fc3f8d37a$var$flipLeftRight_(image) {
    const $image = (0, $010a899b69412c72$export$ede379c4c939d71a)(image, 'image', 'flipLeftRight', 'float32');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($image.rank === 4, ()=>'Error in flipLeftRight: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$34e7296fc8558df5), inputs, {});
    return res;
}
const $e439596fc3f8d37a$export$8358b9c43b687b22 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    flipLeftRight_: $e439596fc3f8d37a$var$flipLeftRight_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Converts images from grayscale to RGB format.
 *
 * @param image A grayscale tensor to convert. The `image`'s last dimension must
 *     be size 1 with at least a two-dimensional shape.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $57ea923baa314bcd$var$grayscaleToRGB_(image) {
    const $image = (0, $010a899b69412c72$export$ede379c4c939d71a)(image, 'image', 'grayscaleToRGB');
    const lastDimsIdx = $image.rank - 1;
    const lastDims = $image.shape[lastDimsIdx];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($image.rank >= 2, ()=>'Error in grayscaleToRGB: images must be at least rank 2, ' + `but got rank ${$image.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(lastDims === 1, ()=>'Error in grayscaleToRGB: last dimension of a grayscale image ' + `should be size 1, but got size ${lastDims}.`);
    const reps = new Array($image.rank);
    reps.fill(1, 0, lastDimsIdx);
    reps[lastDimsIdx] = 3;
    return (0, $461b04d030518b80$export$3c17558da18e4d75)($image, reps);
}
const $57ea923baa314bcd$export$f68e334bfd7e4be6 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    grayscaleToRGB_: $57ea923baa314bcd$var$grayscaleToRGB_
});


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 






/**
 * Converts images from RGB format to grayscale.
 *
 * @param image A RGB tensor to convert. The `image`'s last dimension must
 *     be size 3 with at least a two-dimensional shape.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $dbe45fdb7a5f64e9$var$rgbToGrayscale_(image) {
    const $image = (0, $010a899b69412c72$export$ede379c4c939d71a)(image, 'image', 'RGBToGrayscale');
    const lastDimsIdx = $image.rank - 1;
    const lastDims = $image.shape[lastDimsIdx];
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($image.rank >= 2, ()=>'Error in RGBToGrayscale: images must be at least rank 2, ' + `but got rank ${$image.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(lastDims === 3, ()=>'Error in RGBToGrayscale: last dimension of an RGB image ' + `should be size 3, but got size ${lastDims}.`);
    // Remember original dtype so we can convert back if needed
    const origDtype = $image.dtype;
    const fltImage = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)($image, 'float32');
    const rgbWeights = (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)([
        0.2989,
        0.5870,
        0.1140
    ]);
    let grayFloat;
    switch($image.rank){
        case 2:
            grayFloat = (0, $0fe351921eebd33a$export$27265e7daac5c403)('ij,j->i', fltImage, rgbWeights);
            break;
        case 3:
            grayFloat = (0, $0fe351921eebd33a$export$27265e7daac5c403)('ijk,k->ij', fltImage, rgbWeights);
            break;
        case 4:
            grayFloat = (0, $0fe351921eebd33a$export$27265e7daac5c403)('ijkl,l->ijk', fltImage, rgbWeights);
            break;
        case 5:
            grayFloat = (0, $0fe351921eebd33a$export$27265e7daac5c403)('ijklm,m->ijkl', fltImage, rgbWeights);
            break;
        case 6:
            grayFloat = (0, $0fe351921eebd33a$export$27265e7daac5c403)('ijklmn,n->ijklm', fltImage, rgbWeights);
            break;
        default:
            throw new Error('Not a valid tensor rank.');
    }
    grayFloat = (0, $db5bfab98435c6cf$export$d660d8ed21f46635)(grayFloat, -1);
    return (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(grayFloat, origDtype);
}
const $dbe45fdb7a5f64e9$export$490c4fde2e852c50 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    rgbToGrayscale_: $dbe45fdb7a5f64e9$var$rgbToGrayscale_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Rotates the input image tensor counter-clockwise with an optional offset
 * center of rotation. Currently available in the CPU, WebGL, and WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param radians The amount of rotation.
 * @param fillValue The value to fill in the empty space leftover
 *     after rotation. Can be either a single grayscale value (0-255), or an
 *     array of three numbers `[red, green, blue]` specifying the red, green,
 *     and blue channels. Defaults to `0` (black).
 * @param center The center of rotation. Can be either a single value (0-1), or
 *     an array of two numbers `[centerX, centerY]`. Defaults to `0.5` (rotates
 *     the image around its center).
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $c2141030b1b397d1$var$rotateWithOffset_(image, radians, fillValue = 0, center = 0.5) {
    const $image = (0, $010a899b69412c72$export$ede379c4c939d71a)(image, 'image', 'rotateWithOffset', 'float32');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($image.rank === 4, ()=>'Error in rotateWithOffset: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const attrs = {
        radians: radians,
        fillValue: fillValue,
        center: center
    };
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$c5a44649815d1c3), inputs, attrs);
    return res;
}
const $c2141030b1b397d1$export$66462c489f5f29d2 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    rotateWithOffset_: $c2141030b1b397d1$var$rotateWithOffset_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $9c400d108974778f$export$ccf61bcb3b4e6ac6(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    if (iouThreshold == null) iouThreshold = 0.5;
    if (scoreThreshold == null) scoreThreshold = Number.NEGATIVE_INFINITY;
    if (softNmsSigma == null) softNmsSigma = 0.0;
    const numBoxes = boxes.shape[0];
    maxOutputSize = Math.min(maxOutputSize, numBoxes);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(0 <= iouThreshold && iouThreshold <= 1, ()=>`iouThreshold must be in [0, 1], but was '${iouThreshold}'`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(boxes.rank === 2, ()=>`boxes must be a 2D tensor, but was of rank '${boxes.rank}'`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(boxes.shape[1] === 4, ()=>`boxes must have 4 columns, but 2nd dimension was ${boxes.shape[1]}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(scores.rank === 1, ()=>'scores must be a 1D tensor');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(scores.shape[0] === numBoxes, ()=>`scores has incompatible shape with boxes. Expected ${numBoxes}, ` + `but was ${scores.shape[0]}`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(0 <= softNmsSigma && softNmsSigma <= 1, ()=>`softNmsSigma must be in [0, 1], but was '${softNmsSigma}'`);
    return {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}



/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $2a5279fb7ed7e00c$var$nonMaxSuppression_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $010a899b69412c72$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppression', 'float32');
    const $scores = (0, $010a899b69412c72$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppression', 'float32');
    const inputs = (0, $9c400d108974778f$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$5e11788439c2f04), {
        boxes: $boxes,
        scores: $scores
    }, attrs);
}
const $2a5279fb7ed7e00c$export$b7d265b19ca1d628 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    nonMaxSuppression_: $2a5279fb7ed7e00c$var$nonMaxSuppression_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inserts a value into a sorted array. This method allows duplicate, meaning it
 * allows inserting duplicate value, in which case, the element will be inserted
 * at the lowest index of the value.
 * @param arr The array to modify.
 * @param element The element to insert.
 * @param comparator Optional. If no comparator is specified, elements are
 * compared using array_util.defaultComparator, which is suitable for Strings
 * and Numbers in ascending arrays. If the array contains multiple instances of
 * the target value, the left-most instance will be returned. To provide a
 * comparator, it should take 2 arguments to compare and return a negative,
 * zero, or a positive number.
 */ function $e9d7523e791ea809$export$a64fad5e27f22af5(arr, element, comparator) {
    const index = $e9d7523e791ea809$export$2e0ae67339d5f1ac(arr, element, comparator);
    const insertionPoint = index < 0 ? -(index + 1) : index;
    arr.splice(insertionPoint, 0, element);
}
function $e9d7523e791ea809$export$2e0ae67339d5f1ac(arr, target, comparator) {
    return $e9d7523e791ea809$var$binarySearch_(arr, target, comparator || $e9d7523e791ea809$var$defaultComparator);
}
/**
 * Compares its two arguments for order.
 * @param a The first element to be compared.
 * @param b The second element to be compared.
 * @return A negative number, zero, or a positive number as the first
 *     argument is less than, equal to, or greater than the second.
 */ function $e9d7523e791ea809$var$defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $e9d7523e791ea809$var$binarySearch_(arr, target, comparator) {
    let left = 0;
    let right = arr.length;
    let middle = 0;
    let found = false;
    while(left < right){
        middle = left + (right - left >>> 1);
        const compareResult = comparator(target, arr[middle]);
        if (compareResult > 0) left = middle + 1;
        else {
            right = middle;
            // If compareResult is 0, the value is found. We record it is found,
            // and then keep looking because there may be duplicate.
            found = !compareResult;
        }
    }
    return found ? left : -left - 1;
}


function $08cc9cc3eb1dc63f$export$89e22275998c2878(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
    return $08cc9cc3eb1dc63f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ );
}
function $08cc9cc3eb1dc63f$export$697e7a8cdfefe3a(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize) {
    return $08cc9cc3eb1dc63f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ , false, padToMaxOutputSize /* padToMaxOutputSize */ , true);
}
function $08cc9cc3eb1dc63f$export$4ff849794bce73c5(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    return $08cc9cc3eb1dc63f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, true);
}
function $08cc9cc3eb1dc63f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, returnScoresTensor = false, padToMaxOutputSize = false, returnValidOutputs = false) {
    // The list is sorted in ascending order, so that we can always pop the
    // candidate with the largest score in O(1) time.
    const candidates = [];
    for(let i = 0; i < scores.length; i++)if (scores[i] > scoreThreshold) candidates.push({
        score: scores[i],
        boxIndex: i,
        suppressBeginIndex: 0
    });
    candidates.sort($08cc9cc3eb1dc63f$var$ascendingComparator);
    // If softNmsSigma is 0, the outcome of this algorithm is exactly same as
    // before.
    const scale = softNmsSigma > 0 ? -0.5 / softNmsSigma : 0.0;
    const selectedIndices = [];
    const selectedScores = [];
    while(selectedIndices.length < maxOutputSize && candidates.length > 0){
        const candidate = candidates.pop();
        const { score: originalScore, boxIndex: boxIndex, suppressBeginIndex: suppressBeginIndex } = candidate;
        if (originalScore < scoreThreshold) break;
        // Overlapping boxes are likely to have similar scores, therefore we
        // iterate through the previously selected boxes backwards in order to
        // see if candidate's score should be suppressed. We use
        // suppressBeginIndex to track and ensure a candidate can be suppressed
        // by a selected box no more than once. Also, if the overlap exceeds
        // iouThreshold, we simply ignore the candidate.
        let ignoreCandidate = false;
        for(let j = selectedIndices.length - 1; j >= suppressBeginIndex; --j){
            const iou = $08cc9cc3eb1dc63f$var$intersectionOverUnion(boxes, boxIndex, selectedIndices[j]);
            if (iou >= iouThreshold) {
                ignoreCandidate = true;
                break;
            }
            candidate.score = candidate.score * $08cc9cc3eb1dc63f$var$suppressWeight(iouThreshold, scale, iou);
            if (candidate.score <= scoreThreshold) break;
        }
        // At this point, if `candidate.score` has not dropped below
        // `scoreThreshold`, then we know that we went through all of the
        // previous selections and can safely update `suppressBeginIndex` to the
        // end of the selected array. Then we can re-insert the candidate with
        // the updated score and suppressBeginIndex back in the candidate list.
        // If on the other hand, `candidate.score` has dropped below the score
        // threshold, we will not add it back to the candidates list.
        candidate.suppressBeginIndex = selectedIndices.length;
        if (!ignoreCandidate) {
            // Candidate has passed all the tests, and is not suppressed, so
            // select the candidate.
            if (candidate.score === originalScore) {
                selectedIndices.push(boxIndex);
                selectedScores.push(candidate.score);
            } else if (candidate.score > scoreThreshold) // Candidate's score is suppressed but is still high enough to be
            // considered, so add back to the candidates list.
            (0, $e9d7523e791ea809$export$a64fad5e27f22af5)(candidates, candidate, $08cc9cc3eb1dc63f$var$ascendingComparator);
        }
    }
    // NonMaxSuppressionV4 feature: padding output to maxOutputSize.
    const validOutputs = selectedIndices.length;
    const elemsToPad = maxOutputSize - validOutputs;
    if (padToMaxOutputSize && elemsToPad > 0) {
        selectedIndices.push(...new Array(elemsToPad).fill(0));
        selectedScores.push(...new Array(elemsToPad).fill(0.0));
    }
    const result = {
        selectedIndices: selectedIndices
    };
    if (returnScoresTensor) result['selectedScores'] = selectedScores;
    if (returnValidOutputs) result['validOutputs'] = validOutputs;
    return result;
}
function $08cc9cc3eb1dc63f$var$intersectionOverUnion(boxes, i, j) {
    const iCoord = boxes.subarray(i * 4, i * 4 + 4);
    const jCoord = boxes.subarray(j * 4, j * 4 + 4);
    const yminI = Math.min(iCoord[0], iCoord[2]);
    const xminI = Math.min(iCoord[1], iCoord[3]);
    const ymaxI = Math.max(iCoord[0], iCoord[2]);
    const xmaxI = Math.max(iCoord[1], iCoord[3]);
    const yminJ = Math.min(jCoord[0], jCoord[2]);
    const xminJ = Math.min(jCoord[1], jCoord[3]);
    const ymaxJ = Math.max(jCoord[0], jCoord[2]);
    const xmaxJ = Math.max(jCoord[1], jCoord[3]);
    const areaI = (ymaxI - yminI) * (xmaxI - xminI);
    const areaJ = (ymaxJ - yminJ) * (xmaxJ - xminJ);
    if (areaI <= 0 || areaJ <= 0) return 0.0;
    const intersectionYmin = Math.max(yminI, yminJ);
    const intersectionXmin = Math.max(xminI, xminJ);
    const intersectionYmax = Math.min(ymaxI, ymaxJ);
    const intersectionXmax = Math.min(xmaxI, xmaxJ);
    const intersectionArea = Math.max(intersectionYmax - intersectionYmin, 0.0) * Math.max(intersectionXmax - intersectionXmin, 0.0);
    return intersectionArea / (areaI + areaJ - intersectionArea);
}
// A Gaussian penalty function, this method always returns values in [0, 1].
// The weight is a function of similarity, the more overlap two boxes are, the
// smaller the weight is,meaning highly overlapping boxes will be significantly
// penalized. On the other hand, a non-overlapping box will not be penalized.
function $08cc9cc3eb1dc63f$var$suppressWeight(iouThreshold, scale, iou) {
    const weight = Math.exp(scale * iou * iou);
    return iou <= iouThreshold ? weight : 0.0;
}
function $08cc9cc3eb1dc63f$var$ascendingComparator(c1, c2) {
    // For objects with same scores, we make the object with the larger index go
    // first. In an array that pops from the end, this means that the object with
    // the smaller index will be popped first. This ensures the same output as
    // the TensorFlow python version.
    return c1.score - c2.score || c1.score === c2.score && c2.boxIndex - c1.boxIndex;
}





/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This is the async version of `nonMaxSuppression`
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $d4eeaf2379910934$var$nonMaxSuppressionAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $010a899b69412c72$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $010a899b69412c72$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppressionAsync');
    const inputs = (0, $9c400d108974778f$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices } = (0, $08cc9cc3eb1dc63f$export$89e22275998c2878)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)(selectedIndices, 'int32');
}
const $d4eeaf2379910934$export$cc6d94dffac2ee1a = $d4eeaf2379910934$var$nonMaxSuppressionAsync_;


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $c0aa5c5c9595bb66$var$nonMaxSuppressionWithScore_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $010a899b69412c72$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $010a899b69412c72$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $9c400d108974778f$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$cb45d3fcefce2ef0), inputs, attrs);
    return {
        selectedIndices: result[0],
        selectedScores: result[1]
    };
}
const $c0aa5c5c9595bb66$export$d65fe1460f8c5b4e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    nonMaxSuppressionWithScore_: $c0aa5c5c9595bb66$var$nonMaxSuppressionWithScore_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $5dc292f419a7c34a$var$nonMaxSuppressionWithScoreAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $010a899b69412c72$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $010a899b69412c72$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $9c400d108974778f$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = (0, $08cc9cc3eb1dc63f$export$4ff849794bce73c5)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)(selectedIndices, 'int32'),
        selectedScores: (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)(selectedScores)
    };
}
const $5dc292f419a7c34a$export$d1826570c883f7cf = $5dc292f419a7c34a$var$nonMaxSuppressionWithScoreAsync_;


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $c11b80e2eb953c6d$var$nonMaxSuppressionPadded_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $010a899b69412c72$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $010a899b69412c72$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $9c400d108974778f$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: $maxOutputSize,
        iouThreshold: $iouThreshold,
        scoreThreshold: $scoreThreshold,
        padToMaxOutputSize: padToMaxOutputSize
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$7df908154366fe7f), inputs, attrs);
    return {
        selectedIndices: result[0],
        validOutputs: result[1]
    };
}
const $c11b80e2eb953c6d$export$d8d10e31c41c95dc = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    nonMaxSuppressionPadded_: $c11b80e2eb953c6d$var$nonMaxSuppressionPadded_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $85026b125f5bbb1e$var$nonMaxSuppressionPaddedAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $010a899b69412c72$export$ede379c4c939d71a)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $010a899b69412c72$export$ede379c4c939d71a)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $9c400d108974778f$export$ccf61bcb3b4e6ac6)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const [boxesVals, scoresVals] = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    // We call a cpu based impl directly with the typedarray data here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = (0, $08cc9cc3eb1dc63f$export$697e7a8cdfefe3a)(boxesVals, scoresVals, $maxOutputSize, $iouThreshold, $scoreThreshold, padToMaxOutputSize);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)(selectedIndices, 'int32'),
        validOutputs: (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(validOutputs, 'int32')
    };
}
const $85026b125f5bbb1e$export$4c5691f9710b88a8 = $85026b125f5bbb1e$var$nonMaxSuppressionPaddedAsync_;


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Bilinear resize a single 3D image or a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to `false`. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixel centers
 *     are at 0.5, which would make the floating point coordinates of the top
 *     left pixel 0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $4c832af1e8d94834$var$resizeBilinear_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $010a899b69412c72$export$ede379c4c939d71a)(images, 'images', 'resizeBilinear');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeBilinear: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(size.length === 2, ()=>`Error in resizeBilinear: new shape must 2D, but got shape ` + `${size}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeBilinear: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$24f2f15d869e0fd), inputs, attrs);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $4c832af1e8d94834$export$1f1cbc7da93d06a0 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    resizeBilinear_: $4c832af1e8d94834$var$resizeBilinear_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * NearestNeighbor resize a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to False. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixels are of
 *      half the actual dimensions, and yield more accurate resizes. This flag
 *      would also make the floating point coordinates of the top left pixel
 *      0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $a6d772d3dc572a5d$var$resizeNearestNeighbor_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $010a899b69412c72$export$ede379c4c939d71a)(images, 'images', 'resizeNearestNeighbor');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeNearestNeighbor: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(size.length === 2, ()=>`Error in resizeNearestNeighbor: new shape must 2D, but got shape ` + `${size}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($images.dtype === 'float32' || $images.dtype === 'int32', ()=>'`images` must have `int32` or `float32` as dtype');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeNearestNeighbor: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$6c8d8ec26192bb18), inputs, attrs);
    if (reshapedTo4D) return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $a6d772d3dc572a5d$export$74a902ae74ac2560 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    resizeNearestNeighbor_: $a6d772d3dc572a5d$var$resizeNearestNeighbor_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



















/**
 * Performs image binarization with corresponding threshold
 * (depends on the method)value, which creates a binary image from a grayscale.
 * @param image 3d tensor of shape [imageHeight,imageWidth, depth],
 * where imageHeight and imageWidth must be positive.The image color
 * range should be [0, 255].
 * @param method Optional string from `'binary' | 'otsu'`
 * which specifies the method for thresholding. Defaults to 'binary'.
 * @param inverted Optional boolean whichspecifies
 * if colours should be inverted. Defaults to false.
 * @param threshValue Optional number which defines threshold value from 0 to 1.
 * Defaults to 0.5.
 * @return A 3d tensor of shape [imageHeight,imageWidth, depth], which
 * contains binarized image.
 */ function $1cfd2736c3bd16df$var$threshold_(image, method = 'binary', inverted = false, threshValue = 0.5) {
    const $image = (0, $010a899b69412c72$export$ede379c4c939d71a)(image, 'image', 'threshold');
    /* 0.2989, 0.5870, 0.1140 are represent luma coefficients in CCIR601.
    Reference for converting between RGB and grayscale: https://en.wikipedia.org/wiki/Luma_%28video%29  */ const RED_INTENCITY_COEF = 0.2989;
    const GREEN_INTENCITY_COEF = 0.5870;
    const BLUE_INTENCITY_COEF = 0.1140;
    const totalPixelsInImage = $image.shape[0] * $image.shape[1];
    let $threshold = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $f68b57eba454beb7$export$8133e3bf3cd8f464)([
        threshValue
    ]), 255);
    let r, g, b, grayscale;
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($image.rank === 3, ()=>'Error in threshold: image must be rank 3,' + `but got rank ${$image.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($image.shape[2] === 3 || $image.shape[2] === 1, ()=>"Error in threshold: image color channel must be equal to 3 or 1" + `but got ${$image.shape[2]}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($image.dtype === 'int32' || $image.dtype === 'float32', ()=>'Error in dtype: image dtype must be int32 or float32,' + `but got dtype ${$image.dtype}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(method === 'otsu' || method === 'binary', ()=>`Method must be binary or otsu, but was ${method}`);
    if ($image.shape[2] === 3) {
        [r, g, b] = (0, $6bb70aae893ea3fa$export$65980d18b75784e2)($image, [
            1,
            1,
            1
        ], -1);
        const $r = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(r, RED_INTENCITY_COEF);
        const $g = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(g, GREEN_INTENCITY_COEF);
        const $b = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(b, BLUE_INTENCITY_COEF);
        grayscale = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $c90bd95bc0e58efa$export$e16d8520af44a096)($r, $g), $b);
    } else grayscale = image;
    if (method === 'otsu') {
        const $histogram = (0, $af732e8d9c378509$export$7e474bab088ed182)((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)((0, $743db37ae6b6e648$export$2077e0241d6afd3c)(grayscale), 'int32'), (0, $a82c6773538d9e64$export$65df3ad1ad888abb)([]), 256);
        $threshold = $1cfd2736c3bd16df$var$otsu($histogram, totalPixelsInImage);
    }
    const invCondition = inverted ? (0, $5a854c2455432f6a$export$c24ad19a692bb92)(grayscale, $threshold) : (0, $8a3e558d5bb76a4c$export$9dca161faaf6308b)(grayscale, $threshold);
    const result = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(invCondition, 255), 'int32');
    return result;
}
function $1cfd2736c3bd16df$var$otsu(histogram, total) {
    let bestThresh = (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)([
        -1
    ]);
    let bestInBetVar = (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)([
        0
    ]);
    let cInBetVar = (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)([
        0
    ]);
    let classFirst, classSecond, meanFirst, meanSec, weightForeground, weightBack;
    for(let index = 0; index < histogram.size - 1; index++){
        classFirst = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(histogram, 0, index + 1);
        classSecond = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(histogram, index + 1);
        weightForeground = (0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $7215cb99724b7643$export$8a63f25cc62965f1)(classFirst), total);
        weightBack = (0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $7215cb99724b7643$export$8a63f25cc62965f1)(classSecond), total);
        const meanFirstDivA = (0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(classFirst, (0, $5d4db871afef7031$export$d02631cccf789723)(0, classFirst.size)));
        meanFirst = (0, $15928a4fee5ff81f$export$159d9494db57879b)(meanFirstDivA, (0, $7215cb99724b7643$export$8a63f25cc62965f1)(classFirst));
        const meanSecFill = (0, $c5b09a3759406f8a$export$9563e054e6f787fb)(classSecond.shape, classFirst.size);
        const meanSecAdd = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $5d4db871afef7031$export$d02631cccf789723)(0, classSecond.size), meanSecFill);
        const meanSecMul = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(classSecond, meanSecAdd);
        meanSec = (0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $7215cb99724b7643$export$8a63f25cc62965f1)(meanSecMul), (0, $7215cb99724b7643$export$8a63f25cc62965f1)(classSecond));
        const cInBetVarSubA = (0, $555d660851b98db3$export$f93b5905241a7cca)(meanFirst, meanSec);
        const cInBetVarSubB = (0, $555d660851b98db3$export$f93b5905241a7cca)(meanFirst, meanSec);
        const cInBetVarMul = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(weightForeground, weightBack);
        cInBetVar = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(cInBetVarMul, cInBetVarSubA), cInBetVarSubB);
        const condition = (0, $8a3e558d5bb76a4c$export$9dca161faaf6308b)(cInBetVar, bestInBetVar);
        bestInBetVar = (0, $f5215ba964de19ce$export$9c59b80dda569a6e)(condition, cInBetVar, bestInBetVar);
        bestThresh = (0, $f5215ba964de19ce$export$9c59b80dda569a6e)(condition, (0, $f68b57eba454beb7$export$8133e3bf3cd8f464)([
            index
        ]), bestThresh);
    }
    return bestThresh;
}
const $1cfd2736c3bd16df$export$454d09aca5f3ea63 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    threshold_: $1cfd2736c3bd16df$var$threshold_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




/**
 * Applies the given transform(s) to the image(s).
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param transforms Projective transform matrix/matrices. A tensor1d of length
 *     8 or tensor of size N x 8. If one row of transforms is [a0, a1, a2, b0,
 *     b1, b2, c0, c1], then it maps the output point (x, y) to a transformed
 *     input point (x', y') = ((a0 x + a1 y + a2) / k, (b0 x + b1 y + b2) / k),
 *     where k = c0 x + c1 y + 1. The transforms are inverted compared to the
 *     transform mapping input points to output points.
 * @param interpolation Interpolation mode.
 *     Supported values: 'nearest', 'bilinear'. Default to 'nearest'.
 * @param fillMode Points outside the boundaries of the input are filled
 *     according to the given mode, one of 'constant', 'reflect', 'wrap',
 *     'nearest'. Default to 'constant'.
 *     'reflect': (d c b a | a b c d | d c b a ) The input is extended by
 *     reflecting about the edge of the last pixel.
 *     'constant': (k k k k | a b c d | k k k k) The input is extended by
 *     filling all values beyond the edge with the same constant value k.
 *     'wrap': (a b c d | a b c d | a b c d) The input is extended by
 *     wrapping around to the opposite edge.
 *     'nearest': (a a a a | a b c d | d d d d) The input is extended by
 *     the nearest pixel.
 * @param fillValue A float represents the value to be filled outside the
 *     boundaries when fillMode is 'constant'.
 * @param Output dimension after the transform, [height, width]. If undefined,
 *     output is the same size as input image.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $3ae52ebe9b17d3a8$var$transform_(image, transforms, interpolation = 'nearest', fillMode = 'constant', fillValue = 0, outputShape) {
    const $image = (0, $010a899b69412c72$export$ede379c4c939d71a)(image, 'image', 'transform', 'float32');
    const $transforms = (0, $010a899b69412c72$export$ede379c4c939d71a)(transforms, 'transforms', 'transform', 'float32');
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($image.rank === 4, ()=>'Error in transform: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97($transforms.rank === 2 && ($transforms.shape[0] === $image.shape[0] || $transforms.shape[0] === 1) && $transforms.shape[1] === 8, ()=>`Error in transform: Input transform should be batch x 8 or 1 x 8`);
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(outputShape == null || outputShape.length === 2, ()=>'Error in transform: outputShape must be [height, width] or null, ' + `but got ${outputShape}.`);
    const inputs = {
        image: $image,
        transforms: $transforms
    };
    const attrs = {
        interpolation: interpolation,
        fillMode: fillMode,
        fillValue: fillValue,
        outputShape: outputShape
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$563a914cafbdc389), inputs, attrs);
}
const $3ae52ebe9b17d3a8$export$51186ad6e864892a = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    transform_: $3ae52ebe9b17d3a8$var$transform_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 















/**
 * Copy a tensor setting everything outside a central band in each innermost
 * matrix to zero.
 *
 * The band part is computed as follows: Assume input has `k` dimensions
 * `[I, J, K, ..., M, N]`, then the output is a tensor with the same shape where
 * `band[i, j, k, ..., m, n] = in_band(m, n) * input[i, j, k, ..., m, n]`.
 * The indicator function
 * `in_band(m, n) = (num_lower < 0 || (m-n) <= num_lower)`
 * `&& (num_upper < 0 || (n-m) <= num_upper)`
 *
 * ```js
 * const x = tf.tensor2d([[ 0,  1,  2, 3],
 *                        [-1,  0,  1, 2],
 *                        [-2, -1,  0, 1],
 *                        [-3, -2, -1, 0]]);
 * let y = tf.linalg.bandPart(x, 1, -1);
 * y.print(); // [[ 0,  1,  2, 3],
 *            //  [-1,  0,  1, 2],
 *            //  [ 0, -1,  0, 1],
 *            //  [ 0, 0 , -1, 0]]
 * let z = tf.linalg.bandPart(x, 2, 1);
 * z.print(); // [[ 0,  1,  0, 0],
 *            //  [-1,  0,  1, 0],
 *            //  [-2, -1,  0, 1],
 *            //  [ 0, -2, -1, 0]]
 * ```
 *
 * @param x Rank `k` tensor
 * @param numLower Number of subdiagonals to keep.
 *   If negative, keep entire lower triangle.
 * @param numUpper Number of subdiagonals to keep.
 *   If negative, keep entire upper triangle.
 * @returns Rank `k` tensor of the same shape as input.
 *   The extracted banded tensor.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $f106c3304c20e7b0$var$bandPart_(a, numLower, numUpper) {
    const $a = (0, $010a899b69412c72$export$ede379c4c939d71a)(a, 'a', 'bandPart');
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)($a.rank >= 2, ()=>`bandPart(): Rank must be at least 2, got ${$a.rank}.`);
    const shape = $a.shape;
    const [M, N] = $a.shape.slice(-2);
    let $numLower;
    let $numUpper;
    if (typeof numLower === 'number') {
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(numLower % 1 === 0, ()=>`bandPart(): numLower must be an integer, got ${numLower}.`);
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(numLower <= M, ()=>`bandPart(): numLower (${numLower})` + ` must not be greater than the number of rows (${M}).`);
        $numLower = (0, $010a899b69412c72$export$ede379c4c939d71a)(numLower < 0 ? M : numLower, 'numLower', 'bandPart');
    } else {
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(numLower.dtype === 'int32', ()=>`bandPart(): numLower's dtype must be an int32.`);
        // If numLower is a Scalar, checking `numLower <= M` could hurt performance,
        // but minimum(numLower, M) could avoid unexpected results.
        $numLower = (0, $f5215ba964de19ce$export$9c59b80dda569a6e)((0, $e7c220a817a7d6b0$export$bb1a638da8ad190f)(numLower, 0), M, (0, $509eb1d608c78c8e$export$916782c1f0ddb132)(numLower, M));
    }
    if (typeof numUpper === 'number') {
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(numUpper % 1 === 0, ()=>`bandPart(): numUpper must be an integer, got ${numUpper}.`);
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(numUpper <= N, ()=>`bandPart(): numUpper (${numUpper})` + ` must not be greater than the number of columns (${N}).`);
        $numUpper = (0, $010a899b69412c72$export$ede379c4c939d71a)(numUpper < 0 ? N : numUpper, 'numUpper', 'bandPart');
    } else {
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(numUpper.dtype === 'int32', ()=>`bandPart(): numUpper's dtype must be an int32.`);
        $numUpper = (0, $f5215ba964de19ce$export$9c59b80dda569a6e)((0, $e7c220a817a7d6b0$export$bb1a638da8ad190f)(numUpper, 0), N, (0, $509eb1d608c78c8e$export$916782c1f0ddb132)(numUpper, N));
    }
    const i = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $5d4db871afef7031$export$d02631cccf789723)(0, M, 1, 'int32'), [
        -1,
        1
    ]);
    const j = (0, $5d4db871afef7031$export$d02631cccf789723)(0, N, 1, 'int32');
    const ij = (0, $555d660851b98db3$export$f93b5905241a7cca)(i, j);
    const inBand = (0, $ebf6cebe68ef2a79$export$db5dd0ef9d505f)((0, $5a854c2455432f6a$export$c24ad19a692bb92)(ij, $numLower), (0, $f4c954f893cb9ce6$export$c2fd4164cadc1fa2)(ij, (0, $0ca018ac52410371$export$d9493ff0dfa0fdd5)($numUpper)));
    const zero = (0, $cc4388674ebc96d5$export$4445a00dafa2633b)([
        M,
        N
    ], $a.dtype);
    return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $6437527469582bc5$export$a57ab32f40f83ea9)((0, $c1775cdc84f05f72$export$3c05285afa115eec)((0, $33ee657bc32918d5$export$9eaad88cf88cee2b)($a, [
        -1,
        M,
        N
    ])).map((mat)=>(0, $f5215ba964de19ce$export$9c59b80dda569a6e)(inBand, mat, zero))), shape);
}
const $f106c3304c20e7b0$export$8a3da9cb9e5610a0 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    bandPart_: $f106c3304c20e7b0$var$bandPart_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 










/**
 * Gram-Schmidt orthogonalization.
 *
 * ```js
 * const x = tf.tensor2d([[1, 2], [3, 4]]);
 * let y = tf.linalg.gramSchmidt(x);
 * y.print();
 * console.log('Orthogonalized:');
 * y.dot(y.transpose()).print();  // should be nearly the identity matrix.
 * console.log('First row direction maintained:');
 * const data = await y.array();
 * console.log(data[0][1] / data[0][0]);  // should be nearly 2.
 * ```
 *
 * @param xs The vectors to be orthogonalized, in one of the two following
 *   formats:
 *   - An Array of `tf.Tensor1D`.
 *   - A `tf.Tensor2D`, i.e., a matrix, in which case the vectors are the rows
 *     of `xs`.
 *   In each case, all the vectors must have the same length and the length
 *   must be greater than or equal to the number of vectors.
 * @returns The orthogonalized and normalized vectors or matrix.
 *   Orthogonalization means that the vectors or the rows of the matrix
 *   are orthogonal (zero inner products). Normalization means that each
 *   vector or each row of the matrix has an L2 norm that equals `1`.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $886763dc106f4c3d$var$gramSchmidt_(xs) {
    let inputIsTensor2D;
    if (Array.isArray(xs)) {
        inputIsTensor2D = false;
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(xs != null && xs.length > 0, ()=>"Gram-Schmidt process: input must not be null, undefined, or empty");
        const dim = xs[0].shape[0];
        for(let i = 1; i < xs.length; ++i)(0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(xs[i].shape[0] === dim, ()=>'Gram-Schmidt: Non-unique lengths found in the input vectors: ' + `(${xs[i].shape[0]} vs. ${dim})`);
    } else {
        inputIsTensor2D = true;
        xs = (0, $6bb70aae893ea3fa$export$65980d18b75784e2)(xs, xs.shape[0], 0).map((x)=>(0, $f41010297af56801$export$889c931173b77c2f)(x, [
                0
            ]));
    }
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(xs.length <= xs[0].shape[0], ()=>`Gram-Schmidt: Number of vectors (${xs.length}) exceeds ` + `number of dimensions (${xs[0].shape[0]}).`);
    const ys = [];
    const xs1d = xs;
    for(let i = 0; i < xs.length; ++i)ys.push((0, $249f84ddb1ced836$export$33b63313cc511a3b).tidy(()=>{
        let x = xs1d[i];
        if (i > 0) for(let j = 0; j < i; ++j){
            const proj = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(ys[j], x)), ys[j]);
            x = (0, $555d660851b98db3$export$f93b5905241a7cca)(x, proj);
        }
        return (0, $15928a4fee5ff81f$export$159d9494db57879b)(x, (0, $554f394697e806e8$export$1991ecd29cc92c6b)(x, 'euclidean'));
    }));
    if (inputIsTensor2D) return (0, $6437527469582bc5$export$a57ab32f40f83ea9)(ys, 0);
    else return ys;
}
const $886763dc106f4c3d$export$d505610386a600de = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    gramSchmidt_: $886763dc106f4c3d$var$gramSchmidt_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 




















/**
 * Compute QR decomposition of m-by-n matrix using Householder transformation.
 *
 * Implementation based on
 *   [http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf]
 * (http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf)
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [3, 4]]);
 * let [q, r] = tf.linalg.qr(a);
 * console.log('Q');
 * q.print();
 * console.log('R');
 * r.print();
 * console.log('Orthogonalized');
 * q.dot(q.transpose()).print()  // should be nearly the identity matrix.
 * console.log('Reconstructed');
 * q.dot(r).print(); // should be nearly [[1, 2], [3, 4]];
 * ```
 *
 * @param x The `tf.Tensor` to be QR-decomposed. Must have rank >= 2. Suppose
 *   it has the shape `[..., M, N]`.
 * @param fullMatrices An optional boolean parameter. Defaults to `false`.
 *   If `true`, compute full-sized `Q`. If `false` (the default),
 *   compute only the leading N columns of `Q` and `R`.
 * @returns An `Array` of two `tf.Tensor`s: `[Q, R]`. `Q` is a unitary matrix,
 *   i.e., its columns all have unit norm and are mutually orthogonal.
 *   If `M >= N`,
 *     If `fullMatrices` is `false` (default),
 *       - `Q` has a shape of `[..., M, N]`,
 *       - `R` has a shape of `[..., N, N]`.
 *     If `fullMatrices` is `true` (default),
 *       - `Q` has a shape of `[..., M, M]`,
 *       - `R` has a shape of `[..., M, N]`.
 *   If `M < N`,
 *     - `Q` has a shape of `[..., M, M]`,
 *     - `R` has a shape of `[..., M, N]`.
 * @throws If the rank of `x` is less than 2.
 *
 * @doc {heading:'Operations',
 *       subheading:'Linear Algebra',
 *       namespace:'linalg'}
 */ function $d67fe76a3cc8e71b$var$qr_(x, fullMatrices = false) {
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(x.rank >= 2, ()=>`qr() requires input tensor to have a rank >= 2, but got rank ${x.rank}`);
    if (x.rank === 2) return $d67fe76a3cc8e71b$var$qr2d(x, fullMatrices);
    else {
        // Rank > 2.
        // TODO(cais): Below we split the input into individual 2D tensors,
        //   perform QR decomposition on them and then stack the results back
        //   together. We should explore whether this can be parallelized.
        const outerDimsProd = x.shape.slice(0, x.shape.length - 2).reduce((value, prev)=>value * prev);
        const x2ds = (0, $c1775cdc84f05f72$export$3c05285afa115eec)((0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(x, [
            outerDimsProd,
            x.shape[x.shape.length - 2],
            x.shape[x.shape.length - 1]
        ]), 0);
        const q2ds = [];
        const r2ds = [];
        x2ds.forEach((x2d)=>{
            const [q2d, r2d] = $d67fe76a3cc8e71b$var$qr2d(x2d, fullMatrices);
            q2ds.push(q2d);
            r2ds.push(r2d);
        });
        const q = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $6437527469582bc5$export$a57ab32f40f83ea9)(q2ds, 0), x.shape);
        const r = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $6437527469582bc5$export$a57ab32f40f83ea9)(r2ds, 0), x.shape);
        return [
            q,
            r
        ];
    }
}
function $d67fe76a3cc8e71b$var$qr2d(x, fullMatrices = false) {
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).tidy(()=>{
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(x.shape.length === 2, ()=>`qr2d() requires a 2D Tensor, but got a ${x.shape.length}D Tensor.`);
        const m = x.shape[0];
        const n = x.shape[1];
        let q = (0, $6bf880f08dec68a4$export$4e18cf730a59887e)(m); // Orthogonal transform so far.
        let r = (0, $44a9d8b42e3e34af$export$9cd59f9826255e47)(x); // Transformed matrix so far.
        const one2D = (0, $bea433ea0b14d5fb$export$b5469a65e8732256)([
            [
                1
            ]
        ], [
            1,
            1
        ]);
        let w = (0, $44a9d8b42e3e34af$export$9cd59f9826255e47)(one2D);
        const iters = m >= n ? n : m;
        for(let j = 0; j < iters; ++j){
            // This tidy within the for-loop ensures we clean up temporary
            // tensors as soon as they are no longer needed.
            const rTemp = r;
            const wTemp = w;
            const qTemp = q;
            [w, r, q] = (0, $249f84ddb1ced836$export$33b63313cc511a3b).tidy(()=>{
                // Find H = I - tau * w * w', to put zeros below R(j, j).
                const rjEnd1 = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(r, [
                    j,
                    j
                ], [
                    m - j,
                    1
                ]);
                const normX = (0, $554f394697e806e8$export$1991ecd29cc92c6b)(rjEnd1);
                const rjj = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(r, [
                    j,
                    j
                ], [
                    1,
                    1
                ]);
                // The sign() function returns 0 on 0, which causes division by zero.
                const s = (0, $f5215ba964de19ce$export$9c59b80dda569a6e)((0, $8a3e558d5bb76a4c$export$9dca161faaf6308b)(rjj, 0), (0, $bea433ea0b14d5fb$export$b5469a65e8732256)([
                    [
                        -1
                    ]
                ]), (0, $bea433ea0b14d5fb$export$b5469a65e8732256)([
                    [
                        1
                    ]
                ]));
                const u1 = (0, $555d660851b98db3$export$f93b5905241a7cca)(rjj, (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(s, normX));
                const wPre = (0, $15928a4fee5ff81f$export$159d9494db57879b)(rjEnd1, u1);
                if (wPre.shape[0] === 1) w = (0, $44a9d8b42e3e34af$export$9cd59f9826255e47)(one2D);
                else w = (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)([
                    one2D,
                    (0, $535db06fef6716ec$export$58adb3bec8346d0f)(wPre, [
                        1,
                        0
                    ], [
                        wPre.shape[0] - 1,
                        wPre.shape[1]
                    ])
                ], 0);
                const tau = (0, $0ca018ac52410371$export$d9493ff0dfa0fdd5)((0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $7f1f3e54d78420da$export$6706882a873e9a8f)(s, u1), normX));
                // -- R := HR, Q := QH.
                const rjEndAll = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(r, [
                    j,
                    0
                ], [
                    m - j,
                    n
                ]);
                const tauTimesW = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(tau, w);
                const wT = (0, $7bef7bb1507e4cb8$export$9cb09a71b7d66923)(w);
                if (j === 0) r = (0, $555d660851b98db3$export$f93b5905241a7cca)(rjEndAll, (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(tauTimesW, (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(wT, rjEndAll)));
                else {
                    const rTimesTau = (0, $555d660851b98db3$export$f93b5905241a7cca)(rjEndAll, (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(tauTimesW, (0, $7f1f3e54d78420da$export$6706882a873e9a8f)(wT, rjEndAll)));
                    r = (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)([
                        (0, $535db06fef6716ec$export$58adb3bec8346d0f)(r, [
                            0,
                            0
                        ], [
                            j,
                            n
                        ]),
                        rTimesTau
                    ], 0);
                }
                const tawTimesWT = (0, $7bef7bb1507e4cb8$export$9cb09a71b7d66923)(tauTimesW);
                const qAllJEnd = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(q, [
                    0,
                    j
                ], [
                    m,
                    q.shape[1] - j
                ]);
                if (j === 0) q = (0, $555d660851b98db3$export$f93b5905241a7cca)(qAllJEnd, (0, $7f1f3e54d78420da$export$6706882a873e9a8f)((0, $7f1f3e54d78420da$export$6706882a873e9a8f)(qAllJEnd, w), tawTimesWT));
                else {
                    const qTimesTau = (0, $555d660851b98db3$export$f93b5905241a7cca)(qAllJEnd, (0, $7f1f3e54d78420da$export$6706882a873e9a8f)((0, $7f1f3e54d78420da$export$6706882a873e9a8f)(qAllJEnd, w), tawTimesWT));
                    q = (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)([
                        (0, $535db06fef6716ec$export$58adb3bec8346d0f)(q, [
                            0,
                            0
                        ], [
                            m,
                            j
                        ]),
                        qTimesTau
                    ], 1);
                }
                return [
                    w,
                    r,
                    q
                ];
            });
            (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)([
                rTemp,
                wTemp,
                qTemp
            ]);
        }
        if (!fullMatrices && m > n) {
            q = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(q, [
                0,
                0
            ], [
                m,
                n
            ]);
            r = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(r, [
                0,
                0
            ], [
                n,
                n
            ]);
        }
        return [
            q,
            r
        ];
    });
}
const $d67fe76a3cc8e71b$export$7c27fb47516129d9 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    qr_: $d67fe76a3cc8e71b$var$qr_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $d33626f0529b69e1$export$cc9fa7113d70efba;
(function(Reduction) {
    Reduction[Reduction["NONE"] = 0] = "NONE";
    Reduction[Reduction["MEAN"] = 1] = "MEAN";
    Reduction[Reduction["SUM"] = 2] = "SUM";
    Reduction[Reduction["SUM_BY_NONZERO_WEIGHTS"] = 3] = "SUM_BY_NONZERO_WEIGHTS";
})($d33626f0529b69e1$export$cc9fa7113d70efba || ($d33626f0529b69e1$export$cc9fa7113d70efba = {}));















/**
 * Computes the weighted loss between two tensors.
 *
 * @param losses Tensor of shape `[batch_size, d1, ..., dN]`.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `losses`, and must be broadcastable to `losses` (i.e., all
 *    dimensions must be either `1`, or the same as the corresponding
 *    `losses` dimension).
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $7e41b4c5c17c7f73$var$computeWeightedLoss_(losses, weights, reduction = (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $losses = (0, $010a899b69412c72$export$ede379c4c939d71a)(losses, 'losses', 'computeWeightedLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'computeWeightedLoss');
    const weightedLoss = $weights == null ? $losses : (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($losses, $weights);
    if (reduction === (0, $d33626f0529b69e1$export$cc9fa7113d70efba).NONE) return weightedLoss;
    if (reduction === (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM) return (0, $7215cb99724b7643$export$8a63f25cc62965f1)(weightedLoss);
    if (reduction === (0, $d33626f0529b69e1$export$cc9fa7113d70efba).MEAN) {
        if ($weights == null) return (0, $475473fd3a900b08$export$1ce691f85baaa52)(weightedLoss);
        else {
            const broadcastFactor = $losses.size / $weights.size;
            const result = (0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $7215cb99724b7643$export$8a63f25cc62965f1)(weightedLoss), (0, $7215cb99724b7643$export$8a63f25cc62965f1)($weights));
            return broadcastFactor > 1 ? (0, $15928a4fee5ff81f$export$159d9494db57879b)(result, (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(broadcastFactor)) : result;
        }
    }
    if (reduction === (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
        if ($weights == null) return (0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $7215cb99724b7643$export$8a63f25cc62965f1)(weightedLoss), (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)($losses.size));
        else {
            const broadcastedWeights = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($weights, (0, $b838e56973f13fe0$export$21041dee6b8001b0)($losses.shape));
            const numNonZeros = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)((0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $683debd13acf606f$export$53a6892c50694894)(broadcastedWeights, (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(0))), 'float32');
            return (0, $15928a4fee5ff81f$export$159d9494db57879b)((0, $7215cb99724b7643$export$8a63f25cc62965f1)(weightedLoss), numNonZeros);
        }
    }
    throw Error(`Unknown reduction: ${reduction}`);
}
const $7e41b4c5c17c7f73$export$23bdc4cea2e28782 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    computeWeightedLoss_: $7e41b4c5c17c7f73$var$computeWeightedLoss_
});


/**
 * Computes the absolute difference loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $82e0f41f88acdfa8$var$absoluteDifference_(labels, predictions, weights, reduction = (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $010a899b69412c72$export$ede379c4c939d71a)(labels, 'labels', 'absoluteDifference');
    const $predictions = (0, $010a899b69412c72$export$ede379c4c939d71a)(predictions, 'predictions', 'absoluteDifference');
    let $weights = null;
    if (weights != null) $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'absoluteDifference');
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in absoluteDifference: ');
    const losses = (0, $551d87f9cd40f29c$export$2335f513bbd82c6d)((0, $555d660851b98db3$export$f93b5905241a7cca)($labels, $predictions));
    return (0, $7e41b4c5c17c7f73$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $82e0f41f88acdfa8$export$d81f35aebafd8971 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    absoluteDifference_: $82e0f41f88acdfa8$var$absoluteDifference_
});












/**
 * Computes the cosine distance loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param axis The dimension along which the cosine distance is computed.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $2325895a8bf09f42$var$cosineDistance_(labels, predictions, axis, weights, reduction = (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $010a899b69412c72$export$ede379c4c939d71a)(labels, 'labels', 'cosineDistance');
    const $predictions = (0, $010a899b69412c72$export$ede379c4c939d71a)(predictions, 'predictions', 'cosineDistance');
    let $weights = null;
    if (weights != null) $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'cosineDistance');
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in cosineDistance: ');
    const one = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(1);
    const losses = (0, $555d660851b98db3$export$f93b5905241a7cca)(one, (0, $7215cb99724b7643$export$8a63f25cc62965f1)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($labels, $predictions), axis, true));
    return (0, $7e41b4c5c17c7f73$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $2325895a8bf09f42$export$6168ae03858f836b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    cosineDistance_: $2325895a8bf09f42$var$cosineDistance_
});











/**
 * Computes the Hinge loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $7978d6e60cc0aafc$var$hingeLoss_(labels, predictions, weights, reduction = (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    let $labels = (0, $010a899b69412c72$export$ede379c4c939d71a)(labels, 'labels', 'hingeLoss');
    const $predictions = (0, $010a899b69412c72$export$ede379c4c939d71a)(predictions, 'predictions', 'hingeLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'hingeLoss');
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in hingeLoss: ');
    const one = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(1);
    // Convert binary labels to (-1, 1)
    $labels = (0, $555d660851b98db3$export$f93b5905241a7cca)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(2), $labels), one);
    const losses = (0, $633a7fface57265e$export$16d1e4612cc0139f)((0, $555d660851b98db3$export$f93b5905241a7cca)(one, (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($labels, $predictions)));
    return (0, $7e41b4c5c17c7f73$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $7978d6e60cc0aafc$export$fc7754731492f43f = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    hingeLoss_: $7978d6e60cc0aafc$var$hingeLoss_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 











/**
 * Computes the Huber loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param delta Point where Huber loss changes from quadratic to linear.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`.
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $1b63d20f6bf329ec$var$huberLoss_(labels, predictions, weights, delta = 1.0, reduction = (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $010a899b69412c72$export$ede379c4c939d71a)(labels, 'labels', 'huberLoss');
    const $predictions = (0, $010a899b69412c72$export$ede379c4c939d71a)(predictions, 'predictions', 'huberLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'huberLoss');
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in huberLoss: ');
    const deltaScalar = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(delta);
    const error = (0, $551d87f9cd40f29c$export$2335f513bbd82c6d)((0, $555d660851b98db3$export$f93b5905241a7cca)($predictions, $labels));
    const quadratic = (0, $509eb1d608c78c8e$export$916782c1f0ddb132)(error, deltaScalar);
    const linear = (0, $555d660851b98db3$export$f93b5905241a7cca)(error, quadratic);
    const losses = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(0.5), (0, $03801900ae8a72ab$export$dd4f28cef696bc7d)(quadratic)), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(deltaScalar, linear));
    return (0, $7e41b4c5c17c7f73$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $1b63d20f6bf329ec$export$ad2dd557b367bf2b = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    huberLoss_: $1b63d20f6bf329ec$var$huberLoss_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 










/**
 * Computes the log loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param epsilon A small increment to avoid taking log of zero
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $643d1dca5449e87b$var$logLoss_(labels, predictions, weights, epsilon = 1e-7, reduction = (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $010a899b69412c72$export$ede379c4c939d71a)(labels, 'labels', 'logLoss');
    const $predictions = (0, $010a899b69412c72$export$ede379c4c939d71a)(predictions, 'predictions', 'logLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'logLoss');
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in logLoss: ');
    const one = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(1);
    const epsilonScalar = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(epsilon);
    const l1 = (0, $0ca018ac52410371$export$d9493ff0dfa0fdd5)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($labels, (0, $99bf7e02d49647cf$export$bef1f36f5486a6a3)((0, $c90bd95bc0e58efa$export$e16d8520af44a096)($predictions, epsilonScalar))));
    const l2 = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $555d660851b98db3$export$f93b5905241a7cca)(one, $labels), (0, $99bf7e02d49647cf$export$bef1f36f5486a6a3)((0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $555d660851b98db3$export$f93b5905241a7cca)(one, $predictions), epsilonScalar)));
    const losses = (0, $555d660851b98db3$export$f93b5905241a7cca)(l1, l2);
    return (0, $7e41b4c5c17c7f73$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $643d1dca5449e87b$export$5ca6937b99935214 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    logLoss_: $643d1dca5449e87b$var$logLoss_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





/**
 * Computes the mean squared error between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $21b08f37b92a1b63$var$meanSquaredError_(labels, predictions, weights, reduction = (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $010a899b69412c72$export$ede379c4c939d71a)(labels, 'labels', 'meanSquaredError');
    const $predictions = (0, $010a899b69412c72$export$ede379c4c939d71a)(predictions, 'predictions', 'meanSquaredError');
    let $weights = null;
    if (weights != null) $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'meanSquaredError');
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($labels.shape, $predictions.shape, 'Error in meanSquaredError: ');
    const losses = (0, $7adf3ff43b38d937$export$b178697fb6d0b37f)($labels, $predictions);
    return (0, $7e41b4c5c17c7f73$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $21b08f37b92a1b63$export$33de16355e97f7fb = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    meanSquaredError_: $21b08f37b92a1b63$var$meanSquaredError_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 













function $57265e077d51af65$var$sigmoidCrossEntropyWithLogits_(labels, logits) {
    const $labels = (0, $010a899b69412c72$export$ede379c4c939d71a)(labels, 'labels', 'sigmoidCrossEntropyWithLogits');
    const $logits = (0, $010a899b69412c72$export$ede379c4c939d71a)(logits, 'logits', 'sigmoidCrossEntropyWithLogits');
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($labels.shape, $logits.shape, 'Error in sigmoidCrossEntropyWithLogits: ');
    /**
     * Implementation Details:
     *
     * For brevity, let `x = logits`, `z = labels`.  The logistic loss is
     *     z * -log(sigmoid(x)) + (1 - z) * -log(1 - sigmoid(x))
     *   = z * -log(1 / (1 + exp(-x))) + (1 - z) * -log(exp(-x) / (1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (-log(exp(-x)) + log(1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (x + log(1 + exp(-x))
     *   = (1 - z) * x + log(1 + exp(-x))
     *   = x - x * z + log(1 + exp(-x))
     *
     *   For x < 0, to avoid overflow in exp(-x), we reformulate the above
     *     x - x * z + log(1 + exp(-x))
     *   = log(exp(x)) - x * z + log(1 + exp(-x))
     *   = - x * z + log(1 + exp(x))
     *
     * Hence, to ensure stability and avoid overflow, the implementation uses
     * this equivalent formulation:
     *     max(x, 0) - x * z + log(1 + exp(-abs(x)))
     */ const maxOutput = (0, $633a7fface57265e$export$16d1e4612cc0139f)($logits);
    const outputXTarget = (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($logits, $labels);
    const sigmoidOutput = (0, $442dfe97b70d73dc$export$144dcf16adfb9698)((0, $20ea4fdf69fd4a26$export$b310ec824aaee37f)((0, $0ca018ac52410371$export$d9493ff0dfa0fdd5)((0, $551d87f9cd40f29c$export$2335f513bbd82c6d)($logits))));
    return (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $555d660851b98db3$export$f93b5905241a7cca)(maxOutput, outputXTarget), sigmoidOutput);
}
/**
 * Computes the sigmoid cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newMulticlassLabels = multiclassLabels * (1 - labelSmoothing)
 *                         + 0.5 * labelSmoothing
 *
 * @param multiClassLabels The ground truth output tensor of shape
 * [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $57265e077d51af65$var$sigmoidCrossEntropy_(multiClassLabels, logits, weights, labelSmoothing = 0, reduction = (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    let $multiClassLabels = (0, $010a899b69412c72$export$ede379c4c939d71a)(multiClassLabels, 'multiClassLabels', 'sigmoidCrossEntropy');
    const $logits = (0, $010a899b69412c72$export$ede379c4c939d71a)(logits, 'logits', 'sigmoidCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'sigmoidCrossEntropy');
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($multiClassLabels.shape, $logits.shape, 'Error in sigmoidCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(labelSmoothing);
        const one = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(1);
        const half = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(0.5);
        $multiClassLabels = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($multiClassLabels, (0, $555d660851b98db3$export$f93b5905241a7cca)(one, labelSmoothingScalar)), (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(half, labelSmoothingScalar));
    }
    const losses = $57265e077d51af65$var$sigmoidCrossEntropyWithLogits_($multiClassLabels, $logits);
    return (0, $7e41b4c5c17c7f73$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $57265e077d51af65$export$d099e04c73e0aede = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sigmoidCrossEntropy_: $57265e077d51af65$var$sigmoidCrossEntropy_
});


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

















/**
 * Computes softmax cross entropy between logits and labels.
 *
 * Measures the probability error in discrete classification tasks in which
 * the classes are mutually exclusive (each entry is in exactly one class).
 * For example, each CIFAR-10 image is labeled with one and only one label: an
 * image can be a dog or a truck, but not both.
 *
 * `NOTE`: While the classes are mutually exclusive, their probabilities need
 * not be. All that is required is that each row of labels is a valid
 * probability distribution. If they are not, the computation of the gradient
 * will be incorrect.
 *
 * `WARNING`: This op expects unscaled logits, since it performs a softmax on
 * logits internally for efficiency. Do not call this op with the output of
 * softmax, as it will produce incorrect results.
 *
 * logits and labels must have the same shape, e.g. [batch_size, num_classes]
 * and the same dtype.
 * @param labels The labels array.
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 */ function $01108b7743df9572$var$softmaxCrossEntropyWithLogits_(labels, logits, dim = -1) {
    if (dim === -1) dim = logits.rank - 1;
    if (dim !== logits.rank - 1) throw Error(`Softmax cross entropy along a non-last dimension is not yet ` + `supported. Labels / logits was rank ${logits.rank} ` + `and dim was ${dim}`);
    // Use a custom gradient for numerical stability.
    const customOp = (0, $694041655139423f$export$5519f0eeb00c44e5)((labels, logits, save)=>{
        // Reference:
        //   1. http://cs231n.github.io/linear-classify/#softmax
        //   2. https://blog.feedly.com/tricks-of-the-trade-logsumexp/
        const keepDims = true;
        const lse = (0, $6b6676f787cc0273$export$e20aca1e89397787)(logits, [
            dim
        ], keepDims);
        const logResult = (0, $555d660851b98db3$export$f93b5905241a7cca)((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(logits, 'float32'), lse);
        save([
            labels,
            logResult
        ]);
        const costVector = (0, $0ca018ac52410371$export$d9493ff0dfa0fdd5)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(logResult, labels));
        const value = (0, $7215cb99724b7643$export$8a63f25cc62965f1)(costVector, [
            dim
        ]);
        const gradFunc = (dy, saved)=>{
            const [labels, logResult] = saved;
            const dyShape = (0, $f36081d4d230c419$export$e35db9afe008d7e3)(dy.shape, [
                dim
            ]);
            return [
                (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(dy, dyShape), (0, $555d660851b98db3$export$f93b5905241a7cca)((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(labels, 'float32'), (0, $20ea4fdf69fd4a26$export$b310ec824aaee37f)(logResult))),
                (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(dy, dyShape), (0, $555d660851b98db3$export$f93b5905241a7cca)((0, $20ea4fdf69fd4a26$export$b310ec824aaee37f)(logResult), (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(labels, 'float32')))
            ];
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp(labels, logits);
}
/**
 * Computes the softmax cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newOnehotLabels = onehotLabels * (1 - labelSmoothing)
 *                         + labelSmoothing / numClasses
 *
 * @param onehotLabels One hot encoded labels
 *    [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or 1, and must be
 *    broadcastable to `loss`  of shape [batch_size]
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $01108b7743df9572$var$softmaxCrossEntropy_(onehotLabels, logits, weights, labelSmoothing = 0, reduction = (0, $d33626f0529b69e1$export$cc9fa7113d70efba).SUM_BY_NONZERO_WEIGHTS) {
    let $onehotLabels = (0, $010a899b69412c72$export$ede379c4c939d71a)(onehotLabels, 'onehotLabels', 'softmaxCrossEntropy');
    const $logits = (0, $010a899b69412c72$export$ede379c4c939d71a)(logits, 'logits', 'softmaxCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $010a899b69412c72$export$ede379c4c939d71a)(weights, 'weights', 'softmaxCrossEntropy');
    (0, $5f8d0ee7a8d35dfe$export$e08b27e7f37e2782)($onehotLabels.shape, $logits.shape, 'Error in softmaxCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(labelSmoothing);
        const one = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(1);
        const numClasses = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)($onehotLabels.shape[1]);
        $onehotLabels = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)($onehotLabels, (0, $555d660851b98db3$export$f93b5905241a7cca)(one, labelSmoothingScalar)), (0, $15928a4fee5ff81f$export$159d9494db57879b)(labelSmoothingScalar, numClasses));
    }
    const losses = $01108b7743df9572$var$softmaxCrossEntropyWithLogits_($onehotLabels, $logits);
    return (0, $7e41b4c5c17c7f73$export$23bdc4cea2e28782)(losses, $weights, reduction);
}
const $01108b7743df9572$export$38869aa02829577 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    softmaxCrossEntropy_: $01108b7743df9572$var$softmaxCrossEntropy_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * The input SparseTensor is represented via the map of inputs {`indices`,
 * `values`, `denseShape`}. The output SparseTensor has the same `denseShape`
 * but with indices `outputIndices` and values `outputValues`. This op inserts a
 * single entry for every row that doesn't have any values. The index is created
 * as `[row, 0, ..., 0]` and the inserted value is `defaultValue`.
 *
 * For example, suppose `spInput` has shape [5, 6] and non-empty values:
 * [0, 1]: a
 * [0, 3]: b
 * [2, 0]: c
 * [3, 1]: d
 *
 * Rows 1 and 4 are empty, so the output will be of shape [5, 6] with values:
 * [0, 1]: a
 * [0, 3]: b
 * [1, 0]: `defaultValue`
 * [2, 0]: c
 * [3, 1]: d
 * [4, 0]: `defaultValue`
 *
 * The output SparseTensor will be in row-major order and will have the same
 * shape as the input.
 *
 * This op also returns an indicator vector shaped [dense_shape[0]] such that
 * emptyRowIndicator[i] = True iff row i was an empty row.
 *
 * And a reverse index map vector shaped [indices.shape[0]] that is used during
 * backpropagation, reverseIndexMap[i] = outi s.t. indices[i, j] ==
 * outputIndices[outi, j] for all j
 *
 * ```js
 * const result = tf.sparse.sparseFillEmptyRows(
 *   [[0, 0], [1, 0], [1, 3], [1, 4], [3, 2], [3, 3]],
 *   [0, 10, 13, 14, 32, 33], [5, 6], -1);
 * console.log(result);
 * result['outputIndices'].print(); // [[0, 0], [1, 0], [1, 3], [1, 4],
 *                                  //  [2, 0], [3, 2], [3, 3], [4, 0]]
 * result['outputValues'].print(); // [0, 10, 13, 14,-1, 32, 33, -1]
 * result['emptyRowIndicator'].print(); // [false, false, true, false, true]
 * result['reverseIndexMap'].print(); // [0, 1, 2, 3, 5, 6]
 * ```
 * @param indices: 2-D. The indices of the sparse tensor.
 * @param values: 1-D. The values of the sparse tensor.
 * @param denseShape: 1-D. The shape of the sparse tensor.
 * @param defaultValue: 0-D. Default value to insert into location [row, 0, ...,
 *     0] for rows missing from the input sparse tensor.
 * @return A map with the following properties:
 *     - outputIndices
 *     - outputValues: 1-D. The values of the filled sparse tensor.
 *     - emptyRowIndicator: 1-D. Whether the dense row was missing in the input
 * sparse tensor.
 *     - reverseIndexMap: 1-D. A map from the input indices to the output
 * indices.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $c58d6ea91d141f41$var$sparseFillEmptyRows_(indices, values, denseShape, defaultValue) {
    const $indices = (0, $010a899b69412c72$export$ede379c4c939d71a)(indices, 'indices', 'sparseFillEmptyRows', 'int32');
    const $values = (0, $010a899b69412c72$export$ede379c4c939d71a)(values, 'values', 'sparseFillEmptyRows');
    const $denseShape = (0, $010a899b69412c72$export$ede379c4c939d71a)(denseShape, 'denseShape', 'sparseFillEmptyRows', 'int32');
    const $defaultValue = (0, $010a899b69412c72$export$ede379c4c939d71a)(defaultValue, 'defaultValue', 'sparseFillEmptyRows', $values.dtype);
    if ($indices.rank !== 2) throw new Error(`Indices should be Tensor2D but received shape
        ${$indices.shape}`);
    if ($values.rank !== 1) throw new Error(`Values should be Tensor1D but received shape ${$values.shape}`);
    if ($denseShape.rank !== 1) throw new Error(`Dense shape should be Tensor1D but received shape ${$denseShape.shape}`);
    if ($defaultValue.rank !== 0) throw new Error(`Default value should be a scalar but received shape ${$defaultValue.shape}`);
    const inputs = {
        indices: $indices,
        values: $values,
        denseShape: $denseShape,
        defaultValue: $defaultValue
    };
    const result = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$8f1933853a5c8cca), inputs);
    return {
        outputIndices: result[0],
        outputValues: result[1],
        emptyRowIndicator: result[2],
        reverseIndexMap: result[3]
    };
}
const $c58d6ea91d141f41$export$c82a1904a15b5028 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sparseFillEmptyRows_: $c58d6ea91d141f41$var$sparseFillEmptyRows_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * This operation has the same semantics as reshape on the represented dense
 * tensor. The `inputIndices` are recomputed based on the requested `newShape`.
 * If one component of `newShape` is the special value -1, the size of that
 * dimension is computed so that the total dense size remains constant. At most
 * one component of `newShape` can be -1. The number of dense elements implied
 * by `newShape` must be the same as the number of dense elements originally
 * implied by `inputShape`. Reshaping does not affect the order of values in the
 * SparseTensor. If the input tensor has rank R_in and N non-empty values, and
 * `newShape` has length R_out, then `inputIndices` has shape [N, R_in],
 * `inputShape` has length R_in, `outputIndices` has shape [N, R_out], and
 * `outputShape` has length R_out.
 *
 * ```js
 * const result = tf.sparse.sparseReshape(
 *   [[0, 0, 0], [0, 0, 1], [0, 1, 0], [1, 0, 0], [1, 2, 3]],
 *   [2, 3, 6], [9, -1]);
 * console.log(result);
 * result['outputIndices'].print(); //[[0, 0], [0, 1], [1, 2], [4, 2], [8, 1]]
 * result['outputShape'].print(); // [9, 4]
 * ```
 * @param inputIndices: 2-D. N x R_in matrix with the indices of non-empty
 * values in a SparseTensor.
 * @param inputShape: 1-D. R_in Tensor1D with the input SparseTensor's dense
 * shape.
 * @param newShape: 1-D. R_out Tensor1D with the requested new dense shape.
 * @return A map with the following properties:
 *     - outputIndices: 2-D. N x R_out matrix with the updated indices of
 *       non-empty values in the output SparseTensor.
 *     - outputShape: 1-D. R_out vector with the full dense shape of the output
 *       SparseTensor. This is the same as newShape but with any -1 dimensions
 *        filled in.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $b7c7ec20f4bc8879$var$sparseReshape_(inputIndices, inputShape, newShape) {
    const $inputIndices = (0, $010a899b69412c72$export$ede379c4c939d71a)(inputIndices, 'inputIndices', 'sparseReshape', 'int32');
    const $inputShape = (0, $010a899b69412c72$export$ede379c4c939d71a)(inputShape, 'inputShape', 'sparseReshape', 'int32');
    const $newShape = (0, $010a899b69412c72$export$ede379c4c939d71a)(newShape, 'newShape', 'sparseReshape', 'int32');
    if ($inputIndices.rank !== 2) throw new Error(`Input indices should be Tensor2D but received shape
        ${$inputIndices.shape}`);
    if ($inputShape.rank !== 1) throw new Error(`Input shape should be Tensor1D but received shape ${$inputShape.shape}`);
    if ($newShape.rank !== 1) throw new Error(`New shape should be Tensor1D but received shape ${$newShape.shape}`);
    const inputs = {
        inputIndices: $inputIndices,
        inputShape: $inputShape,
        newShape: $newShape
    };
    const result = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$f08f0dca44fa542), inputs);
    return {
        outputIndices: result[0],
        outputShape: result[1]
    };
}
const $b7c7ec20f4bc8879$export$1408c45865e11fc6 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sparseReshape_: $b7c7ec20f4bc8879$var$sparseReshape_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the mean along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [6,7,8,9]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentMean(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1], 'int32'),
 *                                             tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1, 2], 'int32'),
 *                                             tf.tensor1d([0, 1, 1], 'int32'));
 * result3.print(); // [[1.0, 2.0, 3.0, 4.0], [2.5, 2.5, 2.5, 2.5]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $17d5f1474b4a6bff$var$sparseSegmentMean_(data, indices, segmentIds) {
    const $data = (0, $010a899b69412c72$export$ede379c4c939d71a)(data, 'data', 'sparseSegmentMean');
    const $indices = (0, $010a899b69412c72$export$ede379c4c939d71a)(indices, 'indices', 'sparseSegmentMean', 'int32');
    const $segmentIds = (0, $010a899b69412c72$export$ede379c4c939d71a)(segmentIds, 'segmentIds', 'sparseSegmentMean', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
          ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
          ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$610b077aecc2447b), inputs);
}
const $17d5f1474b4a6bff$export$dbc0c9096869d04e = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sparseSegmentMean_: $17d5f1474b4a6bff$var$sparseSegmentMean_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Computes the sum along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [5,6,7,8]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1, 2], 'int32'),
 *                                           tf.tensor1d([0, 0, 1], 'int32'));
 * result3.print(); // [[0, 0, 0, 0], [5, 6, 7, 8]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $4c06a6535631585e$var$sparseSegmentSum_(data, indices, segmentIds) {
    const $data = (0, $010a899b69412c72$export$ede379c4c939d71a)(data, 'data', 'sparseSegmentSum');
    const $indices = (0, $010a899b69412c72$export$ede379c4c939d71a)(indices, 'indices', 'sparseSegmentSum', 'int32');
    const $segmentIds = (0, $010a899b69412c72$export$ede379c4c939d71a)(segmentIds, 'segmentIds', 'sparseSegmentSum', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
         ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
         ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$68351c28d7116b56), inputs);
}
const $4c06a6535631585e$export$2255ce53fc777865 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    sparseSegmentSum_: $4c06a6535631585e$var$sparseSegmentSum_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Creates ngrams from ragged string data.
 *
 * This op accepts a ragged tensor with 1 ragged dimension containing only
 * strings and outputs a ragged tensor with 1 ragged dimension containing ngrams
 * of that string, joined along the innermost axis.
 *
 * ```js
 * const result = tf.string.stringNGrams(
 *   ['a', 'b', 'c', 'd'], tf.tensor1d([0, 2, 4], 'int32'),
 *   '|', [1, 2], 'LP', 'RP', -1, false);
 * result['nGrams'].print(); // ['a', 'b', 'LP|a', 'a|b', 'b|RP',
 *                           //  'c', 'd', 'LP|c', 'c|d', 'd|RP']
 * result['nGramsSplits'].print(); // [0, 5, 10]
 * ```
 * @param data: The values tensor of the ragged string tensor to make ngrams out
 *     of. Must be a 1D string tensor.
 * @param dataSplits: The splits tensor of the ragged string tensor to make
 *     ngrams out of.
 * @param separator: The string to append between elements of the token. Use ""
 *     for no separator.
 * @param nGramWidths: The sizes of the ngrams to create.
 * @param leftPad: The string to use to pad the left side of the ngram sequence.
 *     Only used if pad_width !== 0.
 * @param rightPad: The string to use to pad the right side of the ngram
 *     sequence. Only used if pad_width !== 0.
 * @param padWidth: The number of padding elements to add to each side of each
 *     sequence. Note that padding will never be greater than `nGramWidths`-1
 *     regardless of this value. If `padWidth`=-1, then add max(`nGramWidths`)-1
 *     elements.
 * @param preserveShortSequences: If true, then ensure that at least one ngram
 *     is generated for each input sequence. In particular, if an input sequence
 *     is shorter than min(ngramWidth) + 2*padWidth, then generate a single
 *     ngram containing the entire sequence. If false, then no ngrams are
 *     generated for these short input sequences.
 * @return A map with the following properties:
 *     - nGrams: The values tensor of the output ngrams ragged tensor.
 *     - nGramsSplits: The splits tensor of the output ngrams ragged tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $855276121844dfd0$var$stringNGrams_(data, dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences) {
    const $data = (0, $010a899b69412c72$export$ede379c4c939d71a)(data, 'data', 'stringNGrams', 'string');
    if ($data.dtype !== 'string') throw new Error('Data must be of datatype string');
    if ($data.shape.length !== 1) throw new Error(`Data must be a vector, saw: ${$data.shape}`);
    const $dataSplits = (0, $010a899b69412c72$export$ede379c4c939d71a)(dataSplits, 'dataSplits', 'stringNGrams');
    if ($dataSplits.dtype !== 'int32') throw new Error('Data splits must be of datatype int32');
    const attrs = {
        separator: separator,
        nGramWidths: nGramWidths,
        leftPad: leftPad,
        rightPad: rightPad,
        padWidth: padWidth,
        preserveShortSequences: preserveShortSequences
    };
    const inputs = {
        data: $data,
        dataSplits: $dataSplits
    };
    const result = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$11a7f4af7d96ad41), inputs, attrs);
    return {
        nGrams: result[0],
        nGramsSplits: result[1]
    };
}
const $855276121844dfd0$export$3490514dcc63b044 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    stringNGrams_: $855276121844dfd0$var$stringNGrams_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Split elements of `input` based on `delimiter` into a SparseTensor .
 *
 * Let N be the size of source (typically N will be the batch size). Split each
 * element of `input` based on `delimiter` and return a SparseTensor containing
 * the splitted tokens. Empty tokens are ignored if `skipEmpty` is set to True.
 *
 * `delimiter` can be empty, or a string of split characters. If `delimiter` is
 * an empty string, each element of `input` is split into individual
 * character strings. Otherwise every character of `delimiter` is a potential
 * split point.
 *
 * ```js
 * const result = tf.string.stringSplit(['hello world',  'a b c'], ' ');
 * result['indices'].print(); // [[0, 0], [0, 1], [1, 0], [1, 1], [1, 2]]
 * result['values'].print(); // ['hello', 'world', 'a', 'b', 'c']
 * result['shape'].print(); // [2, 3]
 * ```
 * @param input: 1-D. Strings to split.
 * @param delimiter: 0-D. Delimiter characters, or empty string.
 * @param skipEmpty: Optional. If true, skip the empty strings from the result.
 *     Defaults to true.
 * @return A map with the following properties:
 *     - indices: A dense matrix of int32 representing the indices of the sparse
 *       tensor.
 *     - values: A vector of strings corresponding to the splited values.
 *     - shape: a length-2 vector of int32 representing the shape of the sparse
 * tensor, where the first value is N and the second value is the maximum number
 * of tokens in a single input entry.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $0ae0fe890110e667$var$stringSplit_(input, delimiter, skipEmpty = true) {
    const $input = (0, $010a899b69412c72$export$ede379c4c939d71a)(input, 'input', 'stringSplit', 'string');
    const $delimiter = (0, $010a899b69412c72$export$ede379c4c939d71a)(delimiter, 'delimiter', 'stringSplit', 'string');
    if ($input.rank !== 1) throw new Error(`Input should be Tensor1D but received shape ${$input.shape}`);
    if ($delimiter.rank !== 0) throw new Error(`Delimiter should be a scalar but received shape ${$delimiter.shape}`);
    const attrs = {
        skipEmpty: skipEmpty
    };
    const inputs = {
        input: $input,
        delimiter: $delimiter
    };
    const result = (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$7e266f7223b9d396), inputs, attrs);
    return {
        indices: result[0],
        values: result[1],
        shape: result[2]
    };
}
const $0ae0fe890110e667$export$aa7f8babb17e7672 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    stringSplit_: $0ae0fe890110e667$var$stringSplit_
});


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Converts each string in the input Tensor to its hash mod by a number of
 * buckets.
 *
 * The hash function is deterministic on the content of the string within the
 * process and will never change. However, it is not suitable for cryptography.
 * This function may be used when CPU time is scarce and inputs are trusted or
 * unimportant. There is a risk of adversaries constructing inputs that all hash
 * to the same bucket.
 *
 * ```js
 * const result = tf.string.stringToHashBucketFast(
 *   ['Hello', 'TensorFlow', '2.x'], 3);
 * result.print(); // [0, 2, 2]
 * ```
 * @param input: The strings to assign a hash bucket.
 * @param numBuckets: The number of buckets.
 * @return A Tensor of the same shape as the input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $bbcd2f4086631904$var$stringToHashBucketFast_(input, numBuckets) {
    const $input = (0, $010a899b69412c72$export$ede379c4c939d71a)(input, 'input', 'stringToHashBucketFast', 'string');
    const attrs = {
        numBuckets: numBuckets
    };
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const inputs = {
        input: $input
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$a5639899909bc8ae), inputs, attrs);
}
const $bbcd2f4086631904$export$6195616d6fd0c848 = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    stringToHashBucketFast_: $bbcd2f4086631904$var$stringToHashBucketFast_
});


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 



/**
 * Replace the match of a `pattern` in `input` with `rewrite`.
 *
 * ```js
 * const result = tf.string.staticRegexReplace(
 *     ['format       this   spacing      better'], ' +', ' ');
 * result.print(); // ['format this spacing better']
 * ```
 * @param input: A Tensor of type string. The text to be processed.
 * @param pattern: A string. The regular expression to match the input.
 * @param rewrite: A string. The rewrite to be applied to the matched
 *     expression.
 * @param replaceGlobal: An optional bool. Defaults to True. If True, the
 *     replacement is global, otherwise the replacement is done only on the
 *     first match.
 * @return A Tensor of type string.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $8bb9f3a220558625$var$staticRegexReplace_(input, pattern, rewrite, replaceGlobal = true) {
    const $input = (0, $010a899b69412c72$export$ede379c4c939d71a)(input, 'input', 'staticRegexReplace', 'string');
    const attrs = {
        pattern: pattern,
        rewrite: rewrite,
        replaceGlobal: replaceGlobal
    };
    return (0, $249f84ddb1ced836$export$33b63313cc511a3b).runKernel((0, $c9f78399309a8a0d$export$2fbaa77553edaeff), {
        x: $input
    }, attrs);
}
const $8bb9f3a220558625$export$2bdfdc7ae087914d = /* @__PURE__ */ (0, $e25ad0fc1c7fe06f$export$f59964a629598e2)({
    staticRegexReplace_: $8bb9f3a220558625$var$staticRegexReplace_
});


const $7912647d6e7a4ee9$export$e0ccf6166915bd59 = {
    fft: $1486b5b57f2c7550$export$a535ef183b6128fa,
    ifft: $26eacb6258cb10d5$export$776649b0bf8ce1fd,
    rfft: $8db28b200f22d7be$export$72aff1768917e9e5,
    irfft: $cb2ae7445ffa5769$export$f47f4e5bcd3d6a66
};
const $7912647d6e7a4ee9$export$e2ef10f86a8d60e8 = {
    hammingWindow: $02925f9669efedc1$export$941eafcc99b559fa,
    hannWindow: $bdc802a5a22bb768$export$f498cfeee84e5e59,
    frame: $fd98a793f0920716$export$2cef06c20297c17d,
    stft: $cdf98b3fb379599a$export$eb1cf9b274257b4a
};
const $7912647d6e7a4ee9$export$5c452ff88e35e47d = {
    flipLeftRight: $e439596fc3f8d37a$export$8358b9c43b687b22,
    grayscaleToRGB: $57ea923baa314bcd$export$f68e334bfd7e4be6,
    resizeNearestNeighbor: $a6d772d3dc572a5d$export$74a902ae74ac2560,
    resizeBilinear: $4c832af1e8d94834$export$1f1cbc7da93d06a0,
    rgbToGrayscale: $dbe45fdb7a5f64e9$export$490c4fde2e852c50,
    rotateWithOffset: $c2141030b1b397d1$export$66462c489f5f29d2,
    cropAndResize: $e635a0b2cf6a009d$export$6f0f0090e1f6cd3c,
    nonMaxSuppression: $2a5279fb7ed7e00c$export$b7d265b19ca1d628,
    nonMaxSuppressionAsync: $d4eeaf2379910934$export$cc6d94dffac2ee1a,
    nonMaxSuppressionWithScore: $c0aa5c5c9595bb66$export$d65fe1460f8c5b4e,
    nonMaxSuppressionWithScoreAsync: $5dc292f419a7c34a$export$d1826570c883f7cf,
    nonMaxSuppressionPadded: $c11b80e2eb953c6d$export$d8d10e31c41c95dc,
    nonMaxSuppressionPaddedAsync: $85026b125f5bbb1e$export$4c5691f9710b88a8,
    threshold: $1cfd2736c3bd16df$export$454d09aca5f3ea63,
    transform: $3ae52ebe9b17d3a8$export$51186ad6e864892a
};
const $7912647d6e7a4ee9$export$dbc5be37a4415193 = {
    bandPart: $f106c3304c20e7b0$export$8a3da9cb9e5610a0,
    gramSchmidt: $886763dc106f4c3d$export$d505610386a600de,
    qr: $d67fe76a3cc8e71b$export$7c27fb47516129d9
};
const $7912647d6e7a4ee9$export$24b113a95118cbdc = {
    absoluteDifference: $82e0f41f88acdfa8$export$d81f35aebafd8971,
    computeWeightedLoss: $7e41b4c5c17c7f73$export$23bdc4cea2e28782,
    cosineDistance: $2325895a8bf09f42$export$6168ae03858f836b,
    hingeLoss: $7978d6e60cc0aafc$export$fc7754731492f43f,
    huberLoss: $1b63d20f6bf329ec$export$ad2dd557b367bf2b,
    logLoss: $643d1dca5449e87b$export$5ca6937b99935214,
    meanSquaredError: $21b08f37b92a1b63$export$33de16355e97f7fb,
    sigmoidCrossEntropy: $57265e077d51af65$export$d099e04c73e0aede,
    softmaxCrossEntropy: $01108b7743df9572$export$38869aa02829577
};
const $7912647d6e7a4ee9$export$b6b7e189aa5d134c = {
    sparseFillEmptyRows: $c58d6ea91d141f41$export$c82a1904a15b5028,
    sparseReshape: $b7c7ec20f4bc8879$export$1408c45865e11fc6,
    sparseSegmentMean: $17d5f1474b4a6bff$export$dbc0c9096869d04e,
    sparseSegmentSum: $4c06a6535631585e$export$2255ce53fc777865
};
// tslint:disable-next-line:variable-name
const $7912647d6e7a4ee9$export$22b082955e083ec3 = {
    stringNGrams: $855276121844dfd0$export$3490514dcc63b044,
    stringSplit: $0ae0fe890110e667$export$aa7f8babb17e7672,
    stringToHashBucketFast: $bbcd2f4086631904$export$6195616d6fd0c848,
    staticRegexReplace: $8bb9f3a220558625$export$2bdfdc7ae087914d
};
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $34d7e4c14c617766$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $7bef7bb1507e4cb8$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $554f394697e806e8$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $c2af547bb790802f$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $34a8afa76c8632d3$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $4f8d2a80bf60195c$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $f22637d8b9b4b458$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $420a1e3ced22d90d$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $3e23b5eb4f133b27$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $de4d87485d0c1285$exports);
$parcel$exportWildcard($7912647d6e7a4ee9$exports, $019203b68c50a423$exports);



var $a2aac83cc2c20bd7$exports = {};

$parcel$export($a2aac83cc2c20bd7$exports, "train", () => $a2aac83cc2c20bd7$export$9af937cf8bcbf96);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $a2aac83cc2c20bd7$export$9af937cf8bcbf96 = (0, $898835df87cf1c26$export$1babc3d7b10c0cf6);






/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $71bfb8d913b21bbc$var$delayCallback = (()=>{
    if (typeof requestAnimationFrame !== 'undefined') return requestAnimationFrame;
    else if (typeof setImmediate !== 'undefined') return setImmediate;
    return (f)=>f(); // no delays
})();
/**
 * Returns a promise that resolves when a requestAnimationFrame has completed.
 *
 * On Node.js this uses setImmediate instead of requestAnimationFrame.
 *
 * This is simply a sugar method so that users can do the following:
 * `await tf.nextFrame();`
 *
 * @doc {heading: 'Performance', subheading: 'Timing'}
 */ function $71bfb8d913b21bbc$export$68d2d147c928d1dd() {
    return new Promise((resolve)=>$71bfb8d913b21bbc$var$delayCallback(()=>resolve()));
}


var $5a956a12516ed8ee$exports = {};

$parcel$export($5a956a12516ed8ee$exports, "fromUint8ToStringArray", () => $5a956a12516ed8ee$export$debaff328bdca650);
$parcel$export($5a956a12516ed8ee$exports, "fromStringArrayToUint8", () => $5a956a12516ed8ee$export$ce1f4ec5bdd0ab9a);
$parcel$export($5a956a12516ed8ee$exports, "slice_util", () => $857e39e1331d3036$exports);
$parcel$export($5a956a12516ed8ee$exports, "upcastType", () => $206e8e4148e423f6$export$7bcca02d1a156bdf);
$parcel$export($5a956a12516ed8ee$exports, "segment_util", () => $b6d3dd7a4e14edca$exports);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


var $8f11b07965c032fa$exports = {};

$parcel$export($8f11b07965c032fa$exports, "assertParamsConsistent", () => $8f11b07965c032fa$export$ce1cccab5e7518dd);
$parcel$export($8f11b07965c032fa$exports, "computeOutShape", () => $8f11b07965c032fa$export$22fa6b3b1305508e);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $8f11b07965c032fa$export$ce1cccab5e7518dd(shapes, axis) {
    const rank = shapes[0].length;
    shapes.forEach((shape, i)=>{
        $5f8d0ee7a8d35dfe$export$a7a9523472993e97(shape.length === rank, ()=>`Error in concat${rank}D: rank of tensors[${i}] must be the same ` + `as the rank of the rest (${rank})`);
    });
    $5f8d0ee7a8d35dfe$export$a7a9523472993e97(axis >= 0 && axis < rank, ()=>`Error in concat${rank}D: axis must be between 0 and ${rank - 1}.`);
    const firstShape = shapes[0];
    shapes.forEach((shape, i)=>{
        for(let r = 0; r < rank; r++)$5f8d0ee7a8d35dfe$export$a7a9523472993e97(r === axis || shape[r] === firstShape[r], ()=>`Error in concat${rank}D: Shape of tensors[${i}] (${shape}) ` + `does not match the shape of the rest (${firstShape}) ` + `along the non-concatenated axis ${i}.`);
    });
}
function $8f11b07965c032fa$export$22fa6b3b1305508e(shapes, axis) {
    const outputShape = shapes[0].slice();
    for(let i = 1; i < shapes.length; i++)outputShape[axis] += shapes[i][axis];
    return outputShape;
}




var $9b65f19b1b23a153$exports = {};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

var $eaf0d5393d9bb67a$exports = {};

$parcel$export($eaf0d5393d9bb67a$exports, "RowPartitionType", () => $eaf0d5393d9bb67a$export$c56fa138ccffd243);
$parcel$export($eaf0d5393d9bb67a$exports, "combineRaggedTensorToTensorShapes", () => $eaf0d5393d9bb67a$export$ab67507eda6e05cb);
$parcel$export($eaf0d5393d9bb67a$exports, "getRowPartitionTypesHelper", () => $eaf0d5393d9bb67a$export$b8324e259bdd3daf);
$parcel$export($eaf0d5393d9bb67a$exports, "getRaggedRank", () => $eaf0d5393d9bb67a$export$1cdd548e021d4109);
$parcel$export($eaf0d5393d9bb67a$exports, "validateDefaultValueShape", () => $eaf0d5393d9bb67a$export$4170394182a906f5);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $eaf0d5393d9bb67a$export$c56fa138ccffd243;
(function(RowPartitionType) {
    RowPartitionType[RowPartitionType["FIRST_DIM_SIZE"] = 0] = "FIRST_DIM_SIZE";
    RowPartitionType[RowPartitionType["VALUE_ROWIDS"] = 1] = "VALUE_ROWIDS";
    RowPartitionType[RowPartitionType["ROW_LENGTHS"] = 2] = "ROW_LENGTHS";
    RowPartitionType[RowPartitionType["ROW_SPLITS"] = 3] = "ROW_SPLITS";
    RowPartitionType[RowPartitionType["ROW_LIMITS"] = 4] = "ROW_LIMITS";
    RowPartitionType[RowPartitionType["ROW_STARTS"] = 5] = "ROW_STARTS";
})($eaf0d5393d9bb67a$export$c56fa138ccffd243 || ($eaf0d5393d9bb67a$export$c56fa138ccffd243 = {}));
function $eaf0d5393d9bb67a$export$ab67507eda6e05cb(raggedRank, shape, valueShape) {
    // Test for consistency of valueShape and shape specified.
    // If shape is unspecified and valueShape is specified, then copy
    // over the size from the valueShape dimension.
    let outputShape = new Array();
    if (valueShape == null && shape == null) return outputShape;
    if (shape == null) // Here, value_shape must be of known size.
    while(outputShape.length < raggedRank + valueShape.length)outputShape.push(-1);
    else outputShape = shape.slice();
    if (valueShape == null) return outputShape;
    // At this point, valueShape and output_shape have known ranks.
    if (raggedRank + valueShape.length !== outputShape.length) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.rank = ${raggedRank + valueShape.length}, but shape.rank = ${outputShape.length}`);
    for(let i = 1; i < valueShape.length; ++i){
        const valueDim = valueShape[i];
        const outputShapeDimIndex = outputShape[outputShape.length - valueShape.length + i];
        const outputShapeDim = outputShape[outputShapeDimIndex];
        if (valueDim >= 0) {
            if (outputShapeDim >= 0) {
                if (outputShapeDim !== valueDim) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.shape[${i + raggedRank}] = ${valueDim} but shape[${i + raggedRank}] = ${outputShapeDim}`);
            } else outputShape[outputShapeDimIndex] = valueDim;
        }
    }
    return outputShape;
}
function $eaf0d5393d9bb67a$export$b8324e259bdd3daf(rowPartitionTypeStrings) {
    const stringToType = {
        'FIRST_DIM_SIZE': $eaf0d5393d9bb67a$export$c56fa138ccffd243.FIRST_DIM_SIZE,
        'VALUE_ROWIDS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.VALUE_ROWIDS,
        'ROW_LENGTHS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.ROW_LENGTHS,
        'ROW_SPLITS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.ROW_SPLITS,
        'ROW_LIMITS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.ROW_LIMITS,
        'ROW_STARTS': $eaf0d5393d9bb67a$export$c56fa138ccffd243.ROW_STARTS
    };
    const result = [];
    for (const typeStr of rowPartitionTypeStrings){
        if (typeStr in stringToType) result.push(stringToType[typeStr]);
        else break;
    }
    return result;
}
function $eaf0d5393d9bb67a$export$1cdd548e021d4109(rowPartitionTypes) {
    if (rowPartitionTypes.length === 0) return 0;
    if (rowPartitionTypes[0] === $eaf0d5393d9bb67a$export$c56fa138ccffd243.FIRST_DIM_SIZE) return rowPartitionTypes.length - 1;
    return rowPartitionTypes.length;
}
function $eaf0d5393d9bb67a$export$4170394182a906f5(defaultValueShape, valueShape) {
    if (defaultValueShape == null || valueShape == null) return;
    const defaultNDims = defaultValueShape.length;
    const valuesNDims = valueShape.length;
    if (defaultNDims >= valuesNDims) throw new Error(`defaultValue.shape=${defaultValueShape} and ragged tensor flatValues.shape=${valueShape}, are incompatible: defaultValue.rank = ${defaultNDims} must be less than ragged tensor input flatValues.rank = ${valuesNDims})`);
    for(let i = 0; i < Math.min(defaultNDims, valuesNDims - 1); ++i){
        const defaultDim = defaultValueShape[i];
        const valueDim = valueShape[i + 1];
        if (defaultDim >= 0 && valueDim >= 0 && defaultDim !== 1 && defaultDim !== valueDim) throw new Error(`defaultValue.shape=${defaultValueShape}, and ragged tensor input flatValues.shape=${valueShape} are incompatible: defaultValue.shape[${i - defaultValueShape.length}] = ${defaultDim} but ragged tensor input.flatValues.shape[${i - defaultValueShape.length}] = ${valueDim}`);
    }
}


var $3293c731db2632b8$exports = {};

$parcel$export($3293c731db2632b8$exports, "PARALLELIZE_THRESHOLD", () => $3293c731db2632b8$export$ee3544492fe530f6);
$parcel$export($3293c731db2632b8$exports, "computeOptimalWindowSize", () => $3293c731db2632b8$export$ee795473f4c8fb04);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inputs of size above this threshold will be parallelized by calling multiple
 * shader programs.
 */ 
const $3293c731db2632b8$export$ee3544492fe530f6 = 30;
function $3293c731db2632b8$export$ee795473f4c8fb04(inSize) {
    if (inSize <= $3293c731db2632b8$export$ee3544492fe530f6) return inSize;
    return (0, $5f8d0ee7a8d35dfe$export$c0ff3276320ddb5e)(inSize, Math.floor(Math.sqrt(inSize)));
}




var $7e603dca0b7d8a65$exports = {};

$parcel$export($7e603dca0b7d8a65$exports, "getImageCenter", () => $7e603dca0b7d8a65$export$3c8762d0dab347aa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Returns the image center in pixels.
function $7e603dca0b7d8a65$export$3c8762d0dab347aa(center, imageHeight, imageWidth) {
    const centerX = imageWidth * (typeof center === 'number' ? center : center[0]);
    const centerY = imageHeight * (typeof center === 'number' ? center : center[1]);
    return [
        centerX,
        centerY
    ];
}


var $31cb63e85869de81$exports = {};

$parcel$export($31cb63e85869de81$exports, "getReshaped", () => $31cb63e85869de81$export$4a6fd6a82dc667e2);
$parcel$export($31cb63e85869de81$exports, "getPermuted", () => $31cb63e85869de81$export$4def7dccf4cfc2e9);
$parcel$export($31cb63e85869de81$exports, "getReshapedPermuted", () => $31cb63e85869de81$export$2435a8b57f99e080);
$parcel$export($31cb63e85869de81$exports, "getSliceBeginCoords", () => $31cb63e85869de81$export$b9a01540baa98f86);
$parcel$export($31cb63e85869de81$exports, "getSliceSize", () => $31cb63e85869de81$export$2457416ec9e0c8d3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Gets the new shape of the input Tensor after it's been reshaped
 * to:
 * [blockShape[0], ..., blockShape[M-1], batch / prod(blockShape),
 * inputShape[1], ..., inputShape[N-1]]
 *
 * See step 1: https://www.tensorflow.org/api_docs/python/tf/batch_to_space_nd
 */ function $31cb63e85869de81$export$4a6fd6a82dc667e2(inputShape, blockShape, prod, batchToSpace = true) {
    let reshaped = [];
    if (batchToSpace) {
        reshaped = reshaped.concat(blockShape.slice(0));
        reshaped.push(inputShape[0] / prod);
        reshaped = reshaped.concat(inputShape.slice(1));
    } else {
        reshaped = reshaped.concat(inputShape[0]);
        const spatialLength = blockShape.length;
        for(let i = 0; i < spatialLength; ++i)reshaped = reshaped.concat([
            inputShape[i + 1] / blockShape[i],
            blockShape[i]
        ]);
        reshaped = reshaped.concat(inputShape.slice(spatialLength + 1));
    }
    return reshaped;
}
function $31cb63e85869de81$export$4def7dccf4cfc2e9(reshapedRank, blockShapeRank, batchToSpace = true) {
    const permuted = [];
    if (batchToSpace) {
        permuted.push(blockShapeRank);
        for(let i = blockShapeRank + 1; i < reshapedRank; ++i)if (i <= 2 * blockShapeRank) {
            permuted.push(i);
            permuted.push(i - (blockShapeRank + 1));
        } else permuted.push(i);
    } else {
        const permutedBeforeBatch = [];
        const permutedAfterBatch = [];
        for(let i = 1; i < reshapedRank; ++i)if (i >= blockShapeRank * 2 + 1 || i % 2 === 1) permutedAfterBatch.push(i);
        else permutedBeforeBatch.push(i);
        permuted.push(...permutedBeforeBatch);
        permuted.push(0);
        permuted.push(...permutedAfterBatch);
    }
    return permuted;
}
function $31cb63e85869de81$export$2435a8b57f99e080(inputShape, blockShape, prod, batchToSpace = true) {
    const reshapedPermuted = [];
    if (batchToSpace) reshapedPermuted.push(inputShape[0] / prod);
    else reshapedPermuted.push(inputShape[0] * prod);
    for(let i = 1; i < inputShape.length; ++i)if (i <= blockShape.length) {
        if (batchToSpace) reshapedPermuted.push(blockShape[i - 1] * inputShape[i]);
        else reshapedPermuted.push(inputShape[i] / blockShape[i - 1]);
    } else reshapedPermuted.push(inputShape[i]);
    return reshapedPermuted;
}
function $31cb63e85869de81$export$b9a01540baa98f86(crops, blockShape) {
    const sliceBeginCoords = [
        0
    ];
    for(let i = 0; i < blockShape; ++i)sliceBeginCoords.push(crops[i][0]);
    return sliceBeginCoords;
}
function $31cb63e85869de81$export$2457416ec9e0c8d3(uncroppedShape, crops, blockShape) {
    const sliceSize = uncroppedShape.slice(0, 1);
    for(let i = 0; i < blockShape; ++i)sliceSize.push(uncroppedShape[i + 1] - crops[i][0] - crops[i][1]);
    return sliceSize;
}




var $a7aca423016084b8$exports = {};

$parcel$export($a7aca423016084b8$exports, "SELU_SCALEALPHA", () => $a7aca423016084b8$export$49dc487a025ce2d0);
$parcel$export($a7aca423016084b8$exports, "SELU_SCALE", () => $a7aca423016084b8$export$e6ebc294ea9ea7e7);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $a7aca423016084b8$export$49dc487a025ce2d0 = 1.7580993408473768599402175208123;
const $a7aca423016084b8$export$e6ebc294ea9ea7e7 = 1.0507009873554804934193349852946;


var $7d94b6b022d70fbf$exports = {};

$parcel$export($7d94b6b022d70fbf$exports, "ERF_P", () => $7d94b6b022d70fbf$export$5588b9ca3e514e43);
$parcel$export($7d94b6b022d70fbf$exports, "ERF_A1", () => $7d94b6b022d70fbf$export$2ac384940e9cdd31);
$parcel$export($7d94b6b022d70fbf$exports, "ERF_A2", () => $7d94b6b022d70fbf$export$db2d4485da836713);
$parcel$export($7d94b6b022d70fbf$exports, "ERF_A3", () => $7d94b6b022d70fbf$export$644ec7b31d43803f);
$parcel$export($7d94b6b022d70fbf$exports, "ERF_A4", () => $7d94b6b022d70fbf$export$904f8b3bbafadf78);
$parcel$export($7d94b6b022d70fbf$exports, "ERF_A5", () => $7d94b6b022d70fbf$export$e40fe2da7629526);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $7d94b6b022d70fbf$export$5588b9ca3e514e43 = 0.3275911;
const $7d94b6b022d70fbf$export$2ac384940e9cdd31 = 0.254829592;
const $7d94b6b022d70fbf$export$db2d4485da836713 = -0.284496736;
const $7d94b6b022d70fbf$export$644ec7b31d43803f = 1.421413741;
const $7d94b6b022d70fbf$export$904f8b3bbafadf78 = -1.453152027;
const $7d94b6b022d70fbf$export$e40fe2da7629526 = 1.061405429;



var $aa5ca9cb878e8d20$exports = {};

$parcel$export($aa5ca9cb878e8d20$exports, "mergeRealAndImagArrays", () => $aa5ca9cb878e8d20$export$e54cb13fcd32a531);
$parcel$export($aa5ca9cb878e8d20$exports, "splitRealAndImagArrays", () => $aa5ca9cb878e8d20$export$fa0ac0984ed1da1c);
$parcel$export($aa5ca9cb878e8d20$exports, "complexWithEvenIndex", () => $aa5ca9cb878e8d20$export$270b4351d25667e0);
$parcel$export($aa5ca9cb878e8d20$exports, "complexWithOddIndex", () => $aa5ca9cb878e8d20$export$36193f08102303b4);
$parcel$export($aa5ca9cb878e8d20$exports, "getComplexWithIndex", () => $aa5ca9cb878e8d20$export$628d071452d50aaf);
$parcel$export($aa5ca9cb878e8d20$exports, "assignToTypedArray", () => $aa5ca9cb878e8d20$export$b7f57c25a82b9fba);
$parcel$export($aa5ca9cb878e8d20$exports, "exponents", () => $aa5ca9cb878e8d20$export$7d98ee6b5f9e9f08);
$parcel$export($aa5ca9cb878e8d20$exports, "exponent", () => $aa5ca9cb878e8d20$export$abde88043842a778);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Merges real and imaginary Float32Arrays into a single complex Float32Array.
 *
 * The memory layout is interleaved as follows:
 * real: [r0, r1, r2]
 * imag: [i0, i1, i2]
 * complex: [r0, i0, r1, i1, r2, i2]
 *
 * This is the inverse of splitRealAndImagArrays.
 *
 * @param real The real values of the complex tensor values.
 * @param imag The imag values of the complex tensor values.
 * @returns A complex tensor as a Float32Array with merged values.
 */ function $aa5ca9cb878e8d20$export$e54cb13fcd32a531(real, imag) {
    if (real.length !== imag.length) throw new Error(`Cannot merge real and imag arrays of different lengths. real:` + `${real.length}, imag: ${imag.length}.`);
    const result = new Float32Array(real.length * 2);
    for(let i = 0; i < result.length; i += 2){
        result[i] = real[i / 2];
        result[i + 1] = imag[i / 2];
    }
    return result;
}
function $aa5ca9cb878e8d20$export$fa0ac0984ed1da1c(complex) {
    const real = new Float32Array(complex.length / 2);
    const imag = new Float32Array(complex.length / 2);
    for(let i = 0; i < complex.length; i += 2){
        real[i / 2] = complex[i];
        imag[i / 2] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$270b4351d25667e0(complex) {
    const len = Math.ceil(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 0; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$36193f08102303b4(complex) {
    const len = Math.floor(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 2; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$628d071452d50aaf(complex, index) {
    const real = complex[index * 2];
    const imag = complex[index * 2 + 1];
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$b7f57c25a82b9fba(data, real, imag, index) {
    data[index * 2] = real;
    data[index * 2 + 1] = imag;
}
function $aa5ca9cb878e8d20$export$7d98ee6b5f9e9f08(n, inverse) {
    const real = new Float32Array(n / 2);
    const imag = new Float32Array(n / 2);
    for(let i = 0; i < Math.ceil(n / 2); i++){
        const x = (inverse ? 2 : -2) * Math.PI * (i / n);
        real[i] = Math.cos(x);
        imag[i] = Math.sin(x);
    }
    return {
        real: real,
        imag: imag
    };
}
function $aa5ca9cb878e8d20$export$abde88043842a778(k, n, inverse) {
    const x = (inverse ? 2 : -2) * Math.PI * (k / n);
    const real = Math.cos(x);
    const imag = Math.sin(x);
    return {
        real: real,
        imag: imag
    };
}


var $d85db0b313b0b278$exports = {};

$parcel$export($d85db0b313b0b278$exports, "decodeEinsumEquation", () => $d85db0b313b0b278$export$2f615958577142db);
$parcel$export($d85db0b313b0b278$exports, "getEinsumPermutation", () => $d85db0b313b0b278$export$ce55bd5175fdcdbf);
$parcel$export($d85db0b313b0b278$exports, "checkEinsumDimSizes", () => $d85db0b313b0b278$export$40ac7c38e2986bbe);
$parcel$export($d85db0b313b0b278$exports, "getEinsumComputePath", () => $d85db0b313b0b278$export$3f6835c0d48b762d);
$parcel$export($d85db0b313b0b278$exports, "isIdentityPermutation", () => $d85db0b313b0b278$export$6a8a32f5fc3d978e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $d85db0b313b0b278$var$ARROW = '->';
const $d85db0b313b0b278$var$ARROW_REGEX = /->/g;
const $d85db0b313b0b278$var$COMMA = ',';
const $d85db0b313b0b278$var$ELLIPSIS = '...';
function $d85db0b313b0b278$export$2f615958577142db(equation, numTensors) {
    equation = equation.replace(/\s/g, ''); // Remove witespace in equation.
    const numArrows = (equation.length - equation.replace($d85db0b313b0b278$var$ARROW_REGEX, '').length) / $d85db0b313b0b278$var$ARROW.length;
    if (numArrows < 1) throw new Error('Equations without an arrow are not supported.');
    else if (numArrows > 1) throw new Error(`Equation must contain exactly one arrow ("${$d85db0b313b0b278$var$ARROW}").`);
    const [inputString, outputString] = equation.split($d85db0b313b0b278$var$ARROW);
    (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(inputString.indexOf($d85db0b313b0b278$var$ELLIPSIS) === -1, ()=>`The ellipsis notation ("${$d85db0b313b0b278$var$ELLIPSIS}") is not supported yet.`);
    const inputTerms = inputString.split($d85db0b313b0b278$var$COMMA);
    const numInputs = inputTerms.length;
    if (numTensors !== numInputs) throw new Error(`Expected ${numInputs} input tensors, received ${numTensors}`);
    if (numInputs > 2) throw new Error('Support for more than 2 input tensors is not implemented yet.');
    const allDims = [];
    for(let i = 0; i < outputString.length; ++i){
        const dimName = outputString[i];
        if (!inputTerms.some((inputTerm)=>inputTerm.indexOf(dimName) !== -1)) throw new Error(`Output subscripts contain the label ${dimName} ` + `not present in the input subscripts.`);
        if (allDims.indexOf(dimName) === -1) allDims.push(dimName);
    }
    for(let i = 0; i < inputString.length; ++i){
        const dimName = inputString[i];
        if (allDims.indexOf(dimName) === -1 && dimName !== $d85db0b313b0b278$var$COMMA) allDims.push(dimName);
    }
    const idDims = new Array(inputTerms.length);
    for(let i = 0; i < numInputs; ++i){
        if (new Set(inputTerms[i].split('')).size !== inputTerms[i].length) throw new Error(`Found duplicate axes in input component ${inputTerms[i]}. ` + `Support for duplicate axes in input is not implemented yet.`);
        idDims[i] = [];
        for(let j = 0; j < inputTerms[i].length; ++j)idDims[i].push(allDims.indexOf(inputTerms[i][j]));
    }
    const numDims = allDims.length; // Number of unique dimensions.
    const numOutDims = outputString.length; // Number of output dimensions.
    const summedDims = []; // Dimensions being summed over.
    for(let i = numOutDims; i < numDims; ++i)summedDims.push(i);
    return {
        allDims: allDims,
        summedDims: summedDims,
        idDims: idDims
    };
}
function $d85db0b313b0b278$export$ce55bd5175fdcdbf(nDims, idDims) {
    let permutationIndices = new Array(nDims);
    permutationIndices.fill(-1);
    for(let i = 0; i < idDims.length; ++i)permutationIndices[idDims[i]] = i;
    const expandDims = [];
    for(let i = 0; i < nDims; ++i)if (permutationIndices[i] === -1) expandDims.push(i);
    permutationIndices = permutationIndices.filter((d)=>d !== -1);
    return {
        permutationIndices: permutationIndices,
        expandDims: expandDims
    };
}
function $d85db0b313b0b278$export$40ac7c38e2986bbe(nDims, idDims, tensors) {
    const dimSizes = new Array(nDims);
    for(let i = 0; i < tensors.length; ++i){
        const shape = tensors[i].shape;
        for(let j = 0; j < idDims[i].length; ++j)if (dimSizes[idDims[i][j]] === undefined) dimSizes[idDims[i][j]] = shape[j];
        else (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(dimSizes[idDims[i][j]] === shape[j], ()=>`Expected dimension ${dimSizes[idDims[i][j]]} at axis ${j} ` + `of input shaped ${JSON.stringify(shape)}, ` + `but got dimension ${shape[j]}`);
    }
}
function $d85db0b313b0b278$export$3f6835c0d48b762d(summedDims, idDims) {
    const path = summedDims;
    const steps = [];
    let nSteps = 0;
    if (summedDims.length === 0) // Einsum that involes no summing: e.g., transpose and outer product.
    path.push(-1);
    nSteps = summedDims.length + 1;
    for(let i = 0; i < nSteps; ++i)steps.push([]);
    const computedTermIndices = [];
    for(let i = 0; i < path.length; ++i){
        const summedDim = path[i];
        const termIndices = $d85db0b313b0b278$var$findTermsWithDim(idDims, summedDim);
        for (const termIndex of termIndices)if (computedTermIndices.indexOf(termIndex) === -1) {
            steps[i].push(termIndex);
            computedTermIndices.push(termIndex);
        }
    }
    return {
        path: path,
        steps: steps
    };
}
function $d85db0b313b0b278$export$6a8a32f5fc3d978e(perm) {
    return perm.every((dim, index)=>dim === index);
}
function $d85db0b313b0b278$var$findTermsWithDim(idDims, dim) {
    const termIndices = [];
    for(let i = 0; i < idDims.length; ++i)if (idDims[i].length === 0 || idDims[i].indexOf(dim) !== -1 || dim === -1) termIndices.push(i);
    return termIndices;
}


var $335e215ffeab62fb$exports = {};

$parcel$export($335e215ffeab62fb$exports, "prepareSplitSize", () => $335e215ffeab62fb$export$b45a3b30df9d4b49);

function $335e215ffeab62fb$export$b45a3b30df9d4b49(x, numOrSizeSplits, axis = 0) {
    let splitSizes = [];
    if (typeof numOrSizeSplits === 'number') {
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(x.shape[axis] % numOrSizeSplits === 0, ()=>'Number of splits must evenly divide the axis.');
        splitSizes = new Array(numOrSizeSplits).fill(x.shape[axis] / numOrSizeSplits);
    } else {
        const numOfNegs = numOrSizeSplits.reduce((count, value)=>{
            if (value === -1) count += 1;
            return count;
        }, 0);
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(numOfNegs <= 1, ()=>'There should be only one negative value in split array.');
        const negIndex = numOrSizeSplits.indexOf(-1);
        // Allow the number of split array to be -1, which indicates the rest
        // of dimension is allocated to that split.
        if (negIndex !== -1) {
            const total = numOrSizeSplits.reduce((a, b)=>b > 0 ? a + b : a);
            numOrSizeSplits[negIndex] = x.shape[axis] - total;
        }
        (0, $5f8d0ee7a8d35dfe$export$a7a9523472993e97)(x.shape[axis] === numOrSizeSplits.reduce((a, b)=>a + b), ()=>'The sum of sizes must match the size of the axis dimension.');
        splitSizes = numOrSizeSplits;
    }
    return splitSizes;
}


var $4399455c72817f69$exports = {};

$parcel$export($4399455c72817f69$exports, "getSparseFillEmptyRowsIndicesDenseShapeMismatch", () => $4399455c72817f69$export$afc2f2dec50723b1);
$parcel$export($4399455c72817f69$exports, "getSparseFillEmptyRowsNegativeIndexErrorMessage", () => $4399455c72817f69$export$69038529bd45dbce);
$parcel$export($4399455c72817f69$exports, "getSparseFillEmptyRowsOutOfRangeIndexErrorMessage", () => $4399455c72817f69$export$4179b115ac384c01);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse fill empty rows indices, dense shape mismatch error message.
 *
 * @param indicesLength The first dimension of indices.
 */ function $4399455c72817f69$export$afc2f2dec50723b1(indicesLength) {
    return `Received SparseTensor with denseShape[0] = 0 but
  indices.shape[0] = ${indicesLength}`;
}
function $4399455c72817f69$export$69038529bd45dbce(index, value) {
    return `indices(${index}, 0) is invalid: ${value} < 0`;
}
function $4399455c72817f69$export$4179b115ac384c01(index, value, limit) {
    return `indices(${index}, 0) is invalid: ${value} >= ${limit}`;
}


var $1e10bd84af2e2307$exports = {};

$parcel$export($1e10bd84af2e2307$exports, "getSparseReshapeMultipleNegativeOneOutputDimErrorMessage", () => $1e10bd84af2e2307$export$22b04105649d1e3d);
$parcel$export($1e10bd84af2e2307$exports, "getSparseReshapeNegativeOutputDimErrorMessage", () => $1e10bd84af2e2307$export$3350ee0ca4641eae);
$parcel$export($1e10bd84af2e2307$exports, "getSparseReshapeEmptyTensorZeroOutputDimErrorMessage", () => $1e10bd84af2e2307$export$632a7731cfb4dc4b);
$parcel$export($1e10bd84af2e2307$exports, "getSparseReshapeInputOutputMultipleErrorMessage", () => $1e10bd84af2e2307$export$6996eb40ec18f24);
$parcel$export($1e10bd84af2e2307$exports, "getSparseReshapeInputOutputMismatchErrorMessage", () => $1e10bd84af2e2307$export$7c74c1672e7ca2d1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $1e10bd84af2e2307$export$22b04105649d1e3d(dim1, dim2) {
    return `only one output dimension may be -1, not both ${dim1} and ${dim2}`;
}
function $1e10bd84af2e2307$export$3350ee0ca4641eae(dim, value) {
    return `size ${dim} must be non-negative, not ${value}`;
}
function $1e10bd84af2e2307$export$632a7731cfb4dc4b() {
    return "reshape cannot infer the missing input size for an empty tensor unless all specified input sizes are non-zero";
}
function $1e10bd84af2e2307$export$6996eb40ec18f24(inputShape, outputShape) {
    const inputSize = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(inputShape);
    const outputSize = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(outputShape);
    return `Input to reshape is a SparseTensor with ${inputSize}
  dense values, but the requested shape requires a multiple of ${outputSize}. inputShape=${inputShape} outputShape= ${outputShape}`;
}
function $1e10bd84af2e2307$export$7c74c1672e7ca2d1(inputShape, outputShape) {
    const inputSize = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(inputShape);
    const outputSize = (0, $5f8d0ee7a8d35dfe$export$b4c3214a70a0e73f)(outputShape);
    return `Input to reshape is a tensor with ${inputSize} dense values, but the requested shape has ${outputSize}. inputShape=${inputShape} outputShape=${outputShape}`;
}


var $4818829ad25e3220$exports = {};

$parcel$export($4818829ad25e3220$exports, "getSparseSegmentReductionNegativeSegmentIdsErrorMessage", () => $4818829ad25e3220$export$cb1b83ffdf66736);
$parcel$export($4818829ad25e3220$exports, "getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage", () => $4818829ad25e3220$export$6f5af72ace1661e1);
$parcel$export($4818829ad25e3220$exports, "getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage", () => $4818829ad25e3220$export$bdc282d2ae15e823);
$parcel$export($4818829ad25e3220$exports, "getSparseSegmentReductionIndicesOutOfRangeErrorMessage", () => $4818829ad25e3220$export$c470f477911f1cb7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse segment reduction negative segment ids error message.
 *
 */ function $4818829ad25e3220$export$cb1b83ffdf66736() {
    return `segment ids must be >= 0`;
}
function $4818829ad25e3220$export$6f5af72ace1661e1() {
    return `segment ids are not increasing`;
}
function $4818829ad25e3220$export$bdc282d2ae15e823(segmentId, outputRows) {
    return `Segment id ${segmentId} out of range [0, ${outputRows}), possibly because segmentIds input is not sorted.`;
}
function $4818829ad25e3220$export$c470f477911f1cb7(index, indexValue, inputRows) {
    return `Bad: indices[${index}] == ${indexValue} out of range [0, ${inputRows})`;
}


var $b6d3dd7a4e14edca$exports = {};

$parcel$export($b6d3dd7a4e14edca$exports, "segOpComputeOptimalWindowSize", () => $b6d3dd7a4e14edca$export$6ef0c7b128709ff);
$parcel$export($b6d3dd7a4e14edca$exports, "computeOutShape", () => $b6d3dd7a4e14edca$export$22fa6b3b1305508e);
$parcel$export($b6d3dd7a4e14edca$exports, "collectGatherOpShapeInfo", () => $b6d3dd7a4e14edca$export$fa9ad97afacf8191);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

function $b6d3dd7a4e14edca$export$6ef0c7b128709ff(inSize, numSegments) {
    let done = false;
    let res;
    if (inSize <= (0, $3293c731db2632b8$export$ee3544492fe530f6)) {
        res = inSize;
        done = true;
    } else res = (0, $5f8d0ee7a8d35dfe$export$c0ff3276320ddb5e)(inSize, Math.floor(Math.sqrt(inSize)));
    while(!done)if (res > numSegments || res === inSize) done = true;
    else res = (0, $5f8d0ee7a8d35dfe$export$c0ff3276320ddb5e)(inSize, res + 1);
    return res;
}
function $b6d3dd7a4e14edca$export$22fa6b3b1305508e(aShape, axis, numSegments) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (dim !== axis) outShape.push(aShape[dim]);
    else outShape.push(numSegments);
    return outShape;
}
function $b6d3dd7a4e14edca$export$fa9ad97afacf8191(x, indices, axis, batchDims) {
    const indicesRank = indices.shape.length;
    const xRank = x.shape.length;
    if (batchDims !== 0) {
        if (batchDims < -indicesRank || batchDims > indicesRank) throw new Error(`Expect batchDims in the range of [-${indicesRank}, ${indicesRank}], but got ${batchDims}`);
    }
    if (batchDims < 0) batchDims += indicesRank;
    if (batchDims > xRank) throw new Error(`batchDims (${batchDims}) must be less than rank(x) (
    ${xRank}).`);
    if (axis < batchDims) throw new Error(`batchDims (${batchDims}) must be less than or equal to axis (${axis}).`);
    for(let i = 0; i < batchDims; ++i){
        if (x.shape[i] !== indices.shape[i]) throw new Error(`x.shape[${i}]: ${x.shape[i]} should be equal to indices.shape[${i}]: ${indices.shape[i]}.`);
    }
    const dimSize = x.shape[axis];
    const outputShape = [];
    let batchSize = 1;
    let outerSize = 1;
    let sliceSize = 1;
    for(let i = 0; i < batchDims; ++i){
        outputShape.push(x.shape[i]);
        batchSize *= x.shape[i];
    }
    for(let i = batchDims; i < axis; i++){
        outputShape.push(x.shape[i]);
        outerSize *= x.shape[i];
    }
    for(let i = batchDims; i < indicesRank; i++)outputShape.push(indices.shape[i]);
    for(let i = axis + 1; i < xRank; i++){
        outputShape.push(x.shape[i]);
        sliceSize *= x.shape[i];
    }
    return {
        batchSize: batchSize,
        sliceSize: sliceSize,
        outerSize: outerSize,
        dimSize: dimSize,
        outputShape: outputShape
    };
}


function $5a956a12516ed8ee$export$debaff328bdca650(vals) {
    try {
        // Decode the bytes into string.
        return vals.map((val)=>(0, $e10678764dab7ea0$export$a0fb664af7d0cc44)(val));
    } catch (err) {
        throw new Error(`Failed to decode encoded string bytes into utf-8, error: ${err}`);
    }
}
function $5a956a12516ed8ee$export$ce1f4ec5bdd0ab9a(strings) {
    return strings.map((s)=>(0, $e10678764dab7ea0$export$8146d2e653b87d6a)(s));
}
$parcel$exportWildcard($5a956a12516ed8ee$exports, $f36081d4d230c419$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $642a122b4608acc0$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $8f11b07965c032fa$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $b3e4d1c19b78487c$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $86c60a0aff9fcea2$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $9b65f19b1b23a153$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $eaf0d5393d9bb67a$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $3293c731db2632b8$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $7e603dca0b7d8a65$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $31cb63e85869de81$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $36339f0b093f9859$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $57b46503159dbf6f$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $a7aca423016084b8$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $7d94b6b022d70fbf$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $8ee8f3c328242644$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $aa5ca9cb878e8d20$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $d85db0b313b0b278$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $335e215ffeab62fb$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $4399455c72817f69$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $1e10bd84af2e2307$exports);
$parcel$exportWildcard($5a956a12516ed8ee$exports, $4818829ad25e3220$exports);



var $fb3bc18262ab6c94$exports = {};

$parcel$export($fb3bc18262ab6c94$exports, "nonMaxSuppressionV3Impl", () => $08cc9cc3eb1dc63f$export$89e22275998c2878);
$parcel$export($fb3bc18262ab6c94$exports, "nonMaxSuppressionV4Impl", () => $08cc9cc3eb1dc63f$export$697e7a8cdfefe3a);
$parcel$export($fb3bc18262ab6c94$exports, "nonMaxSuppressionV5Impl", () => $08cc9cc3eb1dc63f$export$4ff849794bce73c5);
$parcel$export($fb3bc18262ab6c94$exports, "whereImpl", () => $f233c777c497de5b$export$3a1005f93c3f4453);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 





$parcel$exportWildcard($4b62b17ea43e8f87$exports, $7912647d6e7a4ee9$exports);
$parcel$exportWildcard($4b62b17ea43e8f87$exports, $a2aac83cc2c20bd7$exports);
$parcel$exportWildcard($4b62b17ea43e8f87$exports, $8c449c89295c3cc4$exports);
$parcel$exportWildcard($4b62b17ea43e8f87$exports, $a6ed5fb1cf7ee2a4$exports);
$parcel$exportWildcard($4b62b17ea43e8f87$exports, $c9f78399309a8a0d$exports);


(0, $4303074357071843$export$9a85654c75805c9a)();
$parcel$exportWildcard($d2cc08cc2aa8032f$exports, $4b62b17ea43e8f87$exports);


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
const $13109e66f2098a0a$var$ENV = (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)();
/** Whether to keep intermediate tensors. */ $13109e66f2098a0a$var$ENV.registerFlag('KEEP_INTERMEDIATE_TENSORS', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Keep intermediate tensors is ON. This will print the values of all intermediate tensors during model inference. Not all models support this mode. For details, check e2e/benchmarks/ model_config.js. This significantly impacts performance.");
});


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /** DataType enum. */ var $da1154ef7a939058$export$45c69700ee30a78c;
(function(DataType) {
    // These properties must be quoted since they are used by parseDtypeParam
    // in tfjs-converter/src/operations/operation_mapper.ts to look up dtypes
    // by string name. If they are not quoted, Closure will mangle their names.
    // Not a legal value for DataType.  Used to indicate a DataType field
    // has not been set.
    DataType[DataType["DT_INVALID"] = 0] = "DT_INVALID";
    // Data types that all computation devices are expected to be
    // capable to support.
    DataType[DataType["DT_FLOAT"] = 1] = "DT_FLOAT";
    DataType[DataType["DT_DOUBLE"] = 2] = "DT_DOUBLE";
    DataType[DataType["DT_INT32"] = 3] = "DT_INT32";
    DataType[DataType["DT_UINT8"] = 4] = "DT_UINT8";
    DataType[DataType["DT_INT16"] = 5] = "DT_INT16";
    DataType[DataType["DT_INT8"] = 6] = "DT_INT8";
    DataType[DataType["DT_STRING"] = 7] = "DT_STRING";
    DataType[DataType["DT_COMPLEX64"] = 8] = "DT_COMPLEX64";
    DataType[DataType["DT_INT64"] = 9] = "DT_INT64";
    DataType[DataType["DT_BOOL"] = 10] = "DT_BOOL";
    DataType[DataType["DT_QINT8"] = 11] = "DT_QINT8";
    DataType[DataType["DT_QUINT8"] = 12] = "DT_QUINT8";
    DataType[DataType["DT_QINT32"] = 13] = "DT_QINT32";
    DataType[DataType["DT_BFLOAT16"] = 14] = "DT_BFLOAT16";
    DataType[DataType["DT_QINT16"] = 15] = "DT_QINT16";
    DataType[DataType["DT_QUINT16"] = 16] = "DT_QUINT16";
    DataType[DataType["DT_UINT16"] = 17] = "DT_UINT16";
    DataType[DataType["DT_COMPLEX128"] = 18] = "DT_COMPLEX128";
    DataType[DataType["DT_HALF"] = 19] = "DT_HALF";
    DataType[DataType["DT_RESOURCE"] = 20] = "DT_RESOURCE";
    DataType[DataType["DT_VARIANT"] = 21] = "DT_VARIANT";
    DataType[DataType["DT_UINT32"] = 22] = "DT_UINT32";
    DataType[DataType["DT_UINT64"] = 23] = "DT_UINT64";
    // Do not use!  These are only for parameters.  Every enum above
    // should have a corresponding value below (verified by types_test).
    DataType[DataType["DT_FLOAT_REF"] = 101] = "DT_FLOAT_REF";
    DataType[DataType["DT_DOUBLE_REF"] = 102] = "DT_DOUBLE_REF";
    DataType[DataType["DT_INT32_REF"] = 103] = "DT_INT32_REF";
    DataType[DataType["DT_UINT8_REF"] = 104] = "DT_UINT8_REF";
    DataType[DataType["DT_INT16_REF"] = 105] = "DT_INT16_REF";
    DataType[DataType["DT_INT8_REF"] = 106] = "DT_INT8_REF";
    DataType[DataType["DT_STRING_REF"] = 107] = "DT_STRING_REF";
    DataType[DataType["DT_COMPLEX64_REF"] = 108] = "DT_COMPLEX64_REF";
    DataType[DataType["DT_INT64_REF"] = 109] = "DT_INT64_REF";
    DataType[DataType["DT_BOOL_REF"] = 110] = "DT_BOOL_REF";
    DataType[DataType["DT_QINT8_REF"] = 111] = "DT_QINT8_REF";
    DataType[DataType["DT_QUINT8_REF"] = 112] = "DT_QUINT8_REF";
    DataType[DataType["DT_QINT32_REF"] = 113] = "DT_QINT32_REF";
    DataType[DataType["DT_BFLOAT16_REF"] = 114] = "DT_BFLOAT16_REF";
    DataType[DataType["DT_QINT16_REF"] = 115] = "DT_QINT16_REF";
    DataType[DataType["DT_QUINT16_REF"] = 116] = "DT_QUINT16_REF";
    DataType[DataType["DT_UINT16_REF"] = 117] = "DT_UINT16_REF";
    DataType[DataType["DT_COMPLEX128_REF"] = 118] = "DT_COMPLEX128_REF";
    DataType[DataType["DT_HALF_REF"] = 119] = "DT_HALF_REF";
    DataType[DataType["DT_RESOURCE_REF"] = 120] = "DT_RESOURCE_REF";
    DataType[DataType["DT_VARIANT_REF"] = 121] = "DT_VARIANT_REF";
    DataType[DataType["DT_UINT32_REF"] = 122] = "DT_UINT32_REF";
    DataType[DataType["DT_UINT64_REF"] = 123] = "DT_UINT64_REF";
})($da1154ef7a939058$export$45c69700ee30a78c || ($da1154ef7a939058$export$45c69700ee30a78c = {}));
var $da1154ef7a939058$export$c7aebf4a33f92df2;
(function(SaverDef) {
    /** CheckpointFormatVersion enum. */ let CheckpointFormatVersion;
    (function(CheckpointFormatVersion) {
        CheckpointFormatVersion[CheckpointFormatVersion["LEGACY"] = 0] = "LEGACY";
        CheckpointFormatVersion[CheckpointFormatVersion["V1"] = 1] = "V1";
        CheckpointFormatVersion[CheckpointFormatVersion["V2"] = 2] = "V2";
    })(CheckpointFormatVersion = SaverDef.CheckpointFormatVersion || (SaverDef.CheckpointFormatVersion = {}));
})($da1154ef7a939058$export$c7aebf4a33f92df2 || ($da1154ef7a939058$export$c7aebf4a33f92df2 = {}));


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $a25ca992a33088d7$var$CUSTOM_OPS = {};
function $a25ca992a33088d7$export$670e5ae0b581ed28(name, opFunc) {
    const opMapper = {
        tfOpName: name,
        category: 'custom',
        inputs: [],
        attrs: [],
        customExecutor: opFunc
    };
    $a25ca992a33088d7$var$CUSTOM_OPS[name] = opMapper;
}
function $a25ca992a33088d7$export$ad480e5d0b303fdc(name) {
    return $a25ca992a33088d7$var$CUSTOM_OPS[name];
}
function $a25ca992a33088d7$export$26ff69eae92eb5cb(name) {
    delete $a25ca992a33088d7$var$CUSTOM_OPS[name];
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $727b63cbe12c1384$export$390042a9afe1baa5(paramName, node, tensorMap, context, resourceManager) {
    const inputParam = node.inputParams[paramName];
    if (inputParam && inputParam.inputIndexStart !== undefined) {
        const start = inputParam.inputIndexStart;
        const end = inputParam.inputIndexEnd === 0 ? undefined : inputParam.inputIndexEnd === undefined ? start + 1 : inputParam.inputIndexEnd;
        const shiftedStart = start < 0 ? node.inputNames.length + start : start;
        if (inputParam.type === 'tensor') return $727b63cbe12c1384$export$c5e50df225428195(node.inputNames[shiftedStart], tensorMap, context, resourceManager);
        if (inputParam.type === 'tensors') {
            // TODO(mattSoulanille): This filters out NoOp nodes during execution, but
            // these should really never be in the execution graph in the first place.
            // They're necessary for ordering the graph, but should not be visible
            // during execution. Perhaps have different sets of children, one for
            // control dependencies and another for real dependencies.
            const inputs = node.inputs.slice(start, end);
            const inputNames = node.inputNames.slice(start, end).filter((_name, index)=>{
                var _a;
                return ((_a = inputs[index]) === null || _a === void 0 ? void 0 : _a.op) !== 'NoOp';
            });
            return inputNames.map((name)=>$727b63cbe12c1384$export$c5e50df225428195(name, tensorMap, context, resourceManager));
        }
        const tensor = $727b63cbe12c1384$export$c5e50df225428195(node.inputNames[shiftedStart], tensorMap, context, resourceManager);
        const data = tensor.dataSync();
        return inputParam.type === 'number' ? data[0] : (0, $e10678764dab7ea0$exports).toNestedArray(tensor.shape, data);
    }
    const attrParam = node.attrParams[paramName];
    return attrParam && attrParam.value;
}
function $727b63cbe12c1384$export$c5e50df225428195(name, tensorsMap, context, resourceManager) {
    const [nodeName, index] = $727b63cbe12c1384$export$67aec20b8c372baf(name, context);
    if (resourceManager != null) {
        const tensor = resourceManager.getHashTableHandleByName(nodeName);
        if (tensor != null) return tensor;
    }
    const contextId = context.currentContextIds.find((contextId)=>{
        return !!tensorsMap[$727b63cbe12c1384$var$getNodeNameWithContextId(nodeName, contextId)];
    });
    return contextId !== undefined ? tensorsMap[$727b63cbe12c1384$var$getNodeNameWithContextId(nodeName, contextId)][index] : undefined;
}
function $727b63cbe12c1384$export$d8cd584ff358961a(name, tensorsMap, context) {
    return tensorsMap[$727b63cbe12c1384$var$getNodeNameWithContextId(name, context.currentContextId)];
}
function $727b63cbe12c1384$export$6cbb65bf9e07a72(inputName, context) {
    const [nodeName, index, outputName] = $727b63cbe12c1384$export$67aec20b8c372baf(inputName, context);
    return [
        $727b63cbe12c1384$var$getNodeNameWithContextId(nodeName, context && context.currentContextId),
        index,
        outputName
    ];
}
function $727b63cbe12c1384$var$getNodeNameWithContextId(name, contextId) {
    return !!contextId ? `${name}-${contextId}` : name;
}
function $727b63cbe12c1384$export$67aec20b8c372baf(name, context) {
    if (name === '') return [
        '',
        0,
        undefined
    ];
    const isCacheEnabled = context != null && context.parseNodeNameCache != null;
    if (isCacheEnabled) {
        const cachedResult = context.parseNodeNameCache.get(name);
        if (cachedResult != null) return cachedResult;
    }
    const parts = name.split(':');
    let result;
    if (parts.length === 1) result = [
        name,
        0,
        undefined
    ];
    else {
        const nodeName = parts[0];
        const outputName = parts.length === 3 ? parts[1] : undefined;
        const index = Number(parts[parts.length - 1]);
        result = [
            nodeName,
            index,
            outputName
        ];
    }
    if (isCacheEnabled) context.parseNodeNameCache.set(name, result);
    return result;
}
function $727b63cbe12c1384$export$65980d18b75784e2(arr, size) {
    const res = [];
    for(let i = 0; i < arr.length; i += size)res.push(arr.slice(i, i + size));
    return res;
}
function $727b63cbe12c1384$export$d7501e6bee71bfee(node, tensorMap, context) {
    let pad = $727b63cbe12c1384$export$390042a9afe1baa5('pad', node, tensorMap, context);
    if (pad === 'explicit') {
        // This is 1d array, we need to convert it to 2d array
        pad = $727b63cbe12c1384$export$390042a9afe1baa5('explicitPaddings', node, tensorMap, context);
        const explicitPadding = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        for(let i = 0; i < 4; i++){
            explicitPadding[i][0] = pad[i * 2];
            explicitPadding[i][1] = pad[i * 2 + 1];
        }
        return explicitPadding;
    }
    return pad;
}
function $727b63cbe12c1384$export$c2185cfeaef7ba84(tensor) {
    return tensor.kept ? tensor : (0, $44a9d8b42e3e34af$export$9cd59f9826255e47)(tensor);
}


var $92f2f618b7788456$exports = {};

$parcel$export($92f2f618b7788456$exports, "json", () => $92f2f618b7788456$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $92f2f618b7788456$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Add',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddV2',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddN',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'BiasAdd',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sub',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RealDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Div',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DivNoNan',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mul',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Maximum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Minimum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Pow',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SquaredDifference',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorMod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];


var $5038a9a026061abc$exports = {};

$parcel$export($5038a9a026061abc$exports, "json", () => $5038a9a026061abc$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $5038a9a026061abc$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Abs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan2',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Ceil',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ClipByValue',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'clipValueMin',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'clipValueMax',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Complex',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'real',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'imag',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ComplexAbs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Elu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Exp',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Floor',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Imag',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Neg',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Real',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Prelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'alpha',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu6',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Selu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sigmoid',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Rsqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Square',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sign',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Round',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Expm1',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log1p',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reciprocal',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Softplus',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Erf',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LeakyRelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsNan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsFinite',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsInf',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];


var $18466f05b5f0cde0$exports = {};

$parcel$export($18466f05b5f0cde0$exports, "json", () => $18466f05b5f0cde0$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $18466f05b5f0cde0$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EmptyTensorList',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'maxNumElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LoopCond',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Switch',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Merge',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Enter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'frame_name',
                'name': 'frameName',
                'type': 'string'
            },
            {
                'tfName': 'is_constant',
                'name': 'isConstant',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Exit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NextIteration',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'size',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'dynamic_size',
                'name': 'dynamicSize',
                'type': 'bool'
            },
            {
                'tfName': 'clear_after_read',
                'name': 'clearAfterRead',
                'type': 'bool'
            },
            {
                'tfName': 'identical_element_shapes',
                'name': 'identicalElementShapes',
                'type': 'bool'
            },
            {
                'tfName': 'tensor_array_name',
                'name': 'name',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayWriteV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayReadV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayGatherV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayScatterV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayConcatV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape_except0',
                'name': 'elementShapeExcept0',
                'type': 'shape',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySplitV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySizeV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayCloseV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'StatelessIf',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'If',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'StatelessWhile',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'While',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatterV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 3,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGather',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListReserve',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListFromTensor',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListStack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            },
            {
                'tfName': 'num_elements',
                'name': 'numElements',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSplit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcat',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcatV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPopBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPushBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListLength',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TensorListResize',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            }
        ]
    }
];


var $f2c62b406e0cb44f$exports = {};

$parcel$export($f2c62b406e0cb44f$exports, "json", () => $f2c62b406e0cb44f$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $f2c62b406e0cb44f$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'AvgPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': [],
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPoolWithArgmax',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'include_batch_in_index',
                'name': 'includeBatchInIndex',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AvgPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Conv1D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'stride',
                'name': 'stride',
                'type': 'number'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NWC'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'dilation',
                'name': 'dilation',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'Conv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'useCudnnOnGpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': '_FusedConv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'use_cudnn_on_gpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool',
                'defaultValue': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            }
        ]
    },
    {
        'tfOpName': 'Conv2DBackpropInput',
        'category': 'convolution',
        'inputs': [
            {
                'start': 2,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 0,
                'name': 'outputShape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2d',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'FusedDepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            }
        ]
    },
    {
        'tfOpName': 'Conv3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Dilation2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'rates',
                'name': 'dilations',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            }
        ]
    }
];


var $da57c6fbc0e8e275$exports = {};

$parcel$export($da57c6fbc0e8e275$exports, "json", () => $da57c6fbc0e8e275$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $da57c6fbc0e8e275$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Fill',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            },
            {
                'start': 1,
                'name': 'value',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LinSpace',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'num',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'OneHot',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'depth',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'onValue',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'start': 3,
                'name': 'offValue',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Ones',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'OnesLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'RandomStandardNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RandomUniform',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'minval',
                'name': 'minval',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'maxval',
                'name': 'maxval',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RandomUniformInt',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'minval',
                'name': 'minval',
                'type': 'number'
            },
            {
                'tfName': 'maxval',
                'name': 'maxval',
                'type': 'number'
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Range',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'step',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'Tidx',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TruncatedNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'means',
                'name': 'mean',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'stddev',
                'name': 'stdDev',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Zeros',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ZerosLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Multinomial',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'logits',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numSamples',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'output_dtype',
                'name': 'output_dtype',
                'type': 'dtype'
            }
        ]
    }
];


var $c00fc2ecdf828344$exports = {};

$parcel$export($c00fc2ecdf828344$exports, "json", () => $c00fc2ecdf828344$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $c00fc2ecdf828344$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'NonMaxSuppressionV2',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV3',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV4',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'T_threshold',
                'name': 'threshold',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'pad_to_max_output_size',
                'name': 'padToMaxOutputSize',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV5',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            },
            {
                'start': 5,
                'name': 'softNmsSigma',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Where',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ListDiff',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];


var $64107a6ca6735dbb$exports = {};

$parcel$export($64107a6ca6735dbb$exports, "json", () => $64107a6ca6735dbb$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $64107a6ca6735dbb$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'LowerBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TopKV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'k',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'sorted',
                'name': 'sorted',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'UpperBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Unique',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'UniqueV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    }
];


var $8e9e37ca1fe0a351$exports = {};

$parcel$export($8e9e37ca1fe0a351$exports, "json", () => $8e9e37ca1fe0a351$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $8e9e37ca1fe0a351$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'PlaceholderWithDefault',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'default',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Placeholder',
        'category': 'graph',
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Const',
        'category': 'graph'
    },
    {
        'tfOpName': 'Identity',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IdentityN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Snapshot',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Rank',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Size',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Shape',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'ShapeN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Print',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'data',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'message',
                'name': 'message',
                'type': 'string'
            },
            {
                'tfName': 'first_n',
                'name': 'firstN',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'summarize',
                'name': 'summarize',
                'type': 'number',
                'defaultValue': 3
            }
        ]
    },
    {
        'tfOpName': 'NoOp',
        'category': 'graph',
        'inputs': []
    },
    {
        'tfOpName': 'StopGradient',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'FakeQuantWithMinMaxVars',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'min',
                'name': 'min',
                'type': 'number'
            },
            {
                'tfName': 'max',
                'name': 'max',
                'type': 'number'
            }
        ]
    }
];


var $7789a3b787b221c4$exports = {};

$parcel$export($7789a3b787b221c4$exports, "json", () => $7789a3b787b221c4$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $7789a3b787b221c4$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'HashTable',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'HashTableV2',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImport',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImportV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFind',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFindV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSize',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSizeV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'InitializeTable',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'InitializeTableV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    }
];


var $de231e99c3a957b4$exports = {};

$parcel$export($de231e99c3a957b4$exports, "json", () => $de231e99c3a957b4$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $de231e99c3a957b4$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ResizeBilinear',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ResizeNearestNeighbor',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'CropAndResize',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'image',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'boxInd',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'cropSize',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'method',
                'name': 'method',
                'type': 'string'
            },
            {
                'tfName': 'extrapolation_value',
                'name': 'extrapolationValue',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ImageProjectiveTransformV3',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'transforms',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'fillValue',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'interpolation',
                'name': 'interpolation',
                'type': 'string'
            },
            {
                'tfName': 'fill_mode',
                'name': 'fillMode',
                'type': 'string'
            }
        ]
    }
];


var $c5092e77366f20b6$exports = {};

$parcel$export($c5092e77366f20b6$exports, "json", () => $c5092e77366f20b6$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $c5092e77366f20b6$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Equal',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NotEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Greater',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'GreaterEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Less',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LessEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalAnd',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalNot',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalOr',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Select',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SelectV2',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BitwiseAnd',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ]
    }
];


var $4b307384703dd93a$exports = {};

$parcel$export($4b307384703dd93a$exports, "json", () => $4b307384703dd93a$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $4b307384703dd93a$export$7b419323e6ed4f31 = [
    {
        'tfOpName': '_FusedMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMulV2',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Transpose',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'perm',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Einsum',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'equation',
                'name': 'equation',
                'type': 'string'
            },
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'MatrixBandPart',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numLower',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numUpper',
                'type': 'tensor'
            }
        ]
    }
];


var $10feecedb5ca137c$exports = {};

$parcel$export($10feecedb5ca137c$exports, "json", () => $10feecedb5ca137c$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $10feecedb5ca137c$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EuclideanNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool',
                'defaultValue': false
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV2',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV3',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LRN',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'depth_radius',
                'name': 'radius',
                'type': 'number',
                'defaultValue': 5
            },
            {
                'tfName': 'bias',
                'name': 'bias',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'beta',
                'name': 'beta',
                'type': 'number',
                'defaultValue': 0.5
            }
        ]
    },
    {
        'tfOpName': 'Softmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LogSoftmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    }
];


var $f4c3b3292cb4fff9$exports = {};

$parcel$export($f4c3b3292cb4fff9$exports, "json", () => $f4c3b3292cb4fff9$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $f4c3b3292cb4fff9$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Bincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'DenseBincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'binary_output',
                'name': 'binaryOutput',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Max',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Mean',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Min',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Sum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'All',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Any',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'ArgMax',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ArgMin',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Prod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cumprod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Cumsum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    }
];


var $ad8a8e039d544a71$exports = {};

$parcel$export($ad8a8e039d544a71$exports, "json", () => $ad8a8e039d544a71$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $ad8a8e039d544a71$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ConcatV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': -1,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': -1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'Concat',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 1,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': 0,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'GatherV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'batch_dims',
                'name': 'batchDims',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Gather',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reverse',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dims',
                'type': 'bool[]'
            }
        ]
    },
    {
        'tfOpName': 'ReverseV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Slice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'size',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'StridedSlice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'end',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'strides',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'begin_mask',
                'name': 'beginMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'end_mask',
                'name': 'endMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'new_axis_mask',
                'name': 'newAxisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'ellipsis_mask',
                'name': 'ellipsisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'shrink_axis_mask',
                'name': 'shrinkAxisMask',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Pack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Unpack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'num',
                'name': 'num',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tile',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'reps',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Split',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'start': 1,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_split',
                'name': 'numOrSizeSplits',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'SplitV',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numOrSizeSplits',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'ScatterNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'GatherNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseToDense',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'sparseIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'sparseValues',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'defaultValue': false,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorScatterUpdate',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    }
];


var $403df01f4cd348e9$exports = {};

$parcel$export($403df01f4cd348e9$exports, "json", () => $403df01f4cd348e9$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $403df01f4cd348e9$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'SparseFillEmptyRows',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'denseShape',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseReshape',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'inputIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'inputShape',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'newShape',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentMean',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentSum',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    }
];


var $eec239eec40164f1$exports = {};

$parcel$export($eec239eec40164f1$exports, "json", () => $eec239eec40164f1$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $eec239eec40164f1$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'FFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'RFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IRFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    }
];


var $2abf07103affb121$exports = {};

$parcel$export($2abf07103affb121$exports, "json", () => $2abf07103affb121$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $2abf07103affb121$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'StaticRegexReplace',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'pattern',
                'name': 'pattern',
                'type': 'string'
            },
            {
                'tfName': 'rewrite',
                'name': 'rewrite',
                'type': 'string'
            },
            {
                'tfName': 'replace_global',
                'name': 'replaceGlobal',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'StringNGrams',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dataSplits',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'separator',
                'name': 'separator',
                'type': 'string'
            },
            {
                'tfName': 'ngram_widths',
                'name': 'nGramWidths',
                'type': 'number[]'
            },
            {
                'tfName': 'left_pad',
                'name': 'leftPad',
                'type': 'string'
            },
            {
                'tfName': 'right_pad',
                'name': 'rightPad',
                'type': 'string'
            },
            {
                'tfName': 'pad_width',
                'name': 'padWidth',
                'type': 'number'
            },
            {
                'tfName': 'preserve_short_sequences',
                'name': 'preserveShortSequences',
                'type': 'bool'
            }
        ],
        'outputs': [
            'ngrams',
            'ngrams_splits'
        ]
    },
    {
        'tfOpName': 'StringSplit',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'delimiter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'skip_empty',
                'name': 'skipEmpty',
                'type': 'bool'
            }
        ],
        'outputs': [
            'indices',
            'values',
            'shape'
        ]
    },
    {
        'tfOpName': 'StringToHashBucketFast',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_buckets',
                'name': 'numBuckets',
                'type': 'number'
            }
        ]
    }
];


var $26c4596fea9f489e$exports = {};

$parcel$export($26c4596fea9f489e$exports, "json", () => $26c4596fea9f489e$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $26c4596fea9f489e$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Cast',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'SrcT',
                'name': 'sdtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'DstT',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ExpandDims',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'MirrorPad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'mode',
                'name': 'mode',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'Pad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'constant_value',
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'PadV2',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Reshape',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'EnsureShape',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Squeeze',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'tfDeprecatedName': 'squeeze_dims',
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'SpaceToBatchND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'paddings',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'BatchToSpaceND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'crops',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthToSpace',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'block_size',
                'name': 'blockSize',
                'type': 'number'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'BroadcastTo',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': []
    },
    {
        'tfOpName': 'BroadcastArgs',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 's0',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 's1',
                'type': 'tensor'
            }
        ],
        'attrs': []
    }
];



var $e7636b16c8ece759$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
class $e7636b16c8ece759$export$712e670bcbcf1315 {
    // Singleton instance for the mapper
    static get Instance() {
        return this._instance || (this._instance = new this());
    }
    // Loads the op mapping from the JSON file.
    constructor(){
        const ops = [
            $92f2f618b7788456$exports,
            $5038a9a026061abc$exports,
            $18466f05b5f0cde0$exports,
            $f2c62b406e0cb44f$exports,
            $da57c6fbc0e8e275$exports,
            $c00fc2ecdf828344$exports,
            $64107a6ca6735dbb$exports,
            $8e9e37ca1fe0a351$exports,
            $7789a3b787b221c4$exports,
            $de231e99c3a957b4$exports,
            $c5092e77366f20b6$exports,
            $4b307384703dd93a$exports,
            $10feecedb5ca137c$exports,
            $f4c3b3292cb4fff9$exports,
            $ad8a8e039d544a71$exports,
            $403df01f4cd348e9$exports,
            $eec239eec40164f1$exports,
            $2abf07103affb121$exports,
            $26c4596fea9f489e$exports
        ];
        const mappersJson = [].concat(...ops.map((op)=>op.json));
        this.opMappers = mappersJson.reduce((map, mapper)=>{
            map[mapper.tfOpName] = mapper;
            return map;
        }, {});
    }
    // Converts the model inference graph from Tensorflow GraphDef to local
    // representation for TensorFlow.js API
    transformGraph(graph, signature = {}) {
        const tfNodes = graph.node;
        const placeholders = [];
        const weights = [];
        const initNodes = [];
        const nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op.startsWith('Placeholder')) placeholders.push(map[node.name]);
            else if (node.op === 'Const') weights.push(map[node.name]);
            else if (node.input == null || node.input.length === 0) initNodes.push(map[node.name]);
            return map;
        }, {});
        let inputs = [];
        const outputs = [];
        let inputNodeNameToKey = {};
        let outputNodeNameToKey = {};
        if (signature != null) {
            inputNodeNameToKey = this.mapSignatureEntries(signature.inputs);
            outputNodeNameToKey = this.mapSignatureEntries(signature.outputs);
        }
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $727b63cbe12c1384$export$6cbb65bf9e07a72)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        // if signature has not outputs set, add any node that does not have
        // outputs.
        if (Object.keys(outputNodeNameToKey).length === 0) allNodes.forEach((key)=>{
            const node = nodes[key];
            if (node.children.length === 0) outputs.push(node);
        });
        else Object.keys(outputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $727b63cbe12c1384$export$6cbb65bf9e07a72)(name);
            const node = nodes[nodeName];
            if (node != null) {
                node.signatureKey = outputNodeNameToKey[name];
                outputs.push(node);
            }
        });
        if (Object.keys(inputNodeNameToKey).length > 0) Object.keys(inputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $727b63cbe12c1384$export$6cbb65bf9e07a72)(name);
            const node = nodes[nodeName];
            if (node) {
                node.signatureKey = inputNodeNameToKey[name];
                inputs.push(node);
            }
        });
        else inputs = placeholders;
        let functions = {};
        if (graph.library != null && graph.library.function != null) functions = graph.library.function.reduce((functions, func)=>{
            functions[func.signature.name] = this.mapFunction(func);
            return functions;
        }, {});
        const result = {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature,
            functions: functions
        };
        if (initNodes.length > 0) result.initNodes = initNodes;
        return result;
    }
    mapSignatureEntries(entries) {
        return Object.keys(entries || {}).reduce((prev, curr)=>{
            prev[entries[curr].name] = curr;
            return prev;
        }, {});
    }
    mapNode(node) {
        // Unsupported ops will cause an error at run-time (not parse time), since
        // they may not be used by the actual execution subgraph.
        const mapper = (0, $a25ca992a33088d7$export$ad480e5d0b303fdc)(node.op) || this.opMappers[node.op] || {};
        if (node.attr == null) node.attr = {};
        const newNode = {
            name: node.name,
            op: node.op,
            category: mapper.category,
            inputNames: (node.input || []).map((input)=>input.startsWith('^') ? input.slice(1) : input),
            inputs: [],
            children: [],
            inputParams: {},
            attrParams: {},
            rawAttrs: node.attr,
            outputs: mapper.outputs
        };
        if (mapper.inputs != null) newNode.inputParams = mapper.inputs.reduce((map, param)=>{
            map[param.name] = {
                type: param.type,
                inputIndexStart: param.start,
                inputIndexEnd: param.end
            };
            return map;
        }, {});
        if (mapper.attrs != null) newNode.attrParams = mapper.attrs.reduce((map, param)=>{
            const type = param.type;
            let value = undefined;
            switch(param.type){
                case 'string':
                    value = $e7636b16c8ece759$export$88878e8ea979e9e0(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$88878e8ea979e9e0(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'string[]':
                    value = $e7636b16c8ece759$export$3ad7c1b82be1673b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$3ad7c1b82be1673b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number':
                    value = $e7636b16c8ece759$export$9bb8d6def7820923(node.attr, param.tfName, param.defaultValue || 0);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$9bb8d6def7820923(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number[]':
                    value = $e7636b16c8ece759$export$a5181f35ff520ed9(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$a5181f35ff520ed9(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool':
                    value = $e7636b16c8ece759$export$2dc362e9c5612e66(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$2dc362e9c5612e66(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool[]':
                    value = $e7636b16c8ece759$export$71dea7cc6cfe5d6(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$71dea7cc6cfe5d6(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape':
                    value = $e7636b16c8ece759$export$2f3f0447f2b6ba0c(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$2f3f0447f2b6ba0c(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape[]':
                    value = $e7636b16c8ece759$export$296050a88ff1b217(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$296050a88ff1b217(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype':
                    value = $e7636b16c8ece759$export$8ff555328ef39a1b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$8ff555328ef39a1b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype[]':
                    value = $e7636b16c8ece759$export$4d8018dacba67c5a(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$4d8018dacba67c5a(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'func':
                    value = $e7636b16c8ece759$export$aafe7fbc7c8a8284(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $e7636b16c8ece759$export$aafe7fbc7c8a8284(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'tensor':
                case 'tensors':
                    break;
                default:
                    throw new Error(`Unsupported param type: ${param.type} for op: ${node.op}`);
            }
            map[param.name] = {
                value: value,
                type: type
            };
            return map;
        }, {});
        return newNode;
    }
    // map the TFunctionDef to TFJS graph object
    mapFunction(functionDef) {
        const tfNodes = functionDef.nodeDef;
        const placeholders = [];
        const weights = [];
        let nodes = {};
        if (tfNodes != null) nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op === 'Const') weights.push(map[node.name]);
            return map;
        }, {});
        const inputs = [];
        const outputs = [];
        functionDef.signature.inputArg.forEach((arg)=>{
            const [nodeName] = (0, $727b63cbe12c1384$export$6cbb65bf9e07a72)(arg.name);
            const node = {
                name: nodeName,
                op: 'Placeholder',
                inputs: [],
                inputNames: [],
                category: 'graph',
                inputParams: {},
                attrParams: {
                    dtype: {
                        value: $e7636b16c8ece759$export$863992a6f00f04d8(arg.type),
                        type: 'dtype'
                    }
                },
                children: []
            };
            node.signatureKey = arg.name;
            inputs.push(node);
            nodes[nodeName] = node;
        });
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $727b63cbe12c1384$export$6cbb65bf9e07a72)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        const returnNodeMap = functionDef.ret;
        functionDef.signature.outputArg.forEach((output)=>{
            const [nodeName, index] = (0, $727b63cbe12c1384$export$6cbb65bf9e07a72)(returnNodeMap[output.name]);
            const node = nodes[nodeName];
            if (node != null) {
                node.defaultOutput = index;
                outputs.push(node);
            }
        });
        const signature = this.mapArgsToSignature(functionDef);
        return {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature
        };
    }
    mapArgsToSignature(functionDef) {
        return {
            methodName: functionDef.signature.name,
            inputs: functionDef.signature.inputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg);
                return map;
            }, {}),
            outputs: functionDef.signature.outputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg, functionDef.ret);
                return map;
            }, {})
        };
    }
    mapArgToTensorInfo(arg, nameMap) {
        let name = arg.name;
        if (nameMap != null) name = nameMap[name];
        return {
            name: name,
            dtype: arg.type
        };
    }
}
function $e7636b16c8ece759$export$94fdf11bafc8de6b(text) {
    const global = (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().global;
    if (typeof global.atob !== 'undefined') return global.atob(text);
    else if (typeof $e7636b16c8ece759$require$Buffer !== 'undefined') return new $e7636b16c8ece759$require$Buffer(text, 'base64').toString();
    else throw new Error("Unable to decode base64 in this environment. Missing built-in atob() or Buffer()");
}
function $e7636b16c8ece759$export$a112ee1a9f1f58d1(s, keepCase) {
    const value = Array.isArray(s) ? String.fromCharCode.apply(null, s) : $e7636b16c8ece759$export$94fdf11bafc8de6b(s);
    return keepCase ? value : value.toLowerCase();
}
function $e7636b16c8ece759$export$88878e8ea979e9e0(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param != null) return $e7636b16c8ece759$export$a112ee1a9f1f58d1(param.s, keepCase);
    return def;
}
function $e7636b16c8ece759$export$2dc362e9c5612e66(attrs, name, def) {
    const param = attrs[name];
    return param ? param.b : def;
}
function $e7636b16c8ece759$export$9bb8d6def7820923(attrs, name, def) {
    const param = attrs[name] || {};
    const value = param['i'] != null ? param['i'] : param['f'] != null ? param['f'] : def;
    return typeof value === 'number' ? value : parseInt(value, 10);
}
function $e7636b16c8ece759$export$863992a6f00f04d8(value) {
    if (typeof value === 'string') // tslint:disable-next-line:no-any
    value = $da1154ef7a939058$export$45c69700ee30a78c[value];
    switch(value){
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_FLOAT:
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_HALF:
            return 'float32';
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_INT32:
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_INT64:
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_INT8:
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_UINT8:
            return 'int32';
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_BOOL:
            return 'bool';
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_DOUBLE:
            return 'float32';
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_STRING:
            return 'string';
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_COMPLEX64:
        case $da1154ef7a939058$export$45c69700ee30a78c.DT_COMPLEX128:
            return 'complex64';
        default:
            // Unknown dtype error will happen at runtime (instead of parse time),
            // since these nodes might not be used by the actual subgraph execution.
            return null;
    }
}
function $e7636b16c8ece759$export$aafe7fbc7c8a8284(attrs, name, def) {
    const param = attrs[name];
    if (param && param.func) return param.func.name;
    return def;
}
function $e7636b16c8ece759$export$8ff555328ef39a1b(attrs, name, def) {
    const param = attrs[name];
    if (param && param.type) return $e7636b16c8ece759$export$863992a6f00f04d8(param.type);
    return def;
}
function $e7636b16c8ece759$export$4d8018dacba67c5a(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.type) return param.list.type.map((v)=>$e7636b16c8ece759$export$863992a6f00f04d8(v));
    return def;
}
function $e7636b16c8ece759$export$e22e6990f4767045(shape) {
    if (shape.unknownRank) return undefined;
    if (shape.dim != null) return shape.dim.map((dim)=>typeof dim.size === 'number' ? dim.size : parseInt(dim.size, 10));
    return [];
}
function $e7636b16c8ece759$export$2f3f0447f2b6ba0c(attrs, name, def) {
    const param = attrs[name];
    if (param && param.shape) return $e7636b16c8ece759$export$e22e6990f4767045(param.shape);
    return def;
}
function $e7636b16c8ece759$export$a5181f35ff520ed9(attrs, name, def) {
    const param = attrs[name];
    if (param) return ((param.list.f && param.list.f.length ? param.list.f : param.list.i) || []).map((v)=>typeof v === 'number' ? v : parseInt(v, 10));
    return def;
}
function $e7636b16c8ece759$export$3ad7c1b82be1673b(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param && param.list && param.list.s) return param.list.s.map((v)=>{
        return $e7636b16c8ece759$export$a112ee1a9f1f58d1(v, keepCase);
    });
    return def;
}
function $e7636b16c8ece759$export$296050a88ff1b217(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.shape) return param.list.shape.map((v)=>{
        return $e7636b16c8ece759$export$e22e6990f4767045(v);
    });
    return def;
}
function $e7636b16c8ece759$export$71dea7cc6cfe5d6(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.b) return param.list.b;
    return def;
}


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $13336795b5ffd0da$export$2964c493e854c8ad {
    constructor(node, tensorMap, context){
        this.node = node;
        this.tensorMap = tensorMap;
        this.context = context;
        this.inputs = [];
        this.attrs = {};
        this.inputs = node.inputNames.map((name)=>this.getInput(name));
        if (node.rawAttrs != null) this.attrs = Object.keys(node.rawAttrs).reduce((attrs, key)=>{
            attrs[key] = this.getAttr(key);
            return attrs;
        }, {});
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getInput(name) {
        return (0, $727b63cbe12c1384$export$c5e50df225428195)(name, this.tensorMap, this.context);
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getAttr(name, defaultValue) {
        const value = this.node.rawAttrs[name];
        if (value.tensor != null) return (0, $727b63cbe12c1384$export$c5e50df225428195)(name, this.tensorMap, this.context);
        if (value.i != null || value.f != null) return (0, $e7636b16c8ece759$export$9bb8d6def7820923)(this.node.rawAttrs, name, defaultValue);
        if (value.s != null) return (0, $e7636b16c8ece759$export$88878e8ea979e9e0)(this.node.rawAttrs, name, defaultValue);
        if (value.b != null) return (0, $e7636b16c8ece759$export$2dc362e9c5612e66)(this.node.rawAttrs, name, defaultValue);
        if (value.shape != null) return (0, $e7636b16c8ece759$export$2f3f0447f2b6ba0c)(this.node.rawAttrs, name, defaultValue);
        if (value.type != null) return (0, $e7636b16c8ece759$export$8ff555328ef39a1b)(this.node.rawAttrs, name, defaultValue);
        if (value.list != null) {
            if (value.list.i != null || value.list.f != null) return (0, $e7636b16c8ece759$export$a5181f35ff520ed9)(this.node.rawAttrs, name, defaultValue);
            if (value.list.s != null) return (0, $e7636b16c8ece759$export$3ad7c1b82be1673b)(this.node.rawAttrs, name, defaultValue);
            if (value.list.shape != null) return (0, $e7636b16c8ece759$export$296050a88ff1b217)(this.node.rawAttrs, name, defaultValue);
            if (value.list.b != null) return (0, $e7636b16c8ece759$export$71dea7cc6cfe5d6)(this.node.rawAttrs, name, defaultValue);
            if (value.list.type != null) return (0, $e7636b16c8ece759$export$4d8018dacba67c5a)(this.node.rawAttrs, name, defaultValue);
        }
        return defaultValue;
    }
}



/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist
var $c795cbee2e7509f4$exports = {};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This file exports ops used by the converters executors. By default it
 * re-exports all ops. In a custom build this is aliased to a file that will
 * only exports ops for a given model.json.
 */ 
$parcel$exportWildcard($c795cbee2e7509f4$exports, $7912647d6e7a4ee9$exports);



const $96d33391e4514d4b$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'BiasAdd':
        case 'AddV2':
        case 'Add':
            return [
                ops.add((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'AddN':
            return [
                ops.addN((0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensors', node, tensorMap, context))
            ];
        case 'FloorMod':
        case 'Mod':
            return [
                ops.mod((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Mul':
            return [
                ops.mul((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'RealDiv':
        case 'Div':
            return [
                ops.div((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'DivNoNan':
            return [
                ops.divNoNan((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'FloorDiv':
            return [
                ops.floorDiv((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Sub':
            return [
                ops.sub((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Minimum':
            return [
                ops.minimum((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Maximum':
            return [
                ops.maximum((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Pow':
            return [
                ops.pow((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'SquaredDifference':
            return [
                ops.squaredDifference((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $96d33391e4514d4b$export$2c04807512a22510 = 'arithmetic';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $30db9efeda54c353$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'Abs':
        case 'ComplexAbs':
            return [
                ops.abs((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Acos':
            return [
                ops.acos((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Acosh':
            return [
                ops.acosh((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Asin':
            return [
                ops.asin((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Asinh':
            return [
                ops.asinh((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Atan':
            return [
                ops.atan((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Atan2':
            return [
                ops.atan2((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('y', node, tensorMap, context))
            ];
        case 'Atanh':
            return [
                ops.atanh((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Ceil':
            return [
                ops.ceil((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Complex':
            return [
                ops.complex((0, $727b63cbe12c1384$export$390042a9afe1baa5)('real', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('imag', node, tensorMap, context))
            ];
        case 'Cos':
            return [
                ops.cos((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Cosh':
            return [
                ops.cosh((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Elu':
            return [
                ops.elu((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Erf':
            return [
                ops.erf((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Exp':
            return [
                ops.exp((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Expm1':
            return [
                ops.expm1((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Floor':
            return [
                ops.floor((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Log':
            return [
                ops.log((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Log1p':
            return [
                ops.log1p((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Imag':
            return [
                ops.imag((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Neg':
            return [
                ops.neg((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Reciprocal':
            return [
                ops.reciprocal((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Real':
            return [
                ops.real((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Relu':
            return [
                ops.relu((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Round':
            return [
                ops.round((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Selu':
            return [
                ops.selu((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sigmoid':
            return [
                ops.sigmoid((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sin':
            return [
                ops.sin((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sign':
            return [
                ops.sign((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sinh':
            return [
                ops.sinh((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Softplus':
            return [
                ops.softplus((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Sqrt':
            return [
                ops.sqrt((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Square':
            return [
                ops.square((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Tanh':
            return [
                ops.tanh((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Tan':
            return [
                ops.tan((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'ClipByValue':
            return [
                ops.clipByValue((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('clipValueMin', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('clipValueMax', node, tensorMap, context))
            ];
        case 'Relu6':
            return [
                ops.relu6((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'Rsqrt':
            return [
                ops.rsqrt((0, $727b63cbe12c1384$export$c5e50df225428195)(node.inputNames[0], tensorMap, context))
            ];
        case 'LeakyRelu':
            return [
                ops.leakyRelu((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('alpha', node, tensorMap, context))
            ];
        case 'Prelu':
            return [
                ops.prelu((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('alpha', node, tensorMap, context))
            ];
        case 'IsNan':
            return [
                ops.isNaN((0, $727b63cbe12c1384$export$c5e50df225428195)(node.inputNames[0], tensorMap, context))
            ];
        case 'IsInf':
            return [
                ops.isInf((0, $727b63cbe12c1384$export$c5e50df225428195)(node.inputNames[0], tensorMap, context))
            ];
        case 'IsFinite':
            return [
                ops.isFinite((0, $727b63cbe12c1384$export$c5e50df225428195)(node.inputNames[0], tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $30db9efeda54c353$export$2c04807512a22510 = 'basic_math';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This differs from util.assertShapesMatch in that it allows values of
 * negative one, an undefined size of a dimensinon, in a shape to match
 * anything.
 */ 
function $92f03a63a0936b26$export$c20af1b3c2621826(shapeA, shapeB, errorMessagePrefix = '') {
    // constant shape means unknown rank
    if (typeof shapeA === 'number' || typeof shapeB === 'number') return;
    (0, $e10678764dab7ea0$exports).assert(shapeA.length === shapeB.length, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    for(let i = 0; i < shapeA.length; i++){
        const dim0 = shapeA[i];
        const dim1 = shapeB[i];
        (0, $e10678764dab7ea0$exports).assert(dim0 < 0 || dim1 < 0 || dim0 === dim1, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    }
}
function $92f03a63a0936b26$export$caa10238f73d8dc2(elementShape) {
    if (typeof elementShape === 'number' || elementShape.some((dim)=>dim < 0)) return false;
    return true;
}
function $92f03a63a0936b26$export$48aa6d00714ed79b(listElementShape, tensors, elementShape) {
    let partialShape = $92f03a63a0936b26$export$455cf61aa434d74b(listElementShape, elementShape);
    const notfullDefinedShape = !$92f03a63a0936b26$export$caa10238f73d8dc2(partialShape);
    if (notfullDefinedShape && tensors.length === 0) throw new Error(`Tried to calculate elements of an empty list` + ` with non-fully-defined elementShape: ${partialShape}`);
    if (notfullDefinedShape) tensors.forEach((tensor)=>{
        partialShape = $92f03a63a0936b26$export$455cf61aa434d74b(tensor.shape, partialShape);
    });
    if (!$92f03a63a0936b26$export$caa10238f73d8dc2(partialShape)) throw new Error(`Non-fully-defined elementShape: ${partialShape}`);
    return partialShape;
}
function $92f03a63a0936b26$export$455cf61aa434d74b(elementShapeA, elementShapeB) {
    if (typeof elementShapeA === 'number') return elementShapeB;
    if (typeof elementShapeB === 'number') return elementShapeA;
    if (elementShapeA.length !== elementShapeB.length) throw new Error(`Incompatible ranks during merge: ${elementShapeA} vs. ${elementShapeB}`);
    const result = [];
    for(let i = 0; i < elementShapeA.length; ++i){
        const dim0 = elementShapeA[i];
        const dim1 = elementShapeB[i];
        if (dim0 >= 0 && dim1 >= 0 && dim0 !== dim1) throw new Error(`Incompatible shape during merge: ${elementShapeA} vs. ${elementShapeB}`);
        result[i] = dim0 >= 0 ? dim0 : dim1;
    }
    return result;
}


class $c078a50831c724a0$export$854ca114072d2abc {
    constructor(name, dtype, maxSize, elementShape, identicalElementShapes, dynamicSize, clearAfterRead){
        this.name = name;
        this.dtype = dtype;
        this.maxSize = maxSize;
        this.elementShape = elementShape;
        this.identicalElementShapes = identicalElementShapes;
        this.dynamicSize = dynamicSize;
        this.clearAfterRead = clearAfterRead;
        this.tensors = [];
        this.closed_ = false;
        this.idTensor = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(0);
        (0, $8c449c89295c3cc4$export$fae3166c418e0471)(this.idTensor);
    }
    get id() {
        return this.idTensor.id;
    }
    get closed() {
        return this.closed_;
    }
    /**
     * Dispose the tensors and idTensor and mark the TensoryArray as closed.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.tensor.id)) tensor.tensor.dispose();
        });
        this.tensors = [];
        this.closed_ = true;
        this.idTensor.dispose();
    }
    size() {
        return this.tensors.length;
    }
    /**
     * Read the value at location index in the TensorArray.
     * @param index Number the index to read from.
     */ read(index) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || index >= this.size()) throw new Error(`Tried to read from index ${index}, but array size is: ${this.size()}`);
        const tensorWithState = this.tensors[index];
        if (tensorWithState.cleared) throw new Error(`TensorArray ${this.name}: Could not read index ${index} twice because it was cleared after a previous read ` + `(perhaps try setting clear_after_read = false?).`);
        if (this.clearAfterRead) tensorWithState.cleared = true;
        tensorWithState.read = true;
        return tensorWithState.tensor;
    }
    /**
     * Helper method to read multiple tensors from the specified indices.
     */ readMany(indices) {
        return indices.map((index)=>this.read(index));
    }
    /**
     * Write value into the index of the TensorArray.
     * @param index number the index to write to.
     * @param tensor
     */ write(index, tensor) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || !this.dynamicSize && index >= this.maxSize) throw new Error(`Tried to write to index ${index}, but array is not resizeable and size is: ${this.maxSize}`);
        const t = this.tensors[index] || {};
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index},
          because the value dtype is ${tensor.dtype}, but TensorArray dtype is ${this.dtype}.`);
        // Set the shape for the first time write to unknow shape tensor array
        if (this.size() === 0 && (this.elementShape == null || this.elementShape.length === 0)) this.elementShape = tensor.shape;
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(this.elementShape, tensor.shape, `TensorArray ${this.name}: Could not write to TensorArray index ${index}.`);
        if (t.read) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been read.`);
        if (t.written) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been written.`);
        t.tensor = tensor;
        (0, $8c449c89295c3cc4$export$fae3166c418e0471)(tensor);
        t.written = true;
        this.tensors[index] = t;
    }
    /**
     * Helper method to write multiple tensors to the specified indices.
     */ writeMany(indices, tensors) {
        if (indices.length !== tensors.length) throw new Error(`TensorArray ${this.name}: could not write multiple tensors,` + `because the index size: ${indices.length} is not the same as tensors size: ${tensors.length}.`);
        indices.forEach((i, index)=>this.write(i, tensors[index]));
    }
    /**
     * Return selected values in the TensorArray as a packed Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param [indices] number[] Optional. Taking values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size(). If not specified returns
     *    all tensors in the original order.
     * @param [dtype]
     */ gather(indices, dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but gather requested dtype ${dtype}`);
        if (!indices) {
            indices = [];
            for(let i = 0; i < this.size(); i++)indices.push(i);
        } else indices = indices.slice(0, this.size());
        if (indices.length === 0) return (0, $a82c6773538d9e64$export$65df3ad1ad888abb)([], [
            0
        ].concat(this.elementShape));
        // Read all the PersistentTensors into a vector to keep track of
        // their memory.
        const tensors = this.readMany(indices);
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(this.elementShape, tensors[0].shape, 'TensorArray shape mismatch: ');
        return (0, $6437527469582bc5$export$a57ab32f40f83ea9)(tensors, 0);
    }
    /**
     * Return the values in the TensorArray as a concatenated Tensor.
     */ concat(dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but concat requested dtype ${dtype}`);
        if (this.size() === 0) return (0, $a82c6773538d9e64$export$65df3ad1ad888abb)([], [
            0
        ].concat(this.elementShape));
        const indices = [];
        for(let i = 0; i < this.size(); i++)indices.push(i);
        // Collect all the tensors from the tensors array.
        const tensors = this.readMany(indices);
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(this.elementShape, tensors[0].shape, `TensorArray shape mismatch: tensor array shape (${this.elementShape}) vs first tensor shape (${tensors[0].shape})`);
        return (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)(tensors, 0);
    }
    /**
     * Scatter the values of a Tensor in specific indices of a TensorArray.
     * @param indices number[] values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size().
     * @param tensor Tensor input tensor.
     */ scatter(indices, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
        const maxIndex = Math.max(...indices);
        if (!this.dynamicSize && maxIndex >= this.maxSize) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${this.maxSize})`);
        this.writeMany(indices, (0, $c1775cdc84f05f72$export$3c05285afa115eec)(tensor, 0));
    }
    /**
     * Split the values of a Tensor into the TensorArray.
     * @param length number[] with the lengths to use when splitting value along
     *    its first dimension.
     * @param tensor Tensor, the tensor to split.
     */ split(length, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        let totalLength = 0;
        const cumulativeLengths = length.map((len)=>{
            totalLength += len;
            return totalLength;
        });
        if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
        if (!this.dynamicSize && length.length !== this.maxSize) throw new Error(`TensorArray's size is not equal to the size of lengths (${this.maxSize} vs. ${length.length}), ` + 'and the TensorArray is not marked as dynamically resizeable');
        const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
        const tensors = [];
        (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            tensor = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(tensor, [
                1,
                totalLength,
                elementPerRow
            ]);
            for(let i = 0; i < length.length; ++i){
                const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
                const indices = [
                    0,
                    previousLength,
                    0
                ];
                const sizes = [
                    1,
                    length[i],
                    elementPerRow
                ];
                tensors[i] = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $535db06fef6716ec$export$58adb3bec8346d0f)(tensor, indices, sizes), this.elementShape);
            }
            return tensors;
        });
        const indices = [];
        for(let i = 0; i < length.length; i++)indices[i] = i;
        this.writeMany(indices, tensors);
    }
}


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $5c09375ed812532e$export$97d48a41015c8fa8 {
    get id() {
        return this.idTensor.id;
    }
    /**
     *
     * @param tensors list of tensors
     * @param elementShape shape of each tensor, this can be a single number (any
     * shape is allowed) or partial shape (dim = -1).
     * @param elementDtype data type of each tensor
     * @param maxNumElements The maximum allowed size of `tensors`. Defaults to -1
     *   meaning that the size of `tensors` is unbounded.
     */ constructor(tensors, elementShape, elementDtype, maxNumElements = -1){
        this.tensors = tensors;
        this.elementShape = elementShape;
        this.elementDtype = elementDtype;
        if (tensors != null) tensors.forEach((tensor)=>{
            if (elementDtype !== tensor.dtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${tensor.dtype}`);
            (0, $92f03a63a0936b26$export$c20af1b3c2621826)(elementShape, tensor.shape, 'TensorList shape mismatch: ');
            (0, $8c449c89295c3cc4$export$fae3166c418e0471)(tensor);
        });
        this.idTensor = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(0);
        this.maxNumElements = maxNumElements;
        (0, $8c449c89295c3cc4$export$fae3166c418e0471)(this.idTensor);
    }
    /**
     * Get a new TensorList containing a copy of the underlying tensor container.
     */ copy() {
        return new $5c09375ed812532e$export$97d48a41015c8fa8([
            ...this.tensors
        ], this.elementShape, this.elementDtype);
    }
    /**
     * Dispose the tensors and idTensor and clear the tensor list.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.id)) tensor.dispose();
        });
        this.tensors.length = 0;
        this.idTensor.dispose();
    }
    /**
     * The size of the tensors in the tensor list.
     */ size() {
        return this.tensors.length;
    }
    /**
     * Return a tensor that stacks a list of rank-R tf.Tensors into one rank-(R+1)
     * tf.Tensor.
     * @param elementShape shape of each tensor
     * @param elementDtype data type of each tensor
     * @param numElements the number of elements to stack
     */ stack(elementShape, elementDtype, numElements = -1) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (numElements !== -1 && this.tensors.length !== numElements) throw new Error(`Operation expected a list with ${numElements} elements but got a list with ${this.tensors.length} elements.`);
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(elementShape, this.elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $92f03a63a0936b26$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            const reshapedTensors = this.tensors.map((tensor)=>(0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(tensor, outputElementShape));
            return (0, $6437527469582bc5$export$a57ab32f40f83ea9)(reshapedTensors, 0);
        });
    }
    /**
     * Pop a tensor from the end of the list.
     * @param elementShape shape of the tensor
     * @param elementDtype data type of the tensor
     */ popBack(elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (this.size() === 0) throw new Error('Trying to pop from an empty list.');
        const outputElementShape = (0, $92f03a63a0936b26$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        const tensor = this.tensors.pop();
        tensor.kept = false;
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(tensor.shape, elementShape, 'TensorList shape mismatch: ');
        return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(tensor, outputElementShape);
    }
    /**
     * Push a tensor to the end of the list.
     * @param tensor Tensor to be pushed.
     */ pushBack(tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(tensor.shape, this.elementShape, 'TensorList shape mismatch: ');
        if (this.maxNumElements === this.size()) throw new Error(`Trying to push element into a full list.`);
        (0, $8c449c89295c3cc4$export$fae3166c418e0471)(tensor);
        this.tensors.push(tensor);
    }
    /**
     * Update the size of the list.
     * @param size the new size of the list.
     */ resize(size) {
        if (size < 0) throw new Error(`TensorListResize expects size to be non-negative. Got: ${size}`);
        if (this.maxNumElements !== -1 && size > this.maxNumElements) throw new Error(`TensorListResize input size ${size} is greater maxNumElement ${this.maxNumElements}.`);
        const destTensorList = new $5c09375ed812532e$export$97d48a41015c8fa8([], this.elementShape, this.elementDtype, this.maxNumElements);
        destTensorList.tensors.length = size;
        for(let i = 0; i < Math.min(this.tensors.length, size); ++i)destTensorList.tensors[i] = this.tensors[i];
        return destTensorList;
    }
    /**
     * Retrieve the element at the provided index
     * @param elementShape shape of the tensor
     * @param elementDtype dtype of the tensor
     * @param elementIndex index of the tensor
     */ getItem(elementIndex, elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || elementIndex > this.tensors.length) throw new Error(`Trying to access element ${elementIndex} in a list with ${this.tensors.length} elements.`);
        if (this.tensors[elementIndex] == null) throw new Error(`element at index ${elementIndex} is null.`);
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(this.tensors[elementIndex].shape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $92f03a63a0936b26$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(this.tensors[elementIndex], outputElementShape);
    }
    /**
     * Set the tensor at the index
     * @param elementIndex index of the tensor
     * @param tensor the tensor to be inserted into the list
     */ setItem(elementIndex, tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || this.maxNumElements !== -1 && elementIndex >= this.maxNumElements) throw new Error(`Trying to set element ${elementIndex} in a list with max ${this.maxNumElements} elements.`);
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(this.elementShape, tensor.shape, 'TensorList shape mismatch: ');
        (0, $8c449c89295c3cc4$export$fae3166c418e0471)(tensor);
        // dispose the previous value if it is replacing.
        if (this.tensors[elementIndex] != null) this.tensors[elementIndex].kept = false;
        this.tensors[elementIndex] = tensor;
    }
    /**
     * Return selected values in the TensorList as a stacked Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param indices indices of tensors to gather
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ gather(indices, elementDtype, elementShape) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        // When indices is greater than the size of the list, indices beyond the
        // size of the list are ignored.
        indices = indices.slice(0, this.size());
        const outputElementShape = (0, $92f03a63a0936b26$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        if (indices.length === 0) return (0, $a82c6773538d9e64$export$65df3ad1ad888abb)([], [
            0
        ].concat(outputElementShape));
        return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            const tensors = indices.map((i)=>(0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(this.tensors[i], outputElementShape));
            return (0, $6437527469582bc5$export$a57ab32f40f83ea9)(tensors, 0);
        });
    }
    /**
     * Return the values in the TensorList as a concatenated Tensor.
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ concat(elementDtype, elementShape) {
        if (!!elementDtype && elementDtype !== this.elementDtype) throw new Error(`TensorList dtype is ${this.elementDtype} but concat requested dtype ${elementDtype}`);
        (0, $92f03a63a0936b26$export$c20af1b3c2621826)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $92f03a63a0936b26$export$48aa6d00714ed79b)(this.elementShape, this.tensors, elementShape);
        if (this.size() === 0) return (0, $a82c6773538d9e64$export$65df3ad1ad888abb)([], [
            0
        ].concat(outputElementShape));
        return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            const tensors = this.tensors.map((t)=>(0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(t, outputElementShape));
            return (0, $dc14b6735dbc478f$export$ee1b3e54f0441b22)(tensors, 0);
        });
    }
}
function $5c09375ed812532e$export$1bc9ee297bacb6e5(tensor, elementShape, elementDtype) {
    const dtype = tensor.dtype;
    if (tensor.shape.length < 1) throw new Error(`Tensor must be at least a vector, but saw shape: ${tensor.shape}`);
    if (tensor.dtype !== elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${elementDtype}`);
    const tensorElementShape = tensor.shape.slice(1);
    (0, $92f03a63a0936b26$export$c20af1b3c2621826)(tensorElementShape, elementShape, 'TensorList shape mismatch: ');
    const tensorList = (0, $c1775cdc84f05f72$export$3c05285afa115eec)(tensor);
    return new $5c09375ed812532e$export$97d48a41015c8fa8(tensorList, elementShape, dtype);
}
function $5c09375ed812532e$export$12d6b2bf497a6811(elementShape, elementDtype, numElements, maxNumElements) {
    return new $5c09375ed812532e$export$97d48a41015c8fa8([], elementShape, elementDtype, maxNumElements);
}
function $5c09375ed812532e$export$c97954fff4307550(tensor, indices, elementShape, numElements) {
    if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
    const maxIndex = Math.max(...indices);
    if (numElements != null && numElements !== -1 && maxIndex >= numElements) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${numElements})`);
    const list = new $5c09375ed812532e$export$97d48a41015c8fa8([], elementShape, tensor.dtype, numElements);
    const tensors = (0, $c1775cdc84f05f72$export$3c05285afa115eec)(tensor, 0);
    indices.forEach((value, index)=>{
        list.setItem(value, tensors[index]);
    });
    return list;
}
function $5c09375ed812532e$export$65980d18b75784e2(tensor, length, elementShape) {
    let totalLength = 0;
    const cumulativeLengths = length.map((len)=>{
        totalLength += len;
        return totalLength;
    });
    if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
    const shapeWithoutFirstDim = tensor.shape.slice(1);
    const outputElementShape = (0, $92f03a63a0936b26$export$455cf61aa434d74b)(shapeWithoutFirstDim, elementShape);
    const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
    const tensors = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
        const tensors = [];
        tensor = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(tensor, [
            1,
            totalLength,
            elementPerRow
        ]);
        for(let i = 0; i < length.length; ++i){
            const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
            const indices = [
                0,
                previousLength,
                0
            ];
            const sizes = [
                1,
                length[i],
                elementPerRow
            ];
            tensors[i] = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)((0, $535db06fef6716ec$export$58adb3bec8346d0f)(tensor, indices, sizes), outputElementShape);
        }
        tensor.dispose();
        return tensors;
    });
    const list = new $5c09375ed812532e$export$97d48a41015c8fa8([], elementShape, tensor.dtype, length.length);
    for(let i = 0; i < tensors.length; i++)list.setItem(i, tensors[i]);
    return list;
}



const $8c83a74940ef156e$export$7be88578e558e499 = async (node, tensorMap, context)=>{
    switch(node.op){
        case 'If':
        case 'StatelessIf':
            {
                const thenFunc = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('thenBranch', node, tensorMap, context);
                const elseFunc = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elseBranch', node, tensorMap, context);
                const cond = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('cond', node, tensorMap, context);
                const args = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('args', node, tensorMap, context);
                const condValue = await cond.data();
                if (condValue[0]) return context.functionMap[thenFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                else return context.functionMap[elseFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
            }
        case 'While':
        case 'StatelessWhile':
            {
                const bodyFunc = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('body', node, tensorMap, context);
                const condFunc = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('cond', node, tensorMap, context);
                const args = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('args', node, tensorMap, context);
                // Calculate the condition of the loop
                const condResult = await context.functionMap[condFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                const argIds = args.map((tensor)=>tensor.id);
                let condValue = await condResult[0].data();
                // Dispose the intermediate tensors for condition function
                condResult.forEach((tensor)=>{
                    if (!tensor.kept && argIds.indexOf(tensor.id) === -1) tensor.dispose();
                });
                let result = args;
                while(condValue[0]){
                    // Record the previous result for intermediate tensor tracking
                    const origResult = result;
                    // Execution the body of the loop
                    result = await context.functionMap[bodyFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    const resultIds = result.map((tensor)=>tensor.id);
                    // Dispose the intermediate tensor for body function that is not global
                    // kept, not input/output of the body function
                    origResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                    // Recalcuate the condition of the loop using the latest results.
                    const condResult = await context.functionMap[condFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    condValue = await condResult[0].data();
                    // Dispose the intermediate tensors for condition function
                    condResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                }
                return result;
            }
        case 'LoopCond':
            {
                const pred = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pred', node, tensorMap, context);
                return [
                    (0, $727b63cbe12c1384$export$c2185cfeaef7ba84)(pred)
                ];
            }
        case 'Switch':
            {
                const pred = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pred', node, tensorMap, context);
                let data = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('data', node, tensorMap, context);
                if (!data.kept) data = (0, $727b63cbe12c1384$export$c2185cfeaef7ba84)(data);
                // Outputs nodes :0 => false, :1 => true
                return (await pred.data())[0] ? [
                    undefined,
                    data
                ] : [
                    data,
                    undefined
                ];
            }
        case 'Merge':
            {
                const inputName = node.inputNames.find((name)=>(0, $727b63cbe12c1384$export$c5e50df225428195)(name, tensorMap, context) !== undefined);
                if (inputName) {
                    const data = (0, $727b63cbe12c1384$export$c5e50df225428195)(inputName, tensorMap, context);
                    return [
                        (0, $727b63cbe12c1384$export$c2185cfeaef7ba84)(data)
                    ];
                }
                return undefined;
            }
        case 'Enter':
            {
                const frameId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('frameName', node, tensorMap, context);
                const data = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                context.enterFrame(frameId);
                return [
                    (0, $727b63cbe12c1384$export$c2185cfeaef7ba84)(data)
                ];
            }
        case 'Exit':
            {
                const data = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                context.exitFrame();
                return [
                    (0, $727b63cbe12c1384$export$c2185cfeaef7ba84)(data)
                ];
            }
        case 'NextIteration':
            {
                const data = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                context.nextIteration();
                return [
                    (0, $727b63cbe12c1384$export$c2185cfeaef7ba84)(data)
                ];
            }
        case 'TensorArrayV3':
            {
                const size = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const dtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const dynamicSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dynamicSize', node, tensorMap, context);
                const clearAfterRead = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('clearAfterRead', node, tensorMap, context);
                const identicalElementShapes = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('identicalElementShapes', node, tensorMap, context);
                const name = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('name', node, tensorMap, context);
                const tensorArray = new (0, $c078a50831c724a0$export$854ca114072d2abc)(name, dtype, size, elementShape, identicalElementShapes, dynamicSize, clearAfterRead);
                context.addTensorArray(tensorArray);
                return [
                    tensorArray.idTensor,
                    (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(1.0)
                ];
            }
        case 'TensorArrayWriteV3':
            {
                const id = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const index = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('index', node, tensorMap, context);
                const writeTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const writeTensorArray = context.getTensorArray(id.id);
                writeTensorArray.write(index, writeTensor);
                return [
                    writeTensorArray.idTensor
                ];
            }
        case 'TensorArrayReadV3':
            {
                const readId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const readIndex = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('index', node, tensorMap, context);
                const readTensorArray = context.getTensorArray(readId.id);
                return [
                    readTensorArray.read(readIndex)
                ];
            }
        case 'TensorArrayGatherV3':
            {
                const gatherId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const gatherIndices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const gatherDtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                const gatherTensorArray = context.getTensorArray(gatherId.id);
                return [
                    gatherTensorArray.gather(gatherIndices, gatherDtype)
                ];
            }
        case 'TensorArrayScatterV3':
            {
                const scatterId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const scatterIndices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const scatterTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const scatterTensorArray = context.getTensorArray(scatterId.id);
                scatterTensorArray.scatter(scatterIndices, scatterTensor);
                return [
                    scatterTensorArray.idTensor
                ];
            }
        case 'TensorArrayConcatV3':
            {
                const concatId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const concatTensorArray = context.getTensorArray(concatId.id);
                const concatDtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                return [
                    concatTensorArray.concat(concatDtype)
                ];
            }
        case 'TensorArraySplitV3':
            {
                const splitId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const splitTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const lengths = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('lengths', node, tensorMap, context);
                const splitTensorArray = context.getTensorArray(splitId.id);
                splitTensorArray.split(lengths, splitTensor);
                return [
                    splitTensorArray.idTensor
                ];
            }
        case 'TensorArraySizeV3':
            {
                const sizeId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const sizeTensorArray = context.getTensorArray(sizeId.id);
                return [
                    (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(sizeTensorArray.size(), 'int32')
                ];
            }
        case 'TensorArrayCloseV3':
            {
                const closeId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorArrayId', node, tensorMap, context);
                const closeTensorArray = context.getTensorArray(closeId.id);
                closeTensorArray.clearAndClose();
                return [
                    closeTensorArray.idTensor
                ];
            }
        case 'TensorListSetItem':
            {
                const idTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const index = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('index', node, tensorMap, context);
                const writeTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.setItem(index, writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGetItem':
            {
                const idTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const readIndex = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('index', node, tensorMap, context);
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDType = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.getItem(readIndex, elementShape, elementDType)
                ];
            }
        case 'TensorListScatterV2':
        case 'TensorListScatter':
            {
                const scatterIndices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const scatterTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const numElements = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('numElements', node, tensorMap, context);
                const tensorList = (0, $5c09375ed812532e$export$c97954fff4307550)(scatterTensor, scatterIndices, elementShape, numElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListReserve':
        case 'EmptyTensorList':
            {
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                let numElementsParam;
                if (node.op === 'TensorListReserve') numElementsParam = 'numElements';
                else numElementsParam = 'maxNumElements';
                const numElements = (0, $727b63cbe12c1384$export$390042a9afe1baa5)(numElementsParam, node, tensorMap, context);
                const maxNumElements = node.op === 'TensorListReserve' ? -1 : numElements;
                const tensorList = (0, $5c09375ed812532e$export$12d6b2bf497a6811)(elementShape, elementDtype, numElements, maxNumElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGather':
            {
                const gatherId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const gatherIndices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(gatherId.id);
                return [
                    tensorList.gather(gatherIndices, elementDtype, elementShape)
                ];
            }
        case 'TensorListStack':
            {
                const idTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const numElements = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('numElements', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.stack(elementShape, elementDtype, numElements)
                ];
            }
        case 'TensorListFromTensor':
            {
                const tensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const tensorList = (0, $5c09375ed812532e$export$1bc9ee297bacb6e5)(tensor, elementShape, elementDtype);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListConcat':
        case 'TensorListConcatV2':
            {
                const concatId = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(concatId.id);
                const concatDtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                return [
                    tensorList.concat(concatDtype, elementShape)
                ];
            }
        case 'TensorListPushBack':
            {
                const idTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const writeTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.pushBack(writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListPopBack':
            {
                const idTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const elementDType = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.popBack(elementShape, elementDType)
                ];
            }
        case 'TensorListSplit':
            {
                const splitTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                const elementShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('elementShape', node, tensorMap, context);
                const lengths = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('lengths', node, tensorMap, context);
                const tensorList = (0, $5c09375ed812532e$export$65980d18b75784e2)(splitTensor, lengths, elementShape);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListLength':
            {
                const idTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(tensorList.size(), 'int32')
                ];
            }
        case 'TensorListResize':
            {
                const idTensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensorListId', node, tensorMap, context);
                const size = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const srcTensorList = context.getTensorList(idTensor.id);
                const destTensorList = srcTensorList.resize(size);
                context.addTensorList(destTensorList);
                return [
                    destTensorList.idTensor
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $8c83a74940ef156e$export$2c04807512a22510 = 'control';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


function $c4b7115ed5899ad3$var$fusedConvAndDepthWiseParams(node, tensorMap, context) {
    const [extraOp, activationFunc] = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('fusedOps', node, tensorMap, context);
    const isBiasAdd = extraOp === 'biasadd';
    const noBiasAdd = !isBiasAdd;
    const isPrelu = activationFunc === 'prelu';
    const isBatchNorm = extraOp === 'fusedbatchnorm';
    const numArgs = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('numArgs', node, tensorMap, context);
    if (isBiasAdd) {
        if (isPrelu && numArgs !== 2) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
        if (!isPrelu && isBiasAdd && numArgs !== 1) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd must have one extra argument: bias.");
    }
    if (isBatchNorm) throw new Error('FusedConv2d and DepthwiseConv2d with FusedBatchNorm is not supported');
    const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
    const pad = (0, $727b63cbe12c1384$export$d7501e6bee71bfee)(node, tensorMap, context);
    const dataFormat = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
    const dilations = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
    let [biasArg, preluArg] = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('args', node, tensorMap, context);
    if (noBiasAdd) {
        preluArg = biasArg;
        biasArg = undefined;
    }
    const leakyreluAlpha = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('leakyreluAlpha', node, tensorMap, context);
    return {
        stride: stride,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        biasArg: biasArg,
        preluArg: preluArg,
        activationFunc: activationFunc,
        leakyreluAlpha: leakyreluAlpha
    };
}
const $c4b7115ed5899ad3$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'Conv1D':
            {
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('stride', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const dataFormat = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilation = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dilation', node, tensorMap, context);
                return [
                    ops.conv1d((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('filter', node, tensorMap, context), stride, pad, dataFormat, dilation)
                ];
            }
        case 'Conv2D':
            {
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$d7501e6bee71bfee)(node, tensorMap, context);
                const dataFormat = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
                return [
                    ops.conv2d((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case '_FusedConv2D':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $c4b7115ed5899ad3$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.conv2d({
                        x: (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context),
                        filter: (0, $727b63cbe12c1384$export$390042a9afe1baa5)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'FusedDepthwiseConv2dNative':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $c4b7115ed5899ad3$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.depthwiseConv2d({
                        x: (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context),
                        filter: (0, $727b63cbe12c1384$export$390042a9afe1baa5)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'Conv2DBackpropInput':
        case 'Conv2dTranspose':
            {
                const shape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('outputShape', node, tensorMap, context);
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$d7501e6bee71bfee)(node, tensorMap, context);
                return [
                    ops.conv2dTranspose((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('filter', node, tensorMap, context), shape, [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'DepthwiseConv2dNative':
        case 'DepthwiseConv2d':
            {
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$d7501e6bee71bfee)(node, tensorMap, context);
                const dilations = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
                const dataFormat = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthwiseConv2d((0, $727b63cbe12c1384$export$390042a9afe1baa5)('input', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case 'Conv3D':
            {
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const dataFormat = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
                return [
                    ops.conv3d((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2],
                        dilations[3]
                    ])
                ];
            }
        case 'AvgPool':
            {
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPool':
            {
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPoolWithArgmax':
            {
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                const includeBatchInIndex = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('includeBatchInIndex', node, tensorMap, context);
                const { result: result, indexes: indexes } = ops.maxPoolWithArgmax((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                    kernelSize[1],
                    kernelSize[2]
                ], [
                    stride[1],
                    stride[2]
                ], pad, includeBatchInIndex);
                return [
                    result,
                    indexes
                ];
            }
        case 'AvgPool3D':
            {
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool3d((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'MaxPool3D':
            {
                const stride = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const kernelSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool3d((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'Dilation2D':
            {
                const strides = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const pad = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pad', node, tensorMap, context);
                const dilations = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dilations', node, tensorMap, context);
                // strides: [1, stride_height, stride_width, 1].
                const strideHeight = strides[1];
                const strideWidth = strides[2];
                // dilations: [1, dilation_height, dilation_width, 1].
                const dilationHeight = dilations[1];
                const dilationWidth = dilations[2];
                return [
                    ops.dilation2d((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('filter', node, tensorMap, context), [
                        strideHeight,
                        strideWidth
                    ], pad, [
                        dilationHeight,
                        dilationWidth
                    ], 'NHWC' /* dataFormat */ )
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c4b7115ed5899ad3$export$2c04807512a22510 = 'convolution';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $2d6eacb28dd145d3$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'Fill':
            {
                const shape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context);
                const dtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                const value = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('value', node, tensorMap, context);
                return [
                    ops.fill(shape, value, dtype)
                ];
            }
        case 'LinSpace':
            {
                const start = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('start', node, tensorMap, context);
                const stop = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('stop', node, tensorMap, context);
                const num = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('num', node, tensorMap, context);
                return [
                    ops.linspace(start, stop, num)
                ];
            }
        case 'Multinomial':
            {
                const logits = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('logits', node, tensorMap, context);
                const numSamples = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('numSamples', node, tensorMap, context);
                const seed = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('seed', node, tensorMap, context);
                return [
                    ops.multinomial(logits, numSamples, seed)
                ];
            }
        case 'OneHot':
            {
                const indices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const depth = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('depth', node, tensorMap, context);
                const onValue = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('onValue', node, tensorMap, context);
                const offValue = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('offValue', node, tensorMap, context);
                const dtype = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context);
                return [
                    ops.oneHot(indices, depth, onValue, offValue, dtype)
                ];
            }
        case 'Ones':
            return [
                ops.ones((0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
            ];
        case 'OnesLike':
            return [
                ops.onesLike((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'RandomStandardNormal':
            return [
                ops.randomStandardNormal((0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('seed', node, tensorMap, context))
            ];
        case 'RandomUniform':
            return [
                ops.randomUniform(// tslint:disable-next-line:no-any
                (0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('minval', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('maxval', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
            ];
        case 'RandomUniformInt':
            return [
                ops.randomUniformInt((0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('minval', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('maxval', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('seed', node, tensorMap, context))
            ];
        case 'Range':
            {
                const start = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('start', node, tensorMap, context);
                const stop = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('stop', node, tensorMap, context);
                const step = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('step', node, tensorMap, context);
                return [
                    ops.range(start, stop, step, (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
                ];
            }
        case 'TruncatedNormal':
            {
                const shape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context);
                const mean = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('mean', node, tensorMap, context);
                const stdDev = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('stdDev', node, tensorMap, context);
                const seed = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('seed', node, tensorMap, context);
                return [
                    ops.truncatedNormal(shape, mean, stdDev, (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context), seed)
                ];
            }
        case 'Zeros':
            return [
                ops.zeros((0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
            ];
        case 'ZerosLike':
            return [
                ops.zerosLike((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $2d6eacb28dd145d3$export$2c04807512a22510 = 'creation';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


function $8be045277287a719$var$nmsParams(node, tensorMap, context) {
    const boxes = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('boxes', node, tensorMap, context);
    const scores = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('scores', node, tensorMap, context);
    const maxOutputSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('maxOutputSize', node, tensorMap, context);
    const iouThreshold = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('iouThreshold', node, tensorMap, context);
    const scoreThreshold = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('scoreThreshold', node, tensorMap, context);
    const softNmsSigma = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('softNmsSigma', node, tensorMap, context);
    return {
        boxes: boxes,
        scores: scores,
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}
const $8be045277287a719$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'NonMaxSuppressionV5':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = $8be045277287a719$var$nmsParams(node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionWithScoreAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
                return [
                    result.selectedIndices,
                    result.selectedScores
                ];
            }
        case 'NonMaxSuppressionV4':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $8be045277287a719$var$nmsParams(node, tensorMap, context);
                const padToMaxOutputSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('padToMaxOutputSize', node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionPaddedAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
                return [
                    result.selectedIndices,
                    result.validOutputs
                ];
            }
        case 'NonMaxSuppressionV3':
        case 'NonMaxSuppressionV2':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $8be045277287a719$var$nmsParams(node, tensorMap, context);
                return [
                    await ops.image.nonMaxSuppressionAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold)
                ];
            }
        case 'Where':
            {
                const condition = ops.cast((0, $727b63cbe12c1384$export$390042a9afe1baa5)('condition', node, tensorMap, context), 'bool');
                const result = [
                    await ops.whereAsync(condition)
                ];
                condition.dispose();
                return result;
            }
        case 'ListDiff':
            return ops.setdiff1dAsync((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('y', node, tensorMap, context));
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $8be045277287a719$export$2c04807512a22510 = 'dynamic';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $c41b514af3513033$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'LowerBound':
            {
                const sortedSequence = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('sortedSequence', node, tensorMap, context);
                const values = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('values', node, tensorMap, context);
                return [
                    ops.lowerBound(sortedSequence, values)
                ];
            }
        case 'TopKV2':
            {
                const x = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const k = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('k', node, tensorMap, context);
                const sorted = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('sorted', node, tensorMap, context);
                const result = ops.topk(x, k, sorted);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UpperBound':
            {
                const sortedSequence = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('sortedSequence', node, tensorMap, context);
                const values = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('values', node, tensorMap, context);
                return [
                    ops.upperBound(sortedSequence, values)
                ];
            }
        case 'Unique':
            {
                const x = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const result = ops.unique(x);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UniqueV2':
            {
                const x = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const result = ops.unique(x, axis);
                return [
                    result.values,
                    result.indices
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c41b514af3513033$export$2c04807512a22510 = 'evaluation';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $f8f1ac7b25597c83$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'Const':
            return tensorMap[node.name];
        case 'PlaceholderWithDefault':
            const def = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('default', node, tensorMap, context);
            return [
                (0, $727b63cbe12c1384$export$c5e50df225428195)(node.name, tensorMap, context) || def
            ];
        case 'Placeholder':
            return [
                (0, $727b63cbe12c1384$export$c5e50df225428195)(node.name, tensorMap, context)
            ];
        case 'Identity':
        case 'StopGradient':
        case 'FakeQuantWithMinMaxVars':
            {
                const data = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return [
                    (0, $727b63cbe12c1384$export$c2185cfeaef7ba84)(data)
                ];
            }
        case 'IdentityN':
            return (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context).map((t)=>(0, $727b63cbe12c1384$export$c2185cfeaef7ba84)(t));
        case 'Snapshot':
            const snapshot = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
            return [
                (0, $727b63cbe12c1384$export$c2185cfeaef7ba84)(snapshot)
            ];
        case 'Shape':
            return [
                ops.tensor1d((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context).shape, 'int32')
            ];
        case 'ShapeN':
            return (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context).map((t)=>ops.tensor1d(t.shape));
        case 'Size':
            return [
                ops.scalar((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context).size, 'int32')
            ];
        case 'Rank':
            return [
                ops.scalar((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context).rank, 'int32')
            ];
        case 'NoOp':
            return [
                ops.scalar(1)
            ];
        case 'Print':
            const input = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
            const data = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('data', node, tensorMap, context);
            const message = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('message', node, tensorMap, context);
            const summarize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('summarize', node, tensorMap, context);
            console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance.");
            console.log(message);
            for(let i = 0; i < data.length; i++)console.log(Array.prototype.slice.call(data[i].dataSync()).slice(0, summarize));
            return [
                input
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $f8f1ac7b25597c83$export$2c04807512a22510 = 'graph';


/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 

class $62036930e8dbd6ca$export$b3bcf29b77543c46 {
    get id() {
        return this.handle.id;
    }
    /**
     * Constructor of HashTable. Creates a hash table.
     *
     * @param keyDType `dtype` of the table keys.
     * @param valueDType `dtype` of the table values.
     */ constructor(keyDType, valueDType){
        this.keyDType = keyDType;
        this.valueDType = valueDType;
        this.handle = (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(0);
        // tslint:disable-next-line: no-any
        this.tensorMap = new Map();
        (0, $8c449c89295c3cc4$export$fae3166c418e0471)(this.handle);
    }
    /**
     * Dispose the tensors and handle and clear the hashtable.
     */ clearAndClose() {
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        this.handle.dispose();
    }
    /**
     * The number of items in the hash table.
     */ size() {
        return this.tensorMap.size;
    }
    /**
     * The number of items in the hash table as a rank-0 tensor.
     */ tensorSize() {
        return $2937f01f2600aea0$export$7de3fcd3cdba2a46(this.size(), 'int32');
    }
    /**
     * Replaces the contents of the table with the specified keys and values.
     * @param keys Keys to store in the hashtable.
     * @param values Values to store in the hashtable.
     */ async import(keys, values) {
        this.checkKeyAndValueTensor(keys, values);
        // We only store the primitive values of the keys, this allows lookup
        // to be O(1).
        const $keys = await keys.data();
        // Clear the hashTable before inserting new values.
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            const $values = (0, $c1775cdc84f05f72$export$3c05285afa115eec)(values);
            const keysLength = $keys.length;
            const valuesLength = $values.length;
            (0, $e10678764dab7ea0$exports).assert(keysLength === valuesLength, ()=>`The number of elements doesn't match, keys has ` + `${keysLength} elements, the values has ${valuesLength} ` + `elements.`);
            for(let i = 0; i < keysLength; i++){
                const key = $keys[i];
                const value = $values[i];
                (0, $8c449c89295c3cc4$export$fae3166c418e0471)(value);
                this.tensorMap.set(key, value);
            }
            return this.handle;
        });
    }
    /**
     * Looks up keys in a hash table, outputs the corresponding values.
     *
     * Performs batch lookups, for every element in the key tensor, `find`
     * stacks the corresponding value into the return tensor.
     *
     * If an element is not present in the table, the given `defaultValue` is
     * used.
     *
     * @param keys Keys to look up. Must have the same type as the keys of the
     *     table.
     * @param defaultValue The scalar `defaultValue` is the value output for keys
     *     not present in the table. It must also be of the same type as the
     *     table values.
     */ async find(keys, defaultValue) {
        this.checkKeyAndValueTensor(keys, defaultValue);
        const $keys = await keys.data();
        return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            const result = [];
            for(let i = 0; i < $keys.length; i++){
                const key = $keys[i];
                const value = this.findWithDefault(key, defaultValue);
                result.push(value);
            }
            return (0, $6437527469582bc5$export$a57ab32f40f83ea9)(result);
        });
    }
    // tslint:disable-next-line: no-any
    findWithDefault(key, defaultValue) {
        const result = this.tensorMap.get(key);
        return result != null ? result : defaultValue;
    }
    checkKeyAndValueTensor(key, value) {
        if (key.dtype !== this.keyDType) throw new Error(`Expect key dtype ${this.keyDType}, but got ` + `${key.dtype}`);
        if (value.dtype !== this.valueDType) throw new Error(`Expect value dtype ${this.valueDType}, but got ` + `${value.dtype}`);
    }
}



const $8d0c801a69328189$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager)=>{
    switch(node.op){
        case 'HashTable':
        case 'HashTableV2':
            {
                const existingTableHandle = resourceManager.getHashTableHandleByName(node.name);
                // Table is shared with initializer.
                if (existingTableHandle != null) return [
                    existingTableHandle
                ];
                else {
                    const keyDType = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keyDType', node, tensorMap, context);
                    const valueDType = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('valueDType', node, tensorMap, context);
                    const hashTable = new (0, $62036930e8dbd6ca$export$b3bcf29b77543c46)(keyDType, valueDType);
                    resourceManager.addHashTable(node.name, hashTable);
                    return [
                        hashTable.handle
                    ];
                }
            }
        case 'InitializeTable':
        case 'InitializeTableV2':
        case 'LookupTableImport':
        case 'LookupTableImportV2':
            {
                const handle = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keys', node, tensorMap, context);
                const values = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('values', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.import(keys, values)
                ];
            }
        case 'LookupTableFind':
        case 'LookupTableFindV2':
            {
                const handle = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keys', node, tensorMap, context);
                const defaultValue = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('defaultValue', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.find(keys, defaultValue)
                ];
            }
        case 'LookupTableSize':
        case 'LookupTableSizeV2':
            {
                const handle = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tableHandle', node, tensorMap, context, resourceManager);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    hashTable.tensorSize()
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $8d0c801a69328189$export$2c04807512a22510 = 'hash_table';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $a13e941b4812d120$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'ResizeBilinear':
            {
                const images = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('images', node, tensorMap, context);
                const size = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const alignCorners = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeBilinear(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'ResizeNearestNeighbor':
            {
                const images = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('images', node, tensorMap, context);
                const size = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const alignCorners = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeNearestNeighbor(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'CropAndResize':
            {
                const image = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('image', node, tensorMap, context);
                const boxes = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('boxes', node, tensorMap, context);
                const boxInd = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('boxInd', node, tensorMap, context);
                const cropSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('cropSize', node, tensorMap, context);
                const method = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('method', node, tensorMap, context);
                const extrapolationValue = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('extrapolationValue', node, tensorMap, context);
                return [
                    ops.image.cropAndResize(image, boxes, boxInd, cropSize, method, extrapolationValue)
                ];
            }
        case 'ImageProjectiveTransformV3':
            {
                const images = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('images', node, tensorMap, context);
                const transforms = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('transforms', node, tensorMap, context);
                const outputShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('outputShape', node, tensorMap, context);
                const fillValue = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('fillValue', node, tensorMap, context);
                const interpolation = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('interpolation', node, tensorMap, context);
                const fillMode = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('fillMode', node, tensorMap, context);
                return [
                    ops.image.transform(images, transforms, interpolation.toLowerCase(), fillMode.toLowerCase(), fillValue, outputShape)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $a13e941b4812d120$export$2c04807512a22510 = 'image';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $c6567984b1dc615f$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'Equal':
            return [
                ops.equal((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'NotEqual':
            return [
                ops.notEqual((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Greater':
            return [
                ops.greater((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'GreaterEqual':
            return [
                ops.greaterEqual((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Less':
            return [
                ops.less((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'LessEqual':
            return [
                ops.lessEqual((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'LogicalAnd':
            return [
                ops.logicalAnd((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'LogicalNot':
            return [
                ops.logicalNot((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context))
            ];
        case 'LogicalOr':
            return [
                ops.logicalOr((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'Select':
        case 'SelectV2':
            return [
                ops.where((0, $727b63cbe12c1384$export$390042a9afe1baa5)('condition', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        case 'BitwiseAnd':
            return [
                ops.bitwiseAnd((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c6567984b1dc615f$export$2c04807512a22510 = 'logical';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $5c035ed45fb383d4$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'BatchMatMul':
        case 'BatchMatMulV2':
        case 'MatMul':
            return [
                ops.matMul((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('transposeA', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('transposeB', node, tensorMap, context))
            ];
        case 'Einsum':
            return [
                ops.einsum((0, $727b63cbe12c1384$export$390042a9afe1baa5)('equation', node, tensorMap, context), ...(0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensors', node, tensorMap, context))
            ];
        case 'Transpose':
            return [
                ops.transpose((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('perm', node, tensorMap, context))
            ];
        case '_FusedMatMul':
            const [extraOp, activationFunc] = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('fusedOps', node, tensorMap, context);
            const isBiasAdd = extraOp === 'biasadd';
            const isPrelu = activationFunc === 'prelu';
            const numArgs = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('numArgs', node, tensorMap, context);
            const leakyreluAlpha = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('leakyreluAlpha', node, tensorMap, context);
            if (isBiasAdd) {
                if (isPrelu && numArgs !== 2) throw new Error("Fused MatMul with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
                if (!isPrelu && numArgs !== 1) throw new Error('Fused MatMul with BiasAdd must have one extra argument: bias.');
            }
            const [biasArg, preluArg] = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('args', node, tensorMap, context);
            return [
                ops.fused.matMul({
                    a: (0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context),
                    b: (0, $727b63cbe12c1384$export$390042a9afe1baa5)('b', node, tensorMap, context),
                    transposeA: (0, $727b63cbe12c1384$export$390042a9afe1baa5)('transposeA', node, tensorMap, context),
                    transposeB: (0, $727b63cbe12c1384$export$390042a9afe1baa5)('transposeB', node, tensorMap, context),
                    bias: biasArg,
                    activation: activationFunc,
                    preluActivationWeights: preluArg,
                    leakyreluAlpha: leakyreluAlpha
                })
            ];
        case 'MatrixBandPart':
            return [
                ops.linalg.bandPart((0, $727b63cbe12c1384$export$390042a9afe1baa5)('a', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('numLower', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('numUpper', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $5c035ed45fb383d4$export$2c04807512a22510 = 'matrices';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $6cf068095bcef4e0$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'EuclideanNorm':
            return [
                ops.euclideanNorm((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keepDims', node, tensorMap, context))
            ];
        case 'FusedBatchNorm':
        case 'FusedBatchNormV2':
            return [
                ops.batchNorm((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('mean', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('variance', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('offset', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('scale', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('epsilon', node, tensorMap, context))
            ];
        case 'FusedBatchNormV3':
            return [
                ops.batchNorm((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('mean', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('variance', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('offset', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('scale', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('epsilon', node, tensorMap, context))
            ];
        case 'LRN':
            return [
                ops.localResponseNormalization((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('radius', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('bias', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('alpha', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('beta', node, tensorMap, context))
            ];
        case 'Softmax':
            return [
                ops.softmax((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'LogSoftmax':
            return [
                ops.logSoftmax((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $6cf068095bcef4e0$export$2c04807512a22510 = 'normalization';


/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $89bc80e340dd8862$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'RaggedGather':
            {
                const { outputNestedSplits: outputNestedSplits, outputDenseValues: outputDenseValues } = ops.raggedGather((0, $727b63cbe12c1384$export$390042a9afe1baa5)('paramsNestedSplits', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('paramsDenseValues', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('outputRaggedRank', node, tensorMap, context));
                return outputNestedSplits.concat(outputDenseValues);
            }
        case 'RaggedRange':
            {
                const { rtNestedSplits: rtNestedSplits, rtDenseValues: rtDenseValues } = ops.raggedRange((0, $727b63cbe12c1384$export$390042a9afe1baa5)('starts', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('limits', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('splits', node, tensorMap, context));
                return [
                    rtNestedSplits,
                    rtDenseValues
                ];
            }
        case 'RaggedTensorToTensor':
            return [
                ops.raggedTensorToTensor((0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('values', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('defaultValue', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('rowPartitionTensors', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('rowPartitionTypes', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $89bc80e340dd8862$export$2c04807512a22510 = 'ragged';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $88625822056e3201$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'Max':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.max((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Mean':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.mean((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Min':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.min((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Sum':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.sum((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'All':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.all((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Any':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.any((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'ArgMax':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                return [
                    ops.argMax((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis)
                ];
            }
        case 'ArgMin':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                return [
                    ops.argMin((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Prod':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const keepDims = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('keepDims', node, tensorMap, context);
                return [
                    ops.prod((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Cumprod':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const exclusive = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('exclusive', node, tensorMap, context);
                const reverse = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('reverse', node, tensorMap, context);
                return [
                    ops.cumprod((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Cumsum':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const exclusive = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('exclusive', node, tensorMap, context);
                const reverse = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('reverse', node, tensorMap, context);
                return [
                    ops.cumsum((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Bincount':
            const x = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
            const weights = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('weights', node, tensorMap, context);
            const size = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('size', node, tensorMap, context);
            return [
                ops.bincount(x, weights, size)
            ];
        case 'DenseBincount':
            {
                const x = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const weights = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('weights', node, tensorMap, context);
                const size = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('size', node, tensorMap, context);
                const binaryOutput = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('binaryOutput', node, tensorMap, context);
                return [
                    ops.denseBincount(x, weights, size, binaryOutput)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $88625822056e3201$export$2c04807512a22510 = 'reduction';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 


const $6fdf345a87642b8d$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'ConcatV2':
        case 'Concat':
            {
                const n = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('n', node, tensorMap, context);
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                let inputs = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensors', node, tensorMap, context);
                inputs = inputs.slice(0, n);
                return [
                    ops.concat(inputs, axis)
                ];
            }
        case 'Gather':
            {
                const input = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const indices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), 0)
                ];
            }
        case 'GatherV2':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const batchDims = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('batchDims', node, tensorMap, context);
                const input = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const indices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), axis, batchDims)
                ];
            }
        case 'Reverse':
            {
                const dims = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dims', node, tensorMap, context);
                const axis = [];
                for(let i = 0; i < dims.length; i++)if (dims[i]) axis.push(i);
                const input = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'ReverseV2':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const input = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'Slice':
            {
                // tslint:disable-next-line:no-any
                const begin = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('begin', node, tensorMap, context);
                // tslint:disable-next-line:no-any
                const size = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('size', node, tensorMap, context);
                return [
                    ops.slice((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), begin, size)
                ];
            }
        case 'StridedSlice':
            {
                const begin = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('begin', node, tensorMap, context);
                const end = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('end', node, tensorMap, context);
                const strides = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('strides', node, tensorMap, context);
                const beginMask = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('beginMask', node, tensorMap, context);
                const endMask = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('endMask', node, tensorMap, context);
                const ellipsisMask = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('ellipsisMask', node, tensorMap, context);
                const newAxisMask = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('newAxisMask', node, tensorMap, context);
                const shrinkAxisMask = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('shrinkAxisMask', node, tensorMap, context);
                const tensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return [
                    ops.stridedSlice(tensor, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask)
                ];
            }
        case 'Pack':
            return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const tensors = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensors', node, tensorMap, context);
                // Reshape the tensors to the first tensor's shape if they don't
                // match.
                const shape = tensors[0].shape;
                const squeezedShape = ops.squeeze(tensors[0]).shape;
                const mapped = tensors.map((tensor)=>{
                    const sameShape = (0, $e10678764dab7ea0$exports).arraysEqual(tensor.shape, shape);
                    if (!sameShape && !(0, $e10678764dab7ea0$exports).arraysEqual(ops.squeeze(tensor).shape, squeezedShape)) throw new Error('the input tensors shape does not match');
                    return sameShape ? tensor : ops.reshape(tensor, shape);
                });
                return [
                    ops.stack(mapped, axis)
                ];
            });
        case 'Unpack':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const tensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                return ops.unstack(tensor, axis);
            }
        case 'Tile':
            {
                const reps = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('reps', node, tensorMap, context);
                return [
                    ops.tile((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), reps)
                ];
            }
        case 'Split':
        case 'SplitV':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                const numOrSizeSplits = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('numOrSizeSplits', node, tensorMap, context);
                const tensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                return ops.split(tensor, numOrSizeSplits, axis);
            }
        case 'ScatterNd':
            {
                const indices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const values = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('values', node, tensorMap, context);
                const shape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context);
                return [
                    ops.scatterND(indices, values, shape)
                ];
            }
        case 'GatherNd':
            {
                const x = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context);
                const indices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                return [
                    ops.gatherND(x, indices)
                ];
            }
        case 'SparseToDense':
            {
                const indices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('sparseIndices', node, tensorMap, context);
                const shape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('outputShape', node, tensorMap, context);
                const sparseValues = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('sparseValues', node, tensorMap, context);
                const defaultValue = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('defaultValue', node, tensorMap, context);
                return [
                    ops.sparseToDense(indices, sparseValues, shape, sparseValues.dtype === defaultValue.dtype ? defaultValue : ops.cast(defaultValue, sparseValues.dtype))
                ];
            }
        case 'TensorScatterUpdate':
            {
                const indices = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context);
                const values = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('values', node, tensorMap, context);
                const tensor = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('tensor', node, tensorMap, context);
                return [
                    ops.tensorScatterUpdate(tensor, indices, values)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $6fdf345a87642b8d$export$2c04807512a22510 = 'slice_join';


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $27bcb23aad64f19e$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'SparseFillEmptyRows':
            {
                const { outputIndices: outputIndices, outputValues: outputValues, emptyRowIndicator: emptyRowIndicator, reverseIndexMap: reverseIndexMap } = ops.sparse.sparseFillEmptyRows((0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('values', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('denseShape', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('defaultValue', node, tensorMap, context));
                return [
                    outputIndices,
                    outputValues,
                    emptyRowIndicator,
                    reverseIndexMap
                ];
            }
        case 'SparseReshape':
            {
                const { outputIndices: outputIndices, outputShape: outputShape } = ops.sparse.sparseReshape((0, $727b63cbe12c1384$export$390042a9afe1baa5)('inputIndices', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('inputShape', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('newShape', node, tensorMap, context));
                return [
                    outputIndices,
                    outputShape
                ];
            }
        case 'SparseSegmentMean':
            {
                const outputData = ops.sparse.sparseSegmentMean((0, $727b63cbe12c1384$export$390042a9afe1baa5)('data', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        case 'SparseSegmentSum':
            {
                const outputData = ops.sparse.sparseSegmentSum((0, $727b63cbe12c1384$export$390042a9afe1baa5)('data', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('indices', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $27bcb23aad64f19e$export$2c04807512a22510 = 'sparse';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $5ba7eca525afd1a8$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'FFT':
            return [
                ops.fft((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'IFFT':
            return [
                ops.ifft((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'RFFT':
            return [
                ops.rfft((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        case 'IRFFT':
            return [
                ops.irfft((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $5ba7eca525afd1a8$export$2c04807512a22510 = 'spectral';


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $de37c451bea39463$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'StaticRegexReplace':
            return [
                ops.string.staticRegexReplace((0, $727b63cbe12c1384$export$390042a9afe1baa5)('input', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('pattern', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('rewrite', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('replaceGlobal', node, tensorMap, context))
            ];
        case 'StringNGrams':
            {
                const { nGrams: nGrams, nGramsSplits: nGramsSplits } = ops.string.stringNGrams((0, $727b63cbe12c1384$export$390042a9afe1baa5)('data', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dataSplits', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('separator', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('nGramWidths', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('leftPad', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('rightPad', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('padWidth', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('preserveShortSequences', node, tensorMap, context));
                return [
                    nGrams,
                    nGramsSplits
                ];
            }
        case 'StringSplit':
            {
                const { indices: indices, values: values, shape: shape } = ops.string.stringSplit((0, $727b63cbe12c1384$export$390042a9afe1baa5)('input', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('delimiter', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('skipEmpty', node, tensorMap, context));
                return [
                    indices,
                    values,
                    shape
                ];
            }
        case 'StringToHashBucketFast':
            {
                const output = ops.string.stringToHashBucketFast((0, $727b63cbe12c1384$export$390042a9afe1baa5)('input', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('numBuckets', node, tensorMap, context));
                return [
                    output
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $de37c451bea39463$export$2c04807512a22510 = 'string';


/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist


const $96f65b1bb42dfff1$export$7be88578e558e499 = (node, tensorMap, context, ops = $c795cbee2e7509f4$exports)=>{
    switch(node.op){
        case 'Cast':
            return [
                ops.cast((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dtype', node, tensorMap, context))
            ];
        case 'ExpandDims':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                return [
                    ops.expandDims((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Squeeze':
            {
                const axis = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('axis', node, tensorMap, context);
                return [
                    ops.squeeze((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Reshape':
            return [
                ops.reshape((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context))
            ];
        case 'EnsureShape':
            return [
                ops.ensureShape((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context))
            ];
        case 'MirrorPad':
            return [
                ops.mirrorPad((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('padding', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('mode', node, tensorMap, context))
            ];
        case 'PadV2':
        case 'Pad':
            return [
                ops.pad((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('padding', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('constantValue', node, tensorMap, context))
            ];
        case 'SpaceToBatchND':
            {
                const blockShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('blockShape', node, tensorMap, context);
                const paddings = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('paddings', node, tensorMap, context);
                return [
                    ops.spaceToBatchND((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), blockShape, paddings)
                ];
            }
        case 'BatchToSpaceND':
            {
                const blockShape = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('blockShape', node, tensorMap, context);
                const crops = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('crops', node, tensorMap, context);
                return [
                    ops.batchToSpaceND((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), blockShape, crops)
                ];
            }
        case 'DepthToSpace':
            {
                const blockSize = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('blockSize', node, tensorMap, context);
                const dataFormat = (0, $727b63cbe12c1384$export$390042a9afe1baa5)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthToSpace((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), blockSize, dataFormat)
                ];
            }
        case 'BroadcastTo':
            return [
                ops.broadcastTo((0, $727b63cbe12c1384$export$390042a9afe1baa5)('x', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('shape', node, tensorMap, context))
            ];
        case 'BroadcastArgs':
            return [
                ops.broadcastArgs((0, $727b63cbe12c1384$export$390042a9afe1baa5)('s0', node, tensorMap, context), (0, $727b63cbe12c1384$export$390042a9afe1baa5)('s1', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $96f65b1bb42dfff1$export$2c04807512a22510 = 'transformation';


function $0be46d614b171346$export$7be88578e558e499(node, tensorMap, context, resourceManager, tidy = $8c449c89295c3cc4$export$b841c6a213a653eb) {
    const value = ((node, tensorMap, context)=>{
        switch(node.category){
            case 'arithmetic':
                return tidy(()=>$96d33391e4514d4b$export$7be88578e558e499(node, tensorMap, context));
            case 'basic_math':
                return tidy(()=>$30db9efeda54c353$export$7be88578e558e499(node, tensorMap, context));
            case 'control':
                return $8c83a74940ef156e$export$7be88578e558e499(node, tensorMap, context);
            case 'convolution':
                return tidy(()=>$c4b7115ed5899ad3$export$7be88578e558e499(node, tensorMap, context));
            case 'creation':
                return tidy(()=>$2d6eacb28dd145d3$export$7be88578e558e499(node, tensorMap, context));
            case 'dynamic':
                return $8be045277287a719$export$7be88578e558e499(node, tensorMap, context);
            case 'evaluation':
                return tidy(()=>$c41b514af3513033$export$7be88578e558e499(node, tensorMap, context));
            case 'image':
                return tidy(()=>$a13e941b4812d120$export$7be88578e558e499(node, tensorMap, context));
            case 'graph':
                return tidy(()=>$f8f1ac7b25597c83$export$7be88578e558e499(node, tensorMap, context));
            case 'logical':
                return tidy(()=>$c6567984b1dc615f$export$7be88578e558e499(node, tensorMap, context));
            case 'matrices':
                return tidy(()=>$5c035ed45fb383d4$export$7be88578e558e499(node, tensorMap, context));
            case 'normalization':
                return tidy(()=>$6cf068095bcef4e0$export$7be88578e558e499(node, tensorMap, context));
            case 'ragged':
                return tidy(()=>$89bc80e340dd8862$export$7be88578e558e499(node, tensorMap, context));
            case 'reduction':
                return tidy(()=>$88625822056e3201$export$7be88578e558e499(node, tensorMap, context));
            case 'slice_join':
                return tidy(()=>$6fdf345a87642b8d$export$7be88578e558e499(node, tensorMap, context));
            case 'sparse':
                return tidy(()=>$27bcb23aad64f19e$export$7be88578e558e499(node, tensorMap, context));
            case 'spectral':
                return tidy(()=>$5ba7eca525afd1a8$export$7be88578e558e499(node, tensorMap, context));
            case 'string':
                return tidy(()=>$de37c451bea39463$export$7be88578e558e499(node, tensorMap, context));
            case 'transformation':
                return tidy(()=>$96f65b1bb42dfff1$export$7be88578e558e499(node, tensorMap, context));
            case 'hash_table':
                return $8d0c801a69328189$export$7be88578e558e499(node, tensorMap, context, resourceManager);
            case 'custom':
                const opMapper = (0, $a25ca992a33088d7$export$ad480e5d0b303fdc)(node.op);
                if (opMapper && opMapper.customExecutor) return opMapper.customExecutor(new (0, $13336795b5ffd0da$export$2964c493e854c8ad)(node, tensorMap, context));
                else throw TypeError(`Custom op ${node.op} is not registered.`);
            default:
                throw TypeError(`Unknown op '${node.op}'. File an issue at ` + `https://github.com/tensorflow/tfjs/issues so we can add it` + `, or register a custom execution with tf.registerOp()`);
        }
    })(node, tensorMap, context);
    if ($e10678764dab7ea0$exports.isPromise(value)) return value.then((data)=>[].concat(data));
    return [].concat(value);
}


/**
 * ExecutionContext captures the runtime environment of the node. It keeps
 * track of the current frame and iteration for the control flow ops.
 *
 * For example, typical Dynamic RNN model may contain loops, for which
 * TensorFlow will generate graphs with Enter/Exit nodes to control the
 * current execution frame, and NextIteration Nodes for iteration id increment.
 * For model with branch logic, TensorFLow will generate Switch/Merge ops.
 */ class $cbd876c4994cdbd2$export$f7c638676c8af91d {
    constructor(weightMap = {}, tensorArrayMap = {}, tensorListMap = {}, functionMap = {}, parseNodeNameCache){
        this.weightMap = weightMap;
        this.tensorArrayMap = tensorArrayMap;
        this.tensorListMap = tensorListMap;
        this.functionMap = functionMap;
        this.parseNodeNameCache = parseNodeNameCache;
        this.rootContext = {
            id: 0,
            frameName: '',
            iterationId: 0
        };
        this.contexts = [
            this.rootContext
        ];
        this.lastId = 0;
        this.generateCurrentContextIds();
    }
    newFrame(id, frameName) {
        return {
            id: id,
            frameName: frameName,
            iterationId: 0
        };
    }
    /**
     * Set the current context
     * @param contexts: ExecutionContextInfo[] the current path of execution
     * frames
     */ set currentContext(contexts) {
        if (this.contexts !== contexts) {
            this.contexts = contexts;
            this.generateCurrentContextIds();
        }
    }
    get currentContext() {
        return this.contexts;
    }
    /**
     * Returns the current context in string format.
     */ get currentContextId() {
        return this._currentContextIds[0];
    }
    /**
     * Returns the current context and all parent contexts in string format.
     * This allow access to the nodes in the current and parent frames.
     */ get currentContextIds() {
        return this._currentContextIds;
    }
    generateCurrentContextIds() {
        const names = [];
        for(let i = 0; i < this.contexts.length - 1; i++){
            const contexts = this.contexts.slice(0, this.contexts.length - i);
            names.push(this.contextIdforContexts(contexts));
        }
        names.push('');
        this._currentContextIds = names;
    }
    contextIdforContexts(contexts) {
        return contexts ? contexts.map((context)=>context.id === 0 && context.iterationId === 0 ? '' : `${context.frameName}-${context.iterationId}`).join('/') : '';
    }
    /**
     * Enter a new frame, a new context is pushed on the current context list.
     * @param frameId new frame id
     */ enterFrame(frameId) {
        if (this.contexts) {
            this.lastId++;
            this.contexts = this.contexts.slice();
            this.contexts.push(this.newFrame(this.lastId, frameId));
            this._currentContextIds.unshift(this.contextIdforContexts(this.contexts));
        }
    }
    /**
     * Exit the current frame, the last context is removed from the current
     * context list.
     */ exitFrame() {
        if (this.contexts && this.contexts.length > 1) {
            this.contexts = this.contexts.slice();
            this.contexts.splice(-1);
            this.currentContextIds.shift();
        } else throw new Error('Cannot exit frame, the context is empty');
    }
    /**
     * Enter the next iteration of a loop, the iteration id of last context is
     * increased.
     */ nextIteration() {
        if (this.contexts && this.contexts.length > 0) {
            this.contexts = this.contexts.slice();
            this.lastId++;
            const context = Object.assign({}, this.contexts[this.contexts.length - 1]);
            context.iterationId += 1;
            context.id = this.lastId;
            this.contexts.splice(-1, 1, context);
            this._currentContextIds.splice(0, 1, this.contextIdforContexts(this.contexts));
        } else throw new Error('Cannot increase frame iteration, the context is empty');
    }
    getWeight(name) {
        return this.weightMap[name];
    }
    addTensorArray(tensorArray) {
        this.tensorArrayMap[tensorArray.id] = tensorArray;
    }
    getTensorArray(id) {
        return this.tensorArrayMap[id];
    }
    addTensorList(tensorList) {
        this.tensorListMap[tensorList.id] = tensorList;
    }
    getTensorList(id) {
        return this.tensorListMap[id];
    }
    dispose(keepIds) {
        for(const key in this.tensorArrayMap)this.tensorArrayMap[key].clearAndClose(keepIds);
        for(const key in this.tensorListMap)this.tensorListMap[key].clearAndClose(keepIds);
    }
}


/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
function $762f89dd007c9432$export$73c2416e6ab509c5(inputs, outputs, weightMap, initNodes) {
    const usedNodes = new Set();
    const missingInputs = [];
    let dynamicNode = null;
    let syncInputs = null;
    // Start with the outputs, going backwards and find all the nodes that are
    // needed to compute those outputs.
    const seen = new Set();
    const inputNodeNames = new Set(Object.keys(inputs).map((name)=>(0, $727b63cbe12c1384$export$67aec20b8c372baf)(name)[0]));
    initNodes = initNodes || [];
    const initNodeNames = new Set(initNodes.map((node)=>(0, $727b63cbe12c1384$export$67aec20b8c372baf)(node.name)[0]));
    const frontier = [
        ...outputs
    ];
    while(frontier.length > 0){
        const node = frontier.pop();
        if ($762f89dd007c9432$export$683ae22d42a16fd1(node) || $762f89dd007c9432$export$eee9c104bd05368d(node) || $762f89dd007c9432$export$ad7e54a7e645a447(node)) {
            if (dynamicNode == null) {
                dynamicNode = node;
                syncInputs = dynamicNode.children.map((child)=>child.name).filter((name)=>usedNodes.has(name));
            }
        }
        usedNodes.add(node.name);
        // Weights are dead end since we already have their values.
        if (weightMap[node.name] != null) continue;
        // This node is a dead end since it's one of the user-provided inputs.
        if (inputNodeNames.has(node.name)) continue;
        // This node is a dead end since it doesn't have any inputs.
        if (initNodeNames.has(node.name)) continue;
        if (node.inputs.length === 0) {
            missingInputs.push(node.name);
            continue;
        }
        node.inputs.forEach((input)=>{
            // Don't add to the frontier if it is already there.
            if (seen.has(input.name)) return;
            seen.add(input.name);
            frontier.push(input);
        });
    }
    return {
        inputs: inputs,
        outputs: outputs,
        usedNodes: usedNodes,
        missingInputs: missingInputs,
        dynamicNode: dynamicNode,
        syncInputs: syncInputs
    };
}
function $762f89dd007c9432$export$66747854b63761e1(graph, executionInfo) {
    const { usedNodes: usedNodes, inputs: inputs } = executionInfo;
    const inputNodes = Object.keys(inputs).map((name)=>(0, $727b63cbe12c1384$export$67aec20b8c372baf)(name)[0]).map((name)=>graph.nodes[name]);
    const initNodes = graph.initNodes || [];
    const isUsed = (node)=>usedNodes.has(typeof node === 'string' ? node : node.name);
    function unique(nodes) {
        return [
            ...new Map(nodes.map((node)=>[
                    node.name,
                    node
                ])).values()
        ];
    }
    const predefinedNodes = unique([
        ...inputNodes,
        ...graph.weights,
        ...initNodes
    ]).filter(isUsed);
    const allNodes = unique([
        ...predefinedNodes,
        ...Object.values(graph.nodes)
    ]).filter(isUsed);
    const nameToNode = new Map(allNodes.map((node)=>[
            node.name,
            node
        ]));
    const inCounts = {};
    for (const node of allNodes){
        inCounts[node.name] = inCounts[node.name] || 0;
        for (const child of node.children){
            // When the child is unused, set in counts to infinity so that it will
            // never be decreased to 0 and added to the execution list.
            if (!isUsed(child)) inCounts[child.name] = Number.POSITIVE_INFINITY;
            inCounts[child.name] = (inCounts[child.name] || 0) + 1;
        }
    }
    // Build execution order for all used nodes regardless whether they are
    // predefined or not.
    const frontier = Object.entries(inCounts).filter(([, inCount])=>inCount === 0).map(([name])=>name);
    const orderedNodeNames = [
        ...frontier
    ];
    while(frontier.length > 0){
        const nodeName = frontier.pop();
        const node = nameToNode.get(nodeName);
        for (const child of node.children.filter(isUsed))if (--inCounts[child.name] === 0) {
            orderedNodeNames.push(child.name);
            frontier.push(child.name);
        }
    }
    const orderedNodes = orderedNodeNames.map((name)=>nameToNode.get(name));
    const filteredOrderedNodes = $762f89dd007c9432$var$filterPredefinedReachableNodes(orderedNodes, predefinedNodes);
    // TODO: Turn validation on/off with tf env flag.
    $762f89dd007c9432$var$validateNodesExecutionOrder(filteredOrderedNodes, predefinedNodes);
    return filteredOrderedNodes;
}
/**
 * This is a helper function of `getNodesInTopologicalOrder`.
 * Returns ordered nodes reachable by at least one predefined node.
 * This can help us filter out redundant nodes from the returned node list.
 * For example:
 * If we have four nodes with dependencies like this:
 *   a --> b --> c --> d
 * when node `c` is predefined (e.g. given as an input tensor), we can
 * skip node `a` and `b` since their outputs will never be used.
 *
 * @param orderedNodes Graph nodes in execution order.
 * @param predefinedNodes Graph inputs, weights, and init nodes. Nodes in this
 *     list must have distinct names.
 */ function $762f89dd007c9432$var$filterPredefinedReachableNodes(orderedNodes, predefinedNodes) {
    const nameToNode = new Map(orderedNodes.map((node)=>[
            node.name,
            node
        ]));
    // TODO: Filter out more nodes when >=2 nodes are predefined in a path.
    const stack = predefinedNodes.map((node)=>node.name);
    const predefinedReachableNodeNames = new Set(stack);
    // Perform a DFS starting from the set of all predefined nodes
    // to find the set of all nodes reachable from the predefined nodes.
    while(stack.length > 0){
        const nodeName = stack.pop();
        const node = nameToNode.get(nodeName);
        for (const child of node.children){
            if (!nameToNode.has(child.name) || predefinedReachableNodeNames.has(child.name)) continue;
            predefinedReachableNodeNames.add(child.name);
            stack.push(child.name);
        }
    }
    // Filter out unreachable nodes and build the ordered node list.
    const filteredOrderedNodes = orderedNodes.filter((node)=>predefinedReachableNodeNames.has(node.name));
    return filteredOrderedNodes;
}
class $762f89dd007c9432$var$NodesExecutionOrderError extends Error {
    constructor(message){
        super(`NodesExecutionOrderError: ${message}`);
    }
}
/**
 * This is a helper function of `getNodesInTopologicalOrder`.
 * Validates property: given nodes `a` and `b`, Order(a) > Order(b) if `a`
 * is a child of `b`. This function throws an error if validation fails.
 *
 * @param orderedNodes Graph nodes in execution order.
 * @param predefinedNodes Graph inputs, weights, and init nodes. Nodes in this
 *     list must have distinct names.
 */ function $762f89dd007c9432$var$validateNodesExecutionOrder(orderedNodes, predefinedNodes) {
    const nodeNameToOrder = new Map(orderedNodes.map((node, order)=>[
            node.name,
            order
        ]));
    const predefinedNodeNames = new Set(predefinedNodes.map((node)=>node.name));
    const isPredefined = (node)=>predefinedNodeNames.has(typeof node === 'string' ? node : node.name);
    const willBeExecutedNodeNames = new Set(orderedNodes.map((node)=>node.name));
    const willBeExecuted = (node)=>willBeExecutedNodeNames.has(typeof node === 'string' ? node : node.name);
    for (const node of orderedNodes){
        for (const child of node.children.filter(willBeExecuted)){
            if (!nodeNameToOrder.has(child.name)) throw new $762f89dd007c9432$var$NodesExecutionOrderError(`Child ${child.name} of node ${node.name} is unreachable.`);
            if (nodeNameToOrder.get(node.name) > nodeNameToOrder.get(child.name)) throw new $762f89dd007c9432$var$NodesExecutionOrderError(`Node ${node.name} is scheduled to run after its child ${child.name}.`);
        }
        if (!isPredefined(node)) for (const input of node.inputs){
            if (!nodeNameToOrder.has(input.name)) throw new $762f89dd007c9432$var$NodesExecutionOrderError(`Input ${input.name} of node ${node.name} is unreachable.`);
            if (nodeNameToOrder.get(input.name) > nodeNameToOrder.get(node.name)) throw new $762f89dd007c9432$var$NodesExecutionOrderError(`Node ${node.name} is scheduled to run before its input ${input.name}.`);
        }
    }
}
function $762f89dd007c9432$export$1b4890839d1091f5(orderedNodes) {
    const nodeNameToOrder = new Map(orderedNodes.map((node, order)=>[
            node.name,
            order
        ]));
    const INF_LIFE = Number.MAX_SAFE_INTEGER;
    // Make control flow nodes (and consequently their direct parents)
    // live forever since they're tricky to track correctly.
    const selfLifespans = orderedNodes.map((node, nodeOrder)=>$762f89dd007c9432$export$683ae22d42a16fd1(node) ? INF_LIFE : nodeOrder);
    const getSelfLifeSpan = (node)=>{
        const selfLife = selfLifespans[nodeNameToOrder.get(node.name)];
        if (selfLife == null) // If nodeToOrder does not contain the node, it is unused or
        // unreachable in graph.
        return -1;
        return selfLife;
    };
    // `liveUntil[i]` points to the last node in the `orderedNodes` array that
    // may depend on tensors from node `i`. It indicates that all the
    // intermediate tensors from `orderedNodes[i]` should be disposed after
    // `orderedNodes[liveUntil[i]]` is executed.
    // A node lives long enough to pass on its tensors to its children.
    // It lives until at least `max(node's position, children's positions)`.
    const liveUntilOrders = orderedNodes.map((node, nodeOrder)=>{
        return node.children.map(getSelfLifeSpan).reduce((a, b)=>Math.max(a, b), selfLifespans[nodeOrder]);
    });
    // liveUntilMap:
    // - Key: Name of a node `x`
    // - Values: All nodes whose intermediate tensors should be disposed
    //           after `x` is executed.
    const liveUntilMap = new Map();
    for(let nodeOrder = 0; nodeOrder < orderedNodes.length; ++nodeOrder){
        const liveUntilOrder = liveUntilOrders[nodeOrder];
        if (liveUntilOrder === INF_LIFE) continue;
        const node = orderedNodes[nodeOrder];
        const liveUntilNode = orderedNodes[liveUntilOrder];
        if (!liveUntilMap.has(liveUntilNode.name)) liveUntilMap.set(liveUntilNode.name, []);
        liveUntilMap.get(liveUntilNode.name).push(node);
    }
    return liveUntilMap;
}
const $762f89dd007c9432$var$CONTROL_FLOW_OPS = new Set([
    'Switch',
    'Merge',
    'Enter',
    'Exit',
    'NextIteration',
    'StatelessIf',
    'StatelessWhile',
    'if',
    'While'
]);
const $762f89dd007c9432$var$DYNAMIC_SHAPE_OPS = new Set([
    'NonMaxSuppressionV2',
    'NonMaxSuppressionV3',
    'NonMaxSuppressionV5',
    'Where'
]);
const $762f89dd007c9432$var$HASH_TABLE_OPS = new Set([
    'HashTable',
    'HashTableV2',
    'LookupTableImport',
    'LookupTableImportV2',
    'LookupTableFind',
    'LookupTableFindV2',
    'LookupTableSize',
    'LookupTableSizeV2'
]);
function $762f89dd007c9432$export$683ae22d42a16fd1(node) {
    return $762f89dd007c9432$var$CONTROL_FLOW_OPS.has(node.op);
}
function $762f89dd007c9432$export$eee9c104bd05368d(node) {
    return $762f89dd007c9432$var$DYNAMIC_SHAPE_OPS.has(node.op);
}
function $762f89dd007c9432$export$ad7e54a7e645a447(node) {
    return $762f89dd007c9432$var$HASH_TABLE_OPS.has(node.op);
}


class $ae971a607c14eb85$export$289b3892ec35f79a {
    get weightIds() {
        return this.parent ? this.parent.weightIds : this._weightIds;
    }
    get functionExecutorMap() {
        return this.parent ? this.parent.functionExecutorMap : this._functionExecutorMap;
    }
    get weightMap() {
        return this.parent ? this.parent.weightMap : this._weightMap;
    }
    set weightMap(weightMap) {
        const weightIds = Object.keys(weightMap).map((key)=>weightMap[key].map((tensor)=>tensor.id));
        this._weightIds = [].concat(...weightIds);
        this._weightMap = weightMap;
    }
    /**
     * Set `ResourceManager` shared by executors of a model.
     * @param resourceManager: `ResourceManager` of the `GraphModel`.
     */ set resourceManager(resourceManager) {
        this._resourceManager = resourceManager;
    }
    get inputs() {
        return this._inputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get outputs() {
        return this._outputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get inputNodes() {
        return this._inputs.map((node)=>node.signatureKey || node.name);
    }
    get outputNodes() {
        return this._outputs.map((node)=>{
            const name = node.signatureKey || node.name;
            return node.defaultOutput ? `${name}:${node.defaultOutput}` : name;
        });
    }
    get functions() {
        return Object.keys(this._functions).reduce((map, key)=>{
            map[key] = this._functions[key].signature;
            return map;
        }, {});
    }
    /**
     *
     * @param graph Graph the model or function graph to be executed.
     * @param parent When building function exector you need to set the parent
     * executor. Since the weights and function executor maps are set at parant
     * level, that function executor can access the function maps and weight maps
     * through the parent.
     */ constructor(graph, parent){
        this.graph = graph;
        this.parent = parent;
        this.compiledMap = new Map();
        this.parseNodeNameCache = new Map();
        this._weightMap = {};
        this.SEPARATOR = ',';
        this._functions = {};
        this._functionExecutorMap = {};
        this.keepIntermediateTensors = false;
        this._outputs = graph.outputs;
        this._inputs = graph.inputs;
        this._initNodes = graph.initNodes;
        this._signature = graph.signature;
        this._functions = graph.functions;
        // create sub-graph executors
        if (graph.functions != null) Object.keys(graph.functions).forEach((name)=>{
            this._functionExecutorMap[name] = new $ae971a607c14eb85$export$289b3892ec35f79a(graph.functions[name], this);
        });
    }
    getCompilationKey(inputs, outputs) {
        const sortedInputs = inputs.map((node)=>node.name).sort();
        const sortedOutputs = outputs.map((node)=>node.name).sort();
        return sortedInputs.join(this.SEPARATOR) + '--' + sortedOutputs.join(this.SEPARATOR);
    }
    /**
     * Compiles the inference graph and returns the minimal set of nodes that are
     * required for execution, in the correct execution order.
     * @returns {Object} compilation The compile result.
     * @returns {Node[]} compilation.orderedNodes Nodes in the correct execution
     *     order.
     * @returns {Map<string, Node[]>} compilation.nodeLiveUntilMap A map from node
     *     to disposable nodes after its execution. That is, for a node `x`,
     *     `nodeLiveUntilMap[x]` indicates all nodes whose intermediate
     *     tensors should be disposed after `x` is executed.
     */ compile(inputs, outputs) {
        const executionInfo = (0, $762f89dd007c9432$export$73c2416e6ab509c5)(inputs, outputs, this.weightMap, this._initNodes);
        const { missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = executionInfo;
        if (dynamicNode != null) throw new Error(`This execution contains the node '${dynamicNode.name}', which has ` + `the dynamic op '${dynamicNode.op}'. Please use ` + `model.executeAsync() instead. Alternatively, to avoid the ` + `dynamic ops, specify the inputs [${syncInputs}]`);
        if (missingInputs.length > 0) {
            const outNames = outputs.map((n)=>n.name);
            const inNames = Object.keys(inputs);
            throw new Error(`Cannot compute the outputs [${outNames}] from the provided inputs ` + `[${inNames}]. Missing the following inputs: [${missingInputs}]`);
        }
        const orderedNodes = (0, $762f89dd007c9432$export$66747854b63761e1)(this.graph, executionInfo);
        const nodeLiveUntilMap = (0, $762f89dd007c9432$export$1b4890839d1091f5)(orderedNodes);
        return {
            orderedNodes: orderedNodes,
            nodeLiveUntilMap: nodeLiveUntilMap
        };
    }
    cloneAndKeepTensor(tensor) {
        if (tensor == null) return null;
        const clone = tensor.clone();
        // Keep the clone because`model.execute()` may be called within
        // a `tidy()`, but the user may inspect these tensors after the
        // tidy.
        (0, $8c449c89295c3cc4$export$fae3166c418e0471)(clone);
        return clone;
    }
    cloneTensorList(tensors) {
        if (!tensors) return null;
        const clonedTensor = tensors.map((tensor)=>{
            return this.cloneAndKeepTensor(tensor);
        });
        return clonedTensor;
    }
    cloneTensorMap(tensorsMap) {
        return Object.fromEntries(Object.entries(tensorsMap).map(([name, tensorsList])=>{
            return [
                name,
                this.cloneTensorList(tensorsList)
            ];
        }));
    }
    /**
     * Executes the inference for given input tensors.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model, if
     * no outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     */ execute(inputs, outputs) {
        // Dispose any tensors from a prior run to avoid leaking them.
        this.disposeIntermediateTensors();
        inputs = this.mapInputs(inputs);
        const names = Object.keys(inputs).sort();
        this.checkInputs(inputs);
        this.checkInputShapeAndType(inputs);
        outputs = this.mapOutputs(outputs);
        this.checkOutputs(outputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $727b63cbe12c1384$export$67aec20b8c372baf)(name)[0]]);
        const outputNodeNames = outputs.map((name)=>(0, $727b63cbe12c1384$export$67aec20b8c372baf)(name)[0]);
        const outputNodeNameSet = new Set(outputNodeNames);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const compilationKey = this.getCompilationKey(inputNodes, outputNodes);
        // Do nothing if the compiled graph cache contains the input.
        let compilation = this.compiledMap.get(compilationKey);
        if (compilation == null) {
            compilation = this.compile(inputs, outputNodes);
            this.compiledMap.set(compilationKey, compilation);
        }
        // Keep tensors if KEEP_INTERMEDIATE_TENSORS is on.
        try {
            this.keepIntermediateTensors = (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('KEEP_INTERMEDIATE_TENSORS');
        } catch (e) {
            this.keepIntermediateTensors = false;
            console.warn(e.message);
        }
        const tensorArrayMap = {};
        const tensorListMap = {};
        return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(()=>{
            const context = new (0, $cbd876c4994cdbd2$export$f7c638676c8af91d)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap, this.parseNodeNameCache);
            const tensorsMap = Object.assign({}, this.weightMap);
            if (this.keepIntermediateTensors) this.clonedTensorsMap = this.cloneTensorMap(this.weightMap);
            Object.keys(inputs).forEach((name)=>{
                const [nodeName, index] = (0, $727b63cbe12c1384$export$67aec20b8c372baf)(name, context);
                const tensors = [];
                tensors[index] = inputs[name];
                tensorsMap[nodeName] = tensors;
                if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(tensors);
            });
            const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
            const { orderedNodes: orderedNodes, nodeLiveUntilMap: nodeLiveUntilMap } = compilation;
            for (const node of orderedNodes){
                if (tensorsMap[node.name]) continue;
                const tensors = (0, $0be46d614b171346$export$7be88578e558e499)(node, tensorsMap, context, this._resourceManager);
                if ((0, $e10678764dab7ea0$exports).isPromise(tensors)) throw new Error(`The execution of the op '${node.op}' returned a promise. ` + `Please use model.executeAsync() instead.`);
                tensorsMap[node.name] = tensors;
                if (this.keepIntermediateTensors) this.clonedTensorsMap[node.name] = this.cloneTensorList(tensors);
                this.checkTensorForDisposalWithNodeLiveUntilInfo(node, tensorsMap, context, tensorsToKeep, outputNodeNameSet, nodeLiveUntilMap.get(node.name));
            }
            // dispose the context for the root executor
            if (this.parent == null) context.dispose(tensorsToKeep);
            return outputs.map((name)=>(0, $727b63cbe12c1384$export$c5e50df225428195)(name, tensorsMap, context));
        });
    }
    getFrozenTensorIds(tensorMap) {
        const ids = [].concat.apply([], Object.keys(tensorMap).map((key)=>tensorMap[key]).map((tensors)=>tensors.map((tensor)=>tensor.id)));
        return new Set(ids);
    }
    checkTensorForDisposal(nodeName, node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount) {
        // Skip output nodes and any control flow nodes, since its dependency is
        // tricky to track correctly.
        if ((0, $762f89dd007c9432$export$683ae22d42a16fd1)(node) || outputNodeNameSet.has(nodeName)) return;
        for (const tensor of tensorMap[nodeName]){
            if (tensor == null) continue;
            intermediateTensorConsumerCount[tensor.id] = (intermediateTensorConsumerCount[tensor.id] || 0) + node.children.length;
        }
        for (const input of node.inputs){
            // Skip any control flow nodes, since its dependency is tricky to track
            // correctly.
            if ((0, $762f89dd007c9432$export$683ae22d42a16fd1)(input)) continue;
            const tensors = (0, $727b63cbe12c1384$export$d8cd584ff358961a)(input.name, tensorMap, context);
            if (tensors == null) continue;
            for (const tensor of tensors){
                if (!tensor || tensor.kept || tensorsToKeep.has(tensor.id)) continue;
                // Only intermediate nodes' tensors have counts set, not marked as
                // kept, and not in `tensorsToKeep`.
                // Input and weight nodes' tensors should exist in `tensorsToKeep`.
                // Output and control flow nodes' tensors should never have count set.
                const count = intermediateTensorConsumerCount[tensor.id];
                if (count === 1) {
                    tensor.dispose();
                    delete intermediateTensorConsumerCount[tensor.id];
                } else if (count != null) intermediateTensorConsumerCount[tensor.id]--;
            }
        }
    }
    checkTensorForDisposalWithNodeLiveUntilInfo(node, tensorMap, context, tensorsToKeep, outputNodeNameSet, liveUntilNodes) {
        function isNonDisposableNode(node) {
            // Skip output nodes and any control flow nodes, since its dependency is
            // tricky to track correctly.
            return (0, $762f89dd007c9432$export$683ae22d42a16fd1)(node) || outputNodeNameSet.has(node.name);
        }
        if ((0, $762f89dd007c9432$export$683ae22d42a16fd1)(node) || liveUntilNodes == null) return;
        for (const nodeToDispose of liveUntilNodes){
            if (isNonDisposableNode(nodeToDispose)) continue;
            const tensors = (0, $727b63cbe12c1384$export$d8cd584ff358961a)(nodeToDispose.name, tensorMap, context);
            for (const tensor of tensors){
                if (!tensor || tensor.kept || tensorsToKeep.has(tensor.id)) continue;
                tensor.dispose();
            }
        }
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs output node name from the Tensorflow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     */ async executeAsync(inputs, outputs) {
        return this._executeAsync(inputs, outputs);
    }
    disposeIntermediateTensors() {
        if (!this.clonedTensorsMap) return;
        Object.values(this.clonedTensorsMap).forEach((tensorsList)=>{
            for (const tensor of tensorsList)if (tensor && !tensor.isDisposed) tensor.dispose();
        });
        this.clonedTensorsMap = null;
    }
    getIntermediateTensors() {
        return this.clonedTensorsMap;
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to
     * the outputs array.
     * @param isFunctionExecution Optional. Flag for executing a function.
     * @param tensorArrayMap Optional, global TensorArray map by id. Used for
     * function execution.
     * @param tensorArrayMap Optional global TensorList map by id. Used for
     * function execution.
     */ async _executeAsync(inputs, outputs, isFunctionExecution = false, tensorArrayMap = {}, tensorListMap = {}) {
        // Dispose any tensors from a prior run to avoid leaking them.
        this.disposeIntermediateTensors();
        if (!isFunctionExecution) {
            inputs = this.mapInputs(inputs);
            this.checkInputs(inputs);
            this.checkInputShapeAndType(inputs);
            outputs = this.mapOutputs(outputs);
            this.checkOutputs(outputs);
        }
        // Keep tensors if KEEP_INTERMEDIATE_TENSORS is on.
        try {
            this.keepIntermediateTensors = (0, $d3cf252ef4ef8e7f$export$a7b6bc01c63cdfc3)().getBool('KEEP_INTERMEDIATE_TENSORS');
        } catch (e) {
            this.keepIntermediateTensors = false;
            console.warn(e.message);
        }
        const context = new (0, $cbd876c4994cdbd2$export$f7c638676c8af91d)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap, this.parseNodeNameCache);
        if (this.keepIntermediateTensors) this.clonedTensorsMap = this.cloneTensorMap(this.weightMap);
        // Graph with control flow op requires runtime evaluation of the execution
        // order, while without control flow the execution order is pre-determined
        // in the compile method.
        const tensorsMap = await this.executeWithControlFlow(inputs, context, outputs, isFunctionExecution);
        const results = outputs.map((name)=>(0, $727b63cbe12c1384$export$c5e50df225428195)(name, tensorsMap, context));
        // dispose all the intermediate tensors
        const outputIds = results.map((t)=>t.id);
        const inputIds = Object.keys(inputs).map((name)=>inputs[name].id);
        const keepIds = new Set([
            ...outputIds,
            ...inputIds,
            ...this.weightIds
        ]);
        Object.values(tensorsMap).forEach((tensorsList)=>{
            tensorsList.forEach((tensor)=>{
                if (tensor && !tensor.isDisposed && !keepIds.has(tensor.id)) tensor.dispose();
            });
        });
        // dispose the context for the root executor
        if (this.parent == null) context.dispose(keepIds);
        return results;
    }
    async executeFunctionAsync(inputs, tensorArrayMap, tensorListMap) {
        const mappedInputs = inputs.reduce((map, tensor, index)=>{
            map[this.inputs[index].name] = tensor;
            return map;
        }, {});
        return this._executeAsync(mappedInputs, this.outputNodes, true, tensorArrayMap, tensorListMap);
    }
    /**
     * When there are control flow nodes in the graph, the graph execution use
     * ExecutionContext to keep track of the frames and loop iterators.
     * @param inputs placeholder tensors for the graph.
     * @param context the execution context object for current execution.
     * @param outputNames Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to
     * the outputs array.
     * @param isFunctionExecution Flag for executing a function.
     */ async executeWithControlFlow(inputs, context, outputNames, isFunctionExecution) {
        const names = Object.keys(inputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $727b63cbe12c1384$export$67aec20b8c372baf)(name)[0]]);
        const outputNodeNames = outputNames.map((name)=>(0, $727b63cbe12c1384$export$67aec20b8c372baf)(name)[0]);
        const outputNodeNameSet = new Set(outputNodeNames);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const { usedNodes: usedNodes, missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = (0, $762f89dd007c9432$export$73c2416e6ab509c5)(inputs, outputNodes, this.weightMap, this._initNodes);
        // First nodes to execute include inputNodes, weights, and initNodes.
        const stack = [
            ...inputNodes,
            ...this.graph.weights,
            ...this._initNodes || []
        ].map((node)=>{
            return {
                node: node,
                contexts: context.currentContext
            };
        });
        const tensorsMap = Object.assign({}, this.weightMap);
        Object.keys(inputs).forEach((name)=>{
            const [nodeName, index] = (0, $727b63cbe12c1384$export$67aec20b8c372baf)(name);
            const tensors = [];
            tensors[index] = inputs[name];
            tensorsMap[nodeName] = tensors;
        });
        const intermediateTensorConsumerCount = {};
        const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
        const added = {};
        while(stack.length > 0){
            const promises = this.processStack(inputNodes, stack, context, tensorsMap, added, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount, usedNodes);
            await Promise.all(promises);
        }
        if (dynamicNode == null && !isFunctionExecution) console.warn(`This model execution did not contain any nodes with control flow ` + `or dynamic output shapes. You can use model.execute() instead.`);
        const missingOutputs = outputNodes.filter((node)=>!(0, $762f89dd007c9432$export$683ae22d42a16fd1)(node) && !(0, $727b63cbe12c1384$export$c5e50df225428195)(node.name, tensorsMap, context)).map((node)=>node.name);
        if (missingOutputs.length > 0) {
            let alternativeMsg = '';
            if (dynamicNode != null) alternativeMsg = `Alternatively, to avoid the dynamic ops, use model.execute() ` + `and specify the inputs [${syncInputs}]`;
            throw new Error(`Cannot compute the outputs [${missingOutputs}] from the provided ` + `inputs [${names}]. Consider providing the following inputs: ` + `[${missingInputs}]. ${alternativeMsg}`);
        }
        return tensorsMap;
    }
    processStack(inputNodes, stack, context, tensorMap, added, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount, usedNodes) {
        const promises = [];
        while(stack.length > 0){
            const item = stack.pop();
            context.currentContext = item.contexts;
            let nodeName = '';
            // The tensor of the Enter op with isConstant set should be set
            // in the parent scope, so it will be available as constant for the
            // whole loop.
            if (item.node.op === 'Enter' && (0, $727b63cbe12c1384$export$390042a9afe1baa5)('isConstant', item.node, tensorMap, context)) [nodeName] = (0, $727b63cbe12c1384$export$6cbb65bf9e07a72)(item.node.name, context);
            // only process nodes that are not in the tensorMap yet, this include
            // inputNodes and internal initNodes.
            if (tensorMap[item.node.name] == null) {
                const tensors = (0, $0be46d614b171346$export$7be88578e558e499)(item.node, tensorMap, context, this._resourceManager);
                if (!nodeName) [nodeName] = (0, $727b63cbe12c1384$export$6cbb65bf9e07a72)(item.node.name, context);
                const currentContext = context.currentContext;
                if ((0, $e10678764dab7ea0$exports).isPromise(tensors)) promises.push(tensors.then((t)=>{
                    tensorMap[nodeName] = t;
                    if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(t);
                    context.currentContext = currentContext;
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                    return t;
                }));
                else {
                    tensorMap[nodeName] = tensors;
                    if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(tensors);
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                }
            } else this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
        }
        return promises;
    }
    processChildNodes(node, stack, context, tensorMap, added, usedNodes) {
        node.children.forEach((childNode)=>{
            const [nodeName] = (0, $727b63cbe12c1384$export$6cbb65bf9e07a72)(childNode.name, context);
            if (added[nodeName] || !usedNodes.has(childNode.name)) return;
            // Merge op can be pushed if any of its inputs has value.
            if (childNode.op === 'Merge') {
                if (childNode.inputNames.some((name)=>{
                    return !!(0, $727b63cbe12c1384$export$c5e50df225428195)(name, tensorMap, context);
                })) {
                    added[nodeName] = true;
                    stack.push({
                        contexts: context.currentContext,
                        node: childNode
                    });
                }
            } else if (childNode.inputNames.every((name)=>{
                return !!(0, $727b63cbe12c1384$export$c5e50df225428195)(name, tensorMap, context);
            })) {
                added[nodeName] = true;
                stack.push({
                    contexts: context.currentContext,
                    node: childNode
                });
            }
        });
    }
    /**
     * Releases the memory used by the weight tensors.
     */ dispose() {
        Object.keys(this.weightMap).forEach((key)=>this.weightMap[key].forEach((tensor)=>tensor.dispose()));
    }
    checkInputShapeAndType(inputs) {
        Object.keys(inputs).forEach((name)=>{
            const input = inputs[name];
            const [nodeName] = (0, $727b63cbe12c1384$export$67aec20b8c372baf)(name);
            const node = this.graph.nodes[nodeName];
            if (node.attrParams['shape'] && node.attrParams['shape'].value) {
                const shape = node.attrParams['shape'].value;
                const match = shape.length === input.shape.length && input.shape.every((dim, index)=>shape[index] === -1 || shape[index] === dim);
                (0, $e10678764dab7ea0$exports).assert(match, ()=>`The shape of dict['${node.name}'] provided in ` + `model.execute(dict) must be [${shape}], but was ` + `[${input.shape}]`);
            }
            if (node.attrParams['dtype'] && node.attrParams['dtype'].value) (0, $e10678764dab7ea0$exports).assert(input.dtype === node.attrParams['dtype'].value, ()=>`The dtype of dict['${node.name}'] provided in ` + `model.execute(dict) must be ` + `${node.attrParams['dtype'].value}, but was ${input.dtype}`);
        });
    }
    mapInputs(inputs) {
        var _a, _b;
        const result = {};
        for(const inputName in inputs){
            const tensor = (_b = (_a = this._signature) === null || _a === void 0 ? void 0 : _a.inputs) === null || _b === void 0 ? void 0 : _b[inputName];
            if (tensor != null) result[tensor.name] = inputs[inputName];
            else result[inputName] = inputs[inputName];
        }
        return result;
    }
    checkInputs(inputs) {
        const notInGraph = Object.keys(inputs).filter((name)=>{
            const [nodeName] = (0, $727b63cbe12c1384$export$67aec20b8c372baf)(name);
            return this.graph.nodes[nodeName] == null;
        });
        if (notInGraph.length > 0) throw new Error(`The dict provided in model.execute(dict) has ` + `keys: [${notInGraph}] that are not part of graph`);
    }
    mapOutputs(outputs) {
        return outputs.map((name)=>{
            var _a, _b;
            const tensor = (_b = (_a = this._signature) === null || _a === void 0 ? void 0 : _a.outputs) === null || _b === void 0 ? void 0 : _b[name];
            if (tensor != null) return tensor.name;
            return name;
        }, {});
    }
    checkOutputs(outputs) {
        outputs.forEach((name)=>{
            const [normalizedName] = (0, $727b63cbe12c1384$export$67aec20b8c372baf)(name);
            if (!this.graph.nodes[normalizedName]) throw new Error(`The output '${name}' is not found in the graph`);
        });
    }
}


/**
 * Contains global resources of a model.
 */ class $ee051708509f1ea6$export$60667f9de734e56 {
    constructor(hashTableNameToHandle = {}, hashTableMap = {}){
        this.hashTableNameToHandle = hashTableNameToHandle;
        this.hashTableMap = hashTableMap;
    }
    /**
     * Register a `HashTable` in the resource manager.
     *
     * The `HashTable` can be retrieved by `resourceManager.getHashTableById`,
     * where id is the table handle tensor's id.
     *
     * @param name Op node name that creates the `HashTable`.
     * @param hashTable The `HashTable` to be added to resource manager.
     */ addHashTable(name, hashTable) {
        this.hashTableNameToHandle[name] = hashTable.handle;
        this.hashTableMap[hashTable.id] = hashTable;
    }
    /**
     * Get the table handle by node name.
     * @param name Op node name that creates the `HashTable`. This name is also
     *     used in the inputs list of lookup and import `HashTable` ops.
     */ getHashTableHandleByName(name) {
        return this.hashTableNameToHandle[name];
    }
    /**
     * Get the actual `HashTable` by its handle tensor's id.
     * @param id The id of the handle tensor.
     */ getHashTableById(id) {
        return this.hashTableMap[id];
    }
    /**
     * Dispose `ResourceManager`, including its hashTables and tensors in them.
     */ dispose() {
        for(const key in this.hashTableMap){
            this.hashTableMap[key].clearAndClose();
            delete this.hashTableMap[key];
        }
        for(const name in this.hashTableNameToHandle){
            this.hashTableNameToHandle[name].dispose();
            delete this.hashTableNameToHandle[name];
        }
    }
}



const $8afdb9914f122011$export$a9bc79b23e178599 = '?tfjs-format=file';
const $8afdb9914f122011$export$9ffb2eac80132860 = 'model.json';
class $8afdb9914f122011$export$357a78c279dfa8cf {
    // Returns the version information for the tensorflow model GraphDef.
    get modelVersion() {
        return this.version;
    }
    get inputNodes() {
        return this.executor.inputNodes;
    }
    get outputNodes() {
        return this.executor.outputNodes;
    }
    get inputs() {
        return this.executor.inputs;
    }
    get outputs() {
        return this.executor.outputs;
    }
    get weights() {
        return this.executor.weightMap;
    }
    get metadata() {
        return this.artifacts.userDefinedMetadata;
    }
    get modelSignature() {
        return this.signature;
    }
    get modelStructuredOutputKeys() {
        return this.structuredOutputKeys;
    }
    /**
     * @param modelUrl url for the model, or an `io.IOHandler`.
     * @param weightManifestUrl url for the weight file generated by
     * scripts/convert.py script.
     * @param requestOption options for Request, which allows to send credentials
     * and custom headers.
     * @param onProgress Optional, progress callback function, fired periodically
     * before the load is completed.
     */ constructor(modelUrl, loadOptions = {}, tfio = (0, $707ce2a17ca1210d$exports)){
        this.modelUrl = modelUrl;
        this.loadOptions = loadOptions;
        this.version = 'n/a';
        this.io = tfio;
        if (loadOptions == null) this.loadOptions = {};
        this.resourceManager = new (0, $ee051708509f1ea6$export$60667f9de734e56)();
    }
    findIOHandler() {
        const path = this.modelUrl;
        if (path.load != null) // Path is an IO Handler.
        this.handler = path;
        else if (this.loadOptions.requestInit != null) this.handler = this.io.browserHTTPRequest(path, this.loadOptions);
        else {
            const handlers = this.io.getLoadHandlers(path, this.loadOptions);
            if (handlers.length === 0) // For backward compatibility: if no load handler can be found,
            // assume it is a relative http path.
            handlers.push(this.io.browserHTTPRequest(path, this.loadOptions));
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) load handlers for ` + `URL '${[
                path
            ]}'`);
            this.handler = handlers[0];
        }
    }
    /**
     * Loads the model and weight files, construct the in memory weight map and
     * compile the inference graph.
     */ load() {
        this.findIOHandler();
        if (this.handler.load == null) throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
        const loadResult = this.handler.load();
        if ((0, $e10678764dab7ea0$exports).isPromise(loadResult)) return loadResult.then((artifacts)=>{
            if (artifacts.getWeightStream == null) return this.loadSync(artifacts);
            return this.loadStreaming(artifacts);
        });
        return this.loadSync(loadResult);
    }
    /**
     * Synchronously construct the in memory weight map and
     * compile the inference graph.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ loadSync(artifacts) {
        const weightMap = this.io.decodeWeights(artifacts.weightData, artifacts.weightSpecs);
        return this.loadWithWeightMap(artifacts, weightMap);
    }
    async loadStreaming(artifacts) {
        if (artifacts.getWeightStream == null) throw new Error('Model artifacts missing streamWeights function');
        const weightMap = await (0, $3674b353dc6c3d42$export$6c19531ae9ba1204)(artifacts.getWeightStream(), artifacts.weightSpecs);
        return this.loadWithWeightMap(artifacts, weightMap);
    }
    loadWithWeightMap(artifacts, weightMap) {
        this.artifacts = artifacts;
        const graph = this.artifacts.modelTopology;
        let signature = this.artifacts.signature;
        if (this.artifacts.userDefinedMetadata != null) {
            const metadata = this.artifacts.userDefinedMetadata;
            if (metadata.signature != null) signature = metadata.signature;
            if (metadata.structuredOutputKeys != null) this.structuredOutputKeys = metadata.structuredOutputKeys;
        }
        this.signature = signature;
        this.version = `${graph.versions.producer}.${graph.versions.minConsumer}`;
        this.executor = new (0, $ae971a607c14eb85$export$289b3892ec35f79a)((0, $e7636b16c8ece759$export$712e670bcbcf1315).Instance.transformGraph(graph, this.signature));
        this.executor.weightMap = this.convertTensorMapToTensorsMap(weightMap);
        // Attach a model-level resourceManager to each executor to share resources,
        // such as `HashTable`.
        this.executor.resourceManager = this.resourceManager;
        if (artifacts.modelInitializer != null && artifacts.modelInitializer.node != null) {
            const initializer = (0, $e7636b16c8ece759$export$712e670bcbcf1315).Instance.transformGraph(artifacts.modelInitializer);
            this.initializer = new (0, $ae971a607c14eb85$export$289b3892ec35f79a)(initializer);
            this.initializer.weightMap = this.executor.weightMap;
            // Attach a model-level resourceManager to the initializer, the
            // hashTables created from when executing the initializer will be stored
            // in the resourceManager.
            this.initializer.resourceManager = this.resourceManager;
            this.initializerSignature = artifacts.initializerSignature;
        }
        return true;
    }
    /**
     * Save the configuration and/or weights of the GraphModel.
     *
     * An `IOHandler` is an object that has a `save` method of the proper
     * signature defined. The `save` method manages the storing or
     * transmission of serialized data ("artifacts") that represent the
     * model's topology and weights onto or via a specific medium, such as
     * file downloads, local storage, IndexedDB in the web browser and HTTP
     * requests to a server. TensorFlow.js provides `IOHandler`
     * implementations for a number of frequently used saving mediums, such as
     * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
     * for more details.
     *
     * This method also allows you to refer to certain types of `IOHandler`s
     * as URL-like string shortcuts, such as 'localstorage://' and
     * 'indexeddb://'.
     *
     * Example 1: Save `model`'s topology and weights to browser [local
     * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
     * then load it back.
     *
     * ```js
     * const modelUrl =
     *    'https://storage.googleapis.com/tfjs-models/savedmodel/mobilenet_v2_1.0_224/model.json';
     * const model = await tf.loadGraphModel(modelUrl);
     * const zeros = tf.zeros([1, 224, 224, 3]);
     * model.predict(zeros).print();
     *
     * const saveResults = await model.save('localstorage://my-model-1');
     *
     * const loadedModel = await tf.loadGraphModel('localstorage://my-model-1');
     * console.log('Prediction from loaded model:');
     * model.predict(zeros).print();
     * ```
     *
     * @param handlerOrURL An instance of `IOHandler` or a URL-like,
     * scheme-based string shortcut for `IOHandler`.
     * @param config Options for saving the model.
     * @returns A `Promise` of `SaveResult`, which summarizes the result of
     * the saving, such as byte sizes of the saved artifacts for the model's
     *   topology and weight values.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async save(handlerOrURL, config) {
        if (typeof handlerOrURL === 'string') {
            const handlers = this.io.getSaveHandlers(handlerOrURL);
            if (handlers.length === 0) throw new Error(`Cannot find any save handlers for URL '${handlerOrURL}'`);
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) save handlers for ` + `URL '${handlerOrURL}'`);
            handlerOrURL = handlers[0];
        }
        if (handlerOrURL.save == null) throw new Error("GraphModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        return handlerOrURL.save(this.artifacts);
    }
    addStructuredOutputNames(outputTensors) {
        if (this.structuredOutputKeys) {
            const outputTensorsArray = outputTensors instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? [
                outputTensors
            ] : outputTensors;
            const outputTensorMap = {};
            outputTensorsArray.forEach((outputTensor, i)=>outputTensorMap[this.structuredOutputKeys[i]] = outputTensor);
            return outputTensorMap;
        }
        return outputTensors;
    }
    /**
     * Execute the inference for the input tensors.
     *
     * @param input The input tensors, when there is single input for the model,
     * inputs param should be a `tf.Tensor`. For models with multiple inputs,
     * inputs params should be in either `tf.Tensor`[] if the input order is
     * fixed, or otherwise NamedTensorMap format.
     *
     * For model with multiple inputs, we recommend you use NamedTensorMap as the
     * input type, if you use `tf.Tensor`[], the order of the array needs to
     * follow the
     * order of inputNodes array. @see {@link GraphModel.inputNodes}
     *
     * You can also feed any intermediate nodes using the NamedTensorMap as the
     * input type. For example, given the graph
     *    InputNode => Intermediate => OutputNode,
     * you can execute the subgraph Intermediate => OutputNode by calling
     *    model.execute('IntermediateNode' : tf.tensor(...));
     *
     * This is useful for models that uses tf.dynamic_rnn, where the intermediate
     * state needs to be fed manually.
     *
     * For batch inference execution, the tensors for each input need to be
     * concatenated together. For example with mobilenet, the required input shape
     * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
     * If we are provide a batched data of 100 images, the input tensor should be
     * in the shape of [100, 244, 244, 3].
     *
     * @param config Prediction configuration for specifying the batch size.
     * Currently the batch size option is ignored for graph model.
     *
     * @returns Inference result tensors. If the model is converted and it
     * originally had structured_outputs in tensorflow, then a NamedTensorMap
     * will be returned matching the structured_outputs. If no structured_outputs
     * are present, the output will be single `tf.Tensor` if the model has single
     * output node, otherwise Tensor[].
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(inputs, config) {
        const outputTensors = this.execute(inputs, this.outputNodes);
        return this.addStructuredOutputNames(outputTensors);
    }
    /**
     * Execute the inference for the input tensors in async fashion, use this
     * method when your model contains control flow ops.
     *
     * @param input The input tensors, when there is single input for the model,
     * inputs param should be a `tf.Tensor`. For models with mutliple inputs,
     * inputs params should be in either `tf.Tensor`[] if the input order is
     * fixed, or otherwise NamedTensorMap format.
     *
     * For model with multiple inputs, we recommend you use NamedTensorMap as the
     * input type, if you use `tf.Tensor`[], the order of the array needs to
     * follow the
     * order of inputNodes array. @see {@link GraphModel.inputNodes}
     *
     * You can also feed any intermediate nodes using the NamedTensorMap as the
     * input type. For example, given the graph
     *    InputNode => Intermediate => OutputNode,
     * you can execute the subgraph Intermediate => OutputNode by calling
     *    model.execute('IntermediateNode' : tf.tensor(...));
     *
     * This is useful for models that uses tf.dynamic_rnn, where the intermediate
     * state needs to be fed manually.
     *
     * For batch inference execution, the tensors for each input need to be
     * concatenated together. For example with mobilenet, the required input shape
     * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
     * If we are provide a batched data of 100 images, the input tensor should be
     * in the shape of [100, 244, 244, 3].
     *
     * @param config Prediction configuration for specifying the batch size.
     * Currently the batch size option is ignored for graph model.
     *
     * @returns A Promise of inference result tensors. If the model is converted
     * and it originally had structured_outputs in tensorflow, then a
     * NamedTensorMap will be returned matching the structured_outputs. If no
     * structured_outputs are present, the output will be single `tf.Tensor` if
     * the model has single output node, otherwise Tensor[].
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async predictAsync(inputs, config) {
        const outputTensors = await this.executeAsync(inputs, this.outputNodes);
        return this.addStructuredOutputNames(outputTensors);
    }
    normalizeInputs(inputs) {
        var _a;
        if (!(inputs instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814)) && !Array.isArray(inputs)) {
            // The input is already a NamedTensorMap.
            const signatureInputs = (_a = this.signature) === null || _a === void 0 ? void 0 : _a.inputs;
            if (signatureInputs != null) for(const input in signatureInputs){
                const tensor = signatureInputs[input];
                if (tensor.resourceId != null) inputs[input] = this.resourceIdToCapturedInput[tensor.resourceId];
            }
            return inputs;
        }
        inputs = Array.isArray(inputs) ? inputs : [
            inputs
        ];
        const numCapturedInputs = Object.keys(this.resourceIdToCapturedInput).length;
        if (inputs.length + numCapturedInputs !== this.inputNodes.length) throw new Error(`Input tensor count mismatch, the graph model has ${this.inputNodes.length - numCapturedInputs} non-resource placeholders, while there are ${inputs.length} input tensors provided.`);
        let inputIndex = 0;
        return this.inputNodes.reduce((map, inputName)=>{
            var _a, _b, _c;
            const resourceId = (_c = (_b = (_a = this.signature) === null || _a === void 0 ? void 0 : _a.inputs) === null || _b === void 0 ? void 0 : _b[inputName]) === null || _c === void 0 ? void 0 : _c.resourceId;
            if (resourceId != null) map[inputName] = this.resourceIdToCapturedInput[resourceId];
            else map[inputName] = inputs[inputIndex++];
            return map;
        }, {});
    }
    normalizeOutputs(outputs) {
        outputs = outputs || this.outputNodes;
        return !Array.isArray(outputs) ? [
            outputs
        ] : outputs;
    }
    executeInitializerGraph() {
        if (this.initializer == null) return [];
        if (this.initializerSignature == null) return this.initializer.execute({}, []);
        else return this.initializer.execute({}, Object.keys(this.initializerSignature.outputs));
    }
    async executeInitializerGraphAsync() {
        if (this.initializer == null) return [];
        if (this.initializerSignature == null) return this.initializer.executeAsync({}, []);
        else return this.initializer.executeAsync({}, Object.keys(this.initializerSignature.outputs));
    }
    setResourceIdToCapturedInput(outputs) {
        this.resourceIdToCapturedInput = {};
        if (this.initializerSignature) {
            const signatureOutputs = this.initializerSignature.outputs;
            const outputNames = Object.keys(signatureOutputs);
            for(let i = 0; i < outputNames.length; i++){
                const outputName = outputNames[i];
                const tensorInfo = signatureOutputs[outputName];
                this.resourceIdToCapturedInput[tensorInfo.resourceId] = outputs[i];
            }
        }
    }
    /**
     * Executes inference for the model for given input tensors.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no
     * outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     *
     * @returns A single tensor if provided with a single output or no outputs
     * are provided and there is only one default output, otherwise return a
     * tensor array. The order of the tensor array is the same as the outputs
     * if provided, otherwise the order of outputNodes attribute of the model.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ execute(inputs, outputs) {
        if (this.resourceIdToCapturedInput == null) this.setResourceIdToCapturedInput(this.executeInitializerGraph());
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = this.executor.execute(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Executes inference for the model for given input tensors in async
     * fashion, use this method when your model contains control flow ops.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     *
     * @returns A Promise of single tensor if provided with a single output or
     * no outputs are provided and there is only one default output, otherwise
     * return a tensor map.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async executeAsync(inputs, outputs) {
        if (this.resourceIdToCapturedInput == null) this.setResourceIdToCapturedInput(await this.executeInitializerGraphAsync());
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = await this.executor.executeAsync(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Get intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ getIntermediateTensors() {
        return this.executor.getIntermediateTensors();
    }
    /**
     * Dispose intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ disposeIntermediateTensors() {
        this.executor.disposeIntermediateTensors();
    }
    convertTensorMapToTensorsMap(map) {
        return Object.keys(map).reduce((newMap, key)=>{
            newMap[key] = [
                map[key]
            ];
            return newMap;
        }, {});
    }
    /**
     * Releases the memory used by the weight tensors and resourceManager.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ dispose() {
        this.executor.dispose();
        if (this.initializer) {
            this.initializer.dispose();
            if (this.resourceIdToCapturedInput) (0, $8c449c89295c3cc4$export$fcfbbcec2cb820d5)(this.resourceIdToCapturedInput);
        }
        this.resourceManager.dispose();
    }
}
async function $8afdb9914f122011$export$f077572b5d896ffd(modelUrl, options = {}, tfio = (0, $707ce2a17ca1210d$exports)) {
    if (modelUrl == null) throw new Error("modelUrl in loadGraphModel() cannot be null. Please provide a url or an IOHandler that loads the model");
    if (options == null) options = {};
    if (options.fromTFHub && typeof modelUrl === 'string') modelUrl = $8afdb9914f122011$var$getTFHubUrl(modelUrl);
    const model = new $8afdb9914f122011$export$357a78c279dfa8cf(modelUrl, options, tfio);
    await model.load();
    return model;
}
function $8afdb9914f122011$export$64fa41ef6cfbfdd7(modelSource) {
    if (modelSource == null) throw new Error("modelUrl in loadGraphModelSync() cannot be null. Please provide model artifacts or an IOHandler that loads the model");
    let ioHandler;
    if (modelSource instanceof Array) {
        const [modelJSON, weights] = modelSource;
        if (!modelJSON) throw new Error('modelJSON must be the first element of the array');
        if (!weights || !(weights instanceof ArrayBuffer)) throw new Error("An ArrayBuffer of weights must be the second element of the array");
        if (!('modelTopology' in modelJSON)) throw new Error('Model JSON is missing \'modelTopology\'');
        if (!('weightsManifest' in modelJSON)) throw new Error('Model JSON is missing \'weightsManifest\'');
        const weightSpecs = (0, $707ce2a17ca1210d$exports).getWeightSpecs(modelJSON.weightsManifest);
        const modelArtifacts = (0, $707ce2a17ca1210d$exports).getModelArtifactsForJSONSync(modelJSON, weightSpecs, weights);
        ioHandler = (0, $707ce2a17ca1210d$exports).fromMemorySync(modelArtifacts);
    } else if ('load' in modelSource) // Then modelSource is already an IOHandlerSync.
    ioHandler = modelSource;
    else if ('modelTopology' in modelSource && 'weightSpecs' in modelSource && 'weightData' in modelSource) // modelSource is of type ModelArtifacts.
    ioHandler = (0, $707ce2a17ca1210d$exports).fromMemorySync(modelSource);
    else throw new Error('Unknown model format');
    const model = new $8afdb9914f122011$export$357a78c279dfa8cf(ioHandler);
    model.load();
    return model;
}
function $8afdb9914f122011$var$getTFHubUrl(modelUrl) {
    if (!modelUrl.endsWith('/')) modelUrl = modelUrl + '/';
    return `${modelUrl}${$8afdb9914f122011$export$9ffb2eac80132860}${$8afdb9914f122011$export$a9bc79b23e178599}`;
}



/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $15d517509cfbc24d$export$83d89fbfd8236492 = '4.22.0';




var $f5e8984c016ca24a$exports = {};
(function() {
    'use strict';
    var x;
    function aa(a) {
        var b = 0;
        return function() {
            return b < a.length ? {
                done: !1,
                value: a[b++]
            } : {
                done: !0
            };
        };
    }
    var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ca(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var y = ca(this);
    function z(a, b) {
        if (b) a: {
            var c = y;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && ba(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    z("Symbol", function(a) {
        function b(g) {
            if (this instanceof b) throw new TypeError("Symbol is not a constructor");
            return new c(d + (g || "") + "_" + e++, g);
        }
        function c(g, f) {
            this.h = g;
            ba(this, "description", {
                configurable: !0,
                writable: !0,
                value: f
            });
        }
        if (a) return a;
        c.prototype.toString = function() {
            return this.h;
        };
        var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
        return b;
    });
    z("Symbol.iterator", function(a) {
        if (a) return a;
        a = Symbol("Symbol.iterator");
        for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
            var d = y[b[c]];
            "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, {
                configurable: !0,
                writable: !0,
                value: function() {
                    return da(aa(this));
                }
            });
        }
        return a;
    });
    function da(a) {
        a = {
            next: a
        };
        a[Symbol.iterator] = function() {
            return this;
        };
        return a;
    }
    function A(a) {
        var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
        return b ? b.call(a) : {
            next: aa(a)
        };
    }
    function ea(a) {
        if (!(a instanceof Array)) {
            a = A(a);
            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
            a = c;
        }
        return a;
    }
    var fa = "function" == typeof Object.assign ? Object.assign : function(a, b) {
        for(var c = 1; c < arguments.length; c++){
            var d = arguments[c];
            if (d) for(var e in d)Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
        }
        return a;
    };
    z("Object.assign", function(a) {
        return a || fa;
    });
    var ha = "function" == typeof Object.create ? Object.create : function(a) {
        function b() {}
        b.prototype = a;
        return new b;
    }, ia;
    if ("function" == typeof Object.setPrototypeOf) ia = Object.setPrototypeOf;
    else {
        var ja;
        a: {
            var ka = {
                a: !0
            }, la = {};
            try {
                la.__proto__ = ka;
                ja = la.a;
                break a;
            } catch (a) {}
            ja = !1;
        }
        ia = ja ? function(a, b) {
            a.__proto__ = b;
            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
            return a;
        } : null;
    }
    var ma = ia;
    function na(a, b) {
        a.prototype = ha(b.prototype);
        a.prototype.constructor = a;
        if (ma) ma(a, b);
        else for(var c in b)if ("prototype" != c) {
            if (Object.defineProperties) {
                var d = Object.getOwnPropertyDescriptor(b, c);
                d && Object.defineProperty(a, c, d);
            } else a[c] = b[c];
        }
        a.za = b.prototype;
    }
    function oa() {
        this.m = !1;
        this.j = null;
        this.i = void 0;
        this.h = 1;
        this.v = this.s = 0;
        this.l = null;
    }
    function pa(a) {
        if (a.m) throw new TypeError("Generator is already running");
        a.m = !0;
    }
    oa.prototype.u = function(a) {
        this.i = a;
    };
    function qa(a, b) {
        a.l = {
            ma: b,
            na: !0
        };
        a.h = a.s || a.v;
    }
    oa.prototype.return = function(a) {
        this.l = {
            return: a
        };
        this.h = this.v;
    };
    function D(a, b, c) {
        a.h = c;
        return {
            value: b
        };
    }
    function ra(a) {
        this.h = new oa;
        this.i = a;
    }
    function sa(a, b) {
        pa(a.h);
        var c = a.h.j;
        if (c) return ta(a, "return" in c ? c["return"] : function(d) {
            return {
                value: d,
                done: !0
            };
        }, b, a.h.return);
        a.h.return(b);
        return ua(a);
    }
    function ta(a, b, c, d) {
        try {
            var e = b.call(a.h.j, c);
            if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
            if (!e.done) return a.h.m = !1, e;
            var g = e.value;
        } catch (f) {
            return a.h.j = null, qa(a.h, f), ua(a);
        }
        a.h.j = null;
        d.call(a.h, g);
        return ua(a);
    }
    function ua(a) {
        for(; a.h.h;)try {
            var b = a.i(a.h);
            if (b) return a.h.m = !1, {
                value: b.value,
                done: !1
            };
        } catch (c) {
            a.h.i = void 0, qa(a.h, c);
        }
        a.h.m = !1;
        if (a.h.l) {
            b = a.h.l;
            a.h.l = null;
            if (b.na) throw b.ma;
            return {
                value: b.return,
                done: !0
            };
        }
        return {
            value: void 0,
            done: !0
        };
    }
    function va(a) {
        this.next = function(b) {
            pa(a.h);
            a.h.j ? b = ta(a, a.h.j.next, b, a.h.u) : (a.h.u(b), b = ua(a));
            return b;
        };
        this.throw = function(b) {
            pa(a.h);
            a.h.j ? b = ta(a, a.h.j["throw"], b, a.h.u) : (qa(a.h, b), b = ua(a));
            return b;
        };
        this.return = function(b) {
            return sa(a, b);
        };
        this[Symbol.iterator] = function() {
            return this;
        };
    }
    function wa(a) {
        function b(d) {
            return a.next(d);
        }
        function c(d) {
            return a.throw(d);
        }
        return new Promise(function(d, e) {
            function g(f) {
                f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
            }
            g(a.next());
        });
    }
    function E(a) {
        return wa(new va(new ra(a)));
    }
    z("Promise", function(a) {
        function b(f) {
            this.i = 0;
            this.j = void 0;
            this.h = [];
            this.u = !1;
            var h = this.l();
            try {
                f(h.resolve, h.reject);
            } catch (k) {
                h.reject(k);
            }
        }
        function c() {
            this.h = null;
        }
        function d(f) {
            return f instanceof b ? f : new b(function(h) {
                h(f);
            });
        }
        if (a) return a;
        c.prototype.i = function(f) {
            if (null == this.h) {
                this.h = [];
                var h = this;
                this.j(function() {
                    h.m();
                });
            }
            this.h.push(f);
        };
        var e = y.setTimeout;
        c.prototype.j = function(f) {
            e(f, 0);
        };
        c.prototype.m = function() {
            for(; this.h && this.h.length;){
                var f = this.h;
                this.h = [];
                for(var h = 0; h < f.length; ++h){
                    var k = f[h];
                    f[h] = null;
                    try {
                        k();
                    } catch (l) {
                        this.l(l);
                    }
                }
            }
            this.h = null;
        };
        c.prototype.l = function(f) {
            this.j(function() {
                throw f;
            });
        };
        b.prototype.l = function() {
            function f(l) {
                return function(m) {
                    k || (k = !0, l.call(h, m));
                };
            }
            var h = this, k = !1;
            return {
                resolve: f(this.I),
                reject: f(this.m)
            };
        };
        b.prototype.I = function(f) {
            if (f === this) this.m(new TypeError("A Promise cannot resolve to itself"));
            else if (f instanceof b) this.L(f);
            else {
                a: switch(typeof f){
                    case "object":
                        var h = null != f;
                        break a;
                    case "function":
                        h = !0;
                        break a;
                    default:
                        h = !1;
                }
                h ? this.F(f) : this.s(f);
            }
        };
        b.prototype.F = function(f) {
            var h = void 0;
            try {
                h = f.then;
            } catch (k) {
                this.m(k);
                return;
            }
            "function" == typeof h ? this.M(h, f) : this.s(f);
        };
        b.prototype.m = function(f) {
            this.v(2, f);
        };
        b.prototype.s = function(f) {
            this.v(1, f);
        };
        b.prototype.v = function(f, h) {
            if (0 != this.i) throw Error("Cannot settle(" + f + ", " + h + "): Promise already settled in state" + this.i);
            this.i = f;
            this.j = h;
            2 === this.i && this.K();
            this.H();
        };
        b.prototype.K = function() {
            var f = this;
            e(function() {
                if (f.D()) {
                    var h = y.console;
                    "undefined" !== typeof h && h.error(f.j);
                }
            }, 1);
        };
        b.prototype.D = function() {
            if (this.u) return !1;
            var f = y.CustomEvent, h = y.Event, k = y.dispatchEvent;
            if ("undefined" === typeof k) return !0;
            "function" === typeof f ? f = new f("unhandledrejection", {
                cancelable: !0
            }) : "function" === typeof h ? f = new h("unhandledrejection", {
                cancelable: !0
            }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", !1, !0, f));
            f.promise = this;
            f.reason = this.j;
            return k(f);
        };
        b.prototype.H = function() {
            if (null != this.h) {
                for(var f = 0; f < this.h.length; ++f)g.i(this.h[f]);
                this.h = null;
            }
        };
        var g = new c;
        b.prototype.L = function(f) {
            var h = this.l();
            f.T(h.resolve, h.reject);
        };
        b.prototype.M = function(f, h) {
            var k = this.l();
            try {
                f.call(h, k.resolve, k.reject);
            } catch (l) {
                k.reject(l);
            }
        };
        b.prototype.then = function(f, h) {
            function k(p, n) {
                return "function" == typeof p ? function(q) {
                    try {
                        l(p(q));
                    } catch (t) {
                        m(t);
                    }
                } : n;
            }
            var l, m, r = new b(function(p, n) {
                l = p;
                m = n;
            });
            this.T(k(f, l), k(h, m));
            return r;
        };
        b.prototype.catch = function(f) {
            return this.then(void 0, f);
        };
        b.prototype.T = function(f, h) {
            function k() {
                switch(l.i){
                    case 1:
                        f(l.j);
                        break;
                    case 2:
                        h(l.j);
                        break;
                    default:
                        throw Error("Unexpected state: " + l.i);
                }
            }
            var l = this;
            null == this.h ? g.i(k) : this.h.push(k);
            this.u = !0;
        };
        b.resolve = d;
        b.reject = function(f) {
            return new b(function(h, k) {
                k(f);
            });
        };
        b.race = function(f) {
            return new b(function(h, k) {
                for(var l = A(f), m = l.next(); !m.done; m = l.next())d(m.value).T(h, k);
            });
        };
        b.all = function(f) {
            var h = A(f), k = h.next();
            return k.done ? d([]) : new b(function(l, m) {
                function r(q) {
                    return function(t) {
                        p[q] = t;
                        n--;
                        0 == n && l(p);
                    };
                }
                var p = [], n = 0;
                do p.push(void 0), n++, d(k.value).T(r(p.length - 1), m), k = h.next();
                while (!k.done);
            });
        };
        return b;
    });
    function xa(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var g = c++;
                    return {
                        value: b(g, a[g]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    z("Array.prototype.keys", function(a) {
        return a ? a : function() {
            return xa(this, function(b) {
                return b;
            });
        };
    });
    z("Array.prototype.fill", function(a) {
        return a ? a : function(b, c, d) {
            var e = this.length || 0;
            0 > c && (c = Math.max(0, e + c));
            if (null == d || d > e) d = e;
            d = Number(d);
            0 > d && (d = Math.max(0, e + d));
            for(c = Number(c || 0); c < d; c++)this[c] = b;
            return this;
        };
    });
    function F(a) {
        return a ? a : Array.prototype.fill;
    }
    z("Int8Array.prototype.fill", F);
    z("Uint8Array.prototype.fill", F);
    z("Uint8ClampedArray.prototype.fill", F);
    z("Int16Array.prototype.fill", F);
    z("Uint16Array.prototype.fill", F);
    z("Int32Array.prototype.fill", F);
    z("Uint32Array.prototype.fill", F);
    z("Float32Array.prototype.fill", F);
    z("Float64Array.prototype.fill", F);
    z("Object.is", function(a) {
        return a ? a : function(b, c) {
            return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
        };
    });
    z("Array.prototype.includes", function(a) {
        return a ? a : function(b, c) {
            var d = this;
            d instanceof String && (d = String(d));
            var e = d.length;
            c = c || 0;
            for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                var g = d[c];
                if (g === b || Object.is(g, b)) return !0;
            }
            return !1;
        };
    });
    z("String.prototype.includes", function(a) {
        return a ? a : function(b, c) {
            if (null == this) throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
            return -1 !== this.indexOf(b, c || 0);
        };
    });
    var ya = this || self;
    function Aa(a, b) {
        a = a.split(".");
        var c = ya;
        a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
        for(var d; a.length && (d = a.shift());)a.length || void 0 === b ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
    }
    function Ba(a) {
        var b;
        a: {
            if (b = ya.navigator) {
                if (b = b.userAgent) break a;
            }
            b = "";
        }
        return -1 != b.indexOf(a);
    }
    var Ca = Array.prototype.map ? function(a, b) {
        return Array.prototype.map.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = Array(c), e = "string" === typeof a ? a.split("") : a, g = 0; g < c; g++)g in e && (d[g] = b.call(void 0, e[g], g, a));
        return d;
    };
    var Da = {}, Ea = null;
    function Fa(a) {
        var b = a.length, c = 3 * b / 4;
        c % 3 ? c = Math.floor(c) : -1 != "=.".indexOf(a[b - 1]) && (c = -1 != "=.".indexOf(a[b - 2]) ? c - 2 : c - 1);
        var d = new Uint8Array(c), e = 0;
        Ga(a, function(g) {
            d[e++] = g;
        });
        return e !== c ? d.subarray(0, e) : d;
    }
    function Ga(a, b) {
        function c(k) {
            for(; d < a.length;){
                var l = a.charAt(d++), m = Ea[l];
                if (null != m) return m;
                if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
            }
            return k;
        }
        Ha();
        for(var d = 0;;){
            var e = c(-1), g = c(0), f = c(64), h = c(64);
            if (64 === h && -1 === e) break;
            b(e << 2 | g >> 4);
            64 != f && (b(g << 4 & 240 | f >> 2), 64 != h && b(f << 6 & 192 | h));
        }
    }
    function Ha() {
        if (!Ea) {
            Ea = {};
            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                "+/=",
                "+/",
                "-_=",
                "-_.",
                "-_"
            ], c = 0; 5 > c; c++){
                var d = a.concat(b[c].split(""));
                Da[c] = d;
                for(var e = 0; e < d.length; e++){
                    var g = d[e];
                    void 0 === Ea[g] && (Ea[g] = e);
                }
            }
        }
    }
    var Ia = "undefined" !== typeof Uint8Array, Ja = !(Ba("Trident") || Ba("MSIE")) && "function" === typeof ya.btoa;
    function Ka(a) {
        if (!Ja) {
            var b;
            void 0 === b && (b = 0);
            Ha();
            b = Da[b];
            for(var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3){
                var f = a[e], h = a[e + 1], k = a[e + 2], l = b[f >> 2];
                f = b[(f & 3) << 4 | h >> 4];
                h = b[(h & 15) << 2 | k >> 6];
                k = b[k & 63];
                c[g++] = l + f + h + k;
            }
            l = 0;
            k = d;
            switch(a.length - e){
                case 2:
                    l = a[e + 1], k = b[(l & 15) << 2] || d;
                case 1:
                    a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
            }
            return c.join("");
        }
        for(b = ""; 10240 < a.length;)b += String.fromCharCode.apply(null, a.subarray(0, 10240)), a = a.subarray(10240);
        b += String.fromCharCode.apply(null, a);
        return btoa(b);
    }
    var La = RegExp("[-_.]", "g");
    function Ma(a) {
        switch(a){
            case "-":
                return "+";
            case "_":
                return "/";
            case ".":
                return "=";
            default:
                return "";
        }
    }
    function Na(a) {
        if (!Ja) return Fa(a);
        La.test(a) && (a = a.replace(La, Ma));
        a = atob(a);
        for(var b = new Uint8Array(a.length), c = 0; c < a.length; c++)b[c] = a.charCodeAt(c);
        return b;
    }
    var Oa;
    function Pa() {
        return Oa || (Oa = new Uint8Array(0));
    }
    var Qa = {};
    var Ra = "function" === typeof Uint8Array.prototype.slice, G = 0, H = 0;
    function Sa(a) {
        var b = 0 > a;
        a = Math.abs(a);
        var c = a >>> 0;
        a = Math.floor((a - c) / 4294967296);
        b && (c = A(Ta(c, a)), b = c.next().value, a = c.next().value, c = b);
        G = c >>> 0;
        H = a >>> 0;
    }
    var Ua = "function" === typeof BigInt;
    function Ta(a, b) {
        b = ~b;
        a ? a = ~a + 1 : b += 1;
        return [
            a,
            b
        ];
    }
    function Va(a, b) {
        this.i = a >>> 0;
        this.h = b >>> 0;
    }
    function Wa(a) {
        if (!a) return Xa || (Xa = new Va(0, 0));
        if (!/^-?\d+$/.test(a)) return null;
        if (16 > a.length) Sa(Number(a));
        else if (Ua) a = BigInt(a), G = Number(a & BigInt(4294967295)) >>> 0, H = Number(a >> BigInt(32) & BigInt(4294967295));
        else {
            var b = +("-" === a[0]);
            H = G = 0;
            for(var c = a.length, d = b, e = (c - b) % 6 + b; e <= c; d = e, e += 6)d = Number(a.slice(d, e)), H *= 1E6, G = 1E6 * G + d, 4294967296 <= G && (H += G / 4294967296 | 0, G %= 4294967296);
            b && (b = A(Ta(G, H)), a = b.next().value, b = b.next().value, G = a, H = b);
        }
        return new Va(G, H);
    }
    var Xa;
    function Ya(a, b) {
        return Error("Invalid wire type: " + a + " (at position " + b + ")");
    }
    function Za() {
        return Error("Failed to read varint, encoding is invalid.");
    }
    function $a(a, b) {
        return Error("Tried to read past the end of the data " + b + " > " + a);
    }
    function K() {
        throw Error("Invalid UTF8");
    }
    function ab(a, b) {
        b = String.fromCharCode.apply(null, b);
        return null == a ? b : a + b;
    }
    var bb = void 0, cb, db = "undefined" !== typeof TextDecoder, eb, fb = "undefined" !== typeof TextEncoder;
    var gb;
    function hb(a) {
        if (a !== Qa) throw Error("illegal external caller");
    }
    function ib(a, b) {
        hb(b);
        this.V = a;
        if (null != a && 0 === a.length) throw Error("ByteString should be constructed with non-empty values");
    }
    function jb() {
        return gb || (gb = new ib(null, Qa));
    }
    function kb(a) {
        hb(Qa);
        var b = a.V;
        b = null == b || Ia && null != b && b instanceof Uint8Array ? b : "string" === typeof b ? Na(b) : null;
        return null == b ? b : a.V = b;
    }
    function lb(a) {
        if ("string" === typeof a) return {
            buffer: Na(a),
            C: !1
        };
        if (Array.isArray(a)) return {
            buffer: new Uint8Array(a),
            C: !1
        };
        if (a.constructor === Uint8Array) return {
            buffer: a,
            C: !1
        };
        if (a.constructor === ArrayBuffer) return {
            buffer: new Uint8Array(a),
            C: !1
        };
        if (a.constructor === ib) return {
            buffer: kb(a) || Pa(),
            C: !0
        };
        if (a instanceof Uint8Array) return {
            buffer: new Uint8Array(a.buffer, a.byteOffset, a.byteLength),
            C: !1
        };
        throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, a ByteString or an Array of numbers");
    }
    function mb(a, b) {
        this.i = null;
        this.m = !1;
        this.h = this.j = this.l = 0;
        nb(this, a, b);
    }
    function nb(a, b, c) {
        c = void 0 === c ? {} : c;
        a.S = void 0 === c.S ? !1 : c.S;
        b && (b = lb(b), a.i = b.buffer, a.m = b.C, a.l = 0, a.j = a.i.length, a.h = a.l);
    }
    mb.prototype.reset = function() {
        this.h = this.l;
    };
    function L(a, b) {
        a.h = b;
        if (b > a.j) throw $a(a.j, b);
    }
    function ob(a) {
        var b = a.i, c = a.h, d = b[c++], e = d & 127;
        if (d & 128 && (d = b[c++], e |= (d & 127) << 7, d & 128 && (d = b[c++], e |= (d & 127) << 14, d & 128 && (d = b[c++], e |= (d & 127) << 21, d & 128 && (d = b[c++], e |= d << 28, d & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128 && b[c++] & 128))))) throw Za();
        L(a, c);
        return e;
    }
    function pb(a, b) {
        if (0 > b) throw Error("Tried to read a negative byte length: " + b);
        var c = a.h, d = c + b;
        if (d > a.j) throw $a(b, a.j - c);
        a.h = d;
        return c;
    }
    var qb = [];
    function rb() {
        this.h = [];
    }
    rb.prototype.length = function() {
        return this.h.length;
    };
    rb.prototype.end = function() {
        var a = this.h;
        this.h = [];
        return a;
    };
    function sb(a, b, c) {
        for(; 0 < c || 127 < b;)a.h.push(b & 127 | 128), b = (b >>> 7 | c << 25) >>> 0, c >>>= 7;
        a.h.push(b);
    }
    function M(a, b) {
        for(; 127 < b;)a.h.push(b & 127 | 128), b >>>= 7;
        a.h.push(b);
    }
    function tb(a, b) {
        if (qb.length) {
            var c = qb.pop();
            nb(c, a, b);
            a = c;
        } else a = new mb(a, b);
        this.h = a;
        this.j = this.h.h;
        this.i = this.l = -1;
        this.setOptions(b);
    }
    tb.prototype.setOptions = function(a) {
        a = void 0 === a ? {} : a;
        this.ca = void 0 === a.ca ? !1 : a.ca;
    };
    tb.prototype.reset = function() {
        this.h.reset();
        this.j = this.h.h;
        this.i = this.l = -1;
    };
    function ub(a) {
        var b = a.h;
        if (b.h == b.j) return !1;
        a.j = a.h.h;
        var c = ob(a.h) >>> 0;
        b = c >>> 3;
        c &= 7;
        if (!(0 <= c && 5 >= c)) throw Ya(c, a.j);
        if (1 > b) throw Error("Invalid field number: " + b + " (at position " + a.j + ")");
        a.l = b;
        a.i = c;
        return !0;
    }
    function vb(a) {
        switch(a.i){
            case 0:
                if (0 != a.i) vb(a);
                else a: {
                    a = a.h;
                    for(var b = a.h, c = b + 10, d = a.i; b < c;)if (0 === (d[b++] & 128)) {
                        L(a, b);
                        break a;
                    }
                    throw Za();
                }
                break;
            case 1:
                a = a.h;
                L(a, a.h + 8);
                break;
            case 2:
                2 != a.i ? vb(a) : (b = ob(a.h) >>> 0, a = a.h, L(a, a.h + b));
                break;
            case 5:
                a = a.h;
                L(a, a.h + 4);
                break;
            case 3:
                b = a.l;
                do {
                    if (!ub(a)) throw Error("Unmatched start-group tag: stream EOF");
                    if (4 == a.i) {
                        if (a.l != b) throw Error("Unmatched end-group tag");
                        break;
                    }
                    vb(a);
                }while (1);
                break;
            default:
                throw Ya(a.i, a.j);
        }
    }
    var wb = [];
    function xb() {
        this.j = [];
        this.i = 0;
        this.h = new rb;
    }
    function N(a, b) {
        0 !== b.length && (a.j.push(b), a.i += b.length);
    }
    function yb(a, b) {
        if (b = b.R) {
            N(a, a.h.end());
            for(var c = 0; c < b.length; c++)N(a, kb(b[c]) || Pa());
        }
    }
    var O = "function" === typeof Symbol && "symbol" === typeof Symbol() ? Symbol() : void 0;
    function P(a, b) {
        if (O) return a[O] |= b;
        if (void 0 !== a.A) return a.A |= b;
        Object.defineProperties(a, {
            A: {
                value: b,
                configurable: !0,
                writable: !0,
                enumerable: !1
            }
        });
        return b;
    }
    function zb(a, b) {
        O ? a[O] && (a[O] &= ~b) : void 0 !== a.A && (a.A &= ~b);
    }
    function Q(a) {
        var b;
        O ? b = a[O] : b = a.A;
        return null == b ? 0 : b;
    }
    function R(a, b) {
        O ? a[O] = b : void 0 !== a.A ? a.A = b : Object.defineProperties(a, {
            A: {
                value: b,
                configurable: !0,
                writable: !0,
                enumerable: !1
            }
        });
    }
    function Ab(a) {
        P(a, 1);
        return a;
    }
    function Bb(a, b) {
        R(b, (a | 0) & -51);
    }
    function Cb(a, b) {
        R(b, (a | 18) & -41);
    }
    var Db = {};
    function Eb(a) {
        return null !== a && "object" === typeof a && !Array.isArray(a) && a.constructor === Object;
    }
    var Fb, Gb = [];
    R(Gb, 23);
    Fb = Object.freeze(Gb);
    function Hb(a) {
        if (Q(a.o) & 2) throw Error("Cannot mutate an immutable Message");
    }
    function Ib(a) {
        var b = a.length;
        (b = b ? a[b - 1] : void 0) && Eb(b) ? b.g = 1 : (b = {}, a.push((b.g = 1, b)));
    }
    function Jb(a) {
        var b = a.i + a.G;
        return a.B || (a.B = a.o[b] = {});
    }
    function S(a, b) {
        return -1 === b ? null : b >= a.i ? a.B ? a.B[b] : void 0 : a.o[b + a.G];
    }
    function U(a, b, c, d) {
        Hb(a);
        Kb(a, b, c, d);
    }
    function Kb(a, b, c, d) {
        a.j && (a.j = void 0);
        b >= a.i || d ? Jb(a)[b] = c : (a.o[b + a.G] = c, (a = a.B) && b in a && delete a[b]);
    }
    function Lb(a, b, c, d) {
        var e = S(a, b);
        Array.isArray(e) || (e = Fb);
        var g = Q(e);
        g & 1 || Ab(e);
        if (d) g & 2 || P(e, 2), c & 1 || Object.freeze(e);
        else {
            d = !(c & 2);
            var f = g & 2;
            c & 1 || !f ? d && g & 16 && !f && zb(e, 16) : (e = Ab(Array.prototype.slice.call(e)), Kb(a, b, e));
        }
        return e;
    }
    function Mb(a, b) {
        var c = S(a, b);
        var d = null == c ? c : "number" === typeof c || "NaN" === c || "Infinity" === c || "-Infinity" === c ? Number(c) : void 0;
        null != d && d !== c && Kb(a, b, d);
        return d;
    }
    function Nb(a, b, c, d, e) {
        a.h || (a.h = {});
        var g = a.h[c], f = Lb(a, c, 3, e);
        if (!g) {
            var h = f;
            g = [];
            var k = !!(Q(a.o) & 16);
            f = !!(Q(h) & 2);
            var l = h;
            !e && f && (h = Array.prototype.slice.call(h));
            for(var m = f, r = 0; r < h.length; r++){
                var p = h[r];
                var n = b, q = !1;
                q = void 0 === q ? !1 : q;
                p = Array.isArray(p) ? new n(p) : q ? new n : void 0;
                if (void 0 !== p) {
                    n = p.o;
                    var t = q = Q(n);
                    f && (t |= 2);
                    k && (t |= 16);
                    t != q && R(n, t);
                    n = t;
                    m = m || !!(2 & n);
                    g.push(p);
                }
            }
            a.h[c] = g;
            k = Q(h);
            b = k | 33;
            b = m ? b & -9 : b | 8;
            k != b && (m = h, Object.isFrozen(m) && (m = Array.prototype.slice.call(m)), R(m, b), h = m);
            l !== h && Kb(a, c, h);
            (e || d && f) && P(g, 2);
            d && Object.freeze(g);
            return g;
        }
        e || (e = Object.isFrozen(g), d && !e ? Object.freeze(g) : !d && e && (g = Array.prototype.slice.call(g), a.h[c] = g));
        return g;
    }
    function Ob(a, b, c) {
        var d = !!(Q(a.o) & 2);
        b = Nb(a, b, c, d, d);
        a = Lb(a, c, 3, d);
        if (!(d || Q(a) & 8)) {
            for(d = 0; d < b.length; d++){
                c = b[d];
                if (Q(c.o) & 2) {
                    var e = Pb(c, !1);
                    e.j = c;
                } else e = c;
                c !== e && (b[d] = e, a[d] = e.o);
            }
            P(a, 8);
        }
        return b;
    }
    function V(a, b, c) {
        if (null != c && "number" !== typeof c) throw Error("Value of float/double field must be a number|null|undefined, found " + typeof c + ": " + c);
        U(a, b, c);
    }
    function Qb(a, b, c, d, e) {
        Hb(a);
        var g = Nb(a, c, b, !1, !1);
        c = null != d ? d : new c;
        a = Lb(a, b, 2, !1);
        void 0 != e ? (g.splice(e, 0, c), a.splice(e, 0, c.o)) : (g.push(c), a.push(c.o));
        c.C() && zb(a, 8);
        return c;
    }
    function Rb(a, b) {
        return null == a ? b : a;
    }
    function W(a, b, c) {
        c = void 0 === c ? 0 : c;
        return Rb(Mb(a, b), c);
    }
    var Sb;
    function Tb(a) {
        switch(typeof a){
            case "number":
                return isFinite(a) ? a : String(a);
            case "object":
                if (a) {
                    if (Array.isArray(a)) {
                        if (0 !== (Q(a) & 128)) return a = Array.prototype.slice.call(a), Ib(a), a;
                    } else {
                        if (Ia && null != a && a instanceof Uint8Array) return Ka(a);
                        if (a instanceof ib) {
                            var b = a.V;
                            return null == b ? "" : "string" === typeof b ? b : a.V = Ka(b);
                        }
                    }
                }
        }
        return a;
    }
    function Ub(a, b, c, d) {
        if (null != a) {
            if (Array.isArray(a)) a = Vb(a, b, c, void 0 !== d);
            else if (Eb(a)) {
                var e = {}, g;
                for(g in a)e[g] = Ub(a[g], b, c, d);
                a = e;
            } else a = b(a, d);
            return a;
        }
    }
    function Vb(a, b, c, d) {
        var e = Q(a);
        d = d ? !!(e & 16) : void 0;
        a = Array.prototype.slice.call(a);
        for(var g = 0; g < a.length; g++)a[g] = Ub(a[g], b, c, d);
        c(e, a);
        return a;
    }
    function Wb(a) {
        return a.ja === Db ? a.toJSON() : Tb(a);
    }
    function Xb(a, b) {
        a & 128 && Ib(b);
    }
    function Yb(a, b, c) {
        c = void 0 === c ? Cb : c;
        if (null != a) {
            if (Ia && a instanceof Uint8Array) return a.length ? new ib(new Uint8Array(a), Qa) : jb();
            if (Array.isArray(a)) {
                var d = Q(a);
                if (d & 2) return a;
                if (b && !(d & 32) && (d & 16 || 0 === d)) return R(a, d | 2), a;
                a = Vb(a, Yb, d & 4 ? Cb : c, !0);
                b = Q(a);
                b & 4 && b & 2 && Object.freeze(a);
                return a;
            }
            return a.ja === Db ? Zb(a) : a;
        }
    }
    function $b(a, b, c, d, e, g, f) {
        if (a = a.h && a.h[c]) {
            d = Q(a);
            d & 2 ? d = a : (g = Ca(a, Zb), Cb(d, g), Object.freeze(g), d = g);
            Hb(b);
            f = null == d ? Fb : Ab([]);
            if (null != d) {
                g = !!d.length;
                for(a = 0; a < d.length; a++){
                    var h = d[a];
                    g = g && !(Q(h.o) & 2);
                    f[a] = h.o;
                }
                g = (g ? 8 : 0) | 1;
                a = Q(f);
                (a & g) !== g && (Object.isFrozen(f) && (f = Array.prototype.slice.call(f)), R(f, a | g));
                b.h || (b.h = {});
                b.h[c] = d;
            } else b.h && (b.h[c] = void 0);
            Kb(b, c, f, e);
        } else U(b, c, Yb(d, g, f), e);
    }
    function Zb(a) {
        if (Q(a.o) & 2) return a;
        a = Pb(a, !0);
        P(a.o, 2);
        return a;
    }
    function Pb(a, b) {
        var c = a.o, d = [];
        P(d, 16);
        var e = a.constructor.h;
        e && d.push(e);
        e = a.B;
        if (e) {
            d.length = c.length;
            d.fill(void 0, d.length, c.length);
            var g = {};
            d[d.length - 1] = g;
        }
        0 !== (Q(c) & 128) && Ib(d);
        b = b || a.C() ? Cb : Bb;
        g = a.constructor;
        Sb = d;
        d = new g(d);
        Sb = void 0;
        a.R && (d.R = a.R.slice());
        g = !!(Q(c) & 16);
        for(var f = e ? c.length - 1 : c.length, h = 0; h < f; h++)$b(a, d, h - a.G, c[h], !1, g, b);
        if (e) for(var k in e)$b(a, d, +k, e[k], !0, g, b);
        return d;
    }
    function X(a, b, c) {
        null == a && (a = Sb);
        Sb = void 0;
        var d = this.constructor.i || 0, e = 0 < d, g = this.constructor.h, f = !1;
        if (null == a) {
            a = g ? [
                g
            ] : [];
            var h = 48;
            var k = !0;
            e && (d = 0, h |= 128);
            R(a, h);
        } else {
            if (!Array.isArray(a)) throw Error();
            if (g && g !== a[0]) throw Error();
            var l = h = P(a, 0);
            if (k = 0 !== (16 & l)) (f = 0 !== (32 & l)) || (l |= 32);
            if (e) {
                if (128 & l) d = 0;
                else if (0 < a.length) {
                    var m = a[a.length - 1];
                    if (Eb(m) && "g" in m) {
                        d = 0;
                        l |= 128;
                        delete m.g;
                        var r = !0, p;
                        for(p in m){
                            r = !1;
                            break;
                        }
                        r && a.pop();
                    }
                }
            } else if (128 & l) throw Error();
            h !== l && R(a, l);
        }
        this.G = (g ? 0 : -1) - d;
        this.h = void 0;
        this.o = a;
        a: {
            g = this.o.length;
            d = g - 1;
            if (g && (g = this.o[d], Eb(g))) {
                this.B = g;
                this.i = d - this.G;
                break a;
            }
            void 0 !== b && -1 < b ? (this.i = Math.max(b, d + 1 - this.G), this.B = void 0) : this.i = Number.MAX_VALUE;
        }
        if (!e && this.B && "g" in this.B) throw Error('Unexpected "g" flag in sparse object of message that is not a group type.');
        if (c) {
            b = k && !f && !0;
            e = this.i;
            var n;
            for(k = 0; k < c.length; k++)f = c[k], f < e ? (f += this.G, (d = a[f]) ? ac(d, b) : a[f] = Fb) : (n || (n = Jb(this)), (d = n[f]) ? ac(d, b) : n[f] = Fb);
        }
    }
    X.prototype.toJSON = function() {
        return Vb(this.o, Wb, Xb);
    };
    X.prototype.C = function() {
        return !!(Q(this.o) & 2);
    };
    function ac(a, b) {
        if (Array.isArray(a)) {
            var c = Q(a), d = 1;
            !b || c & 2 || (d |= 16);
            (c & d) !== d && R(a, c | d);
        }
    }
    X.prototype.ja = Db;
    X.prototype.toString = function() {
        return this.o.toString();
    };
    function bc(a, b, c) {
        if (c) {
            var d = {}, e;
            for(e in c){
                var g = c[e], f = g.ra;
                f || (d.J = g.xa || g.oa.W, g.ia ? (d.aa = cc(g.ia), f = function(h) {
                    return function(k, l, m) {
                        return h.J(k, l, m, h.aa);
                    };
                }(d)) : g.ka ? (d.Z = dc(g.da.P, g.ka), f = function(h) {
                    return function(k, l, m) {
                        return h.J(k, l, m, h.Z);
                    };
                }(d)) : f = d.J, g.ra = f);
                f(b, a, g.da);
                d = {
                    J: d.J,
                    aa: d.aa,
                    Z: d.Z
                };
            }
        }
        yb(b, a);
    }
    var ec = Symbol();
    function fc(a, b, c) {
        return a[ec] || (a[ec] = function(d, e) {
            return b(d, e, c);
        });
    }
    function gc(a) {
        var b = a[ec];
        if (!b) {
            var c = hc(a);
            b = function(d, e) {
                return ic(d, e, c);
            };
            a[ec] = b;
        }
        return b;
    }
    function jc(a) {
        var b = a.ia;
        if (b) return gc(b);
        if (b = a.wa) return fc(a.da.P, b, a.ka);
    }
    function kc(a) {
        var b = jc(a), c = a.da, d = a.oa.U;
        return b ? function(e, g) {
            return d(e, g, c, b);
        } : function(e, g) {
            return d(e, g, c);
        };
    }
    function lc(a, b) {
        var c = a[b];
        "function" == typeof c && 0 === c.length && (c = c(), a[b] = c);
        return Array.isArray(c) && (mc in c || nc in c || 0 < c.length && "function" == typeof c[0]) ? c : void 0;
    }
    function oc(a, b, c, d, e, g) {
        b.P = a[0];
        var f = 1;
        if (a.length > f && "number" !== typeof a[f]) {
            var h = a[f++];
            c(b, h);
        }
        for(; f < a.length;){
            c = a[f++];
            for(var k = f + 1; k < a.length && "number" !== typeof a[k];)k++;
            h = a[f++];
            k -= f;
            switch(k){
                case 0:
                    d(b, c, h);
                    break;
                case 1:
                    (k = lc(a, f)) ? (f++, e(b, c, h, k)) : d(b, c, h, a[f++]);
                    break;
                case 2:
                    k = f++;
                    k = lc(a, k);
                    e(b, c, h, k, a[f++]);
                    break;
                case 3:
                    g(b, c, h, a[f++], a[f++], a[f++]);
                    break;
                case 4:
                    g(b, c, h, a[f++], a[f++], a[f++], a[f++]);
                    break;
                default:
                    throw Error("unexpected number of binary field arguments: " + k);
            }
        }
        return b;
    }
    var pc = Symbol();
    function cc(a) {
        var b = a[pc];
        if (!b) {
            var c = qc(a);
            b = function(d, e) {
                return rc(d, e, c);
            };
            a[pc] = b;
        }
        return b;
    }
    function dc(a, b) {
        var c = a[pc];
        c || (c = function(d, e) {
            return bc(d, e, b);
        }, a[pc] = c);
        return c;
    }
    var nc = Symbol();
    function sc(a, b) {
        a.push(b);
    }
    function tc(a, b, c) {
        a.push(b, c.W);
    }
    function uc(a, b, c, d) {
        var e = cc(d), g = qc(d).P, f = c.W;
        a.push(b, function(h, k, l) {
            return f(h, k, l, g, e);
        });
    }
    function vc(a, b, c, d, e, g) {
        var f = dc(d, g), h = c.W;
        a.push(b, function(k, l, m) {
            return h(k, l, m, d, f);
        });
    }
    function qc(a) {
        var b = a[nc];
        if (b) return b;
        b = oc(a, a[nc] = [], sc, tc, uc, vc);
        mc in a && nc in a && (a.length = 0);
        return b;
    }
    var mc = Symbol();
    function wc(a, b) {
        a[0] = b;
    }
    function xc(a, b, c, d) {
        var e = c.U;
        a[b] = d ? function(g, f, h) {
            return e(g, f, h, d);
        } : e;
    }
    function yc(a, b, c, d, e) {
        var g = c.U, f = gc(d), h = hc(d).P;
        a[b] = function(k, l, m) {
            return g(k, l, m, h, f, e);
        };
    }
    function zc(a, b, c, d, e, g, f) {
        var h = c.U, k = fc(d, e, g);
        a[b] = function(l, m, r) {
            return h(l, m, r, d, k, f);
        };
    }
    function hc(a) {
        var b = a[mc];
        if (b) return b;
        b = oc(a, a[mc] = {}, wc, xc, yc, zc);
        mc in a && nc in a && (a.length = 0);
        return b;
    }
    function ic(a, b, c) {
        for(; ub(b) && 4 != b.i;){
            var d = b.l, e = c[d];
            if (!e) {
                var g = c[0];
                g && (g = g[d]) && (e = c[d] = kc(g));
            }
            if (!e || !e(b, a, d)) {
                e = b;
                d = a;
                g = e.j;
                vb(e);
                var f = e;
                if (!f.ca) {
                    e = f.h.h - g;
                    f.h.h = g;
                    f = f.h;
                    if (0 == e) e = jb();
                    else {
                        g = pb(f, e);
                        if (f.S && f.m) e = f.i.subarray(g, g + e);
                        else {
                            f = f.i;
                            var h = g;
                            e = g + e;
                            e = h === e ? Pa() : Ra ? f.slice(h, e) : new Uint8Array(f.subarray(h, e));
                        }
                        e = 0 == e.length ? jb() : new ib(e, Qa);
                    }
                    (g = d.R) ? g.push(e) : d.R = [
                        e
                    ];
                }
            }
        }
        return a;
    }
    function rc(a, b, c) {
        for(var d = c.length, e = 1 == d % 2, g = e ? 1 : 0; g < d; g += 2)(0, c[g + 1])(b, a, c[g]);
        bc(a, b, e ? c[0] : void 0);
    }
    function Ac(a, b) {
        return {
            U: a,
            W: b
        };
    }
    var Y = Ac(function(a, b, c) {
        if (5 !== a.i) return !1;
        a = a.h;
        var d = a.i, e = a.h, g = d[e];
        var f = d[e + 1];
        var h = d[e + 2];
        d = d[e + 3];
        L(a, a.h + 4);
        f = (g << 0 | f << 8 | h << 16 | d << 24) >>> 0;
        a = 2 * (f >> 31) + 1;
        g = f >>> 23 & 255;
        f &= 8388607;
        U(b, c, 255 == g ? f ? NaN : Infinity * a : 0 == g ? a * Math.pow(2, -149) * f : a * Math.pow(2, g - 150) * (f + Math.pow(2, 23)));
        return !0;
    }, function(a, b, c) {
        b = Mb(b, c);
        if (null != b) {
            M(a.h, 8 * c + 5);
            a = a.h;
            var d = +b;
            0 === d ? 0 < 1 / d ? G = H = 0 : (H = 0, G = 2147483648) : isNaN(d) ? (H = 0, G = 2147483647) : (d = (c = 0 > d ? -2147483648 : 0) ? -d : d, 3.4028234663852886E38 < d ? (H = 0, G = (c | 2139095040) >>> 0) : 1.1754943508222875E-38 > d ? (d = Math.round(d / Math.pow(2, -149)), H = 0, G = (c | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, H = 0, G = (c | b + 127 << 23 | d & 8388607) >>> 0));
            c = G;
            a.h.push(c >>> 0 & 255);
            a.h.push(c >>> 8 & 255);
            a.h.push(c >>> 16 & 255);
            a.h.push(c >>> 24 & 255);
        }
    }), Bc = Ac(function(a, b, c) {
        if (0 !== a.i) return !1;
        var d = a.h, e = 0, g = a = 0, f = d.i, h = d.h;
        do {
            var k = f[h++];
            e |= (k & 127) << g;
            g += 7;
        }while (32 > g && k & 128);
        32 < g && (a |= (k & 127) >> 4);
        for(g = 3; 32 > g && k & 128; g += 7)k = f[h++], a |= (k & 127) << g;
        L(d, h);
        if (128 > k) {
            d = e >>> 0;
            k = a >>> 0;
            if (a = k & 2147483648) d = ~d + 1 >>> 0, k = ~k >>> 0, 0 == d && (k = k + 1 >>> 0);
            d = 4294967296 * k + (d >>> 0);
        } else throw Za();
        U(b, c, a ? -d : d);
        return !0;
    }, function(a, b, c) {
        b = S(b, c);
        null != b && ("string" === typeof b && Wa(b), null != b && (M(a.h, 8 * c), "number" === typeof b ? (a = a.h, Sa(b), sb(a, G, H)) : (c = Wa(b), sb(a.h, c.i, c.h))));
    }), Cc = Ac(function(a, b, c) {
        if (0 !== a.i) return !1;
        U(b, c, ob(a.h));
        return !0;
    }, function(a, b, c) {
        b = S(b, c);
        if (null != b && null != b) {
            if (M(a.h, 8 * c), a = a.h, c = b, 0 <= c) M(a, c);
            else {
                for(b = 0; 9 > b; b++)a.h.push(c & 127 | 128), c >>= 7;
                a.h.push(1);
            }
        }
    }), Dc = Ac(function(a, b, c) {
        if (2 !== a.i) return !1;
        var d = ob(a.h) >>> 0;
        a = a.h;
        var e = pb(a, d);
        a = a.i;
        if (db) {
            var g = a, f;
            (f = cb) || (f = cb = new TextDecoder("utf-8", {
                fatal: !0
            }));
            a = e + d;
            g = 0 === e && a === g.length ? g : g.subarray(e, a);
            try {
                var h = f.decode(g);
            } catch (r) {
                if (void 0 === bb) {
                    try {
                        f.decode(new Uint8Array([
                            128
                        ]));
                    } catch (p) {}
                    try {
                        f.decode(new Uint8Array([
                            97
                        ])), bb = !0;
                    } catch (p) {
                        bb = !1;
                    }
                }
                !bb && (cb = void 0);
                throw r;
            }
        } else {
            h = e;
            d = h + d;
            e = [];
            for(var k = null, l, m; h < d;)l = a[h++], 128 > l ? e.push(l) : 224 > l ? h >= d ? K() : (m = a[h++], 194 > l || 128 !== (m & 192) ? (h--, K()) : e.push((l & 31) << 6 | m & 63)) : 240 > l ? h >= d - 1 ? K() : (m = a[h++], 128 !== (m & 192) || 224 === l && 160 > m || 237 === l && 160 <= m || 128 !== ((g = a[h++]) & 192) ? (h--, K()) : e.push((l & 15) << 12 | (m & 63) << 6 | g & 63)) : 244 >= l ? h >= d - 2 ? K() : (m = a[h++], 128 !== (m & 192) || 0 !== (l << 28) + (m - 144) >> 30 || 128 !== ((g = a[h++]) & 192) || 128 !== ((f = a[h++]) & 192) ? (h--, K()) : (l = (l & 7) << 18 | (m & 63) << 12 | (g & 63) << 6 | f & 63, l -= 65536, e.push((l >> 10 & 1023) + 55296, (l & 1023) + 56320))) : K(), 8192 <= e.length && (k = ab(k, e), e.length = 0);
            h = ab(k, e);
        }
        U(b, c, h);
        return !0;
    }, function(a, b, c) {
        b = S(b, c);
        if (null != b) {
            var d = !1;
            d = void 0 === d ? !1 : d;
            if (fb) {
                if (d && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(b)) throw Error("Found an unpaired surrogate");
                b = (eb || (eb = new TextEncoder)).encode(b);
            } else {
                for(var e = 0, g = new Uint8Array(3 * b.length), f = 0; f < b.length; f++){
                    var h = b.charCodeAt(f);
                    if (128 > h) g[e++] = h;
                    else {
                        if (2048 > h) g[e++] = h >> 6 | 192;
                        else {
                            if (55296 <= h && 57343 >= h) {
                                if (56319 >= h && f < b.length) {
                                    var k = b.charCodeAt(++f);
                                    if (56320 <= k && 57343 >= k) {
                                        h = 1024 * (h - 55296) + k - 56320 + 65536;
                                        g[e++] = h >> 18 | 240;
                                        g[e++] = h >> 12 & 63 | 128;
                                        g[e++] = h >> 6 & 63 | 128;
                                        g[e++] = h & 63 | 128;
                                        continue;
                                    } else f--;
                                }
                                if (d) throw Error("Found an unpaired surrogate");
                                h = 65533;
                            }
                            g[e++] = h >> 12 | 224;
                            g[e++] = h >> 6 & 63 | 128;
                        }
                        g[e++] = h & 63 | 128;
                    }
                }
                b = e === g.length ? g : g.subarray(0, e);
            }
            M(a.h, 8 * c + 2);
            M(a.h, b.length);
            N(a, a.h.end());
            N(a, b);
        }
    }), Ec = Ac(function(a, b, c, d, e) {
        if (2 !== a.i) return !1;
        b = Qb(b, c, d);
        c = a.h.j;
        d = ob(a.h) >>> 0;
        var g = a.h.h + d, f = g - c;
        0 >= f && (a.h.j = g, e(b, a, void 0, void 0, void 0), f = g - a.h.h);
        if (f) throw Error("Message parsing ended unexpectedly. Expected to read " + (d + " bytes, instead read " + (d - f) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
        a.h.h = g;
        a.h.j = c;
        return !0;
    }, function(a, b, c, d, e) {
        b = Ob(b, d, c);
        if (null != b) for(d = 0; d < b.length; d++){
            var g = a;
            M(g.h, 8 * c + 2);
            var f = g.h.end();
            N(g, f);
            f.push(g.i);
            g = f;
            e(b[d], a);
            f = a;
            var h = g.pop();
            for(h = f.i + f.h.length() - h; 127 < h;)g.push(h & 127 | 128), h >>>= 7, f.i++;
            g.push(h);
            f.i++;
        }
    });
    function Fc(a) {
        return function(b, c) {
            a: {
                if (wb.length) {
                    var d = wb.pop();
                    d.setOptions(c);
                    nb(d.h, b, c);
                    b = d;
                } else b = new tb(b, c);
                try {
                    var e = hc(a);
                    var g = ic(new e.P, b, e);
                    break a;
                } finally{
                    e = b.h, e.i = null, e.m = !1, e.l = 0, e.j = 0, e.h = 0, e.S = !1, b.l = -1, b.i = -1, 100 > wb.length && wb.push(b);
                }
                g = void 0;
            }
            return g;
        };
    }
    function Gc(a) {
        return function() {
            var b = new xb;
            rc(this, b, qc(a));
            N(b, b.h.end());
            for(var c = new Uint8Array(b.i), d = b.j, e = d.length, g = 0, f = 0; f < e; f++){
                var h = d[f];
                c.set(h, g);
                g += h.length;
            }
            b.j = [
                c
            ];
            return c;
        };
    }
    function Z(a) {
        X.call(this, a);
    }
    na(Z, X);
    var Hc = [
        Z,
        1,
        Cc,
        2,
        Y,
        3,
        Dc,
        4,
        Dc
    ];
    Z.prototype.l = Gc(Hc);
    function Ic(a) {
        X.call(this, a, -1, Jc);
    }
    na(Ic, X);
    Ic.prototype.addClassification = function(a, b) {
        Qb(this, 1, Z, a, b);
        return this;
    };
    var Jc = [
        1
    ], Kc = Fc([
        Ic,
        1,
        Ec,
        Hc
    ]);
    function Lc(a) {
        X.call(this, a);
    }
    na(Lc, X);
    var Mc = [
        Lc,
        1,
        Y,
        2,
        Y,
        3,
        Y,
        4,
        Y,
        5,
        Y
    ];
    Lc.prototype.l = Gc(Mc);
    function Nc(a) {
        X.call(this, a, -1, Oc);
    }
    na(Nc, X);
    var Oc = [
        1
    ], Pc = Fc([
        Nc,
        1,
        Ec,
        Mc
    ]);
    function Qc(a) {
        X.call(this, a);
    }
    na(Qc, X);
    var Rc = [
        Qc,
        1,
        Y,
        2,
        Y,
        3,
        Y,
        4,
        Y,
        5,
        Y,
        6,
        Bc
    ], Sc = Fc(Rc);
    Qc.prototype.l = Gc(Rc);
    function Tc(a, b, c) {
        c = a.createShader(0 === c ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
        a.shaderSource(c, b);
        a.compileShader(c);
        if (!a.getShaderParameter(c, a.COMPILE_STATUS)) throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
        return c;
    }
    function Uc(a) {
        return Ob(a, Z, 1).map(function(b) {
            var c = S(b, 1);
            return {
                index: null == c ? 0 : c,
                qa: W(b, 2),
                label: null != S(b, 3) ? Rb(S(b, 3), "") : void 0,
                displayName: null != S(b, 4) ? Rb(S(b, 4), "") : void 0
            };
        });
    }
    function Vc(a) {
        return {
            x: W(a, 1),
            y: W(a, 2),
            z: W(a, 3),
            visibility: null != Mb(a, 4) ? W(a, 4) : void 0
        };
    }
    function Wc(a, b) {
        this.i = a;
        this.h = b;
        this.m = 0;
    }
    function Xc(a, b, c) {
        Yc(a, b);
        if ("function" === typeof a.h.canvas.transferToImageBitmap) return Promise.resolve(a.h.canvas.transferToImageBitmap());
        if (c) return Promise.resolve(a.h.canvas);
        if ("function" === typeof createImageBitmap) return createImageBitmap(a.h.canvas);
        void 0 === a.j && (a.j = document.createElement("canvas"));
        return new Promise(function(d) {
            a.j.height = a.h.canvas.height;
            a.j.width = a.h.canvas.width;
            a.j.getContext("2d", {}).drawImage(a.h.canvas, 0, 0, a.h.canvas.width, a.h.canvas.height);
            d(a.j);
        });
    }
    function Yc(a, b) {
        var c = a.h;
        if (void 0 === a.s) {
            var d = Tc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = Tc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
            c.attachShader(g, d);
            c.attachShader(g, e);
            c.linkProgram(g);
            if (!c.getProgramParameter(g, c.LINK_STATUS)) throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
            d = a.s = g;
            c.useProgram(d);
            e = c.getUniformLocation(d, "sampler0");
            a.l = {
                O: c.getAttribLocation(d, "aVertex"),
                N: c.getAttribLocation(d, "aTex"),
                ya: e
            };
            a.v = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, a.v);
            c.enableVertexAttribArray(a.l.O);
            c.vertexAttribPointer(a.l.O, 2, c.FLOAT, !1, 0, 0);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                -1,
                -1,
                -1,
                1,
                1,
                1,
                1,
                -1
            ]), c.STATIC_DRAW);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            a.u = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, a.u);
            c.enableVertexAttribArray(a.l.N);
            c.vertexAttribPointer(a.l.N, 2, c.FLOAT, !1, 0, 0);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array([
                0,
                1,
                0,
                0,
                1,
                0,
                1,
                1
            ]), c.STATIC_DRAW);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            c.uniform1i(e, 0);
        }
        d = a.l;
        c.useProgram(a.s);
        c.canvas.width = b.width;
        c.canvas.height = b.height;
        c.viewport(0, 0, b.width, b.height);
        c.activeTexture(c.TEXTURE0);
        a.i.bindTexture2d(b.glName);
        c.enableVertexAttribArray(d.O);
        c.bindBuffer(c.ARRAY_BUFFER, a.v);
        c.vertexAttribPointer(d.O, 2, c.FLOAT, !1, 0, 0);
        c.enableVertexAttribArray(d.N);
        c.bindBuffer(c.ARRAY_BUFFER, a.u);
        c.vertexAttribPointer(d.N, 2, c.FLOAT, !1, 0, 0);
        c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
        c.clearColor(0, 0, 0, 0);
        c.clear(c.COLOR_BUFFER_BIT);
        c.colorMask(!0, !0, !0, !0);
        c.drawArrays(c.TRIANGLE_FAN, 0, 4);
        c.disableVertexAttribArray(d.O);
        c.disableVertexAttribArray(d.N);
        c.bindBuffer(c.ARRAY_BUFFER, null);
        a.i.bindTexture2d(0);
    }
    function Zc(a) {
        this.h = a;
    }
    var $c = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        2,
        1,
        0,
        10,
        9,
        1,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    function ad(a, b) {
        return b + a;
    }
    function bd(a, b) {
        window[a] = b;
    }
    function cd(a) {
        var b = document.createElement("script");
        b.setAttribute("src", a);
        b.setAttribute("crossorigin", "anonymous");
        return new Promise(function(c) {
            b.addEventListener("load", function() {
                c();
            }, !1);
            b.addEventListener("error", function() {
                c();
            }, !1);
            document.body.appendChild(b);
        });
    }
    function dd() {
        return E(function(a) {
            switch(a.h){
                case 1:
                    return a.s = 2, D(a, WebAssembly.instantiate($c), 4);
                case 4:
                    a.h = 3;
                    a.s = 0;
                    break;
                case 2:
                    return a.s = 0, a.l = null, a.return(!1);
                case 3:
                    return a.return(!0);
            }
        });
    }
    function ed(a) {
        this.h = a;
        this.listeners = {};
        this.l = {};
        this.L = {};
        this.s = {};
        this.v = {};
        this.M = this.u = this.ga = !0;
        this.I = Promise.resolve();
        this.fa = "";
        this.D = {};
        this.locateFile = a && a.locateFile || ad;
        if ("object" === typeof window) var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
        else if ("undefined" !== typeof location) b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
        else throw Error("solutions can only be loaded on a web page or in a web worker");
        this.ha = b;
        if (a.options) {
            b = A(Object.keys(a.options));
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = a.options[c].default;
                void 0 !== d && (this.l[c] = "function" === typeof d ? d() : d);
            }
        }
    }
    x = ed.prototype;
    x.close = function() {
        this.j && this.j.delete();
        return Promise.resolve();
    };
    function fd(a) {
        var b, c, d, e, g, f, h, k, l, m, r;
        return E(function(p) {
            switch(p.h){
                case 1:
                    if (!a.ga) return p.return();
                    b = void 0 === a.h.files ? [] : "function" === typeof a.h.files ? a.h.files(a.l) : a.h.files;
                    return D(p, dd(), 2);
                case 2:
                    c = p.i;
                    if ("object" === typeof window) return bd("createMediapipeSolutionsWasm", {
                        locateFile: a.locateFile
                    }), bd("createMediapipeSolutionsPackedAssets", {
                        locateFile: a.locateFile
                    }), f = b.filter(function(n) {
                        return void 0 !== n.data;
                    }), h = b.filter(function(n) {
                        return void 0 === n.data;
                    }), k = Promise.all(f.map(function(n) {
                        var q = gd(a, n.url);
                        if (void 0 !== n.path) {
                            var t = n.path;
                            q = q.then(function(w) {
                                a.overrideFile(t, w);
                                return Promise.resolve(w);
                            });
                        }
                        return q;
                    })), l = Promise.all(h.map(function(n) {
                        return void 0 === n.simd || n.simd && c || !n.simd && !c ? cd(a.locateFile(n.url, a.ha)) : Promise.resolve();
                    })).then(function() {
                        var n, q, t;
                        return E(function(w) {
                            if (1 == w.h) return n = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, D(w, n(q), 2);
                            t.i = w.i;
                            w.h = 0;
                        });
                    }), m = function() {
                        return E(function(n) {
                            a.h.graph && a.h.graph.url ? n = D(n, gd(a, a.h.graph.url), 0) : (n.h = 0, n = void 0);
                            return n;
                        });
                    }(), D(p, Promise.all([
                        l,
                        k,
                        m
                    ]), 7);
                    if ("function" !== typeof importScripts) throw Error("solutions can only be loaded on a web page or in a web worker");
                    d = b.filter(function(n) {
                        return void 0 === n.simd || n.simd && c || !n.simd && !c;
                    }).map(function(n) {
                        return a.locateFile(n.url, a.ha);
                    });
                    importScripts.apply(null, ea(d));
                    e = a;
                    return D(p, createMediapipeSolutionsWasm(Module), 6);
                case 6:
                    e.i = p.i;
                    a.m = new OffscreenCanvas(1, 1);
                    a.i.canvas = a.m;
                    g = a.i.GL.createContext(a.m, {
                        antialias: !1,
                        alpha: !1,
                        va: "undefined" !== typeof WebGL2RenderingContext ? 2 : 1
                    });
                    a.i.GL.makeContextCurrent(g);
                    p.h = 4;
                    break;
                case 7:
                    a.m = document.createElement("canvas");
                    r = a.m.getContext("webgl2", {});
                    if (!r && (r = a.m.getContext("webgl", {}), !r)) return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
                    a.K = r;
                    a.i.canvas = a.m;
                    a.i.createContext(a.m, !0, !0, {});
                case 4:
                    a.j = new a.i.SolutionWasm, a.ga = !1, p.h = 0;
            }
        });
    }
    function hd(a) {
        var b, c, d, e, g, f, h, k;
        return E(function(l) {
            if (1 == l.h) {
                if (a.h.graph && a.h.graph.url && a.fa === a.h.graph.url) return l.return();
                a.u = !0;
                if (!a.h.graph || !a.h.graph.url) {
                    l.h = 2;
                    return;
                }
                a.fa = a.h.graph.url;
                return D(l, gd(a, a.h.graph.url), 3);
            }
            2 != l.h && (b = l.i, a.j.loadGraph(b));
            c = A(Object.keys(a.D));
            for(d = c.next(); !d.done; d = c.next())e = d.value, a.j.overrideFile(e, a.D[e]);
            a.D = {};
            if (a.h.listeners) for(g = A(a.h.listeners), f = g.next(); !f.done; f = g.next())h = f.value, id(a, h);
            k = a.l;
            a.l = {};
            a.setOptions(k);
            l.h = 0;
        });
    }
    x.reset = function() {
        var a = this;
        return E(function(b) {
            a.j && (a.j.reset(), a.s = {}, a.v = {});
            b.h = 0;
        });
    };
    x.setOptions = function(a, b) {
        var c = this;
        if (b = b || this.h.options) {
            for(var d = [], e = [], g = {}, f = A(Object.keys(a)), h = f.next(); !h.done; g = {
                X: g.X,
                Y: g.Y
            }, h = f.next())if (h = h.value, !(h in this.l && this.l[h] === a[h])) {
                this.l[h] = a[h];
                var k = b[h];
                void 0 !== k && (k.onChange && (g.X = k.onChange, g.Y = a[h], d.push(function(l) {
                    return function() {
                        var m;
                        return E(function(r) {
                            if (1 == r.h) return D(r, l.X(l.Y), 2);
                            m = r.i;
                            !0 === m && (c.u = !0);
                            r.h = 0;
                        });
                    };
                }(g))), k.graphOptionXref && (h = Object.assign({}, {
                    calculatorName: "",
                    calculatorIndex: 0
                }, k.graphOptionXref, {
                    valueNumber: 1 === k.type ? a[h] : 0,
                    valueBoolean: 0 === k.type ? a[h] : !1,
                    valueString: 2 === k.type ? a[h] : ""
                }), e.push(h)));
            }
            if (0 !== d.length || 0 !== e.length) this.u = !0, this.H = (void 0 === this.H ? [] : this.H).concat(e), this.F = (void 0 === this.F ? [] : this.F).concat(d);
        }
    };
    function jd(a) {
        var b, c, d, e, g, f, h;
        return E(function(k) {
            switch(k.h){
                case 1:
                    if (!a.u) return k.return();
                    if (!a.F) {
                        k.h = 2;
                        break;
                    }
                    b = A(a.F);
                    c = b.next();
                case 3:
                    if (c.done) {
                        k.h = 5;
                        break;
                    }
                    d = c.value;
                    return D(k, d(), 4);
                case 4:
                    c = b.next();
                    k.h = 3;
                    break;
                case 5:
                    a.F = void 0;
                case 2:
                    if (a.H) {
                        e = new a.i.GraphOptionChangeRequestList;
                        g = A(a.H);
                        for(f = g.next(); !f.done; f = g.next())h = f.value, e.push_back(h);
                        a.j.changeOptions(e);
                        e.delete();
                        a.H = void 0;
                    }
                    a.u = !1;
                    k.h = 0;
            }
        });
    }
    x.initialize = function() {
        var a = this;
        return E(function(b) {
            return 1 == b.h ? D(b, fd(a), 2) : 3 != b.h ? D(b, hd(a), 3) : D(b, jd(a), 0);
        });
    };
    function gd(a, b) {
        var c, d;
        return E(function(e) {
            if (b in a.L) return e.return(a.L[b]);
            c = a.locateFile(b, "");
            d = fetch(c).then(function(g) {
                return g.arrayBuffer();
            });
            a.L[b] = d;
            return e.return(d);
        });
    }
    x.overrideFile = function(a, b) {
        this.j ? this.j.overrideFile(a, b) : this.D[a] = b;
    };
    x.clearOverriddenFiles = function() {
        this.D = {};
        this.j && this.j.clearOverriddenFiles();
    };
    x.send = function(a, b) {
        var c = this, d, e, g, f, h, k, l, m, r;
        return E(function(p) {
            switch(p.h){
                case 1:
                    if (!c.h.inputs) return p.return();
                    d = 1E3 * (void 0 === b || null === b ? performance.now() : b);
                    return D(p, c.I, 2);
                case 2:
                    return D(p, c.initialize(), 3);
                case 3:
                    e = new c.i.PacketDataList;
                    g = A(Object.keys(a));
                    for(f = g.next(); !f.done; f = g.next())if (h = f.value, k = c.h.inputs[h]) {
                        a: {
                            var n = a[h];
                            switch(k.type){
                                case "video":
                                    var q = c.s[k.stream];
                                    q || (q = new Wc(c.i, c.K), c.s[k.stream] = q);
                                    0 === q.m && (q.m = q.i.createTexture());
                                    if ("undefined" !== typeof HTMLVideoElement && n instanceof HTMLVideoElement) {
                                        var t = n.videoWidth;
                                        var w = n.videoHeight;
                                    } else "undefined" !== typeof HTMLImageElement && n instanceof HTMLImageElement ? (t = n.naturalWidth, w = n.naturalHeight) : (t = n.width, w = n.height);
                                    w = {
                                        glName: q.m,
                                        width: t,
                                        height: w
                                    };
                                    t = q.h;
                                    t.canvas.width = w.width;
                                    t.canvas.height = w.height;
                                    t.activeTexture(t.TEXTURE0);
                                    q.i.bindTexture2d(q.m);
                                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n);
                                    q.i.bindTexture2d(0);
                                    q = w;
                                    break a;
                                case "detections":
                                    q = c.s[k.stream];
                                    q || (q = new Zc(c.i), c.s[k.stream] = q);
                                    q.data || (q.data = new q.h.DetectionListData);
                                    q.data.reset(n.length);
                                    for(w = 0; w < n.length; ++w){
                                        t = n[w];
                                        var v = q.data, B = v.setBoundingBox, J = w;
                                        var I = t.la;
                                        var u = new Qc;
                                        V(u, 1, I.sa);
                                        V(u, 2, I.ta);
                                        V(u, 3, I.height);
                                        V(u, 4, I.width);
                                        V(u, 5, I.rotation);
                                        U(u, 6, I.pa);
                                        I = u.l();
                                        B.call(v, J, I);
                                        if (t.ea) for(v = 0; v < t.ea.length; ++v){
                                            u = t.ea[v];
                                            B = q.data;
                                            J = B.addNormalizedLandmark;
                                            I = w;
                                            u = Object.assign({}, u, {
                                                visibility: u.visibility ? u.visibility : 0
                                            });
                                            var C = new Lc;
                                            V(C, 1, u.x);
                                            V(C, 2, u.y);
                                            V(C, 3, u.z);
                                            u.visibility && V(C, 4, u.visibility);
                                            u = C.l();
                                            J.call(B, I, u);
                                        }
                                        if (t.ba) for(v = 0; v < t.ba.length; ++v)B = q.data, J = B.addClassification, I = w, u = t.ba[v], C = new Z, V(C, 2, u.qa), u.index && U(C, 1, u.index), u.label && U(C, 3, u.label), u.displayName && U(C, 4, u.displayName), u = C.l(), J.call(B, I, u);
                                    }
                                    q = q.data;
                                    break a;
                                default:
                                    q = {};
                            }
                        }
                        l = q;
                        m = k.stream;
                        switch(k.type){
                            case "video":
                                e.pushTexture2d(Object.assign({}, l, {
                                    stream: m,
                                    timestamp: d
                                }));
                                break;
                            case "detections":
                                r = l;
                                r.stream = m;
                                r.timestamp = d;
                                e.pushDetectionList(r);
                                break;
                            default:
                                throw Error("Unknown input config type: '" + k.type + "'");
                        }
                    }
                    c.j.send(e);
                    return D(p, c.I, 4);
                case 4:
                    e.delete(), p.h = 0;
            }
        });
    };
    function kd(a, b, c) {
        var d, e, g, f, h, k, l, m, r, p, n, q, t, w;
        return E(function(v) {
            switch(v.h){
                case 1:
                    if (!c) return v.return(b);
                    d = {};
                    e = 0;
                    g = A(Object.keys(c));
                    for(f = g.next(); !f.done; f = g.next())h = f.value, k = c[h], "string" !== typeof k && "texture" === k.type && void 0 !== b[k.stream] && ++e;
                    1 < e && (a.M = !1);
                    l = A(Object.keys(c));
                    f = l.next();
                case 2:
                    if (f.done) {
                        v.h = 4;
                        break;
                    }
                    m = f.value;
                    r = c[m];
                    if ("string" === typeof r) return t = d, w = m, D(v, ld(a, m, b[r]), 14);
                    p = b[r.stream];
                    if ("detection_list" === r.type) {
                        if (p) {
                            var B = p.getRectList();
                            for(var J = p.getLandmarksList(), I = p.getClassificationsList(), u = [], C = 0; C < B.size(); ++C){
                                var T = Sc(B.get(C)), od = W(T, 1), pd = W(T, 2), qd = W(T, 3), rd = W(T, 4), sd = W(T, 5, 0), za = void 0;
                                za = void 0 === za ? 0 : za;
                                T = {
                                    la: {
                                        sa: od,
                                        ta: pd,
                                        height: qd,
                                        width: rd,
                                        rotation: sd,
                                        pa: Rb(S(T, 6), za)
                                    },
                                    ea: Ob(Pc(J.get(C)), Lc, 1).map(Vc),
                                    ba: Uc(Kc(I.get(C)))
                                };
                                u.push(T);
                            }
                            B = u;
                        } else B = [];
                        d[m] = B;
                        v.h = 7;
                        break;
                    }
                    if ("proto_list" === r.type) {
                        if (p) {
                            B = Array(p.size());
                            for(J = 0; J < p.size(); J++)B[J] = p.get(J);
                            p.delete();
                        } else B = [];
                        d[m] = B;
                        v.h = 7;
                        break;
                    }
                    if (void 0 === p) {
                        v.h = 3;
                        break;
                    }
                    if ("float_list" === r.type) {
                        d[m] = p;
                        v.h = 7;
                        break;
                    }
                    if ("proto" === r.type) {
                        d[m] = p;
                        v.h = 7;
                        break;
                    }
                    if ("texture" !== r.type) throw Error("Unknown output config type: '" + r.type + "'");
                    n = a.v[m];
                    n || (n = new Wc(a.i, a.K), a.v[m] = n);
                    return D(v, Xc(n, p, a.M), 13);
                case 13:
                    q = v.i, d[m] = q;
                case 7:
                    r.transform && d[m] && (d[m] = r.transform(d[m]));
                    v.h = 3;
                    break;
                case 14:
                    t[w] = v.i;
                case 3:
                    f = l.next();
                    v.h = 2;
                    break;
                case 4:
                    return v.return(d);
            }
        });
    }
    function ld(a, b, c) {
        var d;
        return E(function(e) {
            return "number" === typeof c || c instanceof Uint8Array || c instanceof a.i.Uint8BlobList ? e.return(c) : c instanceof a.i.Texture2dDataOut ? (d = a.v[b], d || (d = new Wc(a.i, a.K), a.v[b] = d), e.return(Xc(d, c, a.M))) : e.return(void 0);
        });
    }
    function id(a, b) {
        for(var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.i.StringList, g = A(b.wants), f = g.next(); !f.done; f = g.next())e.push_back(f.value);
        g = a.i.PacketListener.implement({
            onResults: function(h) {
                for(var k = {}, l = 0; l < b.wants.length; ++l)k[d[l]] = h.get(l);
                var m = a.listeners[c];
                m && (a.I = kd(a, k, b.outs).then(function(r) {
                    r = m(r);
                    for(var p = 0; p < b.wants.length; ++p){
                        var n = k[d[p]];
                        "object" === typeof n && n.hasOwnProperty && n.hasOwnProperty("delete") && n.delete();
                    }
                    r && (a.I = r);
                }));
            }
        });
        a.j.attachMultiListener(e, g);
        e.delete();
    }
    x.onResults = function(a, b) {
        this.listeners[b || "$"] = a;
    };
    Aa("Solution", ed);
    Aa("OptionType", {
        BOOL: 0,
        NUMBER: 1,
        ua: 2,
        0: "BOOL",
        1: "NUMBER",
        2: "STRING"
    });
    function md(a) {
        void 0 === a && (a = 0);
        switch(a){
            case 1:
                return "selfie_segmentation_landscape.tflite";
            default:
                return "selfie_segmentation.tflite";
        }
    }
    function nd(a) {
        var b = this;
        a = a || {};
        this.h = new ed({
            locateFile: a.locateFile,
            files: function(c) {
                return [
                    {
                        simd: !0,
                        url: "selfie_segmentation_solution_simd_wasm_bin.js"
                    },
                    {
                        simd: !1,
                        url: "selfie_segmentation_solution_wasm_bin.js"
                    },
                    {
                        data: !0,
                        url: md(c.modelSelection)
                    }
                ];
            },
            graph: {
                url: "selfie_segmentation.binarypb"
            },
            listeners: [
                {
                    wants: [
                        "segmentation_mask",
                        "image_transformed"
                    ],
                    outs: {
                        image: {
                            type: "texture",
                            stream: "image_transformed"
                        },
                        segmentationMask: {
                            type: "texture",
                            stream: "segmentation_mask"
                        }
                    }
                }
            ],
            inputs: {
                image: {
                    type: "video",
                    stream: "input_frames_gpu"
                }
            },
            options: {
                useCpuInference: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "InferenceCalculator",
                        fieldName: "use_cpu_inference"
                    },
                    default: "object" !== typeof window || void 0 === window.navigator ? !1 : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                },
                selfieMode: {
                    type: 0,
                    graphOptionXref: {
                        calculatorType: "GlScalerCalculator",
                        calculatorIndex: 1,
                        fieldName: "flip_horizontal"
                    }
                },
                modelSelection: {
                    type: 1,
                    graphOptionXref: {
                        calculatorType: "ConstantSidePacketCalculator",
                        calculatorName: "ConstantSidePacketCalculatorModelSelection",
                        fieldName: "int_value"
                    },
                    onChange: function(c) {
                        var d, e, g;
                        return E(function(f) {
                            if (1 == f.h) return d = md(c), e = "third_party/mediapipe/modules/selfie_segmentation/" + d, D(f, gd(b.h, d), 2);
                            g = f.i;
                            b.h.overrideFile(e, g);
                            return f.return(!0);
                        });
                    }
                }
            }
        });
    }
    x = nd.prototype;
    x.close = function() {
        this.h.close();
        return Promise.resolve();
    };
    x.onResults = function(a) {
        this.h.onResults(a);
    };
    x.initialize = function() {
        var a = this;
        return E(function(b) {
            return D(b, a.h.initialize(), 0);
        });
    };
    x.reset = function() {
        this.h.reset();
    };
    x.send = function(a) {
        var b = this;
        return E(function(c) {
            return D(c, b.h.send(a), 0);
        });
    };
    x.setOptions = function(a) {
        this.h.setOptions(a);
    };
    Aa("SelfieSegmentation", nd);
    Aa("VERSION", "0.1.1675465747");
}).call($f5e8984c016ca24a$exports);


var $325200b03e780f5a$var$R = function(t, e) {
    return $325200b03e780f5a$var$R = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
    }, $325200b03e780f5a$var$R(t, e);
};
function $325200b03e780f5a$var$F(t, e) {
    function n() {
        this.constructor = t;
    }
    $325200b03e780f5a$var$R(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
}
var $325200b03e780f5a$var$C = function() {
    return $325200b03e780f5a$var$C = Object.assign || function(t) {
        for(var e, n = 1, r = arguments.length; n < r; n++)for(var i in e = arguments[n])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
    }, $325200b03e780f5a$var$C.apply(this, arguments);
};
function $325200b03e780f5a$var$D(t, e, n, r) {
    return new (n || (n = Promise))(function(i, o) {
        function a(t) {
            try {
                u(r.next(t));
            } catch (t) {
                o(t);
            }
        }
        function s(t) {
            try {
                u(r.throw(t));
            } catch (t) {
                o(t);
            }
        }
        function u(t) {
            var e;
            t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function(t) {
                t(e);
            })).then(a, s);
        }
        u((r = r.apply(t, e || [])).next());
    });
}
function $325200b03e780f5a$var$B(t, e) {
    var n, r, i, o, a = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function s(o) {
        return function(s) {
            return function(o) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch(r = 0, i && (o = [
                        2 & o[0],
                        i.value
                    ]), o[0]){
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return a.label++, {
                                value: o[1],
                                done: !1
                            };
                        case 5:
                            a.label++, r = o[1], o = [
                                0
                            ];
                            continue;
                        case 7:
                            o = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                a.label = o[1];
                                break;
                            }
                            if (6 === o[0] && a.label < i[1]) {
                                a.label = i[1], i = o;
                                break;
                            }
                            if (i && a.label < i[2]) {
                                a.label = i[2], a.ops.push(o);
                                break;
                            }
                            i[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    o = e.call(t, a);
                } catch (t) {
                    o = [
                        6,
                        t
                    ], r = 0;
                } finally{
                    n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                    value: o[0] ? o[1] : void 0,
                    done: !0
                };
            }([
                o,
                s
            ]);
        };
    }
}
function $325200b03e780f5a$var$L(t) {
    return t instanceof SVGAnimatedLength ? t.baseVal.value : t;
}
function $325200b03e780f5a$var$z(t) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var r, i;
        return $325200b03e780f5a$var$B(this, function(o) {
            switch(o.label){
                case 0:
                    return r = document.createElement("canvas"), t instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? [
                        4,
                        (0, $90849bbe88a0108e$exports).toPixels(t, r)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    return o.sent(), [
                        3,
                        3
                    ];
                case 2:
                    r.width = $325200b03e780f5a$var$L(t.width), r.height = $325200b03e780f5a$var$L(t.height), i = r.getContext("2d"), t instanceof ImageData ? i.putImageData(t, 0, 0) : i.drawImage(t, 0, 0), o.label = 3;
                case 3:
                    return [
                        2,
                        r
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$W(t) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var r, i, o, a, s, u;
        return $325200b03e780f5a$var$B(this, function(f) {
            switch(f.label){
                case 0:
                    return t instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? (r = t.shape.slice(0, 2), i = r[0], o = r[1], a = ImageData.bind, [
                        4,
                        (0, $90849bbe88a0108e$exports).toPixels(t)
                    ]) : [
                        3,
                        2
                    ];
                case 1:
                    return [
                        2,
                        new (a.apply(ImageData, [
                            void 0,
                            f.sent(),
                            o,
                            i
                        ]))
                    ];
                case 2:
                    return s = document.createElement("canvas"), u = s.getContext("2d"), s.width = $325200b03e780f5a$var$L(t.width), s.height = $325200b03e780f5a$var$L(t.height), u.drawImage(t, 0, 0), [
                        2,
                        u.getImageData(0, 0, s.width, s.height)
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$j(t) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var e, r;
        return $325200b03e780f5a$var$B(this, function(i) {
            switch(i.label){
                case 0:
                    return t instanceof SVGImageElement || t instanceof OffscreenCanvas ? [
                        4,
                        $325200b03e780f5a$var$z(t)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    return r = i.sent(), [
                        3,
                        3
                    ];
                case 2:
                    r = t, i.label = 3;
                case 3:
                    return e = r, [
                        2,
                        (0, $90849bbe88a0108e$exports).fromPixels(e, 4)
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$V(t) {
    if (t < 0 || t >= 256) throw new Error("Mask value must be in range [0, 255] but got " + t);
    if (!Number.isInteger(t)) throw new Error("Mask value must be an integer but got " + t);
}
var $325200b03e780f5a$var$K = [
    [
        110,
        64,
        170
    ],
    [
        143,
        61,
        178
    ],
    [
        178,
        60,
        178
    ],
    [
        210,
        62,
        167
    ],
    [
        238,
        67,
        149
    ],
    [
        255,
        78,
        125
    ],
    [
        255,
        94,
        99
    ],
    [
        255,
        115,
        75
    ],
    [
        255,
        140,
        56
    ],
    [
        239,
        167,
        47
    ],
    [
        217,
        194,
        49
    ],
    [
        194,
        219,
        64
    ],
    [
        175,
        240,
        91
    ],
    [
        135,
        245,
        87
    ],
    [
        96,
        247,
        96
    ],
    [
        64,
        243,
        115
    ],
    [
        40,
        234,
        141
    ],
    [
        28,
        219,
        169
    ],
    [
        26,
        199,
        194
    ],
    [
        33,
        176,
        213
    ],
    [
        47,
        150,
        224
    ],
    [
        65,
        125,
        224
    ],
    [
        84,
        101,
        214
    ],
    [
        99,
        81,
        195
    ]
];
function $325200b03e780f5a$export$28d0bd9091d7b2d1(t) {
    if ($325200b03e780f5a$var$V(t), t < $325200b03e780f5a$var$K.length) {
        var e = $325200b03e780f5a$var$K[t];
        return {
            r: e[0],
            g: e[1],
            b: e[2],
            a: 255
        };
    }
    throw new Error("Mask value must be in range [0, " + $325200b03e780f5a$var$K.length + ")");
}
function $325200b03e780f5a$var$q(t) {
    var e = t.shape[2], n = (0, $dfa64f3fd949567e$export$7980a683c1b852b4)(t, 2), r = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(n, [
        -1
    ]);
    return (0, $d263ffd91bb8ab3a$export$341b5490a776d041)(r, e);
}
function $325200b03e780f5a$var$N(t, e) {
    return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
        return (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)((0, $8a3e558d5bb76a4c$export$9dca161faaf6308b)(t, (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(e)), "int32");
    });
}
function $325200b03e780f5a$var$Q(t, e) {
    var n = e.shape, o = n[0], s = n[1], m = n[2];
    return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
        var n = $325200b03e780f5a$var$q(e), r = (0, $db5bfab98435c6cf$export$d660d8ed21f46635)((0, $5d4db871afef7031$export$d02631cccf789723)(0, m, 1, "int32"), 1), g = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)((0, $7f1f3e54d78420da$export$6706882a873e9a8f)(n, r), "int32"), v = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(g, [
            o,
            s
        ]), w = (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(v, (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(1, "int32"));
        return (0, $555d660851b98db3$export$f93b5905241a7cca)(function(t, e) {
            return (0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(t, e);
        }(w, t), (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(1, "int32"));
    });
}
var $325200b03e780f5a$var$X = function() {
    function t(t, e) {
        this.model = t, this.outputStride = e;
        var n = this.model.inputs[0].shape;
        (0, $e10678764dab7ea0$exports).assert(-1 === n[1] && -1 === n[2], function() {
            return "Input shape [" + n[1] + ", " + n[2] + "] must both be equal to or -1";
        });
    }
    return t.prototype.predict = function(t) {
        var e = this;
        return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
            var n = e.preprocessInput((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(t, "float32")), r = (0, $db5bfab98435c6cf$export$d660d8ed21f46635)(n, 0), o = e.model.predict(r).map(function(t) {
                return (0, $f41010297af56801$export$889c931173b77c2f)(t, [
                    0
                ]);
            }), a = e.nameOutputResults(o);
            return {
                heatmapScores: (0, $e3381678584872cc$export$3b295495ca3cad7c)(a.heatmap),
                offsets: a.offsets,
                displacementFwd: a.displacementFwd,
                displacementBwd: a.displacementBwd,
                segmentation: a.segmentation,
                partHeatmaps: a.partHeatmaps,
                longOffsets: a.longOffsets,
                partOffsets: a.partOffsets
            };
        });
    }, t.prototype.dispose = function() {
        this.model.dispose();
    }, t;
}(), $325200b03e780f5a$var$Y = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $325200b03e780f5a$var$F(e, t), e.prototype.preprocessInput = function(t) {
        return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
            return (0, $555d660851b98db3$export$f93b5905241a7cca)((0, $15928a4fee5ff81f$export$159d9494db57879b)(t, 127.5), 1);
        });
    }, e.prototype.nameOutputResults = function(t) {
        return {
            offsets: t[0],
            segmentation: t[1],
            partHeatmaps: t[2],
            longOffsets: t[3],
            heatmap: t[4],
            displacementFwd: t[5],
            displacementBwd: t[6],
            partOffsets: t[7]
        };
    }, e;
}($325200b03e780f5a$var$X), $325200b03e780f5a$var$G = [
    "nose",
    "leftEye",
    "rightEye",
    "leftEar",
    "rightEar",
    "leftShoulder",
    "rightShoulder",
    "leftElbow",
    "rightElbow",
    "leftWrist",
    "rightWrist",
    "leftHip",
    "rightHip",
    "leftKnee",
    "rightKnee",
    "leftAnkle",
    "rightAnkle"
], $325200b03e780f5a$var$$ = $325200b03e780f5a$var$G.length, $325200b03e780f5a$var$J = $325200b03e780f5a$var$G.reduce(function(t, e, n) {
    return t[e] = n, t;
}, {});
[
    [
        "leftHip",
        "leftShoulder"
    ],
    [
        "leftElbow",
        "leftShoulder"
    ],
    [
        "leftElbow",
        "leftWrist"
    ],
    [
        "leftHip",
        "leftKnee"
    ],
    [
        "leftKnee",
        "leftAnkle"
    ],
    [
        "rightHip",
        "rightShoulder"
    ],
    [
        "rightElbow",
        "rightShoulder"
    ],
    [
        "rightElbow",
        "rightWrist"
    ],
    [
        "rightHip",
        "rightKnee"
    ],
    [
        "rightKnee",
        "rightAnkle"
    ],
    [
        "leftShoulder",
        "rightShoulder"
    ],
    [
        "leftHip",
        "rightHip"
    ]
].map(function(t) {
    var e = t[0], n = t[1];
    return [
        $325200b03e780f5a$var$J[e],
        $325200b03e780f5a$var$J[n]
    ];
});
function $325200b03e780f5a$var$Z(t, e, n) {
    var r = t[0], i = t[1], o = e[0], a = e[1], s = n.top, u = n.bottom;
    return [
        a / (n.left + n.right + i),
        o / (s + u + r)
    ];
}
function $325200b03e780f5a$var$tt(t, e, n, r) {
    return {
        y: r.get(t, e, n),
        x: r.get(t, e, n + $325200b03e780f5a$var$$)
    };
}
function $325200b03e780f5a$var$et(t, e, n) {
    var r = $325200b03e780f5a$var$tt(t.heatmapY, t.heatmapX, t.id, n), i = r.y, o = r.x;
    return {
        x: t.heatmapX * e + o,
        y: t.heatmapY * e + i
    };
}
function $325200b03e780f5a$var$nt(t, e, n) {
    return t < e ? e : t > n ? n : t;
}
function $325200b03e780f5a$var$rt(t, e) {
    return {
        x: t.x + e.x,
        y: t.y + e.y
    };
}
function $325200b03e780f5a$var$it(t, e, n) {
    void 0 === n && (n = .3);
    for(var r = 0, i = 0, o = 0; o < t.length; o++)e.keypoints[o].score > n && (i += 1, r += Math.pow(t[o].x - e.keypoints[o].position.x, 2) + Math.pow(t[o].y - e.keypoints[o].position.y, 2));
    return 0 === i ? r = 1 / 0 : r /= i, r;
}
function $325200b03e780f5a$var$ot(t, e, n, r, i, o, a) {
    for(var s = a[0], u = a[1], f = n(t), l = f.y * r + f.x, c = i[$325200b03e780f5a$var$$ * (2 * l) + e], d = i[$325200b03e780f5a$var$$ * (2 * l + 1) + e], h = t.y + c, p = t.x + d, m = 0; m < o; m++){
        h = Math.min(h, s - 1);
        var g = n({
            x: p = Math.min(p, u - 1),
            y: h
        }), v = g.y * r + g.x;
        h += c = i[$325200b03e780f5a$var$$ * (2 * v) + e], p += d = i[$325200b03e780f5a$var$$ * (2 * v + 1) + e];
    }
    return {
        x: p,
        y: h
    };
}
function $325200b03e780f5a$var$at(t, e, n, r, i, o, a, s, u, f) {
    for(var l = i[0], c = i[1], d = o[0], h = o[1], p = s[0], m = s[1], g = [], v = function(t) {
        return function(t, e, n, r) {
            var i = e[0], o = e[1], a = n[0], s = n[1], u = Math.round(((i + t.y + 1) * s - 1) / r);
            return {
                x: Math.round(((o + t.x + 1) * a - 1) / r),
                y: u
            };
        }(t, [
            l,
            c
        ], [
            d,
            h
        ], u);
    }, w = 0; w < r; w++){
        var y = $325200b03e780f5a$var$ot(t, w, v, a, e, f, [
            p,
            m
        ]);
        g.push(y);
    }
    for(var b = -1, S = 1 / 0, x = 0; x < n.length; x++){
        var M = $325200b03e780f5a$var$it(g, n[x]);
        M < S && (b = x, S = M);
    }
    return b;
}
function $325200b03e780f5a$var$st(t, e) {
    var n = t[0], r = t[1];
    return [
        Math.round((r - 1) / e + 1),
        Math.round((n - 1) / e + 1)
    ];
}
function $325200b03e780f5a$var$ut(t, e, n, r, i, o, a, s, u, f, l) {
    for(var d = a[0], h = a[1], p = t.shape, m = p[0], g = p[1], v = e.shape.slice(0, 2), w = v[0], y = v[1], x = (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(e, [
        w,
        y,
        2,
        $325200b03e780f5a$var$$
    ]), M = new Float32Array(l * $325200b03e780f5a$var$$ * 3).fill(0), k = 0; k < n.length; k++)for(var E = k * $325200b03e780f5a$var$$ * 3, T = n[k], P = 0; P < $325200b03e780f5a$var$$; P++){
        var I = T.keypoints[P], O = E + 3 * P;
        M[O] = I.score, M[O + 1] = I.position.y, M[O + 2] = I.position.x;
    }
    var _ = $325200b03e780f5a$var$Z([
        r,
        i
    ], [
        d,
        h
    ], s), H = _[0], A = _[1], R = (0, $a82c6773538d9e64$export$65df3ad1ad888abb)(M, [
        l,
        $325200b03e780f5a$var$$,
        3
    ]), F = s.top, C = s.left, D = {
        variableNames: [
            "segmentation",
            "longOffsets",
            "poses"
        ],
        outputShape: [
            m,
            g
        ],
        userCode: "\n    int convertToPositionInOutput(int pos, int pad, float scale, int stride) {\n      return round(((float(pos + pad) + 1.0) * scale - 1.0) / float(stride));\n    }\n\n    float convertToPositionInOutputFloat(\n        int pos, int pad, float scale, int stride) {\n      return ((float(pos + pad) + 1.0) * scale - 1.0) / float(stride);\n    }\n\n    float dist(float x1, float y1, float x2, float y2) {\n      return pow(x1 - x2, 2.0) + pow(y1 - y2, 2.0);\n    }\n\n    float sampleLongOffsets(float h, float w, int d, int k) {\n      float fh = fract(h);\n      float fw = fract(w);\n      int clH = int(ceil(h));\n      int clW = int(ceil(w));\n      int flH = int(floor(h));\n      int flW = int(floor(w));\n      float o11 = getLongOffsets(flH, flW, d, k);\n      float o12 = getLongOffsets(flH, clW, d, k);\n      float o21 = getLongOffsets(clH, flW, d, k);\n      float o22 = getLongOffsets(clH, clW, d, k);\n      float o1 = mix(o11, o12, fw);\n      float o2 = mix(o21, o22, fw);\n      return mix(o1, o2, fh);\n    }\n\n    int findNearestPose(int h, int w) {\n      float prob = getSegmentation(h, w);\n      if (prob < 1.0) {\n        return -1;\n      }\n\n      // Done(Tyler): convert from output space h/w to strided space.\n      float stridedH = convertToPositionInOutputFloat(\n        h, " + F + ", " + A + ", " + o + ");\n      float stridedW = convertToPositionInOutputFloat(\n        w, " + C + ", " + H + ", " + o + ");\n\n      float minDist = 1000000.0;\n      int iMin = -1;\n      for (int i = 0; i < " + l + "; i++) {\n        float curDistSum = 0.0;\n        int numKpt = 0;\n        for (int k = 0; k < " + $325200b03e780f5a$var$$ + "; k++) {\n          float dy = sampleLongOffsets(stridedH, stridedW, 0, k);\n          float dx = sampleLongOffsets(stridedH, stridedW, 1, k);\n\n          float y = float(h) + dy;\n          float x = float(w) + dx;\n\n          for (int s = 0; s < " + u + "; s++) {\n            int yRounded = round(min(y, float(" + (r - 1) + ")));\n            int xRounded = round(min(x, float(" + (i - 1) + ")));\n\n            float yStrided = convertToPositionInOutputFloat(\n              yRounded, " + F + ", " + A + ", " + o + ");\n            float xStrided = convertToPositionInOutputFloat(\n              xRounded, " + C + ", " + H + ", " + o + ");\n\n            float dy = sampleLongOffsets(yStrided, xStrided, 0, k);\n            float dx = sampleLongOffsets(yStrided, xStrided, 1, k);\n\n            y = y + dy;\n            x = x + dx;\n          }\n\n          float poseScore = getPoses(i, k, 0);\n          float poseY = getPoses(i, k, 1);\n          float poseX = getPoses(i, k, 2);\n          if (poseScore > " + f + ") {\n            numKpt = numKpt + 1;\n            curDistSum = curDistSum + dist(x, y, poseX, poseY);\n          }\n        }\n        if (numKpt > 0 && curDistSum / float(numKpt) < minDist) {\n          minDist = curDistSum / float(numKpt);\n          iMin = i;\n        }\n      }\n      return iMin;\n    }\n\n    void main() {\n        ivec2 coords = getOutputCoords();\n        int nearestPose = findNearestPose(coords[0], coords[1]);\n        setOutput(float(nearestPose));\n      }\n  "
    };
    return (0, $8c449c89295c3cc4$export$32a253b6f8b50fb4)().compileAndRun(D, [
        t,
        x,
        R
    ]);
}
function $325200b03e780f5a$var$ft() {
    return "webgl" === (0, $8c449c89295c3cc4$export$b098501f764cdf30)();
}
function $325200b03e780f5a$var$lt(t, e, n, o, s, u, f, l, c, d, h, p) {
    var m = f[0], g = f[1];
    return void 0 === c && (c = .2), void 0 === d && (d = 8), void 0 === h && (h = .3), void 0 === p && (p = 10), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var f, v, w, y, b;
        return $325200b03e780f5a$var$B(this, function(S) {
            switch(S.label){
                case 0:
                    return f = n.filter(function(t) {
                        return t.score >= c;
                    }), $325200b03e780f5a$var$ft() ? (w = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
                        var n = $325200b03e780f5a$var$ut(t, e, f, o, s, u, [
                            m,
                            g
                        ], l, d, h, p), c = (0, $8c449c89295c3cc4$export$d3c662a6136faebb)().makeTensorFromDataId(n.dataId, n.shape, n.dtype);
                        return f.map(function(t, e) {
                            return function(t, e) {
                                return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
                                    return (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)((0, $5b85025852d3ccbe$export$411ce8e5a71e3069)(t, (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(e)), "int32");
                                });
                            }(c, e);
                        });
                    }), [
                        4,
                        Promise.all(w.map(function(t) {
                            return t.data();
                        }))
                    ]) : [
                        3,
                        2
                    ];
                case 1:
                    return v = S.sent(), w.forEach(function(t) {
                        return t.dispose();
                    }), [
                        3,
                        5
                    ];
                case 2:
                    return [
                        4,
                        t.data()
                    ];
                case 3:
                    return y = S.sent(), [
                        4,
                        e.data()
                    ];
                case 4:
                    b = S.sent(), v = function(t, e, n, r, i, o, a, s, u, f) {
                        var l = a[0], c = a[1];
                        void 0 === f && (f = 5);
                        for(var d = n.map(function(t) {
                            return new Uint8Array(r * i).fill(0);
                        }), h = s.top, p = s.left, m = $325200b03e780f5a$var$Z([
                            r,
                            i
                        ], [
                            l,
                            c
                        ], s), g = m[0], v = m[1], w = $325200b03e780f5a$var$st([
                            l,
                            c
                        ], o)[0], y = 0; y < r; y += 1)for(var b = 0; b < i; b += 1){
                            var S = y * i + b;
                            if (1 === t[S]) {
                                var x = $325200b03e780f5a$var$at({
                                    x: b,
                                    y: y
                                }, e, n, f, [
                                    h,
                                    p
                                ], [
                                    g,
                                    v
                                ], w, [
                                    r,
                                    i
                                ], o, u);
                                x >= 0 && (d[x][S] = 1);
                            }
                        }
                        return d;
                    }(y, b, f, o, s, u, [
                        m,
                        g
                    ], l, d), S.label = 5;
                case 5:
                    return [
                        2,
                        v.map(function(t, e) {
                            return {
                                data: t,
                                pose: f[e],
                                width: s,
                                height: o
                            };
                        })
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$ct(t, e, n, o, s, u, f, l, c, m, g, v, w) {
    var y = l[0], b = l[1];
    return void 0 === m && (m = .2), void 0 === g && (g = 8), void 0 === v && (v = .3), void 0 === w && (w = 10), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var l, S, x, E, T, P;
        return $325200b03e780f5a$var$B(this, function(I) {
            switch(I.label){
                case 0:
                    return l = o.filter(function(t) {
                        return t.score >= m;
                    }), $325200b03e780f5a$var$ft() ? (x = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
                        var o = $325200b03e780f5a$var$ut(t, e, l, s, u, f, [
                            y,
                            b
                        ], c, g, v, w), m = (0, $8c449c89295c3cc4$export$d3c662a6136faebb)().makeTensorFromDataId(o.dataId, o.shape, o.dtype);
                        return l.map(function(t, e) {
                            return function(t, e, n) {
                                return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
                                    return (0, $555d660851b98db3$export$f93b5905241a7cca)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)((0, $5b85025852d3ccbe$export$411ce8e5a71e3069)(t, (0, $2937f01f2600aea0$export$7de3fcd3cdba2a46)(n)), "int32"), (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(e, 1)), 1);
                                });
                            }(m, n, e);
                        });
                    }), [
                        4,
                        Promise.all(x.map(function(t) {
                            return t.data();
                        }))
                    ]) : [
                        3,
                        2
                    ];
                case 1:
                    return S = I.sent(), x.forEach(function(t) {
                        return t.dispose();
                    }), [
                        3,
                        6
                    ];
                case 2:
                    return [
                        4,
                        t.data()
                    ];
                case 3:
                    return E = I.sent(), [
                        4,
                        e.data()
                    ];
                case 4:
                    return T = I.sent(), [
                        4,
                        n.data()
                    ];
                case 5:
                    P = I.sent(), S = function(t, e, n, r, i, o, a, s, u, f, l) {
                        var c = s[0], d = s[1];
                        void 0 === l && (l = 5);
                        for(var h = r.map(function(t) {
                            return new Int32Array(i * o).fill(-1);
                        }), p = u.top, m = u.left, g = $325200b03e780f5a$var$Z([
                            i,
                            o
                        ], [
                            c,
                            d
                        ], u), v = g[0], w = g[1], y = $325200b03e780f5a$var$st([
                            c,
                            d
                        ], a)[0], b = 0; b < i; b += 1)for(var S = 0; S < o; S += 1){
                            var x = b * o + S;
                            if (1 === t[x]) {
                                var M = $325200b03e780f5a$var$at({
                                    x: S,
                                    y: b
                                }, e, r, l, [
                                    p,
                                    m
                                ], [
                                    v,
                                    w
                                ], y, [
                                    i,
                                    o
                                ], a, f);
                                M >= 0 && (h[M][x] = n[x]);
                            }
                        }
                        return h;
                    }(E, T, P, l, s, u, f, [
                        y,
                        b
                    ], c, g), I.label = 6;
                case 6:
                    return [
                        2,
                        S.map(function(t, e) {
                            return {
                                pose: l[e],
                                data: t,
                                height: s,
                                width: u
                            };
                        })
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$dt(t) {
    return Math.floor(t / 2);
}
var $325200b03e780f5a$var$ht = function() {
    function t(t, e) {
        this.priorityQueue = new Array(t), this.numberOfElements = -1, this.getElementValue = e;
    }
    return t.prototype.enqueue = function(t) {
        this.priorityQueue[++this.numberOfElements] = t, this.swim(this.numberOfElements);
    }, t.prototype.dequeue = function() {
        var t = this.priorityQueue[0];
        return this.exchange(0, this.numberOfElements--), this.sink(0), this.priorityQueue[this.numberOfElements + 1] = null, t;
    }, t.prototype.empty = function() {
        return -1 === this.numberOfElements;
    }, t.prototype.size = function() {
        return this.numberOfElements + 1;
    }, t.prototype.all = function() {
        return this.priorityQueue.slice(0, this.numberOfElements + 1);
    }, t.prototype.max = function() {
        return this.priorityQueue[0];
    }, t.prototype.swim = function(t) {
        for(; t > 0 && this.less($325200b03e780f5a$var$dt(t), t);)this.exchange(t, $325200b03e780f5a$var$dt(t)), t = $325200b03e780f5a$var$dt(t);
    }, t.prototype.sink = function(t) {
        for(; 2 * t <= this.numberOfElements;){
            var e = 2 * t;
            if (e < this.numberOfElements && this.less(e, e + 1) && e++, !this.less(t, e)) break;
            this.exchange(t, e), t = e;
        }
    }, t.prototype.getValueAt = function(t) {
        return this.getElementValue(this.priorityQueue[t]);
    }, t.prototype.less = function(t, e) {
        return this.getValueAt(t) < this.getValueAt(e);
    }, t.prototype.exchange = function(t, e) {
        var n = this.priorityQueue[t];
        this.priorityQueue[t] = this.priorityQueue[e], this.priorityQueue[e] = n;
    }, t;
}();
function $325200b03e780f5a$var$pt(t, e, n, r, i, o) {
    for(var a = o.shape, s = a[0], u = a[1], f = !0, l = Math.max(n - i, 0), c = Math.min(n + i + 1, s), d = l; d < c; ++d){
        for(var h = Math.max(r - i, 0), p = Math.min(r + i + 1, u), m = h; m < p; ++m)if (o.get(d, m, t) > e) {
            f = !1;
            break;
        }
        if (!f) break;
    }
    return f;
}
var $325200b03e780f5a$var$mt = [
    [
        "nose",
        "leftEye"
    ],
    [
        "leftEye",
        "leftEar"
    ],
    [
        "nose",
        "rightEye"
    ],
    [
        "rightEye",
        "rightEar"
    ],
    [
        "nose",
        "leftShoulder"
    ],
    [
        "leftShoulder",
        "leftElbow"
    ],
    [
        "leftElbow",
        "leftWrist"
    ],
    [
        "leftShoulder",
        "leftHip"
    ],
    [
        "leftHip",
        "leftKnee"
    ],
    [
        "leftKnee",
        "leftAnkle"
    ],
    [
        "nose",
        "rightShoulder"
    ],
    [
        "rightShoulder",
        "rightElbow"
    ],
    [
        "rightElbow",
        "rightWrist"
    ],
    [
        "rightShoulder",
        "rightHip"
    ],
    [
        "rightHip",
        "rightKnee"
    ],
    [
        "rightKnee",
        "rightAnkle"
    ]
].map(function(t) {
    var e = t[0], n = t[1];
    return [
        $325200b03e780f5a$var$J[e],
        $325200b03e780f5a$var$J[n]
    ];
}), $325200b03e780f5a$var$gt = $325200b03e780f5a$var$mt.map(function(t) {
    return t[1];
}), $325200b03e780f5a$var$vt = $325200b03e780f5a$var$mt.map(function(t) {
    return t[0];
});
function $325200b03e780f5a$var$wt(t, e, n, r) {
    return {
        y: $325200b03e780f5a$var$nt(Math.round(t.y / e), 0, n - 1),
        x: $325200b03e780f5a$var$nt(Math.round(t.x / e), 0, r - 1)
    };
}
function $325200b03e780f5a$var$yt(t, e, n, r, i, o, a, s) {
    void 0 === s && (s = 2);
    for(var u = r.shape, f = u[0], l = u[1], c = function(t, e, n) {
        var r = n.shape[2] / 2;
        return {
            y: n.get(e.y, e.x, t),
            x: n.get(e.y, e.x, r + t)
        };
    }(t, $325200b03e780f5a$var$wt(e.position, o, f, l), a), d = $325200b03e780f5a$var$rt(e.position, c), h = 0; h < s; h++){
        var p = $325200b03e780f5a$var$wt(d, o, f, l), m = $325200b03e780f5a$var$tt(p.y, p.x, n, i);
        d = $325200b03e780f5a$var$rt({
            x: p.x * o,
            y: p.y * o
        }, {
            x: m.x,
            y: m.y
        });
    }
    var g = $325200b03e780f5a$var$wt(d, o, f, l), v = r.get(g.y, g.x, n);
    return {
        position: d,
        part: $325200b03e780f5a$var$G[n],
        score: v
    };
}
function $325200b03e780f5a$var$bt(t, e, n, r, i, o) {
    var a = e.shape[2], s = $325200b03e780f5a$var$gt.length, u = new Array(a), f = t.part, l = t.score, c = $325200b03e780f5a$var$et(f, r, n);
    u[f.id] = {
        score: l,
        part: $325200b03e780f5a$var$G[f.id],
        position: c
    };
    for(var d = s - 1; d >= 0; --d){
        var h = $325200b03e780f5a$var$gt[d], p = $325200b03e780f5a$var$vt[d];
        u[h] && !u[p] && (u[p] = $325200b03e780f5a$var$yt(d, u[h], p, e, n, r, o));
    }
    for(d = 0; d < s; ++d){
        h = $325200b03e780f5a$var$vt[d], p = $325200b03e780f5a$var$gt[d];
        u[h] && !u[p] && (u[p] = $325200b03e780f5a$var$yt(d, u[h], p, e, n, r, i));
    }
    return u;
}
function $325200b03e780f5a$var$St(t, e, n, r) {
    var i = n.x, o = n.y;
    return t.some(function(t) {
        var n, a, s, u, f, l, c = t.keypoints[r].position;
        return n = o, a = i, s = c.y, u = c.x, (f = s - n) * f + (l = u - a) * l <= e;
    });
}
function $325200b03e780f5a$var$xt(t, e, n) {
    var r = n.reduce(function(n, r, i) {
        var o = r.position, a = r.score;
        return $325200b03e780f5a$var$St(t, e, o, i) || (n += a), n;
    }, 0);
    return r / n.length;
}
function $325200b03e780f5a$var$Mt(t, e, n, r, i, o, a, s) {
    void 0 === a && (a = .5), void 0 === s && (s = 20);
    for(var u = [], f = function(t, e, n) {
        for(var r = n.shape, i = r[0], o = r[1], a = r[2], s = new $325200b03e780f5a$var$ht(i * o * a, function(t) {
            return t.score;
        }), u = 0; u < i; ++u)for(var f = 0; f < o; ++f)for(var l = 0; l < a; ++l){
            var c = n.get(u, f, l);
            c < t || $325200b03e780f5a$var$pt(l, c, u, f, e, n) && s.enqueue({
                score: c,
                part: {
                    heatmapY: u,
                    heatmapX: f,
                    id: l
                }
            });
        }
        return s;
    }(a, 1, t), l = s * s; u.length < o && !f.empty();){
        var c = f.dequeue();
        if (!$325200b03e780f5a$var$St(u, l, $325200b03e780f5a$var$et(c.part, i, e), c.part.id)) {
            var d = $325200b03e780f5a$var$bt(c, t, e, i, n, r), h = $325200b03e780f5a$var$xt(u, l, d);
            u.push({
                keypoints: d,
                score: h
            });
        }
    }
    return u;
}
var $325200b03e780f5a$var$kt, $325200b03e780f5a$var$Et = [
    -123.15,
    -115.9,
    -103.06
], $325200b03e780f5a$var$Tt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $325200b03e780f5a$var$F(e, t), e.prototype.preprocessInput = function(t) {
        return (0, $c90bd95bc0e58efa$export$e16d8520af44a096)(t, $325200b03e780f5a$var$Et);
    }, e.prototype.nameOutputResults = function(t) {
        var e = t[0], n = t[1], r = t[2], i = t[3], o = t[4], a = t[5];
        return {
            offsets: o,
            segmentation: t[6],
            partHeatmaps: a,
            longOffsets: i,
            heatmap: r,
            displacementFwd: n,
            displacementBwd: e,
            partOffsets: t[7]
        };
    }, e;
}($325200b03e780f5a$var$X), $325200b03e780f5a$var$Pt = "https://storage.googleapis.com/tfjs-models/savedmodel/bodypix/resnet50/", $325200b03e780f5a$var$It = "https://storage.googleapis.com/tfjs-models/savedmodel/bodypix/mobilenet/";
function $325200b03e780f5a$var$Ot(t) {
    if ("undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof OffscreenCanvas && t instanceof OffscreenCanvas || "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement) return function(t) {
        if ("offsetHeight" in t && 0 !== t.offsetHeight && "offsetWidth" in t && 0 !== t.offsetWidth) return [
            t.offsetHeight,
            t.offsetWidth
        ];
        if (null != t.height && null != t.width) return [
            t.height,
            t.width
        ];
        throw new Error("HTMLImageElement must have height and width attributes set.");
    }(t);
    if ("undefined" != typeof ImageData && t instanceof ImageData) return [
        t.height,
        t.width
    ];
    if ("undefined" != typeof HTMLVideoElement && t instanceof HTMLVideoElement) return function(t) {
        return t.hasAttribute("height") && t.hasAttribute("width") ? [
            t.height,
            t.width
        ] : [
            t.videoHeight,
            t.videoWidth
        ];
    }(t);
    if (t instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814)) return [
        t.shape[0],
        t.shape[1]
    ];
    throw new Error("error: Unknown input type: " + t + ".");
}
function $325200b03e780f5a$var$_t(t, e) {
    return function(t, e) {
        return (t - 1) % e == 0;
    }(t, e) ? t : Math.floor(t / e) * e + 1;
}
var $325200b03e780f5a$var$Ht = {
    low: "low",
    medium: "medium",
    high: "high",
    full: "full"
}, $325200b03e780f5a$var$At = (($325200b03e780f5a$var$kt = {})[$325200b03e780f5a$var$Ht.low] = .25, $325200b03e780f5a$var$kt[$325200b03e780f5a$var$Ht.medium] = .5, $325200b03e780f5a$var$kt[$325200b03e780f5a$var$Ht.high] = .75, $325200b03e780f5a$var$kt[$325200b03e780f5a$var$Ht.full] = 1, $325200b03e780f5a$var$kt);
function $325200b03e780f5a$var$Rt(t, e, n) {
    var r = n[0], i = n[1], o = function(t) {
        if ("string" == typeof t) {
            var e = $325200b03e780f5a$var$At[t];
            return (0, $e10678764dab7ea0$exports).assert("number" == typeof e, function() {
                return "string value of inputResolution must be one of " + Object.values($325200b03e780f5a$var$Ht).join(",") + " but was " + t + ".";
            }), e;
        }
        return (0, $e10678764dab7ea0$exports).assert("number" == typeof t && t <= 2 && t >= .1, function() {
            return "inputResolution must be a string or number between 0.1 and 2, but was " + t;
        }), t;
    }(t);
    return [
        $325200b03e780f5a$var$_t(r * o, e),
        $325200b03e780f5a$var$_t(i * o, e)
    ];
}
function $325200b03e780f5a$var$Ft(t, e, n, i, o) {
    var a = e[0], s = e[1], f = n[0], l = n[1], c = i[0], d = c[0], h = c[1], p = i[1], m = p[0], w = p[1];
    return void 0 === o && (o = !1), (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
        var e = (0, $7912647d6e7a4ee9$export$5c452ff88e35e47d).resizeBilinear(t, [
            f,
            l
        ], !0);
        return o && (e = (0, $e3381678584872cc$export$3b295495ca3cad7c)(e)), function(t, e, n) {
            var i = e[0], o = e[1], a = n[0], s = a[0], f = a[1], l = n[1], c = l[0], d = l[1];
            return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
                var e = (0, $db5bfab98435c6cf$export$d660d8ed21f46635)(t);
                return (0, $f41010297af56801$export$889c931173b77c2f)((0, $7912647d6e7a4ee9$export$5c452ff88e35e47d).cropAndResize(e, [
                    [
                        s / (i + s + f - 1),
                        c / (o + c + d - 1),
                        (s + i - 1) / (i + s + f - 1),
                        (c + o - 1) / (o + c + d - 1)
                    ]
                ], [
                    0
                ], [
                    i,
                    o
                ]), [
                    0
                ]);
            });
        }(e, [
            a,
            s
        ], [
            [
                d,
                h
            ],
            [
                m,
                w
            ]
        ]);
    });
}
function $325200b03e780f5a$var$Ct(t, i) {
    var o = i[0], a = i[1], s = $325200b03e780f5a$var$Ot(t), u = s[0], f = s[1], l = a / o, c = [
        0,
        0,
        0,
        0
    ], d = c[0], h = c[1], p = c[2], m = c[3];
    f / u < l ? (d = 0, h = 0, p = Math.round(.5 * (l * u - f)), m = Math.round(.5 * (l * u - f))) : (d = Math.round(.5 * (1 / l * f - u)), h = Math.round(.5 * (1 / l * f - u)), p = 0, m = 0);
    var g = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
        var r = function(t) {
            return t instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? t : (0, $90849bbe88a0108e$exports).fromPixels(t);
        }(t);
        return r = (0, $f49389cdab278f98$export$880821ebecb16ceb)(r, [
            [
                d,
                h
            ],
            [
                p,
                m
            ],
            [
                0,
                0
            ]
        ]), (0, $7912647d6e7a4ee9$export$5c452ff88e35e47d).resizeBilinear(r, [
            o,
            a
        ]);
    });
    return {
        resized: g,
        padding: {
            top: d,
            left: p,
            right: m,
            bottom: h
        }
    };
}
function $325200b03e780f5a$var$Dt(t) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        return $325200b03e780f5a$var$B(this, function(e) {
            return [
                2,
                Promise.all(t.map(function(t) {
                    return t.buffer();
                }))
            ];
        });
    });
}
function $325200b03e780f5a$var$Bt(t, e, n, r, i) {
    var o = e[0], a = e[1], s = n[0], u = n[1], f = function(t, e, n, r, i) {
        return void 0 === r && (r = 0), void 0 === i && (i = 0), 1 === n && 1 === e && 0 === r && 0 === i ? t : t.map(function(t) {
            return function(t, e, n, r, i) {
                return void 0 === r && (r = 0), void 0 === i && (i = 0), {
                    score: t.score,
                    keypoints: t.keypoints.map(function(t) {
                        var o = t.score, a = t.part, s = t.position;
                        return {
                            score: o,
                            part: a,
                            position: {
                                x: s.x * n + i,
                                y: s.y * e + r
                            }
                        };
                    })
                };
            }(t, e, n, r, i);
        });
    }(t, (o + r.top + r.bottom) / s, (a + r.left + r.right) / u, -r.top, -r.left);
    return i ? function(t, e) {
        return e <= 0 ? t : t.map(function(t) {
            return function(t, e) {
                return {
                    score: t.score,
                    keypoints: t.keypoints.map(function(t) {
                        var n = t.score, r = t.part, i = t.position;
                        return {
                            score: n,
                            part: r,
                            position: {
                                x: e - 1 - i.x,
                                y: i.y
                            }
                        };
                    })
                };
            }(t, e);
        });
    }(f, a) : f;
}
var $325200b03e780f5a$var$Lt = {
    architecture: "MobileNetV1",
    outputStride: 16,
    quantBytes: 4,
    multiplier: .75
}, $325200b03e780f5a$var$zt = [
    "MobileNetV1",
    "ResNet50"
], $325200b03e780f5a$var$Wt = {
    MobileNetV1: [
        8,
        16,
        32
    ],
    ResNet50: [
        32,
        16
    ]
}, $325200b03e780f5a$var$jt = {
    MobileNetV1: [
        .5,
        .75,
        1
    ],
    ResNet50: [
        1
    ]
}, $325200b03e780f5a$var$Vt = [
    1,
    2,
    4
];
var $325200b03e780f5a$var$Kt = {
    flipHorizontal: !1,
    internalResolution: "medium",
    segmentationThreshold: .7,
    maxDetections: 10,
    scoreThreshold: .4,
    nmsRadius: 20
}, $325200b03e780f5a$var$Ut = {
    flipHorizontal: !1,
    internalResolution: "medium",
    segmentationThreshold: .7,
    maxDetections: 10,
    scoreThreshold: .4,
    nmsRadius: 20,
    minKeypointScore: .3,
    refineSteps: 10
};
function $325200b03e780f5a$var$qt(t) {
    var e = t.segmentationThreshold, n = t.maxDetections, r = t.scoreThreshold, i = t.nmsRadius;
    if (e < 0 || e > 1) throw new Error("segmentationThreshold " + e + ". Should be in range [0.0, 1.0]");
    if (n <= 0) throw new Error("Invalid maxDetections " + n + ". Should be > 0");
    if (r < 0 || r > 1) throw new Error("Invalid scoreThreshold " + r + ". Should be in range [0.0, 1.0]");
    if (i <= 0) throw new Error("Invalid nmsRadius " + i + ".");
}
function $325200b03e780f5a$var$Nt(t) {
    var e = t.segmentationThreshold, n = t.maxDetections, r = t.scoreThreshold, i = t.nmsRadius, o = t.minKeypointScore, a = t.refineSteps;
    if (e < 0 || e > 1) throw new Error("segmentationThreshold " + e + ". Should be in range [0.0, 1.0]");
    if (n <= 0) throw new Error("Invalid maxDetections " + n + ". Should be > 0");
    if (r < 0 || r > 1) throw new Error("Invalid scoreThreshold " + r + ". Should be in range [0.0, 1.0]");
    if (i <= 0) throw new Error("Invalid nmsRadius " + i + ".");
    if (o < 0 || o > 1) throw new Error("Invalid minKeypointScore " + o + ".Should be in range [0.0, 1.0]");
    if (a <= 0 || a > 20) throw new Error("Invalid refineSteps " + a + ".Should be in range [1, 20]");
}
var $325200b03e780f5a$var$Qt = function() {
    function t(t) {
        this.baseModel = t;
    }
    return t.prototype.predictForPersonSegmentation = function(t) {
        var e = this.baseModel.predict(t);
        return {
            segmentLogits: e.segmentation,
            heatmapScores: e.heatmapScores,
            offsets: e.offsets,
            displacementFwd: e.displacementFwd,
            displacementBwd: e.displacementBwd
        };
    }, t.prototype.predictForPersonSegmentationAndPart = function(t) {
        var e = this.baseModel.predict(t);
        return {
            segmentLogits: e.segmentation,
            partHeatmapLogits: e.partHeatmaps,
            heatmapScores: e.heatmapScores,
            offsets: e.offsets,
            displacementFwd: e.displacementFwd,
            displacementBwd: e.displacementBwd
        };
    }, t.prototype.predictForMultiPersonInstanceSegmentationAndPart = function(t) {
        var e = this.baseModel.predict(t);
        return {
            segmentLogits: e.segmentation,
            longOffsets: e.longOffsets,
            heatmapScores: e.heatmapScores,
            offsets: e.offsets,
            displacementFwd: e.displacementFwd,
            displacementBwd: e.displacementBwd,
            partHeatmaps: e.partHeatmaps
        };
    }, t.prototype.segmentPersonActivation = function(t, e, n) {
        var i = this;
        void 0 === n && (n = .5);
        var o = $325200b03e780f5a$var$Ot(t), a = o[0], s = o[1], u = $325200b03e780f5a$var$Rt(e, this.baseModel.outputStride, [
            a,
            s
        ]), f = $325200b03e780f5a$var$Ct(t, u), l = f.resized, c = f.padding, d = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
            var t = i.predictForPersonSegmentation(l), e = t.segmentLogits, r = t.heatmapScores, o = t.offsets, u = t.displacementFwd, f = t.displacementBwd, d = l.shape, h = d[0], p = d[1], m = $325200b03e780f5a$var$Ft(e, [
                a,
                s
            ], [
                h,
                p
            ], [
                [
                    c.top,
                    c.bottom
                ],
                [
                    c.left,
                    c.right
                ]
            ], true);
            return {
                segmentation: $325200b03e780f5a$var$N((0, $f41010297af56801$export$889c931173b77c2f)(m), n),
                heatmapScores: r,
                offsets: o,
                displacementFwd: u,
                displacementBwd: f
            };
        }), h = d.segmentation, p = d.heatmapScores, m = d.offsets, v = d.displacementFwd, w = d.displacementBwd;
        return l.dispose(), {
            segmentation: h,
            heatmapScores: p,
            offsets: m,
            displacementFwd: v,
            displacementBwd: w,
            padding: c,
            internalResolutionHeightAndWidth: u
        };
    }, t.prototype.segmentPerson = function(t, e) {
        return void 0 === e && (e = $325200b03e780f5a$var$Kt), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            var n, r, i, o, a, s, u, f, l, c, d, h, p, m, g, v, w, y;
            return $325200b03e780f5a$var$B(this, function(b) {
                switch(b.label){
                    case 0:
                        return $325200b03e780f5a$var$qt(e = $325200b03e780f5a$var$C($325200b03e780f5a$var$C({}, $325200b03e780f5a$var$Kt), e)), n = this.segmentPersonActivation(t, e.internalResolution, e.segmentationThreshold), r = n.segmentation, i = n.heatmapScores, o = n.offsets, a = n.displacementFwd, s = n.displacementBwd, u = n.padding, f = n.internalResolutionHeightAndWidth, l = r.shape, c = l[0], d = l[1], [
                            4,
                            r.data()
                        ];
                    case 1:
                        return h = b.sent(), r.dispose(), [
                            4,
                            $325200b03e780f5a$var$Dt([
                                i,
                                o,
                                a,
                                s
                            ])
                        ];
                    case 2:
                        return p = b.sent(), m = p[0], g = p[1], v = p[2], w = p[3], y = $325200b03e780f5a$var$Bt(y = $325200b03e780f5a$var$Mt(m, g, v, w, this.baseModel.outputStride, e.maxDetections, e.scoreThreshold, e.nmsRadius), [
                            c,
                            d
                        ], f, u, false), i.dispose(), o.dispose(), a.dispose(), s.dispose(), [
                            2,
                            {
                                height: c,
                                width: d,
                                data: h,
                                allPoses: y
                            }
                        ];
                }
            });
        });
    }, t.prototype.segmentMultiPerson = function(t, e) {
        return void 0 === e && (e = $325200b03e780f5a$var$Ut), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            var n, i, o, a, s, u, f, l, c, d, h, p, m, v, w, y, b, S, x, M, k, E = this;
            return $325200b03e780f5a$var$B(this, function(T) {
                switch(T.label){
                    case 0:
                        return $325200b03e780f5a$var$Nt(e = $325200b03e780f5a$var$C($325200b03e780f5a$var$C({}, $325200b03e780f5a$var$Ut), e)), n = $325200b03e780f5a$var$Ot(t), i = n[0], o = n[1], a = $325200b03e780f5a$var$Rt(e.internalResolution, this.baseModel.outputStride, [
                            i,
                            o
                        ]), s = $325200b03e780f5a$var$Ct(t, a), u = s.resized, f = s.padding, l = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
                            var t, n = E.predictForMultiPersonInstanceSegmentationAndPart(u), r = n.segmentLogits, s = n.longOffsets, l = n.heatmapScores, c = n.offsets, d = n.displacementFwd, h = n.displacementBwd, p = $325200b03e780f5a$var$Ft(r, [
                                i,
                                o
                            ], a, [
                                [
                                    f.top,
                                    f.bottom
                                ],
                                [
                                    f.left,
                                    f.right
                                ]
                            ], true);
                            return t = s, {
                                segmentation: $325200b03e780f5a$var$N((0, $f41010297af56801$export$889c931173b77c2f)(p), e.segmentationThreshold),
                                longOffsets: t,
                                heatmapScoresRaw: l,
                                offsetsRaw: c,
                                displacementFwdRaw: d,
                                displacementBwdRaw: h
                            };
                        }), c = l.segmentation, d = l.longOffsets, h = l.heatmapScoresRaw, p = l.offsetsRaw, m = l.displacementFwdRaw, v = l.displacementBwdRaw, [
                            4,
                            $325200b03e780f5a$var$Dt([
                                h,
                                p,
                                m,
                                v
                            ])
                        ];
                    case 1:
                        return w = T.sent(), y = w[0], b = w[1], S = w[2], x = w[3], M = $325200b03e780f5a$var$Bt(M = $325200b03e780f5a$var$Mt(y, b, S, x, this.baseModel.outputStride, e.maxDetections, e.scoreThreshold, e.nmsRadius), [
                            i,
                            o
                        ], a, f, false), [
                            4,
                            $325200b03e780f5a$var$lt(c, d, M, i, o, this.baseModel.outputStride, a, f, e.scoreThreshold, e.refineSteps, e.minKeypointScore, e.maxDetections)
                        ];
                    case 2:
                        return k = T.sent(), u.dispose(), c.dispose(), d.dispose(), h.dispose(), p.dispose(), m.dispose(), v.dispose(), [
                            2,
                            k
                        ];
                }
            });
        });
    }, t.prototype.segmentPersonPartsActivation = function(t, e, n) {
        var i = this;
        void 0 === n && (n = .5);
        var o = $325200b03e780f5a$var$Ot(t), a = o[0], s = o[1], u = $325200b03e780f5a$var$Rt(e, this.baseModel.outputStride, [
            a,
            s
        ]), f = $325200b03e780f5a$var$Ct(t, u), l = f.resized, c = f.padding, d = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
            var t = i.predictForPersonSegmentationAndPart(l), e = t.segmentLogits, r = t.partHeatmapLogits, o = t.heatmapScores, u = t.offsets, f = t.displacementFwd, d = t.displacementBwd, h = l.shape, p = h[0], m = h[1], v = $325200b03e780f5a$var$Ft(e, [
                a,
                s
            ], [
                p,
                m
            ], [
                [
                    c.top,
                    c.bottom
                ],
                [
                    c.left,
                    c.right
                ]
            ], true), w = $325200b03e780f5a$var$Ft(r, [
                a,
                s
            ], [
                p,
                m
            ], [
                [
                    c.top,
                    c.bottom
                ],
                [
                    c.left,
                    c.right
                ]
            ], true);
            return {
                partSegmentation: $325200b03e780f5a$var$Q($325200b03e780f5a$var$N((0, $f41010297af56801$export$889c931173b77c2f)(v), n), w),
                heatmapScores: o,
                offsets: u,
                displacementFwd: f,
                displacementBwd: d
            };
        }), h = d.partSegmentation, p = d.heatmapScores, m = d.offsets, v = d.displacementFwd, w = d.displacementBwd;
        return l.dispose(), {
            partSegmentation: h,
            heatmapScores: p,
            offsets: m,
            displacementFwd: v,
            displacementBwd: w,
            padding: c,
            internalResolutionHeightAndWidth: u
        };
    }, t.prototype.segmentPersonParts = function(t, e) {
        return void 0 === e && (e = $325200b03e780f5a$var$Kt), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            var n, r, i, o, a, s, u, f, l, c, d, h, p, m, g, v, w, y;
            return $325200b03e780f5a$var$B(this, function(b) {
                switch(b.label){
                    case 0:
                        return $325200b03e780f5a$var$qt(e = $325200b03e780f5a$var$C($325200b03e780f5a$var$C({}, $325200b03e780f5a$var$Kt), e)), n = this.segmentPersonPartsActivation(t, e.internalResolution, e.segmentationThreshold), r = n.partSegmentation, i = n.heatmapScores, o = n.offsets, a = n.displacementFwd, s = n.displacementBwd, u = n.padding, f = n.internalResolutionHeightAndWidth, l = r.shape, c = l[0], d = l[1], [
                            4,
                            r.data()
                        ];
                    case 1:
                        return h = b.sent(), r.dispose(), [
                            4,
                            $325200b03e780f5a$var$Dt([
                                i,
                                o,
                                a,
                                s
                            ])
                        ];
                    case 2:
                        return p = b.sent(), m = p[0], g = p[1], v = p[2], w = p[3], y = $325200b03e780f5a$var$Bt(y = $325200b03e780f5a$var$Mt(m, g, v, w, this.baseModel.outputStride, e.maxDetections, e.scoreThreshold, e.nmsRadius), [
                            c,
                            d
                        ], f, u, false), i.dispose(), o.dispose(), a.dispose(), s.dispose(), [
                            2,
                            {
                                height: c,
                                width: d,
                                data: h,
                                allPoses: y
                            }
                        ];
                }
            });
        });
    }, t.prototype.segmentMultiPersonParts = function(t, e) {
        return void 0 === e && (e = $325200b03e780f5a$var$Ut), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            var n, o, a, s, d, h, p, m, v, w, y, b, S, x, M, k, E, T, P, I, O, _, H = this;
            return $325200b03e780f5a$var$B(this, function(A) {
                switch(A.label){
                    case 0:
                        return $325200b03e780f5a$var$Nt(e = $325200b03e780f5a$var$C($325200b03e780f5a$var$C({}, $325200b03e780f5a$var$Ut), e)), n = $325200b03e780f5a$var$Ot(t), o = n[0], a = n[1], s = $325200b03e780f5a$var$Rt(e.internalResolution, this.baseModel.outputStride, [
                            o,
                            a
                        ]), d = $325200b03e780f5a$var$Ct(t, s), h = d.resized, p = d.padding, m = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
                            var t = H.predictForMultiPersonInstanceSegmentationAndPart(h), n = t.segmentLogits, d = t.longOffsets, m = t.heatmapScores, v = t.offsets, w = t.displacementFwd, y = t.displacementBwd, b = t.partHeatmaps, S = $325200b03e780f5a$var$Ft(n, [
                                o,
                                a
                            ], s, [
                                [
                                    p.top,
                                    p.bottom
                                ],
                                [
                                    p.left,
                                    p.right
                                ]
                            ], true), x = $325200b03e780f5a$var$Ft(b, [
                                o,
                                a
                            ], s, [
                                [
                                    p.top,
                                    p.bottom
                                ],
                                [
                                    p.left,
                                    p.right
                                ]
                            ], true), M = d, k = $325200b03e780f5a$var$N((0, $f41010297af56801$export$889c931173b77c2f)(S), e.segmentationThreshold), E = function(t) {
                                var e = t.shape, n = e[0], o = e[1], a = e[2];
                                return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
                                    var e = $325200b03e780f5a$var$q(t), r = (0, $db5bfab98435c6cf$export$d660d8ed21f46635)((0, $5d4db871afef7031$export$d02631cccf789723)(0, a, 1, "int32"), 1), s = (0, $d61a75572b5954a3$export$f2db7d5238e1d23f)((0, $7f1f3e54d78420da$export$6706882a873e9a8f)(e, r), "int32");
                                    return (0, $33ee657bc32918d5$export$9eaad88cf88cee2b)(s, [
                                        n,
                                        o
                                    ]);
                                });
                            }(x);
                            return {
                                segmentation: k,
                                longOffsets: M,
                                heatmapScoresRaw: m,
                                offsetsRaw: v,
                                displacementFwdRaw: w,
                                displacementBwdRaw: y,
                                partSegmentation: E
                            };
                        }), v = m.segmentation, w = m.longOffsets, y = m.heatmapScoresRaw, b = m.offsetsRaw, S = m.displacementFwdRaw, x = m.displacementBwdRaw, M = m.partSegmentation, [
                            4,
                            $325200b03e780f5a$var$Dt([
                                y,
                                b,
                                S,
                                x
                            ])
                        ];
                    case 1:
                        return k = A.sent(), E = k[0], T = k[1], P = k[2], I = k[3], O = $325200b03e780f5a$var$Bt(O = $325200b03e780f5a$var$Mt(E, T, P, I, this.baseModel.outputStride, e.maxDetections, e.scoreThreshold, e.nmsRadius), [
                            o,
                            a
                        ], s, p, false), [
                            4,
                            $325200b03e780f5a$var$ct(v, w, M, O, o, a, this.baseModel.outputStride, s, p, e.scoreThreshold, e.refineSteps, e.minKeypointScore, e.maxDetections)
                        ];
                    case 2:
                        return _ = A.sent(), h.dispose(), v.dispose(), w.dispose(), y.dispose(), b.dispose(), S.dispose(), x.dispose(), M.dispose(), [
                            2,
                            _
                        ];
                }
            });
        });
    }, t.prototype.dispose = function() {
        this.baseModel.dispose();
    }, t;
}();
function $325200b03e780f5a$var$Xt(e) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var n, r, i, o, a, s;
        return $325200b03e780f5a$var$B(this, function(u) {
            switch(u.label){
                case 0:
                    if (n = e.outputStride, r = e.quantBytes, i = e.multiplier, null == $d2cc08cc2aa8032f$exports) throw new Error("Cannot find TensorFlow.js. If you are using a <script> tag, please also include @tensorflow/tfjs on the page before using this\n        model.");
                    return o = function(t, e, n) {
                        var r = {
                            1: "100",
                            .75: "075",
                            .5: "050"
                        }, i = "model-stride" + t + ".json";
                        return 4 === n ? $325200b03e780f5a$var$It + "float/" + r[e] + "/" + i : $325200b03e780f5a$var$It + "quant" + n + "/" + r[e] + "/" + i;
                    }(n, i, r), [
                        4,
                        (0, $8afdb9914f122011$export$f077572b5d896ffd)(e.modelUrl || o)
                    ];
                case 1:
                    return a = u.sent(), s = new $325200b03e780f5a$var$Y(a, n), [
                        2,
                        new $325200b03e780f5a$var$Qt(s)
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$Yt(e) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var n, r, i, o, a;
        return $325200b03e780f5a$var$B(this, function(s) {
            switch(s.label){
                case 0:
                    if (n = e.outputStride, r = e.quantBytes, null == $d2cc08cc2aa8032f$exports) throw new Error("Cannot find TensorFlow.js. If you are using a <script> tag, please also include @tensorflow/tfjs on the page before using this\n        model.");
                    return i = function(t, e) {
                        var n = "model-stride" + t + ".json";
                        return 4 === e ? $325200b03e780f5a$var$Pt + "float/" + n : $325200b03e780f5a$var$Pt + "quant" + e + "/" + n;
                    }(n, r), [
                        4,
                        (0, $8afdb9914f122011$export$f077572b5d896ffd)(e.modelUrl || i)
                    ];
                case 1:
                    return o = s.sent(), a = new $325200b03e780f5a$var$Tt(o, n), [
                        2,
                        new $325200b03e780f5a$var$Qt(a)
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$Gt(t) {
    return void 0 === t && (t = $325200b03e780f5a$var$Lt), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        return $325200b03e780f5a$var$B(this, function(e) {
            return "ResNet50" === (t = function(t) {
                if (null == (t = t || $325200b03e780f5a$var$Lt).architecture && (t.architecture = "MobileNetV1"), $325200b03e780f5a$var$zt.indexOf(t.architecture) < 0) throw new Error("Invalid architecture " + t.architecture + ". Should be one of " + $325200b03e780f5a$var$zt);
                if (null == t.outputStride && (t.outputStride = 16), $325200b03e780f5a$var$Wt[t.architecture].indexOf(t.outputStride) < 0) throw new Error("Invalid outputStride " + t.outputStride + ". Should be one of " + $325200b03e780f5a$var$Wt[t.architecture] + " for architecture " + t.architecture + ".");
                if (null == t.multiplier && (t.multiplier = 1), $325200b03e780f5a$var$jt[t.architecture].indexOf(t.multiplier) < 0) throw new Error("Invalid multiplier " + t.multiplier + ". Should be one of " + $325200b03e780f5a$var$jt[t.architecture] + " for architecture " + t.architecture + ".");
                if (null == t.quantBytes && (t.quantBytes = 4), $325200b03e780f5a$var$Vt.indexOf(t.quantBytes) < 0) throw new Error("Invalid quantBytes " + t.quantBytes + ". Should be one of " + $325200b03e780f5a$var$Vt + " for architecture " + t.architecture + ".");
                return t;
            }(t)).architecture ? [
                2,
                $325200b03e780f5a$var$Yt(t)
            ] : "MobileNetV1" === t.architecture ? [
                2,
                $325200b03e780f5a$var$Xt(t)
            ] : [
                2,
                null
            ];
        });
    });
}
var $325200b03e780f5a$var$$t = [
    "left_face",
    "right_face",
    "left_upper_arm_front",
    "left_upper_arm_back",
    "right_upper_arm_front",
    "right_upper_arm_back",
    "left_lower_arm_front",
    "left_lower_arm_back",
    "right_lower_arm_front",
    "right_lower_arm_back",
    "left_hand",
    "right_hand",
    "torso_front",
    "torso_back",
    "left_upper_leg_front",
    "left_upper_leg_back",
    "right_upper_leg_front",
    "right_upper_leg_back",
    "left_lower_leg_front",
    "left_lower_leg_back",
    "right_lower_leg_front",
    "right_lower_leg_back",
    "left_feet",
    "right_feet"
], $325200b03e780f5a$var$Jt = function() {
    function t(t) {
        this.mask = t;
    }
    return t.prototype.toCanvasImageSource = function() {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            return $325200b03e780f5a$var$B(this, function(t) {
                return [
                    2,
                    $325200b03e780f5a$var$z(this.mask)
                ];
            });
        });
    }, t.prototype.toImageData = function() {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            return $325200b03e780f5a$var$B(this, function(t) {
                return [
                    2,
                    this.mask
                ];
            });
        });
    }, t.prototype.toTensor = function() {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            return $325200b03e780f5a$var$B(this, function(t) {
                return [
                    2,
                    $325200b03e780f5a$var$j(this.mask)
                ];
            });
        });
    }, t.prototype.getUnderlyingType = function() {
        return "imagedata";
    }, t;
}();
function $325200b03e780f5a$var$Zt(t) {
    if ($325200b03e780f5a$var$V(t), 255 !== t) throw new Error("Foreground id must be 255 but got " + t);
    return "person";
}
function $325200b03e780f5a$var$te(t) {
    if ($325200b03e780f5a$var$V(t), t >= $325200b03e780f5a$var$$t.length) throw new Error("Invalid body part value " + t);
    return $325200b03e780f5a$var$$t[t];
}
var $325200b03e780f5a$var$ee = function() {
    function t(t) {
        this.bodyPixModel = t;
    }
    return t.prototype.segmentPeople = function(t, e) {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            var n, r, i, o;
            return $325200b03e780f5a$var$B(this, function(a) {
                switch(a.label){
                    case 0:
                        return t instanceof ImageBitmap && ((n = document.createElement("canvas")).getContext("2d").drawImage(t, 0, 0), t = n), e.segmentBodyParts ? e.multiSegmentation ? [
                            4,
                            this.bodyPixModel.segmentMultiPersonParts(t, e)
                        ] : [
                            3,
                            2
                        ] : [
                            3,
                            5
                        ];
                    case 1:
                        return i = a.sent(), [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.bodyPixModel.segmentPersonParts(t, e)
                        ];
                    case 3:
                        i = [
                            a.sent()
                        ], a.label = 4;
                    case 4:
                        return r = i.map(function(t) {
                            var e = t.data, n = t.width, r = t.height, i = new Uint8ClampedArray(n * r * 4).fill(0);
                            return e.forEach(function(t, e) {
                                -1 === t ? (i[4 * e] = $325200b03e780f5a$var$$t.length, i[4 * e + 3] = 0) : (i[4 * e] = t, i[4 * e + 3] = 255);
                            }), {
                                maskValueToLabel: $325200b03e780f5a$var$te,
                                mask: new $325200b03e780f5a$var$Jt(new ImageData(i, n, r))
                            };
                        }), [
                            3,
                            10
                        ];
                    case 5:
                        return e.multiSegmentation ? [
                            4,
                            this.bodyPixModel.segmentMultiPerson(t, e)
                        ] : [
                            3,
                            7
                        ];
                    case 6:
                        return o = a.sent(), [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            this.bodyPixModel.segmentPerson(t, e)
                        ];
                    case 8:
                        o = [
                            a.sent()
                        ], a.label = 9;
                    case 9:
                        r = o.map(function(t) {
                            var e = t.data, n = t.width, r = t.height, i = new Uint8ClampedArray(n * r * 4).fill(0);
                            return e.forEach(function(t, e) {
                                0 === t ? (i[4 * e] = 0, i[4 * e + 3] = 0) : (i[4 * e] = 255, i[4 * e + 3] = 255);
                            }), {
                                maskValueToLabel: $325200b03e780f5a$var$Zt,
                                mask: new $325200b03e780f5a$var$Jt(new ImageData(i, n, r))
                            };
                        }), a.label = 10;
                    case 10:
                        return [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.dispose = function() {
        this.bodyPixModel.dispose();
    }, t.prototype.reset = function() {}, t;
}();
function $325200b03e780f5a$var$ne(t) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        return $325200b03e780f5a$var$B(this, function(e) {
            return [
                2,
                $325200b03e780f5a$var$Gt(t).then(function(t) {
                    return new $325200b03e780f5a$var$ee(t);
                })
            ];
        });
    });
}
var $325200b03e780f5a$var$re = {
    runtime: "mediapipe",
    modelType: "general"
};
var $325200b03e780f5a$var$ie = function() {
    function t(t) {
        this.mask = t;
    }
    return t.prototype.toCanvasImageSource = function() {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            return $325200b03e780f5a$var$B(this, function(t) {
                return [
                    2,
                    this.mask
                ];
            });
        });
    }, t.prototype.toImageData = function() {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            return $325200b03e780f5a$var$B(this, function(t) {
                return [
                    2,
                    $325200b03e780f5a$var$W(this.mask)
                ];
            });
        });
    }, t.prototype.toTensor = function() {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            return $325200b03e780f5a$var$B(this, function(t) {
                return [
                    2,
                    $325200b03e780f5a$var$j(this.mask)
                ];
            });
        });
    }, t.prototype.getUnderlyingType = function() {
        return "canvasimagesource";
    }, t;
}();
function $325200b03e780f5a$var$oe(t) {
    return $325200b03e780f5a$var$V(t), "person";
}
var $325200b03e780f5a$var$ae = function() {
    function t(t) {
        var e, n = this;
        this.selfieMode = !1;
        var r;
        if (this.selfieSegmentationSolution = new (0, $f5e8984c016ca24a$exports.SelfieSegmentation)({
            locateFile: null !== (e = t.locateFile) && void 0 !== e ? e : function(e, n) {
                return t.solutionPath ? t.solutionPath.replace(/\/+$/, "") + "/" + e : n + "/" + e;
            }
        }), "landscape" === t.modelType) r = 1;
        else r = 0;
        this.selfieSegmentationSolution.setOptions({
            modelSelection: r,
            selfieMode: this.selfieMode
        }), this.selfieSegmentationSolution.onResults(function(t) {
            n.segmentation = [
                {
                    maskValueToLabel: $325200b03e780f5a$var$oe,
                    mask: new $325200b03e780f5a$var$ie(t.segmentationMask)
                }
            ];
        });
    }
    return t.prototype.segmentPeople = function(t, r) {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            var i, o;
            return $325200b03e780f5a$var$B(this, function(a) {
                switch(a.label){
                    case 0:
                        return r && r.flipHorizontal && r.flipHorizontal !== this.selfieMode && (this.selfieMode = r.flipHorizontal, this.selfieSegmentationSolution.setOptions({
                            selfieMode: this.selfieMode
                        })), t instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? (o = ImageData.bind, [
                            4,
                            (0, $90849bbe88a0108e$exports).toPixels(t)
                        ]) : [
                            3,
                            2
                        ];
                    case 1:
                        return i = new (o.apply(ImageData, [
                            void 0,
                            a.sent(),
                            t.shape[1],
                            t.shape[0]
                        ])), [
                            3,
                            3
                        ];
                    case 2:
                        i = t, a.label = 3;
                    case 3:
                        return t = i, [
                            4,
                            this.selfieSegmentationSolution.send({
                                image: t
                            })
                        ];
                    case 4:
                        return a.sent(), [
                            2,
                            this.segmentation
                        ];
                }
            });
        });
    }, t.prototype.dispose = function() {
        this.selfieSegmentationSolution.close();
    }, t.prototype.reset = function() {
        this.selfieSegmentationSolution.reset(), this.segmentation = null, this.selfieMode = !1;
    }, t.prototype.initialize = function() {
        return this.selfieSegmentationSolution.initialize();
    }, t;
}();
function $325200b03e780f5a$var$se(t) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var e, n;
        return $325200b03e780f5a$var$B(this, function(r) {
            switch(r.label){
                case 0:
                    return e = function(t) {
                        if (null == t) return $325200b03e780f5a$var$C({}, $325200b03e780f5a$var$re);
                        var e = $325200b03e780f5a$var$C({}, t);
                        return e.runtime = "mediapipe", null == e.modelType && (e.modelType = $325200b03e780f5a$var$re.modelType), e;
                    }(t), [
                        4,
                        (n = new $325200b03e780f5a$var$ae(e)).initialize()
                    ];
                case 1:
                    return r.sent(), [
                        2,
                        n
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$ue(t, e, n, r) {
    var i = t.width, o = t.height, a = r ? -1 : 1, s = Math.cos(t.rotation), u = Math.sin(t.rotation), f = t.xCenter, l = t.yCenter, c = 1 / e, d = 1 / n, h = new Array(16);
    return h[0] = i * s * a * c, h[1] = -o * u * c, h[2] = 0, h[3] = (-0.5 * i * s * a + .5 * o * u + f) * c, h[4] = i * u * a * d, h[5] = o * s * d, h[6] = 0, h[7] = (-0.5 * o * s - .5 * i * u * a + l) * d, h[8] = 0, h[9] = 0, h[10] = i * c, h[11] = 0, h[12] = 0, h[13] = 0, h[14] = 0, h[15] = 1, function(t) {
        if (16 !== t.length) throw new Error("Array length must be 16 but got " + t.length);
        return [
            [
                t[0],
                t[1],
                t[2],
                t[3]
            ],
            [
                t[4],
                t[5],
                t[6],
                t[7]
            ],
            [
                t[8],
                t[9],
                t[10],
                t[11]
            ],
            [
                t[12],
                t[13],
                t[14],
                t[15]
            ]
        ];
    }(h);
}
function $325200b03e780f5a$var$fe(t) {
    return t instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? {
        height: t.shape[0],
        width: t.shape[1]
    } : {
        height: t.height,
        width: t.width
    };
}
function $325200b03e780f5a$var$le(t, e) {
    (0, $e10678764dab7ea0$exports).assert(0 !== t.width, function() {
        return e + " width cannot be 0.";
    }), (0, $e10678764dab7ea0$exports).assert(0 !== t.height, function() {
        return e + " height cannot be 0.";
    });
}
function $325200b03e780f5a$var$ce(t, e) {
    var n = function(t, e, n, r) {
        var i = e - t, o = r - n;
        if (0 === i) throw new Error("Original min and max are both " + t + ", range cannot be 0.");
        var a = o / i;
        return {
            scale: a,
            offset: n - t * a
        };
    }(0, 255, e[0], e[1]);
    return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
        return (0, $c90bd95bc0e58efa$export$e16d8520af44a096)((0, $e8cd0739d0f73f4b$export$6e3a27864ab166fe)(t, n.scale), n.offset);
    });
}
function $325200b03e780f5a$var$de(t, o, a) {
    var s = o.outputTensorSize, f = o.keepAspectRatio, l = o.borderMode, c = o.outputTensorFloatRange, d = $325200b03e780f5a$var$fe(t), h = function(t, e) {
        return e ? {
            xCenter: e.xCenter * t.width,
            yCenter: e.yCenter * t.height,
            width: e.width * t.width,
            height: e.height * t.height,
            rotation: e.rotation
        } : {
            xCenter: .5 * t.width,
            yCenter: .5 * t.height,
            width: t.width,
            height: t.height,
            rotation: 0
        };
    }(d, a), p = function(t, e, n) {
        if (void 0 === n && (n = !1), !n) return {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        };
        var r = e.height, i = e.width;
        $325200b03e780f5a$var$le(e, "targetSize"), $325200b03e780f5a$var$le(t, "roi");
        var o, a, s = r / i, u = t.height / t.width, f = 0, l = 0;
        return s > u ? (o = t.width, a = t.width * s, l = (1 - u / s) / 2) : (o = t.height / s, a = t.height, f = (1 - s / u) / 2), t.width = o, t.height = a, {
            top: l,
            left: f,
            right: f,
            bottom: l
        };
    }(h, s, f), m = $325200b03e780f5a$var$ue(h, d.width, d.height, !1), g = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
        var r, o = (r = t) instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? r : (0, $90849bbe88a0108e$exports).fromPixels(r), a = (0, $bea433ea0b14d5fb$export$b5469a65e8732256)(function(t, e, n) {
            return $325200b03e780f5a$var$le(n, "inputResolution"), [
                1 / n.width * t[0][0] * e.width,
                1 / n.height * t[0][1] * e.width,
                t[0][3] * e.width,
                1 / n.width * t[1][0] * e.height,
                1 / n.height * t[1][1] * e.height,
                t[1][3] * e.height,
                0,
                0
            ];
        }(m, d, s), [
            1,
            8
        ]), f = "zero" === l ? "constant" : "nearest", h = (0, $7912647d6e7a4ee9$export$5c452ff88e35e47d).transform((0, $db5bfab98435c6cf$export$d660d8ed21f46635)((0, $d61a75572b5954a3$export$f2db7d5238e1d23f)(o, "float32")), a, "bilinear", f, 0, [
            s.height,
            s.width
        ]);
        return null != c ? $325200b03e780f5a$var$ce(h, c) : h;
    });
    return {
        imageTensor: g,
        padding: p,
        transformationMatrix: m
    };
}
function $325200b03e780f5a$var$he(t, e, n) {
    return (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
        var r = (0, $f41010297af56801$export$889c931173b77c2f)(t, [
            0
        ]), i = r.shape[2];
        if (1 === i) {
            var o = r;
            switch(e.activation){
                case "none":
                    break;
                case "sigmoid":
                    o = (0, $e3381678584872cc$export$3b295495ca3cad7c)(o);
                    break;
                case "softmax":
                    throw new Error("Softmax activation requires two channels.");
                default:
                    throw new Error("Activation not supported (" + e.activation + ")");
            }
            var a = n ? (0, $7912647d6e7a4ee9$export$5c452ff88e35e47d).resizeBilinear(o, [
                n.height,
                n.width
            ]) : o;
            return (0, $f41010297af56801$export$889c931173b77c2f)(a, [
                2
            ]);
        }
        throw new Error("Unsupported number of tensor channels " + i);
    });
}
var $325200b03e780f5a$var$pe = {
    runtime: "tfjs",
    modelType: "general",
    modelUrl: "https://tfhub.dev/mediapipe/tfjs-model/selfie_segmentation/general/1"
}, $325200b03e780f5a$var$me = {
    flipHorizontal: !1
}, $325200b03e780f5a$var$ge = {
    outputTensorSize: {
        width: 256,
        height: 256
    },
    keepAspectRatio: !1,
    borderMode: "zero",
    outputTensorFloatRange: [
        0,
        1
    ]
}, $325200b03e780f5a$var$ve = {
    outputTensorSize: {
        width: 256,
        height: 144
    },
    keepAspectRatio: !1,
    borderMode: "zero",
    outputTensorFloatRange: [
        0,
        1
    ]
}, $325200b03e780f5a$var$we = {
    activation: "none"
};
var $325200b03e780f5a$var$ye = function() {
    function t(t) {
        this.mask = t;
    }
    return t.prototype.toCanvasImageSource = function() {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            return $325200b03e780f5a$var$B(this, function(t) {
                return [
                    2,
                    $325200b03e780f5a$var$z(this.mask)
                ];
            });
        });
    }, t.prototype.toImageData = function() {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            return $325200b03e780f5a$var$B(this, function(t) {
                return [
                    2,
                    $325200b03e780f5a$var$W(this.mask)
                ];
            });
        });
    }, t.prototype.toTensor = function() {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            return $325200b03e780f5a$var$B(this, function(t) {
                return [
                    2,
                    this.mask
                ];
            });
        });
    }, t.prototype.getUnderlyingType = function() {
        return "tensor";
    }, t;
}();
function $325200b03e780f5a$var$be(t) {
    return $325200b03e780f5a$var$V(t), "person";
}
var $325200b03e780f5a$export$2f09812b4c450c2b, $325200b03e780f5a$var$xe = function() {
    function t(t, e) {
        this.modelType = t, this.model = e;
    }
    return t.prototype.segmentPeople = function(t, e) {
        return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
            var n, i = this;
            return $325200b03e780f5a$var$B(this, function(o) {
                return e = function(t) {
                    if (null == t) return $325200b03e780f5a$var$C({}, $325200b03e780f5a$var$me);
                    var e = $325200b03e780f5a$var$C({}, t);
                    return null == e.flipHorizontal && (e.flipHorizontal = $325200b03e780f5a$var$me.flipHorizontal), e;
                }(e), null == t ? (this.reset(), [
                    2,
                    []
                ]) : (n = (0, $8c449c89295c3cc4$export$b841c6a213a653eb)(function() {
                    var e = $325200b03e780f5a$var$de(t, "general" === i.modelType ? $325200b03e780f5a$var$ge : $325200b03e780f5a$var$ve).imageTensor, n = (0, $535db06fef6716ec$export$58adb3bec8346d0f)(i.model.predict(e), [
                        0,
                        0,
                        0,
                        1
                    ], -1), r = $325200b03e780f5a$var$fe(t), o = $325200b03e780f5a$var$he(n, $325200b03e780f5a$var$we, r), a = (0, $db5bfab98435c6cf$export$d660d8ed21f46635)(o, 2), s = (0, $b90bbaefd48f2353$export$5d04458e2a6c373e)(a, [
                        [
                            0,
                            0
                        ],
                        [
                            0,
                            0
                        ],
                        [
                            0,
                            1
                        ]
                    ]);
                    return (0, $a6b3cd7f35f32ec3$export$c0b11600e90b86ae)(s, [
                        [
                            0,
                            0
                        ],
                        [
                            0,
                            0
                        ],
                        [
                            0,
                            2
                        ]
                    ], "symmetric");
                }), [
                    2,
                    [
                        {
                            maskValueToLabel: $325200b03e780f5a$var$be,
                            mask: new $325200b03e780f5a$var$ye(n)
                        }
                    ]
                ]);
            });
        });
    }, t.prototype.dispose = function() {
        this.model.dispose();
    }, t.prototype.reset = function() {}, t;
}();
function $325200b03e780f5a$var$Me(t) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var e, n, r;
        return $325200b03e780f5a$var$B(this, function(i) {
            switch(i.label){
                case 0:
                    return e = function(t) {
                        if (null == t) return $325200b03e780f5a$var$C({}, $325200b03e780f5a$var$pe);
                        var e = $325200b03e780f5a$var$C({}, t);
                        if (e.runtime = "tfjs", null == e.modelType && (e.modelType = $325200b03e780f5a$var$pe.modelType), "general" !== e.modelType && "landscape" !== e.modelType) throw new Error("Model type must be one of general or landscape, but got " + e.modelType);
                        null == e.modelUrl && ("general" === e.modelType ? e.modelUrl = "https://tfhub.dev/mediapipe/tfjs-model/selfie_segmentation/general/1" : e.modelUrl = "https://tfhub.dev/mediapipe/tfjs-model/selfie_segmentation/landscape/1");
                        return e;
                    }(t), n = "string" == typeof e.modelUrl && e.modelUrl.indexOf("https://tfhub.dev") > -1, [
                        4,
                        (0, $8afdb9914f122011$export$f077572b5d896ffd)(e.modelUrl, {
                            fromTFHub: n
                        })
                    ];
                case 1:
                    return r = i.sent(), [
                        2,
                        new $325200b03e780f5a$var$xe(e.modelType, r)
                    ];
            }
        });
    });
}
function $325200b03e780f5a$export$aa9d968a842359fd(t, e) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var n, r;
        return $325200b03e780f5a$var$B(this, function(i) {
            switch(t){
                case $325200b03e780f5a$export$2f09812b4c450c2b.MediaPipeSelfieSegmentation:
                    if (n = void 0, null != (r = e)) {
                        if ("tfjs" === r.runtime) return [
                            2,
                            $325200b03e780f5a$var$Me(r)
                        ];
                        if ("mediapipe" === r.runtime) return [
                            2,
                            $325200b03e780f5a$var$se(r)
                        ];
                        n = r.runtime;
                    }
                    throw new Error("Expect modelConfig.runtime to be either 'tfjs' or 'mediapipe', but got " + n);
                case $325200b03e780f5a$export$2f09812b4c450c2b.BodyPix:
                    return [
                        2,
                        $325200b03e780f5a$var$ne(r = e)
                    ];
                default:
                    throw new Error(t + " is not a supported model name.");
            }
        });
    });
}
!function(t) {
    t.BodyPix = "BodyPix", t.MediaPipeSelfieSegmentation = "MediaPipeSelfieSegmentation";
}($325200b03e780f5a$export$2f09812b4c450c2b || ($325200b03e780f5a$export$2f09812b4c450c2b = {}));
var $325200b03e780f5a$var$Ee = "blurred", $325200b03e780f5a$var$Te = "blurred-mask", $325200b03e780f5a$var$Pe = "mask", $325200b03e780f5a$var$Ie = "lowres-part-mask", $325200b03e780f5a$var$Oe = "draw-image", $325200b03e780f5a$var$_e = {};
function $325200b03e780f5a$var$He(t, e, n, r) {
    var i = t.width, o = t.height, a = e.width, s = e.height;
    if (i !== a || o !== s) throw new Error("error: dimensions must match. " + n + " has dimensions " + i + "x" + o + ", " + r + " has dimensions " + a + "x" + s);
}
function $325200b03e780f5a$var$Ae(t) {
    if ("undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof OffscreenCanvas && t instanceof OffscreenCanvas || "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement) return function(t) {
        if ("offsetHeight" in t && 0 !== t.offsetHeight && "offsetWidth" in t && 0 !== t.offsetWidth) return [
            t.offsetHeight,
            t.offsetWidth
        ];
        if (null != t.height && null != t.width) return [
            t.height,
            t.width
        ];
        throw new Error("HTMLImageElement must have height and width attributes set.");
    }(t);
    if ("undefined" != typeof ImageData && t instanceof ImageData) return [
        t.height,
        t.width
    ];
    if ("undefined" != typeof HTMLVideoElement && t instanceof HTMLVideoElement) return function(t) {
        return t.hasAttribute("height") && t.hasAttribute("width") ? [
            t.height,
            t.width
        ] : [
            t.videoHeight,
            t.videoWidth
        ];
    }(t);
    if (t instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814)) return [
        t.shape[0],
        t.shape[1]
    ];
    throw new Error("error: Unknown input type: " + t + ".");
}
function $325200b03e780f5a$var$Re(t) {
    return $325200b03e780f5a$var$_e[t] || ($325200b03e780f5a$var$_e[t] = function() {
        if ("undefined" != typeof document) return document.createElement("canvas");
        if ("undefined" != typeof OffscreenCanvas) return new OffscreenCanvas(0, 0);
        throw new Error("Cannot create a canvas in this context");
    }()), $325200b03e780f5a$var$_e[t];
}
function $325200b03e780f5a$var$Fe(t, e) {
    var n = $325200b03e780f5a$var$Re(e);
    return function(t, e) {
        e.width = t.width, e.height = t.height, e.getContext("2d").putImageData(t, 0, 0);
    }(t, n), n;
}
function $325200b03e780f5a$var$Ce(t, r, i, o, a, s) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var u, f, l, c;
        return $325200b03e780f5a$var$B(this, function(d) {
            switch(d.label){
                case 0:
                    return r instanceof (0, $6c839404e55214b5$export$7b6b8d90402f8814) ? [
                        4,
                        (0, $90849bbe88a0108e$exports).toPixels(r)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    u = d.sent(), f = $325200b03e780f5a$var$Ae(r), l = f[0], c = f[1], r = new ImageData(u, c, l), d.label = 2;
                case 2:
                    return r instanceof ImageData && (r = $325200b03e780f5a$var$Fe(r, $325200b03e780f5a$var$Oe)), null == a || null == s ? t.drawImage(r, i, o) : t.drawImage(r, i, o, a, s), [
                        2
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$De(t, e) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var n, r, i;
        return $325200b03e780f5a$var$B(this, function(o) {
            switch(o.label){
                case 0:
                    return n = $325200b03e780f5a$var$Ae(t), r = n[0], i = n[1], e.width = i, e.height = r, [
                        4,
                        $325200b03e780f5a$var$Ce(e.getContext("2d"), t, 0, 0, i, r)
                    ];
                case 1:
                    return o.sent(), [
                        2
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$Be(t) {
    var e = t.getContext("2d");
    e.scale(-1, 1), e.translate(-t.width, 0);
}
function $325200b03e780f5a$var$Le(t, e, n) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        return $325200b03e780f5a$var$B(this, function(r) {
            switch(r.label){
                case 0:
                    return t.globalCompositeOperation = n, [
                        4,
                        $325200b03e780f5a$var$Ce(t, e, 0, 0)
                    ];
                case 1:
                    return r.sent(), [
                        2
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$ze(t, e, n) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var r, i, o, a, s, u, f, l;
        return $325200b03e780f5a$var$B(this, function(c) {
            switch(c.label){
                case 0:
                    for(r = t.getContext("2d"), i = 0, o = 5, a = 1 / (2 * Math.PI * o * o), s = n < 3 ? 1 : 2, f = -n; f <= n; f += s)for(l = -n; l <= n; l += s)u = a * Math.exp(-(l * l + f * f) / (2 * o * o)), i += u;
                    f = -n, c.label = 1;
                case 1:
                    if (!(f <= n)) return [
                        3,
                        6
                    ];
                    l = -n, c.label = 2;
                case 2:
                    return l <= n ? (r.globalAlpha = a * Math.exp(-(l * l + f * f) / (2 * o * o)) / i * n, [
                        4,
                        $325200b03e780f5a$var$Ce(r, e, l, f)
                    ]) : [
                        3,
                        5
                    ];
                case 3:
                    c.sent(), c.label = 4;
                case 4:
                    return l += s, [
                        3,
                        2
                    ];
                case 5:
                    return f += s, [
                        3,
                        1
                    ];
                case 6:
                    return r.globalAlpha = 1, [
                        2
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$We(t, e, n) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var r, i, o, a;
        return $325200b03e780f5a$var$B(this, function(s) {
            switch(s.label){
                case 0:
                    return r = $325200b03e780f5a$var$Ae(t), i = r[0], o = r[1], a = n.getContext("2d"), n.width = o, n.height = i, a.clearRect(0, 0, o, i), a.save(), /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? [
                        4,
                        $325200b03e780f5a$var$ze(n, t, e)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    return s.sent(), [
                        3,
                        4
                    ];
                case 2:
                    return a.filter = "blur(" + e + "px)", [
                        4,
                        $325200b03e780f5a$var$Ce(a, t, 0, 0, o, i)
                    ];
                case 3:
                    s.sent(), s.label = 4;
                case 4:
                    return a.restore(), [
                        2
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$je(t, e, n) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var r;
        return $325200b03e780f5a$var$B(this, function(i) {
            switch(i.label){
                case 0:
                    return r = $325200b03e780f5a$var$Re(n), 0 !== e ? [
                        3,
                        2
                    ] : [
                        4,
                        $325200b03e780f5a$var$De(t, r)
                    ];
                case 1:
                    return i.sent(), [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        $325200b03e780f5a$var$We(t, e, r)
                    ];
                case 3:
                    i.sent(), i.label = 4;
                case 4:
                    return [
                        2,
                        r
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$Ve(t, e, n, r, i, o) {
    void 0 === o && (o = {
        r: 0,
        g: 255,
        b: 255,
        a: 255
    });
    for(var a = -i; a <= i; a++)for(var s = -i; s <= i; s++)if (0 !== a && 0 !== s) {
        var u = (e + a) * r + (n + s);
        t[4 * u + 0] = o.r, t[4 * u + 1] = o.g, t[4 * u + 2] = o.b, t[4 * u + 3] = o.a;
    }
}
function $325200b03e780f5a$var$Ke(t, e, n, r, i, o, a) {
    void 0 === a && (a = 1);
    for(var s = 0, u = -a; u <= a; u++)for(var f = -a; f <= a; f++)if (0 !== u && 0 !== f) {
        var l = (e + u) * r + (n + f);
        (!i[t[4 * l]] || t[4 * l + 3] < o) && (s += 1);
    }
    return s > 0;
}
function $325200b03e780f5a$export$4e07a956e3258daf(t, e, n, r, i, o) {
    return void 0 === e && (e = {
        r: 0,
        g: 0,
        b: 0,
        a: 0
    }), void 0 === n && (n = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    }), void 0 === r && (r = !1), void 0 === i && (i = .5), void 0 === o && (o = Array.from(Array(256).keys())), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var a, s, u, f, l, c, d, h, p, m, g, v, w, y;
        return $325200b03e780f5a$var$B(this, function(b) {
            switch(b.label){
                case 0:
                    return 0 === (a = Array.isArray(t) ? t : [
                        t
                    ]).length ? [
                        2,
                        null
                    ] : [
                        4,
                        Promise.all(a.map(function(t) {
                            return t.mask.toImageData();
                        }))
                    ];
                case 1:
                    for(s = b.sent(), u = s[0], f = u.width, l = u.height, c = new Uint8ClampedArray(f * l * 4), d = Math.round(255 * i), h = new Array(256).fill(!1), o.forEach(function(t) {
                        return h[t] = !0;
                    }), p = 0; p < l; p++)for(m = 0; m < f; m++)for(c[4 * (g = p * f + m) + 0] = n.r, c[4 * g + 1] = n.g, c[4 * g + 2] = n.b, c[4 * g + 3] = n.a, v = 0, w = s; v < w.length; v++)y = w[v], h[y.data[4 * g]] && y.data[4 * g + 3] >= d && (c[4 * g] = e.r, c[4 * g + 1] = e.g, c[4 * g + 2] = e.b, c[4 * g + 3] = e.a, r && p - 1 >= 0 && p + 1 < l && m - 1 >= 0 && m + 1 < f && $325200b03e780f5a$var$Ke(y.data, p, m, f, h, d) && $325200b03e780f5a$var$Ve(c, p, m, f, 1));
                    return [
                        2,
                        new ImageData(c, f, l)
                    ];
            }
        });
    });
}
function $325200b03e780f5a$export$5390c942ed0c0d9b(t, e, n, r) {
    return void 0 === n && (n = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    }), void 0 === r && (r = .5), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var i, o, a, s, u, f, l, c, d, h, p, m, g, v;
        return $325200b03e780f5a$var$B(this, function(w) {
            switch(w.label){
                case 0:
                    return 0 === (i = Array.isArray(t) ? t : [
                        t
                    ]).length ? [
                        2,
                        null
                    ] : [
                        4,
                        Promise.all(i.map(function(t) {
                            return t.mask.toImageData();
                        }))
                    ];
                case 1:
                    for(o = w.sent(), a = o[0], s = a.width, u = a.height, f = new Uint8ClampedArray(s * u * 4), l = Math.round(255 * r), c = 0; c < u * s; ++c)for(f[(d = 4 * c) + 0] = n.r, f[d + 1] = n.g, f[d + 2] = n.b, f[d + 3] = n.a, h = 0, p = o; h < p.length; h++)(m = p[h]).data[d + 3] >= l && (g = m.data[d], v = e(g), f[d + 0] = v.r, f[d + 1] = v.g, f[d + 2] = v.b, f[d + 3] = v.a);
                    return [
                        2,
                        new ImageData(f, s, u)
                    ];
            }
        });
    });
}
function $325200b03e780f5a$export$36ff583a570c1e17(t, e, n, r, i, o) {
    return void 0 === r && (r = .7), void 0 === i && (i = 0), void 0 === o && (o = !1), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var a, s, u, f, l;
        return $325200b03e780f5a$var$B(this, function(c) {
            switch(c.label){
                case 0:
                    return a = $325200b03e780f5a$var$Ae(e), s = a[0], u = a[1], t.width = u, t.height = s, (f = t.getContext("2d")).save(), o && $325200b03e780f5a$var$Be(t), [
                        4,
                        $325200b03e780f5a$var$Ce(f, e, 0, 0)
                    ];
                case 1:
                    return c.sent(), f.globalAlpha = r, n ? ($325200b03e780f5a$var$He({
                        width: u,
                        height: s
                    }, n, "image", "mask"), [
                        4,
                        $325200b03e780f5a$var$je($325200b03e780f5a$var$Fe(n, $325200b03e780f5a$var$Pe), i, $325200b03e780f5a$var$Te)
                    ]) : [
                        3,
                        3
                    ];
                case 2:
                    l = c.sent(), f.drawImage(l, 0, 0, u, s), c.label = 3;
                case 3:
                    return f.restore(), [
                        2
                    ];
            }
        });
    });
}
function $325200b03e780f5a$export$1190983c4273fa2d(t, e, n, r, i, o, a) {
    return void 0 === r && (r = .7), void 0 === i && (i = 0), void 0 === o && (o = !1), void 0 === a && (a = 10), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var s, u, f, l, c, d, h;
        return $325200b03e780f5a$var$B(this, function(p) {
            switch(p.label){
                case 0:
                    return s = $325200b03e780f5a$var$Ae(e), u = s[0], $325200b03e780f5a$var$He({
                        width: s[1],
                        height: u
                    }, n, "image", "mask"), [
                        4,
                        $325200b03e780f5a$var$je($325200b03e780f5a$var$Fe(n, $325200b03e780f5a$var$Pe), i, $325200b03e780f5a$var$Te)
                    ];
                case 1:
                    for(f = p.sent(), t.width = f.width, t.height = f.height, (l = t.getContext("2d")).save(), o && $325200b03e780f5a$var$Be(t), c = $325200b03e780f5a$var$Re($325200b03e780f5a$var$Ie), d = c.getContext("2d"), c.width = f.width * (1 / a), c.height = f.height * (1 / a), d.drawImage(f, 0, 0, f.width, f.height, 0, 0, c.width, c.height), l.imageSmoothingEnabled = !1, l.drawImage(c, 0, 0, c.width, c.height, 0, 0, t.width, t.height), h = 0; h < c.width; h++)l.beginPath(), l.strokeStyle = "#ffffff", l.moveTo(a * h, 0), l.lineTo(a * h, t.height), l.stroke();
                    for(h = 0; h < c.height; h++)l.beginPath(), l.strokeStyle = "#ffffff", l.moveTo(0, a * h), l.lineTo(t.width, a * h), l.stroke();
                    return l.globalAlpha = 1 - r, [
                        4,
                        $325200b03e780f5a$var$Ce(l, e, 0, 0, f.width, f.height)
                    ];
                case 2:
                    return p.sent(), l.restore(), [
                        2
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$Xe(t, e, n) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var r, i;
        return $325200b03e780f5a$var$B(this, function(o) {
            switch(o.label){
                case 0:
                    return [
                        4,
                        $325200b03e780f5a$export$4e07a956e3258daf(t, {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 255
                        }, {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 0
                        }, !1, e)
                    ];
                case 1:
                    return r = o.sent(), i = $325200b03e780f5a$var$Fe(r, $325200b03e780f5a$var$Pe), 0 === n ? [
                        2,
                        i
                    ] : [
                        2,
                        $325200b03e780f5a$var$je(i, n, $325200b03e780f5a$var$Te)
                    ];
            }
        });
    });
}
function $325200b03e780f5a$export$b40eb7d92667f4c9(t, e, n, r, i, o, a) {
    return void 0 === r && (r = .5), void 0 === i && (i = 3), void 0 === o && (o = 3), void 0 === a && (a = !1), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var s, u, f, l, c, d;
        return $325200b03e780f5a$var$B(this, function(h) {
            switch(h.label){
                case 0:
                    return [
                        4,
                        $325200b03e780f5a$var$je(e, i, $325200b03e780f5a$var$Ee)
                    ];
                case 1:
                    return s = h.sent(), t.width = s.width, t.height = s.height, u = t.getContext("2d"), Array.isArray(n) && 0 === n.length ? (u.drawImage(s, 0, 0), [
                        2
                    ]) : [
                        4,
                        $325200b03e780f5a$var$Xe(n, r, o)
                    ];
                case 2:
                    return f = h.sent(), u.save(), a && $325200b03e780f5a$var$Be(t), l = $325200b03e780f5a$var$Ae(e), c = l[0], d = l[1], [
                        4,
                        $325200b03e780f5a$var$Ce(u, e, 0, 0, d, c)
                    ];
                case 3:
                    return h.sent(), [
                        4,
                        $325200b03e780f5a$var$Le(u, f, "destination-in")
                    ];
                case 4:
                    return h.sent(), [
                        4,
                        $325200b03e780f5a$var$Le(u, s, "destination-over")
                    ];
                case 5:
                    return h.sent(), u.restore(), [
                        2
                    ];
            }
        });
    });
}
function $325200b03e780f5a$var$Ge(t, e, n, r) {
    return $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var i, o;
        return $325200b03e780f5a$var$B(this, function(a) {
            switch(a.label){
                case 0:
                    return [
                        4,
                        $325200b03e780f5a$export$4e07a956e3258daf(t, {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 0
                        }, {
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 255
                        }, !0, n, e)
                    ];
                case 1:
                    return i = a.sent(), o = $325200b03e780f5a$var$Fe(i, $325200b03e780f5a$var$Pe), 0 === r ? [
                        2,
                        o
                    ] : [
                        2,
                        $325200b03e780f5a$var$je(o, r, $325200b03e780f5a$var$Te)
                    ];
            }
        });
    });
}
function $325200b03e780f5a$export$aa8770df5ceb8f7c(t, e, n, r, i, o, a, s) {
    return void 0 === i && (i = .5), void 0 === o && (o = 3), void 0 === a && (a = 3), void 0 === s && (s = !1), $325200b03e780f5a$var$D(this, void 0, void 0, function() {
        var u, f, l, c, d, h;
        return $325200b03e780f5a$var$B(this, function(p) {
            switch(p.label){
                case 0:
                    return [
                        4,
                        $325200b03e780f5a$var$je(e, o, $325200b03e780f5a$var$Ee)
                    ];
                case 1:
                    return u = p.sent(), t.width = u.width, t.height = u.height, f = t.getContext("2d"), Array.isArray(n) && 0 === n.length ? (f.drawImage(u, 0, 0), [
                        2
                    ]) : [
                        4,
                        $325200b03e780f5a$var$Ge(n, r, i, a)
                    ];
                case 2:
                    return l = p.sent(), f.save(), s && $325200b03e780f5a$var$Be(t), c = $325200b03e780f5a$var$Ae(e), d = c[0], h = c[1], [
                        4,
                        $325200b03e780f5a$var$Ce(f, e, 0, 0, h, d)
                    ];
                case 3:
                    return p.sent(), [
                        4,
                        $325200b03e780f5a$var$Le(f, l, "destination-in")
                    ];
                case 4:
                    return p.sent(), [
                        4,
                        $325200b03e780f5a$var$Le(f, u, "destination-over")
                    ];
                case 5:
                    return p.sent(), f.restore(), [
                        2
                    ];
            }
        });
    });
}


var $ed5f20c0ff99c580$exports = {};
$ed5f20c0ff99c580$exports = import.meta.resolve("fZrIz");


var $18e473ca8e497df2$exports = {};
$18e473ca8e497df2$exports = import.meta.resolve("8g9DF");


var $160352f79424aa64$exports = {};
$160352f79424aa64$exports = import.meta.resolve("7MzKh");


var $b91d3ff82e887bb0$exports = {};
$b91d3ff82e887bb0$exports = import.meta.resolve("hqzBB");


var $c116e212a86f311b$exports = {};
$c116e212a86f311b$exports = import.meta.resolve("rb6VC");


var $b260cd63001f4821$exports = {};
$b260cd63001f4821$exports = import.meta.resolve("2pJQw");


var $0fac9ccfbe0e7a34$exports = {};
$0fac9ccfbe0e7a34$exports = import.meta.resolve("iZ1zH");


const $2ae6a0e1d65fc3a5$var$foregroundColor = {
    r: 0,
    g: 0,
    b: 0,
    a: 0
};
const $2ae6a0e1d65fc3a5$var$backgroundColor = {
    r: 0,
    g: 0,
    b: 0,
    a: 255
};
const $2ae6a0e1d65fc3a5$var$useOwnMask = true;
const $2ae6a0e1d65fc3a5$var$logFps = false;
let $2ae6a0e1d65fc3a5$var$fpsCounter = 0;
let $2ae6a0e1d65fc3a5$var$t1 = performance.now();
const $2ae6a0e1d65fc3a5$export$388b5bc5140fe9e6 = [
    {
        image: '',
        name_en: 'No background',
        name_sv: 'Ingen bakgrund',
        src: ''
    },
    {
        image: 'blur',
        name_en: 'Blur',
        name_sv: 'Suddig',
        src: ''
    },
    {
        image: 'office',
        name_en: 'Office',
        name_sv: 'Kontor',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b91d3ff82e887bb0$exports)))
    },
    {
        image: 'office2',
        name_en: 'Office 2',
        name_sv: 'Kontor 2',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c116e212a86f311b$exports)))
    },
    {
        image: 'kitchen',
        name_en: 'Kitchen',
        name_sv: "K\xf6k",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($160352f79424aa64$exports)))
    },
    {
        image: 'forest',
        name_en: 'Forest',
        name_sv: 'Skog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($18e473ca8e497df2$exports)))
    },
    {
        image: 'wall',
        name_en: 'Wall',
        name_sv: "V\xe4gg",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0fac9ccfbe0e7a34$exports)))
    },
    {
        image: 'beach',
        name_en: 'Beach',
        name_sv: 'Strand',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5f20c0ff99c580$exports)))
    },
    {
        image: 'sunset',
        name_en: 'Sun set',
        name_sv: "Solnedg\xe5ng",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b260cd63001f4821$exports)))
    }
];
function $2ae6a0e1d65fc3a5$var$changeBackground(resources) {
    if (resources.changeBackground) {
        let img = '';
        if (resources.background.length > 0 && resources.background !== 'blur') {
            // img = '/public/video_background/' + resources.background + '.jpg'
            if (resources.background === 'beach') img = (0, (/*@__PURE__*/$parcel$interopDefault($ed5f20c0ff99c580$exports)));
            else if (resources.background === 'forest') img = (0, (/*@__PURE__*/$parcel$interopDefault($18e473ca8e497df2$exports)));
            else if (resources.background === 'kitchen') img = (0, (/*@__PURE__*/$parcel$interopDefault($160352f79424aa64$exports)));
            else if (resources.background === 'office') img = (0, (/*@__PURE__*/$parcel$interopDefault($b91d3ff82e887bb0$exports)));
            else if (resources.background === 'office2') img = (0, (/*@__PURE__*/$parcel$interopDefault($c116e212a86f311b$exports)));
            else if (resources.background === 'sunset') img = (0, (/*@__PURE__*/$parcel$interopDefault($b260cd63001f4821$exports)));
            else if (resources.background === 'wall') img = (0, (/*@__PURE__*/$parcel$interopDefault($0fac9ccfbe0e7a34$exports)));
        }
        if (img.length > 0) {
            const background = new Image();
            background.src = img;
            background.onload = ()=>{
                if (resources.canvas) {
                    const canvas = document.createElement('canvas');
                    canvas.width = resources.canvas.width;
                    canvas.height = resources.canvas.height;
                    const ctx = canvas.getContext('2d');
                    if (ctx) {
                        if (background.width > canvas.width && background.height > canvas.height) {
                            const sx = (background.width - canvas.width) / 2;
                            // const sy = (background.height - canvas.height) / 2
                            const sy = 0;
                            const w = canvas.width;
                            const h = canvas.height;
                            ctx.drawImage(background, sx, sy, w, h, 0, 0, w, h);
                        } else ctx.drawImage(background, 0, 0);
                        resources.canvas.backgroundData = ctx.getImageData(0, 0, resources.canvas.width, resources.canvas.height);
                    }
                }
            };
        } else {
            console.log('No img');
            if (resources.canvas) {
                console.log('Restoring canvas');
                resources.canvas.backgroundData = new ImageData(resources.canvas.width, resources.canvas.height);
            }
        }
        resources.changeBackground = false;
    }
}
async function $2ae6a0e1d65fc3a5$export$5d3661a787e3ea15(resources) {
    resources.stateFunc('info', 'Changing background...');
    resources.stateFunc('showInfo', true);
    if (resources.videoContainer && resources.videoElement?.videoWidth && resources.videoElement?.videoHeight) {
        const width = resources.videoElement.videoWidth;
        const height = resources.videoElement.videoHeight;
        resources.videoElement.width = width;
        resources.videoElement.height = height;
        const canvas = $2ae6a0e1d65fc3a5$var$createCanvases(resources.videoContainer, width, height);
        resources.canvas = canvas;
        resources.canvas.backgroundData = new ImageData(width, height);
        const model = $325200b03e780f5a$export$2f09812b4c450c2b.MediaPipeSelfieSegmentation;
        canvas.segmenter = await $325200b03e780f5a$export$aa9d968a842359fd(model, {
            runtime: 'mediapipe',
            // solutionPath: '@mediapipe/selfie_segmentation'
            solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation'
        });
        resources.videoElement?.classList.add('invisible');
        canvas.canvasOut.classList.remove('invisible');
        resources.stateFunc('arrangeVideos', '');
        if (resources.partners.length > 0) $2ae6a0e1d65fc3a5$export$1609c8a0afa4d4(resources);
        $2ae6a0e1d65fc3a5$var$drawToCanvas(resources, width, height);
    }
}
function $2ae6a0e1d65fc3a5$export$1609c8a0afa4d4(resources) {
    // @ts-ignore
    // captureStream is still in draft for HTMLCanvasElement
    const canvasStream = resources.canvas?.canvasOut.captureStream();
    canvasStream?.getTracks().forEach((track)=>{
        for (const partner of resources.partners)partner.peerConnection.getSenders().forEach((sender)=>{
            if (sender.track !== null && sender.track.kind === 'video') sender.replaceTrack(track).then((_result)=>{
                console.log('Replaced track');
            });
        });
    });
}
function $2ae6a0e1d65fc3a5$var$backgroundToMask(bg, m) {
    const bgData = bg.data;
    const mData = m.data;
    let prevPerson = false;
    for(let n = 0; n < mData.length; n += 4)// n + 3 > 240 means pixel is outside person
    if (mData[n + 3] > 240) {
        mData[n] = bgData[n];
        mData[n + 1] = bgData[n + 1];
        mData[n + 2] = bgData[n + 2];
        // Previous pixel was person, set opacity in background to 127 to smoothen image
        if (prevPerson) mData[n + 3] = 127;
        prevPerson = false;
    } else {
        // Previous pixel was background, set opacity in background to 127 to smoothen image
        if (!prevPerson) mData[n - 1] = 127;
        prevPerson = true;
    }
}
function $2ae6a0e1d65fc3a5$var$mergeBackground(bg, m) {
    const bgData = bg.data;
    const mData = m.data;
    for(let n = 0; n < mData.length; n += 4)// n + 3 > 240 means pixel is outside person
    if (mData[n + 3] > 128) mData[n + 3] = 0;
    else {
        mData[n] = bgData[n];
        mData[n + 1] = bgData[n + 1];
        mData[n + 2] = bgData[n + 2];
        mData[n + 3] = 255 - mData[n + 3];
    }
}
async function $2ae6a0e1d65fc3a5$var$drawToCanvas(resources, width, height) {
    const canvas = resources.canvas;
    const videoElement = resources.videoElement;
    if (canvas && videoElement) {
        if (!canvas.doLoop) {
            console.log('Stopping animation loop');
            return;
        }
        if ($2ae6a0e1d65fc3a5$var$logFps) {
            $2ae6a0e1d65fc3a5$var$fpsCounter++;
            if ($2ae6a0e1d65fc3a5$var$fpsCounter % 20 === 0) {
                const t2 = performance.now();
                console.log('20 frames took ' + (t2 - $2ae6a0e1d65fc3a5$var$t1));
                $2ae6a0e1d65fc3a5$var$t1 = t2;
            }
        }
        if (resources.background === 'blur') {
            const people = await canvas.segmenter.segmentPeople(videoElement, {
                flipHorizontal: false
            });
            await $325200b03e780f5a$export$b40eb7d92667f4c9(canvas.canvasOut, videoElement, people, 0.5, 3);
        } else {
            if ($2ae6a0e1d65fc3a5$var$useOwnMask) {
                if (canvas.ctxTemp) {
                    canvas.ctxTemp.drawImage(videoElement, 0, 0);
                    const videoImage = canvas.ctxTemp.getImageData(0, 0, width, height);
                    const people = await canvas.segmenter.segmentPeople(videoImage, {
                        flipHorizontal: false
                    });
                    let maskImage = await people[0].mask.toImageData();
                    $2ae6a0e1d65fc3a5$var$mergeBackground(canvas.backgroundData, maskImage);
                    await $325200b03e780f5a$export$36ff583a570c1e17(canvas.canvasOut, videoElement, maskImage, 1, 0);
                }
            } else {
                const people = await canvas.segmenter.segmentPeople(videoElement, {
                    flipHorizontal: false
                });
                const backgroundMask = await $325200b03e780f5a$export$4e07a956e3258daf(people, $2ae6a0e1d65fc3a5$var$foregroundColor, $2ae6a0e1d65fc3a5$var$backgroundColor, false, 0.5);
                if (canvas.backgroundData) {
                    $2ae6a0e1d65fc3a5$var$backgroundToMask(canvas.backgroundData, backgroundMask);
                    await $325200b03e780f5a$export$36ff583a570c1e17(canvas.canvasOut, videoElement, backgroundMask, 1, 0);
                }
            }
        }
        if (resources.changeBackground) {
            $2ae6a0e1d65fc3a5$var$changeBackground(resources);
            resources.stateFunc('showInfo', false);
        }
        canvas.animFrameId = requestAnimationFrame(function() {
            $2ae6a0e1d65fc3a5$var$drawToCanvas(resources, width, height);
        });
    } else console.log('!!!No canvas to draw on');
}
function $2ae6a0e1d65fc3a5$export$e117f21e0d9f40c9(resources) {
    if (resources.canvas) {
        resources.canvas.doLoop = false;
        cancelAnimationFrame(resources.canvas.animFrameId);
        console.log('Stopping ' + resources.canvas.animFrameId);
        // Allow for loops to finish
        setTimeout(()=>{
            if (resources.videoContainer && resources.canvas) {
                resources.videoContainer.removeChild(resources.canvas.canvasOut);
                resources.canvas.canvasOut.remove();
                resources.glStructs = undefined;
            }
            resources.canvas = undefined;
            resources.videoElement?.classList.remove('invisible');
        }, 200);
    }
}
function $2ae6a0e1d65fc3a5$var$createCanvases(container, width, height) {
    const canvasOut = document.createElement('canvas');
    const canvasTemp = document.createElement('canvas');
    canvasTemp.width = width;
    canvasTemp.height = height;
    canvasOut.width = width;
    canvasOut.height = height;
    canvasOut.classList.add('invisible');
    canvasOut.classList.add('video_mirrored');
    canvasOut.setAttribute('style', 'position: absolute; top: 1px; left: 1px; z-index: 901');
    container.append(canvasOut);
    const canvas = {
        canvasOut: canvasOut,
        ctxTemp: canvasTemp.getContext('2d'),
        width: width,
        height: height,
        segmenter: undefined,
        animFrameId: undefined,
        doLoop: true
    };
    return canvas;
}



class $910fe95c6c1b0e1b$export$2e2bcd8739ae039 {
    static myInstance;
    baseUrl;
    apiToken;
    loggedIn;
    constructor(){
        this.baseUrl = (0, $9ecda7333d28e490$export$1630b5343357e8b5).API_ENDPOINT;
        this.loggedIn = false;
        this.apiToken = window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).PERSON_TOKEN];
    }
    static getInstance() {
        if ($910fe95c6c1b0e1b$export$2e2bcd8739ae039.myInstance == null) $910fe95c6c1b0e1b$export$2e2bcd8739ae039.myInstance = new $910fe95c6c1b0e1b$export$2e2bcd8739ae039();
        return this.myInstance;
    }
    async get(url, expectedErrors = []) {
        const call = this.getRaw(url);
        return this.makeCall(call, expectedErrors);
    }
    async post(url, data, expectedErrors = []) {
        const call = this.postRaw(url, data);
        return this.makeCall(call, expectedErrors);
    }
    formatUrl(url) {
        if (url.startsWith('https')) return url;
        else return this.baseUrl + url;
    }
    formatHeaders(url) {
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.apiToken}`
        };
    }
    getRaw(url) {
        let getUrl = this.formatUrl(url);
        return fetch(getUrl, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: this.formatHeaders(url),
            redirect: 'follow',
            referrerPolicy: 'no-referrer'
        });
    }
    postRaw(url, data) {
        let postUrl = this.formatUrl(url);
        return fetch(postUrl, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: this.formatHeaders(url),
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
    }
    makeCall(apiCall, expectedErrors) {
        return new Promise((resolve, reject)=>{
            apiCall// We got an http response
            .then((response)=>{
                const result = {
                    response: response,
                    isExpectedError: false
                };
                if (response.ok) // Call was successful (2XX status code)
                response.json().then((json)=>{
                    // Uncomment to debug. Should be removed in production.
                    // console.log("----> ", json)
                    result.json = json;
                    resolve(result);
                }).catch(()=>{
                    // This is for status 204 which will have an empty body (ie no json)
                    resolve(result);
                });
                else // We got an error (most likely 4XX or 5XX status code)
                response.json().then((json)=>{
                    result.json = json;
                    result.errorName = result.json.name;
                    result.errorMessage = result.json.message;
                    result.isExpectedError = expectedErrors.includes(result.errorName);
                    if (!result.isExpectedError) {
                        console.log(result.json);
                        if (response.status === 401) // User session has most likely expired server side
                        alert("Permission denied: 401");
                        else alert('Error ' + response.status);
                    }
                    reject(result);
                }).catch(()=>{
                    // Response body is not json
                    alert('Error 1:' + response.status);
                    reject(result);
                });
            })// We got no http response (eg due to timeout or network error)
            .catch((reason)=>{
                alert('Error 2: ' + reason);
            });
        });
    }
}




var $acw62 = parcelRequire("acw62");
class $10848baf51ae953b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    doLoop = true;
    volumeBoxes = [];
    state = {
        micVolume: 0
    };
    componentDidMount() {
        for(let i = 0; i < 100; i += 5)this.volumeBoxes.push(i);
        console.log('Mounted test sound, audioDeviceId ' + this.props.audioDeviceId);
        if (this.props.resources.localStream !== undefined) this.displayTestVolume(this.props.resources.localStream);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.audioDeviceId !== this.props.audioDeviceId) {
            console.log('component did update TestSound');
            this.doLoop = false;
            setTimeout(()=>{
                if (this.props.resources.localStream !== undefined) {
                    this.doLoop = true;
                    this.displayTestVolume(this.props.resources.localStream);
                } else console.warn('------ no localStream');
            }, 500);
        }
    }
    componentWillUnmount() {
        this.doLoop = false;
        console.log('Unmounted test sound');
    }
    displayTestVolume = (stream)=>{
        const audioContext = new AudioContext();
        const mediaStreamSource = audioContext.createMediaStreamSource(stream);
        const destination = audioContext.createMediaStreamDestination();
        const analyser = audioContext.createAnalyser();
        analyser.connect(destination);
        const audio = document.createElement('audio');
        audio.srcObject = destination.stream;
        audio.autoplay = false;
        mediaStreamSource.connect(destination);
        mediaStreamSource.connect(analyser);
        analyser.fftSize = 1024;
        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);
        requestAnimationFrame(()=>{
            this.drawSound(analyser, bufferLength, dataArray);
        });
    };
    drawSound = (analyser, bufferLength, dataArray)=>{
        if (!this.doLoop) return;
        analyser.getByteFrequencyData(dataArray);
        let total = 0;
        for(let i = 0; i < bufferLength; i++)total += dataArray[i];
        let volume = Math.sqrt(total / bufferLength) * 8;
        this.setState({
            micVolume: volume
        });
        requestAnimationFrame(()=>{
            this.drawSound(analyser, bufferLength, dataArray);
        });
    };
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "top_margin",
            children: [
                !this.props.micOn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-4 white",
                    children: "You have muted your microphone..."
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "top_margin white",
                    children: "Volume:"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "test_sound_volume_container mt-4 mr-4",
                    children: this.volumeBoxes.map((vol)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "test_sound_volume_box " + (this.state.micVolume > vol ? "active" : "")
                        }, "box_" + vol);
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "top_margin",
                    children: this.props.micOn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: this.state.micVolume === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "white",
                            children: [
                                "No sound detected.",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                "Raise mic volume or change speakers"
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "white",
                            children: [
                                "\xa0",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                "\xa0"
                            ]
                        })
                    })
                })
            ]
        });
    }
}


var $b0a44e27c839d9d3$exports = {};
$b0a44e27c839d9d3$exports = import.meta.resolve("hZrZF");



var $31bf57f98cd6b309$exports = {};
$31bf57f98cd6b309$exports = import.meta.resolve("44AzA");


var $a523f6402245f379$exports = {};
$a523f6402245f379$exports = import.meta.resolve("1PnYL");


var $b805ed793108017b$exports = {};
$b805ed793108017b$exports = import.meta.resolve("3IPJx");


var $e3a1a00d20f15acd$exports = {};
$e3a1a00d20f15acd$exports = import.meta.resolve("c8a0o");


var $b3ab3439e9cfd704$exports = {};
$b3ab3439e9cfd704$exports = import.meta.resolve("fgyFW");


var $a66824a50a34a4f1$exports = {};
$a66824a50a34a4f1$exports = import.meta.resolve("7OJp6");


var $ba6ceb8a6fcc832b$exports = {};
$ba6ceb8a6fcc832b$exports = import.meta.resolve("kIdHc");


var $87584a01cd5e0e0c$exports = {};
$87584a01cd5e0e0c$exports = import.meta.resolve("0QlhD");


var $771ec20e247b4491$exports = {};
$771ec20e247b4491$exports = import.meta.resolve("67CaX");


var $816c0b89a4789cdd$exports = {};
$816c0b89a4789cdd$exports = import.meta.resolve("1Rboc");


var $155e5efd0c1d5fe5$exports = {};
$155e5efd0c1d5fe5$exports = import.meta.resolve("dcmm8");


var $b11080b0bb6bec6b$exports = {};
$b11080b0bb6bec6b$exports = import.meta.resolve("cch4C");


var $cdb78316af408ce7$exports = {};
$cdb78316af408ce7$exports = import.meta.resolve("6feHl");


var $14de963752b00cee$exports = {};
$14de963752b00cee$exports = import.meta.resolve("bNT2P");


var $12192059d6909db0$exports = {};
$12192059d6909db0$exports = import.meta.resolve("91NFZ");


var $6c93e43386478db6$exports = {};
$6c93e43386478db6$exports = import.meta.resolve("9jI4B");


var $82817e8148d9758f$exports = {};
$82817e8148d9758f$exports = import.meta.resolve("iDy1L");


var $8ec22d909ff9299c$exports = {};
$8ec22d909ff9299c$exports = import.meta.resolve("gfmcv");


var $7927313db8b5982f$exports = {};
$7927313db8b5982f$exports = import.meta.resolve("f0JEk");


var $419676c6fce4b2f6$exports = {};
$419676c6fce4b2f6$exports = import.meta.resolve("45snY");


var $59b818d4bf08184f$exports = {};
$59b818d4bf08184f$exports = import.meta.resolve("h15gL");






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $1f390aa9641625b5$exports = {};
$1f390aa9641625b5$exports = import.meta.resolve("gkH3p");


const $4a2354f26b2f9084$var$ChatInput = ({ handleSendMessage: handleSendMessage, onHeightChange: onHeightChange })=>{
    const containerRef = (0, $acw62.useRef)(null);
    const textareaRef = (0, $acw62.useRef)(null);
    const [input, setInput] = (0, $acw62.useState)("");
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const sendMessage = ()=>{
        if (input.trim() === '') return; // Prevent sending empty messages
        handleSendMessage(input);
        setInput(''); // Clear the input field
        if (textareaRef.current) textareaRef.current.style.height = 'auto';
    };
    (0, $acw62.useEffect)(()=>{
        if (!containerRef.current) return;
        const handleResize = ()=>{
            if (containerRef.current && onHeightChange) {
                const height = containerRef.current.offsetHeight;
                onHeightChange(height);
            }
        };
        handleResize(); // Initial height measurement
        const observer = new ResizeObserver(handleResize);
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        onHeightChange
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pb-2 pt-3  border-t border-neutral-700",
        ref: containerRef,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex grow items-center bg-neutral-900 rounded-md ring-1 ring-neutral-600 focus-within:ring-2 focus-within:ring-primary-500",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                        ref: textareaRef,
                        placeholder: "Write here...",
                        className: "flex-1 bg-neutral-900 text-white px-4 py-3 rounded-md resize-none overflow-y-auto max-h-40 border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none",
                        style: {
                            whiteSpace: 'normal'
                        },
                        value: input,
                        onChange: (e)=>{
                            setInput(e.target.value);
                            if (textareaRef.current) {
                                textareaRef.current.style.height = 'auto';
                                textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
                            }
                        },
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                sendMessage();
                            }
                        },
                        rows: 1
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-2 p-2 cursor-pointer text-white",
                    onClick: sendMessage,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1f390aa9641625b5$exports))),
                        alt: "send"
                    })
                })
            ]
        })
    });
};
var $4a2354f26b2f9084$export$2e2bcd8739ae039 = $4a2354f26b2f9084$var$ChatInput;


var $f44b9061dc4d4058$export$2e2bcd8739ae039 = (0, $4a2354f26b2f9084$export$2e2bcd8739ae039);


var $7681aec77a46b3e7$exports = {};
$7681aec77a46b3e7$exports = import.meta.resolve("gIhr2");


var $cdc873224824021b$exports = {};
$cdc873224824021b$exports = import.meta.resolve("2z0Kv");




const $ff0c48d396ccec4c$var$DEBUG = false;
class $ff0c48d396ccec4c$export$2e2bcd8739ae039 {
    static myInstance;
    userId;
    userName;
    webSocket;
    eventEl;
    unReadMessage;
    pingInterval;
    constructor(userId, userName){
        this.unReadMessage = false;
        this.userId = userId ? userId : window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_USER_ID];
        this.userName = userName ? userName : window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).USERNAME_TOKEN];
        this.checkOpen();
        this.eventEl = document.createTextNode('');
    }
    checkOpen() {
        if (this.webSocket) {
            if (this.webSocket.readyState === this.webSocket.CONNECTING) {
                if ($ff0c48d396ccec4c$var$DEBUG) console.log('Socket: already connecting, exiting');
                return;
            } else if (this.webSocket.readyState === this.webSocket.OPEN) {
                if ($ff0c48d396ccec4c$var$DEBUG) console.log('Socket: already open, exiting');
                return;
            } else if (this.webSocket.readyState === this.webSocket.CLOSING) {
                if ($ff0c48d396ccec4c$var$DEBUG) console.log('Socket: is closing ----- todo: reopen when closed');
                return;
            } else if (this.webSocket.readyState === this.webSocket.CLOSED) {
                if ($ff0c48d396ccec4c$var$DEBUG) console.log('Socket: is closed ----- todo: reopen when closed');
            }
        }
        if (!this.userId) {
            if ($ff0c48d396ccec4c$var$DEBUG) console.log('Socket: No token, exiting');
            return;
        }
        this.openSocket();
    }
    openSocket(extraMessage) {
        this.webSocket = new WebSocket((0, $9ecda7333d28e490$export$1630b5343357e8b5).WEB_SOCKET_ENDPOINT);
        if ($ff0c48d396ccec4c$var$DEBUG) console.log('socket new WebSocket: ' + this.webSocket.readyState);
        // console.log('Tried opening websocket')
        this.webSocket.onerror = (err)=>{
            console.log(err);
            if (this.webSocket) console.log('socket error: ' + this.webSocket.readyState);
        };
        this.webSocket.onopen = (event)=>{
            // console.log('Sending', JSON.stringify(mess))
            if (this.webSocket) {
                const mess = {
                    type: 'session_init',
                    user_name: this.userName,
                    user_id: this.userId
                };
                if ($ff0c48d396ccec4c$var$DEBUG) console.log('socket onopen: ' + this.webSocket.readyState);
                this.webSocket.send(JSON.stringify(mess));
                if (extraMessage) // We just sent the init call - wait for a short while to let first message arrive at websocket server
                // TODO - it would be better to wait for session_init confirmation before sending next message
                setTimeout(()=>{
                    if (this.webSocket) {
                        this.webSocket.send(JSON.stringify(extraMessage));
                        if ($ff0c48d396ccec4c$var$DEBUG) console.log('Sent message after open');
                    }
                }, 200);
            }
        };
        // Use addEventListener in places where message matters, e.g VideoMeeting
        // This is just for debugging
        this.webSocket.onmessage = (message)=>{
            const jsonMess = JSON.parse(message.data);
        // console.log(jsonMess)
        };
        this.webSocket.onclose = (message)=>{
            if ($ff0c48d396ccec4c$var$DEBUG) console.log('socket closed');
            clearInterval(this.pingInterval);
        };
        this.pingInterval = setInterval(()=>{
            if (this.webSocket) {
                if (this.webSocket?.readyState === this.webSocket?.OPEN) {
                    const mess = {
                        type: 'ping'
                    };
                    this.webSocket.send(JSON.stringify(mess));
                } else console.log('webSocket not open');
            } else console.log('No webSocket!');
        }, 30000);
    }
    send = (message)=>{
        if (this.webSocket) {
            if (this.webSocket.readyState === 1) this.webSocket.send(JSON.stringify(message));
            else if (this.webSocket.readyState === 0) setTimeout(()=>{
                if (this.webSocket && this.webSocket.readyState === 1) {
                    console.log('socket open after delay');
                    this.webSocket.send(JSON.stringify(message));
                } else alert('Error: webSocket is broken. Report to support');
            }, 1000);
            else if (this.webSocket.readyState === 2) alert('Error: webSocket is closing. Report to support');
            else if (this.webSocket.readyState === 3) {
                console.log('Error: webSocket is closed. Try reopen');
                this.openSocket(message);
            }
        } else alert('Error: webSocket is broken. Report to support');
    };
    close() {
        if (this.webSocket) {
            console.log('socket close - state ' + this.webSocket.readyState);
            if (this.webSocket.readyState === 1) this.webSocket.close();
            else console.log('socket is not open');
            console.log('socket close - closed ' + this.webSocket.readyState);
        } else console.log('socket close - no webSocket');
    }
    sendEvent = (name, message)=>{
        const ev = new CustomEvent(name, {
            detail: {
                message: message
            }
        });
        this.eventEl.dispatchEvent(ev);
    };
    /**
   * @returns {WebSocketClient}
   */ static getInstance() {
        if ($ff0c48d396ccec4c$export$2e2bcd8739ae039.myInstance == null) {
            if ($ff0c48d396ccec4c$var$DEBUG) console.log('HD: creating new instance');
            $ff0c48d396ccec4c$export$2e2bcd8739ae039.myInstance = new $ff0c48d396ccec4c$export$2e2bcd8739ae039();
        } else {
            if ($ff0c48d396ccec4c$var$DEBUG) console.log('HD: checking existing instance');
            $ff0c48d396ccec4c$export$2e2bcd8739ae039.myInstance.checkOpen();
        }
        return this.myInstance;
    }
}


const $4d8f55ac7a5ea02a$export$64783e31db14f0ba = (language)=>{
    if (!language) return 'en';
    if (language.startsWith('sv')) return 'sv';
    return 'en';
};


const $d81e6e01a724e49d$var$Chat = ({ clientId: clientId, coachId: coachId, isCoach: isCoach })=>{
    const api = (0, $910fe95c6c1b0e1b$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { i18n: i18n } = translation;
    const lang = (0, $4d8f55ac7a5ea02a$export$64783e31db14f0ba)(i18n.language);
    const [chats, _setChats] = (0, $acw62.useState)([]);
    const chatsRef = (0, $acw62.useRef)([]);
    const [client, setClient] = (0, $acw62.useState)();
    const [coach, setCoach] = (0, $acw62.useState)();
    const [loaded, setLoaded] = (0, $acw62.useState)(false);
    const [activeLicense, setActiveLicense] = (0, $acw62.useState)(false);
    const chatWindowRef = (0, $acw62.useRef)(null);
    const setChats = (newChats)=>{
        chatsRef.current = newChats;
        _setChats(newChats);
    };
    const webSocketClient = (0, $acw62.useRef)((0, $ff0c48d396ccec4c$export$2e2bcd8739ae039).getInstance());
    (0, $acw62.useEffect)(()=>{
        const url = clientId ? 'coach/chat/' + clientId + '/get' : 'client/chat/' + coachId + '/get';
        api.get(url).then((result)=>{
            const chats = [];
            for (const chat of result.json.chats){
                chat.dateSent = new Date(chat.dateSent);
                if (chat.dateRead) chat.dateRead = new Date(chat.dateRead);
                chats.push(chat);
            }
            setClient(result.json.client);
            setCoach(result.json.coach);
            setChats(chats);
            setActiveLicense(result.json.activeLicense);
            setLoaded(true);
            webSocketClient.current.webSocket?.addEventListener("message", messageListener);
        });
        return ()=>{
            webSocketClient.current.webSocket?.removeEventListener("message", messageListener);
        };
    }, []);
    const sendReadAll = ()=>{
        const url = isCoach ? 'coach/chat/' + clientId + '/read_all' : 'client/chat/' + coachId + '/read_all';
        api.get(url).then(()=>console.log('sent read'));
    };
    const messageListener = (event)=>{
        const mess = JSON.parse(event.data);
        const fromId = isCoach ? "client_" + clientId : "coach_" + coachId;
        if (mess.chat && mess.fromId === fromId) {
            const newChat = {
                id: Math.floor(Math.random() * 1000000),
                text: mess.chat.message,
                sentByCoach: false,
                dateSent: new Date(),
                dateRead: new Date()
            };
            const newChats = [
                ...chatsRef.current
            ];
            newChats.push(newChat);
            setChats(newChats);
            sendReadAll();
        } else {
            console.log('fromId ' + fromId + ' != ' + mess.fromId);
            console.log(mess);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (chats.length > 0 && chatWindowRef.current) chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
    }, [
        chats
    ]);
    if (!loaded) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading chats..."
    });
    const send = (text)=>{
        if (text.length < 1) return;
        const url = isCoach ? 'coach/chat/' + clientId + '/send' : 'client/chat/' + coachId + '/send';
        const data = {
            text: text,
            sentByCoach: isCoach
        };
        api.post(url, data).then((result)=>{
            if (result.response.ok) {
                const chat = {
                    id: 0,
                    text: text,
                    sentByCoach: isCoach,
                    dateSent: new Date()
                };
                if (result.json.readBy && result.json.readBy > 0) chat.dateRead = new Date();
                const newChats = [
                    ...chats
                ];
                newChats.push(chat);
                setChats(newChats);
                if (chatWindowRef.current) chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
            }
        });
    };
    const chatInputHeightChange = (height)=>{
        if (chatWindowRef.current) chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative flex justify-between flex-col",
        style: {
            height: "calc(100vh - 144px)"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: chatWindowRef,
                className: "overflow-y-scroll",
                children: chats.map((chat, index)=>{
                    const img = chat.sentByCoach ? coach?.picture ? coach.picture : (0, (/*@__PURE__*/$parcel$interopDefault($cdc873224824021b$exports))) : client?.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($cdc873224824021b$exports)));
                    const name = chat.sentByCoach ? coach?.firstName + ' ' + coach?.lastName : client?.firstName + ' ' + client?.lastName;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-4 mt-4 flex",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "h-8 w-8 rounded-full",
                                src: img,
                                alt: "pic"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ml-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "font-medium",
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-neutral-400 ml-4 font-normal",
                                                children: (0, $f6959fbcc1e8f0a1$export$83d04527fc498dec)(chat.dateSent, lang)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-neutral-300 whitespace-pre-line",
                                        children: chat.text
                                    })
                                ]
                            })
                        ]
                    }, "chat_" + index);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "border-neutral-700 mt-4"
                    }),
                    activeLicense ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f44b9061dc4d4058$export$2e2bcd8739ae039), {
                        handleSendMessage: send,
                        onHeightChange: chatInputHeightChange
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "border-neutral-500 bg-neutral-700 p-4 mt-4 rounded-[6px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7681aec77a46b3e7$exports))),
                                        alt: "info",
                                        className: "w-6 h-6"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "ml-2",
                                        children: lang === 'sv' ? 'Coachingperioden har avslutats' : 'Coaching period ended'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-4 text-sm",
                                children: lang === 'sv' ? "Coachperioden har avslutats och chatten \xe4r nu inaktiv. Du kan fortfarande se gamla meddelanden, men du kan inte skicka nya." : 'The coaching period has ended and the chat is now inactive. You can still view your past messages, but new messages can no longer be sent.'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $d81e6e01a724e49d$export$2e2bcd8739ae039 = $d81e6e01a724e49d$var$Chat;




var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");
const $7ef95a4e8f007c14$var$colorClasses = {
    blue: 'bg-primary-500 hover:bg-primary-400 active:bg-primary-400 disabled:opacity-40 text-neutral-900',
    'outline-white': 'bg-transparent ring-inset ring-1 text-white ring-neutral-500 hover:bg-neutral-700 disabled:opacity-40',
    neutral: 'bg-neutral-700 text-white hover:bg-neutral-600 active:bg-neutral-700 disabled:bg-neutral-600 disabled:opacity-40 disabled:text-neutral-900',
    transparent: 'bg-transparent text-inherit hover:bg-neutral-600 active:bg-transparent disabled:opacity-40',
    red: 'bg-cherry-500 hover:bg-cherry-400 active:bg-cherry-500 disabled:opacity-40 text-neutral-900'
};
const $7ef95a4e8f007c14$var$regularSizeClasses = {
    sm: 'py-2 px-3 text-xs font-medium',
    md: 'py-3 px-4 text-sm font-medium',
    lg: 'py-3 px-4 text-base font-medium'
};
const $7ef95a4e8f007c14$var$roundSizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6'
};
const $7ef95a4e8f007c14$var$iconSizeClasses = {
    sm: 'h-4 w-4 items-center',
    md: 'h-6 w-6 items-center flex justify-center align-middle'
};
const $7ef95a4e8f007c14$var$buttonTypeClasses = {
    blueBase: $7ef95a4e8f007c14$var$colorClasses.blue,
    outlineWhiteBase: $7ef95a4e8f007c14$var$colorClasses['outline-white'],
    neutralBase: $7ef95a4e8f007c14$var$colorClasses.neutral,
    transparentBase: $7ef95a4e8f007c14$var$colorClasses.transparent,
    dangerBase: $7ef95a4e8f007c14$var$colorClasses.red
};
const $7ef95a4e8f007c14$var$CustomButton = ({ disabled: disabled = false, className: className = '', buttonType: buttonType = 'blueBase', size: size = 'md', isRound: isRound = false, onClick: onClick, leftIcon: leftIcon, rightIcon: rightIcon, children: children, style: style })=>{
    // Determine size-related classes
    const sizeClass = isRound ? $7ef95a4e8f007c14$var$roundSizeClasses[size] : $7ef95a4e8f007c14$var$regularSizeClasses[size];
    // Fully rounded for any isRound scenario
    const roundedClass = 'rounded-full';
    // Width for non-round buttons
    const widthClass = isRound ? '' : 'w-full';
    // Determine icon size
    let iconClass = $7ef95a4e8f007c14$var$iconSizeClasses['sm'];
    if (isRound) iconClass = $7ef95a4e8f007c14$var$iconSizeClasses[size];
    // Combine all classes
    const classes = [
        $7ef95a4e8f007c14$var$buttonTypeClasses[buttonType],
        sizeClass,
        roundedClass,
        widthClass,
        'inline-flex',
        'items-center',
        'justify-center',
        isRound ? 'gap-0' : 'gap-x-2',
        'disabled:pointer-events-none',
        'transition-colors',
        'duration-200',
        className
    ].join(' ');
    // Otherwise, render a regular <button>
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        style: style,
        type: "button",
        className: classes,
        onClick: onClick,
        disabled: disabled,
        children: isRound ? leftIcon || rightIcon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: iconClass,
            children: leftIcon || rightIcon
        }) : children : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                leftIcon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: iconClass,
                    children: leftIcon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: children
                }),
                rightIcon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: iconClass,
                    children: rightIcon
                })
            ]
        })
    });
};
var $7ef95a4e8f007c14$export$2e2bcd8739ae039 = $7ef95a4e8f007c14$var$CustomButton;


var $5f2059b7ec0bc40d$export$2e2bcd8739ae039 = (0, $7ef95a4e8f007c14$export$2e2bcd8739ae039);


// Modal.tsx

parcelRequire("acw62");
// ModalContext.ts

var $acw62 = parcelRequire("acw62");
const $8ae071ebe112bc4e$export$78945e9f57940bb = /*#__PURE__*/ (0, $acw62.createContext)('neutral');


const $a5fe3119a76402fb$var$Modal = ({ isOpen: isOpen, onClose: onClose, children: children, variant: variant = 'neutral', ignoreOutsideClick: ignoreOutsideClick = false })=>{
    const variantClasses = {
        neutral: {
            background: 'bg-neutral-800'
        },
        warning: {
            background: 'bg-cherry-200'
        }
    };
    const clickOutside = ()=>{
        if (!ignoreOutsideClick) onClose();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `fixed inset-0 z-50 ${isOpen ? 'flex' : 'hidden'} items-center justify-center rounded-md`,
        role: "dialog",
        "aria-modal": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 bg-gray-900 bg-opacity-50 dark:bg-opacity-80",
                onClick: clickOutside
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ae071ebe112bc4e$export$78945e9f57940bb).Provider, {
                value: variant,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `relative ${variantClasses[variant].background} rounded-md shadow-lg z-50 w-full max-w-lg mx-4 desktop:mx-0`,
                    children: children
                })
            })
        ]
    });
};
var $a5fe3119a76402fb$export$2e2bcd8739ae039 = $a5fe3119a76402fb$var$Modal;


// ModalHeader.tsx


var $acw62 = parcelRequire("acw62");



const $0f81b3b5e027438c$var$ModalHeader = ({ children: children, onClose: onClose })=>{
    const variant = (0, $acw62.useContext)((0, $8ae071ebe112bc4e$export$78945e9f57940bb));
    const variantClasses = {
        neutral: {
            border: 'border-neutral-600',
            "text": 'text-white'
        },
        warning: {
            border: 'border-cherry-400',
            text: 'text-neutral-900'
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex justify-between items-center py-3 px-4 border-b ${variantClasses[variant].border} ${variantClasses[variant].text}`,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f2059b7ec0bc40d$export$2e2bcd8739ae039), {
                buttonType: "transparentBase",
                size: "sm",
                isRound: true,
                leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($14de963752b00cee$exports))),
                    alt: "Info",
                    className: "w-4 h-4"
                }),
                onClick: onClose
            })
        ]
    });
};
var $0f81b3b5e027438c$export$2e2bcd8739ae039 = $0f81b3b5e027438c$var$ModalHeader;


var $bc773e7786ae2d80$export$2e2bcd8739ae039 = (0, $0f81b3b5e027438c$export$2e2bcd8739ae039);


// ModalBody.tsx


var $acw62 = parcelRequire("acw62");

const $d0069ee8208dc4ce$var$ModalBody = ({ children: children })=>{
    const variant = (0, $acw62.useContext)((0, $8ae071ebe112bc4e$export$78945e9f57940bb));
    const variantClasses = {
        neutral: {
            text: 'text-neutral-300'
        },
        warning: {
            text: 'text-neutral-900'
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `p-4 overflow-y-auto ${variantClasses[variant].text}`,
        children: children
    });
};
var $d0069ee8208dc4ce$export$2e2bcd8739ae039 = $d0069ee8208dc4ce$var$ModalBody;


var $987d8300783ee9b5$export$2e2bcd8739ae039 = (0, $d0069ee8208dc4ce$export$2e2bcd8739ae039);


// ModalFooter.tsx


var $acw62 = parcelRequire("acw62");

const $6608cb53c6ed82ae$var$ModalFooter = ({ children: children })=>{
    const variant = (0, $acw62.useContext)((0, $8ae071ebe112bc4e$export$78945e9f57940bb));
    const variantClasses = {
        neutral: {
            border: 'border-neutral-600',
            text: 'text-white'
        },
        warning: {
            border: 'border-cherry-400',
            text: 'text-neutral-900'
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `flex justify-center items-center gap-x-2 py-3 px-4 border-t ${variantClasses[variant].border} ${variantClasses[variant].text}`,
        children: children
    });
};
var $6608cb53c6ed82ae$export$2e2bcd8739ae039 = $6608cb53c6ed82ae$var$ModalFooter;


var $be53a2c4319a55d6$export$2e2bcd8739ae039 = (0, $6608cb53c6ed82ae$export$2e2bcd8739ae039);


var $a4a4e6cf88f71c21$export$2e2bcd8739ae039 = (0, $a5fe3119a76402fb$export$2e2bcd8739ae039);







var $e427d3b516945e6e$exports = {};
$e427d3b516945e6e$exports = import.meta.resolve("3Cspg");


var $dbfcc90f358ab5a6$exports = {};
$dbfcc90f358ab5a6$exports = import.meta.resolve("fuDt1");






var $acw62 = parcelRequire("acw62");
var $aab92af29e7d5784$exports = {};
$aab92af29e7d5784$exports = import.meta.resolve("eV4fN");


var $bb1bc62454d10b84$exports = {};
$bb1bc62454d10b84$exports = import.meta.resolve("14NwO");


const $2f195e6d38f66fca$var$DatePicker = ({ dates: dates, clickDate: clickDate, preSelectedDate: preSelectedDate, className: className, inactiveDatesRange: inactiveDatesRange, skipClickMonthChange: skipClickMonthChange })=>{
    const today = new Date();
    const thisDay = preSelectedDate ? preSelectedDate : today;
    const [currentMonth, setCurrentMonth] = (0, $acw62.useState)(thisDay.getMonth());
    const [currentYear, setCurrentYear] = (0, $acw62.useState)(thisDay.getFullYear());
    const [selectedDate, setSelectedDate] = (0, $acw62.useState)(preSelectedDate ? {
        day: preSelectedDate.getDate(),
        month: preSelectedDate.getMonth(),
        year: preSelectedDate.getFullYear()
    } : null);
    const [paddingDays, setPaddingDays] = (0, $acw62.useState)([]);
    const [columnGap, setColumnGap] = (0, $acw62.useState)('48px');
    const containerRef = (0, $acw62.useRef)(null);
    // Define event dates
    const eventDates = [];
    for (const d of dates)eventDates.push({
        day: d.getDate(),
        month: d.getMonth(),
        year: d.getFullYear()
    });
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    const daysInMonth = (month, year)=>new Date(year, month + 1, 0).getDate();
    const weekDayOfFirst = (month, year)=>{
        let dayOfWeek = new Date(year, month, 1).getDay();
        return dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Monday = 0, Sunday = 6
    };
    const [days, setDays] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        setDays(Array.from({
            length: daysInMonth(currentMonth, currentYear)
        }, (_, i)=>i + 1));
        const weekDay = weekDayOfFirst(currentMonth, currentYear);
        setPaddingDays(Array.from({
            length: weekDay
        }, (_, i)=>i + 1));
    }, [
        currentMonth,
        currentYear
    ]);
    (0, $acw62.useEffect)(()=>{
        if (preSelectedDate) {
            const year = preSelectedDate.getFullYear();
            const month = preSelectedDate.getMonth();
            const day = preSelectedDate.getDate();
            setSelectedDate({
                day: day,
                month: month,
                year: year
            });
            setCurrentMonth(month);
            setCurrentYear(year);
        }
    }, [
        preSelectedDate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (containerRef.current) {
            const w = containerRef.current.clientWidth;
            if (w < 636) {
                const colGap = w / 6 - 52;
                setColumnGap(colGap + 'px');
            }
        }
    }, [
        containerRef
    ]);
    // Check if the day has an event
    const hasEvent = (day)=>{
        return eventDates.some((event)=>event.day === day && event.month === currentMonth && event.year === currentYear);
    };
    // Check if the day is inactive
    const isInactive = (day)=>{
        if (!inactiveDatesRange || inactiveDatesRange.length === 0) return false;
        const currentDate = new Date(currentYear, currentMonth, day);
        if (inactiveDatesRange.length === 1) {
            const endDate = inactiveDatesRange[0];
            return currentDate < endDate;
        } else if (inactiveDatesRange.length >= 2) {
            const [startDate, endDate] = inactiveDatesRange.slice(0, 2);
            return currentDate >= startDate && currentDate <= endDate;
        }
        return false;
    };
    // Handle date click event
    const handleDateClick = (day)=>{
        setSelectedDate({
            day: day,
            month: currentMonth,
            year: currentYear
        });
        clickDate(new Date(currentYear, currentMonth, day));
    };
    // Handle previous month click
    const handlePreviousMonth = ()=>{
        if (!skipClickMonthChange) clickDate(null);
        if (currentMonth === 0) {
            setCurrentMonth(11);
            setCurrentYear((prev)=>prev - 1);
        } else setCurrentMonth((prev)=>prev - 1);
    };
    // Handle next month click
    const handleNextMonth = ()=>{
        if (!skipClickMonthChange) clickDate(null);
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear((prev)=>prev + 1);
        } else setCurrentMonth((prev)=>prev + 1);
    };
    // Define classes for each day
    const dayClasses = (day)=>{
        const inactive = isInactive(day);
        let classes = 'relative mb-4 size-10 flex flex-col justify-center items-center border border-transparent font-medium rounded-full';
        if (inactive) classes += ' text-neutral-400 cursor-not-allowed';
        else {
            if (selectedDate && day === selectedDate.day && currentMonth === selectedDate.month && currentYear === selectedDate.year) classes += ' bg-primary-500 text-neutral-800';
            else classes += ' text-white hover:bg-neutral-700 hover:text-white';
            if (hasEvent(day)) classes += ' border-white';
        }
        return classes;
    };
    // Render today dot
    const todayDot = (day)=>{
        if (day === today.getDate() && currentMonth === today.getMonth() && currentYear === today.getFullYear()) {
            let classes = 'absolute bottom-1 w-0.5 h-0.5 rounded-full';
            if (isInactive(day)) classes += ' bg-neutral-400';
            else if (selectedDate && day === selectedDate.day && currentMonth === selectedDate.month && currentYear === selectedDate.year) classes += ' bg-neutral-800';
            else classes += ' bg-white hover:bg-white';
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: classes
            });
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "sm:flex",
        ref: containerRef,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-0.5 w-full p-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-5 items-center gap-x-3 pb-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "col-span-1",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: handlePreviousMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-neutral-600 rounded-full",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "left",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($aab92af29e7d5784$exports))),
                                    className: "h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "col-span-3 flex justify-center items-center gap-x-1 text-lg font-medium",
                            children: [
                                months[currentMonth],
                                " ",
                                currentYear
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "col-span-1 flex justify-end",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: handleNextMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-neutral-600 rounded-full",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "right",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bb1bc62454d10b84$exports))),
                                    className: "h-6"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "grid grid-cols-7 pb-2.5",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        'Mo',
                        'Tu',
                        'We',
                        'Th',
                        'Fr',
                        'Sa',
                        'Su'
                    ].map((day)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "m-px w-10 block text-center font-medium text-white",
                            children: day
                        }, day))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-7",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        paddingDays.map((paddingDay)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}, 'p_' + paddingDay)),
                        days.map((day)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>handleDateClick(day),
                                className: dayClasses(day),
                                disabled: isInactive(day),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: day
                                    }),
                                    todayDot(day)
                                ]
                            }, day))
                    ]
                })
            ]
        })
    });
};
var $2f195e6d38f66fca$export$2e2bcd8739ae039 = $2f195e6d38f66fca$var$DatePicker;


var $e6bf20acb9fadbdb$export$2e2bcd8739ae039 = (0, $2f195e6d38f66fca$export$2e2bcd8739ae039);



parcelRequire("acw62");
var $8c9d18c37f87aa13$exports = {};
$8c9d18c37f87aa13$exports = import.meta.resolve("96Y0S");


const $acaec7680bc184d2$var$CheckBox = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "z-checkbox cursor-pointer" + (props.checked ? " checked" : ""),
        children: props.checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8c9d18c37f87aa13$exports))),
            alt: "checked"
        })
    });
};
var $acaec7680bc184d2$export$2e2bcd8739ae039 = $acaec7680bc184d2$var$CheckBox;


const $835a168710da619d$var$BookMeeting = ({ meeting: meeting, clientId: clientId, close: close, lang: lang, who: who })=>{
    const api = (0, $910fe95c6c1b0e1b$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const [txt, setTxt] = (0, $acw62.useState)('');
    const [booked, setBooked] = (0, $acw62.useState)(false);
    const [confirm, setConfirm] = (0, $acw62.useState)(false);
    const [newMeeting, setNewMeeting] = (0, $acw62.useState)(null);
    const [avails, setAvails] = (0, $acw62.useState)([]);
    const [bookableDays, setBookableDays] = (0, $acw62.useState)([]);
    const [selectedDate, setSelectedDate] = (0, $acw62.useState)(null);
    const [clientAgreed, setClientAgreed] = (0, $acw62.useState)(who === 'client');
    const [error, setError] = (0, $acw62.useState)(null);
    const minutesBetweenMeetings = (0, $acw62.useRef)(15);
    (0, $acw62.useEffect)(()=>{
        const meetingId = meeting ? meeting.id : '0';
        if (who === 'coach') api.get('coach/availability/all/' + clientId + '/' + meetingId).then((response)=>{
            const newAvails = [];
            setError(response.json.error);
            const newBookableDays = [];
            for (const recurring of response.json.available){
                const from = new Date(recurring.from);
                const to = new Date(recurring.to);
                newBookableDays.push(from);
                newAvails.push({
                    from: from,
                    to: to
                });
            }
            minutesBetweenMeetings.current = response.json.startInterval;
            setAvails(newAvails);
            setBookableDays(newBookableDays);
        });
        else api.get('client/meeting_availability').then((response)=>{
            if (response.json.error) setError(response.json.error);
            else {
                const newAvails = [];
                const newBookableDays = [];
                for (const timeslot of response.json.timeslots){
                    const from = new Date(timeslot.start);
                    const to = new Date(timeslot.end);
                    newBookableDays.push(from);
                    newAvails.push({
                        from: from,
                        to: to
                    });
                }
                minutesBetweenMeetings.current = response.json.startInterval;
                setAvails(newAvails);
                setBookableDays(newBookableDays);
            }
        });
    }, []);
    const doBook = ()=>{
        if (who === 'coach') {
            const data = {
                id: meeting?.id,
                client_id: meeting?.clientId,
                from: newMeeting?.start,
                length: meeting?.length,
                message: txt
            };
            api.post('coach/meeting/book', data).then((response)=>{
                setBooked(true);
            });
        } else {
            const data = {
                from: newMeeting?.start,
                length: meeting?.length,
                id: meeting?.id
            };
            api.post('client/meeting_book', data).then((response)=>{
                setBooked(true);
            });
        }
    };
    const getBookableMeetings = (day)=>{
        const startEvents = [];
        let id = 1;
        const meetingInSeconds = meeting ? meeting.length * 60 : 1800;
        const pauseInSeconds = minutesBetweenMeetings.current * 60;
        for (const d of avails){
            if (d.from.getFullYear() != day.getFullYear() || d.from.getMonth() != day.getMonth() || d.from.getDate() != day.getDate()) continue;
            let start = new Date(d.from);
            while((d.to.getTime() - start.getTime()) / 1000 >= meetingInSeconds){
                let end = new Date(start);
                end.setSeconds(end.getSeconds() + meetingInSeconds);
                startEvents.push({
                    id: id,
                    title: "M",
                    start: start,
                    end: end
                });
                console.log('Adding ' + start + ' - ' + end);
                id++;
                start = new Date(start);
                start.setSeconds(start.getSeconds() + pauseInSeconds);
            }
        }
        return startEvents;
    };
    const showContent = ()=>{
        if (booked) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "my-12 flex justify-center items-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "icon-xl",
                        alt: "check",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dbfcc90f358ab5a6$exports)))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "text-neutral-300",
                    children: [
                        t("your-meeting-has"),
                        " ",
                        meeting?.id === '0' ? t('been-booked') : t('been-changed'),
                        " ",
                        who === 'coach' ? t("client-is-notified") : t("coach-is-notified")
                    ]
                })
            ]
        });
        else if (newMeeting) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "font-medium",
                    children: [
                        meeting?.firstName,
                        " ",
                        meeting?.lastName
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-4 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            alt: "calendar",
                            className: "h-6 w-6",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6c93e43386478db6$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ml-2",
                            children: (0, $f6959fbcc1e8f0a1$export$1c7501cd03a59e59)(newMeeting.start, false, lang)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-4 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "h-6 w-6",
                            alt: "Time",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e427d3b516945e6e$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "ml-2",
                            children: [
                                (0, $f6959fbcc1e8f0a1$export$5f885a9374f8e024)(newMeeting.start),
                                " - ",
                                (0, $f6959fbcc1e8f0a1$export$5f885a9374f8e024)(newMeeting.end)
                            ]
                        })
                    ]
                }),
                who === 'coach' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-4 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            onClick: ()=>setClientAgreed(!clientAgreed),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acaec7680bc184d2$export$2e2bcd8739ae039), {
                                checked: clientAgreed
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "ml-2",
                            children: lang === 'sv' ? "Avst\xe4mt med klient" : 'Confirmed with client'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                        value: txt,
                        className: "z-input z-700 h-24",
                        placeholder: who === 'coach' ? t("write-message-to-client") : t("write-message-to-coach"),
                        onChange: (e)=>setTxt(e.target.value),
                        autoComplete: "off"
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    };
    const selectMeetingTime = (e)=>{
        setNewMeeting(e);
    };
    (0, $acw62.useEffect)(()=>{
        if (newMeeting) setConfirm(true);
    }, [
        newMeeting
    ]);
    const showConfirmText = ()=>{
        if (booked) {
            if (meeting?.id === '0') {
                if (lang === 'sv') return "M\xf6tet har bokats";
                else return "The meeting has been booked";
            } else {
                if (lang === 'sv') return "M\xf6tet har \xe4ndrats";
                else return "The meeting has been changed";
            }
        } else if (meeting?.id === '0') {
            if (lang === 'sv') return "Bekr\xe4fta bokning";
            else return "Confirm meeting";
        } else {
            if (lang === 'sv') return "Bekr\xe4fta \xe4ndring";
            else return "Confirm change";
        }
    };
    if (error) {
        if (error === 'no_remaining_meetings') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: lang === 'sv' ? "Du har bokat alla dina m\xf6ten" : 'You have booked all your meetings'
            })
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: error
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a4a4e6cf88f71c21$export$2e2bcd8739ae039), {
                isOpen: confirm,
                onClose: ()=>setConfirm(false),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc773e7786ae2d80$export$2e2bcd8739ae039), {
                        onClose: ()=>setConfirm(false),
                        children: showConfirmText()
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $987d8300783ee9b5$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: showContent()
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be53a2c4319a55d6$export$2e2bcd8739ae039), {
                        children: booked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f2059b7ec0bc40d$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            className: "w-full",
                            onClick: ()=>close(booked),
                            children: "Ok"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f2059b7ec0bc40d$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            className: "w-full",
                            onClick: ()=>doBook(),
                            disabled: !clientAgreed,
                            children: meeting?.id === '0' ? t('book-meeting') : t('change-meeting')
                        })
                    })
                ]
            }),
            meeting?.id != '0' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-2xl mt-4 font-medium",
                        children: lang === 'sv' ? "\xc4ndra datum och tid" : 'Change date and time'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 p-4 bg-neutral-700 text-white rounded border border-neutral-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-betwen items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "font-medium",
                                        children: t("original-booking")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-grow justify-end",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: "cursor-pointer",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($14de963752b00cee$exports))),
                                            alt: "close",
                                            onClick: ()=>close(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-4 flex items-center text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            meeting?.firstName,
                                            " ",
                                            meeting?.lastName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "ml-4 flex",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6c93e43386478db6$exports))),
                                                className: "icon",
                                                alt: "cal"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "ml-1",
                                                children: meeting && (0, $f6959fbcc1e8f0a1$export$1c7501cd03a59e59)(meeting.startDate, false, lang)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "ml-4 flex",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e427d3b516945e6e$exports))),
                                                className: "icon",
                                                alt: "cal"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "ml-1",
                                                children: [
                                                    meeting && (0, $f6959fbcc1e8f0a1$export$5f885a9374f8e024)(meeting.startDate),
                                                    " - ",
                                                    meeting && (0, $f6959fbcc1e8f0a1$export$5f885a9374f8e024)((0, $f6959fbcc1e8f0a1$export$2287e3d29250119e)(meeting.startDate, meeting.length))
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-8",
                        children: "\xa0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6bf20acb9fadbdb$export$2e2bcd8739ae039), {
                dates: bookableDays,
                clickDate: (d)=>setSelectedDate(d),
                preSelectedDate: null
            }),
            selectedDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between items-end",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "font-medium text-lg",
                                children: t('available-times')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: (0, $f6959fbcc1e8f0a1$export$1c7501cd03a59e59)(selectedDate, false, lang)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid grid-cols-3 gap-x-2",
                        children: getBookableMeetings(selectedDate).map((d, i)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f2059b7ec0bc40d$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: ()=>selectMeetingTime(d),
                                    className: "w-full",
                                    children: (0, $f6959fbcc1e8f0a1$export$5f885a9374f8e024)(d.start)
                                })
                            }, "time_" + i);
                        })
                    })
                ]
            })
        ]
    });
};
var $835a168710da619d$export$2e2bcd8739ae039 = $835a168710da619d$var$BookMeeting;





var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");
const $a1748a49f7ac5eb7$var$Toaster = ({ message: message, image: image, onClose: onClose, isOpen: isOpen })=>{
    const [fadeOut, setFadeOut] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setFadeOut(true);
            setTimeout(()=>{
                onClose();
            }, 5000);
        }, 8000);
        return ()=>{
            setFadeOut(false);
            clearTimeout(timer);
        };
    }, [
        onClose
    ]);
    const darkStyle = 'dark:bg-neutral-800 dark:border-neutral-700 dark:text-white';
    const fadeOutStyle = fadeOut ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0';
    const animationStyle = 'transition-all duration-5000';
    const shapeStyle = 'max-w-md bg-white border border-gray-200 rounded-md shadow-lg';
    const stylingClasses = `${shapeStyle} ${darkStyle} ${animationStyle} ${fadeOutStyle}`;
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed top-4 left-0 w-full flex justify-center z-50",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: stylingClasses,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center p-4 gap-2.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-shrink-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "h-6 w-6",
                            src: image,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-base font-medium text-gray-800 dark:text-white",
                            children: message
                        })
                    })
                ]
            })
        })
    });
};
var $a1748a49f7ac5eb7$export$2e2bcd8739ae039 = $a1748a49f7ac5eb7$var$Toaster;


var $5e99d435883ec26b$export$2e2bcd8739ae039 = (0, $a1748a49f7ac5eb7$export$2e2bcd8739ae039);



const $3dc97274f32ebfdf$var$imageNrs = Array.from(new Array(58), (val, index)=>"" + (index + 1));
const $3dc97274f32ebfdf$var$CoachingTools = ({ who: who, api: api, meetingId: meetingId, close: close, lang: lang, webSocketClient: webSocketClient, partnerId: partnerId })=>{
    // const api = Api.getInstance();
    const translation = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const [page, setPage] = (0, $acw62.useState)('');
    const [title, setTitle] = (0, $acw62.useState)('');
    const [activity, setActivity] = (0, $acw62.useState)('');
    const [notes, setNotes] = (0, $acw62.useState)('');
    const [images, setImages] = (0, $acw62.useState)([]);
    const [selectImages, setSelectImages] = (0, $acw62.useState)([]);
    const [focusArea, setFocusArea] = (0, $acw62.useState)('');
    const [deadline, setDeadline] = (0, $acw62.useState)(null);
    const [selectDeadline, setSelectDeadline] = (0, $acw62.useState)(false);
    const [imagesChanged, setImagesChanged] = (0, $acw62.useState)(false);
    const [showToaster, setShowToaster] = (0, $acw62.useState)(false);
    const [focusAreas, setFocusAreas] = (0, $acw62.useState)([]);
    const url = who + '/coaching-tools/' + meetingId;
    (0, $acw62.useEffect)(()=>{
        getData();
        webSocketClient.webSocket?.addEventListener("message", messageListener);
        return ()=>{
            webSocketClient.webSocket?.removeEventListener("message", messageListener);
        };
    }, []);
    const getData = ()=>{
        api.get(url).then((response)=>{
            if (response.json.error) alert(response.json.error);
            else {
                setFocusAreas(response.json.focusAreas);
                if (response.json.meetingNotes) {
                    setNotes(response.json.meetingNotes.notes);
                    if (response.json.meetingNotes.images) {
                        setImages(response.json.meetingNotes.images);
                        setSelectImages(response.json.meetingNotes.images);
                    }
                }
            }
        });
    };
    const messageListener = (event)=>{
        const mess = JSON.parse(event.data);
        if (!mess) return;
        if (mess.command === 'updatedCoachingTools') getData();
    // console.log(mess)
    };
    const updateDeadline = (d)=>{
        setDeadline(d);
        setSelectDeadline(false);
    };
    const notifyPeer = ()=>{
        const mess = {
            type: 'to_user_id',
            user_id: partnerId,
            message: {
                type: 'from_user_id',
                command: 'updatedCoachingTools'
            }
        };
        webSocketClient.send(mess);
    };
    const saveActivity = ()=>{
        const data = {
            what: 'createActivity',
            focusAreaId: focusArea,
            title: title,
            activity: activity,
            deadline: deadline
        };
        api.post(url, data).then((response)=>{
            if (response.json.error) alert(response.json.error);
            else {
                setShowToaster(true);
                setDeadline(null);
                setActivity('');
                setTitle('');
                setFocusArea('');
                notifyPeer();
            }
        });
    };
    const saveNotes = ()=>{
        const data = {
            what: 'notes',
            notes: notes
        };
        api.post(url, data).then((response)=>{
            if (response.json.error) alert(response.json.error);
            else {
                console.log('Saved notes');
                notifyPeer();
            }
        });
    };
    const selectImage = (nr)=>{
        let found = false;
        for (let _nr of selectImages)if (_nr === nr) found = true;
        if (!found) // Add image
        setSelectImages([
            ...selectImages,
            nr
        ]);
        else {
            let _images = [];
            for (let _nr of selectImages)if (_nr !== nr) _images.push(_nr);
            setSelectImages(_images);
        }
        setImagesChanged(true);
    };
    const saveImages = (images)=>{
        const data = {
            what: 'images',
            images: images
        };
        api.post(url, data).then((response)=>{
            if (response.json.error) alert(response.json.error);
            else {
                setImages(images);
                setPage('reflect');
                setImagesChanged(false);
                notifyPeer();
            }
        });
    };
    const removeImage = (imgId)=>{
        const _images = [];
        for (const img of images)if (img !== imgId) _images.push(img);
        setSelectImages(_images);
        saveImages(_images);
    };
    if (page === 'activity') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($aab92af29e7d5784$exports))),
                        className: "cursor-pointer h-6 w-6",
                        alt: "left",
                        onClick: ()=>setPage('')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: lang === 'sv' ? 'Skapa aktivitet' : 'Create action'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($14de963752b00cee$exports))),
                        className: "cursor-pointer h-6 w-6",
                        alt: "close",
                        onClick: ()=>close()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "mt-4 border-neutral-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-2xl font-medium mt-6",
                children: lang === 'sv' ? 'Formulera aktivitet' : 'Formulate action'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-neutral-400",
                children: lang === 'sv' ? "Tips! Formulera aktiviteten i Jag-form och skriv den konkret s\xe5 det blir tydligt vad som ska g\xf6ras och n\xe4r det ska vara klart." : 'Recommendation! Write the Action in first person (I-form) and make it specific so it\'s clear what needs to be done and when it should be completed.'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-6 font-medium",
                children: lang === 'sv' ? 'Titel' : 'Title'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                className: "mt-2 z-input",
                value: title,
                placeholder: lang === 'sv' ? "Skriv h\xe4r..." : 'Write here...',
                onChange: (e)=>setTitle(e.target.value)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-4 font-medium",
                children: lang === 'sv' ? 'Formulera aktivitet' : 'Formulate activity'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                rows: 8,
                className: "mt-2 z-input",
                value: activity,
                placeholder: lang === 'sv' ? "Skriv h\xe4r..." : 'Write here...',
                onChange: (e)=>setActivity(e.target.value)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-6 font-medium",
                children: lang === 'sv' ? "M\xe5ldatum" : 'Target date'
            }),
            selectDeadline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6bf20acb9fadbdb$export$2e2bcd8739ae039), {
                dates: [],
                inactiveDatesRange: [
                    new Date()
                ],
                clickDate: updateDeadline,
                preSelectedDate: deadline,
                skipClickMonthChange: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-2 z-input flex justify-between items-center",
                onClick: ()=>setSelectDeadline(true),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-neutral-400",
                        children: deadline ? (0, $f6959fbcc1e8f0a1$export$adf69d68d71478c0)(deadline) : lang === 'sv' ? "V\xe4lj datum" : 'Select date'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c93e43386478db6$exports))),
                        alt: "calendar",
                        className: "h-4 w-4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f2059b7ec0bc40d$export$2e2bcd8739ae039), {
                buttonType: "blueBase",
                onClick: saveActivity,
                className: "mt-6",
                children: lang === 'sv' ? 'Skapa aktivitet' : 'Create action'
            }),
            showToaster && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e99d435883ec26b$export$2e2bcd8739ae039), {
                message: lang === 'sv' ? 'Aktivitet skapad' : 'Action created',
                isOpen: showToaster,
                image: (0, (/*@__PURE__*/$parcel$interopDefault($dbfcc90f358ab5a6$exports))),
                onClose: ()=>setShowToaster(false)
            })
        ]
    });
    else if (page === 'reflect') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($aab92af29e7d5784$exports))),
                        className: "cursor-pointer h-6 w-6",
                        alt: "left",
                        onClick: ()=>setPage('')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: lang === 'sv' ? 'Reflektionsyta' : 'Reflection space'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($14de963752b00cee$exports))),
                        className: "cursor-pointer h-6 w-6",
                        alt: "close",
                        onClick: ()=>close()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "mt-4 border-neutral-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "mt-6 text-2xl font-medium",
                children: lang === 'sv' ? 'Anteckningar' : 'Notes'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                rows: 8,
                className: "mt-2 z-input",
                value: notes,
                onBlur: ()=>saveNotes(),
                placeholder: lang === 'sv' ? "Skriv dina tankar eller insikter h\xe4r..." : 'Write your thoughts or insights here...',
                onChange: (e)=>setNotes(e.target.value)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-neutral-400 text-sm",
                children: lang === 'sv' ? "Dina anteckningar sparas l\xf6pande" : 'Your notes are saved continuously'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-6 text-xl",
                children: lang === 'sv' ? 'Bilder' : 'Images'
            }),
            images.map((nr)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-2 w-full relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "absolute right-0 top-0",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "m-2 p-1 rounded-full bg-black cursor-pointer",
                                onClick: ()=>removeImage(nr),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($14de963752b00cee$exports))),
                                    alt: "remove"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: "https://public.zebrain.se/visionboard/pictures/" + nr + ".jpeg",
                            className: "w-full rounded-[6px] ",
                            alt: "image " + nr
                        })
                    ]
                }, "img_" + nr);
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f2059b7ec0bc40d$export$2e2bcd8739ae039), {
                buttonType: "outlineWhiteBase",
                onClick: ()=>setPage('images'),
                className: "mt-2",
                children: lang === 'sv' ? "L\xe4gg till bilder" : 'Add images'
            })
        ]
    });
    else if (page === 'images') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($aab92af29e7d5784$exports))),
                        className: "cursor-pointer h-6 w-6",
                        alt: "left",
                        onClick: ()=>setPage('reflect')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: lang === 'sv' ? "V\xe4lj bilder" : 'Select images'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($14de963752b00cee$exports))),
                        className: "cursor-pointer h-6 w-6",
                        alt: "close",
                        onClick: ()=>close()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "mt-4 border-neutral-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex gap-4 flex-wrap",
                children: [
                    $3dc97274f32ebfdf$var$imageNrs.map((nr)=>{
                        const bColor = selectImages.indexOf(nr) > -1 ? "border-primary-500" : "border-neutral-900";
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: "https://public.zebrain.se/visionboard/pictures/thumbs/" + nr + ".jpeg",
                            className: "border-[2px] rounded-[6px] cursor-pointer hover:border-primary-500 " + bColor,
                            onClick: ()=>selectImage(nr),
                            style: {
                                width: "calc(50% - 8px)"
                            },
                            alt: "image " + nr
                        }, "img_" + nr);
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-8",
                        children: "\xa0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "video_extra_window_bottom",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "my-2 bg-neutral-900 pt-2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f2059b7ec0bc40d$export$2e2bcd8739ae039), {
                        buttonType: "blueBase",
                        disabled: !imagesChanged,
                        onClick: ()=>saveImages(selectImages),
                        children: lang === 'sv' ? 'Spara' : 'Save'
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\xa0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: lang === 'sv' ? 'Coachingverktyg' : 'Coaching tools'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($14de963752b00cee$exports))),
                        className: "cursor-pointer h-6 w-6",
                        alt: "close",
                        onClick: ()=>close()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "mt-4 border-neutral-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "mt-6 text-2xl font-medium",
                children: lang === 'sv' ? "V\xe4lj verktyg" : 'Choose tool'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex mt-6 justify-between items-center cursor-pointer",
                onClick: ()=>setPage('activity'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: lang === 'sv' ? 'Skapa aktivitet' : 'Create action'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bb1bc62454d10b84$exports))),
                        alt: "right",
                        className: "h-6 w-6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "mt-4 border-neutral-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex mt-6 justify-between items-center cursor-pointer",
                onClick: ()=>setPage('reflect'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: lang === 'sv' ? 'Reflektionsyta' : 'Reflection space'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bb1bc62454d10b84$exports))),
                        alt: "right",
                        className: "h-6 w-6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "mt-4 border-neutral-700"
            })
        ]
    });
};
var $3dc97274f32ebfdf$export$2e2bcd8739ae039 = $3dc97274f32ebfdf$var$CoachingTools;


var $86a541a13dca317c$export$2e2bcd8739ae039 = (0, $3dc97274f32ebfdf$export$2e2bcd8739ae039);



class $835b32d718c0eab5$export$2e2bcd8739ae039 {
    mediaRecorder = null;
    session = 0;
    startTime = new Date();
    constructor(){
        console.log('Initialized RecordSound');
    }
    start = (resources, api)=>{
        // Force sending to localhost or backoffice backend, since files are stored locally
        const apiUrl = api.baseUrl.startsWith('https') ? 'https://backoffice.zebrain.se/api/' : api.baseUrl;
        if (resources.localStream) {
            // We need to merge all audio streams into one destination
            const context = new AudioContext();
            const sourceLocal = context.createMediaStreamSource(resources.localStream);
            const gainLocal = context.createGain();
            gainLocal.gain.value = 0.7;
            const destination = context.createMediaStreamDestination();
            sourceLocal.connect(gainLocal).connect(destination);
            // Add all partner video streams
            for (const partner of resources.partners)if (partner.videoStream) {
                const sourceP = context.createMediaStreamSource(partner.videoStream);
                const gainP = context.createGain();
                gainP.gain.value = 0.7;
                sourceP.connect(gainLocal).connect(destination);
            }
            const streams = new MediaStream();
            for (const track of destination.stream.getAudioTracks()){
                console.log('Added track');
                console.log(track);
                streams.addTrack(track);
            }
            // for (const partner of resources.partners) {
            //   if (partner.audioTrack) {
            //     console.log('Added partner track');
            //     console.log(partner.audioTrack);
            //     streams.addTrack(partner.audioTrack);
            //   }
            // }
            this.mediaRecorder = new MediaRecorder(streams);
            this.startTime = new Date();
            this.mediaRecorder.start(2000);
            this.mediaRecorder.ondataavailable = (e)=>{
                const formData = new FormData();
                formData.append('audio', e.data);
                formData.append('session', '' + this.session);
                const url = apiUrl + 'client/record_stream/meeting_' + resources.meetingKey;
                fetch(url, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + api.apiToken
                    },
                    body: formData
                }).then((response)=>{
                    console.log(response);
                });
            };
            this.mediaRecorder.onstop = (e)=>{
                this.session++;
                console.log('Stopped record');
                let now = new Date();
                let duration = now.getTime() - this.startTime.getTime();
                const url = apiUrl + 'client/record_stop/meeting_' + resources.meetingKey + "?duration=" + duration.toFixed(0);
                fetch(url, {
                    method: "GET",
                    headers: {
                        Authorization: "Bearer " + api.apiToken
                    }
                }).then((response)=>{
                    console.log(response);
                });
            };
        } else console.log("Missing resources");
    };
    stop = ()=>{
        if (this.mediaRecorder) this.mediaRecorder.stop();
        else console.log("Missing mediaRecorder");
    };
}


const $b5b5207d96999e61$var$soundFile = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($59b818d4bf08184f$exports))));
const $b5b5207d96999e61$var$debugOrder = false;
const $b5b5207d96999e61$var$recordSound = new (0, $835b32d718c0eab5$export$2e2bcd8739ae039)();
const $b5b5207d96999e61$export$d29f0e42bedca4fc = (props)=>{
    const api = (0, $910fe95c6c1b0e1b$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $4d8f55ac7a5ea02a$export$64783e31db14f0ba)(i18n.language);
    let infoText = '';
    const [tokenExpired, setTokenExpired] = (0, $acw62.useState)(false);
    const [fullscreen, setFullscreen] = (0, $acw62.useState)(false);
    const [cameraOn, setCameraOn] = (0, $acw62.useState)(false);
    const [micOn, setMicOn] = (0, $acw62.useState)(false);
    const [useCanvas, setUseCanvas] = (0, $acw62.useState)(false);
    const [videoDeviceId, setVideoDeviceId] = (0, $acw62.useState)('unset');
    const [videoGroupId, setVideoGroupId] = (0, $acw62.useState)('unset');
    const [audioDeviceId, setAudioDeviceId] = (0, $acw62.useState)('unset');
    const [audioGroupId, setAudioGroupId] = (0, $acw62.useState)('unset');
    const [audioOutDeviceId, setAudioOutDeviceId] = (0, $acw62.useState)('unset');
    const [showInfo, setShowInfo] = (0, $acw62.useState)(false);
    const [info, setInfo] = (0, $acw62.useState)('');
    const [shareScreen, setShareScreen] = (0, $acw62.useState)(false);
    const [openMenu, setOpenMenu] = (0, $acw62.useState)(false);
    const [recording, setRecording] = (0, $acw62.useState)(false);
    const [showTestSpeakers, setShowTestSpeakers] = (0, $acw62.useState)(false);
    const [extraWindow, setExtraWindow] = (0, $acw62.useState)((0, $cbe71848aa286a1b$export$4ec7f52694178c6).None);
    const [small, setSmall] = (0, $acw62.useState)(window.innerWidth < 800);
    const [windowHeight, setWindowHeight] = (0, $acw62.useState)(window.innerHeight);
    const [windowWidth, setWindowWidth] = (0, $acw62.useState)(window.innerWidth);
    const [videoDevices, setVideoDevices] = (0, $acw62.useState)([]);
    const [audioDevices, setAudioDevices] = (0, $acw62.useState)([]);
    const [audioOutDevices, setAudioOutDevices] = (0, $acw62.useState)([]);
    const meetingInfo = (0, $acw62.useRef)(null);
    const devicesChanging = (0, $acw62.useRef)(false);
    const localOpened = (0, $acw62.useRef)(false);
    const videoCompatible = !!navigator.mediaDevices;
    const screenShareCompatible = 'getDisplayMedia' in navigator.mediaDevices;
    const webSocketClient = (0, $acw62.useRef)((0, $ff0c48d396ccec4c$export$2e2bcd8739ae039).getInstance());
    const [closed, setClosed] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 1: useEffect');
        // start will set up all initial resources
        start().then();
        // When the component is unmounted we need to clean up resources
        return ()=>{
            console.log('Unmounting resources');
            window.removeEventListener('fullscreenchange', fullscreenChange);
            window.removeEventListener('resize', resizeWindow);
            (0, $722e8aa081170f4b$export$755db3b985fb9f16)(resources.current);
            (0, $561686717f5feab0$export$be3892ac83272cb6)(resources.current);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!fullscreen) // We get a fullscreen change on start, make sure we are in fullscreen before exiting fullscreen
        {
            if (document.fullscreenElement) document.exitFullscreen();
        } else {
            const elem = document.getElementById("whole_window");
            if (elem) {
                if (elem.requestFullscreen) elem.requestFullscreen();
            }
        }
    // arrangeVideos(resources.current)
    }, [
        fullscreen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (recording) {
            if (resources.current) $b5b5207d96999e61$var$recordSound.start(resources.current, api);
            else console.warn('No resources');
        } else $b5b5207d96999e61$var$recordSound.stop();
    }, [
        recording
    ]);
    const resizeWindow = ()=>{
        setSmall(window.innerWidth < 800);
        setWindowHeight(window.innerHeight);
        setWindowWidth(window.innerWidth);
        (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources.current);
    };
    const truncateString = (value, chars)=>{
        if (value.length < chars) return value;
        return value.substring(0, chars) + '...';
    };
    const stateFunc = (key, value)=>{
        if (key === 'shareScreen') setShareScreen(value);
        else if (key === 'showInfo') setShowInfo(value);
        else if (key === 'info') setInfo(value);
        else if (key === 'infoText') infoText = value;
        else if (key === 'arrangeVideos') (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources.current);
        else console.log('!!! Unknown key to stateFunc: ' + key);
    };
    const errorFunc = (error)=>{
        let errorText;
        switch(error){
            case (0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_FAILED_OPEN:
                errorText = "Failed opening connection to Zebrain system.\nPlease check your internet connection.\nIf it works, try reloading this page.";
                break;
            case (0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_NOT_OPEN:
                errorText = "Lost connection to Zebrain system (1).\nPlease check your internet connection.\nIf it works, try reloading this page.";
                break;
            case (0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_CLOSED:
                errorText = 'Websocket is closed';
                break;
            case (0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_EVENT_CLOSED:
                errorText = "Lost connection to Zebrain system (2).\nPlease check your internet connection.\nIf it works, try reloading this page.";
                break;
            case (0, $cbe71848aa286a1b$export$4fd720569787ab6f).WEBSOCKET_NOT_AVAILABLE:
                errorText = "Websocket has died :-(\nTry reloading the page, and if that doesn't help, contact coach@zebrain.se";
                break;
            case (0, $cbe71848aa286a1b$export$4fd720569787ab6f).RTC_CONNECTION_STATE_FAILED:
                if (resources.current.rtcHasConnected) {
                    errorText = 'Lost video connection. This is probably due to a network error between you and meeting partner.\n';
                    errorText += 'Check your internet connection. If it works, try reloading this page.\n';
                    errorText += 'If that doesn\'t work, the problem could be with your partner\'s network.\n\n';
                    errorText += 'If nothing works, contact coach@zebrain.se and we will try to help.';
                } else {
                    errorText = 'Failed connecting video stream. This is probably due to a firewall issue.\n';
                    errorText += '\nSend a mail to coach@zebrain.se and we will help.';
                }
                break;
            case (0, $cbe71848aa286a1b$export$4fd720569787ab6f).RTC_NEGOTIATION_SLOW:
                errorText = "If your cannot see your meeting partner within ten seconds, try these steps:\n\n1. Exit meeting and join again\n\n2. If that doesn't work, restart your browser and join meeting again\n\n3. If that doesn't work, contact support";
                break;
            default:
                errorText = 'Unknown error: ' + error;
                break;
        }
        displayInfo(errorText, true);
    };
    const who = props.who;
    const userId = props.userId;
    const userName = props.userName;
    // @ts-ignore
    const resources = (0, $acw62.useRef)({
        audioDeviceId: 'unset',
        audioGroupId: 'unset',
        videoDeviceId: 'unset',
        videoGroupId: 'unset',
        who: who,
        userId: userId,
        userName: userName,
        externalMeeting: who === 'external',
        partners: [],
        videoContainerRef: (0, $acw62.useRef)(undefined),
        webSocket: undefined,
        webSocketHasOpened: false,
        meetingKey: props.meetingKey,
        stateFunc: stateFunc,
        errorFunc: errorFunc,
        small: false,
        background: '',
        changeBackground: false,
        webSocketPingInterval: null,
        rtcStatus: 'waiting',
        rtcHasConnected: false,
        skipTurn: document.location.search.indexOf('skipTurn') > -1,
        gotInputDevices: false,
        showRightMenu: false,
        extraWindow: (0, $cbe71848aa286a1b$export$4ec7f52694178c6).None
    });
    async function start() {
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 2: start()');
        displayInfo(lang === 'sv' ? "Startar n\xe4tverk" : 'Starting network', true);
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 3: openSocket()');
        (0, $722e8aa081170f4b$export$4e6053747055af0e)(resources.current, resources.current.userId, resources.current.userName);
        const socketOpened = await (0, $722e8aa081170f4b$export$948ce3773b347819)(resources.current);
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 4: socketOpened is ' + socketOpened);
        if (!socketOpened) {
            if (resources.current.webSocket) {
                if (resources.current.webSocket.readyState === WebSocket.CLOSED) console.log('-- websocket is closed ' + resources.current.webSocket.readyState);
                else if (resources.current.webSocket.readyState === WebSocket.CONNECTING) console.log('-- websocket is connecting ' + resources.current.webSocket.readyState);
                else console.log('websocket is in state ' + resources.current.webSocket.readyState);
            }
            return;
        }
        displayInfo(lang === 'sv' ? 'Startar kamera' : 'Starting camera', true);
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 5: getInputDevices');
        resources.current.gotInputDevices = await getInputDevices();
        displayInfo(lang === 'sv' ? "Startar videostr\xf6m" : 'Starting video stream', true);
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 6: startLocalVideo');
        startLocalVideo();
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 7: startLocalVideo done');
        setupMediaChange();
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 8: setupMediaChange');
        window.addEventListener('fullscreenchange', fullscreenChange);
        window.addEventListener('resize', resizeWindow);
    }
    const getChatData = ()=>{
        api.get('meeting_data/' + resources.current.who + '/' + resources.current.meetingKey).then((response)=>{
            if (response.json.error === "Token expired") {
                setTokenExpired(true);
                return;
            }
            meetingInfo.current = {
                meetingStart: response.json.meeting.start,
                meetingLength: response.json.meeting.meetingLength,
                clientId: response.json.meeting.clientId,
                clientName: response.json.meeting.clientName,
                coachId: response.json.meeting.coachId,
                coachName: response.json.meeting.coachName,
                meetingId: response.json.meeting.id
            };
            let info = "Meeting starts";
            info += ': ' + (0, $f6959fbcc1e8f0a1$export$31bd54ef8fbd09b6)(meetingInfo.current.meetingStart, lang) + ', ' + 'length' + ': ' + meetingInfo.current.meetingLength + ' minutes';
            info += '\n\nWaiting for ';
            if (resources.current.who === 'coach') info += meetingInfo.current.clientName;
            else info += meetingInfo.current.coachName;
            info += '...';
            const meetingStart = new Date(meetingInfo.current.meetingStart);
            const now = new Date();
            const secondsToStart = (meetingStart.getTime() - now.getTime()) / 1000;
            if (secondsToStart > 3600) {
                info += '\n\n\n\n';
                if (lang === 'sv') info += "Obs! Det \xe4r l\xe5ngt kvar tills m\xf6tet startar.";
                else info += 'NB! It is a long time until meeting starts.';
            }
            displayInfo(info, true);
        });
    };
    const fullscreenF = ()=>{
        if (document.fullscreenElement) setFullscreen(false);
        else setFullscreen(true);
    };
    const fullscreenChange = (event)=>{
        console.log('-------- fullscreenChange checking: ' + fullscreen);
    // console.log(event)
    // setTimeout(() => {
    //   if (!document.fullscreenElement && state.fullscreen) {
    //     console.log('-------- fullscreenChange: ' + false)
    //     setState({"fullscreen": false})
    //   }
    // }, 100)
    };
    const handleLanguageChange = ()=>{
        const newLang = (0, $4d8f55ac7a5ea02a$export$64783e31db14f0ba)(i18n.language) === 'sv' ? 'en' : 'sv';
        i18n.changeLanguage(newLang).then(()=>{
            // Save the selected language to localStorage
            localStorage.setItem('language', newLang);
        });
    };
    const hangup = ()=>{
        if (window.opener) {
            window.opener.console.log('From opened window');
            console.log('----- Closing window');
            window.opener.postMessage('video_window_close');
        // Catcher in the rye - if window.opener has gone away
        // setTimeout(() => {
        //   window.location.href = '/app/' + who + '/overview'
        // }, 300)
        } else // If location.key is 'default' you are routed here from external link
        if (props.back) window.location.href = props.back;
        else setClosed(true);
    };
    const extraIframe = (url)=>{
        const iframeUrl = (0, $9ecda7333d28e490$export$1630b5343357e8b5).COACH_HOST + url;
        const height = windowHeight - 120;
        const width = windowWidth > 800 ? 400 : windowWidth;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
            width: width,
            height: height,
            src: iframeUrl
        });
    };
    const reloadDevices = ()=>{
        const oldAudioGroupId = audioGroupId;
        const oldVideoGroupId = videoGroupId;
        console.log('--- Video is ' + resources.current.videoGroupId);
        getInputDevices().then(()=>{
            console.log('---- getInputDevices done');
            if (localOpened.current) {
                if (resources.current.audioGroupId !== oldAudioGroupId || resources.current.videoGroupId !== oldVideoGroupId) {
                    console.log('Different audio or video');
                    if (resources.current.audioGroupId !== oldAudioGroupId) {
                        console.log('Different audio: ' + oldAudioGroupId + ' !== ' + resources.current.audioGroupId);
                        stopLocalStream('audio');
                    }
                    if (resources.current.videoGroupId !== oldVideoGroupId) {
                        console.log('Different video: ' + oldVideoGroupId + ' !== ' + resources.current.videoGroupId);
                        stopLocalStream('video');
                    }
                    changeLocalVideo();
                    console.log('Changed input stream');
                } else {
                    console.log('--- Not changing a ' + resources.current.audioGroupId + ' == ' + oldAudioGroupId);
                    console.log('--- Not changing v ' + resources.current.videoGroupId + ' == ' + oldVideoGroupId);
                }
            } else console.log('localOpened not opened: ' + localOpened.current);
            devicesChanging.current = false;
        });
    };
    const setupMediaChange = ()=>{
        console.log('--- started setupMediaChange');
        navigator.mediaDevices.ondevicechange = ()=>{
            console.log('-------- media device change');
            if (devicesChanging.current) {
                console.log('---- warning: devices are in changing state');
                setTimeout(()=>{
                    if (!devicesChanging.current) {
                        console.log('Reloading after released devicesChanging');
                        reloadDevices();
                    } else console.log('-------------- still deviceChanging...');
                }, 1000);
                return;
            }
            devicesChanging.current = true;
            reloadDevices();
        };
    };
    // Local video methods
    async function getInputDevices() {
        console.log('------ getInputDevices starting');
        const mediaDevices = await navigator.mediaDevices.enumerateDevices();
        const _videoDevices = [];
        const _audioDevices = [];
        const _audioOutDevices = [];
        for (let device of mediaDevices){
            console.log(device.kind + ': ' + device.label + ', ' + device.deviceId);
            if (device.kind === 'audioinput') _audioDevices.push({
                id: device.deviceId,
                label: device.label,
                groupId: device.groupId
            });
            else if (device.kind === 'videoinput') _videoDevices.push({
                id: device.deviceId,
                label: device.label,
                groupId: device.groupId
            });
            else if (device.kind === 'audiooutput') _audioOutDevices.push({
                id: device.deviceId,
                label: device.label,
                groupId: device.groupId
            });
        }
        setAudioDevices(_audioDevices);
        setVideoDevices(_videoDevices);
        setAudioOutDevices(_audioOutDevices);
        if (_audioDevices.length > 0 && _audioDevices[0].id !== '' && _videoDevices.length > 0 && _videoDevices[0].id !== '') {
            console.log('Setting devices to a ' + _audioDevices[0].label + ' v ' + _videoDevices[0].label);
            resources.current.audioDeviceId = _audioDevices[0].id;
            resources.current.audioGroupId = _audioDevices[0].groupId;
            resources.current.videoDeviceId = _videoDevices[0].id;
            resources.current.videoGroupId = _videoDevices[0].groupId;
            setAudioDeviceId(_audioDevices[0].id);
            setAudioGroupId(_audioDevices[0].groupId);
            setVideoDeviceId(_videoDevices[0].id);
            setVideoGroupId(_videoDevices[0].groupId);
            return true;
        }
        return false;
    }
    const getConstraints = ()=>{
        let video = resources.current.videoDeviceId === 'unset' ? true : {
            deviceId: {
                exact: resources.current.videoDeviceId
            }
        };
        const audio = resources.current.audioDeviceId === 'unset' ? true : {
            deviceId: {
                exact: resources.current.audioDeviceId
            }
        };
        return {
            video: video,
            audio: audio
        };
    };
    function startLocalVideo() {
        if (resources.current.videoContainer) // React sometimes keeps this. Append to parent
        resources.current.videoContainerRef.current.appendChild(resources.current.videoContainer);
        else resources.current.videoContainer = (0, $561686717f5feab0$export$258ec4dbf7f41a75)(resources.current.videoContainerRef.current);
        if (resources.current.videoElement) // React sometimes keeps this. Append to parent
        resources.current.videoContainer.appendChild(resources.current.videoElement);
        else {
            resources.current.videoElement = (0, $561686717f5feab0$export$f4f3d816544d7e44)(resources.current.videoContainer);
            resources.current.videoElement.classList.add('video_mirrored');
        }
        const constraints = getConstraints();
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 7.1: got constraints');
        if (!resources.current.gotInputDevices) displayInfo('Waiting for camera access approval', true);
        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 7.2: getUserMedia');
        navigator.mediaDevices.getUserMedia(constraints).then((localStream)=>{
            if ($b5b5207d96999e61$var$debugOrder) console.log('Order 7.3: in getUserMedia');
            if (props.meetingType === "coaching" && props.who != "external") {
                displayInfo('Looking up meeting information', true);
                getChatData();
                if ($b5b5207d96999e61$var$debugOrder) console.log('Order 7.4: in getChatData');
            } else setShowInfo(false);
            if (resources.current.videoContainer) {
                if (resources.current.localInfoElement) resources.current.videoContainer.appendChild(resources.current.localInfoElement);
                else resources.current.localInfoElement = (0, $561686717f5feab0$export$cd7f3873ff6a50a4)(resources.current, resources.current.videoContainer, displayInfo);
                if ($b5b5207d96999e61$var$debugOrder) console.log('Order 7.5: createLocalInfoDiv');
            }
            resources.current.localStream = localStream;
            // In case we could not get input devices due to allow access dialogue, run getInputDevices again
            if ($b5b5207d96999e61$var$debugOrder) console.log('Order 7.6: getInputDevices');
            if (resources.current.videoDeviceId === 'unset' || resources.current.audioDeviceId === 'unset') {
                console.log('getInputDevices since v ' + resources.current.videoDeviceId + ' a ' + resources.current.audioDeviceId);
                getInputDevices().then((result)=>{
                    resources.current.gotInputDevices = result;
                });
            }
            try {
                // If user changed mic or camera, respect if the turned off camera or mic
                if (resources.current.videoElement) {
                    if ($b5b5207d96999e61$var$debugOrder) console.log('Order 7.7: has videoElement');
                    resources.current.videoElement.onloadedmetadata = ()=>{
                        if ($b5b5207d96999e61$var$debugOrder) console.log('Order 7.8: onloadedmetadata');
                        localOpened.current = true;
                        (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources.current);
                        setMicOn(true);
                        setCameraOn(true);
                        (0, $722e8aa081170f4b$export$a222caf1cf2d6f53)(resources.current);
                    };
                    // Move the allocation of localStream to after listening to loadedmetadata. Suspicion is that some browsers
                    // fire the event after resources.videoElement.srcObject = localStream but before
                    // loademetadata-listener is in place (coach Paula saw this with Chrome on Windows.
                    resources.current.videoElement.muted = true;
                    resources.current.videoElement.srcObject = localStream;
                } else {
                    alert('Failed getting videoElement');
                    (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('No video element', resources.current);
                }
            } catch (error) {
                displayInfo('Could not open video.\n\nReload the page, and if that does not help - contact support', true);
                (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('Failed opening video', resources.current);
            }
        }).catch((err)=>{
            (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('Failed getUserMedia', resources.current);
        });
    }
    const changeLocalVideo = ()=>{
        const constraints = getConstraints();
        console.log('-------- changeLocalVideo 1 c ' + cameraOn + ' m ' + micOn);
        try {
            navigator.mediaDevices.getUserMedia(constraints).then((localStream)=>{
                resources.current.localStream = localStream;
                if (resources.current.videoElement) {
                    // If user changed mic or camera, respect if the turned off camera or mic
                    if (!micOn || !cameraOn) console.log('Not saving on/off state of camera or mic, it does not work');
                    resources.current.videoElement.onloadedmetadata = ()=>{
                        if (useCanvas) (0, $2ae6a0e1d65fc3a5$export$1609c8a0afa4d4)(resources.current);
                        else (0, $561686717f5feab0$export$c3d42395a2b4ee59)(resources.current);
                    };
                    // Move the allocation of localStream to after listening to loadedmetadata. Suspicion is that some browsers
                    // fire the event after resources.videoElement.srcObject = localStream but before
                    // loademetadata-listener is in place (coach Paula saw this with Chrome on Windows.
                    resources.current.videoElement.muted = true;
                    resources.current.videoElement.srcObject = localStream;
                }
            }).catch((err)=>{
                (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('Failed getUserMedia', resources.current);
            });
        } catch (error) {
            displayInfo('Could not open video.\n\nReload the page, and if that does not help - contact support', true);
            (0, $722e8aa081170f4b$export$9d476a4ed49c5f1f)('Failed opening video', resources.current);
        }
    };
    const stopLocalStream = (kind)=>{
        if (resources.current.localStream) resources.current.localStream.getTracks().forEach((track)=>{
            if (track.kind === kind && track.readyState === 'live') {
                console.log('Change, stopping previous track ' + track.kind);
                track.stop();
            }
        });
    };
    const changeVideo = (deviceId)=>{
        if (deviceId === resources.current.videoDeviceId) {
            console.log('already selected ' + deviceId);
            return;
        }
        stopLocalStream('video');
        setOpenMenu(false);
        resources.current.videoDeviceId = deviceId;
        setVideoDeviceId(deviceId);
        changeLocalVideo();
    };
    const changeAudio = (deviceId)=>{
        if (deviceId === resources.current.audioDeviceId) {
            console.log('already selected ' + deviceId);
            return;
        }
        stopLocalStream('audio');
        resources.current.audioDeviceId = deviceId;
        setAudioDeviceId(deviceId);
        changeLocalVideo();
        console.log('Changed to ' + deviceId);
    };
    const changeOutAudio = (deviceId)=>{
        if (deviceId === audioOutDeviceId) {
            console.log('already selected ' + deviceId);
            return;
        }
        if (resources.current.videoElement && 'setSinkId' in HTMLMediaElement.prototype) {
            resources.current.audioDeviceId = deviceId;
            setAudioOutDeviceId(deviceId);
            // @ts-ignore
            resources.current.videoElement.setSinkId(deviceId);
            // @ts-ignore
            $b5b5207d96999e61$var$soundFile.setSinkId(deviceId);
            console.log('Changed audioDeviceId to ' + deviceId);
        }
    };
    const displayInfo = (infoTxt, reset)=>{
        if (reset) infoText = infoTxt;
        else infoText += '\n' + infoTxt;
        setInfo(infoText);
        setShowInfo(true);
    };
    const toggleCamera = ()=>{
        if (resources.current.localStream) resources.current.localStream.getTracks().forEach((track)=>{
            if (track.kind === 'video') {
                const newState = !cameraOn;
                track.enabled = newState;
                setCameraOn(newState);
            }
        });
    };
    const toggleRecording = ()=>{
        if (recording) setRecording(false);
        else if (resources.current.localStream) setRecording(true);
    };
    const toggleMic = ()=>{
        if (resources.current.localStream) resources.current.localStream.getTracks().forEach((track)=>{
            if (track.kind === 'audio') {
                const newState = !micOn;
                track.enabled = newState;
                setMicOn(newState);
            }
        });
    };
    const toggleExtraWindow = (selectWindow)=>{
        resources.current.extraWindow = resources.current.extraWindow === selectWindow ? (0, $cbe71848aa286a1b$export$4ec7f52694178c6).None : selectWindow;
        setExtraWindow(resources.current.extraWindow);
        setOpenMenu(false);
        (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources.current);
    };
    const toggleShareScreen = ()=>{
        const newShareScreen = !shareScreen;
        if (newShareScreen) (0, $561686717f5feab0$export$500335708f2f9ded)(resources.current);
        else (0, $561686717f5feab0$export$a2225f6f9177d1a0)(resources.current);
    };
    const toggleCanvas = (background)=>{
        const shouldUseCanvas = background.length > 0;
        const changeCanvas = useCanvas !== shouldUseCanvas;
        resources.current.background = background;
        resources.current.changeBackground = true;
        toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).None);
        setUseCanvas(shouldUseCanvas);
        if (changeCanvas) {
            if (shouldUseCanvas) (0, $2ae6a0e1d65fc3a5$export$5d3661a787e3ea15)(resources.current);
            else {
                (0, $2ae6a0e1d65fc3a5$export$e117f21e0d9f40c9)(resources.current);
                (0, $561686717f5feab0$export$c3d42395a2b4ee59)(resources.current);
                setTimeout(()=>{
                    // Allow for canvas to be removed
                    (0, $4242a576d6cd20f5$export$e9e6961726f0a4a7)(resources.current);
                }, 200);
            }
        }
    };
    const testSpeakers = ()=>{
        if (showTestSpeakers) $b5b5207d96999e61$var$soundFile.pause();
        else $b5b5207d96999e61$var$soundFile.play();
        setShowTestSpeakers(!showTestSpeakers);
    };
    const speakertext = ()=>{
        if (showTestSpeakers) return lang === 'sv' ? 'Spelar upp musik...' : `Playing music...`;
        else return lang === 'sv' ? "Testa dina h\xf6gtalare" : `Test your speakers`;
    };
    const showMenu = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "video_menu_page bg-neutral-800 px-4 py-2",
            children: [
                small && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center cursor-pointer",
                            onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).Chat),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "chat",
                                    className: "h-6 w-6",
                                    title: "chat",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cdb78316af408ce7$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: "Chat"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "my-2 border-neutral-600"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center cursor-pointer",
                            onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).BookMeeting),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "book",
                                    className: "h-6 w-6",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6c93e43386478db6$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: t('book-meeting')
                                })
                            ]
                        }),
                        props.who === 'coach' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "my-2 border-neutral-600"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "cursor-pointer flex",
                                    onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).Client),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            alt: "client",
                                            className: "h-6 w-6",
                                            title: "client",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($12192059d6909db0$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "ml-2",
                                            children: lang === 'sv' ? 'Klient' : 'Client'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "my-2 border-neutral-600"
                        })
                    ]
                }),
                small && screenShareCompatible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer flex",
                            onClick: ()=>toggleShareScreen(),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "present",
                                    className: "h-6 w-6",
                                    title: shareScreen ? "Stop" : "Start",
                                    src: shareScreen ? (0, (/*@__PURE__*/$parcel$interopDefault($771ec20e247b4491$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($87584a01cd5e0e0c$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: lang === 'sv' ? "Dela sk\xe4rm" : 'Share screen'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "my-2 border-neutral-600"
                        })
                    ]
                }),
                props.meetingType === "coaching" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer flex",
                            onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).CoachingTools),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "background",
                                    className: "h-6 w-6",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b11080b0bb6bec6b$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: lang === 'sv' ? 'Coachingverktyg' : 'Coaching tools'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "my-2 border-neutral-600"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "cursor-pointer flex",
                    onClick: ()=>{
                        fullscreenF();
                        setOpenMenu(false);
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            title: "fullscreen",
                            alt: "fullscreen",
                            className: "h-6 w-6",
                            src: fullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($b805ed793108017b$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($a523f6402245f379$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ml-2",
                            children: lang === 'sv' ? "Fullsk\xe4rm" : 'Full screen'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "my-2 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "cursor-pointer flex",
                    onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).Background),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            alt: "background",
                            className: "h-6 w-6",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($155e5efd0c1d5fe5$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ml-2",
                            children: lang === 'sv' ? "V\xe4lj bakgrund" : 'Select background'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "my-2 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center cursor-pointer",
                    onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).Settings),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            alt: "settings",
                            className: "h-6 w-6",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($816c0b89a4789cdd$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ml-2",
                            children: lang === 'sv' ? "Inst\xe4llningar" : 'Settings'
                        })
                    ]
                })
            ]
        });
    };
    const renderExtraWindow = ()=>{
        if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Chat && meetingInfo.current) {
            if (resources.current.who === 'coach') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d81e6e01a724e49d$export$2e2bcd8739ae039), {
                clientId: meetingInfo.current.clientId,
                isCoach: true
            });
            else if (resources.current.who === 'client') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d81e6e01a724e49d$export$2e2bcd8739ae039), {
                coachId: meetingInfo.current.coachId,
                isCoach: false
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-4",
                children: "Chat not available"
            });
        } else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Client) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "overflow-y-scroll",
            style: {
                marginLeft: -16
            },
            children: meetingInfo.current && // <ClientPageContent clientId={meetingInfo.current?.clientId} standalone={true}/>
            extraIframe("clients/" + meetingInfo.current.clientId)
        });
        else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Settings) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                videoDevices.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mt-4 text-lg font-medium",
                            children: "Video"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                            className: "mt-4 page_select w100",
                            value: videoDeviceId,
                            onChange: (e)=>changeVideo(e.target.value),
                            children: videoDevices.map((device, index)=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: device.id,
                                    children: truncateString(device.label, 36)
                                }, "video_" + index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-8",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-lg font-medium",
                            children: lang === 'sv' ? 'Mikrofon' : 'Microphone'
                        }),
                        audioDevices.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                            className: "my-4 page_select w100",
                            value: audioDeviceId,
                            onChange: (e)=>changeAudio(e.target.value),
                            children: audioDevices.map((device, index)=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: device.id,
                                    children: truncateString(device.label, 36)
                                }, "audio_" + index);
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10848baf51ae953b$export$2e2bcd8739ae039), {
                            resources: resources.current,
                            micOn: micOn,
                            audioDeviceId: audioDeviceId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-8",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-lg font-medium",
                            children: lang === 'sv' ? "H\xf6gtalare" : 'Speakers'
                        }),
                        audioOutDevices.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                            className: "mt-4 page_select w100",
                            value: audioOutDeviceId,
                            onChange: (e)=>changeOutAudio(e.target.value),
                            children: audioOutDevices.map((device, index)=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: device.id,
                                    children: truncateString(device.label, 36)
                                }, "audio_" + index);
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    onClick: ()=>testSpeakers(),
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: 'video_test_sound ' + (showTestSpeakers ? 'on' : 'off')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                marginLeft: '5px'
                                            },
                                            className: "align-center",
                                            children: speakertext()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontStyle: 'italic'
                                    },
                                    className: "mt-4 font_small",
                                    children: lang === 'sv' ? "Om du h\xf6r musik spelas, s\xe5 fungerar dina h\xf6gtalare" : `If you hear music, your speakers are working.`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "mt-4",
                                    children: lang === 'sv' ? "H\xf6r du inget ljud?" : `Can't hear any sound?`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-4 font_small",
                                    children: lang === 'sv' ? "Kontrollera att dina h\xf6gtalare \xe4r p\xe5" : `Check if your speakers are on.`
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-8 cursor-pointer flex",
                    onClick: ()=>handleLanguageChange(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: lang === 'en' ? (0, (/*@__PURE__*/$parcel$interopDefault($8ec22d909ff9299c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($82817e8148d9758f$exports))),
                            alt: "language"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "ml-4",
                            children: lang === 'en' ? 'Swedish' : 'English'
                        })
                    ]
                })
            ]
        });
        else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).BookMeeting && meetingInfo.current) {
            const name = props.who === 'coach' ? meetingInfo.current.clientName : meetingInfo.current.coachName;
            const meeting = {
                id: '0',
                clientId: meetingInfo.current.clientId,
                length: 30,
                firstName: name,
                lastName: '',
                start: '2024-11-25 12:00:00Z',
                startDate: new Date(),
                status: 'no_status'
            };
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mr-4 mt-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $835a168710da619d$export$2e2bcd8739ae039), {
                    meeting: meeting,
                    clientId: meetingInfo.current.clientId,
                    who: props.who,
                    close: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).None),
                    lang: lang
                })
            });
        } else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).CoachingTools && who) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "mr-4 mt-4",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86a541a13dca317c$export$2e2bcd8739ae039), {
                meetingId: resources.current.meetingKey,
                who: who,
                api: api,
                webSocketClient: webSocketClient.current,
                partnerId: "client_" + meetingInfo.current?.clientId,
                close: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).None),
                lang: lang
            })
        });
        else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Background) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "mt-4 mr-4",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-3 gap-2",
                children: (0, $2ae6a0e1d65fc3a5$export$388b5bc5140fe9e6).map((bgImage, index)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "cursor-pointer rounded border " + (resources.current.background === bgImage.image ? "border-sky-700" : "border-neutral-300"),
                        onClick: ()=>toggleCanvas(bgImage.image),
                        children: bgImage.src.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            alt: bgImage.name_en,
                            src: bgImage.src
                        }, index) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex items-center justify-center p-4",
                            children: lang === 'sv' ? bgImage.name_sv : bgImage.name_en
                        })
                    }, "bg_" + index);
                })
            })
        });
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: "Not implemented yet :-("
        });
    };
    const extraMenuTitle = ()=>{
        if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Chat) return "Chat";
        else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Settings) return lang === 'sv' ? "Inst\xe4llningar" : "Settings";
        else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Client) return lang === 'sv' ? "Klient" : "Client";
        else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).BookMeeting) return t('book-meeting');
        else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Background) return lang === 'sv' ? "V\xe4lj bakgrund" : "Choose background";
        else if (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).CoachingTools) return lang === 'sv' ? 'Coachingverktyg' : 'Coaching tools';
        return "??";
    };
    if (!videoCompatible) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "m-4",
        children: "Your browser is not compatible with video conferences"
    });
    else if (closed) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "m-4",
        children: "Meeting is closed"
    });
    else if (tokenExpired) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-4 text-xl",
                children: "Your token has expired."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-4 underline cursor-pointer",
                onClick: ()=>hangup(),
                children: "Go back and enter meeting again."
            })
        ]
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        id: "whole_window",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: resources.current.videoContainerRef
            }),
            showInfo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "video_info",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($14de963752b00cee$exports))),
                            alt: "close",
                            onClick: ()=>setShowInfo(false),
                            className: "cursor-pointer"
                        })
                    }),
                    info
                ]
            }),
            openMenu && showMenu(),
            extraWindow != (0, $cbe71848aa286a1b$export$4ec7f52694178c6).None && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "video_extra_window",
                children: [
                    extraWindow !== (0, $cbe71848aa286a1b$export$4ec7f52694178c6).CoachingTools && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-center relative p-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-lg font-medium",
                                        children: extraMenuTitle()
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($14de963752b00cee$exports))),
                                        className: "cursor-pointer h-6 w-6",
                                        alt: "close",
                                        style: {
                                            position: 'absolute',
                                            right: '16px',
                                            top: '16px'
                                        },
                                        onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).None)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                className: "border-neutral-600"
                            })
                        ]
                    }),
                    renderExtraWindow()
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "video_footer flex items-center justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex justify-evently",
                    children: [
                        props.who === "client" && !props.back?.startsWith("https://platform.zebrain.se") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer video_footer_icon text-xs",
                            onClick: ()=>toggleRecording(),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "record",
                                    className: "video_icon",
                                    title: recording ? "Stop recording" : "Start recording",
                                    src: recording ? (0, (/*@__PURE__*/$parcel$interopDefault($419676c6fce4b2f6$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($7927313db8b5982f$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-1",
                                    children: lang === 'sv' ? 'Spela in' : 'Record'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer video_footer_icon text-xs",
                            onClick: ()=>toggleMic(),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "microphone",
                                    className: "video_icon",
                                    title: micOn ? "Mute" : "Unmute",
                                    src: micOn ? (0, (/*@__PURE__*/$parcel$interopDefault($a66824a50a34a4f1$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ba6ceb8a6fcc832b$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-1",
                                    children: lang === 'sv' ? 'Mikrofon' : 'Mic'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer video_footer_icon text-xs",
                            onClick: ()=>toggleCamera(),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    title: cameraOn ? "Hide" : "Show",
                                    alt: "camera",
                                    className: "video_icon",
                                    src: cameraOn ? (0, (/*@__PURE__*/$parcel$interopDefault($e3a1a00d20f15acd$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($b3ab3439e9cfd704$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-1",
                                    children: lang === 'sv' ? 'Kamera' : 'Camera'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                borderLeft: "1px solid #4a4a6b"
                            },
                            children: "\xa0"
                        }),
                        !small && props.meetingType === "coaching" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer video_footer_icon text-xs px-2" + (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Chat ? " bg-neutral-600 rounded" : ""),
                            onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).Chat),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "chat",
                                    className: "video_icon",
                                    title: "chat",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cdb78316af408ce7$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-1",
                                    children: "Chat"
                                })
                            ]
                        }),
                        !small && props.who !== 'external' && props.meetingType === "coaching" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer video_footer_icon text-xs px-2" + (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).BookMeeting ? " bg-neutral-600 rounded" : ""),
                            onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).BookMeeting),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "book",
                                    className: "video_icon",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6c93e43386478db6$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-1",
                                    children: t('book')
                                })
                            ]
                        }),
                        !small && screenShareCompatible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer video_footer_icon text-xs",
                            onClick: ()=>toggleShareScreen(),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "present",
                                    className: "video_icon",
                                    title: shareScreen ? "Stop" : "Start",
                                    src: shareScreen ? (0, (/*@__PURE__*/$parcel$interopDefault($771ec20e247b4491$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($87584a01cd5e0e0c$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-1",
                                    children: lang === 'sv' ? 'Dela' : 'Share'
                                })
                            ]
                        }),
                        props.who === 'coach' && !small && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer video_footer_icon text-xs px-2" + (extraWindow === (0, $cbe71848aa286a1b$export$4ec7f52694178c6).Client ? " bg-neutral-600 rounded" : ""),
                            onClick: ()=>toggleExtraWindow((0, $cbe71848aa286a1b$export$4ec7f52694178c6).Client),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "client",
                                    className: "video_icon",
                                    title: "clint",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($12192059d6909db0$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-1",
                                    children: lang === 'sv' ? 'Klient' : 'Client'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "cursor-pointer video_footer_icon text-xs",
                            onClick: ()=>setOpenMenu(!openMenu),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    alt: "menu",
                                    className: "video_icon",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b0a44e27c839d9d3$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-1",
                                    children: lang === 'sv' ? 'Mer' : 'More'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "cursor-pointer video_footer_icon",
                            onClick: ()=>hangup(),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                title: "Leave",
                                alt: "hangup",
                                className: "w-12 h-12",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($31bf57f98cd6b309$exports)))
                            })
                        })
                    ]
                })
            })
        ]
    });
};


function $cd93687958c8007e$export$86fbec116b87613f() {
    let userName = null;
    let userId = null;
    let who = 'external';
    let meetingKey = null;
    let meetingType = "coaching";
    let back = null;
    const readParameters = ()=>{
        if (window.location.search.indexOf('?') !== -1) {
            let search = window.location.search.substring(1);
            for (const nameValue of search.split('&')){
                const pair = nameValue.split('=');
                const name = pair[0];
                let value = decodeURIComponent(pair[1]);
                value = value.replace(/\+/g, ' ');
                if (name === 'name') {
                    userName = value;
                    window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).USERNAME_TOKEN] = value;
                } else if (name === 'token') window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).PERSON_TOKEN] = value;
                else if (name === 'meetingKey') {
                    meetingKey = value;
                    window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_KEY] = value;
                } else if (name === 'meetingType') meetingType = value;
                else if (name === 'who') {
                    if (value === 'client' || value === 'coach' || who === 'external') {
                        who = value;
                        window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_WHO] = value;
                    }
                } else if (name === 'userId') {
                    userId = value;
                    window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_USER_ID] = value;
                } else if (name === 'back') {
                    back = value;
                    window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_BACK] = value;
                }
                console.log(name + ' = ' + value);
            }
            window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_TYPE] = meetingType;
            history.pushState(null, '', '/');
        } else {
            userName = window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).USERNAME_TOKEN];
            userId = window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_USER_ID];
            meetingType = window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_TYPE];
            meetingKey = window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_KEY];
            back = window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_BACK];
            let _who = window.localStorage[(0, $9ecda7333d28e490$export$1630b5343357e8b5).MEETING_WHO];
            if (who === 'client' || who === 'coach' || who === 'external') who = _who;
        }
    };
    readParameters();
    if (userName && userId && who && meetingKey) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5b5207d96999e61$export$d29f0e42bedca4fc), {
        who: who,
        userId: userId,
        userName: userName,
        meetingKey: meetingKey,
        meetingType: meetingType,
        back: back
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "mt-4 text-center",
        children: "Missing parameters for video"
    });
}



let $70fc9a727fa662ae$var$container = document.getElementById("app");
let $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {}));


//# sourceMappingURL=meeting-app.0c5ecc8b.js.map
